
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dVPAB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a31lS = parcelRequire("a31lS");

function $04b9396588ced93d$export$1d81a44583df97d2(createPreset, dependencies = []) {
    const [editorApi, setAPI] = (0, $cozmU.useState)(undefined);
    const preset = (0, $cozmU.useMemo)(()=>createPreset(new (0, $a31lS.EditorPresetBuilder)()), // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies);
    (0, $cozmU.useLayoutEffect)(()=>{
        return preset.apiResolver.on((api)=>{
            setAPI(api);
        });
    }, [
        preset.apiResolver
    ]);
    return {
        editorApi: editorApi,
        preset: preset
    };
}
module.exports["usePreset"] = $04b9396588ced93d$export$1d81a44583df97d2;

});

parcelRegister("a31lS", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $fGIRV = parcelRequire("fGIRV");

class $9c360b29d5ed3fbb$export$dab03ba05a79e5c7 {
    add(nextOrTuple) {
        return new $9c360b29d5ed3fbb$export$dab03ba05a79e5c7(/**
     * re-cast this to NewPlugin as we've done all the type
     * safety, dependency checking, narrowing, during
     * `SafePresetCheck & VerifyPluginDependencies`
     */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? // @ts-expect-error Argument of type 'SafePresetCheck<ToAddPlugin, StackPlugins>' is not assignable to parameter of type 'ToAddPlugin'.
        shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $9c360b29d5ed3fbb$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
     * re-cast this to NewPlugin as we've done all the type
     * safety, dependency checking, narrowing, during
     * `SafePresetCheck & VerifyPluginDependencies`
     */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $9c360b29d5ed3fbb$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) {
            // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
            // It is returning a generic type but on top of the Proxy system
            // So, we can safely recast it here
            this.apiEmitter(pluginInjectionAPI.api());
            // Deprecated approach
            this.resolver?.(pluginInjectionAPI.api());
        }
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            let plugin;
            if ((0, $ieeJu.expValEquals)('platform_editor_improve_preset_builder_logging', 'isEnabled', true)) try {
                plugin = pluginInjectionAPI ? fn({
                    config: config,
                    api: pluginInjectionAPI.api()
                }) : fn({
                    config: config
                });
            } catch (error) {
                const pluginName = fn.name || 'unknown';
                const enhancedError = error instanceof Error ? new Error(`Failed to initialize plugin '${pluginName}': ${error.message}`) : new Error(`Failed to initialize plugin '${pluginName}'`);
                throw enhancedError;
            }
            else plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins?.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
    constructor(...more){
        this.data = void 0;
        // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
        /**
     * @deprecated Use `apiResolver` instead
     */ this.apiPromise = void 0;
        this.resolver = void 0;
        /**
     * Returns the editor API when resolved.
     * This occurs when the preset is initially built.
     */ this.apiResolver = void 0;
        this.apiEmitter = ()=>{};
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        // @ts-ignore - TS2872 TypeScript 5.9.2 upgrade
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
        this.apiResolver = new $9c360b29d5ed3fbb$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
    }
}
/**
 * WARNING: Internal object
 *
 * Dedicated wrapper around EventDispatcher for public API around the editor API.
 * This only has the public method `on` which is used to listen to updates to the editor API.
 *
 * This shouldn't really be used externally - the `editorAPI` should be accessed via `usePreset`.
 */ class $9c360b29d5ed3fbb$var$APIDispatcher {
    /**
   * Used to observe Editor API events
   *
   * @param cb Callback to listen to the editor API.
   * This will also emit the last event if the stream has already started.
   * @returns Cleanup function to cleanup the listener
   */ on(cb) {
        if (this.initialEvent !== undefined) // Keeps timing consistent with old approach - certain products
        // ie. ai-mate relied on this.
        Promise.resolve().then(()=>cb(this.initialEvent));
        this.eventDispatcher.on(this.key, cb);
        return ()=>{
            this.eventDispatcher.off(this.key, cb);
        };
    }
    destroy() {
        this.eventDispatcher.destroy();
    }
    constructor(emitter){
        this.emitter = emitter;
        this.eventDispatcher = new (0, $fGIRV.EventDispatcher)();
        this.key = 'api-resolved-event';
        // Need to store the last event created in case we subscribe after the fact
        this.initialEvent = undefined;
        this.emitter((v)=>{
            this.initialEvent = v;
            this.eventDispatcher.emit(this.key, v);
        });
    }
}
module.exports["EditorPresetBuilder"] = $9c360b29d5ed3fbb$export$dab03ba05a79e5c7;

});

parcelRegister("euISL", function(module, exports) {
const $93e344319910007c$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
module.exports["getParentOfTypeCount"] = $93e344319910007c$export$d5cbd8b17958f08b;

});

parcelRegister("is9bZ", function(module, exports) {
const $c049b7caa0b47521$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
module.exports["getPositionAfterTopParentNodeOfType"] = $c049b7caa0b47521$export$ae584b8f0be37f04;

});

parcelRegister("1tdnq", function(module, exports) {
const $11716d1504321a1f$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
module.exports["isSelectionAtEndOfNode"] = $11716d1504321a1f$export$5762916b8b83bc6d;

});

parcelRegister("iscRo", function(module, exports) {
const $50e0c49736bd2019$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
module.exports["isSelectionAtStartOfNode"] = $50e0c49736bd2019$export$2543715425b0bf0b;

});

parcelRegister("1jz5K", function(module, exports) {

var $9FPR8 = parcelRequire("9FPR8");


var $lfek5 = parcelRequire("lfek5");


function $3bf8781424353f41$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ((0, $lfek5.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = (0, $9FPR8.isBody)(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight) return 'bottom';
    if (spaceAbove >= fitHeight) return 'top';
    // If neither space can accommodate the full height, prefer the one with more space
    // When spaces are equal, prefer 'top' to show the top portion of the popup
    return spaceAbove >= spaceBelow ? 'top' : 'bottom';
}
function $3bf8781424353f41$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ((0, $lfek5.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $3bf8781424353f41$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $3bf8781424353f41$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $3bf8781424353f41$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $3bf8781424353f41$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false, minPopupMargin: minPopupMargin })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $3bf8781424353f41$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin);
        if (position.right !== undefined) position.right = $3bf8781424353f41$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin);
    }
    return position;
};
const $3bf8781424353f41$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin = 1)=>{
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $3bf8781424353f41$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const scrollParent = scrollableElement || $3bf8781424353f41$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        const targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $3bf8781424353f41$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const scrollParent = scrollableElement || $3bf8781424353f41$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $3bf8781424353f41$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        const top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $3bf8781424353f41$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect, boundariesElement: boundariesElement, minPopupMargin: minPopupMargin, scrollableElement: scrollableElement }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent || !$3bf8781424353f41$var$isHTMLElementNode(popup.offsetParent)) return position;
    if ((0, $lfek5.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    // Calculate scrollbar dimensions to adjust positions
    // clientWidth/Height excludes scrollbars, offsetWidth/Height includes them
    const scrollbarWidth = popupOffsetParent.offsetWidth - popupOffsetParent.clientWidth;
    const scrollbarHeight = popupOffsetParent.offsetHeight - popupOffsetParent.clientHeight;
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = (0, $9FPR8.isBody)(popupOffsetParent);
    const verticalPosition = $3bf8781424353f41$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight - (isPopupParentBody ? 0 : scrollbarHeight),
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $3bf8781424353f41$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $3bf8781424353f41$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
    const horizontalPosition = $3bf8781424353f41$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight - (isPopupParentBody ? 0 : scrollbarWidth),
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds,
        minPopupMargin: minPopupMargin
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $3bf8781424353f41$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}
// Helper function to check if the passed node is of Element class
function $3bf8781424353f41$var$isElementNode(node) {
    return node.nodeType === 1;
}
// Helper function to check if the passed node is of HTMLElement class
function $3bf8781424353f41$var$isHTMLElementNode(node) {
    return $3bf8781424353f41$var$isElementNode(node) && node.namespaceURI === 'http://www.w3.org/1999/xhtml';
}
module.exports["calculatePlacement"] = $3bf8781424353f41$export$b81415a09b611cb;
module.exports["findOverflowScrollParent"] = $3bf8781424353f41$export$69742dd9a26edd3e;
module.exports["calculatePosition"] = $3bf8781424353f41$export$b3ceb0cbf1056d98;

});

parcelRegister("8i6M6", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // Transformation
const $37644829fde681f1$export$a3c0fcb7531fdfae = {
    key: 'transform-menu-section'
};
const $37644829fde681f1$export$3ca3ae97eef4f3f0 = {
    key: 'transform-menu-item'
};
const $37644829fde681f1$export$34447db936e8c6fc = {
    key: 'transform-create-menu-section'
};
const $37644829fde681f1$export$385a1c1d9736262f = {
    key: 'transform-headings-menu-secion'
};
const $37644829fde681f1$export$80e640e763379a61 = {
    key: 'transform-headings-h1-menu-item'
};
const $37644829fde681f1$export$d31447f17d5c40f8 = {
    key: 'transform-headings-heading-2-menu-item'
};
const $37644829fde681f1$export$2d9132330244bad7 = {
    key: 'transform-headings-heading-3-menu-item'
};
const $37644829fde681f1$export$b5bbd55812f553dd = {
    key: 'transform-headings-heading-4-menu-item'
};
const $37644829fde681f1$export$33814ca575ac386 = {
    key: 'transform-headings-heading-5-menu-item'
};
const $37644829fde681f1$export$a8ceacf53925c4c2 = {
    key: 'transform-headings-heading-6-menu-item'
};
const $37644829fde681f1$export$bbc46da54e477efa = {
    key: 'transform-suggested-menu-section'
};
const $37644829fde681f1$export$c2d6d85aaa7f89 = {
    key: 'transform-structure-menu-section'
};
const $37644829fde681f1$export$d816a8e427c44cab = {
    key: 'transform-suggested-menu-item'
};
const $37644829fde681f1$export$e99d73a096eba9d8 = {
    key: 'transform-structure-bulleted-list-menu-item'
};
const $37644829fde681f1$export$4f5251553e2c0d3b = {
    key: 'transform-structure-task-list-menu-item'
};
const $37644829fde681f1$export$320d169c65770531 = {
    key: 'transform-structure-numbered-list-menu-item'
};
const $37644829fde681f1$export$5bbaff6e2e9a6ff0 = {
    key: 'transform-structure-code-block-menu-item'
};
const $37644829fde681f1$export$3017e11a8c1f80da = {
    key: 'transform-structure-panel-menu-item'
};
const $37644829fde681f1$export$6177b4b3a7cfe84a = {
    key: 'transform-structure-expand-menu-item'
};
const $37644829fde681f1$export$63f059e253c26b26 = {
    key: 'transform-structure-layout-menu-item'
};
const $37644829fde681f1$export$f2570dad43233f20 = {
    key: 'transform-structure-quote-menu-item'
};
const $37644829fde681f1$export$6f504bddd3dd2224 = {
    key: 'transform-structure-decision-menu-item'
};
const $37644829fde681f1$export$cc2e3e5d65e6f0d4 = {
    key: 'transform-structure-paragraph-menu-item'
};
const $37644829fde681f1$export$a23188d593dca4ea = {
    key: 'transform-clear-menu-section'
};
const $37644829fde681f1$export$745da57990b04239 = {
    key: 'transform-clear-menu-item'
};
const $37644829fde681f1$export$a3f6bf14b5ca64b8 = {
    key: 'transform-default-extension-slot-menu-item'
};
const $37644829fde681f1$export$c1df15c59989a309 = {
    key: 'block-actions-featured-extension-slot-menu-item'
};
const $37644829fde681f1$export$3867fe0cfddbf139 = {
    key: 'block-actions-template-section'
};
const $37644829fde681f1$export$6fea06990444f5d3 = [
    'block-actions-template-section'
];
const $37644829fde681f1$export$ac3b29d06d42b0ea = {
    key: 'block-actions-menu-section'
};
const $37644829fde681f1$export$cfe82275ae8140a2 = {
    key: 'block-actions-create-synced-block-menu-item'
};
const $37644829fde681f1$export$b20c456de8129c0 = {
    key: 'block-actions-copy-link-to-block-menu-item'
};
const $37644829fde681f1$export$483ea0be292b7dac = {
    key: 'block-actions-copy-menu-section'
};
const $37644829fde681f1$export$770efbdcddf7d03b = {
    key: 'position-menu-section'
};
const $37644829fde681f1$export$f74c131f207c4e6e = {
    key: 'position-move-up-menu-item'
};
const $37644829fde681f1$export$849e72f364364410 = {
    key: 'position-move-down-menu-item'
};
const $37644829fde681f1$export$ca2108a38e6280a5 = {
    key: 'delete-menu-section'
};
const $37644829fde681f1$export$1bb697e1417f5dce = {
    key: 'delete-menu-item'
};
const $37644829fde681f1$export$f826d1887c683892 = 'editor-block-menu';
const $37644829fde681f1$export$58ecf5644244b209 = {
    MOVE_UP: 'block-menu-move-up',
    MOVE_DOWN: 'block-menu-move-down',
    DELETE: 'block-menu-delete',
    COPY_LINK: 'block-menu-copy-link'
};
const $37644829fde681f1$export$9bac3cc6a7894e2 = 'extension-menu-item';
const $37644829fde681f1$export$8ee5435f172be1d5 = {
    key: 'ai-menu-section'
};
const $37644829fde681f1$export$fb755d72aa4ac157 = 300;
const $37644829fde681f1$export$e118f97623bf0ced = {
    key: 'block-menu-ai-ask-rovo-menu-item'
};
const $37644829fde681f1$export$3c7acd6b38230e6c = {
    key: 'block-menu-ai-improve-writing-menu-item'
};
const $37644829fde681f1$export$1aa04b5aeed1c667 = {
    key: 'block-menu-ai-polish-menu-item'
};
const $37644829fde681f1$export$c5db784a4bf3dac3 = {
    key: 'block-menu-ai-remix-menu-item'
};
module.exports["TRANSFORM_MENU_SECTION"] = $37644829fde681f1$export$a3c0fcb7531fdfae;
module.exports["TRANSFORM_MENU_ITEM"] = $37644829fde681f1$export$3ca3ae97eef4f3f0;
module.exports["TRANSFORM_CREATE_MENU_SECTION"] = $37644829fde681f1$export$34447db936e8c6fc;
module.exports["TRANSFORM_HEADINGS_MENU_SECTION"] = $37644829fde681f1$export$385a1c1d9736262f;
module.exports["TRANSFORM_HEADINGS_H1_MENU_ITEM"] = $37644829fde681f1$export$80e640e763379a61;
module.exports["TRANSFORM_HEADINGS_H2_MENU_ITEM"] = $37644829fde681f1$export$d31447f17d5c40f8;
module.exports["TRANSFORM_HEADINGS_H3_MENU_ITEM"] = $37644829fde681f1$export$2d9132330244bad7;
module.exports["TRANSFORM_HEADINGS_H4_MENU_ITEM"] = $37644829fde681f1$export$b5bbd55812f553dd;
module.exports["TRANSFORM_HEADINGS_H5_MENU_ITEM"] = $37644829fde681f1$export$33814ca575ac386;
module.exports["TRANSFORM_HEADINGS_H6_MENU_ITEM"] = $37644829fde681f1$export$a8ceacf53925c4c2;
module.exports["TRANSFORM_SUGGESTED_MENU_SECTION"] = $37644829fde681f1$export$bbc46da54e477efa;
module.exports["TRANSFORM_STRUCTURE_MENU_SECTION"] = $37644829fde681f1$export$c2d6d85aaa7f89;
module.exports["TRANSFORM_SUGGESTED_MENU_ITEM"] = $37644829fde681f1$export$d816a8e427c44cab;
module.exports["TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM"] = $37644829fde681f1$export$e99d73a096eba9d8;
module.exports["TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM"] = $37644829fde681f1$export$4f5251553e2c0d3b;
module.exports["TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM"] = $37644829fde681f1$export$320d169c65770531;
module.exports["TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM"] = $37644829fde681f1$export$5bbaff6e2e9a6ff0;
module.exports["TRANSFORM_STRUCTURE_PANEL_MENU_ITEM"] = $37644829fde681f1$export$3017e11a8c1f80da;
module.exports["TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM"] = $37644829fde681f1$export$6177b4b3a7cfe84a;
module.exports["TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM"] = $37644829fde681f1$export$63f059e253c26b26;
module.exports["TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM"] = $37644829fde681f1$export$f2570dad43233f20;
module.exports["TRANSFORM_STRUCTURE_DECISION_MENU_ITEM"] = $37644829fde681f1$export$6f504bddd3dd2224;
module.exports["TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM"] = $37644829fde681f1$export$cc2e3e5d65e6f0d4;
module.exports["TRANSFORM_CLEAR_MENU_SECTION"] = $37644829fde681f1$export$a23188d593dca4ea;
module.exports["TRANSFORM_CLEAR_MENU_ITEM"] = $37644829fde681f1$export$745da57990b04239;
module.exports["TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM"] = $37644829fde681f1$export$a3f6bf14b5ca64b8;
module.exports["BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM"] = $37644829fde681f1$export$c1df15c59989a309;
module.exports["BLOCK_ACTIONS_TEMPLATE_SECTION"] = $37644829fde681f1$export$3867fe0cfddbf139;
module.exports["BLOCK_ACTIONS_MENU_SECTION"] = $37644829fde681f1$export$ac3b29d06d42b0ea;
module.exports["BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM"] = $37644829fde681f1$export$cfe82275ae8140a2;
module.exports["BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM"] = $37644829fde681f1$export$b20c456de8129c0;
module.exports["BLOCK_ACTIONS_COPY_MENU_SECTION"] = $37644829fde681f1$export$483ea0be292b7dac;
module.exports["POSITION_MENU_SECTION"] = $37644829fde681f1$export$770efbdcddf7d03b;
module.exports["POSITION_MOVE_UP_MENU_ITEM"] = $37644829fde681f1$export$f74c131f207c4e6e;
module.exports["POSITION_MOVE_DOWN_MENU_ITEM"] = $37644829fde681f1$export$849e72f364364410;
module.exports["DELETE_MENU_SECTION"] = $37644829fde681f1$export$ca2108a38e6280a5;
module.exports["DELETE_MENU_ITEM"] = $37644829fde681f1$export$1bb697e1417f5dce;
module.exports["BLOCK_MENU_TEST_ID"] = $37644829fde681f1$export$f826d1887c683892;
module.exports["BLOCK_MENU_ACTION_TEST_ID"] = $37644829fde681f1$export$58ecf5644244b209;
module.exports["EXTENSION_MENU_ITEM_TEST_ID"] = $37644829fde681f1$export$9bac3cc6a7894e2;
module.exports["AI_MENU_SECTION"] = $37644829fde681f1$export$8ee5435f172be1d5;
module.exports["AI_BLOCK_MENU_LARGE_TEXT_THRESHOLD"] = $37644829fde681f1$export$fb755d72aa4ac157;
module.exports["AI_ASK_ROVO_MENU_ITEM"] = $37644829fde681f1$export$e118f97623bf0ced;
module.exports["AI_IMPROVE_WRITING_MENU_ITEM"] = $37644829fde681f1$export$3c7acd6b38230e6c;
module.exports["AI_POLISH_MENU_ITEM"] = $37644829fde681f1$export$1aa04b5aeed1c667;
module.exports["AI_REMIX_MENU_ITEM"] = $37644829fde681f1$export$c5db784a4bf3dac3;

});

parcelRegister("cCXFd", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8i6M6 = parcelRequire("8i6M6");

const $27cb189669cfc14d$export$1fa59ca2cd42fda1 = {
    [(0, $8i6M6.AI_MENU_SECTION).key]: 100,
    [(0, $8i6M6.TRANSFORM_MENU_SECTION).key]: 200,
    [(0, $8i6M6.BLOCK_ACTIONS_TEMPLATE_SECTION).key]: 250,
    [(0, $8i6M6.BLOCK_ACTIONS_MENU_SECTION).key]: 300,
    [(0, $8i6M6.BLOCK_ACTIONS_COPY_MENU_SECTION).key]: 350,
    [(0, $8i6M6.POSITION_MENU_SECTION).key]: 400,
    [(0, $8i6M6.DELETE_MENU_SECTION).key]: 500
};
const $27cb189669cfc14d$export$f6e766e0dc1b4cae = {
    [(0, $8i6M6.AI_ASK_ROVO_MENU_ITEM).key]: 100
};
const $27cb189669cfc14d$export$9e41545bda08797e = {
    [(0, $8i6M6.TRANSFORM_MENU_ITEM).key]: 100,
    [(0, $8i6M6.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]: 200,
    [(0, $8i6M6.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 300
};
const $27cb189669cfc14d$export$d0040892fb8e31d3 = {
    [(0, $8i6M6.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 100
};
const $27cb189669cfc14d$export$b3f35fbdee992328 = {
    [(0, $8i6M6.TRANSFORM_SUGGESTED_MENU_ITEM).key]: 100
};
const $27cb189669cfc14d$export$fb745cd9e8ece9b3 = {
    [(0, $8i6M6.TRANSFORM_SUGGESTED_MENU_SECTION).key]: 100,
    [(0, $8i6M6.TRANSFORM_CREATE_MENU_SECTION).key]: 200,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key]: 300,
    [(0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key]: 400,
    [(0, $8i6M6.TRANSFORM_CLEAR_MENU_SECTION).key]: 500
};
const $27cb189669cfc14d$export$8a17e62e7bf2e23a = {
    [(0, $8i6M6.TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM).key]: 1000
};
const $27cb189669cfc14d$export$41ce132dcee74abf = {
    [(0, $8i6M6.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]: 100,
    [(0, $8i6M6.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 200,
    [(0, $8i6M6.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]: 300,
    [(0, $8i6M6.TRANSFORM_HEADINGS_H4_MENU_ITEM).key]: 400,
    [(0, $8i6M6.TRANSFORM_HEADINGS_H5_MENU_ITEM).key]: 500,
    [(0, $8i6M6.TRANSFORM_HEADINGS_H6_MENU_ITEM).key]: 600
};
const $27cb189669cfc14d$export$575896636002a88 = {
    [(0, $8i6M6.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]: 200,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 300,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]: 400,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 500,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 600,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 700,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 800,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key]: 900,
    [(0, $8i6M6.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 1000
};
const $27cb189669cfc14d$export$a36e8b8d5a6bf549 = {
    [(0, $8i6M6.TRANSFORM_CLEAR_MENU_ITEM).key]: 100
};
const $27cb189669cfc14d$export$ad596cf0c7684e08 = {
    [(0, $8i6M6.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]: 100,
    [(0, $8i6M6.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 200,
    [(0, $8i6M6.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]: 300
};
const $27cb189669cfc14d$export$15097da746e4c9f2 = {
    [(0, $8i6M6.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]: 100
};
const $27cb189669cfc14d$export$5d8a5a6209dd67c3 = {
    [(0, $8i6M6.POSITION_MOVE_UP_MENU_ITEM).key]: 100,
    [(0, $8i6M6.POSITION_MOVE_DOWN_MENU_ITEM).key]: 200
};
const $27cb189669cfc14d$export$c635062ff5e2cdef = {
    [(0, $8i6M6.DELETE_MENU_ITEM).key]: 100
};
module.exports["MAIN_BLOCK_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$1fa59ca2cd42fda1;
module.exports["AI_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$f6e766e0dc1b4cae;
module.exports["TRANSFORM_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$9e41545bda08797e;
module.exports["BLOCK_ACTIONS_FEATURED_EXTENSION_ITEM_RANK"] = $27cb189669cfc14d$export$d0040892fb8e31d3;
module.exports["TRANSFORM_SUGGESTED_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$b3f35fbdee992328;
module.exports["TRANSFORM_MENU_ITEM_RANK"] = $27cb189669cfc14d$export$fb745cd9e8ece9b3;
module.exports["TRANSFORM_CREATE_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$8a17e62e7bf2e23a;
module.exports["TRANSFORM_HEADINGS_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$41ce132dcee74abf;
module.exports["TRANSFORM_STRUCTURE_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$575896636002a88;
module.exports["BLOCK_ACTIONS_COPY_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$15097da746e4c9f2;
module.exports["POSITION_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$5d8a5a6209dd67c3;
module.exports["DELETE_MENU_SECTION_RANK"] = $27cb189669cfc14d$export$c635062ff5e2cdef;

});

parcelRegister("jw4KW", function(module, exports) {
/**
 * Searches for the popup container element relative to the provided editor view element.
 *
 * @param editorViewEl - The editor view HTMLElement.
 * @returns The popup container HTMLElement if found, otherwise undefined.
 */ const $292bc4fd2f38ffba$export$f562a1e3da45e3ca = (editorViewEl)=>{
    const editorContentArea = editorViewEl?.closest('.ak-editor-content-area');
    const pluginsComponentsWrapper = editorContentArea?.querySelector(':scope > [data-testid="plugins-components-wrapper"]');
    return pluginsComponentsWrapper || undefined;
};
module.exports["getPopupContainerFromEditorView"] = $292bc4fd2f38ffba$export$f562a1e3da45e3ca;

});

parcelRegister("7Upsh", function(module, exports) {

var $5SlVI = parcelRequire("5SlVI");

var $gMOVH = parcelRequire("gMOVH");

var $etdmL = parcelRequire("etdmL");


var $eBSR7 = parcelRequire("eBSR7");


var $iUNgd = parcelRequire("iUNgd");


var $di3bZ = parcelRequire("di3bZ");


var $kCECX = parcelRequire("kCECX");

const $94114cb9b4e52bc4$export$54fdd3c2782161ea = new (0, $kCECX.PluginKey)('scrollGutter');
const $94114cb9b4e52bc4$export$a237783470abe542 = (state)=>{
    if (state) return $94114cb9b4e52bc4$export$54fdd3c2782161ea.getState(state);
};


const $ff3b167ec0457521$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $94114cb9b4e52bc4$export$54fdd3c2782161ea), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };



var $8dxef = parcelRequire("8dxef");


var $kpCD8 = parcelRequire("kpCD8");




function $c26041f74bced5f9$var$getCurrentBrowserAndVersion(browserEnv) {
    switch(true){
        case browserEnv.chrome === true:
            return {
                browser: 'chrome',
                version: browserEnv.chrome_version
            };
        case browserEnv.ie === true:
            return {
                browser: 'ie',
                version: browserEnv.ie_version
            };
        case browserEnv.gecko === true:
            return {
                browser: 'gecko',
                version: browserEnv.gecko_version
            };
        case browserEnv.safari === true:
            return {
                browser: 'safari',
                version: browserEnv.safari_version
            };
    }
    return undefined;
}
var $c26041f74bced5f9$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $kpCD8.SafePlugin)({
        key: new (0, $kCECX.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const browserEnv = (0, $8dxef.getBrowserInfo)();
                const userCurrentBrowserAndVersion = $c26041f74bced5f9$var$getCurrentBrowserAndVersion(browserEnv);
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !browserEnv[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : browserEnv[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });



var $krYZG = parcelRequire("krYZG");

var $gkq2M = parcelRequire("gkq2M");




const $4f7286f18986e8f0$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $4f7286f18986e8f0$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $kpCD8.SafePlugin)({
        filterTransaction (transaction) {
            if ($4f7286f18986e8f0$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $gkq2M.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};





var $iLcY8 = parcelRequire("iLcY8");


var $ehJxy = parcelRequire("ehJxy");


var $gMweA = parcelRequire("gMweA");





var $6pnwK = parcelRequire("6pnwK");




/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $4fc95bbcd5372581$export$324d9bc8f4935d84 = (value)=>value;





/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $13d1b7101a31f768$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;


class $8a80e21665e8d373$export$2e2bcd8739ae039 {
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $13d1b7101a31f768$export$a26b90db2c8f1b97)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                this.onSlowInput?.(time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                this.flush();
                this.onSampleEnd?.(time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        this.dispatchAverage?.({
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $6pnwK.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = void 0;
        this.slowThreshold = void 0;
        this.normalThreshold = void 0;
        this.degradedThreshold = void 0;
        this.dispatchAverage = void 0;
        this.dispatchSample = void 0;
        this.onSampleStart = void 0;
        this.onSampleEnd = void 0;
        this.onSlowInput = void 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
}


const $d44184047ed8cbb5$export$70246689264eff75 = new (0, $kCECX.PluginKey)('frozenEditor');
const $d44184047ed8cbb5$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $d44184047ed8cbb5$var$DEFAULT_SLOW_THRESHOLD = 300;
const $d44184047ed8cbb5$export$c8d5b833abcf8e80 = 600;
const $d44184047ed8cbb5$export$47b2879ca9bbf67a = 2000;
const $d44184047ed8cbb5$export$1b622068be977101 = 3000;
const $d44184047ed8cbb5$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $d44184047ed8cbb5$export$5705ac5f923a65e7 = 100;
const $d44184047ed8cbb5$export$1c6feb3429832c55 = 500;
const $d44184047ed8cbb5$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    };
var $d44184047ed8cbb5$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
        let interactionType;
        let inputLatencyTracker = null;
        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $4fc95bbcd5372581$export$324d9bc8f4935d84)((0, $iLcY8.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $d44184047ed8cbb5$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        // TODO: ED-26959 - get right values here based on appearance
        const slowThreshold = $d44184047ed8cbb5$var$DEFAULT_SLOW_THRESHOLD;
        // TODO: ED-26959 - get right values here based on appearance
        const freezeThreshold = $d44184047ed8cbb5$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $ehJxy.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = inputTracking?.trackSeverity || $d44184047ed8cbb5$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = inputTracking?.severityNormalThreshold || $d44184047ed8cbb5$export$5705ac5f923a65e7;
        const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $d44184047ed8cbb5$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $kpCD8.SafePlugin)({
            key: $d44184047ed8cbb5$export$70246689264eff75,
            props: (0, $gMweA.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $iLcY8.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $4fc95bbcd5372581$export$324d9bc8f4935d84)((0, $iLcY8.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $4fc95bbcd5372581$export$324d9bc8f4935d84)((0, $iLcY8.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $gMweA.isPerformanceObserverAvailable)()) return {};
                inputLatencyTracker = new (0, $8a80e21665e8d373$export$2e2bcd8739ae039)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $krYZG.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $krYZG.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $krYZG.ACTION).SLOW_INPUT,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                            },
                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $d44184047ed8cbb5$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, (0, $6pnwK.getAnalyticsEventSeverity)(duration, // Ignored via go/ees007
                            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                            //TODO: get right values here
                            severityThresholdNormal, severityThresholdDegraded));
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        inputLatencyTracker?.flush();
                        observer?.disconnect();
                    }
                };
            }
        });
    };









var $b9BvQ = parcelRequire("b9BvQ");


var $fngNp = parcelRequire("fngNp");





var $8nvEM = parcelRequire("8nvEM");

const $4a7c1663cc882ca0$export$8836bfc6be4cb708 = new (0, $kCECX.PluginKey)('inlineCursorTargetPlugin');
const $4a7c1663cc882ca0$var$isInlineNodeView = (node)=>{
    /**
   * If inlineNodeView is a hardbreak we don't want to add decorations
   * as it breaks soft line breaks for Japanese/Chinese keyboards.
   */ const isHardBreak = node?.type === node?.type.schema.nodes.hardBreak;
    return node && node.type.isInline && !node.type.isText && !isHardBreak;
};
var $4a7c1663cc882ca0$export$2e2bcd8739ae039 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $4a7c1663cc882ca0$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($4a7c1663cc882ca0$export$8836bfc6be4cb708);
                if (selection && (0, $b9BvQ.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $4a7c1663cc882ca0$var$isInlineNodeView($from.nodeAfter);
                    const hasInlineNodeViewBefore = $4a7c1663cc882ca0$var$isInlineNodeView($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $4a7c1663cc882ca0$var$isInlineNodeView($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $4a7c1663cc882ca0$var$isInlineNodeView($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $fngNp.ZERO_WIDTH_SPACE)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $8nvEM.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $4a7c1663cc882ca0$export$8836bfc6be4cb708.getState(state);
                if ($4a7c1663cc882ca0$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $8nvEM.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO: ED-26959 - We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    const browser = (0, $8dxef.getBrowserInfo)();
                    if (browser.safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($4a7c1663cc882ca0$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $4a7c1663cc882ca0$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $4a7c1663cc882ca0$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $4a7c1663cc882ca0$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $4a7c1663cc882ca0$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $4a7c1663cc882ca0$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $4a7c1663cc882ca0$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const defaultTransaction = ()=>view.state.tr.insertText(content, cursorTarget.positions.from, cursorTarget.positions.to);
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content, defaultTransaction));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    view.dispatch(defaultTransaction());
}



var $hMfrQ = parcelRequire("hMfrQ");







const $c047ce784fa03d66$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $c047ce784fa03d66$export$650082547b31be68() {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $hMfrQ.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $hMfrQ.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $hMfrQ.lazyNodeViewDecorationPluginKey).getState(newState);
                if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                            class: $c047ce784fa03d66$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $8nvEM.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if (actionPayload?.type === 'clear') return {
                    decorations: (0, $8nvEM.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $hMfrQ.lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
           * After view update can clean up decorations...
           */ const pluginState = (0, $hMfrQ.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $8nvEM.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $hMfrQ.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}






var $dTPhv = parcelRequire("dTPhv");

var $iTNNs = parcelRequire("iTNNs");


var $44cyU = parcelRequire("44cyU");





var $ieeJu = parcelRequire("ieeJu");

const $bb2c4342007ad659$export$2f489388b18569dd = new (0, $kCECX.PluginKey)('newlinePreserveMarksPlugin');
const $bb2c4342007ad659$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $bb2c4342007ad659$var$isSelectionFontSized = (state)=>{
    const { blockTaskItem: blockTaskItem, listItem: listItem } = state.schema.nodes;
    const { fontSize: fontSize } = state.schema.marks;
    const $to = state.selection.$to;
    const grandParent = $to.node($to.depth - 1);
    if (!fontSize || // don't intercept Enter inside blockTaskItem or listItem
    grandParent && (grandParent.type === blockTaskItem || grandParent.type === listItem)) return false;
    return !!$to.parent.marks.find((m)=>m.type === fontSize);
};
const $bb2c4342007ad659$var$hasBlockMarksToPreserve = (state)=>$bb2c4342007ad659$var$isSelectionAligned(state) || $bb2c4342007ad659$var$isSelectionFontSized(state);
const $bb2c4342007ad659$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $bb2c4342007ad659$export$2e2bcd8739ae039 = ()=>new (0, $kpCD8.SafePlugin)({
        key: $bb2c4342007ad659$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Enter: (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? (0, $dTPhv.filter)([
                    (0, $iTNNs.isSelectionEndOfParagraph),
                    $bb2c4342007ad659$var$hasBlockMarksToPreserve
                ], $bb2c4342007ad659$var$splitBlockPreservingMarks) : (0, $dTPhv.filter)([
                    (0, $iTNNs.isSelectionEndOfParagraph),
                    $bb2c4342007ad659$var$isSelectionAligned
                ], $bb2c4342007ad659$var$splitBlockPreservingMarks)
            })
        }
    });






var $fqVYq = parcelRequire("fqVYq");


const $b873dd85c7c807c8$var$GUTTER_SIZE_IN_PX = 120;
const $b873dd85c7c807c8$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
const $b873dd85c7c807c8$var$GUTTER_ATTR = 'data-editor-scroll-gutter';
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $b873dd85c7c807c8$var$createGutter(gutterSize, parent) {
    if ((0, $fqVYq.editorExperiment)('platform_editor_blocks', true)) {
        if (!parent) return ()=>{};
        const existing = parent.querySelector(`[${$b873dd85c7c807c8$var$GUTTER_ATTR}]`);
        if (existing instanceof HTMLElement) return ()=>parent.removeChild(existing);
        const gutter = document.createElement('div');
        gutter.style.paddingBottom = `${gutterSize}px`;
        gutter.setAttribute('data-vc', 'scroll-gutter');
        gutter.setAttribute($b873dd85c7c807c8$var$GUTTER_ATTR, 'true');
        parent.appendChild(gutter);
        return ()=>parent.removeChild(gutter);
    }
    const gutterRef = document.getElementById($b873dd85c7c807c8$var$GUTTER_SELECTOR_NAME);
    if (gutterRef) return ()=>parent?.removeChild(gutterRef);
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.setAttribute('data-vc', 'scroll-gutter');
    gutter.id = $b873dd85c7c807c8$var$GUTTER_SELECTOR_NAME;
    if (parent) parent.appendChild(gutter);
    return ()=>parent?.removeChild(gutter);
}
var // eslint-disable-next-line @typescript-eslint/no-empty-object-type
$b873dd85c7c807c8$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, gutterSize: gutterSize = $b873dd85c7c807c8$var$GUTTER_SIZE_IN_PX } = pluginOptions;
    if (!getScrollElement) return undefined;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $94114cb9b4e52bc4$export$54fdd3c2782161ea),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $94114cb9b4e52bc4$export$54fdd3c2782161ea))) return tr.getMeta((0, $94114cb9b4e52bc4$export$54fdd3c2782161ea));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize
        },
        view (view) {
            // Store references to avoid lookups on successive checks.
            const scrollElement = getScrollElement(view);
            let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
            let editorParentElement = editorElement?.parentElement;
            let cleanup = ()=>{};
            if (editorParentElement && scrollElement) cleanup = $b873dd85c7c807c8$var$createGutter(gutterSize, editorParentElement);
            return {
                destroy () {
                    cleanup();
                    editorParentElement = editorElement = null;
                }
            };
        }
    });
};



const $eead6fdef6a9499d$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $94114cb9b4e52bc4$export$a237783470abe542)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};


const $ff787522eb48dcae$export$30b652f8daa79df4 = {
    enabled: true,
    samplingRate: 100,
    countNodes: true,
    trackSeverity: true,
    trackRenderingTime: false,
    trackSingleKeypress: false,
    // TODO: ED-26959 - change this based on appearance due to SLOs - need to make ticket for both
    severityDegradedThreshold: 273,
    severityNormalThreshold: 143
};


function $ffbe24e2abe40ac7$export$edcd20463038b9e1(from, to, tr, callbacks) {
    const { doc: doc } = tr;
    doc.nodesBetween(from, to, (node, pos)=>{
        callbacks.forEach((cb)=>cb({
                tr: tr,
                node: node,
                pos: pos,
                from: from,
                to: to
            }));
    });
}
const $ffbe24e2abe40ac7$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// eslint-disable-next-line require-unicode-regexp
const $ffbe24e2abe40ac7$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($ffbe24e2abe40ac7$var$SMART_TO_ASCII).join('')}]`, 'g');
const $ffbe24e2abe40ac7$var$basePlugin = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const callbacks = [];
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos, from: from, to: to })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { text: textNodeType } = schema.nodes;
        if (node.type === textNodeType && node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($ffbe24e2abe40ac7$var$FIND_SMART_CHAR, (match)=>$ffbe24e2abe40ac7$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                allowScrollGutter: options?.allowScrollGutter,
                keyboardHeight: (0, $eead6fdef6a9499d$export$af5702f0c69bf4d7)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $ff3b167ec0457521$export$b8c3ea160300668d,
            resolveMarks: (from, to, tr)=>$ffbe24e2abe40ac7$export$edcd20463038b9e1(from, to, tr, callbacks),
            registerMarks: (callback)=>{
                callbacks.push(callback);
            }
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $4f7286f18986e8f0$export$2e2bcd8739ae039)(dispatchAnalyticsEvent)
                }
            ];
            plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $c047ce784fa03d66$export$650082547b31be68)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $4a7c1663cc882ca0$export$2e2bcd8739ae039)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $bb2c4342007ad659$export$2e2bcd8739ae039)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    return (0, $d44184047ed8cbb5$export$2e2bcd8739ae039)(api?.contextIdentifier)(dispatchAnalyticsEvent, (0, $ff787522eb48dcae$export$30b652f8daa79df4), undefined);
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $di3bZ.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $eBSR7.keymap)({
                        ...(0, $iUNgd.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $b873dd85c7c807c8$export$2e2bcd8739ae039)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $c26041f74bced5f9$export$2e2bcd8739ae039)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $5SlVI.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $gMOVH.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $etdmL.text)
                }
            ];
        }
    };
};
var $ffbe24e2abe40ac7$export$2e2bcd8739ae039 = $ffbe24e2abe40ac7$var$basePlugin;
module.exports["default"] = $ffbe24e2abe40ac7$export$2e2bcd8739ae039;

});

parcelRegister("ehJxy", function(module, exports) {
function $c21bbcd401d6f510$export$1daf15cbaf649dad(state) {
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        nodeTypes.extension?.name,
        nodeTypes.inlineExtension?.name,
        nodeTypes.bodiedExtension?.name,
        nodeTypes.multiBodiedExtension?.name
    ];
    state.doc.descendants((node)=>{
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
            extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}
module.exports["countNodes"] = $c21bbcd401d6f510$export$1daf15cbaf649dad;

});

parcelRegister("hMfrQ", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kCECX = parcelRequire("kCECX");

const $c0c1006b286bec0d$var$hasIdleCallback = 'requestIdleCallback' in window;
const $c0c1006b286bec0d$export$4db3c991f22dbc2d = (cb, options)=>{
    return $c0c1006b286bec0d$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $c0c1006b286bec0d$export$b888d8f981c07a46 = (id)=>{
    return $c0c1006b286bec0d$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};



var $5xdta = parcelRequire("5xdta");


var $d6dQh = parcelRequire("d6dQh");


var $8Dx7s = parcelRequire("8Dx7s");

const $fe1f94323ce6ace2$export$325659f41b2239a7 = new (0, $kCECX.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $fe1f94323ce6ace2$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $fe1f94323ce6ace2$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $fe1f94323ce6ace2$var$debounceToEditorViewMap = new WeakMap();
const $fe1f94323ce6ace2$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $fe1f94323ce6ace2$export$6c7e823c919edf69(view) {
    $fe1f94323ce6ace2$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $fe1f94323ce6ace2$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    return (node, view, getPos, decorations, innerDecorations)=>{
        let requestedNodes = $fe1f94323ce6ace2$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $fe1f94323ce6ace2$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $fe1f94323ce6ace2$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $fe1f94323ce6ace2$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews?.get(nodeName);
            if (resolvedNodeView && !$fe1f94323ce6ace2$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations, innerDecorations);
            return new (0, $d6dQh.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            const nodeViewFunc = (node, view, getPos, decorations, innerDecorations)=>{
                const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions, innerDecorations);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = nodeView.dom;
                dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                const pos = getPos();
                if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, $5xdta.makeNodePlaceholderId)(node.type.name, pos));
                return nodeView;
            };
            $fe1f94323ce6ace2$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
            /**
       * Triggering lazyNodeViewDecoration plugin to apply decorations
       * to nodes with newly loaded NodeViews.
       */ const [callbackId, nodeTypes] = $fe1f94323ce6ace2$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $c0c1006b286bec0d$export$b888d8f981c07a46)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $c0c1006b286bec0d$export$4db3c991f22dbc2d)(()=>{
                $fe1f94323ce6ace2$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($fe1f94323ce6ace2$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $fe1f94323ce6ace2$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
       * END triggering LazyNodeViewDecoration plugin
       */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof node.type?.spec?.toDOM;
        return new (0, $d6dQh.LazyNodeView)(node, view, getPos, decorations);
    };
};
module.exports["lazyNodeViewDecorationPluginKey"] = $fe1f94323ce6ace2$export$325659f41b2239a7;
module.exports["withLazyLoading"] = $fe1f94323ce6ace2$export$6b97b121e15a69b7;

});

parcelRegister("8Dx7s", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $db780643ed103ed5$var$MS_PREFIX_REGEX = /^ms/;
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $db780643ed103ed5$var$hyphenate(property) {
    // Ignored via go/ees005
    /* eslint-disable require-unicode-regexp */ return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace($db780643ed103ed5$var$MS_PREFIX_REGEX, '-ms');
/* eslint-enable require-unicode-regexp */ }
function $db780643ed103ed5$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $db780643ed103ed5$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}
module.exports["convertToInlineCss"] = $db780643ed103ed5$export$7da93c9174ab9340;

});

parcelRegister("lK9Pz", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $jGEbn = parcelRequire("jGEbn");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $di3bZ = parcelRequire("di3bZ");




const $44d62459c884e4ca$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('betterTypeHistoryPlugin');


const $1b17d7432ac0d83d$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $kCECX.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $1b17d7432ac0d83d$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $1b17d7432ac0d83d$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $aPdNQ.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $1b17d7432ac0d83d$export$2e2bcd8739ae039 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $44d62459c884e4ca$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $44d62459c884e4ca$export$18d4026d1ea86bb1)));
            if (hasHandlePasteMeta) return (0, $di3bZ.closeHistory)(newState.tr);
            const enterStep = $1b17d7432ac0d83d$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $jGEbn.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($1b17d7432ac0d83d$var$isSliceSplittingBlockNode(slice) || $1b17d7432ac0d83d$var$isSliceAddingNewlineChar(slice, schema))) return (0, $di3bZ.closeHistory)(newState.tr);
        }
    });
};



/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $ed72165ee738a98e$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $44d62459c884e4ca$export$18d4026d1ea86bb1), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $1b17d7432ac0d83d$export$2e2bcd8739ae039)()
                }
            ];
        }
    };
};
module.exports["betterTypeHistoryPlugin"] = $ed72165ee738a98e$export$5587393ddd97118a;

});

parcelRegister("lVAkE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $cycWk = parcelRequire("cycWk");

var $8imfU = parcelRequire("8imfU");


var $aXHNB = parcelRequire("aXHNB");


var $c7UOz = parcelRequire("c7UOz");


var $4EksL = parcelRequire("4EksL");


var $1GYCH = parcelRequire("1GYCH");


var $inM0i = parcelRequire("inM0i");






function $8ca25e86c62a1016$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $4EksL.GapCursorSelection)) return false;
    if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.isBlock) return true;
    return (0, $c7UOz.endPositionOfParent)($to) === $to.pos + 1;
}
function $8ca25e86c62a1016$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    return $8ca25e86c62a1016$export$dba2543e302d55ed(selection);
}
function $8ca25e86c62a1016$export$dba2543e302d55ed(selection) {
    const { $from: $from } = selection;
    if (selection instanceof (0, $4EksL.GapCursorSelection)) return false;
    if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.isBlock) return true;
    return (0, $inM0i.startPositionOfParent)($from) === $from.pos;
}
const $8ca25e86c62a1016$export$2c0117b92050cffe = (tr, selectionToUse)=>{
    const selection = selectionToUse || tr.selection;
    let from = selection.$from.pos;
    let to = selection.$to.pos;
    if (selection instanceof (0, $kCECX.TextSelection)) {
        // Expand just the from position to the start of the block
        // This ensures entire paragraphs are deleted instead of just
        // the text content, which avoids leaving an empty line behind
        const expanded = $8ca25e86c62a1016$export$f69f5016bc6a173(selection.$from, selection.$to);
        from = expanded.$from.pos;
    } else if ((0, $8imfU.isTableSelected)(selection)) {
        const table = (0, $cycWk.findTable)(selection);
        if (table) {
            from = table.pos;
            to = table.pos + table.node.nodeSize;
        }
    }
    tr.deleteRange(from, to);
    return tr;
};
const $8ca25e86c62a1016$var$getDefaultPredicate = ({ nodes: nodes })=>{
    const requiresFurtherExpansion = new Set([
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList,
        nodes.listItem,
        nodes.taskItem,
        nodes.tableHeader,
        nodes.tableRow,
        nodes.tableCell,
        nodes.table,
        nodes.mediaGroup,
        nodes.mediaSingle
    ]);
    return (node)=>!requiresFurtherExpansion.has(node.type);
};
const $8ca25e86c62a1016$export$f69f5016bc6a173 = ($from, $to, predicate = $8ca25e86c62a1016$var$getDefaultPredicate($from.doc.type.schema))=>{
    const range = $from.blockRange($to, predicate);
    if (!range) return {
        $from: $from,
        $to: $to
    };
    return {
        $from: $from.doc.resolve(range.start),
        $to: $to.doc.resolve(range.end),
        range: range
    };
};
const $8ca25e86c62a1016$export$cf7b5a42a57ba7c7 = ({ $from: $from, $to: $to })=>{
    return $8ca25e86c62a1016$export$f69f5016bc6a173($from, $to);
};
function $8ca25e86c62a1016$export$87365ac27c0f1ed1(selection) {
    const { range: range } = $8ca25e86c62a1016$export$cf7b5a42a57ba7c7(selection);
    if (!range) return false;
    return (0, $1GYCH.isMultiBlockRange)(range);
}
function $8ca25e86c62a1016$export$d9d2142e5263c662(tr, selection) {
    const { $from: $from, $to: $to } = $8ca25e86c62a1016$export$cf7b5a42a57ba7c7(selection);
    const selectedParent = $from.parent;
    const isList = (0, $aXHNB.isListNode)(selectedParent);
    const sliceStart = isList ? $from.pos - 1 : $from.pos;
    const sliceEnd = isList ? $to.pos + 1 : $to.pos;
    const slice = tr.doc.slice(sliceStart, sliceEnd);
    return [
        ...slice.content.content
    ];
}
module.exports["atTheEndOfBlock"] = $8ca25e86c62a1016$export$6f303ca7dac350ae;
module.exports["atTheBeginningOfBlock"] = $8ca25e86c62a1016$export$8351d833af62ae68;
module.exports["selectionIsAtTheBeginningOfBlock"] = $8ca25e86c62a1016$export$dba2543e302d55ed;
module.exports["deleteSelectedRange"] = $8ca25e86c62a1016$export$2c0117b92050cffe;
module.exports["expandToBlockRange"] = $8ca25e86c62a1016$export$f69f5016bc6a173;
module.exports["expandSelectionToBlockRange"] = $8ca25e86c62a1016$export$cf7b5a42a57ba7c7;
module.exports["isMultiBlockSelection"] = $8ca25e86c62a1016$export$87365ac27c0f1ed1;
module.exports["getSourceNodesFromSelectionRange"] = $8ca25e86c62a1016$export$d9d2142e5263c662;

});

parcelRegister("8imfU", function(module, exports) {

var $8Z43Z = parcelRequire("8Z43Z");


var $bc8rR = parcelRequire("bc8rR");

const $5819edd73f98b4ca$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $bc8rR.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $8Z43Z.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };
const $5819edd73f98b4ca$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $bc8rR.isSelectionType)(selection, 'cell')) {
            const map = (0, $8Z43Z.TableMap).get(selection.$anchorCell.node(-1));
            return $5819edd73f98b4ca$export$d06743a3adc2076d({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
const $5819edd73f98b4ca$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $bc8rR.isSelectionType)(selection, 'cell')) {
            const map = (0, $8Z43Z.TableMap).get(selection.$anchorCell.node(-1));
            return $5819edd73f98b4ca$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };
const $5819edd73f98b4ca$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $bc8rR.isSelectionType)(selection, 'cell')) {
        const map = (0, $8Z43Z.TableMap).get(selection.$anchorCell.node(-1));
        return $5819edd73f98b4ca$export$d06743a3adc2076d({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};
module.exports["isColumnSelected"] = $5819edd73f98b4ca$export$8db1cdcc0c397a6d;
module.exports["isRowSelected"] = $5819edd73f98b4ca$export$710e11cf672b86c;
module.exports["isTableSelected"] = $5819edd73f98b4ca$export$5d08de4a0eeb0408;

});

parcelRegister("c7UOz", function(module, exports) {
function $da2ce8038a4570b9$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
module.exports["endPositionOfParent"] = $da2ce8038a4570b9$export$8e09b50c60354750;

});

parcelRegister("1GYCH", function(module, exports) {
const $a954a07228f7b512$export$4327aeb0536d2384 = (range)=>{
    if (range.endIndex - range.startIndex <= 1) return false; // At most one child
    // Count block nodes in the range, return true if more than one
    let blockCount = 0;
    for(let i = range.startIndex; i < range.endIndex; i++){
        if (range.parent.child(i).isBlock) blockCount++;
        if (blockCount > 1) return true;
    }
    return false;
};
module.exports["isMultiBlockRange"] = $a954a07228f7b512$export$4327aeb0536d2384;

});

parcelRegister("inM0i", function(module, exports) {
function $4c43a52c90b6fdab$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
module.exports["startPositionOfParent"] = $4c43a52c90b6fdab$export$ced77c72038c89cb;

});

parcelRegister("jzePg", function(module, exports) {
function $3fd4a0cd8c458c87$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
module.exports["atTheEndOfDoc"] = $3fd4a0cd8c458c87$export$4ca816540352da02;

});

parcelRegister("c2E4R", function(module, exports) {
function $0c12d988a6481eff$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
module.exports["atTheBeginningOfDoc"] = $0c12d988a6481eff$export$e9083e8cbe24bec0;

});

parcelRegister("iQ6F7", function(module, exports) {
const $1249709673174418$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (toDepth < fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};
module.exports["expandSelectionBounds"] = $1249709673174418$export$748c2428d313e6d0;

});

parcelRegister("57Rmq", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

/**
 * Returns the base name of a node type, stripping known variant suffixes.
 */ const $006125c0c0c637c7$var$variantToBaseNameMap = {
    panel_c1: 'panel'
};
function $006125c0c0c637c7$export$e7c4aaf94dfc397d(nodeType) {
    return $006125c0c0c637c7$var$variantToBaseNameMap[nodeType.name] ?? nodeType.name;
}
function $006125c0c0c637c7$export$7138504956ccb99(a, b) {
    return $006125c0c0c637c7$export$e7c4aaf94dfc397d(a) === $006125c0c0c637c7$export$e7c4aaf94dfc397d(b);
}
function $006125c0c0c637c7$export$5131954471e1003(childTypeName, parentNode, schema) {
    const childType = schema.nodes[childTypeName];
    if (!childType) return false;
    const candidate = childType.createAndFill();
    if (!candidate) return false;
    return parentNode.type.validContent((0, $aPdNQ.Fragment).from(candidate));
}
function $006125c0c0c637c7$export$1dccb55ec61cba15($from) {
    const schema = $from.doc.type.schema;
    const { panel: panel, panel_c1: panel_c1 } = schema.nodes;
    if (!panel_c1) return panel;
    for(let depth = $from.depth; depth >= 0; depth--){
        const parent = $from.node(depth);
        const index = $from.index(depth);
        if (parent.canReplaceWith(index, index, panel_c1)) return panel_c1;
        const spec = parent.type.spec;
        // Stop at isolating containers (e.g. expand, tableCell) — hard walls where
        // the panel stays inside and should use the regular panel type.
        if (spec.isolating) return panel;
    }
    return panel;
}
module.exports["getBaseNodeTypeName"] = $006125c0c0c637c7$export$e7c4aaf94dfc397d;
module.exports["isNodeOfSameBaseType"] = $006125c0c0c637c7$export$7138504956ccb99;
module.exports["isNodeTypeValidChildOf"] = $006125c0c0c637c7$export$5131954471e1003;
module.exports["pickPanelTypeForInsertion"] = $006125c0c0c637c7$export$1dccb55ec61cba15;

});

parcelRegister("kPKLu", function(module, exports) {
const $80eca4a2d4693a70$export$d295c32f32566012 = ({ attrs: attrs, content: content, marks: marks, schema: schema })=>{
    const { blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    const newParagraph = paragraph.createChecked(null, content, marks?.filter((mark)=>blockTaskItem.allowsMarkType(mark.type)));
    return blockTaskItem.create(attrs ?? null, newParagraph);
};
module.exports["createBlockTaskItem"] = $80eca4a2d4693a70$export$d295c32f32566012;

});

parcelRegister("6gBg9", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $2nOF5 = parcelRequire("2nOF5");


var $eOaGc = parcelRequire("eOaGc");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fud2r = parcelRequire("fud2r");

const $30b609a912fcdbc1$export$dea78458f6234074 = false;
const $30b609a912fcdbc1$export$15e74cb2b99d4f44 = new WeakMap();
const $30b609a912fcdbc1$export$f86d342c9776cad6 = (attrs)=>{
    const localId = attrs?.localId ?? // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    ((0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_code_block_language_detection_flow') ? (0, $2nOF5.uuid).generate() : undefined);
    const attrsWithLocalId = localId ? {
        ...attrs,
        localId: localId
    } : attrs;
    if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return attrsWithLocalId;
    // Only boolean wrap values represent caller intent. null/undefined means unset.
    if (attrs?.wrap === true || attrs?.wrap === false) return attrsWithLocalId;
    return {
        ...attrsWithLocalId,
        wrap: true
    };
};
const $30b609a912fcdbc1$export$95a2b1adfd5a9190 = (slice, schema)=>{
    if (!(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return slice;
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type !== schema.nodes.codeBlock || node.attrs.wrap === true) return node;
        // Markdown conversion uses MarkdownParser token mappings and creates code block nodes
        // with the schema-default wrap:false. Since Markdown has no wrap syntax, treat that
        // default as missing user intent and change it to wrap:true.
        return node.type.create($30b609a912fcdbc1$export$f86d342c9776cad6(node.attrs), node.content, node.marks);
    });
};
const $30b609a912fcdbc1$var$isReplaceStep = (step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep);
const $30b609a912fcdbc1$var$isNodeShellReplaceStep = (step)=>step instanceof (0, $eOaGc.ReplaceAroundStep) && // Node shell updates preserve all inner content and only replace the outer node boundary.
    step.gapFrom === step.from + 1 && step.gapTo === step.to - 1;
const $30b609a912fcdbc1$var$hasInsertedCodeBlockInStep = (step, codeBlockType, filter)=>{
    let hasInsertedCodeBlock = false;
    step.slice.content.descendants((node)=>{
        if (node.type === codeBlockType && (!filter || filter(node))) {
            hasInsertedCodeBlock = true;
            return false;
        }
        return !hasInsertedCodeBlock;
    });
    return hasInsertedCodeBlock;
};
const $30b609a912fcdbc1$var$collectMappedInsertedRanges = (tr, stepIndex)=>{
    const ranges = [];
    const stepMap = tr.mapping.maps[stepIndex];
    const remainingMaps = tr.mapping.slice(stepIndex + 1);
    stepMap.forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
        if (newStart === newEnd) return;
        const finalFrom = remainingMaps.map(newStart, 1);
        const finalTo = remainingMaps.map(newEnd, -1);
        if (finalFrom < finalTo) ranges.push([
            finalFrom,
            finalTo
        ]);
    });
    return ranges;
};
const $30b609a912fcdbc1$export$ee996fbdea8dfc30 = (tr, codeBlockType, options = {})=>{
    const insertedCodeBlocks = [];
    const seenPositions = new Set();
    tr.steps.forEach((step, stepIndex)=>{
        if (!$30b609a912fcdbc1$var$isReplaceStep(step)) return;
        // Attribute/type updates can replace just the node shell while preserving content.
        // Those should not make an existing code block look newly inserted.
        if ($30b609a912fcdbc1$var$isNodeShellReplaceStep(step)) return;
        const insertedCodeBlockByStep = $30b609a912fcdbc1$var$hasInsertedCodeBlockInStep(step, codeBlockType, options.filter);
        if (!insertedCodeBlockByStep) return;
        $30b609a912fcdbc1$var$collectMappedInsertedRanges(tr, stepIndex).forEach(([from, to])=>{
            tr.doc.nodesBetween(from, to, (node, pos)=>{
                if (pos >= from && node.type === codeBlockType && (!options.filter || options.filter(node)) && !seenPositions.has(pos)) {
                    seenPositions.add(pos);
                    insertedCodeBlocks.push({
                        node: node,
                        pos: pos
                    });
                    return false;
                }
                return true;
            });
        });
    });
    return insertedCodeBlocks;
};
const $30b609a912fcdbc1$var$codeBlockFoldStates = new WeakMap();
const $30b609a912fcdbc1$export$ca74aa614fc297de = (codeBlockNode)=>{
    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return Boolean(codeBlockNode.attrs.wrap);
    const currentNodeWordWrapState = $30b609a912fcdbc1$export$15e74cb2b99d4f44.get(codeBlockNode);
    return currentNodeWordWrapState !== undefined ? currentNodeWordWrapState : $30b609a912fcdbc1$export$dea78458f6234074;
};
const $30b609a912fcdbc1$export$ae57f08acfae6877 = (codeBlockNode)=>{
    if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return false;
    return Boolean(codeBlockNode.attrs.hideLineNumbers);
};
const $30b609a912fcdbc1$export$17fa4cce31080ba8 = (codeBlockNode)=>!$30b609a912fcdbc1$export$ae57f08acfae6877(codeBlockNode);
const $30b609a912fcdbc1$export$dd8d371c28bc93ab = (codeBlockNode)=>{
    const currentNodeFoldState = $30b609a912fcdbc1$var$codeBlockFoldStates.get(codeBlockNode);
    return currentNodeFoldState || [];
};
const $30b609a912fcdbc1$export$84bbe896418e05aa = (codeBlockNode, foldRanges)=>{
    $30b609a912fcdbc1$var$codeBlockFoldStates.set(codeBlockNode, foldRanges);
};
const $30b609a912fcdbc1$export$8de8069131d61656 = (oldCodeBlockNode, newCodeBlockNode)=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)) $30b609a912fcdbc1$var$transferCodeBlockFoldValue(oldCodeBlockNode, newCodeBlockNode);
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($30b609a912fcdbc1$export$15e74cb2b99d4f44.has(newCodeBlockNode)) return;
    const previousValue = $30b609a912fcdbc1$export$ca74aa614fc297de(oldCodeBlockNode);
    $30b609a912fcdbc1$export$15e74cb2b99d4f44.set(newCodeBlockNode, previousValue);
    $30b609a912fcdbc1$export$15e74cb2b99d4f44.delete(oldCodeBlockNode);
};
/**
 * Swap the old node key with the new node key in the fold states WeakMap.
 */ const $30b609a912fcdbc1$var$transferCodeBlockFoldValue = (oldCodeBlockNode, newCodeBlockNode)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($30b609a912fcdbc1$var$codeBlockFoldStates.has(newCodeBlockNode)) return;
    const previousValue = $30b609a912fcdbc1$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $30b609a912fcdbc1$var$codeBlockFoldStates.set(newCodeBlockNode, previousValue);
    $30b609a912fcdbc1$var$codeBlockFoldStates.delete(oldCodeBlockNode);
};
const $30b609a912fcdbc1$export$de41d58f29620282 = (newCodeBlockNodes, oldState)=>{
    newCodeBlockNodes.forEach((newCodeBlockNode)=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)) $30b609a912fcdbc1$var$updateCodeBlockFoldStateNodeKeys(newCodeBlockNode, oldState);
        // Don't overwrite the value for the new node if it already exists.
        // This can happen when a drag&drop is swapping nodes.
        if ($30b609a912fcdbc1$export$15e74cb2b99d4f44.has(newCodeBlockNode.node)) return;
        // Do not go out of range on the oldState doc. Happens on initial load.
        if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
        const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
        if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
        const previousValue = $30b609a912fcdbc1$export$ca74aa614fc297de(oldCodeBlockNode);
        $30b609a912fcdbc1$export$15e74cb2b99d4f44.set(newCodeBlockNode.node, previousValue);
    });
};
/**
 * As the code block node is used as the fold state key, there is instances where the node will be destroyed & recreated and is no longer a valid key.
 * In these instances, we must get the value from that old node and set it to the value of the new node.
 * This function takes all the given nodes, finds their old nodes from the old state and updates these old node keys.
 */ const $30b609a912fcdbc1$var$updateCodeBlockFoldStateNodeKeys = (newCodeBlockNode, oldState)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($30b609a912fcdbc1$var$codeBlockFoldStates.has(newCodeBlockNode.node)) return;
    // Do not go out of range on the oldState doc. Happens on initial load.
    if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
    const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
    if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
    const previousValue = $30b609a912fcdbc1$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $30b609a912fcdbc1$var$codeBlockFoldStates.set(newCodeBlockNode.node, previousValue);
};
module.exports["defaultWordWrapState"] = $30b609a912fcdbc1$export$dea78458f6234074;
module.exports["codeBlockWrappedStates"] = $30b609a912fcdbc1$export$15e74cb2b99d4f44;
module.exports["getDefaultCodeBlockAttrs"] = $30b609a912fcdbc1$export$f86d342c9776cad6;
module.exports["normalizeMarkdownCodeBlockAttrsInSlice"] = $30b609a912fcdbc1$export$95a2b1adfd5a9190;
module.exports["getInsertedCodeBlocksInTransaction"] = $30b609a912fcdbc1$export$ee996fbdea8dfc30;
module.exports["isCodeBlockWordWrapEnabled"] = $30b609a912fcdbc1$export$ca74aa614fc297de;
module.exports["areCodeBlockLineNumbersHidden"] = $30b609a912fcdbc1$export$ae57f08acfae6877;
module.exports["areCodeBlockLineNumbersVisible"] = $30b609a912fcdbc1$export$17fa4cce31080ba8;
module.exports["getCodeBlockFoldState"] = $30b609a912fcdbc1$export$dd8d371c28bc93ab;
module.exports["setCodeBlockFoldState"] = $30b609a912fcdbc1$export$84bbe896418e05aa;
module.exports["transferCodeBlockWrappedValue"] = $30b609a912fcdbc1$export$8de8069131d61656;
module.exports["updateCodeBlockWrappedStateNodeKeys"] = $30b609a912fcdbc1$export$de41d58f29620282;

});

parcelRegister("brnfH", function(module, exports) {

var $ezEf7 = parcelRequire("ezEf7");

class $7eebd10ffb258560$export$e76932dc77daa06a {
    start(callback) {
        this.stop();
        const configResult = this.observeConfig();
        const configs = Array.isArray(configResult) ? configResult : [
            configResult
        ];
        const validConfigs = configs.filter((config)=>!!config?.target);
        if (validConfigs.length === 0) {
            callback({
                status: 'failure',
                reason: (0, $ezEf7.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_TARGET_NOT_FOUND
            });
            return;
        }
        this.mutationObserver = new MutationObserver((mutations)=>{
            try {
                const result = this.onDomMutation({
                    mutations: mutations
                });
                if (result) callback(result);
            } catch  {
                callback({
                    status: 'failure',
                    reason: (0, $ezEf7.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_CHECK_ERROR
                });
            }
        });
        for (const config of validConfigs){
            const { target: target, options: options } = config;
            if (target) this.mutationObserver.observe(target, options ?? {
                childList: true
            });
        }
    }
    stop() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = undefined;
        }
    }
    constructor({ onDomMutation: onDomMutation, observeConfig: observeConfig }){
        this.mutationObserver = void 0;
        this.onDomMutation = void 0;
        this.observeConfig = void 0;
        this.onDomMutation = onDomMutation;
        this.observeConfig = observeConfig;
    }
}
module.exports["ExperienceCheckDomMutation"] = $7eebd10ffb258560$export$e76932dc77daa06a;

});

parcelRegister("iil4f", function(module, exports) {

var $1hQ0e = parcelRequire("1hQ0e");


var $ezEf7 = parcelRequire("ezEf7");


var $6X62h = parcelRequire("6X62h");

const $8c34f37d607774c8$var$PORTAL_CONTAINER_SELECTOR = 'body > .atlaskit-portal-container';
class $8c34f37d607774c8$export$10f7d66405927699 {
    /**
   * Returns the list of DOM elements to observe based on popup type.
   */ getObserveTargets() {
        const { config: config } = this;
        switch(config.type){
            case 'inline':
                return this.getInlineTargets(config);
            case 'editorRoot':
                return this.getEditorRootTargets(config);
            case 'editorContent':
                return this.getEditorContentTargets(config);
            case 'portalRoot':
                return this.getPortalRootTargets();
        }
    }
    /**
   * For 'portalRoot' type: observe .atlaskit-portal-container.
   * Popups like flags and modals render in body > .atlaskit-portal-container.
   */ getPortalRootTargets() {
        const portalContainer = (0, $1hQ0e.getDocument)()?.querySelector($8c34f37d607774c8$var$PORTAL_CONTAINER_SELECTOR);
        return portalContainer ? [
            portalContainer
        ] : [];
    }
    /**
   * For 'editorContent' type: observe the target (mount point) and any existing
   * [data-editor-popup] wrappers within it. Content-level popups and modals
   * appear in portal containers.
   */ getEditorContentTargets(config) {
        const target = config.getTarget();
        if (!target) return [];
        const targets = [
            target
        ];
        const wrappers = target.querySelectorAll('[data-editor-popup]');
        for (const wrapper of wrappers)targets.push(wrapper);
        return targets;
    }
    /**
   * For 'inline' type: observe the target element directly.
   * The caller is responsible for resolving the correct container
   * (e.g. the toolbar button-group) via the getTarget function.
   */ getInlineTargets(config) {
        const target = config.getTarget();
        if (!target) return [];
        return [
            target
        ];
    }
    /**
   * For 'editorRoot' type: observe the actual editor root container.
   * The editorDom is the ProseMirror element, but popups appear as direct children
   * of the parent .akEditor container. So we observe the parent of editorDom.
   */ getEditorRootTargets(config) {
        const targets = [];
        const editorDom = config.getEditorDom();
        if (editorDom) {
            const editorRoot = editorDom.closest('.akEditor') || editorDom.parentElement;
            if (editorRoot instanceof HTMLElement) targets.push(editorRoot);
        }
        return targets;
    }
    start(callback) {
        const doc = (0, $1hQ0e.getDocument)();
        const observeTargets = this.getObserveTargets();
        if (!doc || !observeTargets.length) {
            callback({
                status: 'failure',
                reason: (0, $ezEf7.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_TARGET_NOT_FOUND
            });
            return;
        }
        const query = this.config.nestedElementQuery;
        const subtree = this.config.type === 'inline' && this.config.subtree === true;
        const observe = (el)=>{
            const observer = new MutationObserver(onMutation);
            observer.observe(el, {
                childList: true,
                subtree: subtree
            });
            this.observers.push(observer);
        };
        const onMutation = (mutations)=>{
            const found = mutations.some(({ type: type, addedNodes: addedNodes })=>type === 'childList' && [
                    ...addedNodes
                ].some((node)=>node instanceof HTMLElement && ((0, $6X62h.popupWithNestedElement)(node, query) || node.matches(query) || node.querySelector(query) !== null)));
            if (found) {
                callback({
                    status: 'success'
                });
                return;
            }
        };
        for (const observeTarget of observeTargets)observe(observeTarget);
    }
    stop() {
        for (const observer of this.observers)observer.disconnect();
        this.observers = [];
    }
    constructor(config){
        this.config = void 0;
        this.observers = [];
        this.config = config;
    }
}
module.exports["ExperienceCheckPopupMutation"] = $8c34f37d607774c8$export$10f7d66405927699;

});

parcelRegister("6X62h", function(module, exports) {
/**
 * Returns the popup with a nested element identified by a specific test ID if it exists.
 *
 * @param node - The node to check.
 * @param nestedElementQuery - The query to look for the nested element.
 * @returns Element if the node contains the popup, undefined otherwise.
 */ const $b161600008859078$export$8a7378047752ffb6 = (node, nestedElementQuery)=>{
    if (!(node instanceof HTMLElement)) return undefined;
    // Check if node itself has the popup attribute and contains the element matching the nestedElementQuery
    if (node.matches('[data-editor-popup="true"]')) return node.querySelector(nestedElementQuery);
    // Check if any direct child with popup attribute contains the element matching the nestedElementQuery
    return node.querySelector(`:scope > [data-editor-popup="true"] ${nestedElementQuery}`);
};
module.exports["popupWithNestedElement"] = $b161600008859078$export$8a7378047752ffb6;

});

parcelRegister("bYHr8", function(module, exports) {
const $451311451b1ed3a2$export$fe7123d322bc7614 = (editorView)=>{
    if (!editorView) return null;
    const pmDom = editorView.dom;
    const { selection: selection } = editorView.state;
    // nodeDOM can return null when editor loses focus (e.g. toolbar click) or for certain positions.
    // Fall back to domAtPos which resolves the DOM node at the given position.
    let currentNode = editorView.nodeDOM(selection.from);
    if (!currentNode) try {
        const { node: node } = editorView.domAtPos(selection.from);
        currentNode = node instanceof HTMLElement ? node : node.parentElement;
    } catch  {
        return null;
    }
    let lastValidAncestor = currentNode;
    while(currentNode instanceof HTMLElement && currentNode !== pmDom){
        lastValidAncestor = currentNode;
        currentNode = currentNode.parentElement;
    }
    return lastValidAncestor instanceof HTMLElement ? lastValidAncestor : null;
};
module.exports["getSelectionAncestorDOM"] = $451311451b1ed3a2$export$fe7123d322bc7614;

});

parcelRegister("jfFbl", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $04971d96549367d0$var$TEXT_PLAIN = "text/plain";
var $04971d96549367d0$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $04971d96549367d0$var$debugLogImpl = (s)=>{};
function $04971d96549367d0$var$debugLog(s) {
    $04971d96549367d0$var$debugLogImpl(s);
}
function $04971d96549367d0$export$e014146e87162c32(logFn) {
    $04971d96549367d0$var$debugLogImpl = logFn;
}
var $04971d96549367d0$var$showWarnings = true;
function $04971d96549367d0$export$ba5c9528becaaf25() {
    $04971d96549367d0$var$showWarnings = false;
}
function $04971d96549367d0$var$shouldShowWarnings() {
    return $04971d96549367d0$var$showWarnings;
}
function $04971d96549367d0$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $04971d96549367d0$var$warn = $04971d96549367d0$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $04971d96549367d0$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $04971d96549367d0$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $04971d96549367d0$var$_a, $04971d96549367d0$var$_b, $04971d96549367d0$var$_c;
var $04971d96549367d0$var$promiseConstructorImpl = ($04971d96549367d0$var$_c = ($04971d96549367d0$var$_a = $04971d96549367d0$var$originalWindow) == null ? void 0 : $04971d96549367d0$var$_a.Promise) != null ? $04971d96549367d0$var$_c : ($04971d96549367d0$var$_b = $04971d96549367d0$var$originalGlobalThis) == null ? void 0 : $04971d96549367d0$var$_b.Promise;
function $04971d96549367d0$var$getPromiseConstructor() {
    if (!$04971d96549367d0$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $04971d96549367d0$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $04971d96549367d0$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $04971d96549367d0$var$originalNavigatorClipboard = $04971d96549367d0$var$originalNavigator == null ? void 0 : $04971d96549367d0$var$originalNavigator.clipboard;
var $04971d96549367d0$var$_a2;
var $04971d96549367d0$var$originalNavigatorClipboardRead = ($04971d96549367d0$var$_a2 = $04971d96549367d0$var$originalNavigatorClipboard == null ? void 0 : $04971d96549367d0$var$originalNavigatorClipboard.read) == null ? void 0 : $04971d96549367d0$var$_a2.bind($04971d96549367d0$var$originalNavigatorClipboard);
var $04971d96549367d0$var$_a3;
var $04971d96549367d0$var$originalNavigatorClipboardReadText = ($04971d96549367d0$var$_a3 = $04971d96549367d0$var$originalNavigatorClipboard == null ? void 0 : $04971d96549367d0$var$originalNavigatorClipboard.readText) == null ? void 0 : $04971d96549367d0$var$_a3.bind($04971d96549367d0$var$originalNavigatorClipboard);
var $04971d96549367d0$var$_a4;
var $04971d96549367d0$var$originalNavigatorClipboardWrite = ($04971d96549367d0$var$_a4 = $04971d96549367d0$var$originalNavigatorClipboard == null ? void 0 : $04971d96549367d0$var$originalNavigatorClipboard.write) == null ? void 0 : $04971d96549367d0$var$_a4.bind($04971d96549367d0$var$originalNavigatorClipboard);
var $04971d96549367d0$var$_a5;
var $04971d96549367d0$var$originalNavigatorClipboardWriteText = ($04971d96549367d0$var$_a5 = $04971d96549367d0$var$originalNavigatorClipboard == null ? void 0 : $04971d96549367d0$var$originalNavigatorClipboard.writeText) == null ? void 0 : $04971d96549367d0$var$_a5.bind($04971d96549367d0$var$originalNavigatorClipboard);
var $04971d96549367d0$var$_a6;
var $04971d96549367d0$var$originalWindowClipboardItem = ($04971d96549367d0$var$_a6 = $04971d96549367d0$var$originalWindow) == null ? void 0 : $04971d96549367d0$var$_a6.ClipboardItem;
var $04971d96549367d0$var$promiseConstructor = $04971d96549367d0$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $04971d96549367d0$var$ieWindow = $04971d96549367d0$var$originalWindow;
function $04971d96549367d0$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($04971d96549367d0$var$ieWindow == null ? void 0 : $04971d96549367d0$var$ieWindow.clipboardData) !== "undefined" && typeof ($04971d96549367d0$var$ieWindow == null ? void 0 : $04971d96549367d0$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $04971d96549367d0$var$writeTextIE(text) {
    if (!$04971d96549367d0$var$ieWindow.clipboardData) return false;
    var success = $04971d96549367d0$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $04971d96549367d0$var$debugLog("writeTextIE worked");
    return success;
}
function $04971d96549367d0$var$readTextIE() {
    if (!$04971d96549367d0$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $04971d96549367d0$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $04971d96549367d0$var$copyListener(tracker, data, e) {
    $04971d96549367d0$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $04971d96549367d0$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $04971d96549367d0$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $04971d96549367d0$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $04971d96549367d0$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $04971d96549367d0$var$copyUsingTempSelection(e, data) {
    $04971d96549367d0$var$selectionSet(e);
    var success = $04971d96549367d0$var$execCopy(data);
    $04971d96549367d0$var$selectionClear();
    return success;
}
function $04971d96549367d0$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $04971d96549367d0$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $04971d96549367d0$var$copyTextUsingDOM(str) {
    $04971d96549367d0$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $04971d96549367d0$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $04971d96549367d0$var$selectionSet(span);
    var result = document.execCommand("copy");
    $04971d96549367d0$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $04971d96549367d0$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $04971d96549367d0$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $04971d96549367d0$var$writeFallback(stringItem) {
    var hasTextPlain = $04971d96549367d0$var$TEXT_PLAIN in stringItem;
    if ($04971d96549367d0$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($04971d96549367d0$var$writeTextIE(stringItem[$04971d96549367d0$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($04971d96549367d0$var$execCopy(stringItem)) {
        $04971d96549367d0$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $04971d96549367d0$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($04971d96549367d0$var$copyUsingTempSelection(document.body, stringItem)) {
        $04971d96549367d0$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($04971d96549367d0$var$copyUsingTempElem(stringItem)) {
        $04971d96549367d0$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($04971d96549367d0$var$copyTextUsingDOM(stringItem[$04971d96549367d0$var$TEXT_PLAIN])) {
        $04971d96549367d0$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $04971d96549367d0$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $04971d96549367d0$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $04971d96549367d0$var$voidPromise = $04971d96549367d0$var$promiseConstructor.resolve();
var $04971d96549367d0$var$truePromiseFn = ()=>$04971d96549367d0$var$promiseConstructor.resolve(true);
var $04971d96549367d0$var$falsePromise = $04971d96549367d0$var$promiseConstructor.resolve(false);
function $04971d96549367d0$var$rejectThrownErrors(executor) {
    return new $04971d96549367d0$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $04971d96549367d0$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$04971d96549367d0$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $04971d96549367d0$export$bec150f75a9b8f11(s) {
    return $04971d96549367d0$var$rejectThrownErrors(()=>{
        if ($04971d96549367d0$var$originalNavigatorClipboardWriteText) {
            $04971d96549367d0$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $04971d96549367d0$var$originalNavigatorClipboardWriteText(s).catch($04971d96549367d0$var$writeTextStringFallback);
        }
        return $04971d96549367d0$var$promiseConstructor.resolve($04971d96549367d0$var$writeTextStringFallback(s));
    });
}
function $04971d96549367d0$var$writeTextStringFallback(s) {
    if (!$04971d96549367d0$var$writeFallback($04971d96549367d0$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $04971d96549367d0$export$bee0113684d8879b() {
    return $04971d96549367d0$var$rejectThrownErrors(()=>{
        if ($04971d96549367d0$var$originalNavigatorClipboardReadText) {
            $04971d96549367d0$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $04971d96549367d0$var$originalNavigatorClipboardReadText();
        }
        if ($04971d96549367d0$var$seemToBeInIE()) {
            var result = $04971d96549367d0$var$readTextIE();
            return $04971d96549367d0$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $04971d96549367d0$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $04971d96549367d0$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $04971d96549367d0$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $04971d96549367d0$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $04971d96549367d0$export$3b1380c0957dc8fe = $04971d96549367d0$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $04971d96549367d0$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $04971d96549367d0$var$blobToString(blob) {
    return new $04971d96549367d0$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $04971d96549367d0$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $04971d96549367d0$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($04971d96549367d0$var$originalWindowClipboardItem) resolve(new $04971d96549367d0$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $04971d96549367d0$var$textToClipboardItem(text) {
    var items = {};
    items[$04971d96549367d0$var$TEXT_PLAIN] = $04971d96549367d0$var$stringToBlob(text, $04971d96549367d0$var$TEXT_PLAIN);
    return new $04971d96549367d0$export$3b1380c0957dc8fe(items);
}
function $04971d96549367d0$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $04971d96549367d0$var$blobToString(text);
    });
}
function $04971d96549367d0$var$toStringItem(data) {
    return $04971d96549367d0$var$promiseRecordMap(data.types, function(type) {
        return $04971d96549367d0$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $04971d96549367d0$export$68d8715fc104d294(data) {
    return $04971d96549367d0$var$rejectThrownErrors(()=>{
        if ($04971d96549367d0$var$originalNavigatorClipboardWrite && $04971d96549367d0$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $04971d96549367d0$var$originalNavigatorClipboardWrite;
            $04971d96549367d0$var$debugLog("Using `navigator.clipboard.write()`.");
            return $04971d96549367d0$var$promiseConstructor.all(data.map($04971d96549367d0$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($04971d96549367d0$var$truePromiseFn).catch((e)=>{
                    if (!$04971d96549367d0$var$hasItemWithType(data, $04971d96549367d0$var$TEXT_PLAIN) && !$04971d96549367d0$var$hasItemWithType(data, $04971d96549367d0$var$TEXT_HTML)) throw e;
                    return $04971d96549367d0$var$falsePromise;
                });
            });
        }
        return $04971d96549367d0$var$falsePromise;
    }).then((success)=>{
        if (success) return $04971d96549367d0$var$voidPromise;
        var hasTextPlain = $04971d96549367d0$var$hasItemWithType(data, $04971d96549367d0$var$TEXT_PLAIN);
        if ($04971d96549367d0$var$shouldShowWarnings() && !hasTextPlain) $04971d96549367d0$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $04971d96549367d0$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$04971d96549367d0$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $04971d96549367d0$export$aafa59e2e03f2942() {
    return $04971d96549367d0$var$rejectThrownErrors(()=>{
        if ($04971d96549367d0$var$originalNavigatorClipboardRead) {
            $04971d96549367d0$var$debugLog("Using `navigator.clipboard.read()`.");
            return $04971d96549367d0$var$originalNavigatorClipboardRead();
        }
        return $04971d96549367d0$export$bee0113684d8879b().then((text)=>{
            return [
                $04971d96549367d0$var$textToClipboardItem(text)
            ];
        });
    });
}
 //# sourceMappingURL=clipboard-polyfill.es6.js.map



var $kCECX = parcelRequire("kCECX");


var $krYZG = parcelRequire("krYZG");


var $lp7sw = parcelRequire("lp7sw");

const $49c145ec16190d2e$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $49c145ec16190d2e$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $49c145ec16190d2e$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $49c145ec16190d2e$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($49c145ec16190d2e$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($49c145ec16190d2e$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $49c145ec16190d2e$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    if ($49c145ec16190d2e$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        $49c145ec16190d2e$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $49c145ec16190d2e$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $04971d96549367d0$export$3b1380c0957dc8fe({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $04971d96549367d0$export$68d8715fc104d294([
        dt
    ]);
};
const $49c145ec16190d2e$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $lp7sw.getNodeSelectionAnalyticsPayload)(selection) || (0, $lp7sw.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $lp7sw.getAllSelectionAnalyticsPayload)(selection) || (0, $lp7sw.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $krYZG.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($49c145ec16190d2e$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $krYZG.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $krYZG.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $krYZG.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($49c145ec16190d2e$var$isExtensionNode(node)) return {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $kCECX.TextSelection) && selection.$cursor) return {
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};
const $49c145ec16190d2e$export$f8811fa45a00fd64 = (node, inputMethod)=>{
    const nodeType = node.type.name;
    let extensionType;
    let extensionKey;
    if ($49c145ec16190d2e$var$isExtensionNode(nodeType)) {
        extensionType = node.attrs.extensionType;
        extensionKey = node.attrs.extensionKey;
    }
    const payload = {
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: (0, $krYZG.ACTION).COPIED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                nodeType
            ],
            inputMethod: inputMethod,
            nodeType: nodeType,
            ...extensionType ? {
                extensionType: extensionType
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {}
        }
    };
    return payload;
};
module.exports["copyToClipboard"] = $49c145ec16190d2e$export$2cdf1b96a9f86d16;
module.exports["copyHTMLToClipboard"] = $49c145ec16190d2e$export$8b344d2a6a3e9af3;
module.exports["copyHTMLToClipboardPolyfill"] = $49c145ec16190d2e$export$97e18ff8b98c7078;
module.exports["getAnalyticsPayload"] = $49c145ec16190d2e$export$4feda93c1c6b2d80;
module.exports["getNodeCopiedAnalyticsPayload"] = $49c145ec16190d2e$export$f8811fa45a00fd64;

});

parcelRegister("lp7sw", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");


var $91iSj = parcelRequire("91iSj");


var $krYZG = parcelRequire("krYZG");


var $1JP3v = parcelRequire("1JP3v");


var $eaLat = parcelRequire("eaLat");


var $4EksL = parcelRequire("4EksL");


var $Lh4Gi = parcelRequire("Lh4Gi");


var $5X54F = parcelRequire("5X54F");


var $88vX6 = parcelRequire("88vX6");


var $e2j05 = parcelRequire("e2j05");


var $b9DnN = parcelRequire("b9DnN");


var $c2E4R = parcelRequire("c2E4R");


var $jzePg = parcelRequire("jzePg");


var $c7UOz = parcelRequire("c7UOz");


var $iQ6F7 = parcelRequire("iQ6F7");


var $1GYCH = parcelRequire("1GYCH");


var $1tdnq = parcelRequire("1tdnq");


var $iscRo = parcelRequire("iscRo");


var $inM0i = parcelRequire("inM0i");


var $lVAkE = parcelRequire("lVAkE");



var $2ROjz = parcelRequire("2ROjz");


var $3rWk6 = parcelRequire("3rWk6");


var $2RAus = parcelRequire("2RAus");

function $2e695af2bcf1ed26$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $kCECX.NodeSelection)) return {
        action: (0, $krYZG.ACTION).SELECTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $2e695af2bcf1ed26$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $kCECX.AllSelection)) return {
        action: (0, $krYZG.ACTION).SELECTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
}
function $2e695af2bcf1ed26$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $8HW7o.CellSelection)) {
        const rect = (0, $91iSj.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $krYZG.ACTION).SELECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $2e695af2bcf1ed26$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $kCECX.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $krYZG.ACTION).SELECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $2e695af2bcf1ed26$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $kCECX.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $2e695af2bcf1ed26$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, _pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $2e695af2bcf1ed26$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}
module.exports["getNodeSelectionAnalyticsPayload"] = $2e695af2bcf1ed26$export$3162c38157c33ee6;
module.exports["getAllSelectionAnalyticsPayload"] = $2e695af2bcf1ed26$export$9f3a063378bdcaa1;
module.exports["getCellSelectionAnalyticsPayload"] = $2e695af2bcf1ed26$export$dcdd07dcad6adb98;
module.exports["getRangeSelectionAnalyticsPayload"] = $2e695af2bcf1ed26$export$bf6883b886d952b0;
module.exports["createSelectionClickHandler"] = $2e695af2bcf1ed26$export$563f7987ca7936f1;

});

parcelRegister("91iSj", function(module, exports) {

var $8HW7o = parcelRequire("8HW7o");


var $8Z43Z = parcelRequire("8Z43Z");


var $b3vr9 = parcelRequire("b3vr9");

function $6a48490f1f9a0463$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $b3vr9.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $8Z43Z.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $8HW7o.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}
module.exports["selectedRect"] = $6a48490f1f9a0463$export$39ce22e69aa9ed17;

});

parcelRegister("b3vr9", function(module, exports) {

var $7zMjs = parcelRequire("7zMjs");


var $bc8rR = parcelRequire("bc8rR");

function $b30a3d6d6739f300$export$aad75348c8f2d244(selection) {
    if ((0, $bc8rR.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $bc8rR.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $7zMjs.cellAround)(selection.$head) || (0, $7zMjs.cellNear)(selection.$head);
}
module.exports["selectionCell"] = $b30a3d6d6739f300$export$aad75348c8f2d244;

});

parcelRegister("1JP3v", function(module, exports) {
var $03338afe38bfa742$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});
module.exports["RelativeSelectionPos"] = $03338afe38bfa742$export$cb9005d223ae8de7;

});

parcelRegister("b9DnN", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

const $046ab308bca798ab$var$gapCursorBlink = (0, $lOiVq.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $046ab308bca798ab$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $046ab308bca798ab$var$gapCursor = '.ProseMirror-gapcursor';
const $046ab308bca798ab$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $046ab308bca798ab$var$wrapLeft = '[layout="wrap-left"]';
const $046ab308bca798ab$var$wrapRight = '[layout="wrap-right"]';
const $046ab308bca798ab$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $lOiVq.css)(".ProseMirror{&.", $046ab308bca798ab$export$8adc5edbc4a22166, "{caret-color:transparent;}", $046ab308bca798ab$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $046ab308bca798ab$var$gapCursorBlink, " step-start infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $046ab308bca798ab$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $046ab308bca798ab$var$gapCursor, "{display:block;border-color:transparent;}}", $046ab308bca798ab$var$gapCursor, $046ab308bca798ab$var$wrapLeft, "+span+", $046ab308bca798ab$var$wrapLeft, ",", $046ab308bca798ab$var$gapCursor, $046ab308bca798ab$var$wrapRight, "+span+", $046ab308bca798ab$var$wrapRight, ",", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$wrapRight, ",", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+span+", $046ab308bca798ab$var$wrapRight, ",", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$wrapLeft, ",", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+span+", $046ab308bca798ab$var$wrapLeft, ",", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, ",", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+span ", $046ab308bca798ab$var$wrapRight, ",", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, ",", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapLeft, ",", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "{clear:none;}", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, ">div,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapRight, ">div,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, ">div,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapLeft, ">div,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$wrapLeft, ">div,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+span+", $046ab308bca798ab$var$wrapLeft, ">div,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$wrapRight, ">div,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+span+", $046ab308bca798ab$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, ",", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "{float:left;}", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+span+", $046ab308bca798ab$var$wrapRight, "::after,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+span+", $046ab308bca798ab$var$wrapLeft, "::after,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "::after,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapRight, "::after,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "::after,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+*,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+span+*,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+*,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+span+*,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapRight, "+*,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapLeft, "+*,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+span+", $046ab308bca798ab$var$wrapRight, "+*,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+span+", $046ab308bca798ab$var$wrapLeft, "+*,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+*>*,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+span+*>*,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+*>*,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+span+*>*,", $046ab308bca798ab$var$wrapLeft, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapRight, "+*>*,", $046ab308bca798ab$var$wrapRight, "+", $046ab308bca798ab$var$gapCursor, "+span+", $046ab308bca798ab$var$wrapLeft, "+*>*,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapLeft, "+span+", $046ab308bca798ab$var$wrapRight, "+*>*,", $046ab308bca798ab$var$gapCursor, "+", $046ab308bca798ab$var$wrapRight, "+span+", $046ab308bca798ab$var$wrapLeft, "+*>*,", $046ab308bca798ab$var$prosemirrorwidgetNotBlock, "+", $046ab308bca798ab$var$gapCursor, "+*,", $046ab308bca798ab$var$prosemirrorwidgetNotBlock, "+", $046ab308bca798ab$var$gapCursor, "+span+*{margin-top:0;}");
module.exports["hideCaretModifier"] = $046ab308bca798ab$export$8adc5edbc4a22166;

});

parcelRegister("2RAus", function(module, exports) {
/**
 * Transaction meta key used by the selection-preservation plugin
 * to detect formatting operations that need selection re-syncing.
 *
 * When a formatting command (text color, highlight, etc.) changes the document,
 * it sets this meta key to `true` so the selection-preservation plugin can
 * re-sync the DOM selection after the transaction is applied.
 */ const $23b6fc95411fd1a4$export$c97c07443881dcfe = 'editorPluginSelectionPreservationFormatSync';
module.exports["FORMAT_SELECTION_SYNC_META"] = $23b6fc95411fd1a4$export$c97c07443881dcfe;

});

parcelRegister("7XIuB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dlU1V = parcelRequire("dlU1V");


var $LQnOI = parcelRequire("LQnOI");


var $9kbTQ = parcelRequire("9kbTQ");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $1jz5K = parcelRequire("1jz5K");


var $i8Wi0 = parcelRequire("i8Wi0");

class $fb960ec69faa5de6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    /**
   * Calculates new popup position
   */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, minPopupMargin: minPopupMargin, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $1jz5K.calculatePlacement)(target, // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup positioning fallback; keep unchanged for safety.
        boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $1jz5K.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect,
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup positioning fallback; keep unchanged for safety.
            boundariesElement: boundariesElement || document.body,
            minPopupMargin: minPopupMargin,
            scrollableElement: stick ? this.scrollElement : undefined
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $i8Wi0.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $9kbTQ.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
     * Check whether:
     * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
     * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
     *
     * Currently Popup isn't capable of position itself correctly in case 2,
     * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
     */ return !target || // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup containment check; keep unchanged for safety.
        document.body.contains(target) && popup.offsetParent && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
   * Popup initialization.
   * Checks whether it's possible to position popup along given target, and if it's not throws an error.
   */ initPopup(popup) {
        if (this.popupRef.current) this.resizeObserver?.unobserve(this.popupRef.current);
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $1jz5K.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
     * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
     * Now, floating toolbar position depends on it's size.
     * Size of floating toolbar changes, when async component renders.
     * There is currently, no way to re position floating toolbar or
     *  better to not show floating toolbar till all the async component are ready to render.
     * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
     *  as a prop.
     * So, calling scheduledUpdatePosition to position popup on next request animation frame,
     * which is currently working for most of the floating toolbar and other popups.
     */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
        if (this.popupRef.current) this.resizeObserver?.observe(this.popupRef.current);
    }
    /**
   * Cancels the initialisation of the focus trap if it has not yet occured
   * Deactivates the focus trap if it exists
   */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
   * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
   */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    /**
   * Idempotent scroll element setup — tears down any previous listener/observer
   * then attaches to the current scroll parent.
   */ initScrollElement() {
        const { stick: stick, target: target, scrollableElement: scrollableElement } = this.props;
        this.unbindScroll?.();
        if (this.scrollElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollElement);
        this.scrollElement = scrollableElement;
        if (stick && !this.scrollElement && target) this.scrollElement = (0, $1jz5K.findOverflowScrollParent)(target);
        if (this.scrollElement) {
            if (this.resizeObserver) this.resizeObserver.observe(this.scrollElement);
            this.unbindScroll = (0, $cbY7C.bind)(this.scrollElement, {
                type: 'scroll',
                listener: this.onResize
            });
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
        if (prevProps.scrollableElement !== this.props.scrollableElement) this.initScrollElement();
        if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
    }
    componentDidMount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', this.onResize);
        this.initScrollElement();
    }
    componentWillUnmount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.onResize);
        this.unbindScroll?.();
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.removeEventListener('scroll', this.onResize);
        this.resizeObserver?.disconnect();
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        /**
     * https://a11y.atlassian.net/browse/A11Y-9995
     * We set aria-label to undefined if it's null, no more 'Popup' fallback.
     * It is meaningless for screen readers and causes confusion.
     */ const ariaLabel = this.props.ariaLabel ?? undefined;
        const getRole = ()=>{
            // Provide a valid role only when aria-label is present to satisfy a11y rules, as when aria-label is present, role is required
            // use role = dialog as default role, as dialog role itself is not a parent role that requires specific children to function as some other ARIA roles(menu) do
            // if set default role to menu, tons of integration tests will fail as many of our popup usages do not have children that satisfy menu role requirements
            if (ariaLabel) return this.props.role || 'dialog';
            return undefined;
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $7Y8M5.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            role: getRole(),
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true,
            children: this.props.children
        });
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $9kbTQ.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args);
        this.scrollElement = void 0;
        this.unbindScroll = void 0;
        this.rafIds = new Set();
        this.state = {
            validPosition: true
        };
        this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.focusTrap = void 0;
        this.placement = [
            '',
            ''
        ];
        this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        };
        this.scheduledUpdatePosition = (0, $LQnOI.default)((_props)=>{
            this.updatePosition(this.props);
        });
        this.onResize = ()=>this.scheduledUpdatePosition(this.props);
        this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined;
        /**
     * Raf scheduled so that it also occurs after the initial update position
     */ this.initFocusTrap = (0, $LQnOI.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const defaultTrapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            const trapConfig = typeof this.props.focusTrap === 'boolean' ? defaultTrapConfig : {
                ...defaultTrapConfig,
                ...this.props.focusTrap
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($dlU1V)))(popup, (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) || (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true) ? trapConfig : defaultTrapConfig);
            this.focusTrap.activate();
        });
    }
}
$fb960ec69faa5de6$export$2e2bcd8739ae039.defaultProps = {
    offset: [
        0,
        0
    ],
    allowOutOfBound: false
};
module.exports["default"] = $fb960ec69faa5de6$export$2e2bcd8739ae039;

});

parcelRegister("g9ric", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $2iHw5 = parcelRequire("2iHw5");





var $cozmU = parcelRequire("cozmU");

const $b810541013ccda0f$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    const currentSelectedColumnIndex = (0, $cozmU.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $cozmU.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $cozmU.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements_0, columnElements_0)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements_0.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements_1, columnElements_1)=>{
            if (currentSelectedColumnIndex.current === columnElements_1.length - 1) {
                incrementRowIndex(rowElements_1, columnElements_1);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements_2, columnElements_2)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements_2, columnElements_2);
                currentSelectedColumnIndex.current = columnElements_2.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            const colorSwatchesRowElements = $b810541013ccda0f$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $b810541013ccda0f$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || focusableElements?.length === 0) return;
            focusableElements[currentSelectedColumnIndex.current]?.focus();
        };
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements_0 = $b810541013ccda0f$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement_0 = colorSwatchesRowElements_0[currentSelectedRowIndex.current];
            const focusableElements_0 = $b810541013ccda0f$var$getFocusableElements(currentSelectedColorSwatchRowElement_0);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements_0, focusableElements_0);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements_0, focusableElements_0);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements_0, focusableElements_0);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements_0, focusableElements_0);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                default:
                    return;
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    }));
};
function $b810541013ccda0f$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $b810541013ccda0f$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}









var $1hQ0e = parcelRequire("1hQ0e");


var $ieeJu = parcelRequire("ieeJu");

const $a7e726790f59cbca$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $a7e726790f59cbca$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $cozmU.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $cozmU.useState)(element);
    const getCurrentIndex = (0, $cozmU.useCallback)((list)=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) return currentSelectedItemIndex;
        const activeElement = (0, $1hQ0e.getDocument)()?.activeElement;
        if (!(activeElement instanceof HTMLElement)) return currentSelectedItemIndex;
        const activeElementIndex = list.indexOf(activeElement);
        return activeElementIndex >= 0 ? activeElementIndex : currentSelectedItemIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const incrementIndex = (0, $cozmU.useCallback)((list_0)=>{
        const currentIndex = getCurrentIndex(list_0);
        let nextIndex = (currentIndex + 1) % list_0.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list_0[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list_0.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        getCurrentIndex
    ]);
    const decrementIndex = (0, $cozmU.useCallback)((list_1)=>{
        const currentIndex_0 = getCurrentIndex(list_1);
        let nextIndex_0 = (list_1.length + currentIndex_0 - 1) % list_1.length;
        while(nextIndex_0 !== currentIndex_0 && list_1[nextIndex_0].getAttribute('aria-disabled') === 'true')nextIndex_0 = (list_1.length + nextIndex_0 - 1) % list_1.length;
        setCurrentSelectedItemIndex(nextIndex_0);
        return nextIndex_0;
    }, [
        getCurrentIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $cozmU.useEffect)(()=>{
        const currentIndex_1 = currentSelectedItemIndex;
        const list_2 = $a7e726790f59cbca$var$getFocusableElements(wrapperRef?.current);
        const currentElement = list_2[currentIndex_1];
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            const focusIndex = incrementIndex(list_2);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            list_2[focusIndex]?.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        // Backwards compatible behaviour:
        // - `true` disables all key handling (no listeners attached)
        // - a function is evaluated per event inside the handler
        if (disableArrowKeyNavigation === true) return;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            if (typeof disableArrowKeyNavigation === 'function' && disableArrowKeyNavigation(event)) return;
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                keyDownHandlerContext?.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $a7e726790f59cbca$var$getFocusableElements(wrapperRef?.current);
            if (!focusableElements || focusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($a7e726790f59cbca$var$hasEnabledItems(focusableElements)) {
                        const focusIndex_1 = incrementIndex(focusableElements);
                        focusableElements[focusIndex_1]?.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($a7e726790f59cbca$var$hasEnabledItems(focusableElements)) {
                        const focusIndex_0 = decrementIndex(focusableElements);
                        focusableElements[focusIndex_0]?.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem_0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                elem_0 && elem_0.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    });
};
function $a7e726790f59cbca$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}



var $9RT19 = parcelRequire("9RT19");

const $9be3f94359db818c$export$ee87cc4950b6d6fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(14);
    let children;
    let restProps;
    let type;
    if ($[0] !== props) {
        ({ children: children, type: type, ...restProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = restProps;
        $[3] = type;
    } else {
        children = $[1];
        restProps = $[2];
        type = $[3];
    }
    if (type === (0, $9RT19.ArrowKeyNavigationType).COLOR) {
        let t0;
        if ($[4] !== children || $[5] !== props.isOpenedByKeyboard || $[6] !== props.isPopupPositioned || $[7] !== props.selectedColumnIndex || $[8] !== props.selectedRowIndex || $[9] !== restProps) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2iHw5.default).Consumer, {
                children: (t1)=>{
                    const { popupsMountPoint: popupsMountPoint, editorRef: editorRef } = t1;
                    return editorRef && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b810541013ccda0f$export$e17115e9cf808589), {
                        selectedRowIndex: props.selectedRowIndex,
                        selectedColumnIndex: props.selectedColumnIndex,
                        isOpenedByKeyboard: props.isOpenedByKeyboard,
                        isPopupPositioned: props.isPopupPositioned,
                        editorRef: editorRef,
                        popupsMountPoint: popupsMountPoint,
                        ...restProps,
                        children: children
                    });
                }
            });
            $[4] = children;
            $[5] = props.isOpenedByKeyboard;
            $[6] = props.isPopupPositioned;
            $[7] = props.selectedColumnIndex;
            $[8] = props.selectedRowIndex;
            $[9] = restProps;
            $[10] = t0;
        } else t0 = $[10];
        return t0;
    }
    let t0;
    if ($[11] !== children || $[12] !== restProps) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2iHw5.default).Consumer, {
            children: (t1)=>{
                const { popupsMountPoint: popupsMountPoint_0, editorRef: editorRef_0 } = t1;
                return editorRef_0 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a7e726790f59cbca$export$e12b037790bf03e3), {
                    editorRef: editorRef_0,
                    popupsMountPoint: popupsMountPoint_0,
                    ...restProps,
                    children: children
                });
            }
        });
        $[11] = children;
        $[12] = restProps;
        $[13] = t0;
    } else t0 = $[13];
    return t0;
} : (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $9RT19.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2iHw5.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b810541013ccda0f$export$e17115e9cf808589), {
                selectedRowIndex: props.selectedRowIndex,
                selectedColumnIndex: props.selectedColumnIndex,
                isOpenedByKeyboard: props.isOpenedByKeyboard,
                isPopupPositioned: props.isPopupPositioned,
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2iHw5.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint_0, editorView: editorView_0, editorRef: editorRef_0 })=>editorRef_0 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a7e726790f59cbca$export$e12b037790bf03e3), {
                editorRef: editorRef_0,
                popupsMountPoint: popupsMountPoint_0,
                ...restProps,
                children: children
            })
    });
};
module.exports["ArrowKeyNavigationProvider"] = $9be3f94359db818c$export$ee87cc4950b6d6fe;

});

parcelRegister("9RT19", function(module, exports) {
var $b08be2ee79fb3b25$export$26c2c5e2f61f437a = /*#__PURE__*/ function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
    return ArrowKeyNavigationType;
}({});
module.exports["ArrowKeyNavigationType"] = $b08be2ee79fb3b25$export$26c2c5e2f61f437a;

});

parcelRegister("uyXFl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0cc5f8501bca8d33$export$798d66d2e25c3c95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(()=>Object);
module.exports["OutsideClickTargetRefContext"] = $0cc5f8501bca8d33$export$798d66d2e25c3c95;

});

parcelRegister("9Muxb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8b929c0ac1b8e56$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $fqVYq = parcelRequire("fqVYq");


var $uyXFl = parcelRequire("uyXFl");


var $2iHw5 = parcelRequire("2iHw5");

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b8b929c0ac1b8e56$var$WithOutsideClick extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown || this.props.handleBackspaceDeleteKeydown || this.props.handleKeyDown && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        })) // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : // @ts-ignore - TS2873 TypeScript 5.9.2 upgrade
        this.props.editorRef?.current || this.props.targetRef || document).addEventListener('keydown', this.handleKeyDown, false);
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown || this.props.handleBackspaceDeleteKeydown || this.props.handleKeyDown && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        })) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : // @ts-ignore - TS2873 TypeScript 5.9.2 upgrade
        this.props.editorRef?.current || this.props.targetRef || document).removeEventListener('keydown', this.handleKeyDown, false);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.handleClick = (evt)=>{
            if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
            const domNode = this.props.outsideClickTargetRef.current?.deref();
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                this.props.handleClickOutside(evt);
                // When the menus are closed by clicking outside the focus is set on editor.
                if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
            }
        };
        this.handleKeyDown = (evt)=>{
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
            else if ((evt.code === 'Delete' || evt.code === 'Backspace') && this.props.handleBackspaceDeleteKeydown) this.props.handleBackspaceDeleteKeydown(evt);
            if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            })) this.props.handleKeyDown?.(evt);
        };
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b8b929c0ac1b8e56$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $b8b929c0ac1b8e56$export$2e2bcd8739ae039(Component) {
    return ({ captureClick: captureClick, closeOnTab: closeOnTab, handleBackspaceDeleteKeydown: handleBackspaceDeleteKeydown, handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, handleKeyDown: handleKeyDown, ...props })=>{
        const isActiveProp = $b8b929c0ac1b8e56$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $cozmU.useState)(false);
        const outsideClickTargetRef = (0, $cozmU.useRef)(null);
        const setOutsideClickTargetRef = (0, $cozmU.useCallback)((el)=>{
            outsideClickTargetRef.current = el && new WeakRef(el);
        }, [
            outsideClickTargetRef
        ]);
        (0, $cozmU.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2iHw5.default).Consumer, {
            children: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Provider, {
                    value: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($b8b929c0ac1b8e56$var$WithOutsideClick, {
                        editorView: editorView,
                        editorRef: editorRef,
                        targetRef: props.targetRef,
                        outsideClickTargetRef: outsideClickTargetRef,
                        popupsMountPoint: popupsMountPoint,
                        isActiveComponent: isActiveComponent,
                        handleClickOutside: handleClickOutside,
                        handleEnterKeydown: handleEnterKeydown,
                        handleEscapeKeydown: handleEscapeKeydown,
                        handleBackspaceDeleteKeydown: handleBackspaceDeleteKeydown,
                        handleKeyDown: handleKeyDown,
                        closeOnTab: closeOnTab,
                        captureClick: captureClick,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                            ...props
                        })
                    })
                })
        });
    };
}

});

parcelRegister("i9j2V", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jLnA6 = parcelRequire("jLnA6");


var $4aRua = parcelRequire("4aRua");

const $11be7aca2a23b553$export$f433dac65060f723 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { shortcut: shortcut, isDisabled: isDisabled } = t0;
    if (isDisabled) {
        let t1;
        if ($[0] !== shortcut) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
                appearance: "inverse",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.disabled",
                    children: shortcut
                })
            });
            $[0] = shortcut;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== shortcut) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
            children: shortcut
        });
        $[2] = shortcut;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ shortcut: shortcut, isDisabled: isDisabled })=>{
    if (isDisabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
        appearance: "inverse",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.disabled",
            children: shortcut
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
        children: shortcut
    });
};
module.exports["ToolbarKeyboardShortcutHint"] = $11be7aca2a23b553$export$f433dac65060f723;

});

parcelRegister("fKdaf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $9oc8s = parcelRequire("9oc8s");

var $4Fod8 = parcelRequire("4Fod8");

var $ioLmC = parcelRequire("ioLmC");

var $3RygG = parcelRequire("3RygG");


var $krYZG = parcelRequire("krYZG");


var $eBSR7 = parcelRequire("eBSR7");

var $ldqjS = parcelRequire("ldqjS");


var $5HBT9 = parcelRequire("5HBT9");


var $jGK9e = parcelRequire("jGK9e");


var $6OREF = parcelRequire("6OREF");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");





var $9WBFV = parcelRequire("9WBFV");


var $eEdSM = parcelRequire("eEdSM");


var $1yF0C = parcelRequire("1yF0C");

var $gNdNc = parcelRequire("gNdNc");


var $eOaGc = parcelRequire("eOaGc");


var $8HW7o = parcelRequire("8HW7o");





var $et3Y5 = parcelRequire("et3Y5");


var $ca4Zc = parcelRequire("ca4Zc");


var $kPKLu = parcelRequire("kPKLu");


var $d8RhQ = parcelRequire("d8RhQ");

var $c2pcC = parcelRequire("c2pcC");


var $bjg0G = parcelRequire("bjg0G");










const $3eace22a01d888a0$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $et3Y5.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $3eace22a01d888a0$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $c2pcC.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $3eace22a01d888a0$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $d8RhQ.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $3eace22a01d888a0$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to, empty: empty } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, caption: caption, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        const wrapperNodes = [
            blockquote,
            panel,
            orderedList,
            bulletList,
            listItem,
            codeBlock,
            decisionItem,
            decisionList,
            taskItem,
            taskList
        ];
        wrapperNodes.push(caption);
        if (empty && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
            for(let depth = 0; depth <= $from.depth; depth++){
                const node = $from.node(depth);
                if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
            }
            return nodes;
        }
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $3eace22a01d888a0$export$52adb8d9a3386cb8(state, allowFontSize = false) {
    const nodesTypes = $3eace22a01d888a0$var$getSelectedWrapperNodes(state);
    const { panel: panel, blockquote: blockquote, bulletList: bulletList, orderedList: orderedList, listItem: listItem, taskList: taskList, taskItem: taskItem } = state.schema.nodes;
    const isSmallFontSizeEnabled = allowFontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    const excludedTypes = isSmallFontSizeEnabled ? [
        panel,
        bulletList,
        orderedList,
        listItem,
        taskList,
        taskItem
    ] : [
        panel
    ];
    const disallowedWrapperTypes = nodesTypes.filter((type)=>!excludedTypes.includes(type));
    if (isSmallFontSizeEnabled) {
        const selectionInsideList = $3eace22a01d888a0$export$fbe592d31a93b004(state);
        const selectionInsideQuote = $3eace22a01d888a0$export$a7e992c753426072(state);
        // Inside a blockquote (but not a list nested within one): the blockquote itself isn't a
        // disallowing wrapper, but anything else is.
        if (selectionInsideQuote && !selectionInsideList) return disallowedWrapperTypes.some((type)=>type !== blockquote);
        return disallowedWrapperTypes.length > 0;
    }
    if ((0, $fqVYq.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true)) {
        let hasQuote = false;
        let hasNestedListInQuote = false;
        const { $from: $from, $to: $to } = state.selection;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.type === blockquote) {
                hasQuote = true;
                node.descendants((child)=>{
                    if (child.type === bulletList || child.type === orderedList) {
                        hasNestedListInQuote = true;
                        return false;
                    }
                    return true;
                });
            }
            return !hasNestedListInQuote;
        });
        return disallowedWrapperTypes.length > 0 && (!hasQuote || hasNestedListInQuote);
    }
    return disallowedWrapperTypes.length > 0;
}
function $3eace22a01d888a0$export$fbe592d31a93b004(state) {
    if (!state.selection) return false;
    const { $from: $from, $to: $to } = state.selection;
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = state.schema.nodes;
    const listNodeTypes = [
        bulletList,
        orderedList,
        taskList
    ];
    let insideList = false;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (node.isBlock && listNodeTypes.indexOf(node.type) >= 0) {
            insideList = true;
            return false;
        }
        return true;
    });
    return insideList || listNodeTypes.some((nodeType)=>(0, $bjg0G.hasParentNodeOfType)(nodeType)(state.selection));
}
function $3eace22a01d888a0$export$a7e992c753426072(state) {
    if (!state.selection) return false;
    const { $from: $from, $to: $to } = state.selection;
    const { blockquote: blockquote } = state.schema.nodes;
    // For collapsed selections, check if the cursor is inside a blockquote
    if ($from.pos === $to.pos) return (0, $bjg0G.hasParentNodeOfType)(blockquote)(state.selection);
    // For range selections, check if any node in the range is a blockquote,
    // or if the selection starts/ends inside a blockquote
    let insideQuote = false;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (node.type === blockquote) {
            insideQuote = true;
            return false;
        }
        return true;
    });
    return insideQuote || (0, $bjg0G.hasParentNodeOfType)(blockquote)(state.selection);
}
const $3eace22a01d888a0$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $et3Y5.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $3eace22a01d888a0$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $et3Y5.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $ca4Zc.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $3eace22a01d888a0$export$4b48a1fc423972ea = (state)=>{
    return $3eace22a01d888a0$var$marksArePresent(state) || $3eace22a01d888a0$var$blockStylingIsPresent(state);
};
const $3eace22a01d888a0$export$bce51f4ee2032263 = (dropdownOptions)=>{
    return !!dropdownOptions.find((blockType)=>blockType.name === 'blockquote');
};
function $3eace22a01d888a0$export$77bd22d0a1033d4(tr) {
    const { selection: selection } = tr;
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = tr.doc.type.schema.nodes;
    const listNodeTypes = [
        bulletList,
        orderedList,
        taskList
    ];
    let from = selection.from;
    let to = selection.to;
    // Walk up from the selection start to find the outermost list node.
    // We do NOT break at the first list found because task lists nest differently
    // from bullet/ordered lists:
    //   - bullet/ordered: bulletList > listItem > bulletList (nested inside listItem)
    //   - task: taskList > taskList (nested as direct children)
    // For task lists, breaking at the first list would only capture the innermost
    // taskList, missing sibling task items in parent lists. By continuing to walk
    // up, we find the outermost list and include all nested content.
    for(let depth = selection.$from.depth; depth > 0; depth--){
        const node = selection.$from.node(depth);
        if (listNodeTypes.indexOf(node.type) >= 0) from = selection.$from.before(depth);
    }
    for(let depth = selection.$to.depth; depth > 0; depth--){
        const node = selection.$to.node(depth);
        if (listNodeTypes.indexOf(node.type) >= 0) to = selection.$to.after(depth);
    }
    return {
        from: from,
        to: to
    };
}
function $3eace22a01d888a0$export$9fb148c84c583d2a(tr, from, to) {
    const { nodes: { taskItem: taskItem, blockTaskItem: blockTaskItem } } = tr.doc.type.schema;
    if (!blockTaskItem || !taskItem) return;
    // Collect taskItem positions from the current (unmutated) document
    const taskItemsToConvert = [];
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type === taskItem) taskItemsToConvert.push({
            pos: pos,
            node: node
        });
    });
    // Replace in reverse document order so earlier positions remain valid
    for(let i = taskItemsToConvert.length - 1; i >= 0; i--){
        const { pos: pos, node: node } = taskItemsToConvert[i];
        const blockTaskNode = (0, $kPKLu.createBlockTaskItem)({
            attrs: node.attrs,
            content: node.content,
            schema: tr.doc.type.schema
        });
        tr.replaceWith(pos, pos + node.nodeSize, blockTaskNode);
    }
}








const $3b9a329ce4d38fad$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $3b9a329ce4d38fad$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $3b9a329ce4d38fad$export$ce157a3b6664c924 = {
    em: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
const $3b9a329ce4d38fad$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};
function $3b9a329ce4d38fad$export$10ed2145ce1a03b1(schema, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $eOaGc.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}



var $aPdNQ = parcelRequire("aPdNQ");







function $8ce1123749e3b5c0$export$bb05c9a6c853122f(_nodeType) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { alignment: alignment, indentation: indentation, fontSize: fontSize } = tr.doc.type.schema.marks;
        if (nodes.paragraph && nodes.blockquote) {
            /** Remove alignment, indentation, and unsupported blockquote marks from the selection */ const marksToRemove = (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? [
                alignment,
                indentation,
                fontSize
            ] : [
                alignment,
                indentation
            ];
            const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
            const not = (fn)=>(arg)=>!fn(arg);
            /**
			 * When you need to toggle the selection
			 * when another type which does not allow alignment is applied
			 */ tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos)=>{
                if (node.type === nodes.paragraph && node.marks.some(hasMark)) {
                    const resolvedPos = tr.doc.resolve(pos);
                    const withoutBlockMarks = node.marks.filter(not(hasMark));
                    tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
                }
            });
            /** Get range and wrapping needed for the selection */ const { $from: $from, $to: $to } = tr.selection;
            const range = $from.blockRange($to);
            const wrapping = range && (0, $eOaGc.findWrapping)(range, nodes.blockquote);
            if (wrapping) /** Wrap the selection */ tr.wrap(range, wrapping).scrollIntoView();
            else {
                /** If wrapping is not possible, replace with a blockquote */ const start = $from.start();
                const end = $to.end();
                const content = $from.node().content;
                const blockquote = nodes.blockquote.create({}, nodes.paragraph.create({}, content));
                const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(blockquote), 0, 0);
                tr.replaceRange(start, end, slice).scrollIntoView();
            }
        }
        return tr;
    };
}


function $9c4268662dffbdb9$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $et3Y5.NORMAL_TEXT).name && nodes.paragraph) return $9c4268662dffbdb9$export$63c4f0859cc75dc6()({
            tr: tr
        });
        if (name === 'smallText' && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return $9c4268662dffbdb9$export$7343796298b2524f()({
            tr: tr
        });
        const headingBlockType = (0, $et3Y5.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $9c4268662dffbdb9$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $9c4268662dffbdb9$export$c6a04dca1ed03a3c(level, fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $8HW7o.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $eOaGc.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                // Then apply the heading block type to the lifted content
                // We need to recalculate positions after the lift operation
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.heading, {
                    level: level
                });
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        // Remove fontSize mark from transformed content in range
        // List content stays as paragraphs (headings aren't allowed in list items),
        // but non-list content has been converted to headings by setBlockType above.
        const { fontSize: fontSize } = schema.marks;
        if (fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
            const allowedBlocks = [
                schema.nodes.paragraph,
                schema.nodes.heading
            ];
            if (selection instanceof (0, $8HW7o.CellSelection)) selection.forEachCell((cell, pos)=>{
                (0, $9WBFV.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, allowedBlocks)(pos, pos + cell.nodeSize, tr);
            });
            else {
                const expandedRange = (0, $3eace22a01d888a0$export$77bd22d0a1033d4)(tr);
                (0, $9WBFV.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, allowedBlocks)(expandedRange.from, expandedRange.to, tr);
            }
        }
        return tr;
    };
}
function $9c4268662dffbdb9$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return ({ tr: tr })=>{
        const { nodes: nodes, marks: marks } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $9c4268662dffbdb9$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        if (name === 'smallText' && marks.fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return $9c4268662dffbdb9$export$2c10a6ea48e28b89(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        const headingBlockType = (0, $et3Y5.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $9c4268662dffbdb9$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        return null;
    };
}
function $9c4268662dffbdb9$export$7343796298b2524f(fromBlockQuote) {
    return function({ tr: tr }) {
        const { marks: { fontSize: fontSize }, nodes: { paragraph: paragraph } } = tr.doc.type.schema;
        if (!fontSize) return null;
        const { selection: selection } = tr;
        const applySmallFontSize = (0, $9WBFV.createToggleBlockMarkOnRangeNext)(fontSize, ()=>({
                fontSize: 'small'
            }), [
            paragraph
        ]);
        if (fromBlockQuote) {
            const { $from: $from, $to: $to } = selection;
            const range = $from.blockRange($to);
            if (!range) return tr;
            const targetLiftDepth = (0, $eOaGc.liftTarget)(range);
            if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
            const from = tr.mapping.map($from.pos);
            const to = tr.mapping.map($to.pos);
            tr.setBlockType(from, to, paragraph);
            applySmallFontSize(from, to, tr);
        } else if (selection instanceof (0, $8HW7o.CellSelection)) {
            const mapFrom = tr.steps.length;
            selection.forEachCell((cell, pos)=>{
                const from = tr.mapping.slice(mapFrom).map(pos);
                const to = from + cell.nodeSize;
                tr.setBlockType(from, to, paragraph);
                (0, $3eace22a01d888a0$export$9fb148c84c583d2a)(tr, from, to);
                applySmallFontSize(from, to, tr);
            });
        } else {
            tr.setBlockType(selection.from, selection.to, paragraph);
            const expandedRange = (0, $3eace22a01d888a0$export$77bd22d0a1033d4)(tr);
            (0, $3eace22a01d888a0$export$9fb148c84c583d2a)(tr, expandedRange.from, expandedRange.to);
            applySmallFontSize(tr.mapping.map(expandedRange.from, -1), tr.mapping.map(expandedRange.to, 1), tr);
        }
        return tr;
    };
}
function $9c4268662dffbdb9$export$2c10a6ea48e28b89(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $9c4268662dffbdb9$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_SMALL_TEXT,
                attributes: {
                    inputMethod: inputMethod,
                    previousBlockType: previousHeadingLevel !== undefined ? String(previousHeadingLevel) : undefined
                }
            })(tr);
            return $9c4268662dffbdb9$export$7343796298b2524f(fromBlockQuote)({
                tr: tr
            });
        });
}
function $9c4268662dffbdb9$export$63c4f0859cc75dc6(fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        // Apply normal text to the selection range (handles non-list content)
        const ranges = selection instanceof (0, $8HW7o.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $eOaGc.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.paragraph, {});
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        // Remove fontSize mark from any lists the selection touches
        const { fontSize: fontSize } = schema.marks;
        if (fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
            if (selection instanceof (0, $8HW7o.CellSelection)) selection.forEachCell((cell, pos)=>{
                (0, $9WBFV.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, [
                    schema.nodes.paragraph
                ])(pos, pos + cell.nodeSize, tr);
            });
            else {
                const expandedRange = (0, $3eace22a01d888a0$export$77bd22d0a1033d4)(tr);
                (0, $9WBFV.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, [
                    schema.nodes.paragraph
                ])(expandedRange.from, expandedRange.to, tr);
            }
        }
        return tr;
    };
}
function $9c4268662dffbdb9$export$195de5d8e201efd7(inputMethod, editorAnalyticsApi) {
    return function({ tr: tr }) {
        const formattingCleared = [];
        const schema = tr.doc.type.schema;
        (0, $3b9a329ce4d38fad$export$73b50f8f13648c71).forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $8HW7o.CellSelection)) (0, $3b9a329ce4d38fad$export$bd443c1dba3019b8)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push((0, $3b9a329ce4d38fad$export$ce157a3b6664c924)[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push((0, $3b9a329ce4d38fad$export$ce157a3b6664c924)[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        (0, $3b9a329ce4d38fad$export$a5cb0c20bd02ce0c).forEach((nodeName)=>{
            const formattedNodeType = schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $8HW7o.CellSelection)) (0, $3b9a329ce4d38fad$export$bd443c1dba3019b8)(tr.selection, tr.doc, (0, $3b9a329ce4d38fad$export$10ed2145ce1a03b1)(schema, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, (0, $3b9a329ce4d38fad$export$10ed2145ce1a03b1)(schema, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).FORMATTED,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: 'textStyle'
            }
        })(tr);
        return tr;
    };
}
function $9c4268662dffbdb9$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $1yF0C.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (const node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $9c4268662dffbdb9$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $9c4268662dffbdb9$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $9c4268662dffbdb9$export$63c4f0859cc75dc6(fromBlockQuote)({
                tr: tr
            });
        });
}
const $9c4268662dffbdb9$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi, fromBlockQuote)=>{
    return $9c4268662dffbdb9$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $9c4268662dffbdb9$export$c6a04dca1ed03a3c(newHeadingLevel, fromBlockQuote)({
                tr: tr
            });
        });
};
function $9c4268662dffbdb9$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $gNdNc.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $9c4268662dffbdb9$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($9c4268662dffbdb9$var$insertBlockQuote());
};
function $9c4268662dffbdb9$export$f5e16b3b6b62d83(inputMethod, editorAnalyticsApi) {
    return $9c4268662dffbdb9$var$withCurrentHeadingLevel(()=>({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            return (0, $8ce1123749e3b5c0$export$bb05c9a6c853122f)(nodes.blockquote)({
                tr: tr
            });
        });
}
const $9c4268662dffbdb9$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
		 * Use cases:
		 * 1. Change `heading` to `paragraph`
		 * 2. Remove block marks
		 *
		 * NOTE: We already know it's an empty doc so it's safe to use 0
		 */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};






var $56doO = parcelRequire("56doO");


var $kpCD8 = parcelRequire("kpCD8");







var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");


const $7a3e6e706ea3c1d3$var$MAX_HEADING_LEVEL = 6;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7a3e6e706ea3c1d3$var$BLOCK_QUOTE_REGEX = /^\s*>\s$/;
function $7a3e6e706ea3c1d3$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $7a3e6e706ea3c1d3$var$headingRule(nodeType, maxLevel) {
    return (0, $3eace22a01d888a0$export$644b98fd2fd87b8b)({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $7a3e6e706ea3c1d3$var$getHeadingLevel
    });
}
function $7a3e6e706ea3c1d3$var$blockQuoteRule(nodeType) {
    return (0, $3eace22a01d888a0$export$1fe8b64ae159a0fa)($7a3e6e706ea3c1d3$var$BLOCK_QUOTE_REGEX, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $7a3e6e706ea3c1d3$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $7a3e6e706ea3c1d3$var$headingRule(schema.nodes.heading, $7a3e6e706ea3c1d3$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $d8RhQ.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $3brWT.leafNodeReplacementCharacter)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $56doO.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $c2pcC.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $krYZG.ACTION).FORMATTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $7a3e6e706ea3c1d3$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $7a3e6e706ea3c1d3$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $7a3e6e706ea3c1d3$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $d8RhQ.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $3brWT.leafNodeReplacementCharacter)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $56doO.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $c2pcC.inputRuleWithAnalytics)({
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $7a3e6e706ea3c1d3$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$7a3e6e706ea3c1d3$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$7a3e6e706ea3c1d3$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $7a3e6e706ea3c1d3$export$2e2bcd8739ae039 = $7a3e6e706ea3c1d3$var$inputRulePlugin;











var $77KCc = parcelRequire("77KCc");


var $iUNgd = parcelRequire("iUNgd");


var $di3bZ = parcelRequire("di3bZ");









var $kCECX = parcelRequire("kCECX");

// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $b51bf62e653b8893$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $b51bf62e653b8893$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $kCECX.TextSelection))) return false;
    if (!$b51bf62e653b8893$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};








// function to check whether the selected node is the sole decision item in the decision list
const $349e9b9176a8a561$var$isSelectedNodeSoleDecisionItem = (state)=>{
    const isDecisionItemNodeSelected = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (0, $bjg0G.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)?.node;
    return decisionList?.childCount === 1;
};
const $349e9b9176a8a561$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $349e9b9176a8a561$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $bjg0G.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $bjg0G.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $349e9b9176a8a561$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $349e9b9176a8a561$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}





// eslint-disable-next-line require-unicode-regexp
const $86cf7f88083ba8e1$var$WHITESPACE_ONLY = /^\s+$/;
/**
 * Determines whether the current selection is inside a heading, positioned after
 * all of the heading's visible (non-whitespace) content but *before* one or more
 * trailing whitespace characters.
 *
 * In this scenario ProseMirror's default `splitBlock` treats the cursor as *not*
 * being at the end of the node (`atEnd === false`), because there is still
 * (whitespace) content between the cursor and the node boundary. As a result the
 * newly split-off block inherits the heading type instead of becoming a
 * paragraph — even though, visually, the cursor looks like it is at the end of
 * the heading.
 *
 * We intentionally scope this to *only* that case:
 * - The parent must be a heading.
 * - The selection must be empty (a plain caret, not a range).
 * - There must be at least one character between the caret and the end of the
 *   heading, and every such character must be whitespace.
 *
 * All other cases (caret mid-word, caret at the true end, empty heading, etc.)
 * return `false` so the default behaviour is preserved.
 */ const $86cf7f88083ba8e1$var$isCursorAfterHeadingContentBeforeTrailingWhitespace = ($from)=>{
    const parent = $from.parent;
    const headingType = $from.doc.type.schema.nodes.heading;
    if (!headingType || parent.type !== headingType) return false;
    // Offset of the caret within the heading's content.
    const offsetInParent = $from.parentOffset;
    const contentSize = parent.content.size;
    // If the caret is already at (or past) the end of the heading content, this is
    // the normal "atEnd" case handled correctly by the default split — skip.
    if (offsetInParent >= contentSize) return false;
    // The remaining text between the caret and the end of the heading.
    const trailingText = parent.textBetween(offsetInParent, contentSize);
    // Must be non-empty and consist solely of whitespace.
    return trailingText.length > 0 && $86cf7f88083ba8e1$var$WHITESPACE_ONLY.test(trailingText);
};
const $86cf7f88083ba8e1$export$bbc98c32685b9fd = (state, dispatch, view)=>{
    const { $from: $from } = state.selection;
    // Only act on an empty caret selection inside a matching heading.
    if (!state.selection.empty || !$86cf7f88083ba8e1$var$isCursorAfterHeadingContentBeforeTrailingWhitespace($from)) return false;
    const paragraphType = state.schema.nodes.paragraph;
    if (!paragraphType) return false;
    return (0, $iUNgd.splitBlockAs)((_node, atEnd)=>{
        // Guard again inside the callback: only override the type for the exact
        // scenario. If ProseMirror already considers us at the end, defer to the
        // default (return null).
        if (atEnd) return null;
        return {
            type: paragraphType
        };
    })(state, dispatch, view);
};



const $d74877df9942ab3e$var$backspaceCommand = (0, $iUNgd.chainCommands)((0, $9c4268662dffbdb9$export$9c6026f8ac831f44), (0, $349e9b9176a8a561$export$9c1a524875bfb8ec)((0, $3eace22a01d888a0$export$3a2c03e35bc6c7a8)), (0, $b51bf62e653b8893$export$6c408f720f6b44a7));
const $d74877df9942ab3e$var$del = (0, $iUNgd.chainCommands)((0, $77KCc.deleteEmptyParagraphAndMoveBlockUp)((0, $3eace22a01d888a0$export$3a2c03e35bc6c7a8)), (0, $349e9b9176a8a561$export$9c1a524875bfb8ec)((0, $3eace22a01d888a0$export$3a2c03e35bc6c7a8)), (0, $b51bf62e653b8893$export$6c408f720f6b44a7));
function $d74877df9942ab3e$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.insertNewLine).common, (0, $77KCc.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    // Fixes the "Enter after a heading with trailing whitespace creates another
    // heading instead of a paragraph" bug. The command is a no-op (returns false)
    // in every case except that exact scenario, so other Enter handlers are
    // unaffected.
    if ((0, $ieeJu.expValEquals)('platform_editor_fix_new_line_after_heading', 'isEnabled', true)) (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common ?? 'Enter', (0, $86cf7f88083ba8e1$export$bbc98c32685b9fd), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveUp).common, (0, $77KCc.createNewParagraphAbove), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, (0, $77KCc.createNewParagraphBelow), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.findKeyMapForBrowser)((0, $ldqjS.redo)), (0, $di3bZ.redo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.undo).common, (0, $di3bZ.undo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.backspace).common, $d74877df9942ab3e$var$backspaceCommand, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.deleteKey).common, $d74877df9942ab3e$var$del, list);
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.forwardDelete).mac, $d74877df9942ab3e$var$del, list);
    if (schema.nodes[$et3Y5.BLOCK_QUOTE.nodeName]) (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleBlockQuote)), (0, $9c4268662dffbdb9$export$50b4331f407b3ab6)((0, $krYZG.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $eBSR7.keymap)(list);
}






var $lwsLh = parcelRequire("lwsLh");


var $8dxef = parcelRequire("8dxef");














const $5aa59e55be20336a$var$KEY_0 = 48;
const $5aa59e55be20336a$var$KEY_1 = 49;
const $5aa59e55be20336a$var$KEY_2 = 50;
const $5aa59e55be20336a$var$KEY_3 = 51;
const $5aa59e55be20336a$var$KEY_4 = 52;
const $5aa59e55be20336a$var$KEY_5 = 53;
const $5aa59e55be20336a$var$KEY_6 = 54;
const $5aa59e55be20336a$export$495808184472a100 = 55;
const $5aa59e55be20336a$export$442e847723cf0569 = [
    $5aa59e55be20336a$var$KEY_0,
    $5aa59e55be20336a$var$KEY_1,
    $5aa59e55be20336a$var$KEY_2,
    $5aa59e55be20336a$var$KEY_3,
    $5aa59e55be20336a$var$KEY_4,
    $5aa59e55be20336a$var$KEY_5,
    $5aa59e55be20336a$var$KEY_6
];
const $5aa59e55be20336a$var$NUMPAD_KEY_0 = 96;
const $5aa59e55be20336a$var$NUMPAD_KEY_1 = 97;
const $5aa59e55be20336a$var$NUMPAD_KEY_2 = 98;
const $5aa59e55be20336a$var$NUMPAD_KEY_3 = 99;
const $5aa59e55be20336a$var$NUMPAD_KEY_4 = 100;
const $5aa59e55be20336a$var$NUMPAD_KEY_5 = 101;
const $5aa59e55be20336a$var$NUMPAD_KEY_6 = 102;
const $5aa59e55be20336a$export$fcc4b4cb2de35e6 = [
    $5aa59e55be20336a$var$NUMPAD_KEY_0,
    $5aa59e55be20336a$var$NUMPAD_KEY_1,
    $5aa59e55be20336a$var$NUMPAD_KEY_2,
    $5aa59e55be20336a$var$NUMPAD_KEY_3,
    $5aa59e55be20336a$var$NUMPAD_KEY_4,
    $5aa59e55be20336a$var$NUMPAD_KEY_5,
    $5aa59e55be20336a$var$NUMPAD_KEY_6
];



const $fc8ae5254b8d9ad5$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $et3Y5.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.marks.some((m)=>m.type.name === 'fontSize' && m.attrs.fontSize === 'small') && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return 0, $et3Y5.SMALL_TEXT;
    else if (node.type === schema.nodes.paragraph) return 0, $et3Y5.NORMAL_TEXT;
    else if (node.type === schema.nodes.blockquote) return 0, $et3Y5.BLOCK_QUOTE;
    return 0, $et3Y5.OTHER;
};
const $fc8ae5254b8d9ad5$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $et3Y5.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $et3Y5.HEADING_1:
        case 0, $et3Y5.HEADING_2:
        case 0, $et3Y5.HEADING_3:
        case 0, $et3Y5.HEADING_4:
        case 0, $et3Y5.HEADING_5:
        case 0, $et3Y5.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $et3Y5.SMALL_TEXT:
            return !!state.schema.marks.fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
        case 0, $et3Y5.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $et3Y5.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $et3Y5.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $fc8ae5254b8d9ad5$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $et3Y5.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $fc8ae5254b8d9ad5$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $et3Y5.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $et3Y5.OTHER);
            return false;
        }
    });
    return blockType || (0, $et3Y5.OTHER);
};
const $fc8ae5254b8d9ad5$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $9c4268662dffbdb9$export$283e32d0388e302a)((0, $krYZG.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $9c4268662dffbdb9$export$52d74b15bd103d7f)(headingLevel, (0, $krYZG.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $fc8ae5254b8d9ad5$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('blockTypePlugin');
const $fc8ae5254b8d9ad5$export$ae829ec7b2625219 = (editorAPI, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, lastNodeMustBeParagraph, includeBlockQuoteAsTextstyleOption, allowFontSize)=>{
    const editorAnalyticsApi = editorAPI?.analytics?.actions;
    let altKeyLocation = 0;
    return new (0, $kpCD8.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) {
                    const tr = newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create());
                    return tr.setMeta((0, $lwsLh.INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META), true);
                }
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $et3Y5.TEXT_BLOCK_TYPES).filter((blockType)=>$fc8ae5254b8d9ad5$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $et3Y5.WRAPPER_BLOCK_TYPES).filter((blockType)=>$fc8ae5254b8d9ad5$var$isBlockTypeSchemaSupported(blockType, state));
                const BLOCK_TYPES_IN_DROPDOWN = (0, $et3Y5.getBlockTypesInDropdown)(includeBlockQuoteAsTextstyleOption);
                const availableBlockTypesInDropdown = BLOCK_TYPES_IN_DROPDOWN.filter((blockType)=>$fc8ae5254b8d9ad5$var$isBlockTypeSchemaSupported(blockType, state));
                const formattingIsPresent = (0, $3eace22a01d888a0$export$bce51f4ee2032263)(availableBlockTypesInDropdown) ? (0, $3eace22a01d888a0$export$4b48a1fc423972ea)(state) : undefined;
                return {
                    currentBlockType: $fc8ae5254b8d9ad5$var$detectBlockType(availableBlockTypesInDropdown, state),
                    blockTypesDisabled: (0, $3eace22a01d888a0$export$52adb8d9a3386cb8)(state, allowFontSize),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
                    formattingIsPresent: formattingIsPresent
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $fc8ae5254b8d9ad5$var$detectBlockType(oldPluginState.availableBlockTypesInDropdown, newState),
                    blockTypesDisabled: (0, $3eace22a01d888a0$export$52adb8d9a3386cb8)(newState, allowFontSize),
                    formattingIsPresent: (0, $3eace22a01d888a0$export$bce51f4ee2032263)(oldPluginState.availableBlockTypesInDropdown) ? (0, $3eace22a01d888a0$export$4b48a1fc423972ea)(newState) : undefined
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled || newPluginState.formattingIsPresent !== oldPluginState.formattingIsPresent) dispatch($fc8ae5254b8d9ad5$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $fc8ae5254b8d9ad5$export$18d4026d1ea86bb1,
        props: {
            /**
			 * As we only want the left alt key to work for headings shortcuts on Windows
			 * we can't use prosemirror-keymap and need to handle these shortcuts specially
			 * Shortcut on Mac: Cmd-Opt-{heading level}
			 * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
			 */ handleKeyDown: (view, event)=>{
                let headingLevel = (0, $5aa59e55be20336a$export$442e847723cf0569).indexOf(event.keyCode);
                if (headingLevel === -1) // Check for numpad keys if not found in digits row
                headingLevel = (0, $5aa59e55be20336a$export$fcc4b4cb2de35e6).indexOf(event.keyCode);
                const browser = (0, $8dxef.getBrowserInfo)();
                if (headingLevel > -1 && event.altKey) {
                    if (browser.mac && event.metaKey) return editorAPI?.core?.actions.execute($fc8ae5254b8d9ad5$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    else if (!browser.mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($fc8ae5254b8d9ad5$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                } else if (event.keyCode === (0, $5aa59e55be20336a$export$495808184472a100) && event.altKey && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
                    if (browser.mac && event.metaKey) return editorAPI?.core?.actions.execute((0, $9c4268662dffbdb9$export$2c10a6ea48e28b89)((0, $krYZG.INPUT_METHOD).SHORTCUT, editorAnalyticsApi)) ?? false;
                    else if (!browser.mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute((0, $9c4268662dffbdb9$export$2c10a6ea48e28b89)((0, $krYZG.INPUT_METHOD).SHORTCUT, editorAnalyticsApi)) ?? false;
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            }
        }
    });
};






var $cozmU = parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");





var $bq13E = parcelRequire("bq13E");


var $9iFhC = parcelRequire("9iFhC");


var $gLi18 = parcelRequire("gLi18");


var $7Y8M5 = parcelRequire("7Y8M5");


var $UL6rM = parcelRequire("UL6rM");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");





var $2SboX = parcelRequire("2SboX");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 












var $6DhDg = parcelRequire("6DhDg");




var $ldbHR = parcelRequire("ldbHR");


var $7sJoX = parcelRequire("7sJoX");










var $anBbz = parcelRequire("anBbz");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






const $ab85bf8c95e02456$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7Y8M5.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $28uKn = parcelRequire("28uKn");

const $e28eaaa50b54a5a3$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $e28eaaa50b54a5a3$export$9272613b68afed4b = (_typographyTheme)=>{
    return /*#__PURE__*/ (0, $lOiVq.css)({
        '& h1': {
            font: (0, $28uKn.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $28uKn.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $28uKn.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $28uKn.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $28uKn.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $28uKn.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $28uKn.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $28uKn.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $28uKn.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $28uKn.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $28uKn.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $28uKn.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$e28eaaa50b54a5a3$var$headingWithAlignmentStyles()
    });
};



var $lrTDq = parcelRequire("lrTDq");

function $69c2cf8a715357be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $69c2cf8a715357be$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, #292A2E)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        tagName === 'blockquote' ? (0, $ab85bf8c95e02456$export$1b5f3b43e6c4a8ee) : (0, $e28eaaa50b54a5a3$export$9272613b68afed4b)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}blockquote{padding-top:0;padding-bottom:0;margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $69c2cf8a715357be$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $lOiVq.css)((0, $lrTDq.shortcutStyle), "margin-left:var(--ds-space-200, 16px);color:var(--ds-icon, #292A2E);");
const $69c2cf8a715357be$export$b09cf4fbc27c2bae = {
    name: "1cmggog",
    styles: "color:var(--ds-icon, #292A2E)"
};
const $69c2cf8a715357be$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $69c2cf8a715357be$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $69c2cf8a715357be$export$a61e5f64ad28e14a = {
    name: "1t1gmw4",
    styles: "[data-role='droplistContent']{max-height:90vh;}"
};


const $b3e15fb62581fb9a$var$buttonContentStyle = (0, $buxP3.xcss)({
    minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
    overflow: 'hidden',
    padding: 'space.075'
});
const $b3e15fb62581fb9a$var$buttonContentReducedSpacingStyle = (0, $buxP3.xcss)({
    padding: 'space.100',
    minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
});
const $b3e15fb62581fb9a$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $bq13E.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $bq13E.toolbarMessages).textStylesTooltip);
    const icon = (0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && props.blockTypeIcon ? props.blockTypeIcon : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
        label: labelTextStyles,
        spacing: "spacious",
        color: "currentColor"
    });
    const chevronIconSpacing = (0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') ? 'spacious' : 'none';
    const shouldUseIconAsButton = props.isSmall || (0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1');
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $9iFhC.wrapperStyle),
                props.isSmall && (0, $69c2cf8a715357be$export$4f9ef2b7bddb4c3a)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldUseIconAsButton && icon, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $6DhDg.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            spacing: chevronIconSpacing,
            label: "",
            color: "currentColor",
            size: "small"
        }))))
    }, !shouldUseIconAsButton && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $b3e15fb62581fb9a$var$buttonContentStyle,
            props.isReducedSpacing && $b3e15fb62581fb9a$var$buttonContentReducedSpacingStyle
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), props.title || (0, $et3Y5.NORMAL_TEXT).title)));
};



const $f153d59c1935f058$var$buttonWrapperStyles = (0, $buxP3.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $f153d59c1935f058$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        const observer = new (0, $2SboX.default)(({ typography: typography })=>{
            if (typography !== this.state.typographyTheme) this.setState({
                typographyTheme: typography
            });
        });
        this.setState({
            observer: observer
        });
        observer.observe();
    }
    componentWillUnmount() {
        this.state.observer?.disconnect();
    }
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes = [], availableBlockTypesInDropdown: availableBlockTypesInDropdown = [], shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypesInDropdown.filter((blockType)=>blockType.name === currentBlockType?.name).map((blockType)=>blockType.title);
        const defaultIcon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
            label: ""
        });
        const currentIcon = currentBlockType?.icon;
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            const button = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b3e15fb62581fb9a$export$60665cf15e769742), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType?.name,
                blockTypeIcon: currentIcon || defaultIcon
            });
            return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: (0, $fqVYq.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true) ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [
                    (0, $9iFhC.wrapperStyle),
                    (0, $69c2cf8a715357be$export$a61e5f64ad28e14a)
                ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $9iFhC.wrapperStyle)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gLi18.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $7Y8M5.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                section: {
                    hasSeparator: true
                },
                shouldUseDefaultRole: shouldUseDefaultRole,
                // hasSeparator={true}
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
                xcss: $f153d59c1935f058$var$buttonWrapperStyles
            }, button)), !api?.primaryToolbar && /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $9iFhC.separatorStyles)
            }));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: (0, $9iFhC.wrapperStyle)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b3e15fb62581fb9a$export$60665cf15e769742), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType?.name,
            blockTypeIcon: currentIcon || defaultIcon
        }), !api?.primaryToolbar && /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $9iFhC.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            active: false,
            isOpenedByKeyboard: false,
            typographyTheme: undefined,
            observer: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        };
        this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        };
        this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        };
        this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage }, currentBlockType: currentBlockType, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = this.props;
            const items = (availableBlockTypesInDropdown ?? []).map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const defaultMessage = Array.isArray(blockType.title.defaultMessage) ? blockType.title.defaultMessage.find((message)=>'value' in message) : blockType.title.defaultMessage;
                const description = typeof defaultMessage === 'string' ? defaultMessage : defaultMessage && 'value' in defaultMessage ? defaultMessage.value : '';
                const keyMap = (0, $ldqjS.findKeymapByDescription)(description);
                const icon = blockType?.icon;
                const item = {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                        css: (0, $69c2cf8a715357be$export$2e548ca9c55ac73f)(tagName, isActive, this.state.typographyTheme)
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    'aria-label': (0, $ldqjS.tooltip)(keyMap, formatMessage(blockType.title)),
                    key: `${blockType.name}-${index}`,
                    elemBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? icon : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                        css: [
                            (0, $69c2cf8a715357be$export$54ea58af6cf8bf3a),
                            isActive && (0, $69c2cf8a715357be$export$b09cf4fbc27c2bae)
                        ]
                    }, (0, $ldqjS.tooltip)(keyMap)),
                    isActive: isActive
                };
                return item;
            });
            if ((availableBlockTypesInDropdown ?? []).map((blockType)=>blockType.name).includes('blockquote') && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control')) {
                const clearFormattingItem = {
                    content: /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)("p", null, (0, $bq13E.toolbarMessages).clearFormatting.defaultMessage)),
                    value: {
                        name: 'clearFormatting'
                    },
                    'aria-label': (0, $ldqjS.tooltip)((0, $ldqjS.clearFormatting), (0, $bq13E.toolbarMessages).clearFormatting.defaultMessage),
                    key: 'clear-formatting',
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                        css: [
                            (0, $69c2cf8a715357be$export$54ea58af6cf8bf3a)
                        ]
                    }, (0, $ldqjS.tooltip)((0, $ldqjS.clearFormatting))),
                    isActive: false,
                    isDisabled: currentBlockType === (0, $et3Y5.NORMAL_TEXT) && !formattingIsPresent
                };
                return [
                    {
                        items: items
                    },
                    {
                        items: [
                            clearFormattingItem
                        ]
                    }
                ];
            }
            return [
                {
                    items: items
                }
            ];
        };
        this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            if (blockType.name === 'blockquote') this.props.wrapBlockQuote(blockType.name);
            else if (blockType.name === 'clearFormatting') this.props.clearFormatting();
            else {
                const fromBlockQuote = this.props.currentBlockType?.name === 'blockquote';
                this.props.setTextLevel(blockType.name, fromBlockQuote);
            }
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $f153d59c1935f058$var$_default_1 = (0, $kSwu1.injectIntl)($f153d59c1935f058$var$ToolbarBlockType);
var $f153d59c1935f058$export$2e2bcd8739ae039 = $f153d59c1935f058$var$_default_1;


const $d7b550d0f6bfd9f4$var$FloatingToolbarSettings = {
    isSmall: true,
    disabled: false,
    isToolbarReducedSpacing: true,
    shouldUseDefaultRole: false
};
function $d7b550d0f6bfd9f4$export$b15abb95157a91c7({ api: api }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    const boundSetBlockType = (0, $cozmU.useCallback)((name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $krYZG.INPUT_METHOD).FLOATING_TB, fromBlockQuote)), [
        api
    ]);
    const wrapBlockQuote = (0, $cozmU.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $krYZG.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const clearFormatting = (0, $cozmU.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $krYZG.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f153d59c1935f058$export$2e2bcd8739ae039), {
        isSmall: $d7b550d0f6bfd9f4$var$FloatingToolbarSettings.isSmall,
        isDisabled: $d7b550d0f6bfd9f4$var$FloatingToolbarSettings.disabled,
        isReducedSpacing: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? false : $d7b550d0f6bfd9f4$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        shouldUseDefaultRole: $d7b550d0f6bfd9f4$var$FloatingToolbarSettings.shouldUseDefaultRole,
        api: api
    });
}





parcelRequire("cozmU");








function $93a4127a7d8d544b$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    const boundSetBlockType = (name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $krYZG.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    const wrapBlockQuote = ()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $krYZG.INPUT_METHOD).TOOLBAR));
    const clearFormatting = ()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $krYZG.INPUT_METHOD).TOOLBAR));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f153d59c1935f058$export$2e2bcd8739ae039), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");




/* HeadingButton.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 



var $hekY6 = parcelRequire("hekY6");

















var $bFSJa = parcelRequire("bFSJa");





var $4Qu9h = parcelRequire("4Qu9h");


var $dVKvM = parcelRequire("dVKvM");

var $i9j2V = parcelRequire("i9j2V");














const $e7c85a5a66ef5d2d$var$smallTextStyle = null;
const $e7c85a5a66ef5d2d$var$normalStyle = null;
const $e7c85a5a66ef5d2d$var$heading1Style = null;
const $e7c85a5a66ef5d2d$var$heading2Style = null;
const $e7c85a5a66ef5d2d$var$heading3Style = null;
const $e7c85a5a66ef5d2d$var$heading4Style = null;
const $e7c85a5a66ef5d2d$var$heading5Style = null;
const $e7c85a5a66ef5d2d$var$heading6Style = null;
const $e7c85a5a66ef5d2d$var$LegacyHeadingText = ({ children: children, headingType: headingType })=>{
    switch(headingType){
        case 'heading1':
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
        case 'heading2':
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
        case 'heading3':
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
        case 'heading4':
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
        case 'heading5':
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
        case 'heading6':
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
        case 'smallText':
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
        case 'normal':
        default:
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0TsweVCHPu _0o1iyqIncK _3HJhLjhjEV _0bbA8Dh1jw _4AAA7H2zYa _3fLYnMA6Kz _3beUsRzUCw _4kn5M5VXn6 _3YSjYYkKjW _0PTou8kKjW _4hKUmCkKjW _1U3I6ekKjW _40KAEpkKjW _2gprwMkKjW"
                ]),
                children: children
            });
    }
};
const $e7c85a5a66ef5d2d$var$headingTextProps = {
    normal: {
        style: {
            font: (0, $28uKn.default)('editor.font.body')
        }
    },
    smallText: {
        style: {
            font: (0, $28uKn.default)('editor.font.body.small') ?? (0, $28uKn.default)('editor.font.body')
        }
    },
    heading1: {
        style: {
            font: (0, $28uKn.default)('editor.font.heading.h1')
        }
    },
    heading2: {
        style: {
            font: (0, $28uKn.default)('editor.font.heading.h2')
        }
    },
    heading3: {
        style: {
            font: (0, $28uKn.default)('editor.font.heading.h3')
        }
    },
    heading4: {
        style: {
            font: (0, $28uKn.default)('editor.font.heading.h4')
        }
    },
    heading5: {
        style: {
            font: (0, $28uKn.default)('editor.font.heading.h5')
        }
    },
    heading6: {
        style: {
            font: (0, $28uKn.default)('editor.font.heading.h6')
        }
    }
};
const $e7c85a5a66ef5d2d$var$HeadingText = ({ children: children, headingType: headingType })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement('div', $e7c85a5a66ef5d2d$var$headingTextProps[headingType], children);
};
const $e7c85a5a66ef5d2d$var$HeadingPreview = ({ children: children, headingType: headingType })=>{
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_fix_block_type_dropdown_no_style')) return /*#__PURE__*/ (0, $8aG6j.jsx)($e7c85a5a66ef5d2d$var$HeadingText, {
        headingType: headingType,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($e7c85a5a66ef5d2d$var$LegacyHeadingText, {
        headingType: headingType,
        children: children
    });
};
const $e7c85a5a66ef5d2d$var$shortcuts = {
    normal: (0, $ldqjS.setNormalText),
    smallText: (0, $ldqjS.toggleSmallText),
    heading1: (0, $ldqjS.toggleHeading1),
    heading2: (0, $ldqjS.toggleHeading2),
    heading3: (0, $ldqjS.toggleHeading3),
    heading4: (0, $ldqjS.toggleHeading4),
    heading5: (0, $ldqjS.toggleHeading5),
    heading6: (0, $ldqjS.toggleHeading6)
};
const $e7c85a5a66ef5d2d$var$shouldDisableHeadingButton = (state, blockType)=>{
    if (!state) return false;
    return (0, $3eace22a01d888a0$export$fbe592d31a93b004)(state) && blockType.name !== 'normal' && blockType.name !== 'smallText';
};
const $e7c85a5a66ef5d2d$export$a24781eb35f914a5 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const currentBlockType = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const availableBlockTypesInDropdown = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const isMarkdownBridgeEnabled = (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar');
    const { markdownView: markdownView, sourceFormatState: sourceFormatState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>({
            markdownView: isMarkdownBridgeEnabled ? states.markdownModeState?.view : undefined,
            sourceFormatState: isMarkdownBridgeEnabled ? states.markdownModeState?.sourceBlockFormatState : null
        }));
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    if (!availableBlockTypesInDropdown?.some((availableBlockType)=>availableBlockType.name === blockType.name)) return null;
     // When in source view and the bridge is enabled, read heading level from
    // the CM6 Lezer-tree-derived format state rather than the PM block type state.
    // markdownView is authoritative for "in source view" — it flips synchronously
    // on setView. sourceFormatState is null between the view switch and the
    // first CM6 update listener fire, so we can't rely on it as the sentinel.
    const isMarkdownBridgeActive = markdownView === 'syntax'; // Extract the numeric level from the block type name (e.g. 'heading1' → 1).
    const headingLevel = blockType.name.startsWith('heading') ? parseInt(blockType.name.replace('heading', ''), 10) : null;
    const isDisabled = isMarkdownBridgeActive ? Boolean(sourceFormatState?.inCodeBlock) : (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? $e7c85a5a66ef5d2d$var$shouldDisableHeadingButton(editorView?.state, blockType) : false;
    const fromBlockQuote = currentBlockType?.name === 'blockquote';
    const onClick = ()=>{
        if (isDisabled) return;
         // Route to CM6 when in source view.
        //
        // - heading1..6: apply/replace via toggleSourceHeading(targetLevel).
        // - normal (paragraph): if the cursor is currently on a heading line,
        //   call toggleSourceHeading with the *current* level — toggleHeading
        //   removes the prefix when invoked with the matching level, so this
        //   downgrades the heading back to a plain paragraph. No-op when not
        //   on a heading (already normal) or when smallText is selected (no
        //   markdown equivalent).
        if (isMarkdownBridgeActive) {
            const targetLevel = blockType.name === 'normal' ? sourceFormatState?.headingLevel ?? null : headingLevel;
            if (targetLevel !== null && targetLevel >= 1 && targetLevel <= 6) api?.markdownMode?.actions.toggleSourceHeading(targetLevel);
            return;
        }
        api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(blockType.name, (0, $krYZG.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    };
    const shortcut = (0, $ldqjS.formatShortcut)($e7c85a5a66ef5d2d$var$shortcuts[blockType.name]); // In source view, derive isSelected from the Lezer heading level.
    // In WYSIWYG, use the existing PM block type comparison.
    //
    // Branches in source view:
    // - heading1..6: select when the source heading level matches.
    // - normal (paragraph): select when the source has no heading and is not
    //   inside a blockquote — i.e. cursor is on a plain markdown paragraph.
    // - smallText: no markdown equivalent, so never selected in source view.
    //
    // Guard on `sourceFormatState != null` up-front so the body can read the
    // fields directly — clearer than nested optional chains and not fragile to
    // future reordering of the conditions.
    const isSelected = isMarkdownBridgeActive ? sourceFormatState != null ? headingLevel !== null ? sourceFormatState.headingLevel === headingLevel : blockType.name === 'normal' ? sourceFormatState.headingLevel === null && !sourceFormatState.inBlockquote : false : false : currentBlockType?.name === blockType.name;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: isSelected,
        isDisabled: isDisabled,
        ariaKeyshortcuts: shortcut,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($e7c85a5a66ef5d2d$var$HeadingPreview, {
            headingType: blockType.name,
            children: formatMessage(blockType.title)
        })
    });
};





parcelRequire("cozmU");


































const $1abc54a598d8ccd7$var$shouldDisableQuoteButton = (state)=>{
    if (!state) return false;
    return (0, $3eace22a01d888a0$export$fbe592d31a93b004)(state);
};
const $1abc54a598d8ccd7$export$94ec63f36c20dec6 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const availableBlockTypesInDropdown = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const currentBlockType = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const isMarkdownBridgeEnabled = (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar');
    const { markdownView: markdownView, sourceBlockFormatState: sourceBlockFormatState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>({
            markdownView: isMarkdownBridgeEnabled ? states.markdownModeState?.view : undefined,
            sourceBlockFormatState: isMarkdownBridgeEnabled ? states.markdownModeState?.sourceBlockFormatState : null
        }));
    if (!availableBlockTypesInDropdown?.some((availableBlockType)=>availableBlockType.name === blockType.name)) return null;
    // markdownView is authoritative for "in source view" — it flips synchronously
    // on setView. sourceBlockFormatState is null between the view switch and the
    // first CM6 update listener fire, so we can't rely on it as the sentinel.
    const isMarkdownBridgeActive = markdownView === 'syntax';
    const isDisabled = isMarkdownBridgeActive ? Boolean(sourceBlockFormatState?.inCodeBlock) : (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? $1abc54a598d8ccd7$var$shouldDisableQuoteButton(editorView?.state) : false;
    const onClick = ()=>{
        if (isDisabled) return;
        if (isMarkdownBridgeActive) {
            api?.markdownMode?.actions.toggleSourceBlockquote();
            return;
        }
        api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $krYZG.INPUT_METHOD).TOOLBAR));
    };
    const shortcut = (0, $ldqjS.formatShortcut)((0, $ldqjS.toggleBlockQuote));
    const isSelected = isMarkdownBridgeActive ? Boolean(sourceBlockFormatState?.inBlockquote) : currentBlockType === blockType;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: isSelected,
        isDisabled: isDisabled,
        ariaKeyshortcuts: shortcut,
        children: formatMessage(blockType.title)
    });
};























var $a6nzD = parcelRequire("a6nzD");

var $lslMH = parcelRequire("lslMH");













const $e67345de86308d9e$var$usePluginState = (api)=>{
    // Memoized inside the hook (rather than at module scope) so the gate read
    // inside `toolbarBlockTypesWithRank` doesn't run at module import time —
    // that breaks downstream tests that import preset-default without
    // initializing the FeatureGates client.
    const sourceViewBlockTypeValues = (0, $cozmU.useMemo)(()=>Object.values((0, $et3Y5.toolbarBlockTypesWithRank)({})), []);
    const selectPluginState = (0, $cozmU.useCallback)((state)=>{
        const pmCurrentBlockType = state.interactionState?.interactionState === 'hasNotHadInteraction' && (0, $ieeJu.expValEquals)('platform_editor_default_toolbar_state', 'isEnabled', true) ? undefined : state.blockTypeState?.currentBlockType;
        // When the markdown bridge is active and the source view is mounted,
        // derive currentBlockType from the CM6 Lezer heading level rather than
        // PM block type state (which reflects the last WYSIWYG cursor position).
        const isMarkdownBridgeEnabled = (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar');
        const sourceFormatState = isMarkdownBridgeEnabled ? state.markdownModeState?.sourceBlockFormatState : null;
        // markdownView is authoritative for "in source view" — it flips synchronously
        // on setView. sourceFormatState is null between the view switch and the first
        // CM6 update listener fire, so we can't rely on it as the sentinel.
        const isSourceViewActive = isMarkdownBridgeEnabled && state.markdownModeState?.view === 'syntax';
        // When in source view, derive currentBlockType from CM6 Lezer state
        // (heading level or blockquote) rather than PM block type state.
        // Guard on sourceFormatState being available — during the race window
        // after switching to source view but before CM6 fires its first update,
        // sourceFormatState is null even though isSourceViewActive is true.
        const currentBlockType = isSourceViewActive && sourceFormatState ? sourceFormatState.headingLevel !== null ? // In a heading, look up the full BlockType by name.
        sourceViewBlockTypeValues.find((bt)=>bt.name === `heading${sourceFormatState.headingLevel}`) ?? null : sourceFormatState.inBlockquote ? // In a blockquote, look up the blockquote BlockType.
        sourceViewBlockTypeValues.find((bt)=>bt.name === 'blockquote') ?? null : // Plain paragraph — look up the 'normal' BlockType so the trigger
        // shows "Normal text" (matches WYSIWYG and HeadingButton's
        // Normal-in-source-view selection logic).
        sourceViewBlockTypeValues.find((bt)=>bt.name === 'normal') ?? null : isSourceViewActive ? null : pmCurrentBlockType;
        return {
            blockTypesDisabled: isSourceViewActive && sourceFormatState ? Boolean(sourceFormatState.inCodeBlock) : isSourceViewActive ? false : state.blockTypeState?.blockTypesDisabled,
            currentBlockType: currentBlockType
        };
    }, [
        sourceViewBlockTypeValues
    ]);
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockType',
        'interaction',
        'markdownMode'
    ], selectPluginState);
};
const $e67345de86308d9e$export$e34ebed463fa4947 = ({ allowFontSize: allowFontSize, api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { blockTypesDisabled: blockTypesDisabled, currentBlockType: currentBlockType } = $e67345de86308d9e$var$usePluginState(api);
    const blockTypes = (0, $et3Y5.toolbarBlockTypesWithRank)({
        allowFontSize: allowFontSize
    });
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    const CurrentIcon = Object.values(blockTypes).find((blockType)=>blockType.name === currentBlockType?.name)?.icon?.type;
    const normalText = blockTypes.normal;
    const TriggerIcon = (0, $cozmU.useMemo)(()=>{
        if (editorAppearance === 'full-page') {
            const hasCurrentBlockType = currentBlockType && CurrentIcon;
            const Icon = hasCurrentBlockType ? CurrentIcon : (0, (/*@__PURE__*/$parcel$interopDefault($UL6rM)));
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                        label: "",
                        size: "small"
                    }),
                    hasCurrentBlockType ? formatMessage(currentBlockType.title) : formatMessage(normalText.title)
                ]
            });
        }
        return CurrentIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)(CurrentIcon, {
            label: `${currentBlockType?.name} ${formatMessage((0, $bq13E.toolbarMessages).textStylesTooltip)}`,
            size: "small"
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
            label: formatMessage((0, $bq13E.toolbarMessages).textStylesTooltip),
            size: "small"
        });
    }, [
        editorAppearance,
        currentBlockType,
        CurrentIcon,
        normalText,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
        isDisabled: blockTypesDisabled,
        iconBefore: TriggerIcon,
        tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: formatMessage((0, $bq13E.toolbarMessages).textStylesTooltip)
        }),
        label: formatMessage((0, $bq13E.toolbarMessages).textStyles, {
            blockTypeName: currentBlockType?.name
        }),
        children: children
    });
};


const $079671e442bdef18$export$a758406ca53b86a5 = (api, allowFontSize)=>{
    const toolbarComponents = [
        {
            type: (0, $3nacY.TEXT_STYLES_GROUP).type,
            key: (0, $3nacY.TEXT_STYLES_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION).type,
                    key: (0, $3nacY.TEXT_SECTION).key,
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.TEXT_STYLES_GROUP).key]
                },
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.TEXT_STYLES_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3nacY.TEXT_STYLES_MENU).type,
            key: (0, $3nacY.TEXT_STYLES_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_STYLES_GROUP).type,
                    key: (0, $3nacY.TEXT_STYLES_GROUP).key,
                    rank: (0, $hVLmg.TEXT_STYLES_GROUP_RANK)[(0, $3nacY.TEXT_STYLES_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e67345de86308d9e$export$e34ebed463fa4947), {
                    api: api,
                    allowFontSize: allowFontSize,
                    children: children
                })
        },
        {
            type: (0, $3nacY.TEXT_STYLES_MENU_SECTION).type,
            key: (0, $3nacY.TEXT_STYLES_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_STYLES_MENU).type,
                    key: (0, $3nacY.TEXT_STYLES_MENU).key,
                    rank: (0, $hVLmg.TEXT_STYLES_MENU_RANK)[(0, $3nacY.TEXT_STYLES_MENU_SECTION).key]
                },
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $hVLmg.TEXT_COLLAPSED_MENU_RANK)[(0, $3nacY.TEXT_STYLES_MENU_SECTION).key]
                }
            ]
        }
    ];
    Object.values((0, $et3Y5.toolbarBlockTypesWithRank)({
        allowFontSize: allowFontSize
    })).forEach((blockType)=>{
        if (blockType.toolbarKey) {
            const menuItem = {
                type: 'menu-item',
                key: blockType.toolbarKey,
                parents: [
                    {
                        type: (0, $3nacY.TEXT_STYLES_MENU_SECTION).type,
                        key: (0, $3nacY.TEXT_STYLES_MENU_SECTION).key,
                        rank: blockType.toolbarRank
                    }
                ],
                component: blockType.name === 'blockquote' ? ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1abc54a598d8ccd7$export$94ec63f36c20dec6), {
                        blockType: blockType,
                        api: api
                    }) : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e7c85a5a66ef5d2d$export$a24781eb35f914a5), {
                        blockType: blockType,
                        api: api
                    })
            };
            toolbarComponents.push(menuItem);
        }
    });
    return toolbarComponents;
};



var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");




parcelRequire("cozmU");














var $bBlkn = parcelRequire("bBlkn");


var $dhsWS = parcelRequire("dhsWS");


var $bc70Z = parcelRequire("bc70Z");


var $gIW0y = parcelRequire("gIW0y");


var $bUmH3 = parcelRequire("bUmH3");


var $66wqx = parcelRequire("66wqx");

const $879deadef06400b4$var$headingIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bc70Z))),
    (0, (/*@__PURE__*/$parcel$interopDefault($66wqx))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bUmH3))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dhsWS))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bBlkn))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gIW0y)))
];
const $879deadef06400b4$var$headingMessages = [
    (0, $5HBT9.messages).heading1,
    (0, $5HBT9.messages).heading2,
    (0, $5HBT9.messages).heading3,
    (0, $5HBT9.messages).heading4,
    (0, $5HBT9.messages).heading5,
    (0, $5HBT9.messages).heading6
];
const $879deadef06400b4$var$NODE_NAME = 'heading';
const $879deadef06400b4$var$HeadingBlockMenuItem = ({ level: level, api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const Icon = $879deadef06400b4$var$headingIcons[level - 1];
    const message = $879deadef06400b4$var$headingMessages[level - 1];
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.heading, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: `${$879deadef06400b4$var$NODE_NAME}${level}`,
                targetAttrs: {
                    level: level
                }
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: "",
            size: "small"
        }),
        children: formatMessage(message)
    });
};
const $879deadef06400b4$export$93c991c81dd77070 = ({ level: level, api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($879deadef06400b4$var$HeadingBlockMenuItem, {
            level: level,
            api: api,
            isSuggested: isSuggested
        });
};





parcelRequire("cozmU");








var $3FYPH = parcelRequire("3FYPH");





var $2oOlV = parcelRequire("2oOlV");

const $6e556807228b222a$var$NODE_NAME = 'paragraph';
const $6e556807228b222a$var$ParagraphBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.paragraph, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $6e556807228b222a$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2oOlV))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $3FYPH.messages).paragraph)
    });
};
const $6e556807228b222a$export$469651dcc0916a77 = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($6e556807228b222a$var$ParagraphBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};


/* QuoteBlockMenuItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 





parcelRequire("cozmU");














var $d4GYd = parcelRequire("d4GYd");

const $c56a1412b8737dd0$var$styles = {
    svgOverflow: "_4xp0cqYvD1 _2QhaXDYvD1"
};
const $c56a1412b8737dd0$var$NODE_NAME = 'blockquote';
const $c56a1412b8737dd0$var$QuoteBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.blockquote, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $c56a1412b8737dd0$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $c56a1412b8737dd0$var$styles.svgOverflow
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                label: "",
                size: "small"
            })
        }),
        children: formatMessage((0, $5HBT9.messages).blockquote)
    });
};
const $c56a1412b8737dd0$export$e07c899cb2d719c9 = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($c56a1412b8737dd0$var$QuoteBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};


const $2deeccc10ece8c1c$var$HEADING_NODE_NAME = 'heading';
const $2deeccc10ece8c1c$var$QUOTE_NODE_NAME = 'blockquote';
const $2deeccc10ece8c1c$var$PARAGRAPH_NODE_NAME = 'paragraph';
const $2deeccc10ece8c1c$export$325b6b890260a604 = (api)=>{
    const isTransformHeadingDisabled = (level)=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($2deeccc10ece8c1c$var$HEADING_NODE_NAME, {
            level: level
        }));
    return [
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_HEADINGS_H1_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]
            },
            component: (0, $879deadef06400b4$export$93c991c81dd77070)({
                level: 1,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(1)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_HEADINGS_H2_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]
            },
            component: (0, $879deadef06400b4$export$93c991c81dd77070)({
                level: 2,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(2)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_HEADINGS_H3_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]
            },
            component: (0, $879deadef06400b4$export$93c991c81dd77070)({
                level: 3,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(3)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_HEADINGS_H4_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_HEADINGS_H4_MENU_ITEM).key]
            },
            component: (0, $879deadef06400b4$export$93c991c81dd77070)({
                level: 4,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(4)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_HEADINGS_H5_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_HEADINGS_H5_MENU_ITEM).key]
            },
            component: (0, $879deadef06400b4$export$93c991c81dd77070)({
                level: 5,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(5)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_HEADINGS_H6_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_HEADINGS_H6_MENU_ITEM).key]
            },
            component: (0, $879deadef06400b4$export$93c991c81dd77070)({
                level: 6,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(6)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]
            },
            component: (0, $c56a1412b8737dd0$export$e07c899cb2d719c9)({
                api: api
            }),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($2deeccc10ece8c1c$var$QUOTE_NODE_NAME))
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]
            },
            component: (0, $6e556807228b222a$export$469651dcc0916a77)({
                api: api
            }),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($2deeccc10ece8c1c$var$PARAGRAPH_NODE_NAME))
        }
    ];
};





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");























var $I2MTF = parcelRequire("I2MTF");

const $abd3656af47cd07f$var$headingQuickInsertMessages = {
    1: {
        description: (0, $5HBT9.messages).heading1Description,
        title: (0, $5HBT9.messages).heading1
    },
    2: {
        description: (0, $5HBT9.messages).heading2Description,
        title: (0, $5HBT9.messages).heading2
    },
    3: {
        description: (0, $5HBT9.messages).heading3Description,
        title: (0, $5HBT9.messages).heading3
    },
    4: {
        description: (0, $5HBT9.messages).heading4Description,
        title: (0, $5HBT9.messages).heading4
    },
    5: {
        description: (0, $5HBT9.messages).heading5Description,
        title: (0, $5HBT9.messages).heading5
    },
    6: {
        description: (0, $5HBT9.messages).heading6Description,
        title: (0, $5HBT9.messages).heading6
    }
};
const $abd3656af47cd07f$var$headingQuickInsertShortcuts = {
    1: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHeading1)) ?? '',
    2: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHeading2)) ?? '',
    3: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHeading3)) ?? '',
    4: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHeading4)) ?? '',
    5: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHeading5)) ?? '',
    6: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHeading6)) ?? ''
};
const $abd3656af47cd07f$export$7913e5ec6aa6212c = (level)=>$abd3656af47cd07f$var$headingQuickInsertMessages[level];
const $abd3656af47cd07f$export$c99ec4513008fe69 = (level)=>$abd3656af47cd07f$var$headingQuickInsertShortcuts[level];
const $abd3656af47cd07f$export$e0f203c8396bac7c = ({ api: api, item: item })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isBlockquote = item === 'blockquote';
    const shortcut = (0, $cozmU.useMemo)(()=>isBlockquote ? '>' : $abd3656af47cd07f$export$c99ec4513008fe69(item), [
        isBlockquote,
        item
    ]);
    const title = formatMessage(item === 'blockquote' ? (0, $5HBT9.messages).blockquote : $abd3656af47cd07f$export$7913e5ec6aa6212c(item).title);
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert })=>{
        const { schema: schema } = editorView.state;
        const tr = isBlockquote ? insert(schema.nodes.blockquote.createChecked({}, schema.nodes.paragraph.createChecked())) : insert(schema.nodes.heading.createChecked({
            level: item
        }));
        if (item === 'blockquote') api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).FORMATTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        else api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).FORMATTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                newHeadingLevel: item
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api,
        isBlockquote,
        item
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: isBlockquote ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconQuote), {}) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconHeading), {
            level: item
        }),
        onSelect: onSelect,
        shortcut: shortcut,
        title: title
    });
};


const $c721b9da47bf349d$var$headingItems = [
    {
        item: (0, $dCkbP.HEADING_1_MENU_ITEM),
        level: 1
    },
    {
        item: (0, $dCkbP.HEADING_2_MENU_ITEM),
        level: 2
    },
    {
        item: (0, $dCkbP.HEADING_3_MENU_ITEM),
        level: 3
    },
    {
        item: (0, $dCkbP.HEADING_4_MENU_ITEM),
        level: 4
    },
    {
        item: (0, $dCkbP.HEADING_5_MENU_ITEM),
        level: 5
    },
    {
        item: (0, $dCkbP.HEADING_6_MENU_ITEM),
        level: 6
    }
];
const $c721b9da47bf349d$var$getParent = (key)=>[
        {
            key: (0, $dCkbP.TEXT_FORMATTING_SECTION).key,
            type: (0, $dCkbP.TEXT_FORMATTING_SECTION).type,
            rank: (0, $dXqu3.TEXT_FORMATTING_SECTION_RANK)[key]
        }
    ];
const $c721b9da47bf349d$export$49ff46ca659b7c4a = ({ api: api, exclude: exclude })=>[
        ...$c721b9da47bf349d$var$headingItems.filter(()=>!exclude.includes('heading')).map(({ item: item, level: headingLevel })=>{
            const headingMessages = (0, $abd3656af47cd07f$export$7913e5ec6aa6212c)(headingLevel);
            return {
                key: item.key,
                type: item.type,
                parents: $c721b9da47bf349d$var$getParent(item.key),
                match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                        description: formatMessage(headingMessages.description),
                        keywords: [
                            `h${headingLevel}`
                        ],
                        shortcut: (0, $abd3656af47cd07f$export$c99ec4513008fe69)(headingLevel),
                        title: formatMessage(headingMessages.title)
                    })),
                component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $abd3656af47cd07f$export$e0f203c8396bac7c), {
                        api: api,
                        item: headingLevel
                    })
            };
        }),
        ...!exclude.includes('blockquote') ? [
            {
                key: (0, $dCkbP.BLOCKQUOTE_MENU_ITEM).key,
                type: (0, $dCkbP.BLOCKQUOTE_MENU_ITEM).type,
                parents: $c721b9da47bf349d$var$getParent((0, $dCkbP.BLOCKQUOTE_MENU_ITEM).key),
                match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                        description: formatMessage((0, $5HBT9.messages).blockquoteDescription),
                        shortcut: '>',
                        title: formatMessage((0, $5HBT9.messages).blockquote)
                    })),
                component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $abd3656af47cd07f$export$e0f203c8396bac7c), {
                        api: api,
                        item: "blockquote"
                    })
            }
        ] : []
    ];


const $9ce0723cae7526c2$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $5HBT9.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $ldqjS.tooltip)((0, $eBSR7.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $5HBT9.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).FORMATTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $9ce0723cae7526c2$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $5HBT9.messages).blockquote),
            description: formatMessage((0, $5HBT9.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconQuote), {}),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).FORMATTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $9ce0723cae7526c2$export$896c3d927d705025 = ({ config: options, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, $6OREF.ToolbarSize).XXL : toolbarSize < (0, $6OREF.ToolbarSize).XL;
        if ((0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, $6OREF.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $93a4127a7d8d544b$export$94516d5cccf573e3), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $079671e442bdef18$export$a758406ca53b86a5)(api, options?.allowFontSize));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'blockType',
        component: primaryToolbarComponent
    });
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents((0, $2deeccc10ece8c1c$export$325b6b890260a604)(api));
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $c721b9da47bf349d$export$49ff46ca659b7c4a)({
        api: api,
        exclude: options?.allowBlockType?.exclude ?? []
    }));
    return {
        name: 'blockType',
        nodes () {
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $3RygG.heading)
                },
                {
                    name: 'blockquote',
                    node: (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $9oc8s.extendedBlockquoteWithLocalId) : (0, $9oc8s.extendedBlockquote)
                },
                {
                    name: 'hardBreak',
                    node: (0, $ioLmC.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        marks () {
            if (options?.allowFontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return [
                {
                    name: 'fontSize',
                    mark: (0, $4Fod8.fontSize)
                }
            ];
            return [];
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>(0, $fc8ae5254b8d9ad5$export$ae829ec7b2625219)(api, dispatch, options && options.lastNodeMustBeParagraph, options?.includeBlockQuoteAsTextstyleOption, options?.allowFontSize)
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $7a3e6e706ea3c1d3$export$2e2bcd8739ae039)(api?.analytics?.actions, schema, featureFlags)
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $d74877df9942ab3e$export$2e2bcd8739ae039)(api?.analytics?.actions, schema, featureFlags)
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                return (0, $9c4268662dffbdb9$export$50b4331f407b3ab6)(inputMethod, api?.analytics?.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod, fromBlockQuote = false) {
                return (0, $9c4268662dffbdb9$export$3f9af78ebb95cc20)(level, inputMethod, api?.analytics?.actions, fromBlockQuote);
            },
            insertBlockQuote (inputMethod) {
                return (0, $9c4268662dffbdb9$export$f5e16b3b6b62d83)(inputMethod, api?.analytics?.actions);
            },
            clearFormatting (inputMethod) {
                return (0, $9c4268662dffbdb9$export$195de5d8e201efd7)(inputMethod, api?.analytics?.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $fc8ae5254b8d9ad5$export$18d4026d1ea86bb1).getState(editorState);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: ()=>{
                    const toolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view, _idx, _dispatchAnalyticsEvent)=>{
                                if (!view) return;
                                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d7b550d0f6bfd9f4$export$b15abb95157a91c7), {
                                    api: api
                                });
                            },
                            fallback: []
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ],
                            rank: 8
                        };
                    } else return undefined;
                }
            },
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: (intl)=>{
                    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return [
                        ...$9ce0723cae7526c2$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                        ...$9ce0723cae7526c2$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                    ];
                }
            }
        }
    };
};
module.exports["blockTypePlugin"] = $9ce0723cae7526c2$export$896c3d927d705025;

});

parcelRegister("jGK9e", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


const $ddf615dd8f9f1880$export$e40fe94b4cff8ec5 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "5IpRi",
    name: "IconAction",
    loader: ()=>(parcelRequire("1GD4z")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$e332a83b9159d69d = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ru1gk",
    name: "IconCode",
    loader: ()=>(parcelRequire("jkzRS")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$39617668a6028b06 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "v8J9P",
    name: "IconDate",
    loader: ()=>(parcelRequire("clVJ8")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$6eb71591d1461541 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "hRamb",
    name: "IconDecision",
    loader: ()=>(parcelRequire("ahW1J")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$f2ab17920c9d243 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "tltrl",
    name: "IconDivider",
    loader: ()=>(parcelRequire("hXE11")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$8bd591d4b34dcafa = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Erkg9",
    name: "IconEmoji",
    loader: ()=>(parcelRequire("glw62")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$c17cf1164355efc2 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "XfrX5",
    name: "IconImages",
    loader: ()=>(parcelRequire("87jzw")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$fba0c846789a9d87 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "WFuTK",
    name: "IconLayout",
    loader: ()=>(parcelRequire("duJiy")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$23da1e9f164f7ea1 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "gbpgO",
    name: "IconLink",
    loader: ()=>(parcelRequire("bPGRz")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$32f6affcc5f19c17 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "YMJ_i",
    name: "IconListNumber",
    loader: ()=>(parcelRequire("6MgIO")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$527d32aa1785fdd4 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "fOk38",
    name: "IconList",
    loader: ()=>(parcelRequire("cFKCr")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$de1d1a07ff53cf53 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7uj_h",
    name: "IconMention",
    loader: ()=>(parcelRequire("lFTj0")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$a1c6b14f5f0a0c20 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Cs6_K",
    name: "IconPanelError",
    loader: ()=>(parcelRequire("2WQgv")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$4d90d09f9e3039e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "hzniQ",
    name: "IconPanelNote",
    loader: ()=>(parcelRequire("74InO")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$cc5c1cc765c068a0 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "miuZY",
    name: "IconPanelSuccess",
    loader: ()=>(parcelRequire("883PY")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$e728578e48814100 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QZPBB",
    name: "IconPanelWarning",
    loader: ()=>(parcelRequire("2CRQt")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$18978208c8652af3 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "F1uzJ",
    name: "IconPanel",
    loader: ()=>(parcelRequire("9Dw90")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$2478ed0e296e2752 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f_9Lp",
    name: "IconQuote",
    loader: ()=>(parcelRequire("k3yjV")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$4635bc8225f90ec6 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "dMybO",
    name: "IconStatus",
    loader: ()=>(parcelRequire("6ZE21")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$8f1e9e900568bfce = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "1onub",
    name: "IconOneColumnLayout",
    loader: ()=>(parcelRequire("4Tci9")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$732a7fc4975ab5a4 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "6-NfL",
    name: "IconTwoColumnLayout",
    loader: ()=>(parcelRequire("jy2gq")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$fdfaf73f45072edb = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "O0AJE",
    name: "IconThreeColumnLayout",
    loader: ()=>(parcelRequire("4S5Jk")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$a1588f873a973762 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "VvfLh",
    name: "IconFourColumnLayout",
    loader: ()=>(parcelRequire("9ZQsT")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$ff1f32987b4c27d9 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "pum24",
    name: "IconFiveColumnLayout",
    loader: ()=>(parcelRequire("4cdYx")).then((module)=>module.default),
    loading: ()=>null
});






function $ddf615dd8f9f1880$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("7qa76"));
        case 2:
            return (parcelRequire("5ThJW"));
        case 3:
            return (parcelRequire("4pwKu"));
        case 4:
            return (parcelRequire("lBdRh"));
        case 5:
            return (parcelRequire("454uX"));
        case 6:
        default:
            return (parcelRequire("bncay"));
    }
}
const $ddf615dd8f9f1880$export$1a33a10ac24d7971 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { level: level, label: label } = t0;
    let t1;
    if ($[0] !== level) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
            __loadable_id__: "v7jN2",
            name: "platform.packages.editor.editor-common.src.quick-insert.assets.index",
            loader: ()=>$ddf615dd8f9f1880$var$importHeading(level).then($ddf615dd8f9f1880$var$_temp),
            loading: $ddf615dd8f9f1880$var$_temp2
        });
        $[0] = level;
        $[1] = t1;
    } else t1 = $[1];
    const Icon = t1;
    let t2;
    if ($[2] !== Icon || $[3] !== label) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label
        });
        $[2] = Icon;
        $[3] = label;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ level: level, label: label })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "DCCGQ",
        name: "Icon",
        loader: ()=>$ddf615dd8f9f1880$var$importHeading(level).then((module)=>module.default),
        loading: ()=>null
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
        label: label
    });
};

const $ddf615dd8f9f1880$export$e25449dcffb445e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "fnF2w",
    name: "IconFeedback",
    loader: ()=>(parcelRequire("fBHz9")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$209d03a445a7dc8e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "sGpBl",
    name: "IconExpand",
    loader: ()=>(parcelRequire("5UgHD")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$c9b1dcefa7c9a7aa = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "RIvxZ",
    name: "IconDatasourceJiraIssue",
    loader: ()=>(parcelRequire("iG0xf")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$7d6f860161da0fa6 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "mJ_ZJ",
    name: "IconDatasourceAssetsObjects",
    loader: ()=>(parcelRequire("g3igB")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$29a810fd0b8c3f03 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ib_id",
    name: "IconDatasourceConfluenceSearch",
    loader: ()=>(parcelRequire("eqaBH")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$ccbb24eed51aea20 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QB-q-",
    name: "IconLoom",
    loader: ()=>(parcelRequire("8GyMD")).then((module)=>module.default),
    loading: ()=>null
});

const $ddf615dd8f9f1880$export$4dc65faf2ef9e446 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "XCScQ",
    name: "IconSyncBlock",
    loader: ()=>(parcelRequire("kiEE9")).then((module)=>module.default),
    loading: ()=>null
});
function $ddf615dd8f9f1880$var$_temp(module) {
    return module.default;
}
function $ddf615dd8f9f1880$var$_temp2() {
    return null;
}
module.exports["IconAction"] = $ddf615dd8f9f1880$export$e40fe94b4cff8ec5;
module.exports["IconCode"] = $ddf615dd8f9f1880$export$e332a83b9159d69d;
module.exports["IconDate"] = $ddf615dd8f9f1880$export$39617668a6028b06;
module.exports["IconDecision"] = $ddf615dd8f9f1880$export$6eb71591d1461541;
module.exports["IconDivider"] = $ddf615dd8f9f1880$export$f2ab17920c9d243;
module.exports["IconEmoji"] = $ddf615dd8f9f1880$export$8bd591d4b34dcafa;
module.exports["IconImages"] = $ddf615dd8f9f1880$export$c17cf1164355efc2;
module.exports["IconLayout"] = $ddf615dd8f9f1880$export$fba0c846789a9d87;
module.exports["IconLink"] = $ddf615dd8f9f1880$export$23da1e9f164f7ea1;
module.exports["IconListNumber"] = $ddf615dd8f9f1880$export$32f6affcc5f19c17;
module.exports["IconList"] = $ddf615dd8f9f1880$export$527d32aa1785fdd4;
module.exports["IconMention"] = $ddf615dd8f9f1880$export$de1d1a07ff53cf53;
module.exports["IconPanelError"] = $ddf615dd8f9f1880$export$a1c6b14f5f0a0c20;
module.exports["IconPanelNote"] = $ddf615dd8f9f1880$export$4d90d09f9e3039e;
module.exports["IconPanelSuccess"] = $ddf615dd8f9f1880$export$cc5c1cc765c068a0;
module.exports["IconPanelWarning"] = $ddf615dd8f9f1880$export$e728578e48814100;
module.exports["IconPanel"] = $ddf615dd8f9f1880$export$18978208c8652af3;
module.exports["IconQuote"] = $ddf615dd8f9f1880$export$2478ed0e296e2752;
module.exports["IconStatus"] = $ddf615dd8f9f1880$export$4635bc8225f90ec6;
module.exports["IconOneColumnLayout"] = $ddf615dd8f9f1880$export$8f1e9e900568bfce;
module.exports["IconTwoColumnLayout"] = $ddf615dd8f9f1880$export$732a7fc4975ab5a4;
module.exports["IconThreeColumnLayout"] = $ddf615dd8f9f1880$export$fdfaf73f45072edb;
module.exports["IconFourColumnLayout"] = $ddf615dd8f9f1880$export$a1588f873a973762;
module.exports["IconFiveColumnLayout"] = $ddf615dd8f9f1880$export$ff1f32987b4c27d9;
module.exports["IconHeading"] = $ddf615dd8f9f1880$export$1a33a10ac24d7971;
module.exports["IconFeedback"] = $ddf615dd8f9f1880$export$e25449dcffb445e;
module.exports["IconExpand"] = $ddf615dd8f9f1880$export$209d03a445a7dc8e;
module.exports["IconDatasourceJiraIssue"] = $ddf615dd8f9f1880$export$c9b1dcefa7c9a7aa;
module.exports["IconDatasourceAssetsObjects"] = $ddf615dd8f9f1880$export$7d6f860161da0fa6;
module.exports["IconDatasourceConfluenceSearch"] = $ddf615dd8f9f1880$export$29a810fd0b8c3f03;
module.exports["IconSyncBlock"] = $ddf615dd8f9f1880$export$4dc65faf2ef9e446;

});

parcelRegister("1GD4z", function(module, exports) {

let $13a805b40c0d49ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13a805b40c0d49ff$var$load("K8Avq").then(()=>parcelRequire('kzn2g'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("jkzRS", function(module, exports) {

let $e12bb53745fb86f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e12bb53745fb86f3$var$load("9d3f0").then(()=>parcelRequire('fjySd'));

});

parcelRegister("clVJ8", function(module, exports) {

let $8fe439931f26d4bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8fe439931f26d4bc$var$load("87vaA").then(()=>parcelRequire('9eroF'));

});

parcelRegister("ahW1J", function(module, exports) {

let $77d880e049052b80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77d880e049052b80$var$load("bLd1q").then(()=>parcelRequire('98Dfr'));

});

parcelRegister("hXE11", function(module, exports) {

let $d136fc98a77d1ed4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d136fc98a77d1ed4$var$load("k0uGl").then(()=>parcelRequire('74IXk'));

});

parcelRegister("glw62", function(module, exports) {

let $be678131ff418a99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be678131ff418a99$var$load("20PPI").then(()=>parcelRequire('kIUVI'));

});

parcelRegister("87jzw", function(module, exports) {

let $5e8e28bbd04b031b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e8e28bbd04b031b$var$load("jVtcO").then(()=>parcelRequire('hn5nG'));

});

parcelRegister("duJiy", function(module, exports) {

let $9d3136fc55047c6c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d3136fc55047c6c$var$load("hCko4").then(()=>parcelRequire('fGchh'));

});

parcelRegister("bPGRz", function(module, exports) {

let $89d5b4d59da4d9b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89d5b4d59da4d9b9$var$load("cl3XX").then(()=>parcelRequire('7VHe5'));

});

parcelRegister("6MgIO", function(module, exports) {

let $4ef43263060a03e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ef43263060a03e8$var$load("68qky").then(()=>parcelRequire('7HToJ'));

});

parcelRegister("cFKCr", function(module, exports) {

let $939d79f47b53772d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $939d79f47b53772d$var$load("4OLUq").then(()=>parcelRequire('d7aaW'));

});

parcelRegister("lFTj0", function(module, exports) {

let $fc7853d2d1eba721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fc7853d2d1eba721$var$load("2LXU8").then(()=>parcelRequire('lTwpa'));

});

parcelRegister("2WQgv", function(module, exports) {

let $22598a5c286c254b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22598a5c286c254b$var$load("earBt").then(()=>parcelRequire('8eZwx'));

});

parcelRegister("74InO", function(module, exports) {

let $526b55a74c703a53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $526b55a74c703a53$var$load("77tKS").then(()=>parcelRequire('cvzVB'));

});

parcelRegister("883PY", function(module, exports) {

let $5eb20c166ddc0569$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5eb20c166ddc0569$var$load("7lTl6").then(()=>parcelRequire('lAyF9'));

});

parcelRegister("2CRQt", function(module, exports) {

let $1e98e5f62c30c23c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e98e5f62c30c23c$var$load("13lHn").then(()=>parcelRequire('a3uvX'));

});

parcelRegister("9Dw90", function(module, exports) {

let $7040b0bb518a152f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7040b0bb518a152f$var$load("dBtRT").then(()=>parcelRequire('dGya8'));

});

parcelRegister("k3yjV", function(module, exports) {

let $e99eb5c2c58fbeb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e99eb5c2c58fbeb5$var$load("Kyc23").then(()=>parcelRequire('eAn8N'));

});

parcelRegister("6ZE21", function(module, exports) {

let $015061002905c39a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $015061002905c39a$var$load("hoCWi").then(()=>parcelRequire('eZEBq'));

});

parcelRegister("4Tci9", function(module, exports) {

let $38f5d55ac1725ad7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38f5d55ac1725ad7$var$load("5gPcI").then(()=>parcelRequire('dv7PX'));

});

parcelRegister("jy2gq", function(module, exports) {

let $e3b2f2e3a382bdc4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3b2f2e3a382bdc4$var$load("kaob5").then(()=>parcelRequire('6XSw3'));

});

parcelRegister("4S5Jk", function(module, exports) {

let $38c0a677c0d9cc90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38c0a677c0d9cc90$var$load("j0ea4").then(()=>parcelRequire('86c11'));

});

parcelRegister("9ZQsT", function(module, exports) {

let $7472820a4baaa337$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7472820a4baaa337$var$load("6ij8c").then(()=>parcelRequire('6vsoH'));

});

parcelRegister("4cdYx", function(module, exports) {

let $30e31fa32befccfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30e31fa32befccfe$var$load("2MKCq").then(()=>parcelRequire('8fTXq'));

});

parcelRegister("7qa76", function(module, exports) {

let $5672ce75c640472d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5672ce75c640472d$var$load("5CMgk").then(()=>parcelRequire('lMyP8'));

});

parcelRegister("5ThJW", function(module, exports) {

let $449fd993d783000a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $449fd993d783000a$var$load("ianrs").then(()=>parcelRequire('ghUVA'));

});

parcelRegister("4pwKu", function(module, exports) {

let $3362e6721189fae3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3362e6721189fae3$var$load("1yaBg").then(()=>parcelRequire('g0KFE'));

});

parcelRegister("lBdRh", function(module, exports) {

let $fb97cda214066824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb97cda214066824$var$load("4x1iC").then(()=>parcelRequire('6RjQV'));

});

parcelRegister("454uX", function(module, exports) {

let $2f8b1e513d1926f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f8b1e513d1926f6$var$load("drTFo").then(()=>parcelRequire('cjxHZ'));

});

parcelRegister("bncay", function(module, exports) {

let $847b484351fd4a27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $847b484351fd4a27$var$load("Ggk7F").then(()=>parcelRequire('3kgAw'));

});

parcelRegister("fBHz9", function(module, exports) {

let $b5cc1b01d3a9c0c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5cc1b01d3a9c0c4$var$load("4Ocin").then(()=>parcelRequire('hVPyg'));

});

parcelRegister("5UgHD", function(module, exports) {

let $44cf238648a0ceba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44cf238648a0ceba$var$load("jexg6").then(()=>parcelRequire('jk60P'));

});

parcelRegister("iG0xf", function(module, exports) {

let $d98c908a5f16f3c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d98c908a5f16f3c6$var$load("39nXZ").then(()=>parcelRequire('kvaZt'));

});

parcelRegister("g3igB", function(module, exports) {

let $bafb18922757f3ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bafb18922757f3ad$var$load("bb3ox").then(()=>parcelRequire('jUJ0q'));

});

parcelRegister("eqaBH", function(module, exports) {

let $a7fbb8bcb27df1ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7fbb8bcb27df1ff$var$load("hsUoD").then(()=>parcelRequire('1EGgD'));

});

parcelRegister("8GyMD", function(module, exports) {

let $652d3a383b19282a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $652d3a383b19282a$var$load("45EIx").then(()=>parcelRequire('lFitI'));

});

parcelRegister("kiEE9", function(module, exports) {

let $ec7504a85e7307b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec7504a85e7307b4$var$load("6O0j5").then(()=>parcelRequire('dtbyQ'));

});

parcelRegister("hVLmg", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3nacY = parcelRequire("3nacY");

const $ad186fb917e4c48f$export$bc7b81cc80d86c30 = {
    [(0, $3nacY.AI_SECTION).key]: 100,
    [(0, $3nacY.AI_VIEW_SECTION).key]: 100,
    [(0, $3nacY.TEXT_SECTION).key]: 200,
    /* Same rank as TEXT_SECTION as only one is ever shown at a time */ [(0, $3nacY.TEXT_SECTION_COLLAPSED).key]: 200,
    [(0, $3nacY.INSERT_BLOCK_SECTION).key]: 300,
    [(0, $3nacY.LINKING_SECTION).key]: 400,
    [(0, $3nacY.COLLAB_SECTION).key]: 500,
    [(0, $3nacY.APPS_SECTION).key]: 600,
    [(0, $3nacY.TRACK_CHANGES_SECTION).key]: 700,
    [(0, $3nacY.OVERFLOW_SECTION).key]: 800,
    [(0, $3nacY.PIN_SECTION).key]: 900,
    /* Sits between PIN (900) and OVERFLOW_SECTION_PRIMARY_TOOLBAR (1000)
   * so the markdown view-mode toggle renders to the right of all formatting
   * controls but still to the left of the overflow `…` menu. */ [(0, $3nacY.VIEW_MODE_TOGGLE_SECTION).key]: 950,
    [(0, $3nacY.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key]: 1000
};
const $ad186fb917e4c48f$export$466bb91cec477703 = {
    [(0, $3nacY.ROVO_GROUP).key]: 100,
    [(0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key]: 100,
    [(0, $3nacY.ROVO_GROUP_PRIMARY_TOOLBAR).key]: 100,
    [(0, $3nacY.DEFINE_GROUP).key]: 200,
    [(0, $3nacY.IMPROVE_WRITING_GROUP).key]: 300,
    [(0, $3nacY.AI_SUGGESTIONS_GROUP).key]: 400,
    [(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key]: 500
};
const $ad186fb917e4c48f$export$7f767b9830d79831 = {
    [(0, $3nacY.AI_SUGGESTIONS_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$ff4863cfaec82192 = {
    [(0, $3nacY.ROVO_HERO_BUTTON).key]: 100,
    [(0, $3nacY.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key]: 100,
    [(0, $3nacY.ROVO_MENU).key]: 200
};
const $ad186fb917e4c48f$export$bc7ded9825806f2 = {
    [(0, $3nacY.ROVO_HERO_BUTTON).key]: 100,
    [(0, $3nacY.ROVO_MENU_DISPLAY_SMALL).key]: 200,
    [(0, $3nacY.HERO_PROMPT_BUTTON).key]: 300,
    [(0, $3nacY.AI_SUGGESTIONS_BUTTON).key]: 400
};
const $ad186fb917e4c48f$export$322be3308b7fba35 = {
    [(0, $3nacY.DEFINE_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$6f336126efb2136d = {
    [(0, $3nacY.IMPROVE_WRITING_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$5eed3dfe1bf849e5 = {
    [(0, $3nacY.HERO_PROMPT_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$dd95f65f4139e5c7 = {
    [(0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key]: 100,
    [(0, $3nacY.ROVO_PROMPT_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$bfac571871e409b2 = {
    [(0, $3nacY.IMPROVE_WRITING_MENU_ITEM).key]: 100,
    [(0, $3nacY.HERO_PROMPT_MENU_ITEM).key]: 100,
    [(0, $3nacY.ADD_POLISH_MENU_ITEM).key]: 100,
    [(0, $3nacY.SPELLING_AND_GRAMMAR_MENU_ITEM).key]: 300,
    [(0, $3nacY.CHANGE_TONE_NESTED_MENU).key]: 400,
    [(0, $3nacY.MAKE_SHORTER_MENU_ITEM).key]: 500,
    [(0, $3nacY.MAKE_LONGER_MENU_ITEM).key]: 600,
    [(0, $3nacY.TRANSLATE_NESTED_MENU).key]: 700,
    [(0, $3nacY.DEFINE_MENU_ITEM).key]: 800
};
const $ad186fb917e4c48f$export$e63f50c00e536f07 = {
    [(0, $3nacY.CHANGE_TONE_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$b55028e61899c679 = {
    [(0, $3nacY.MORE_PROFESSIONAL_MENU_ITEM).key]: 100,
    [(0, $3nacY.MORE_CASUAL_MENU_ITEM).key]: 200,
    [(0, $3nacY.MORE_EMPATHETIC_MENU_ITEM).key]: 300
};
const $ad186fb917e4c48f$export$6f11aef2061f527c = {
    [(0, $3nacY.TRANSLATE_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$6784d5340d4a1b21 = {
    [(0, $3nacY.TEXT_STYLES_GROUP).key]: 100,
    [(0, $3nacY.TEXT_FORMATTING_GROUP).key]: 200,
    [(0, $3nacY.LISTS_INDENTATION_GROUP).key]: 300,
    [(0, $3nacY.ALIGNMENT_GROUP).key]: 400,
    [(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 500
};
const $ad186fb917e4c48f$export$a3445a42840bc6d9 = {
    [(0, $3nacY.TEXT_STYLES_GROUP).key]: 100,
    [(0, $3nacY.BOLD_BUTTON_GROUP).key]: 200,
    [(0, $3nacY.UNDERLINE_BUTTON_GROUP).key]: 300,
    [(0, $3nacY.TEXT_FORMATTING_GROUP).key]: 400,
    [(0, $3nacY.BULLETED_LIST_BUTTON_GROUP).key]: 500,
    [(0, $3nacY.LISTS_INDENTATION_GROUP).key]: 600,
    [(0, $3nacY.ALIGNMENT_GROUP).key]: 700,
    [(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 800
};
const $ad186fb917e4c48f$export$b3332537c956e2f5 = {
    [(0, $3nacY.TEXT_COLLAPSED_GROUP).key]: 100
};
const $ad186fb917e4c48f$export$d0c8ffa085b6d177 = {
    [(0, $3nacY.TEXT_COLLAPSED_MENU).key]: 100
};
const $ad186fb917e4c48f$export$d5a685ed621e9024 = {
    [(0, $3nacY.TEXT_STYLES_MENU_SECTION).key]: 100,
    [(0, $3nacY.TEXT_FORMATTING_MENU_SECTION).key]: 200,
    [(0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).key]: 300,
    [(0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key]: 400,
    [(0, $3nacY.ALIGNMENT_MENU_SECTION).key]: 500,
    [(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 600
};
const $ad186fb917e4c48f$export$26a9865aa120e992 = {
    [(0, $3nacY.TEXT_STYLES_MENU).key]: 100
};
const $ad186fb917e4c48f$export$51921362eebd85ab = {
    [(0, $3nacY.TEXT_STYLES_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$6449a65588a19d38 = {
    [(0, $3nacY.NORMAL_TEXT_MENU_ITEM).key]: 100,
    [(0, $3nacY.SMALL_TEXT_MENU_ITEM).key]: 150,
    [(0, $3nacY.HEADING_1_MENU_ITEM).key]: 200,
    [(0, $3nacY.HEADING_2_MENU_ITEM).key]: 300,
    [(0, $3nacY.HEADING_3_MENU_ITEM).key]: 400,
    [(0, $3nacY.HEADING_4_MENU_ITEM).key]: 500,
    [(0, $3nacY.HEADING_5_MENU_ITEM).key]: 600,
    [(0, $3nacY.HEADING_6_MENU_ITEM).key]: 700,
    [(0, $3nacY.BLOCK_QUOTE_MENU_ITEM).key]: 800
};
const $ad186fb917e4c48f$export$9cdaceac32c6b4d8 = {
    [(0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).key]: 100,
    [(0, $3nacY.TEXT_FORMATTING_MENU).key]: 200
};
const $ad186fb917e4c48f$export$6d00774ee584bc52 = {
    [(0, $3nacY.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $3nacY.TEXT_FORMATTING_MENU).key]: 200
};
const $ad186fb917e4c48f$export$669a394c241c9256 = {
    [(0, $3nacY.TEXT_FORMATTING_MENU_SECTION).key]: 100,
    [(0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).key]: 200
};
const $ad186fb917e4c48f$export$20900530b02fcff9 = {
    [(0, $3nacY.BOLD_MENU_ITEM).key]: 100,
    [(0, $3nacY.ITALIC_MENU_ITEM).key]: 200,
    [(0, $3nacY.UNDERLINE_MENU_ITEM).key]: 300,
    [(0, $3nacY.STRIKE_MENU_ITEM).key]: 400,
    [(0, $3nacY.CODE_MENU_ITEM).key]: 500,
    [(0, $3nacY.SUBSCRIPT_MENU_ITEM).key]: 600,
    [(0, $3nacY.SUPERSCRIPT_MENU_ITEM).key]: 700
};
const $ad186fb917e4c48f$export$b62a699881de3ad5 = {
    [(0, $3nacY.CLEAR_FORMATTING_MENU_ITEM).key]: 100
};
const $ad186fb917e4c48f$export$f2dba222dee1738d = {
    [(0, $3nacY.SYNCED_BLOCK_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$bbc17a51edaecf5e = {
    [(0, $3nacY.BULLETED_LIST_BUTTON).key]: 100,
    [(0, $3nacY.LISTS_INDENTATION_HERO_BUTTON).key]: 200,
    [(0, $3nacY.LISTS_INDENTATION_MENU).key]: 300
};
const $ad186fb917e4c48f$export$c57e1bc67b28ed16 = {
    [(0, $3nacY.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $3nacY.LISTS_INDENTATION_MENU).key]: 200
};
const $ad186fb917e4c48f$export$29d19572f6bf97d3 = {
    [(0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$70af84b45a4dbc54 = {
    [(0, $3nacY.BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $3nacY.NUMBERED_LIST_MENU_ITEM).key]: 200,
    [(0, $3nacY.TASK_LIST_MENU_ITEM).key]: 300,
    [(0, $3nacY.OUTDENT_MENU_ITEM).key]: 400,
    [(0, $3nacY.INDENT_MENU_ITEM).key]: 500
};
const $ad186fb917e4c48f$export$f2b3800989381ab8 = {
    [(0, $3nacY.ALIGNMENT_MENU).key]: 100
};
const $ad186fb917e4c48f$export$50e3ab1607836660 = {
    [(0, $3nacY.ALIGNMENT_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$fe18fd9800ea0b78 = {
    [(0, $3nacY.ALIGN_LEFT_MENU_ITEM).key]: 100,
    [(0, $3nacY.ALIGN_CENTER_MENU_ITEM).key]: 200,
    [(0, $3nacY.ALIGN_RIGHT_MENU_ITEM).key]: 300
};
const $ad186fb917e4c48f$export$ae4377fbd160eba4 = {
    [(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU).key]: 100
};
const $ad186fb917e4c48f$export$7aebf1f83f92aec4 = {
    [(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$6d61bddc04226fae = {
    [(0, $3nacY.TEXT_COLOR_MENU_ITEM).key]: 100,
    [(0, $3nacY.HIGHLIGHT_MENU_ITEM).key]: 200,
    [(0, $3nacY.CLEAR_COLOR_MENU_ITEM).key]: 300,
    [(0, $3nacY.COLOR_ACCESSIBILITY_MENU_ITEM).key]: 400
};
const $ad186fb917e4c48f$export$d501e2da4fccd3d9 = {
    [(0, $3nacY.TASK_LIST_GROUP).key]: 100,
    [(0, $3nacY.MEDIA_GROUP).key]: 200,
    [(0, $3nacY.CODE_BLOCK_GROUP).key]: 300,
    [(0, $3nacY.MENTION_GROUP).key]: 400,
    [(0, $3nacY.EMOJI_GROUP).key]: 500,
    [(0, $3nacY.LAYOUT_GROUP).key]: 600,
    [(0, $3nacY.SYNCED_BLOCK_GROUP).key]: 700,
    [(0, $3nacY.TABLE_GROUP).key]: 800,
    [(0, $3nacY.INSERT_GROUP).key]: 900
};
const $ad186fb917e4c48f$export$ca5c9182c556b0ba = {
    [(0, $3nacY.TASK_LIST_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$41b6a2bde3ffc16c = {
    [(0, $3nacY.MEDIA_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$2e369b4fbf595d64 = {
    [(0, $3nacY.CODE_BLOCK_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$9834991fe1fe77a = {
    [(0, $3nacY.MENTION_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$5e431f0b402bc573 = {
    [(0, $3nacY.EMOJI_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$18725f40b7ed45c9 = {
    [(0, $3nacY.LAYOUT_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$3b68d352d79ba4dc = {
    [(0, $3nacY.TABLE_BUTTON).key]: 100,
    [(0, $3nacY.TABLE_SIZE_PICKER).key]: 200
};
const $ad186fb917e4c48f$export$6b93bebdb0c4f64b = {
    [(0, $3nacY.INSERT_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$c7c28a2a4f553552 = {
    [(0, $3nacY.LINKING_GROUP).key]: 100
};
const $ad186fb917e4c48f$export$400d2c257bc9421e = {
    [(0, $3nacY.LINKING_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$efde8251fb2b89d5 = {
    [(0, $3nacY.COMMENT_GROUP).key]: 100
};
const $ad186fb917e4c48f$export$4f59ebca6ea8293b = {
    [(0, $3nacY.COMMENT_HERO_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$6795fbb63d664162 = {
    [(0, $3nacY.UNDO_CHANGES_GROUP).key]: 100,
    [(0, $3nacY.REDO_CHANGES_GROUP).key]: 200,
    [(0, $3nacY.TRACK_CHANGES_GROUP).key]: 300
};
const $ad186fb917e4c48f$export$8b9f9ebddc5f6d72 = {
    [(0, $3nacY.UNDO_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$faf3ae5c01b97598 = {
    [(0, $3nacY.REDO_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$e9551bb6af82297a = {
    [(0, $3nacY.TRACK_CHANGES_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$d63a7078a6c0dc57 = {
    [(0, $3nacY.OVERFLOW_GROUP).key]: 100
};
const $ad186fb917e4c48f$export$7aecad5ed6bcab55 = {
    [(0, $3nacY.OVERFLOW_MENU).key]: 100
};
const $ad186fb917e4c48f$export$ea9c3eff8619984 = {
    [(0, $3nacY.PIN_MENU_SECTION).key]: 100,
    [(0, $3nacY.LOOM_MENU_SECTION).key]: 200,
    [(0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key]: 300,
    [(0, $3nacY.SELECTION_EXTENSION_MENU_SECTION).key]: 300,
    [(0, $3nacY.SYNCED_BLOCK_SECTION).key]: 400
};
const $ad186fb917e4c48f$export$510811eb0f5e0b21 = {
    [(0, $3nacY.PIN_MENU_ITEM).key]: 100
};
const $ad186fb917e4c48f$export$6184a38ba6130c9c = {
    [(0, $3nacY.LOOM_MENU_ITEM).key]: 100,
    [(0, $3nacY.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key]: 200,
    [(0, $3nacY.EXTERNAL_EXTENSIONS_MENU_ITEM).key]: 300
};
const $ad186fb917e4c48f$export$3bdd20aa1e9eee2 = {
    [(0, $3nacY.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key]: 100
};
const $ad186fb917e4c48f$export$dc811b512e84a8a4 = {
    [(0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).key]: 100
};
const $ad186fb917e4c48f$export$9cc8eee968218e62 = {
    [(0, $3nacY.LOOM_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$58a4b339bb5abbc1 = {
    [(0, $3nacY.PIN_GROUP).key]: 100
};
const $ad186fb917e4c48f$export$cb4d99d2936acb14 = {
    [(0, $3nacY.PIN_BUTTON).key]: 100
};
const $ad186fb917e4c48f$export$d27db3643df90b4d = {
    [(0, $3nacY.LOOM_MENU_ITEM).key]: 100
};
const $ad186fb917e4c48f$export$a766c0ef72fbd3e1 = {
    [(0, $3nacY.AI_PASTE_MENU_SECTION).key]: 50,
    [(0, $3nacY.PASTE_MENU_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$1e88c7dcdd9c7430 = {
    [(0, $3nacY.PASTE_NESTED_MENU).key]: 100
};
const $ad186fb917e4c48f$export$c200baaef3fcc623 = {
    [(0, $3nacY.PASTE_MENU_NESTED_SECTION).key]: 100
};
const $ad186fb917e4c48f$export$8afb46bea363e001 = {
    [(0, $3nacY.PASTE_RICH_TEXT_MENU_ITEM).key]: 100,
    [(0, $3nacY.PASTE_MARKDOWN_MENU_ITEM).key]: 200,
    [(0, $3nacY.PASTE_PLAIN_TEXT_MENU_ITEM).key]: 300
};
module.exports["TOOLBAR_RANK"] = $ad186fb917e4c48f$export$bc7b81cc80d86c30;
module.exports["AI_SECTION_RANK"] = $ad186fb917e4c48f$export$466bb91cec477703;
module.exports["AI_SUGGESTIONS_GROUP_RANK"] = $ad186fb917e4c48f$export$7f767b9830d79831;
module.exports["ROVO_GROUP_RANK"] = $ad186fb917e4c48f$export$ff4863cfaec82192;
module.exports["ROVO_GROUP_DISPLAY_SMALL_RANK"] = $ad186fb917e4c48f$export$bc7ded9825806f2;
module.exports["DEFINE_GROUP_RANK"] = $ad186fb917e4c48f$export$322be3308b7fba35;
module.exports["IMPROVE_WRITING_GROUP_RANK"] = $ad186fb917e4c48f$export$6f336126efb2136d;
module.exports["HERO_PROMPT_BUTTON_GROUP_RANK"] = $ad186fb917e4c48f$export$5eed3dfe1bf849e5;
module.exports["ROVO_MENU_RANK"] = $ad186fb917e4c48f$export$dd95f65f4139e5c7;
module.exports["ROVO_PROMPT_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$bfac571871e409b2;
module.exports["CHANGE_TONE_MENU_RANK"] = $ad186fb917e4c48f$export$e63f50c00e536f07;
module.exports["CHANGE_TONE_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$b55028e61899c679;
module.exports["TRANSLATE_MENU_RANK"] = $ad186fb917e4c48f$export$6f11aef2061f527c;
module.exports["TEXT_SECTION_RANK"] = $ad186fb917e4c48f$export$6784d5340d4a1b21;
module.exports["TEXT_SECTION_PRIMARY_TOOLBAR_RANK"] = $ad186fb917e4c48f$export$a3445a42840bc6d9;
module.exports["TEXT_COLLAPSED_MENU_RANK"] = $ad186fb917e4c48f$export$d5a685ed621e9024;
module.exports["TEXT_STYLES_GROUP_RANK"] = $ad186fb917e4c48f$export$26a9865aa120e992;
module.exports["TEXT_STYLES_MENU_RANK"] = $ad186fb917e4c48f$export$51921362eebd85ab;
module.exports["TEXT_STYLES_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$6449a65588a19d38;
module.exports["TEXT_FORMAT_GROUP_RANK"] = $ad186fb917e4c48f$export$9cdaceac32c6b4d8;
module.exports["TEXT_FORMAT_GROUP_COLLAPSED_RANK"] = $ad186fb917e4c48f$export$6d00774ee584bc52;
module.exports["TEXT_FORMAT_MENU_RANK"] = $ad186fb917e4c48f$export$669a394c241c9256;
module.exports["TEXT_FORMATTING_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$20900530b02fcff9;
module.exports["CLEAR_FORMARTTING_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$b62a699881de3ad5;
module.exports["SYNCED_BLOCK_SECTION_RANK"] = $ad186fb917e4c48f$export$f2dba222dee1738d;
module.exports["LISTS_INDENTATION_GROUP_RANK"] = $ad186fb917e4c48f$export$bbc17a51edaecf5e;
module.exports["LISTS_INDENTATION_GROUP_COLLAPSED_RANK"] = $ad186fb917e4c48f$export$c57e1bc67b28ed16;
module.exports["LISTS_INDENTATION_MENU_RANK"] = $ad186fb917e4c48f$export$29d19572f6bf97d3;
module.exports["LISTS_INDENTATION_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$70af84b45a4dbc54;
module.exports["ALIGNMENT_GROUP_RANK"] = $ad186fb917e4c48f$export$f2b3800989381ab8;
module.exports["ALIGNMENT_MENU_RANK"] = $ad186fb917e4c48f$export$50e3ab1607836660;
module.exports["ALIGNMENT_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$fe18fd9800ea0b78;
module.exports["TEXT_COLOR_HIGHLIGHT_GROUP_RANK"] = $ad186fb917e4c48f$export$ae4377fbd160eba4;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_RANK"] = $ad186fb917e4c48f$export$7aebf1f83f92aec4;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$6d61bddc04226fae;
module.exports["INSERT_BLOCK_SECTION_RANK"] = $ad186fb917e4c48f$export$d501e2da4fccd3d9;
module.exports["TASK_LIST_GROUP_RANK"] = $ad186fb917e4c48f$export$ca5c9182c556b0ba;
module.exports["MEDIA_GROUP_RANK"] = $ad186fb917e4c48f$export$41b6a2bde3ffc16c;
module.exports["CODE_BLOCK_GROUP_RANK"] = $ad186fb917e4c48f$export$2e369b4fbf595d64;
module.exports["MENTION_GROUP_RANK"] = $ad186fb917e4c48f$export$9834991fe1fe77a;
module.exports["EMOJI_GROUP_RANK"] = $ad186fb917e4c48f$export$5e431f0b402bc573;
module.exports["LAYOUT_GROUP_RANK"] = $ad186fb917e4c48f$export$18725f40b7ed45c9;
module.exports["TABLE_GROUP_RANK"] = $ad186fb917e4c48f$export$3b68d352d79ba4dc;
module.exports["INSERT_GROUP_RANK"] = $ad186fb917e4c48f$export$6b93bebdb0c4f64b;
module.exports["LINKING_SECTION_RANK"] = $ad186fb917e4c48f$export$c7c28a2a4f553552;
module.exports["LINKING_GROUP_RANK"] = $ad186fb917e4c48f$export$400d2c257bc9421e;
module.exports["COLLAB_SECTION_RANK"] = $ad186fb917e4c48f$export$efde8251fb2b89d5;
module.exports["TRACK_CHANGES_SECTION_RANK"] = $ad186fb917e4c48f$export$6795fbb63d664162;
module.exports["UNDO_CHANGES_GROUP_RANK"] = $ad186fb917e4c48f$export$8b9f9ebddc5f6d72;
module.exports["REDO_CHANGES_GROUP_RANK"] = $ad186fb917e4c48f$export$faf3ae5c01b97598;
module.exports["TRACK_CHANGES_GROUP_RANK"] = $ad186fb917e4c48f$export$e9551bb6af82297a;
module.exports["OVERFLOW_SECTION_RANK"] = $ad186fb917e4c48f$export$d63a7078a6c0dc57;
module.exports["OVERFLOW_GROUP_RANK"] = $ad186fb917e4c48f$export$7aecad5ed6bcab55;
module.exports["OVERFLOW_MENU_RANK"] = $ad186fb917e4c48f$export$ea9c3eff8619984;
module.exports["PIN_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$510811eb0f5e0b21;
module.exports["OVERFLOW_EXTENSIONS_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$6184a38ba6130c9c;
module.exports["OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK"] = $ad186fb917e4c48f$export$3bdd20aa1e9eee2;
module.exports["OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK"] = $ad186fb917e4c48f$export$dc811b512e84a8a4;
module.exports["OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK"] = $ad186fb917e4c48f$export$9cc8eee968218e62;
module.exports["PIN_SECTION_RANK"] = $ad186fb917e4c48f$export$58a4b339bb5abbc1;
module.exports["PIN_GROUP_RANK"] = $ad186fb917e4c48f$export$cb4d99d2936acb14;
module.exports["LOOM_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$d27db3643df90b4d;
module.exports["PASTE_MENU_RANK"] = $ad186fb917e4c48f$export$a766c0ef72fbd3e1;
module.exports["PASTE_MENU_SECTION_RANK"] = $ad186fb917e4c48f$export$1e88c7dcdd9c7430;
module.exports["PASTE_NESTED_MENU_RANK"] = $ad186fb917e4c48f$export$c200baaef3fcc623;
module.exports["PASTE_MENU_NESTED_SECTION_RANK"] = $ad186fb917e4c48f$export$8afb46bea363e001;

});

parcelRegister("2HIrf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16986c082688a4f5b3b764388c8e3ca8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f8211771ff2d62d$var$_react = $1f8211771ff2d62d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1f8211771ff2d62d$var$_baseNew = $1f8211771ff2d62d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1f8211771ff2d62d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextNormal".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-normal
 * Usage guidance:
 * Reserved for representing Paragraph text style / Normal text style.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f8211771ff2d62d$var$TextNormalIcon = (props)=>/*#__PURE__*/ $1f8211771ff2d62d$var$_react.default.createElement($1f8211771ff2d62d$var$_baseNew.default, Object.assign({
        name: "TextNormalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 1v1.5H8.751V15h-1.5V2.5H2.5V1z"/>`
    }, props));
$1f8211771ff2d62d$var$TextNormalIcon.displayName = 'TextNormalIcon';
var $1f8211771ff2d62d$var$_default = module.exports.default = $1f8211771ff2d62d$var$TextNormalIcon;

});

parcelRegister("91Kwo", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $di3bZ = parcelRequire("di3bZ");

/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $b033fe0a97e5da13$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};






var $ieeJu = parcelRequire("ieeJu");


var $3brWT = parcelRequire("3brWT");








const $caac40bbd72bf9c0$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $3brWT.MAX_REGEX_MATCH)), $from.parentOffset, undefined, (0, $3brWT.leafNodeReplacementCharacter)) + text;
        let result = $caac40bbd72bf9c0$var$findMatchOnRules({
            rules: rules,
            textToMatch: textBefore,
            from: from,
            to: to,
            state: state
        });
        let isBackwardMatch;
        if (!result && (0, $ieeJu.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            if ((0, $3brWT.TYPEAHEAD_TRIGGERS).includes(text)) return false;
            const textAfter = text + $from.parent.textBetween($from.parentOffset, Math.min($from.parent.content.size, $from.parentOffset + (0, $3brWT.MAX_REGEX_MATCH)), undefined, (0, $3brWT.leafNodeReplacementCharacter));
            isBackwardMatch = true;
            const backwardMatchRules = rules.filter((rule)=>rule.allowsBackwardMatch);
            result = $caac40bbd72bf9c0$var$findMatchOnRules({
                rules: backwardMatchRules,
                textToMatch: textAfter,
                from: from,
                to: to,
                state: state,
                isBackwardMatch: isBackwardMatch
            });
            if (!result) return false;
        }
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $3brWT.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule,
            isBackwardMatch: isBackwardMatch
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $caac40bbd72bf9c0$var$findMatchOnRules({ rules: rules, textToMatch: textToMatch, from: from, to: to, state: state, isBackwardMatch: isBackwardMatch }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textToMatch` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $b033fe0a97e5da13$export$b0e17cd4423f50ca)(state.selection) ? textToMatch.at(-1) ?? '' : textToMatch;
        // if the user is formatting text to inline code from R to L i.e. backwards
        if (rule.allowsBackwardMatch && isBackwardMatch && (0, $ieeJu.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            // if the match has a parenthesis before it, but no whitespace or empty space before that, exit
            const charBefore = state.doc.textBetween(from - 1, from);
            if (charBefore === '(') {
                const charBeforeParenthesis = state.doc.textBetween(from - 2, from - 1);
                if (charBeforeParenthesis !== ' ' && charBeforeParenthesis !== '') continue;
            } else if (charBefore !== ' ' && charBefore !== '') continue;
            const match = rule.match.exec(matchString);
            if (!match) continue;
            const matchEndPos = from + match[0].length - 1;
            const transform = rule.handler(state, match, from, matchEndPos);
            if (transform) return {
                from: from,
                to: matchEndPos,
                matchedRule: {
                    ...rule,
                    result: match
                }
            };
            return null;
        }
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $3brWT.MAX_REGEX_MATCH));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}


function $22c4d92e2bcbb747$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options?.onInputEvent;
    const onBeforeRegexMatch = options?.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
    const pluginKey = new (0, $kCECX.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $caac40bbd72bf9c0$export$9bcba4b183c6bb83)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to, isBackwardMatch: isBackwardMatch } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $3brWT.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            // after inserting inline code, we need to reset the selection back
            // else, we set the selection at the end of the inline code which doesn't make sense if we are closing the inline code from R to L
            if (isBackwardMatch && (0, $ieeJu.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
                const prevSelection = oldState.selection.map(tr.doc, tr.mapping);
                tr.setSelection(new (0, $kCECX.TextSelection)(prevSelection.$from));
            }
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                blur: (view)=>{
                    if (!options?.checkOnBlur) return false;
                    const selection = view.state.selection;
                    if (!(selection instanceof (0, $kCECX.TextSelection))) return;
                    const { $cursor: $cursor } = selection;
                    if ($cursor) inputEvent({
                        view: view,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: options.appendTextOnBlur ?? ''
                    });
                    return false;
                },
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $kCECX.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}


const $955604451657fd29$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $955604451657fd29$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
};
const $955604451657fd29$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true, checkOnBlur: checkOnBlur, appendTextOnBlur: appendTextOnBlur } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $kCECX.TextSelection)) && !(0, $b033fe0a97e5da13$export$b0e17cd4423f50ca)(state.selection) && !isInline || $955604451657fd29$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $955604451657fd29$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $22c4d92e2bcbb747$export$dc83f374e2af640d)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $di3bZ.closeHistory)(tr);
        },
        checkOnBlur: checkOnBlur,
        appendTextOnBlur: appendTextOnBlur
    });
};
module.exports["createPlugin"] = $955604451657fd29$export$ae829ec7b2625219;

});

parcelRegister("3brWT", function(module, exports) {
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $34c003427397f8c7$export$a96b909f1510512b = '\ufffc';
const $34c003427397f8c7$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $34c003427397f8c7$export$af78bb669dec9658 = 500;
const $34c003427397f8c7$export$3082ca29ad268435 = [
    ':',
    '/',
    '@'
];
module.exports["leafNodeReplacementCharacter"] = $34c003427397f8c7$export$a96b909f1510512b;
module.exports["TEXT_INPUT_RULE_TRANSACTION_KEY"] = $34c003427397f8c7$export$e56dc8305776db1f;
module.exports["MAX_REGEX_MATCH"] = $34c003427397f8c7$export$af78bb669dec9658;
module.exports["TYPEAHEAD_TRIGGERS"] = $34c003427397f8c7$export$3082ca29ad268435;

});

parcelRegister("lwsLh", function(module, exports) {
const $9463f98aee92409e$export$fee081d0fba011ce = 'insertedTrailingParagraphToLastNode';
module.exports["INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META"] = $9463f98aee92409e$export$fee081d0fba011ce;

});

parcelRegister("9iFhC", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

function $00324ea523ceadb3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00324ea523ceadb3$export$7638a34f4ed2b514 = {
    name: "ewpfso",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}"
};
const $00324ea523ceadb3$export$5897f954e99cc6c0 = {
    name: "ioewc",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}gap:var(--ds-space-050, 4px);div[role=group]{gap:var(--ds-space-050, 4px);}"
};
const $00324ea523ceadb3$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-border, #0B120E24)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $00324ea523ceadb3$export$c4d4f06a25de97f = {
    name: "1ty89h5",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto;button{&:not([disabled])::after{border:none;}}"
};
const $00324ea523ceadb3$export$147e2cce6f264c9b = {
    name: "wb8qky",
    styles: "display:flex;button{&:not([disabled])::after{border:none;}}"
};
const $00324ea523ceadb3$export$f2c6a721c78d3c4a = {
    name: "4sd07o",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px);button{&:not([disabled])::after{border:none;}}"
};
const $00324ea523ceadb3$export$cd86615b96818354 = {
    name: "ox0lz7",
    styles: "&:not([disabled])::after{border:none;}"
};
module.exports["buttonGroupStyle"] = $00324ea523ceadb3$export$5897f954e99cc6c0;
module.exports["separatorStyles"] = $00324ea523ceadb3$export$39b9f83b35c7456d;
module.exports["wrapperStyle"] = $00324ea523ceadb3$export$c4d4f06a25de97f;
module.exports["triggerWrapperStylesWithPadding"] = $00324ea523ceadb3$export$f2c6a721c78d3c4a;
module.exports["disableBlueBorderStyles"] = $00324ea523ceadb3$export$cd86615b96818354;

});

parcelRegister("gLi18", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $kD4eB = parcelRequire("kD4eB");

var $6IL1T = parcelRequire("6IL1T");

var $8FgJC = parcelRequire("8FgJC");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $feeMI = parcelRequire("feeMI");


var $bZDJe = parcelRequire("bZDJe");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $j9oLZ = parcelRequire("j9oLZ");


var $7XIuB = parcelRequire("7XIuB");


var $g9ric = parcelRequire("g9ric");


var $9RT19 = parcelRequire("9RT19");

function $f85739240361f114$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f85739240361f114$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $f85739240361f114$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #4688EC)"}`,
    outline: 'none'
});
const $f85739240361f114$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) {
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) /**
       * Hack for item to imitate old dropdown-menu selected styles
       */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $lOiVq.css)("position:relative;&::before{display:block;height:100%;width:2px;position:absolute;left:0;top:0;background:var(--ds-border-selected, #1868DB);content:'';}>span,>span:hover,>span:active{background:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB);}:focus>span[aria-disabled='false']{", $f85739240361f114$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $lOiVq.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB);}:focus>span[aria-disabled='false']{", $f85739240361f114$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    } else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #292A2E);background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, #0B120E24)"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #080F214A);}:focus>span[aria-disabled='false']{", $f85739240361f114$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $f85739240361f114$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $uyXFl.OutsideClickTargetRefContext));
    // eslint-disable-next-line react/jsx-props-no-spreading -- Spreading props to pass through dynamic component props
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $j9oLZ.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $f85739240361f114$var$DropListWithOutsideListeners = (0, $9Muxb.default)($f85739240361f114$var$DropListWithOutsideClickTargetRef);
class $f85739240361f114$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $9RT19.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $7Y8M5.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($f85739240361f114$var$DropListWithOutsideListeners, {
            isOpen: true,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
            handleEnterKeydown: this.handleEnterKeydown,
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6IL1T.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $8FgJC.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $lOiVq.jsx)($f85739240361f114$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $f85739240361f114$var$wrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                this.state.target?.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        };
        this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        };
        this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        };
        this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        };
        this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.handleEnterKeydown = (e)=>{
            if (!this.props.allowEnterDefaultBehavior) e.preventDefault();
            e.stopPropagation();
        };
    }
}
const $f85739240361f114$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $f85739240361f114$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const memoizedOnClick = (0, $cozmU.useCallback)(()=>onItemActivated && onItemActivated({
            item: item
        }), [
        onItemActivated,
        item
    ]);
    const onClick = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnClick : ()=>onItemActivated && onItemActivated({
            item: item
        });
    const memoizedOnMouseDown = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const onMouseDown = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnMouseDown : (e)=>{
        e.preventDefault();
    };
    const memoizedOnMouseEnter = (0, $cozmU.useCallback)(()=>onMouseEnter && onMouseEnter({
            item: item
        }), [
        onMouseEnter,
        item
    ]);
    const onMouseEnterHandler = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnMouseEnter : ()=>onMouseEnter && onMouseEnter({
            item: item
        });
    const memoizedOnMouseLeave = (0, $cozmU.useCallback)(()=>onMouseLeave && onMouseLeave({
            item: item
        }), [
        onMouseLeave,
        item
    ]);
    const onMouseLeaveHandler = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnMouseLeave : ()=>onMouseLeave && onMouseLeave({
            item: item
        });
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    const testId = item['data-testid'] || `dropdown-item__${item.content}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    const dropListItem = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>$f85739240361f114$var$buttonStyles(item.isActive, submenuActive),
        role: (0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? shouldUseDefaultRole ? undefined : 'menuitem' : undefined,
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        "aria-expanded": (0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? item['aria-expanded'] : undefined,
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kD4eB.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : (0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? undefined : 'menuitem',
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: onMouseDown,
        component: $f85739240361f114$var$DropdownMenuItemCustomComponent,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        "aria-expanded": (0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? undefined : item['aria-expanded']
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $f85739240361f114$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
({ ...props })=>{
    const keyDownHandlerContext = (0, $cozmU.useContext)((0, $bZDJe.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    const memoizedArrowKeyNavOptions = (0, $cozmU.useMemo)(()=>({
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        }), [
        props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext
    ]);
    const arrowKeyNavOptions = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedArrowKeyNavOptions : {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)($f85739240361f114$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: arrowKeyNavOptions,
        ...props
    });
});
module.exports["default"] = $f85739240361f114$export$2e2bcd8739ae039;
module.exports["DropdownMenuItem"] = $f85739240361f114$export$ed97964d1871885d;
module.exports["DropdownMenuWithKeyboardNavigation"] = $f85739240361f114$export$9e0cd5a62a7d99cf;

});

parcelRegister("feeMI", function(module, exports) {
const $9af1a227809c06a3$export$15eb942addb87cf6 = 'pm-dropdown';
const $9af1a227809c06a3$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$9af1a227809c06a3$export$15eb942addb87cf6}-submenu`
};
module.exports["DropdownMenuSharedCssClassName"] = $9af1a227809c06a3$export$94c0f60c32e7bd13;

});

parcelRegister("j9oLZ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $2iGHk = parcelRequire("2iGHk");


var $gTPfK = parcelRequire("gTPfK");


var $lzgC6 = parcelRequire("lzgC6");


var $iDrrr = parcelRequire("iDrrr");


var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");




/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $16116a34d0afc111$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $16116a34d0afc111$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($16116a34d0afc111$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $16116a34d0afc111$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $16116a34d0afc111$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $16116a34d0afc111$var$timeoutDuration);
        }
    };
}
var $16116a34d0afc111$var$supportsMicroTasks = $16116a34d0afc111$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $16116a34d0afc111$var$debounce = $16116a34d0afc111$var$supportsMicroTasks ? $16116a34d0afc111$var$microtaskDebounce : $16116a34d0afc111$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $16116a34d0afc111$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $16116a34d0afc111$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $16116a34d0afc111$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $16116a34d0afc111$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $16116a34d0afc111$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $16116a34d0afc111$var$getScrollParent($16116a34d0afc111$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $16116a34d0afc111$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $16116a34d0afc111$var$isIE11 = $16116a34d0afc111$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $16116a34d0afc111$var$isIE10 = $16116a34d0afc111$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $16116a34d0afc111$var$isIE(version) {
    if (version === 11) return $16116a34d0afc111$var$isIE11;
    if (version === 10) return $16116a34d0afc111$var$isIE10;
    return $16116a34d0afc111$var$isIE11 || $16116a34d0afc111$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $16116a34d0afc111$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $16116a34d0afc111$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $16116a34d0afc111$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $16116a34d0afc111$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $16116a34d0afc111$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $16116a34d0afc111$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $16116a34d0afc111$var$getRoot(node) {
    if (node.parentNode !== null) return $16116a34d0afc111$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $16116a34d0afc111$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($16116a34d0afc111$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $16116a34d0afc111$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $16116a34d0afc111$var$getRoot(element1);
    if (element1root.host) return $16116a34d0afc111$var$findCommonOffsetParent(element1root.host, element2);
    else return $16116a34d0afc111$var$findCommonOffsetParent(element1, $16116a34d0afc111$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $16116a34d0afc111$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $16116a34d0afc111$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $16116a34d0afc111$var$getScroll(element, 'top');
    var scrollLeft = $16116a34d0afc111$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $16116a34d0afc111$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $16116a34d0afc111$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $16116a34d0afc111$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $16116a34d0afc111$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $16116a34d0afc111$var$isIE(10) && getComputedStyle(html);
    return {
        height: $16116a34d0afc111$var$getSize('Height', body, html, computedStyle),
        width: $16116a34d0afc111$var$getSize('Width', body, html, computedStyle)
    };
}
var $16116a34d0afc111$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $16116a34d0afc111$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $16116a34d0afc111$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $16116a34d0afc111$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $16116a34d0afc111$var$getClientRect(offsets) {
    return $16116a34d0afc111$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $16116a34d0afc111$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($16116a34d0afc111$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $16116a34d0afc111$var$getScroll(element, 'top');
            var scrollLeft = $16116a34d0afc111$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $16116a34d0afc111$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $16116a34d0afc111$var$getStyleComputedProperty(element);
        horizScrollbar -= $16116a34d0afc111$var$getBordersSize(styles, 'x');
        vertScrollbar -= $16116a34d0afc111$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $16116a34d0afc111$var$getClientRect(result);
}
function $16116a34d0afc111$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $16116a34d0afc111$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $16116a34d0afc111$var$getBoundingClientRect(children);
    var parentRect = $16116a34d0afc111$var$getBoundingClientRect(parent);
    var scrollParent = $16116a34d0afc111$var$getScrollParent(children);
    var styles = $16116a34d0afc111$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $16116a34d0afc111$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $16116a34d0afc111$var$includeScroll(offsets, parent);
    return offsets;
}
function $16116a34d0afc111$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $16116a34d0afc111$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $16116a34d0afc111$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $16116a34d0afc111$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $16116a34d0afc111$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $16116a34d0afc111$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($16116a34d0afc111$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $16116a34d0afc111$var$getParentNode(element);
    if (!parentNode) return false;
    return $16116a34d0afc111$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $16116a34d0afc111$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $16116a34d0afc111$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $16116a34d0afc111$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $16116a34d0afc111$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $16116a34d0afc111$var$getFixedPositionOffsetParent(popper) : $16116a34d0afc111$var$findCommonOffsetParent(popper, $16116a34d0afc111$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $16116a34d0afc111$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $16116a34d0afc111$var$getScrollParent($16116a34d0afc111$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $16116a34d0afc111$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$16116a34d0afc111$var$isFixed(offsetParent)) {
            var _getWindowSizes = $16116a34d0afc111$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $16116a34d0afc111$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $16116a34d0afc111$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $16116a34d0afc111$var$_extends({
            key: key
        }, rects[key], {
            area: $16116a34d0afc111$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $16116a34d0afc111$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $16116a34d0afc111$var$getFixedPositionOffsetParent(popper) : $16116a34d0afc111$var$findCommonOffsetParent(popper, $16116a34d0afc111$var$getReferenceNode(reference));
    return $16116a34d0afc111$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $16116a34d0afc111$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $16116a34d0afc111$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $16116a34d0afc111$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $16116a34d0afc111$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$16116a34d0afc111$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $16116a34d0afc111$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $16116a34d0afc111$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $16116a34d0afc111$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $16116a34d0afc111$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $16116a34d0afc111$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $16116a34d0afc111$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $16116a34d0afc111$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $16116a34d0afc111$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $16116a34d0afc111$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $16116a34d0afc111$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $16116a34d0afc111$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $16116a34d0afc111$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $16116a34d0afc111$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $16116a34d0afc111$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $16116a34d0afc111$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $16116a34d0afc111$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($16116a34d0afc111$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$16116a34d0afc111$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $16116a34d0afc111$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $16116a34d0afc111$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $16116a34d0afc111$var$attachToScrollParents($16116a34d0afc111$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $16116a34d0afc111$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $16116a34d0afc111$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $16116a34d0afc111$var$getScrollParent(reference);
    $16116a34d0afc111$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $16116a34d0afc111$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $16116a34d0afc111$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $16116a34d0afc111$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $16116a34d0afc111$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $16116a34d0afc111$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $16116a34d0afc111$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $16116a34d0afc111$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $16116a34d0afc111$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $16116a34d0afc111$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $16116a34d0afc111$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $16116a34d0afc111$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $16116a34d0afc111$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $16116a34d0afc111$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $16116a34d0afc111$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $16116a34d0afc111$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $16116a34d0afc111$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $16116a34d0afc111$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $16116a34d0afc111$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $16116a34d0afc111$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $16116a34d0afc111$var$isFirefox = $16116a34d0afc111$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $16116a34d0afc111$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $16116a34d0afc111$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $16116a34d0afc111$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $16116a34d0afc111$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$16116a34d0afc111$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $16116a34d0afc111$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $16116a34d0afc111$var$_extends({}, attributes, data.attributes);
    data.styles = $16116a34d0afc111$var$_extends({}, styles, data.styles);
    data.arrowStyles = $16116a34d0afc111$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $16116a34d0afc111$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $16116a34d0afc111$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$16116a34d0afc111$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $16116a34d0afc111$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $16116a34d0afc111$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $16116a34d0afc111$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $16116a34d0afc111$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $16116a34d0afc111$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $16116a34d0afc111$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $16116a34d0afc111$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $16116a34d0afc111$var$validPlacements = $16116a34d0afc111$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $16116a34d0afc111$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $16116a34d0afc111$var$validPlacements.indexOf(placement);
    var arr = $16116a34d0afc111$var$validPlacements.slice(index + 1).concat($16116a34d0afc111$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $16116a34d0afc111$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($16116a34d0afc111$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $16116a34d0afc111$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $16116a34d0afc111$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $16116a34d0afc111$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $16116a34d0afc111$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $16116a34d0afc111$var$clockwise(placement);
            break;
        case $16116a34d0afc111$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $16116a34d0afc111$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $16116a34d0afc111$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $16116a34d0afc111$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $16116a34d0afc111$var$_extends({}, data.offsets.popper, $16116a34d0afc111$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $16116a34d0afc111$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $16116a34d0afc111$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $16116a34d0afc111$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $16116a34d0afc111$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($16116a34d0afc111$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $16116a34d0afc111$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($16116a34d0afc111$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($16116a34d0afc111$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $16116a34d0afc111$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $16116a34d0afc111$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $16116a34d0afc111$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $16116a34d0afc111$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $16116a34d0afc111$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $16116a34d0afc111$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $16116a34d0afc111$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $16116a34d0afc111$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $16116a34d0afc111$var$defineProperty({}, side, reference[side]),
            end: $16116a34d0afc111$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $16116a34d0afc111$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$hide(data) {
    if (!$16116a34d0afc111$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $16116a34d0afc111$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $16116a34d0afc111$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $16116a34d0afc111$var$getOppositePlacement(placement);
    data.offsets.popper = $16116a34d0afc111$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $16116a34d0afc111$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $16116a34d0afc111$var$applyStyle,
        /** @prop {Function} */ onLoad: $16116a34d0afc111$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $16116a34d0afc111$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $16116a34d0afc111$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $16116a34d0afc111$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $16116a34d0afc111$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $16116a34d0afc111$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $16116a34d0afc111$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($16116a34d0afc111$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $16116a34d0afc111$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $16116a34d0afc111$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $16116a34d0afc111$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $16116a34d0afc111$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $16116a34d0afc111$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $16116a34d0afc111$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $16116a34d0afc111$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $16116a34d0afc111$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $16116a34d0afc111$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$16116a34d0afc111$var$Popper.placements = $16116a34d0afc111$var$placements;
$16116a34d0afc111$var$Popper.Defaults = $16116a34d0afc111$var$Defaults;
var $16116a34d0afc111$export$2e2bcd8739ae039 //# sourceMappingURL=popper.js.map
 = $16116a34d0afc111$var$Popper;



var $LQnOI = parcelRequire("LQnOI");





var $lQV5m = parcelRequire("lQV5m");

const $f8eb147166d00f85$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};


const $e0433ba66017f95e$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
function $e0433ba66017f95e$var$positionToPopper(position) {
    return position && $e0433ba66017f95e$var$positionMap[position] ? $e0433ba66017f95e$var$positionMap[position].position : null;
}
function $e0433ba66017f95e$export$9e6a7c92c66a7cdd(position) {
    return $e0433ba66017f95e$var$positionToPopper(position) || $e0433ba66017f95e$var$positionMap[(0, $f8eb147166d00f85$export$f6c90e9517ee2ce0).default].position;
} // eslint-disable-next-line @atlaskit/editor/no-re-export


const $24381cd841c7472f$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
function $24381cd841c7472f$var$defaultOnPositioned() {}
const $24381cd841c7472f$var$defaultProps = {
    boundariesElement: 'viewport',
    children: null,
    content: null,
    offset: '0, 0',
    position: 'right middle',
    zIndex: 400,
    lockScroll: false,
    isAlwaysFixed: false,
    onPositioned: $24381cd841c7472f$var$defaultOnPositioned
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $24381cd841c7472f$var$LegacyLayer extends (0, $cozmU.Component) {
    componentDidMount() {
        this.applyPopper(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        if (this.props !== prevProps) this.applyPopper(this.props);
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
   * the bottom of the popper not being viewable.
   * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
   */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? // allow some spacing either side of viewport height
        viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $e0433ba66017f95e$export$9e6a7c92c66a7cdd)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0 // leave 0 pixels between popper and the boundariesElement
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $16116a34d0afc111$export$2e2bcd8739ae039)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    ref: this.targetRef,
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    ref: this.contentRef,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        top: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        left: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'absolute',
                        transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        transform,
                        maxHeight: maxHeight ? maxHeight : 'auto',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...opacity
                    },
                    children: this.props.content
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.popper = void 0;
        this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $24381cd841c7472f$var$defaultState;
        this.extractStyles = (0, $LQnOI.default)(this.extractStyles.bind(this));
    }
}
// working with extract-react-types
$24381cd841c7472f$var$LegacyLayer.defaultProps = $24381cd841c7472f$var$defaultProps;
function $24381cd841c7472f$var$parseOffset({ offset: offset }) {
    const [rawSkidding, rawDistance] = offset.split(',');
    const skidding = Number.parseFloat(rawSkidding);
    const distance = Number.parseFloat(rawDistance);
    return [
        Number.isFinite(skidding) ? skidding : 0,
        Number.isFinite(distance) ? distance : 0
    ];
}
const $24381cd841c7472f$var$popperInteropModifiers = [
    {
        name: 'flip',
        enabled: false
    },
    {
        name: 'preventOverflow',
        enabled: false
    },
    {
        name: 'hide',
        enabled: false
    }
];
const $24381cd841c7472f$var$usePopperInteropModifiers = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePopperInteropModifiers(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { onPositioned: onPositioned } = t0;
    const onPositionedRef = (0, $cozmU.useRef)(onPositioned);
    const hasPositionedRef = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== onPositioned) {
        t1 = ()=>{
            onPositionedRef.current = onPositioned;
        };
        t2 = [
            onPositioned
        ];
        $[0] = onPositioned;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            ...$24381cd841c7472f$var$popperInteropModifiers,
            {
                name: "editorLayerFirstPositioned",
                enabled: true,
                phase: "afterWrite",
                fn () {
                    if (hasPositionedRef.current) return;
                    hasPositionedRef.current = true;
                    onPositionedRef.current();
                }
            }
        ];
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function usePopperInteropModifiers({ onPositioned: onPositioned }) {
    const onPositionedRef = (0, $cozmU.useRef)(onPositioned);
    const hasPositionedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        onPositionedRef.current = onPositioned;
    }, [
        onPositioned
    ]);
    return (0, $cozmU.useMemo)(()=>[
            ...$24381cd841c7472f$var$popperInteropModifiers,
            {
                name: 'editorLayerFirstPositioned',
                enabled: true,
                // React Popper commits calculated styles in `write`; the legacy callback ran afterwards.
                phase: 'afterWrite',
                fn () {
                    if (hasPositionedRef.current) return;
                    hasPositionedRef.current = true;
                    onPositionedRef.current();
                }
            }
        ], []);
};
const $24381cd841c7472f$var$PopperInterop = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PopperInterop(t0) {
    const $ = (0, $bDgLe.c)(19);
    const { children: children, content: content, offset: offset, onPositioned: onPositioned, position: position, strategy: strategy } = t0;
    const targetRef = (0, $cozmU.useRef)(null);
    const [referenceElement, setReferenceElement] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== onPositioned) {
        t1 = {
            onPositioned: onPositioned
        };
        $[0] = onPositioned;
        $[1] = t1;
    } else t1 = $[1];
    const modifiers = $24381cd841c7472f$var$usePopperInteropModifiers(t1);
    let t2;
    if ($[2] !== offset) {
        t2 = $24381cd841c7472f$var$parseOffset({
            offset: offset
        });
        $[2] = offset;
        $[3] = t2;
    } else t2 = $[3];
    const parsedOffset = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const actualTarget = targetRef.current?.children[0];
            setReferenceElement(actualTarget instanceof HTMLElement ? actualTarget : null);
        };
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children) {
        t4 = [
            children
        ];
        $[5] = children;
        $[6] = t4;
    } else t4 = $[6];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[7] !== children) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: targetRef,
            children: children
        });
        $[7] = children;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== content || $[10] !== modifiers || $[11] !== parsedOffset || $[12] !== position || $[13] !== referenceElement || $[14] !== strategy) {
        t6 = content && referenceElement ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
            modifiers: modifiers,
            offset: parsedOffset,
            placement: (0, $e0433ba66017f95e$export$9e6a7c92c66a7cdd)(position),
            referenceElement: referenceElement,
            strategy: strategy,
            children: (t7)=>{
                const { ref: ref, style: style } = t7;
                return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    ref: ref,
                    style: style,
                    children: content
                });
            }
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {});
        $[9] = content;
        $[10] = modifiers;
        $[11] = parsedOffset;
        $[12] = position;
        $[13] = referenceElement;
        $[14] = strategy;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            children: [
                t5,
                t6
            ]
        });
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : function PopperInterop({ children: children, content: content, offset: offset, onPositioned: onPositioned, position: position, strategy: strategy }) {
    const targetRef = (0, $cozmU.useRef)(null);
    const [referenceElement, setReferenceElement] = (0, $cozmU.useState)(null);
    const modifiers = $24381cd841c7472f$var$usePopperInteropModifiers({
        onPositioned: onPositioned
    });
    // Popper v2 compares the offset prop by reference, so memoise to avoid re-running positioning every render.
    const parsedOffset = (0, $cozmU.useMemo)(()=>$24381cd841c7472f$var$parseOffset({
            offset: offset
        }), [
        offset
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const actualTarget = targetRef.current?.children[0];
        setReferenceElement(actualTarget instanceof HTMLElement ? actualTarget : null);
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: targetRef,
                children: children
            }),
            content && referenceElement ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                modifiers: modifiers,
                offset: parsedOffset,
                placement: (0, $e0433ba66017f95e$export$9e6a7c92c66a7cdd)(position),
                referenceElement: referenceElement,
                strategy: strategy,
                children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        ref: ref,
                        style: style,
                        children: content
                    })
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {})
        ]
    });
};
/** Selects the reversible Popper v1 or ADS wrapper implementation. */ const $24381cd841c7472f$var$Layer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Layer(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: t1, content: t2, offset: t3, onPositioned: t4, position: t5 } = t0;
    const children = t1 === undefined ? $24381cd841c7472f$var$defaultProps.children : t1;
    const content = t2 === undefined ? $24381cd841c7472f$var$defaultProps.content : t2;
    const offset = t3 === undefined ? $24381cd841c7472f$var$defaultProps.offset : t3;
    const onPositioned = t4 === undefined ? $24381cd841c7472f$var$defaultProps.onPositioned : t4;
    const position = t5 === undefined ? $24381cd841c7472f$var$defaultProps.position : t5;
    if ((0, $iDrrr.fg)("platform-dst-popper-consolidation")) {
        let t6;
        if ($[0] !== children || $[1] !== content || $[2] !== offset || $[3] !== onPositioned || $[4] !== position) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)($24381cd841c7472f$var$PopperInterop, {
                content: content,
                offset: offset,
                onPositioned: onPositioned,
                position: position,
                strategy: "absolute",
                children: children
            });
            $[0] = children;
            $[1] = content;
            $[2] = offset;
            $[3] = onPositioned;
            $[4] = position;
            $[5] = t6;
        } else t6 = $[5];
        return t6;
    }
    let t6;
    if ($[6] !== children || $[7] !== content || $[8] !== offset || $[9] !== onPositioned || $[10] !== position) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)($24381cd841c7472f$var$LegacyLayer, {
            content: content,
            offset: offset,
            onPositioned: onPositioned,
            position: position,
            children: children
        });
        $[6] = children;
        $[7] = content;
        $[8] = offset;
        $[9] = onPositioned;
        $[10] = position;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : function Layer({ children: children = $24381cd841c7472f$var$defaultProps.children, content: content = $24381cd841c7472f$var$defaultProps.content, offset: offset = $24381cd841c7472f$var$defaultProps.offset, onPositioned: onPositioned = $24381cd841c7472f$var$defaultProps.onPositioned, position: position = $24381cd841c7472f$var$defaultProps.position }) {
    if ((0, $iDrrr.fg)('platform-dst-popper-consolidation')) return /*#__PURE__*/ (0, $8aG6j.jsx)($24381cd841c7472f$var$PopperInterop, {
        content: content,
        offset: offset,
        onPositioned: onPositioned,
        position: position,
        strategy: "absolute",
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($24381cd841c7472f$var$LegacyLayer, {
        content: content,
        offset: offset,
        onPositioned: onPositioned,
        position: position,
        children: children
    });
};
var $24381cd841c7472f$export$2e2bcd8739ae039 = $24381cd841c7472f$var$Layer;


const $c4b5ab9b17f6b108$var$packageName = "platform-pkg";
const $c4b5ab9b17f6b108$var$packageVersion = "0.0.0-use.local";
const $c4b5ab9b17f6b108$var$halfFocusRing = 1;
const $c4b5ab9b17f6b108$var$dropOffset = '0, 8';
const $c4b5ab9b17f6b108$var$fadeIn = (0, $lOiVq.keyframes)({
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c4b5ab9b17f6b108$var$DropList extends (0, $cozmU.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        const layerContent = isOpen ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                this.wrapperStyles,
                (0, $iDrrr.fg)('p2m-drop-down-motion') && this.motionStyles
            ],
            ref: this.handleDroplistRef
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $24381cd841c7472f$export$2e2bcd8739ae039), {
            content: layerContent,
            offset: $c4b5ab9b17f6b108$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                this.triggerStyles,
                (0, $iDrrr.fg)('p2m-drop-down-motion') && this.motionStyles
            ],
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args);
        this.dropContentRef = void 0;
        this.triggerRef = void 0;
        this.wrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        });
        this.triggerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        });
        this.motionStyles = /*#__PURE__*/ (0, $lOiVq.css)({
            animationName: `${$c4b5ab9b17f6b108$var$fadeIn}`,
            animationDuration: '360ms',
            animationTimingFunction: 'cubic-bezier(0.8, 0, 0, 1)'
        });
        /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $lOiVq.css)({
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-radius-small, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        };
        /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleEsc);
        };
        this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        };
        this.componentWillUnmount = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleEsc);
        };
        this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $c4b5ab9b17f6b108$var$halfFocusRing * 2}px`;
        };
        this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        };
        this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        };
        this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        };
        this.handleDroplistRef = (ref)=>{
            this.props.onDroplistRef?.(ref);
        };
        this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $c4b5ab9b17f6b108$var$createAndFireEventOnAtlaskit = (0, $2iGHk.default)('atlaskit');
const $c4b5ab9b17f6b108$var$_default_1 = (0, $gTPfK.default)({
    componentName: 'droplist',
    packageName: $c4b5ab9b17f6b108$var$packageName,
    packageVersion: $c4b5ab9b17f6b108$var$packageVersion
})((0, $lzgC6.default)({
    onOpenChange: $c4b5ab9b17f6b108$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $c4b5ab9b17f6b108$var$packageName,
            packageVersion: $c4b5ab9b17f6b108$var$packageVersion
        }
    })
})($c4b5ab9b17f6b108$var$DropList));
var $c4b5ab9b17f6b108$export$2e2bcd8739ae039 = $c4b5ab9b17f6b108$var$_default_1;
module.exports["default"] = $c4b5ab9b17f6b108$export$2e2bcd8739ae039;

});

parcelRegister("ldbHR", function(module, exports) {
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $iTJtk = parcelRequire("iTJtk");


var $lpNn5 = parcelRequire("lpNn5");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $7ZB0A = parcelRequire("7ZB0A");


var $ieeJu = parcelRequire("ieeJu");

const $9fdf3d933dc6e6ac$var$toolbarButtonStyle = {
    alignItems: 'center'
};
const $9fdf3d933dc6e6ac$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? $9fdf3d933dc6e6ac$var$toolbarButtonStyle : {
            alignItems: "center"
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props || $[2] !== ref) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            ref: ref,
            ...props,
            style: t0
        });
        $[1] = props;
        $[2] = ref;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        ref: ref,
        ...props,
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $9fdf3d933dc6e6ac$var$toolbarButtonStyle : {
            alignItems: 'center'
        }
    });
});
var $9fdf3d933dc6e6ac$export$2e2bcd8739ae039 = $9fdf3d933dc6e6ac$var$_default_1;


function $f739fc223eb0cd1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f739fc223eb0cd1e$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $f739fc223eb0cd1e$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $krYZG.EVENT_TYPE).UI
            })).fire((0, $iTJtk.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9fdf3d933dc6e6ac$export$2e2bcd8739ae039), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
        description: title,
        keymap: keymap
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $f739fc223eb0cd1e$var$buttonWrapper
    }, button));
});
var $f739fc223eb0cd1e$export$2e2bcd8739ae039 = $f739fc223eb0cd1e$var$ToolbarButton;
module.exports["default"] = $f739fc223eb0cd1e$export$2e2bcd8739ae039;

});

parcelRegister("28uKn", function(module, exports) {

var $csUNO = parcelRequire("csUNO");

function $20c8976f4f20343d$var$editorUGCToken(path) {
    return (0, $csUNO.editorUGCTokensRefreshed)[path];
}
var $20c8976f4f20343d$export$2e2bcd8739ae039 = $20c8976f4f20343d$var$editorUGCToken;
module.exports["default"] = $20c8976f4f20343d$export$2e2bcd8739ae039;

});

parcelRegister("lrTDq", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");

const $c5b132a435fb8929$export$297e5814a2c821bb = /*#__PURE__*/ (0, $lOiVq.css)("background-color:var(--ds-background-neutral, #0515240F);color:var(--ds-text-subtle, #505258);border-radius:var(--ds-radius-small, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $7Y8M5.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $7Y8M5.akEditorMobileMaxWidth), "px){display:none;}");
module.exports["shortcutStyle"] = $c5b132a435fb8929$export$297e5814a2c821bb;

});

parcelRegister("bkj40", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $jDAs4 = parcelRequire("jDAs4");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $5HBT9 = parcelRequire("5HBT9");


var $jGK9e = parcelRequire("jGK9e");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");




var $iLcY8 = parcelRequire("iLcY8");


var $jfFbl = parcelRequire("jfFbl");


var $6gBg9 = parcelRequire("6gBg9");


var $eEdSM = parcelRequire("eEdSM");


var $8tXCb = parcelRequire("8tXCb");


var $aC6bW = parcelRequire("aC6bW");


var $hgAxn = parcelRequire("hgAxn");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");





var $ieeJu = parcelRequire("ieeJu");

const $89c889278dbe2765$export$92a1a3b7554e9387 = {
    CLEAR_FORMAT_CODE_ERROR: 'CLEAR_FORMAT_CODE_ERROR',
    REMOVE_AUTO_DETECT_ENTRY: 'REMOVE_AUTO_DETECT_ENTRY',
    RESOLVE_FORMAT_CODE: 'RESOLVE_FORMAT_CODE',
    SET_AUTO_DETECT_ENTRY: 'SET_AUTO_DETECT_ENTRY',
    SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
    SET_IS_WRAPPED: 'SET_IS_WRAPPED',
    SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
    START_FORMAT_CODE: 'START_FORMAT_CODE'
};





const $4883cccd24c030e0$export$264979d19e499e37 = new (0, $kCECX.PluginKey)('codeBlockAutoDetectPlugin');
const $4883cccd24c030e0$export$62e9b65dae1e4e8f = (state)=>$4883cccd24c030e0$export$264979d19e499e37.getState(state);



var $1TzXg = parcelRequire("1TzXg");


var $kpCD8 = parcelRequire("kpCD8");





var $8nvEM = parcelRequire("8nvEM");

const $7996c95e1ce4924a$export$97324d26e7dfa2c5 = new (0, $kCECX.PluginKey)('codeBlockCopySelectionPlugin');
function $7996c95e1ce4924a$var$getSelectionDecorationStartAndEnd({ state: state, transaction: transaction }) {
    const codeBlockNode = (0, $1TzXg.getSelectedNodeOrNodeParentByNodeType)({
        nodeType: state.schema.nodes.codeBlock,
        selection: transaction.selection
    });
    if (!codeBlockNode) return {
        decorationStartAndEnd: undefined,
        codeBlockNode: undefined
    };
    const decorationStartAndEnd = [
        codeBlockNode.start,
        codeBlockNode.start + codeBlockNode.node.nodeSize
    ];
    return {
        decorationStartAndEnd: decorationStartAndEnd,
        codeBlockNode: codeBlockNode.node
    };
}
function $7996c95e1ce4924a$export$bf11b3ffc9027f6b() {
    return new (0, $kpCD8.SafePlugin)({
        key: $7996c95e1ce4924a$export$97324d26e7dfa2c5,
        state: {
            init () {
                return {
                    decorationStartAndEnd: undefined
                };
            },
            apply (transaction, currentCodeBlockCopySelectionPluginState, _oldState, newState) {
                switch(transaction.getMeta($7996c95e1ce4924a$export$97324d26e7dfa2c5)){
                    case 'show-selection':
                        return $7996c95e1ce4924a$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                    case 'remove-selection':
                        return {
                            decorationStartAndEnd: undefined
                        };
                    default:
                        // The contents of the code block can change while the selection is being shown
                        // (either from collab edits -- or from the user continuing to type while hovering
                        // the mouse over the copy button).
                        // This ensures the selection is updated in these cases.
                        if (currentCodeBlockCopySelectionPluginState.decorationStartAndEnd !== undefined) return $7996c95e1ce4924a$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                        return currentCodeBlockCopySelectionPluginState;
                }
            }
        },
        props: {
            decorations (state) {
                if ($7996c95e1ce4924a$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd) {
                    const [start, end] = $7996c95e1ce4924a$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd;
                    return (0, $8nvEM.DecorationSet).create(state.doc, [
                        (0, $8nvEM.Decoration).inline(start, end, {
                            class: 'ProseMirror-fake-text-selection'
                        })
                    ]);
                }
                return (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
}
function $7996c95e1ce4924a$export$73dae478fefb96e(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($7996c95e1ce4924a$export$97324d26e7dfa2c5, 'show-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}
function $7996c95e1ce4924a$export$1ec425a919cc0ea(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($7996c95e1ce4924a$export$97324d26e7dfa2c5, 'remove-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}





const $ad25e7bd70a42738$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('codeBlockPlugin');



var $4EksL = parcelRequire("4EksL");


var $fud2r = parcelRequire("fud2r");

var $efgwK = parcelRequire("efgwK");


var $aPdNQ = parcelRequire("aPdNQ");




function $39d747feddc6695d$export$92adcb8baa0906a6(state, start, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs) {
    const startOfCodeBlockText = state.selection.$from;
    const endPosition = state.selection.empty && !(state.selection instanceof (0, $4EksL.GapCursorSelection)) ? startOfCodeBlockText.end() : state.selection.$to.pos;
    const startLinePosition = startOfCodeBlockText.start();
    //when cmd+A is used to select the content. start position should be 0.
    const parentStartPosition = startOfCodeBlockText.depth === 0 ? 0 : startOfCodeBlockText.before();
    const contentSlice = state.doc.slice(startOfCodeBlockText.pos, endPosition);
    const codeBlockSlice = (0, $fud2r.mapSlice)(contentSlice, (node, parent, index)=>{
        if (node.type === state.schema.nodes.hardBreak) return state.schema.text('\n');
        if (node.isText) return node.mark([]);
        if (node.isInline) {
            // Convert dates
            if (node.attrs.timestamp) return state.schema.text((0, $efgwK.timestampToString)(node.attrs.timestamp, null));
            // Convert links
            if (node.attrs.url) return state.schema.text(node.attrs.url);
            return node.attrs.text ? state.schema.text(node.attrs.text) : null;
        }
        // if the current node is the last child of the Slice exit early to prevent
        // adding additional line breaks
        if (contentSlice.content.childCount - 1 === index) return node.content;
        //useful to decide whether to append line breaks when the content has list items.
        const isParentLastChild = parent && contentSlice.content.childCount - 1 === index;
        // add line breaks at the end of each paragraph to mimic layout of selected content
        // do not add line breaks when the 'paragraph' parent is last child.
        if (node.content.childCount && node.type === state.schema.nodes.paragraph && !isParentLastChild) return node.content.append((0, $aPdNQ.Fragment).from(state.schema.text('\n\n')));
        return node.content.childCount ? node.content : null;
    });
    const tr = state.tr;
    // Replace current block node
    const startMapped = startLinePosition === start ? parentStartPosition : start;
    const codeBlock = state.schema.nodes.codeBlock;
    const codeBlockNode = codeBlock.createChecked(attrs, codeBlockSlice.content);
    tr.replaceWith(startMapped, Math.min(endPosition, tr.doc.content.size), codeBlockNode);
    // Reposition cursor when inserting into layouts or table headers
    const mapped = tr.doc.resolve(tr.mapping.map(startMapped) + 1);
    const selection = (0, $kCECX.TextSelection).findFrom(mapped, state.selection instanceof (0, $4EksL.GapCursorSelection) ? -1 : 1, true);
    if (selection) return tr.setSelection(selection);
    return tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(start + startOfCodeBlockText.node().nodeSize - 1, tr.doc.content.size)));
}
function $39d747feddc6695d$export$4b5d5858845bfcf6(state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) return false;
    const { $from: $from } = state.selection;
    const node = $from.parent;
    if (!node.isTextblock || node.type === state.schema.nodes.codeBlock) return false;
    const parentDepth = $from.depth - 1;
    const parentNode = $from.node(parentDepth);
    const index = $from.index(parentDepth);
    return parentNode.canReplaceWith(index, index + 1, state.schema.nodes.codeBlock);
}






var $2w79Z = parcelRequire("2w79Z");

function $9c52569c583a8f61$export$da3f040fb23d21f(selection) {
    return selection.$cursor || undefined;
}
function $9c52569c583a8f61$export$f43d710a87ced169(state) {
    const codeBlockNodes = [];
    state.doc.descendants((node, pos)=>{
        if (node.type === state.schema.nodes.codeBlock) {
            codeBlockNodes.push({
                node: node,
                pos: pos
            });
            return false;
        }
        return true;
    });
    return codeBlockNodes;
}
function $9c52569c583a8f61$export$3fa3c149b89781e7(tr) {
    const changedCodeBlocks = [];
    const nodePositions = new Set();
    tr.steps.forEach((step)=>{
        const mapResult = step.getMap();
        mapResult.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                if (node.type.name === 'codeBlock') {
                    if (!nodePositions.has(pos)) {
                        nodePositions.add(pos);
                        changedCodeBlocks.push({
                            node: node,
                            pos: pos
                        });
                    }
                }
            });
        });
    });
    return changedCodeBlocks;
}


const $a1429e5b2d8791eb$var$MIN_AUTO_DETECT_TEXT_LENGTH = 20;
const $a1429e5b2d8791eb$export$75fa5ee64c376b5c = (lastObservedText, text)=>{
    if (!lastObservedText) return text.length > 0;
    return Math.abs(text.length - lastObservedText.length) > lastObservedText.length / 2;
};
const $a1429e5b2d8791eb$export$1c51de8940db13e0 = (text)=>text.split('\n')[0] ?? '';
const $a1429e5b2d8791eb$export$a5224da7b01ec0b7 = (text)=>text.trim().length >= $a1429e5b2d8791eb$var$MIN_AUTO_DETECT_TEXT_LENGTH;
const $a1429e5b2d8791eb$export$957229695d10ea4a = (node)=>typeof node.attrs.localId === 'string' ? node.attrs.localId : null;
const $a1429e5b2d8791eb$export$ebf3c95b2e36b335 = (node, pos, isPending, previous, options = {})=>({
        lastObservedText: node.textContent,
        lastObservedFirstLine: $a1429e5b2d8791eb$export$1c51de8940db13e0(node.textContent),
        isPending: isPending,
        detectionResult: options.preserveDetectionResult === false ? undefined : previous?.detectionResult,
        autoDetectedLanguage: previous?.autoDetectedLanguage,
        pos: pos
    });
const $a1429e5b2d8791eb$export$82bdb85239e6f0b5 = (languageDetectionMap, node, pos, isPending)=>{
    const localId = $a1429e5b2d8791eb$export$957229695d10ea4a(node);
    if (!localId) return languageDetectionMap;
    return {
        ...languageDetectionMap,
        [localId]: $a1429e5b2d8791eb$export$ebf3c95b2e36b335(node, pos, isPending, languageDetectionMap[localId])
    };
};
const $a1429e5b2d8791eb$export$8e484f7dcf239a78 = (languageDetectionMap, localId)=>{
    if (!languageDetectionMap[localId]) return languageDetectionMap;
    const nextLanguageDetectionMap = {
        ...languageDetectionMap
    };
    delete nextLanguageDetectionMap[localId];
    return nextLanguageDetectionMap;
};
const $a1429e5b2d8791eb$var$getCodeBlockLocalIdsRemovedFromChangedRanges = (tr, codeBlockType)=>{
    const localIds = new Set();
    tr.steps.forEach((step, stepIndex)=>{
        const docAtStep = tr.docs[stepIndex];
        step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart === oldEnd) return;
            const clampedOldEnd = Math.min(oldEnd, docAtStep.content.size);
            docAtStep.nodesBetween(oldStart, clampedOldEnd, (node, pos)=>{
                if (node.type !== codeBlockType) return true;
                const isWholeCodeBlockRemoved = pos >= oldStart && pos + node.nodeSize <= clampedOldEnd;
                if (!isWholeCodeBlockRemoved) return false;
                const localId = $a1429e5b2d8791eb$export$957229695d10ea4a(node);
                if (localId) localIds.add(localId);
                return false;
            });
        });
    });
    return localIds;
};
const $a1429e5b2d8791eb$var$isHistoryMeta = (meta)=>typeof meta === 'object' && meta !== null && 'redo' in meta;
const $a1429e5b2d8791eb$var$getCodeBlockTransactionChanges = (tr, codeBlockType)=>{
    const insertedNodesWithPos = (0, $6gBg9.getInsertedCodeBlocksInTransaction)(tr, codeBlockType);
    const removedFromChangedRangesLocalIds = $a1429e5b2d8791eb$var$getCodeBlockLocalIdsRemovedFromChangedRanges(tr, codeBlockType);
    const insertedLocalIds = new Set();
    const insertedCodeBlocks = [];
    insertedNodesWithPos.forEach(({ node: node, pos: pos })=>{
        const localId = $a1429e5b2d8791eb$export$957229695d10ea4a(node);
        if (!localId) return;
        insertedLocalIds.add(localId);
        if (!removedFromChangedRangesLocalIds.has(localId)) insertedCodeBlocks.push({
            localId: localId,
            node: node,
            pos: pos
        });
    });
    const deletedLocalIds = new Set();
    removedFromChangedRangesLocalIds.forEach((localId)=>{
        if (!insertedLocalIds.has(localId)) deletedLocalIds.add(localId);
    });
    return {
        deletedLocalIds: deletedLocalIds,
        insertedCodeBlocks: insertedCodeBlocks
    };
};
const $a1429e5b2d8791eb$export$e9e91d763bd6702f = (tr, pluginState)=>{
    const { codeBlock: codeBlock } = tr.doc.type.schema.nodes;
    const isPaste = tr.getMeta('paste') === true || tr.getMeta('uiEvent') === 'paste';
    const isExternalContentChange = tr.getMeta('replaceDocument') === true || tr.getMeta('isRemote') === true;
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    const isUndo = $a1429e5b2d8791eb$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const hasTrackedEntries = Object.keys(pluginState.languageDetectionMap).length > 0;
    // Page loads and remote edits should not start auto-detection for code blocks.
    if (!hasTrackedEntries && isExternalContentChange) return pluginState.languageDetectionMap;
    // Existing entries still need mapping/deletion cleanup, but external edits should not refresh text.
    const changedCodeBlockNodes = isExternalContentChange ? [] : (0, $9c52569c583a8f61$export$3fa3c149b89781e7)(tr);
    if (!hasTrackedEntries && !changedCodeBlockNodes.length) return pluginState.languageDetectionMap;
    const { deletedLocalIds: deletedLocalIds, insertedCodeBlocks: insertedCodeBlocks } = $a1429e5b2d8791eb$var$getCodeBlockTransactionChanges(tr, codeBlock);
    let languageDetectionMap = hasTrackedEntries ? Object.fromEntries(Object.entries(pluginState.languageDetectionMap).map(([localId, entry])=>[
            localId,
            {
                ...entry,
                pos: tr.mapping.map(entry.pos)
            }
        ])) : pluginState.languageDetectionMap;
    if (!isExternalContentChange) {
        insertedCodeBlocks.forEach(({ localId: localId, node: node, pos: pos })=>{
            if (node.attrs.language) {
                languageDetectionMap = $a1429e5b2d8791eb$export$8e484f7dcf239a78(languageDetectionMap, localId);
                return;
            }
            languageDetectionMap = $a1429e5b2d8791eb$export$82bdb85239e6f0b5(languageDetectionMap, node, pos, $a1429e5b2d8791eb$export$a5224da7b01ec0b7(node.textContent));
        });
        changedCodeBlockNodes.forEach(({ node: node, pos: pos })=>{
            const localId = $a1429e5b2d8791eb$export$957229695d10ea4a(node);
            if (!localId || !languageDetectionMap[localId]) return;
            const currentLanguage = node.attrs.language;
            const previousEntry = languageDetectionMap[localId];
            // Undo metadata does not identify the changed node; compare the pre/post language
            // so text undo inside auto-detection mode keeps the entry.
            const previousLanguage = isUndo ? tr.before.nodeAt(tr.mapping.invert().map(pos))?.attrs.language : undefined;
            if (isUndo && previousLanguage && !currentLanguage || currentLanguage && currentLanguage !== previousEntry.autoDetectedLanguage) {
                languageDetectionMap = $a1429e5b2d8791eb$export$8e484f7dcf239a78(languageDetectionMap, localId);
                return;
            }
            const text = node.textContent;
            const firstLine = $a1429e5b2d8791eb$export$1c51de8940db13e0(text);
            const shouldTriggerDetection = previousEntry.isPending || isPaste || firstLine !== previousEntry.lastObservedFirstLine || $a1429e5b2d8791eb$export$75fa5ee64c376b5c(previousEntry.lastObservedText, text);
            const isPending = $a1429e5b2d8791eb$export$a5224da7b01ec0b7(text) && shouldTriggerDetection;
            // Only pending detection refreshes the text snapshot; otherwise gradual typing
            // should continue comparing against the last attempted detection.
            languageDetectionMap = isPending ? $a1429e5b2d8791eb$export$82bdb85239e6f0b5(languageDetectionMap, node, pos, true) : {
                ...languageDetectionMap,
                [localId]: {
                    ...previousEntry,
                    isPending: false,
                    pos: pos
                }
            };
        });
    }
    deletedLocalIds.forEach((localId)=>{
        if (languageDetectionMap[localId]) languageDetectionMap = $a1429e5b2d8791eb$export$8e484f7dcf239a78(languageDetectionMap, localId);
    });
    return languageDetectionMap;
};


const $be654b6d9efea752$export$44b4779780b25933 = (editorAnalyticsAPI)=>{
    return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })($be654b6d9efea752$export$e635d7f974817375);
};
const $be654b6d9efea752$export$e635d7f974817375 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    if (dispatch) {
        let removeTr = tr;
        if ((0, $bjg0G.findSelectedNodeOfType)(nodes.codeBlock)(tr.selection)) removeTr = (0, $bjg0G.removeSelectedNode)(tr);
        else removeTr = (0, $bjg0G.removeParentNodeOfType)(nodes.codeBlock)(tr);
        dispatch(removeTr);
    }
    return true;
};
const $be654b6d9efea752$export$61465194746e7fd2 = (editorAnalyticsAPI)=>(language, selectionSource)=>(state, dispatch)=>{
            const { codeBlock: codeBlock } = state.schema.nodes;
            const pos = (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state)?.pos;
            if (typeof pos !== 'number') return false;
            const node = state.doc.nodeAt(pos);
            const localId = node?.attrs.localId;
            const shouldIncludeAutoDetectionContext = (0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_code_block_language_detection_flow');
            const previousAutoDetectEntry = shouldIncludeAutoDetectionContext ? (0, $4883cccd24c030e0$export$264979d19e499e37).getState(state)?.languageDetectionMap[localId] : undefined;
            const tr = state.tr.setNodeMarkup(pos, codeBlock, {
                ...node?.attrs,
                language: language
            }).setMeta('scrollIntoView', false);
            if (shouldIncludeAutoDetectionContext) tr.setMeta((0, $4883cccd24c030e0$export$264979d19e499e37), {
                type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).REMOVE_AUTO_DETECT_ENTRY,
                data: {
                    localId: localId
                }
            });
            const selection = (0, $bjg0G.isNodeSelection)(state.selection) ? (0, $kCECX.NodeSelection).create(tr.doc, pos) : tr.selection;
            const result = tr.setSelection(selection);
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).LANGUAGE_SELECTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).CODE_BLOCK,
                    attributes: {
                        language: language ?? 'none',
                        ...selectionSource ? {
                            selectionSource: selectionSource
                        } : {},
                        ...shouldIncludeAutoDetectionContext ? {
                            autoDetectionResult: previousAutoDetectEntry?.detectionResult,
                            autoDetectedLanguage: previousAutoDetectEntry?.autoDetectedLanguage
                        } : {}
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(result);
                dispatch(result);
            }
            return true;
        };
const $be654b6d9efea752$export$ae9ea24a1b29b07c = ()=>(state, dispatch)=>{
        const pos = (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state)?.pos;
        if (typeof pos !== 'number') return false;
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        const localId = (0, $a1429e5b2d8791eb$export$957229695d10ea4a)(node);
        if (!localId) return false;
        const autoDetectState = (0, $4883cccd24c030e0$export$264979d19e499e37).getState(state);
        const previousEntry = autoDetectState?.languageDetectionMap[localId];
        const entry = (0, $a1429e5b2d8791eb$export$ebf3c95b2e36b335)(node, pos, (0, $a1429e5b2d8791eb$export$a5224da7b01ec0b7)(node.textContent), previousEntry, {
            preserveDetectionResult: false
        });
        const tr = state.tr.setNodeMarkup(pos, state.schema.nodes.codeBlock, {
            ...node.attrs,
            language: null
        }).setMeta((0, $4883cccd24c030e0$export$264979d19e499e37), {
            type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_AUTO_DETECT_ENTRY,
            data: {
                localId: localId,
                entry: entry
            }
        }).setMeta('scrollIntoView', false);
        const selection = (0, $bjg0G.isNodeSelection)(state.selection) ? (0, $kCECX.NodeSelection).create(tr.doc, pos) : tr.selection;
        const result = tr.setSelection(selection);
        if (dispatch) dispatch(result);
        return true;
    };
const $be654b6d9efea752$var$setResolveFormatCodeMeta = (tr, { languageSource: languageSource, localId: localId, outcome: outcome, requestId: requestId, errorType: errorType })=>tr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
        type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).RESOLVE_FORMAT_CODE,
        data: {
            languageSource: languageSource,
            localId: localId,
            outcome: outcome,
            requestId: requestId,
            ...errorType ? {
                errorType: errorType
            } : {}
        }
    });
const $be654b6d9efea752$var$replaceCodeBlockText = ({ codeBlockNode: codeBlockNode, content: content, pos: pos, tr: tr })=>{
    const from = pos + 1;
    const to = pos + codeBlockNode.nodeSize - 1;
    tr.delete(from, to);
    if (content) tr.insertText(content, from);
    // The editor scroll plugin scrolls doc-changing transactions by default.
    return tr.setMeta('scrollIntoView', false);
};
const $be654b6d9efea752$var$attachFormatCodeAnalytics = ({ editorAnalyticsAPI: editorAnalyticsAPI, languageSource: languageSource, result: result, tr: tr })=>{
    if (result.status === 'failed') {
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CODE_BLOCK,
            attributes: {
                errorType: result.errorType,
                language: result.language,
                languageSource: languageSource
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return;
    }
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            language: result.language,
            languageSource: languageSource,
            outcome: result.status
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
};
const $be654b6d9efea752$var$createResolveFormatCodeTransaction = ({ editorAnalyticsAPI: editorAnalyticsAPI, localId: localId, pendingFormat: pendingFormat, result: result, tr: tr })=>{
    const { languageSource: languageSource, requestId: requestId } = pendingFormat;
    const codeBlockNode = tr.doc.nodeAt(pendingFormat.pos);
    const hasMatchingCodeBlock = codeBlockNode?.type === tr.doc.type.schema.nodes.codeBlock && codeBlockNode?.attrs.localId === localId;
    if (!hasMatchingCodeBlock) {
        // Keep failure telemetry even when the target block is no longer available.
        if (result.status === 'failed') $be654b6d9efea752$var$attachFormatCodeAnalytics({
            editorAnalyticsAPI: editorAnalyticsAPI,
            languageSource: languageSource,
            result: result,
            tr: tr
        });
        return $be654b6d9efea752$var$setResolveFormatCodeMeta(tr, {
            languageSource: languageSource,
            localId: localId,
            outcome: 'unchanged',
            requestId: requestId
        });
    }
    let resultTransaction = tr;
    if (result.status === 'formatted') resultTransaction = $be654b6d9efea752$var$replaceCodeBlockText({
        codeBlockNode: codeBlockNode,
        content: result.content,
        pos: pendingFormat.pos,
        tr: tr
    });
    $be654b6d9efea752$var$attachFormatCodeAnalytics({
        editorAnalyticsAPI: editorAnalyticsAPI,
        languageSource: languageSource,
        result: result,
        tr: resultTransaction
    });
    return $be654b6d9efea752$var$setResolveFormatCodeMeta(resultTransaction, {
        errorType: result.status === 'failed' ? result.errorType : undefined,
        languageSource: languageSource,
        localId: localId,
        outcome: result.status,
        requestId: requestId
    });
};
const $be654b6d9efea752$export$7f5d8563b7e51b88 = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, formatCodeProvider: formatCodeProvider })=>(state, dispatch)=>{
        if (!formatCodeProvider) return false;
        const currentCodeBlockState = (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state);
        const currentPos = currentCodeBlockState?.pos;
        if (!currentCodeBlockState || typeof currentPos !== 'number') return false;
        const currentNode = state.doc.nodeAt(currentPos);
        if (!currentNode || currentNode.type !== state.schema.nodes.codeBlock) return false;
        const currentLanguage = currentNode.attrs.language ?? '';
        const currentLocalId = currentNode.attrs.localId;
        if (currentCodeBlockState.pendingFormats[currentLocalId]) return true;
        const autoDetectEntry = (0, $4883cccd24c030e0$export$264979d19e499e37).getState(state)?.languageDetectionMap[currentLocalId];
        const languageSource = autoDetectEntry?.autoDetectedLanguage === currentLanguage ? 'auto-detected' : 'selected';
        const content = currentNode.textContent;
        const requestId = crypto.randomUUID();
        api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
                type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).START_FORMAT_CODE,
                data: {
                    languageSource: languageSource,
                    localId: currentLocalId,
                    pos: currentPos,
                    requestId: requestId
                }
            }));
        formatCodeProvider.formatCode({
            content: content,
            language: currentLanguage
        }).catch(()=>({
                errorType: 'formatter-execution-failed',
                language: currentLanguage,
                status: 'failed'
            })).then((result)=>{
            const pendingFormat = api?.codeBlock?.sharedState.currentState()?.pendingFormats[currentLocalId];
            if (!pendingFormat || pendingFormat.requestId !== requestId) return;
            api?.core?.actions.execute(({ tr: tr })=>$be654b6d9efea752$var$createResolveFormatCodeTransaction({
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    localId: currentLocalId,
                    pendingFormat: pendingFormat,
                    result: result,
                    tr: tr
                }));
        });
        return true;
    };
const $be654b6d9efea752$export$50ffc017f5e54c0 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const codeBlock = (0, $bjg0G.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
        const textContent = codeBlock && codeBlock.node.textContent;
        if (textContent) {
            (0, $jfFbl.copyToClipboard)(textContent);
            const copyToClipboardTr = tr;
            copyToClipboardTr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
                type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD,
                data: true
            });
            copyToClipboardTr.setMeta((0, $7996c95e1ce4924a$export$97324d26e7dfa2c5), 'remove-selection');
            if (editorAnalyticsAPI) {
                const analyticsPayload = (0, $jfFbl.getAnalyticsPayload)(state, (0, $krYZG.ACTION).COPIED);
                if (analyticsPayload) {
                    analyticsPayload.attributes.inputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
                    analyticsPayload.attributes.nodeType = codeBlock?.node.type.name;
                    editorAnalyticsAPI.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
                }
            }
            if (dispatch) dispatch(copyToClipboardTr);
        }
        return true;
    };
const $be654b6d9efea752$export$859674cc23da4522 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    const codeBlock = (0, $bjg0G.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
    const textContent = codeBlock && codeBlock.node.textContent;
    if (textContent) {
        (0, $jfFbl.copyToClipboard)(textContent);
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
            type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD,
            data: true
        });
        copyToClipboardTr.setMeta((0, $7996c95e1ce4924a$export$97324d26e7dfa2c5), 'remove-selection');
        if (dispatch) dispatch(copyToClipboardTr);
    }
    return true;
};
const $be654b6d9efea752$export$3e0b07341e7576a = (state, dispatch)=>{
    const { tr: tr } = state;
    const codeBlockState = (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state);
    const resetCopiedStateTr = tr;
    if (codeBlockState && codeBlockState.contentCopied) {
        resetCopiedStateTr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
            type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD,
            data: false
        });
        resetCopiedStateTr.setMeta((0, $7996c95e1ce4924a$export$97324d26e7dfa2c5), 'remove-selection');
        if (dispatch) dispatch(resetCopiedStateTr);
    } else {
        const clearSelectionStateTransaction = state.tr;
        clearSelectionStateTransaction.setMeta((0, $7996c95e1ce4924a$export$97324d26e7dfa2c5), 'remove-selection');
        // note: dispatch should always be defined when called from the
        // floating toolbar. Howver the Command type which floating toolbar uses
        // (and resetCopiedState) uses suggests it's optional.
        if (dispatch) dispatch(clearSelectionStateTransaction);
    }
    return true;
};
const $be654b6d9efea752$export$e6e93d61d1873d0c = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
        type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: true
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
const $be654b6d9efea752$export$60364cd5f5fed191 = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
        type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: false
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
function $be654b6d9efea752$export$c875ffe428b4a5f({ state: state }) {
    let { tr: tr } = state;
    const { from: from } = state.selection;
    const { codeBlock: codeBlock } = state.schema.nodes;
    const codeBlockAttrs = (0, $6gBg9.getDefaultCodeBlockAttrs)();
    const grandParentNode = state.selection.$from.node(-1);
    const grandParentNodeType = grandParentNode?.type;
    const parentNodeType = state.selection.$from.parent.type;
    /** We always want to append a codeBlock unless we're inserting into a paragraph
   * AND it's a valid child of the grandparent node.
   * Insert the current selection as codeBlock content unless it contains nodes other
   * than paragraphs and inline.
   */ const canInsertCodeBlock = (0, $8tXCb.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: codeBlock.createAndFill()
    }) && (0, $8tXCb.contentAllowedInCodeBlock)(state);
    if (canInsertCodeBlock) tr = (0, $39d747feddc6695d$export$92adcb8baa0906a6)(state, from, codeBlockAttrs);
    else (0, $bjg0G.safeInsert)(codeBlock.createAndFill(codeBlockAttrs))(tr).scrollIntoView();
    return tr;
}
function $be654b6d9efea752$export$c0fb2037bfcf75f4({ analyticsAPI: analyticsAPI, inputMethod: inputMethod, state: state }) {
    const tr = $be654b6d9efea752$export$c875ffe428b4a5f({
        state: state
    });
    analyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
    return tr;
}
function $be654b6d9efea752$export$a8d9c0f039b6fb43(inputMethod, analyticsAPI) {
    return (0, $eEdSM.withAnalytics)(analyticsAPI, {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        const tr = $be654b6d9efea752$export$c875ffe428b4a5f({
            state: state
        });
        if (dispatch) dispatch(tr);
        return true;
    });
}
const $be654b6d9efea752$export$160d674382436f98 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const codeBlock = (0, $hgAxn.findCodeBlock)(state);
        const codeBlockNode = codeBlock?.node;
        const { tr: tr } = state;
        if (!(0, $6gBg9.codeBlockWrappedStates) || !codeBlockNode) return false;
        const updatedToggleState = !(0, $6gBg9.isCodeBlockWordWrapEnabled)(codeBlockNode);
        if ((0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) tr.setNodeMarkup(codeBlock.pos, undefined, {
            ...codeBlockNode.attrs,
            wrap: updatedToggleState
        }).setMeta('scrollIntoView', false);
        else (0, $6gBg9.codeBlockWrappedStates).set(codeBlockNode, updatedToggleState);
        tr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
            type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_IS_WRAPPED,
            data: updatedToggleState
        });
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).TOGGLE_CODE_BLOCK_WRAP,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    platform: (0, $iLcY8.PLATFORMS).WEB,
                    mode: (0, $iLcY8.MODE).EDITOR,
                    wordWrapEnabled: updatedToggleState,
                    codeBlockNodeSize: codeBlockNode.nodeSize
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $be654b6d9efea752$export$86e84eec7e5dd9ff = (editorAnalyticsAPI)=>({ tr: tr })=>{
        const { codeBlock: codeBlockType } = tr.doc.type.schema.nodes;
        const codeBlock = (0, $bjg0G.findSelectedNodeOfType)(codeBlockType)(tr.selection) || (0, $bjg0G.findParentNodeOfType)(codeBlockType)(tr.selection);
        if (!codeBlock) return null;
        const codeBlockNode = codeBlock.node;
        const lineNumbersHidden = !Boolean(codeBlockNode.attrs.hideLineNumbers);
        tr.setNodeMarkup(codeBlock.pos, undefined, {
            ...codeBlockNode.attrs,
            hideLineNumbers: lineNumbersHidden
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).TOGGLE_CODE_BLOCK_LINE_NUMBERS,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CODE_BLOCK,
            attributes: {
                platform: (0, $iLcY8.PLATFORMS).WEB,
                lineNumbersHidden: lineNumbersHidden,
                codeBlockNodeSize: codeBlockNode.nodeSize
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $be654b6d9efea752$export$5d4256781e1f4071 = (editorAnalyticsAPI)=>(0, $aC6bW.editorCommandToPMCommand)($be654b6d9efea752$export$86e84eec7e5dd9ff(editorAnalyticsAPI));












/* eslint-disable require-unicode-regexp */ // Conservative weighted-regex heuristic for common high-confidence snippets, not a full classifier.
// Ambiguous snippets intentionally return null so users can select the language manually.
const $a287b221060c2b56$var$MAX_DETECTION_CHARS = 10000;
const $a287b221060c2b56$var$MIN_DETECTION_SCORE = 3; // Require at least one medium-confidence signal before auto-selecting.
const $a287b221060c2b56$var$MIN_SCORE_GAP = 2; // Avoid auto-selecting when top two languages are too close to distinguish.
// looksLikeJson regexes
const $a287b221060c2b56$var$JSON_START_REGEX = /^[{[]/;
const $a287b221060c2b56$var$JSON_END_REGEX = /[}\]]$/;
// html regexes
const $a287b221060c2b56$var$HTML_DOCTYPE_REGEX = /<!doctype\s+html/i;
const $a287b221060c2b56$var$HTML_TAG_REGEX = /<\/?(?:html|head|body|div|span|script|style|section|template)\b/i;
// css regexes
const $a287b221060c2b56$var$CSS_AT_RULE_REGEX = /@[\w-]+\s+[^{]+\{/;
const $a287b221060c2b56$var$CSS_SELECTOR_PROPERTY_REGEX = /[.#]?[-_a-zA-Z][-_a-zA-Z0-9\s,.:#>+~*\[\]='"]+\{[^}]*\b(?:color|display|margin|padding|font|background|border|width|height|grid|flex)\s*:/;
const $a287b221060c2b56$var$CSS_PROPERTY_REGEX = /\b(?:color|display|margin|padding|font-size|background|border|width|height)\s*:\s*[^;{}]+;/;
// sql regexes
const $a287b221060c2b56$var$SQL_SELECT_FROM_REGEX = /\bSELECT\b[\s\S]+\bFROM\b/i;
const $a287b221060c2b56$var$SQL_DML_REGEX = /\b(?:INSERT\s+INTO|UPDATE\b[\s\S]+\bSET\b|DELETE\s+FROM|CREATE\s+TABLE|ALTER\s+TABLE)\b/i;
const $a287b221060c2b56$var$SQL_CLAUSE_REGEX = /\b(?:JOIN|WHERE|GROUP\s+BY|ORDER\s+BY|LIMIT)\b/i;
// typescript regexes
const $a287b221060c2b56$var$TS_INTERFACE_TYPE_REGEX = /\b(?:interface|type)\s+[A-Z_$][\w$]*(?:\s*[=<{])/;
const $a287b221060c2b56$var$TS_IMPORT_EXPORT_TYPE_REGEX = /\bimport\s+type\b|\bexport\s+type\b/;
const $a287b221060c2b56$var$TS_TYPED_VAR_REGEX = /\b(?:const|let|var)\s+[\w$]+\s*:\s*[A-Za-z_$][\w$<>|\[\],\s]*/;
const $a287b221060c2b56$var$TS_RETURN_TYPE_REGEX = /\)\s*:\s*(?:Promise<)?[A-Za-z_$][\w$<>|\[\],\s]*(?:>|\s)?\s*=>?\s*[{;]/;
const $a287b221060c2b56$var$TS_ADVANCED_REGEX = /\b(?:as\s+const|implements\s+[A-Z_$]|enum\s+[A-Z_$])/;
const $a287b221060c2b56$var$TS_ACCESS_MODIFIER_REGEX = /\b(?:private|protected|public|readonly)\s+[\w$]+\s*=/;
const $a287b221060c2b56$var$TS_TYPED_ARROW_PARAM_REGEX = /\([^)]{0,500}\b[\w$]+\??:\s*[A-Za-z_$][\w$<>{}\[\]|&,\s.?]{0,200}[^)]{0,500}\)\s*(?::\s*[A-Za-z_$][\w$<>{}\[\]|&,\s.?]{0,200})?\s*=>/;
// javascript regexes
const $a287b221060c2b56$var$JS_VAR_REGEX = /\b(?:const|let|var)\s+[\w$]+\s*=/;
const $a287b221060c2b56$var$JS_FUNCTION_REGEX = /\bfunction\s*[\w$]*\s*\([^)]*\)\s*\{/;
const $a287b221060c2b56$var$JS_ARROW_REGEX = /=>\s*(?:\{|[\w$'"`(])/;
const $a287b221060c2b56$var$JS_IMPORT_EXPORT_REGEX = /\b(?:import|export)\s+(?:[\w${}*,\s]+\s+from\s+)?['"][^'"]+['"]/;
const $a287b221060c2b56$var$JS_COMMON_API_REGEX = /\b(?:console\.log|document\.|window\.|require\()|\bmodule\.exports\b/;
// python regexes
const $a287b221060c2b56$var$PY_DEF_REGEX = /^\s*def\s+[a-zA-Z_]\w*\([^)]*\)\s*:/m;
const $a287b221060c2b56$var$PY_CLASS_REGEX = /^\s*class\s+[A-Z_]\w*(?:\([^)]*\))?\s*:/m;
const $a287b221060c2b56$var$PY_IMPORT_REGEX = /^\s*(?:from\s+[\w.]+\s+import\s+\w+|import\s+[\w.]+)/m;
const $a287b221060c2b56$var$PY_CONTROL_REGEX = /^\s*(?:if|elif|else|for|while|try|except)\b[^\n]*:\s*$/m;
const $a287b221060c2b56$var$PY_PRINT_REGEX = /\bprint\([^)]*\)/;
// java regexes
const $a287b221060c2b56$var$JAVA_CLASS_REGEX = /\bpublic\s+(?:final\s+)?class\s+[A-Z]\w*/;
const $a287b221060c2b56$var$JAVA_MAIN_REGEX = /\bpublic\s+static\s+void\s+main\s*\(\s*String\[\]/;
const $a287b221060c2b56$var$JAVA_PRINTLN_REGEX = /\bSystem\.out\.println\s*\(/;
const $a287b221060c2b56$var$JAVA_MEMBER_REGEX = /\b(?:private|protected|public)\s+(?:static\s+)?(?:final\s+)?[A-Z]\w*(?:<[^>]+>)?\s+\w+\s*[;(=]/;
// go regexes
const $a287b221060c2b56$var$GO_PACKAGE_REGEX = /^\s*package\s+\w+/m;
const $a287b221060c2b56$var$GO_FUNC_REGEX = /\bfunc\s+(?:\([^)]*\)\s*)?[A-Za-z_]\w*\s*\([^)]*\)\s*(?:[A-Za-z_*\[\]]+\s*)?\{/;
const $a287b221060c2b56$var$GO_PRINTLN_REGEX = /\bfmt\.(?:Println|Printf)\s*\(/;
const $a287b221060c2b56$var$GO_IMPORT_REGEX = /\bimport\s+\(\s*[\s\S]*?\)/;
// ruby regexes
const $a287b221060c2b56$var$RUBY_DEF_REGEX = /^\s*def\s+[a-z_]\w*[!?=]?/m;
const $a287b221060c2b56$var$RUBY_CLASS_REGEX = /^\s*class\s+[A-Z]\w*(?:\s*<\s*[A-Z]\w*)?/m;
const $a287b221060c2b56$var$RUBY_END_REGEX = /^\s*end\s*$/m;
const $a287b221060c2b56$var$RUBY_COMMON_API_REGEX = /\b(?:puts|require|attr_reader|attr_accessor)\b/;
const $a287b221060c2b56$var$RUBY_BLOCK_REGEX = /\bdo\s*\|[^|]+\|/;
// rust regexes
const $a287b221060c2b56$var$RUST_FN_REGEX = /\bfn\s+[a-z_]\w*\s*\([^)]*\)\s*(?:->\s*[A-Za-z_:<>]+\s*)?\{/;
const $a287b221060c2b56$var$RUST_LET_MUT_REGEX = /\blet\s+mut\s+\w+/;
const $a287b221060c2b56$var$RUST_PRINTLN_REGEX = /\bprintln!\s*\(/;
const $a287b221060c2b56$var$RUST_USE_REGEX = /\buse\s+(?:std|crate|super)::/;
const $a287b221060c2b56$var$RUST_STRUCT_REGEX = /\b(?:impl|pub\s+struct|enum)\s+[A-Z]\w*/;
// shell regexes
const $a287b221060c2b56$var$SHELL_SHEBANG_REGEX = /^#!\/usr\/bin\/(?:env\s+)?(?:ba|z|k)?sh\b/m;
const $a287b221060c2b56$var$SHELL_CONTROL_REGEX = /^\s*(?:if|for|while)\b[\s\S]+\b(?:then|do)\b/m;
const $a287b221060c2b56$var$SHELL_FI_DONE_REGEX = /^\s*(?:fi|done)\s*$/m;
const $a287b221060c2b56$var$SHELL_COMMAND_REGEX = /\b(?:echo|export|cd|grep|sed|awk|curl)\b[\s\S]*(?:\$\w+|&&|\|)/;
const $a287b221060c2b56$var$SHELL_VAR_REGEX = /\$\{?[A-Z_][A-Z0-9_]*\}?/;
const $a287b221060c2b56$var$hasPattern = (code, pattern)=>{
    // Reset stateful regexes so repeated tests always start at the beginning.
    pattern.lastIndex = 0;
    return pattern.test(code);
};
const $a287b221060c2b56$var$scorePatterns = (code, patterns)=>patterns.reduce((score, [pattern, value])=>score + ($a287b221060c2b56$var$hasPattern(code, pattern) ? value : 0), 0);
const $a287b221060c2b56$var$looksLikeHtmlTagPair = (code)=>{
    const openTags = new Set();
    // Ignored via go/ees019
    // eslint-disable-next-line e18e/prefer-static-regex
    const tagPattern = /<\/?([a-z][a-z0-9-]*)\b[^<>]{0,500}>/gi;
    let match;
    while((match = tagPattern.exec(code)) !== null){
        const [tag, tagName] = match;
        if (tag.endsWith('/>')) continue;
        if (tag.startsWith('</')) {
            if (openTags.has(tagName.toLowerCase())) return true;
        } else openTags.add(tagName.toLowerCase());
    }
    return false;
};
const $a287b221060c2b56$var$looksLikeJson = (code)=>{
    const trimmed = code.trim();
    if (!$a287b221060c2b56$var$JSON_START_REGEX.test(trimmed) || !$a287b221060c2b56$var$JSON_END_REGEX.test(trimmed)) return false;
    try {
        const parsed = JSON.parse(trimmed);
        return parsed !== null && typeof parsed === 'object';
    } catch  {
        return false;
    }
};
const $a287b221060c2b56$var$getLanguageScores = (code)=>[
        {
            language: 'json',
            score: $a287b221060c2b56$var$looksLikeJson(code) ? 8 : 0
        },
        {
            language: 'html',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$HTML_DOCTYPE_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$HTML_TAG_REGEX,
                    2
                ]
            ]) + ($a287b221060c2b56$var$looksLikeHtmlTagPair(code) ? 3 : 0)
        },
        {
            language: 'css',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$CSS_AT_RULE_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$CSS_SELECTOR_PROPERTY_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$CSS_PROPERTY_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'sql',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$SQL_SELECT_FROM_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$SQL_DML_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$SQL_CLAUSE_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'typescript',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$TS_INTERFACE_TYPE_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$TS_IMPORT_EXPORT_TYPE_REGEX,
                    4
                ],
                [
                    $a287b221060c2b56$var$TS_TYPED_VAR_REGEX,
                    4
                ],
                [
                    $a287b221060c2b56$var$TS_RETURN_TYPE_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$TS_ADVANCED_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$TS_ACCESS_MODIFIER_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$TS_TYPED_ARROW_PARAM_REGEX,
                    5
                ]
            ])
        },
        {
            language: 'javascript',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$JS_VAR_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$JS_FUNCTION_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$JS_ARROW_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$JS_IMPORT_EXPORT_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$JS_COMMON_API_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'python',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$PY_DEF_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$PY_CLASS_REGEX,
                    4
                ],
                [
                    $a287b221060c2b56$var$PY_IMPORT_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$PY_CONTROL_REGEX,
                    2
                ],
                [
                    $a287b221060c2b56$var$PY_PRINT_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'java',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$JAVA_CLASS_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$JAVA_MAIN_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$JAVA_PRINTLN_REGEX,
                    4
                ],
                [
                    $a287b221060c2b56$var$JAVA_MEMBER_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'go',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$GO_PACKAGE_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$GO_FUNC_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$GO_PRINTLN_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$GO_IMPORT_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'ruby',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$RUBY_DEF_REGEX,
                    4
                ],
                [
                    $a287b221060c2b56$var$RUBY_CLASS_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$RUBY_END_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$RUBY_COMMON_API_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$RUBY_BLOCK_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'rust',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$RUST_FN_REGEX,
                    5
                ],
                [
                    $a287b221060c2b56$var$RUST_LET_MUT_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$RUST_PRINTLN_REGEX,
                    4
                ],
                [
                    $a287b221060c2b56$var$RUST_USE_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$RUST_STRUCT_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'shell',
            score: $a287b221060c2b56$var$scorePatterns(code, [
                [
                    $a287b221060c2b56$var$SHELL_SHEBANG_REGEX,
                    6
                ],
                [
                    $a287b221060c2b56$var$SHELL_CONTROL_REGEX,
                    4
                ],
                [
                    $a287b221060c2b56$var$SHELL_FI_DONE_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$SHELL_COMMAND_REGEX,
                    3
                ],
                [
                    $a287b221060c2b56$var$SHELL_VAR_REGEX,
                    2
                ]
            ])
        }
    ];
const $a287b221060c2b56$export$ae9ea24a1b29b07c = (code)=>{
    const trimmedCode = code.trim();
    if (trimmedCode.length < 8) return null;
    const codeForDetection = trimmedCode.slice(0, $a287b221060c2b56$var$MAX_DETECTION_CHARS);
    const [best, secondBest] = $a287b221060c2b56$var$getLanguageScores(codeForDetection).filter(({ score: score })=>score > 0).sort((a, b)=>b.score - a.score);
    if (!best || best.score < $a287b221060c2b56$var$MIN_DETECTION_SCORE) return null;
    if (secondBest && best.score - secondBest.score < $a287b221060c2b56$var$MIN_SCORE_GAP) return null;
    return best.language;
};


const $e0d76d062fda9bcf$var$AUTO_DETECT_DEBOUNCE_MS = 500;
// Stored positions are mapped through transactions; verify the localId before using them.
const $e0d76d062fda9bcf$var$getCodeBlockFromEntry = (view, localId, entry)=>{
    const node = view.state.doc.nodeAt(entry.pos);
    const codeBlockType = view.state.schema.nodes.codeBlock;
    if (node?.type === codeBlockType && node.attrs.localId === localId) return {
        node: node,
        pos: entry.pos
    };
    return null;
};
// Runs after debounce, so it must re-read current editor state before applying language changes.
const $e0d76d062fda9bcf$var$runPendingDetection = (view, localId, api)=>{
    const pluginState = (0, $4883cccd24c030e0$export$264979d19e499e37).getState(view.state);
    const entry = pluginState?.languageDetectionMap[localId];
    if (!entry?.isPending) return;
    const found = $e0d76d062fda9bcf$var$getCodeBlockFromEntry(view, localId, entry);
    if (!found) return;
    const detectedLanguage = (0, $a287b221060c2b56$export$ae9ea24a1b29b07c)(found.node.textContent);
    const detectionResult = detectedLanguage ? 'detected' : 'noneDetected';
    const detectionPhase = entry.detectionResult ? 'redetection' : 'initial';
    // Keep a previous auto-detected language when the latest snippet is too weak to classify.
    const shouldPreserveAutoDetectedLanguage = !detectedLanguage && Boolean(entry.autoDetectedLanguage) && found.node.attrs.language === entry.autoDetectedLanguage;
    const nextEntry = {
        ...(0, $a1429e5b2d8791eb$export$ebf3c95b2e36b335)(found.node, found.pos, false, entry),
        detectionResult: detectionResult,
        autoDetectedLanguage: detectedLanguage ?? entry.autoDetectedLanguage
    };
    const hasDetectedLanguageChange = Boolean(detectedLanguage) && found.node.attrs.language !== detectedLanguage;
    const shouldClearStaleLanguage = !detectedLanguage && Boolean(found.node.attrs.language) && !shouldPreserveAutoDetectedLanguage;
    const shouldUpdateNodeLanguage = hasDetectedLanguageChange || shouldClearStaleLanguage;
    api?.core?.actions.execute(({ tr: tr })=>{
        if (shouldUpdateNodeLanguage) {
            tr.setNodeMarkup(found.pos, undefined, {
                ...found.node.attrs,
                language: detectedLanguage
            }, found.node.marks);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).LANGUAGE_AUTO_DETECTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    language: detectedLanguage ?? 'none',
                    detectionResult: detectionResult,
                    detectionPhase: detectionPhase
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
        }
        tr.setMeta((0, $4883cccd24c030e0$export$264979d19e499e37), {
            type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_AUTO_DETECT_ENTRY,
            data: {
                localId: localId,
                entry: nextEntry
            }
        });
        // Language detection runs in the background and should not move the viewport.
        return tr.setMeta('scrollIntoView', false);
    });
};
const $e0d76d062fda9bcf$var$clearTimer = (timers, localId)=>{
    const scheduledDetection = timers.get(localId);
    if (scheduledDetection) {
        clearTimeout(scheduledDetection.timer);
        timers.delete(localId);
    }
};
const $e0d76d062fda9bcf$export$294a2b069616ba23 = (view, timers, api)=>{
    const pluginState = (0, $4883cccd24c030e0$export$264979d19e499e37).getState(view.state);
    const pendingEntries = Object.entries(pluginState?.languageDetectionMap ?? {}).filter(([, entry])=>entry.isPending);
    const pendingLocalIds = new Set(pendingEntries.map(([localId])=>localId));
    pendingEntries.forEach(([localId, entry])=>{
        const scheduledDetection = timers.get(localId);
        if (scheduledDetection?.lastObservedText === entry.lastObservedText) return;
        $e0d76d062fda9bcf$var$clearTimer(timers, localId);
        const timer = setTimeout(()=>{
            timers.delete(localId);
            $e0d76d062fda9bcf$var$runPendingDetection(view, localId, api);
        }, $e0d76d062fda9bcf$var$AUTO_DETECT_DEBOUNCE_MS);
        timers.set(localId, {
            lastObservedText: entry.lastObservedText,
            timer: timer
        });
    });
    timers.forEach((_, localId)=>{
        if (!pendingLocalIds.has(localId)) $e0d76d062fda9bcf$var$clearTimer(timers, localId);
    });
};




const $ad9bed998b476c35$export$d5142f5b34a5c85b = (api)=>new (0, $kpCD8.SafePlugin)({
        key: (0, $4883cccd24c030e0$export$264979d19e499e37),
        state: {
            init () {
                return {
                    languageDetectionMap: {}
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $4883cccd24c030e0$export$264979d19e499e37));
                let languageDetectionMap = tr.docChanged ? (0, $a1429e5b2d8791eb$export$e9e91d763bd6702f)(tr, pluginState) : pluginState.languageDetectionMap;
                if (meta?.type === (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_AUTO_DETECT_ENTRY) languageDetectionMap = {
                    ...languageDetectionMap,
                    [meta.data.localId]: meta.data.entry
                };
                else if (meta?.type === (0, $89c889278dbe2765$export$92a1a3b7554e9387).REMOVE_AUTO_DETECT_ENTRY) languageDetectionMap = (0, $a1429e5b2d8791eb$export$8e484f7dcf239a78)(languageDetectionMap, meta.data.localId);
                if (languageDetectionMap === pluginState.languageDetectionMap) return pluginState;
                return {
                    languageDetectionMap: languageDetectionMap
                };
            }
        },
        view (view) {
            const timers = new Map();
            return {
                update () {
                    (0, $e0d76d062fda9bcf$export$294a2b069616ba23)(view, timers, api);
                },
                destroy () {
                    timers.forEach(({ timer: timer })=>clearTimeout(timer));
                    timers.clear();
                }
            };
        }
    });



var $8dxef = parcelRequire("8dxef");













const $b585f2453e848da1$export$6114c8149cd0d98e = new (0, $kCECX.PluginKey)('codeBlockAutoFullStopTransformPluginKey');
function $b585f2453e848da1$export$67e82b3aa944d041() {
    return new (0, $kpCD8.SafePlugin)({
        key: $b585f2453e848da1$export$6114c8149cd0d98e,
        appendTransaction (_transactions, oldState, newState) {
            if (!(0, $iDrrr.fg)('code_block_auto_insertion_bug_fix')) return undefined;
            // We need to compare the old and new state to isloate auto insertion of fullstop on mac
            const { tr: trNew } = newState;
            const { tr: trOld } = oldState;
            const { from: fromOld } = trOld.selection;
            const { from: fromNew, to: toNew } = trNew.selection;
            const isCodeBlock = !!(0, $hgAxn.findCodeBlock)(oldState, trOld.selection) && !!(0, $hgAxn.findCodeBlock)(newState, trNew.selection);
            const browser = (0, $8dxef.getBrowserInfo)();
            /**
			 * Mac will auto insert a fullstop when the user double taps the space key after some content.
			 * Line number decorators are assumed content so on new lines the fullstop is inserted.
			 *
			 * - When a fulltop is auto inserted the new states selection is the same, the old state selection is one position less
			 * - The text returned for the old state returns as a space with the selection from - 1
			 * - The text returned for the new state returns as a fullstop with the selection from - 2 to from -1
			 *
			 * This is enough conditional logic to isoloate the auto insertion of the fullstop on mac
			 *
			 * There are some solutions to this problem in codemirror which can be read further here
			 * https://discuss.codemirror.net/t/dot-being-added-when-pressing-space-repeatedly/3899
			 */ // both selections must be of code block early exit
            if (browser.mac && fromNew === toNew && fromNew === fromOld + 1 && isCodeBlock) // detect when '.' is inserted when the previous state was a space ' '
            try {
                const textBetweenBefore = trOld.doc.textBetween(fromOld - 1, fromOld); // ' '
                const textBetweenAfter = trNew.doc.textBetween(fromNew - 2, fromNew - 1); // '.'
                if (textBetweenBefore === ' ' && textBetweenAfter === '.') {
                    trNew.delete(fromNew - 2, fromNew); // remove the fullstop
                    trNew.insertText('  ', fromNew - 2); // insert double space
                    return trNew;
                }
            } catch (error) {
                // if for some reason textBetween fails, just return the new transaction as is by defaut.
                return undefined;
            }
            return undefined;
        }
    });
}







var $dTPhv = parcelRequire("dTPhv");


var $44cyU = parcelRequire("44cyU");







const $7b0f44d46516152c$export$94d363c96bda1dd9 = {
    '{': '}',
    '[': ']',
    '(': ')'
};
// when directly before a closing bracket
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b0f44d46516152c$var$CLOSING_BRACKET_REGEX = /^[}\])]/;
// exclusion: when directly before a non-whitespace character
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b0f44d46516152c$var$NON_WHITESPACE_AFTER_REGEX = /^[^\s]/;
const $7b0f44d46516152c$export$29c04e6b1b08e223 = (before, after)=>{
    // when directly before a closing bracket
    if ($7b0f44d46516152c$var$CLOSING_BRACKET_REGEX.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    if ($7b0f44d46516152c$var$NON_WHITESPACE_AFTER_REGEX.test(after)) return false;
    return true;
};
const $7b0f44d46516152c$export$a40becce5a71614c = (before, after)=>{
    const left = Object.keys($7b0f44d46516152c$export$94d363c96bda1dd9).find((item)=>before.endsWith(item));
    const right = left ? $7b0f44d46516152c$export$94d363c96bda1dd9[left] : undefined;
    const hasTrailingMatchingBracket = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingBracket: hasTrailingMatchingBracket
    };
};





var $iX5Ka = parcelRequire("iX5Ka");





const $a1a7544ebeb5819b$export$b54b55a89e362241 = (state)=>state.selection.$from.sameParent(state.selection.$to) && state.selection.$from.parent.type === state.schema.nodes.codeBlock;
const $a1a7544ebeb5819b$export$cecd33f3def3e129 = (state)=>!!(0, $9c52569c583a8f61$export$da3f040fb23d21f)(state.selection) && $a1a7544ebeb5819b$export$b54b55a89e362241(state);
const $a1a7544ebeb5819b$export$13a3ef35664ba7de = (state)=>{
    const { $from: $from } = state.selection;
    if ($from.nodeBefore && $from.nodeBefore.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const prevNewLineIndex = $from.nodeBefore.text.lastIndexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $from.nodeBefore.text.substring(prevNewLineIndex + 1),
            pos: $from.start() + prevNewLineIndex + 1
        };
    }
    return {
        text: '',
        pos: $from.pos
    };
};
const $a1a7544ebeb5819b$export$8291149050336443 = (state)=>{
    const { $to: $to } = state.selection;
    if ($to.nodeAfter && $to.nodeAfter.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextNewLineIndex = $to.nodeAfter.text.indexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $to.nodeAfter.text.substring(0, nextNewLineIndex >= 0 ? nextNewLineIndex : undefined),
            pos: nextNewLineIndex >= 0 ? $to.pos + nextNewLineIndex : $to.end()
        };
    }
    return {
        text: '',
        pos: $to.pos
    };
};
function $a1a7544ebeb5819b$export$64ccdebd7526708f(state) {
    const { pos: start } = $a1a7544ebeb5819b$export$13a3ef35664ba7de(state);
    const { pos: end } = $a1a7544ebeb5819b$export$8291149050336443(state);
    const text = state.doc.textBetween(start, end);
    return {
        text: text,
        start: start,
        end: end
    };
}
const $a1a7544ebeb5819b$export$7f5b487b51da88d0 = (text, callback)=>{
    let offset = 0;
    text.split('\n').forEach((line)=>{
        callback(line, offset);
        offset += line.length + 1;
    });
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a1a7544ebeb5819b$var$SPACE = {
    token: ' ',
    size: 2,
    regex: /[^ ]/
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a1a7544ebeb5819b$var$TAB = {
    token: '\t',
    size: 1,
    regex: /[^\t]/
};
const $a1a7544ebeb5819b$export$7af82191547c5ff7 = (line)=>{
    const indentToken = line.startsWith('\t') ? $a1a7544ebeb5819b$var$TAB : $a1a7544ebeb5819b$var$SPACE;
    const indentLength = line.search(indentToken.regex);
    const indentText = line.substring(0, indentLength >= 0 ? indentLength : line.length);
    return {
        indentToken: indentToken,
        indentText: indentText
    };
};


/**
 * Return the current indentation level
 * @param indentText - Text in the code block that represent an indentation
 * @param indentSize - Size of the indentation token in a string
 */ function $88615dd9c942ebde$var$getIndentLevel(indentText, indentSize) {
    if (indentSize === 0 || indentText.length === 0) return 0;
    return indentText.length / indentSize;
}
const $88615dd9c942ebde$export$79ebfa808dffa5c6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $a1a7544ebeb5819b$export$64ccdebd7526708f)(state);
        const { tr: tr, selection: selection } = state;
        (0, $a1a7544ebeb5819b$export$7f5b487b51da88d0)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $a1a7544ebeb5819b$export$7af82191547c5ff7)(line);
            const indentLevel = $88615dd9c942ebde$var$getIndentLevel(indentText, indentToken.size);
            const indentToAdd = indentToken.token.repeat(indentToken.size - indentText.length % indentToken.size || indentToken.size);
            tr.insertText(indentToAdd, tr.mapping.map(start + offset, -1));
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD,
                    previousIndentationLevel: indentLevel,
                    newIndentLevel: indentLevel + 1,
                    direction: (0, $iX5Ka.INDENT_DIRECTION).INDENT,
                    indentType: (0, $iX5Ka.INDENT_TYPE).CODE_BLOCK
                }
            })(tr);
            if (!selection.empty) tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, tr.mapping.map(selection.from, -1), tr.selection.to));
        });
        if (dispatch) dispatch(tr);
        return true;
    };
const $88615dd9c942ebde$export$25755c0352544598 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $a1a7544ebeb5819b$export$64ccdebd7526708f)(state);
        const { tr: tr } = state;
        (0, $a1a7544ebeb5819b$export$7f5b487b51da88d0)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $a1a7544ebeb5819b$export$7af82191547c5ff7)(line);
            if (indentText) {
                const indentLevel = $88615dd9c942ebde$var$getIndentLevel(indentText, indentToken.size);
                const unindentLength = indentText.length % indentToken.size || indentToken.size;
                tr.delete(tr.mapping.map(start + offset), tr.mapping.map(start + offset + unindentLength));
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).FORMATTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD,
                        previousIndentationLevel: indentLevel,
                        newIndentLevel: indentLevel - 1,
                        direction: (0, $iX5Ka.INDENT_DIRECTION).OUTDENT,
                        indentType: (0, $iX5Ka.INDENT_TYPE).CODE_BLOCK
                    }
                })(tr);
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
function $88615dd9c942ebde$export$ba3935b326bda6a5(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $a1a7544ebeb5819b$export$13a3ef35664ba7de)(state);
    const { indentToken: indentToken } = (0, $a1a7544ebeb5819b$export$7af82191547c5ff7)(textAtStartOfLine);
    const indentToAdd = indentToken.token.repeat(indentToken.size - textAtStartOfLine.length % indentToken.size || indentToken.size);
    dispatch(state.tr.insertText(indentToAdd));
    return true;
}
function $88615dd9c942ebde$export$1b9cc0cafa2b529c(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $a1a7544ebeb5819b$export$13a3ef35664ba7de)(state);
    const { indentText: indentText } = (0, $a1a7544ebeb5819b$export$7af82191547c5ff7)(textAtStartOfLine);
    if (indentText && dispatch) {
        dispatch(state.tr.insertText('\n' + indentText));
        return true;
    }
    return false;
}




const $655d51a7de6da4c7$export$bb64b01afeb72d0a = {
    "'": "'",
    '"': '"',
    '`': '`'
};
// when directly before a closing bracket
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $655d51a7de6da4c7$var$CLOSING_BRACKET_REGEX = /^[}\])]/;
// exclusion: when directly before a non-whitespace character
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $655d51a7de6da4c7$var$NON_WHITESPACE_AFTER_REGEX = /^[^\s]/;
// exclusion: when directly after a letter or quote
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $655d51a7de6da4c7$var$ALPHANUMERIC_END_REGEX = /[A-Za-z0-9]$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $655d51a7de6da4c7$var$QUOTE_END_REGEX = /[\'\"\'`]$/;
const $655d51a7de6da4c7$export$42f0a0996a9a464d = (before, after)=>{
    // when directly before a closing bracket
    if ($655d51a7de6da4c7$var$CLOSING_BRACKET_REGEX.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    if ($655d51a7de6da4c7$var$NON_WHITESPACE_AFTER_REGEX.test(after)) return false;
    // exclusion: when directly after a letter or quote
    if ($655d51a7de6da4c7$var$ALPHANUMERIC_END_REGEX.test(before) || $655d51a7de6da4c7$var$QUOTE_END_REGEX.test(before)) return false;
    return true;
};
const $655d51a7de6da4c7$export$6af564d7e42f37e8 = (before, after)=>{
    const left = Object.keys($655d51a7de6da4c7$export$bb64b01afeb72d0a).find((item)=>before.endsWith(item));
    const right = left ? $655d51a7de6da4c7$export$bb64b01afeb72d0a[left] : undefined;
    const hasTrailingMatchingQuote = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingQuote: hasTrailingMatchingQuote
    };
};


const $846554af5cda12d7$var$PAIRED_CHARACTER_MAP = {
    ...(0, $7b0f44d46516152c$export$94d363c96bda1dd9),
    ...(0, $655d51a7de6da4c7$export$bb64b01afeb72d0a)
};
const $846554af5cda12d7$export$1d6d73d16dcadbdd = (after)=>{
    return Object.keys($846554af5cda12d7$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>after.startsWith($846554af5cda12d7$var$PAIRED_CHARACTER_MAP[leftCharacter]));
};
const $846554af5cda12d7$export$ea0560eb552fb0a7 = (text)=>{
    return Object.keys($846554af5cda12d7$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>text === $846554af5cda12d7$var$PAIRED_CHARACTER_MAP[leftCharacter]);
};




const $70113123ec14242c$var$ideUX = (pluginInjectionApi)=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    return new (0, $kpCD8.SafePlugin)({
        props: {
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const compositionPluginState = pluginInjectionApi?.composition?.sharedState.currentState();
                if ((0, $a1a7544ebeb5819b$export$cecd33f3def3e129)(state) && !compositionPluginState?.isComposing) {
                    const beforeText = (0, $a1a7544ebeb5819b$export$13a3ef35664ba7de)(state).text;
                    const afterText = (0, $a1a7544ebeb5819b$export$8291149050336443)(state).text;
                    // If text is a closing bracket/quote and we've already inserted it, move the selection after
                    if ((0, $846554af5cda12d7$export$1d6d73d16dcadbdd)(afterText) && (0, $846554af5cda12d7$export$ea0560eb552fb0a7)(text) && afterText.startsWith(text)) {
                        dispatch((0, $bjg0G.setTextSelection)(to + text.length)(state.tr));
                        return true;
                    }
                    // Automatically add right-hand side bracket when user types the left bracket
                    if ((0, $7b0f44d46516152c$export$29c04e6b1b08e223)(beforeText, afterText)) {
                        const { left: left, right: right } = (0, $7b0f44d46516152c$export$a40becce5a71614c)(beforeText + text, afterText);
                        if (left && right) {
                            const bracketPair = state.schema.text(text + right);
                            const tr = state.tr.replaceWith(from, to, bracketPair);
                            dispatch((0, $bjg0G.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                    // Automatically add closing quote when user types a starting quote
                    if ((0, $655d51a7de6da4c7$export$42f0a0996a9a464d)(beforeText, afterText)) {
                        const { left: leftQuote, right: rightQuote } = (0, $655d51a7de6da4c7$export$6af564d7e42f37e8)(beforeText + text, afterText);
                        if (leftQuote && rightQuote) {
                            const quotePair = state.schema.text(text + rightQuote);
                            const tr = state.tr.replaceWith(from, to, quotePair);
                            dispatch((0, $bjg0G.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                }
                return false;
            },
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Backspace: (state, dispatch)=>{
                    if ((0, $a1a7544ebeb5819b$export$cecd33f3def3e129)(state)) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const $cursor = (0, $9c52569c583a8f61$export$da3f040fb23d21f)(state.selection);
                        const beforeText = (0, $a1a7544ebeb5819b$export$13a3ef35664ba7de)(state).text;
                        const afterText = (0, $a1a7544ebeb5819b$export$8291149050336443)(state).text;
                        const { left: leftBracket, right: rightBracket, hasTrailingMatchingBracket: hasTrailingMatchingBracket } = (0, $7b0f44d46516152c$export$a40becce5a71614c)(beforeText, afterText);
                        if (leftBracket && rightBracket && hasTrailingMatchingBracket && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftBracket.length, $cursor.pos + rightBracket.length));
                            return true;
                        }
                        const { left: leftQuote, right: rightQuote, hasTrailingMatchingQuote: hasTrailingMatchingQuote } = (0, $655d51a7de6da4c7$export$6af564d7e42f37e8)(beforeText, afterText);
                        if (leftQuote && rightQuote && hasTrailingMatchingQuote && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftQuote.length, $cursor.pos + rightQuote.length));
                            return true;
                        }
                        const { indentToken: { size: size, token: token }, indentText: indentText } = (0, $a1a7544ebeb5819b$export$7af82191547c5ff7)(beforeText);
                        if (beforeText === indentText) {
                            if (indentText.endsWith(token.repeat(size)) && dispatch) {
                                dispatch(state.tr.delete($cursor.pos - (size - indentText.length % size || size), $cursor.pos));
                                return true;
                            }
                        }
                    }
                    return false;
                },
                Enter: (0, $dTPhv.filter)((0, $a1a7544ebeb5819b$export$b54b55a89e362241), (0, $88615dd9c942ebde$export$1b9cc0cafa2b529c)),
                'Mod-]': (0, $dTPhv.filter)((0, $a1a7544ebeb5819b$export$b54b55a89e362241), (0, $88615dd9c942ebde$export$79ebfa808dffa5c6)(editorAnalyticsAPI)),
                'Mod-[': (0, $dTPhv.filter)((0, $a1a7544ebeb5819b$export$b54b55a89e362241), (0, $88615dd9c942ebde$export$25755c0352544598)(editorAnalyticsAPI)),
                Tab: (0, $dTPhv.filter)((0, $a1a7544ebeb5819b$export$b54b55a89e362241), (state, dispatch)=>{
                    if (!dispatch) return false;
                    if ((0, $a1a7544ebeb5819b$export$cecd33f3def3e129)(state)) return (0, $88615dd9c942ebde$export$ba3935b326bda6a5)(state, dispatch);
                    return (0, $88615dd9c942ebde$export$79ebfa808dffa5c6)(editorAnalyticsAPI)(state, dispatch);
                }),
                'Shift-Tab': (0, $dTPhv.filter)((0, $a1a7544ebeb5819b$export$b54b55a89e362241), (0, $88615dd9c942ebde$export$25755c0352544598)(editorAnalyticsAPI)),
                'Mod-a': (state, dispatch)=>{
                    if ((0, $a1a7544ebeb5819b$export$b54b55a89e362241)(state)) {
                        const { $from: $from, $to: $to } = state.selection;
                        const isFullCodeBlockSelection = $from.parentOffset === 0 && $to.parentOffset === $to.parent.nodeSize - 2;
                        if (!isFullCodeBlockSelection && dispatch) {
                            dispatch(state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, $from.start(), $to.end())));
                            return true;
                        }
                    }
                    return false;
                }
            })
        }
    });
};
var $70113123ec14242c$export$2e2bcd8739ae039 = $70113123ec14242c$var$ideUX;









var $56doO = parcelRequire("56doO");





var $d8RhQ = parcelRequire("d8RhQ");

var $c2pcC = parcelRequire("c2pcC");





var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");


// eslint-disable-next-line require-unicode-regexp
const $d8704d2faab835ca$var$THREE_TILDE_RULE_REGEX = /(?!\s)(`{3,})$/;
function $d8704d2faab835ca$export$bdcd7d8080bcac7f(schema, editorAnalyticsAPI) {
    const rules = $d8704d2faab835ca$var$getCodeBlockRules(editorAnalyticsAPI, schema);
    return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('code-block-input-rule', rules, {
        isBlockNodeRule: true
    }));
}
/**
 * Get all code block input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $d8704d2faab835ca$var$getCodeBlockRules(editorAnalyticsAPI, schema) {
    const ruleAnalytics = (0, $c2pcC.inputRuleWithAnalytics)({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    }, editorAnalyticsAPI);
    const validMatchLength = (match)=>match.length > 0 && match[0].length === 3;
    const threeTildeRule = (0, $d8RhQ.createRule)($d8704d2faab835ca$var$THREE_TILDE_RULE_REGEX, (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = (0, $6gBg9.getDefaultCodeBlockAttrs)(match[4] ? {
            language: match[4]
        } : {});
        if ((0, $39d747feddc6695d$export$4b5d5858845bfcf6)(state)) return (0, $39d747feddc6695d$export$92adcb8baa0906a6)(state, start, attributes);
        const tr = state.tr;
        tr.delete(start, end);
        const codeBlock = tr.doc.type.schema.nodes.codeBlock.createChecked(attributes);
        (0, $bjg0G.safeInsert)(codeBlock)(tr);
        return tr;
    });
    const leftNodeReplacementThreeTildeRule = (0, $d8RhQ.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`((${(0, $3brWT.leafNodeReplacementCharacter)}\`{3,})|^\\s(\`{3,}))(\\S*)$`), (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = (0, $6gBg9.getDefaultCodeBlockAttrs)(match[4] ? {
            language: match[4]
        } : {});
        const inlineStart = Math.max(match.index + state.selection.$from.start(), 1);
        return (0, $56doO.insertBlock)(state, schema.nodes.codeBlock, inlineStart, end, attributes);
    });
    return [
        ruleAnalytics(threeTildeRule),
        ruleAnalytics(leftNodeReplacementThreeTildeRule)
    ];
}















const $793c0ceae7c3f5f9$var$deleteCurrentItem = ($from)=>(tr)=>{
        return tr.delete($from.before($from.depth), $from.after($from.depth));
    };
const $793c0ceae7c3f5f9$var$setTextSelection = (pos)=>(tr)=>{
        const newSelection = (0, $kCECX.Selection).findFrom(tr.doc.resolve(pos), -1, true);
        if (newSelection) tr.setSelection(newSelection);
        return tr;
    };
function $793c0ceae7c3f5f9$export$e832373cff8dec22(schema) {
    return (0, $44cyU.keymap)({
        Backspace: (state, dispatch)=>{
            const $cursor = (0, $9c52569c583a8f61$export$da3f040fb23d21f)(state.selection);
            const { codeBlock: codeBlock, listItem: listItem, table: table, layoutColumn: layoutColumn, paragraph: paragraph } = state.schema.nodes;
            if (!$cursor || $cursor.parent.type !== codeBlock || !dispatch) return false;
            if ($cursor.pos === 1 || (0, $bjg0G.hasParentNodeOfType)(listItem)(state.selection) && $cursor.parentOffset === 0) {
                const node = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($cursor, codeBlock);
                if (!node) return false;
                dispatch(state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, []).setBlockType($cursor.pos, $cursor.pos, paragraph));
                return true;
            }
            if ($cursor.node && (0, $2w79Z.isEmptyNode)(schema)($cursor.node()) && ((0, $bjg0G.hasParentNodeOfType)(layoutColumn)(state.selection) || (0, $bjg0G.hasParentNodeOfType)(table)(state.selection))) {
                const { tr: tr } = state;
                const insertPos = $cursor.pos;
                $793c0ceae7c3f5f9$var$deleteCurrentItem($cursor)(tr);
                $793c0ceae7c3f5f9$var$setTextSelection(insertPos)(tr);
                dispatch(tr.scrollIntoView());
                return true;
            }
            // Handle not nested empty code block
            if ((0, $2w79Z.isEmptyNode)(schema)($cursor.node())) {
                dispatch($793c0ceae7c3f5f9$var$deleteCurrentItem($cursor)(state?.tr));
                return true;
            }
            return false;
        }
    });
}
var $793c0ceae7c3f5f9$export$2e2bcd8739ae039 = $793c0ceae7c3f5f9$export$e832373cff8dec22;















var $lp7sw = parcelRequire("lp7sw");































const $2b8289c17f6eb4b6$export$f05434c51e3762e = (state)=>(0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state);



var $cRhiT = parcelRequire("cRhiT");

const $6e858a65ace9f9b4$export$4ffea7f3ae91d083 = {
    container: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    gutter: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER,
    content: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT,
    lineNumberWidget: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f97f4d85e1f47ae4$var$MATCH_NEWLINES = new RegExp('\n', 'g');
const $f97f4d85e1f47ae4$var$toDOM = (node, contentEditable, formattedAriaLabel)=>[
        'div',
        {
            class: (0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).container
        },
        [
            'div',
            {
                class: (0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: (0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).contentWrapper
            },
            [
                'div',
                {
                    class: (0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).gutter,
                    contenteditable: 'false'
                }
            ],
            [
                'div',
                {
                    class: (0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        contenteditable: contentEditable ? 'true' : 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: (0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).end,
                contenteditable: 'false'
            }
        ]
    ];
class $f97f4d85e1f47ae4$export$84ecc4258da6ad44 {
    handleEditorDisabledChanged() {
        if (this.api?.editorDisabled) this.cleanupEditorDisabledListener = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    updateDOMAndSelection(savedInnerHTML, newCursorPosition) {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes?.length > 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const codeElement = contentView.firstChild;
                codeElement.innerHTML = savedInnerHTML;
                // We need to set cursor for the DOM update
                const textElement = Array.from(codeElement.childNodes).find((child)=>child.nodeName === '#text');
                const sel = window.getSelection();
                const range = document.createRange();
                range.setStart(textElement, newCursorPosition);
                range.collapse(true);
                sel?.removeAllRanges();
                sel?.addRange(range);
            }
        }
    }
    coalesceDOMElements() {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes && contentView.childNodes.length > 1) {
                let savedInnerHTML = '';
                while(contentView.childNodes.length > 1){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const lastChild = contentView.lastChild;
                    savedInnerHTML = lastChild.innerHTML + savedInnerHTML;
                    contentView.removeChild(lastChild);
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const firstChild = contentView.firstChild;
                savedInnerHTML = firstChild.innerHTML + '\n' + savedInnerHTML;
                const newCursorPosition = firstChild.innerHTML.length + 1;
                setTimeout(this.updateDOMAndSelection.bind(this, savedInnerHTML, newCursorPosition), 20);
            }
        }
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        if (node !== this.node) {
            if (node.attrs.language !== this.node.attrs.language) this.contentDOM.setAttribute('data-language', node.attrs.language || '');
            this.node = node;
            this.maintainDynamicGutterSize();
            const browser = (0, $8dxef.getBrowserInfo)();
            if (browser.android) {
                this.coalesceDOMElements();
                (0, $be654b6d9efea752$export$60364cd5f5fed191)(this.view.state, this.view.dispatch);
            }
        }
        return true;
    }
    ignoreMutation(record) {
        const pluginState = (0, $2b8289c17f6eb4b6$export$f05434c51e3762e)(this.view.state);
        if (pluginState?.shouldIgnoreFollowingMutations) return true;
        // Ensure updating the line-number gutter doesn't trigger reparsing the codeblock
        return record.target === this.lineNumberGutter || record.target.parentNode === this.lineNumberGutter;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
    constructor(_node, view, getPos, formattedAriaLabel, api, cleanupEditorDisabledListener){
        this.cleanupEditorDisabledListener = cleanupEditorDisabledListener;
        this.node = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.lineNumberGutter = void 0;
        this.getPos = void 0;
        this.view = void 0;
        this.formattedAriaLabel = '';
        this.api = void 0;
        /**
     * As the code block updates we get the maximum amount of digits in a line number and expand the number gutter to reflect this.
     */ this.maintainDynamicGutterSize = ()=>{
            let totalLineCount = 1;
            this.node.forEach((node)=>{
                const text = node.text;
                if (text) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                totalLineCount += (node.text.match($f97f4d85e1f47ae4$var$MATCH_NEWLINES) || []).length;
            });
            const maxDigits = totalLineCount.toString().length;
            this.dom.style.setProperty('--lineNumberGutterWidth', `${maxDigits}ch`);
        };
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $f97f4d85e1f47ae4$var$toDOM(_node, !api?.editorDisabled?.sharedState.currentState()?.editorDisabled, formattedAriaLabel));
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.lineNumberGutter = this.dom.querySelector(`.${(0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).gutter}`);
        this.api = api;
        this.maintainDynamicGutterSize();
        // Ensure the code block node has a wrapped state.
        // Wrapped state may already exist from breakout's recreating the node.
        if (!(0, $6gBg9.codeBlockWrappedStates).has(_node)) (0, $6gBg9.codeBlockWrappedStates).set(_node, (0, $6gBg9.defaultWordWrapState));
        this.handleEditorDisabledChanged();
    }
}
const $f97f4d85e1f47ae4$export$9ea0022afafc61b7 = (node, view, getPos, formattedAriaLabel, api)=>new $f97f4d85e1f47ae4$export$84ecc4258da6ad44(node, view, getPos, formattedAriaLabel, api);




const $3183ee03327dade6$export$bd3710c0a5fb6dad = (pendingFormats, tr, newState)=>{
    const entries = Object.entries(pendingFormats);
    if (entries.length === 0) return pendingFormats;
    let nextPendingFormats = pendingFormats;
    entries.forEach(([localId, pendingFormat])=>{
        const { deleted: deleted, pos: pos } = tr.mapping.mapResult(pendingFormat.pos, 1);
        const codeBlockNode = newState.doc.nodeAt(pos);
        const shouldRemovePendingFormat = deleted || codeBlockNode?.type !== newState.schema.nodes.codeBlock || codeBlockNode?.attrs.localId !== localId;
        const shouldUpdatePendingFormat = pos !== pendingFormat.pos;
        if (shouldRemovePendingFormat || shouldUpdatePendingFormat) {
            if (nextPendingFormats === pendingFormats) nextPendingFormats = {
                ...pendingFormats
            };
        }
        if (shouldRemovePendingFormat) {
            delete nextPendingFormats[localId];
            return;
        }
        if (shouldUpdatePendingFormat) nextPendingFormats[localId] = {
            ...pendingFormat,
            pos: pos
        };
    });
    return nextPendingFormats;
};
function $3183ee03327dade6$var$removeRecordEntry(record, key) {
    const nextRecord = {
        ...record
    };
    delete nextRecord[key];
    return nextRecord;
}
const $3183ee03327dade6$export$6d52e1741d2cdede = (pluginState, meta)=>{
    switch(meta?.type){
        case (0, $89c889278dbe2765$export$92a1a3b7554e9387).START_FORMAT_CODE:
            return {
                ...pluginState,
                pendingFormats: {
                    ...pluginState.pendingFormats,
                    [meta.data.localId]: {
                        languageSource: meta.data.languageSource,
                        pos: meta.data.pos,
                        requestId: meta.data.requestId
                    }
                }
            };
        case (0, $89c889278dbe2765$export$92a1a3b7554e9387).RESOLVE_FORMAT_CODE:
            {
                const pendingFormats = $3183ee03327dade6$var$removeRecordEntry(pluginState.pendingFormats, meta.data.localId);
                const formatCodeErrors = $3183ee03327dade6$var$removeRecordEntry(pluginState.formatCodeErrors, meta.data.localId);
                return {
                    ...pluginState,
                    formatCodeErrors: meta.data.outcome === 'failed' ? {
                        ...formatCodeErrors,
                        [meta.data.localId]: {
                            errorType: meta.data.errorType,
                            localId: meta.data.localId,
                            languageSource: meta.data.languageSource
                        }
                    } : formatCodeErrors,
                    pendingFormats: pendingFormats
                };
            }
        case (0, $89c889278dbe2765$export$92a1a3b7554e9387).CLEAR_FORMAT_CODE_ERROR:
            return {
                ...pluginState,
                formatCodeErrors: $3183ee03327dade6$var$removeRecordEntry(pluginState.formatCodeErrors, meta.data.localId)
            };
        default:
            return pluginState;
    }
};











const $69819b89c010a091$export$feb1744c3f7a1a44 = 'decorationWidgetType';
const $69819b89c010a091$export$7d62a9abd4358350 = 'decorationNodeType';
const $69819b89c010a091$export$e39f4b987bac6a89 = (state)=>{
    const codeBlockNodes = (0, $9c52569c583a8f61$export$f43d710a87ced169)(state);
    return codeBlockNodes.flatMap((node)=>$69819b89c010a091$export$9955827033f49bf6($69819b89c010a091$export$e2f66570e25f0fa7(node)));
};
const $69819b89c010a091$export$af0ed0ae85f93cba = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    // Update line number decorators for changed code block nodes if new line added or line removed.
    updatedDecorationSet = $69819b89c010a091$export$b7832269a6c1c9aa(tr, codeBlockNodes, updatedDecorationSet);
    // Check to make sure the word wrap decorators are still valid.
    updatedDecorationSet = $69819b89c010a091$export$7384f52a5ea552e1(tr, codeBlockNodes, updatedDecorationSet);
    return updatedDecorationSet;
};
const $69819b89c010a091$export$b7832269a6c1c9aa = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    const lineNumberDecorators = [];
    codeBlockNodes.forEach((node)=>{
        const existingWidgetsOnNode = updatedDecorationSet.find(node.pos, node.pos + node.node.nodeSize, (spec)=>spec.type === $69819b89c010a091$export$feb1744c3f7a1a44);
        const newLineAttributes = $69819b89c010a091$export$e2f66570e25f0fa7(node);
        // There will be no widgets on initialisation. If the number of existing widgets does not equal the amount of lines, regenerate the widgets.
        // There may be a case where the number of existing widgets and the number of lines are the same, that's why we track totalLineCount. This allows
        // us to know how many lines there were when the widget was created. It avoids a break in line numbers, e.g. "1, 2, 3, 5, 6". Happens on line removal.
        if (existingWidgetsOnNode.length === 0 || existingWidgetsOnNode.length !== newLineAttributes.length || existingWidgetsOnNode[0].spec.totalLineCount !== newLineAttributes.length) {
            updatedDecorationSet = updatedDecorationSet.remove(existingWidgetsOnNode);
            lineNumberDecorators.push(...$69819b89c010a091$export$9955827033f49bf6(newLineAttributes));
        }
    });
    return updatedDecorationSet.add(tr.doc, [
        ...lineNumberDecorators
    ]);
};
const $69819b89c010a091$export$e2f66570e25f0fa7 = (node)=>{
    const { node: innerNode, pos: pos } = node;
    // Get content node
    const contentNode = innerNode.content;
    // Get node text content
    let lineAttributes = [];
    // Early exit if content size is 0
    if (contentNode.size === 0) return [
        {
            lineStart: pos + 1,
            lineNumber: 1
        }
    ];
    contentNode.forEach((child)=>{
        const nodeTextContent = child.textContent;
        const nodeStartPos = pos;
        let lineStartIndex = nodeStartPos;
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        const newLineAttributes = nodeTextContent.split('\n').map((line, index)=>{
            const lineLength = line.length;
            const lineStart = lineStartIndex + 1;
            const lineNumber = index + 1;
            // Include the newline character and increment to keep tabs on line position
            lineStartIndex += lineLength + 1;
            return {
                lineStart: lineStart,
                lineNumber: lineNumber
            };
        });
        lineAttributes = [
            ...lineAttributes,
            ...newLineAttributes
        ];
    });
    return lineAttributes;
};
const $69819b89c010a091$export$9955827033f49bf6 = (lineAttributes)=>{
    const widgetDecorations = lineAttributes.map((lineAttribute)=>{
        const { lineStart: lineStart, lineNumber: lineNumber } = lineAttribute;
        // Passing a function to create the widget rather than directly passing a widget, as per ProseMirror docs.
        const createLineNumberWidget = ()=>{
            const widget = document.createElement('span');
            widget.textContent = `${lineNumber}`;
            widget.classList.add((0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).lineNumberWidget);
            return widget;
        };
        // side -1 is used so the line numbers are the first thing to the left of the lines of code.
        // totalLineCount is used to know whether or not to update the line numbers when a new line is added or removed.
        return (0, $8nvEM.Decoration).widget(lineStart, createLineNumberWidget, {
            type: $69819b89c010a091$export$feb1744c3f7a1a44,
            side: -1,
            totalLineCount: lineAttributes.length
        });
    });
    return widgetDecorations;
};
const $69819b89c010a091$export$7384f52a5ea552e1 = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    codeBlockNodes.forEach((node)=>{
        const isCodeBlockWrappedInState = (0, $6gBg9.isCodeBlockWordWrapEnabled)(node.node);
        const isCodeBlockWrappedByDecorator = $69819b89c010a091$export$343dbf55d0e24df2(node.pos, decorationSet).length !== 0;
        if (isCodeBlockWrappedInState !== isCodeBlockWrappedByDecorator) updatedDecorationSet = $69819b89c010a091$export$655c2c2993b251d2(decorationSet, tr, node);
    });
    return updatedDecorationSet;
};
const $69819b89c010a091$export$655c2c2993b251d2 = (decorationSet, tr, node)=>{
    if (!node || node.pos === undefined) return decorationSet;
    let updatedDecorationSet = decorationSet;
    const { pos: pos, node: innerNode } = node;
    const isNodeWrapped = (0, $6gBg9.isCodeBlockWordWrapEnabled)(innerNode);
    if (!isNodeWrapped) {
        const currentWrappedBlockDecorationSet = $69819b89c010a091$export$343dbf55d0e24df2(pos, updatedDecorationSet);
        updatedDecorationSet = updatedDecorationSet.remove(currentWrappedBlockDecorationSet);
        // In code block advanced we don't use the node decoration - however a change in decorations
        // is how we detect updates to the word wrap. If we have no decorations attached we've
        // likely changed the breakout width with the toggle ON - we add an empty decoration to force
        // prosemirror to recognise the change so we can update in our node view. This gets filtered
        // out on the next toggle.
        if (currentWrappedBlockDecorationSet.length === 0 && pos + innerNode.nodeSize <= tr.doc.content.size) {
            const wrappedBlock = (0, $8nvEM.Decoration).node(pos, pos + innerNode.nodeSize, {}, {
                type: $69819b89c010a091$export$7d62a9abd4358350
            } // Allows for quick filtering of decorations while using `find`
            );
            updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
                wrappedBlock
            ]);
        }
    } else {
        const wrappedBlock = (0, $8nvEM.Decoration).node(pos, pos + innerNode.nodeSize, {
            class: (0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).contentWrapped
        }, {
            type: $69819b89c010a091$export$7d62a9abd4358350
        } // Allows for quick filtering of decorations while using `find`
        );
        updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
            wrappedBlock
        ]);
    }
    return updatedDecorationSet;
};
const $69819b89c010a091$export$343dbf55d0e24df2 = (pos, decorationSet)=>{
    const codeBlockNodePosition = pos + 1; // We need to add 1 to the position to get the start of the node.
    const currentWrappedBlockDecorationSet = decorationSet.find(codeBlockNodePosition, codeBlockNodePosition, (spec)=>spec.type === $69819b89c010a091$export$7d62a9abd4358350);
    return currentWrappedBlockDecorationSet;
};




const $9234b13c2c2feb2a$export$ae829ec7b2625219 = ({ useLongPressSelection: useLongPressSelection = false, getIntl: getIntl, allowCompositionInputOverride: allowCompositionInputOverride = false, api: api })=>{
    const handleDOMEvents = {
        click: ()=>{
            // Set hasHadInteraction to true on any click of code blocks, as clicks
            // on code blocks to not propagate to editor-level click handlers
            api?.core?.actions.execute(api?.interaction?.commands.handleInteraction);
        }
    };
    // ME-1599: Composition on mobile was causing the DOM observer to mutate the code block
    // incorrecly and lose content when pressing enter in the middle of a code block line.
    if (allowCompositionInputOverride) handleDOMEvents.beforeinput = (view, event)=>{
        const keyEvent = event;
        const eventInputType = keyEvent.inputType;
        const eventText = keyEvent.data;
        const browser = (0, $8dxef.getBrowserInfo)();
        if (browser.ios && event.composed && // insertParagraph will be the input type when the enter key is pressed.
        eventInputType === 'insertParagraph' && (0, $hgAxn.findCodeBlock)(view.state, view.state.selection)) {
            event.preventDefault();
            return true;
        } else if (browser.android && event.composed && eventInputType === 'insertCompositionText' && eventText[eventText?.length - 1] === '\n' && (0, $hgAxn.findCodeBlock)(view.state, view.state.selection)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resultingText = event.target.outerText + '\n';
            if (resultingText.endsWith(eventText)) // End of paragraph
            setTimeout(()=>{
                view.someProp('handleKeyDown', (f)=>f(view, new KeyboardEvent('keydown', {
                        bubbles: true,
                        cancelable: true,
                        key: 'Enter',
                        code: 'Enter'
                    })));
            }, 0);
            else // Middle of paragraph, end of line
            (0, $be654b6d9efea752$export$e6e93d61d1873d0c)(view.state, view.dispatch);
            return true;
        }
        if (browser.android) (0, $be654b6d9efea752$export$60364cd5f5fed191)(view.state, view.dispatch);
        return false;
    };
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init (_, state) {
                const node = (0, $hgAxn.findCodeBlock)(state, state.selection);
                const initialDecorations = // Disabled when using advanced code block advanced since it interfers with styling
                // Long term we will deprecate the code block plugin and move all the related logic to
                // the advanced plugin
                // @ts-expect-error Code block advanced cannot depend on code block
                api?.codeBlockAdvanced !== undefined && (0, $ieeJu.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true) ? [] : (0, $69819b89c010a091$export$e39f4b987bac6a89)(state);
                return {
                    pos: node ? node.pos : null,
                    contentCopied: false,
                    formatCodeErrors: {},
                    isNodeSelected: false,
                    pendingFormats: {},
                    shouldIgnoreFollowingMutations: false,
                    decorations: (0, $8nvEM.DecorationSet).create(state.doc, initialDecorations)
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1));
                if (meta?.type === (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_IS_WRAPPED) {
                    const node = (0, $hgAxn.findCodeBlock)(newState, tr.selection);
                    return {
                        ...pluginState,
                        decorations: (0, $69819b89c010a091$export$655c2c2993b251d2)(pluginState.decorations, tr, node)
                    };
                }
                if (tr.docChanged) {
                    const node = (0, $hgAxn.findCodeBlock)(newState, tr.selection);
                    const codeBlockNodes = (0, $9c52569c583a8f61$export$3fa3c149b89781e7)(tr);
                    // Updates mapping position of all existing decorations to new positions
                    // specifically used for updating word wrap node decorators (does not cover drag & drop, validateWordWrappedDecorators does).
                    let updatedDecorationSet = pluginState.decorations.map(tr.mapping, tr.doc);
                    if (codeBlockNodes.length) {
                        (0, $6gBg9.updateCodeBlockWrappedStateNodeKeys)(codeBlockNodes, _oldState);
                        // Disabled when using advanced code block for performance reasons
                        // @ts-expect-error Code block advanced cannot depend on code block
                        if (api?.codeBlockAdvanced === undefined) updatedDecorationSet = (0, $69819b89c010a091$export$af0ed0ae85f93cba)(tr, codeBlockNodes, updatedDecorationSet);
                    }
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $kCECX.NodeSelection),
                        decorations: updatedDecorationSet
                    };
                    if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return newPluginState;
                    // Successful format results change the doc and carry format meta.
                    const formatCodePluginState = (0, $3183ee03327dade6$export$6d52e1741d2cdede)(newPluginState, meta);
                    return {
                        ...formatCodePluginState,
                        // Pending format requests can outlive unrelated document edits.
                        pendingFormats: (0, $3183ee03327dade6$export$bd3710c0a5fb6dad)(formatCodePluginState.pendingFormats, tr, newState)
                    };
                }
                if (tr.selectionSet) {
                    const node = (0, $hgAxn.findCodeBlock)(newState, tr.selection);
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $kCECX.NodeSelection)
                    };
                    return newPluginState;
                }
                if (meta?.type === (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD) return {
                    ...pluginState,
                    contentCopied: meta.data
                };
                else if (meta?.type === (0, $89c889278dbe2765$export$92a1a3b7554e9387).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS) return {
                    ...pluginState,
                    shouldIgnoreFollowingMutations: meta.data
                };
                if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) // Failed/unchanged format results and dismissals are meta-only.
                return (0, $3183ee03327dade6$export$6d52e1741d2cdede)(pluginState, meta);
                return pluginState;
            }
        },
        key: (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1),
        props: {
            decorations (state) {
                return (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state).decorations || (0, $8nvEM.DecorationSet).empty;
            },
            nodeViews: {
                codeBlock: (node, view, getPos)=>{
                    const { formatMessage: formatMessage } = getIntl();
                    const formattedAriaLabel = formatMessage((0, $5HBT9.messages).codeblock);
                    return (0, $f97f4d85e1f47ae4$export$9ea0022afafc61b7)(node, view, getPos, formattedAriaLabel, api);
                }
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'codeBlock'
            ], (target)=>!!(target.classList.contains((0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).lineNumberWidget) || target.classList.contains((0, $6e858a65ace9f9b4$export$4ffea7f3ae91d083).gutter)), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: handleDOMEvents
        }
    });
};







// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $abd0114b86329ca6$export$b3bd6df96c05d596 = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $abd0114b86329ca6$var$refreshBrowserSelectionOnChange = (transaction, editorState)=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    if (browser.gecko && transaction.docChanged && // codeblockState.pos should be set if current selection is in a codeblock.
    typeof (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(editorState)?.pos === 'number') $abd0114b86329ca6$export$b3bd6df96c05d596();
};
var $abd0114b86329ca6$export$2e2bcd8739ae039 = $abd0114b86329ca6$var$refreshBrowserSelectionOnChange;





parcelRequire("cozmU");





var $go7uG = parcelRequire("go7uG");

var $2xhuI = parcelRequire("2xhuI");


var $g6uqx = parcelRequire("g6uqx");





var $6YkHb = parcelRequire("6YkHb");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $fTKqO = parcelRequire("fTKqO");


var $dwAVI = parcelRequire("dwAVI");















var $cozmU = parcelRequire("cozmU");











const $84937a143e6842b1$export$1ce1cbcc4f60583f = 'none';
const $84937a143e6842b1$export$81fe902fcf56eb7c = 'autodetect';
const $84937a143e6842b1$export$5ebaabde4fc8cb67 = 'text';
const $84937a143e6842b1$export$997b95251f1f16f7 = (formatMessage)=>({
        alias: [
            $84937a143e6842b1$export$81fe902fcf56eb7c
        ],
        label: formatMessage((0, $go7uG.codeBlockButtonMessages).detectLanguage),
        selectionSource: 'pinned',
        value: $84937a143e6842b1$export$81fe902fcf56eb7c
    });
const $84937a143e6842b1$export$1bc7cbac729eb361 = ({ formatMessage: formatMessage, languages: languages, recentlyUsedLanguages: recentlyUsedLanguages = [] })=>{
    const recentlyUsedLanguageValues = new Set(recentlyUsedLanguages.map((language)=>language.value));
    const allLanguages = languages.filter((language)=>language.value !== $84937a143e6842b1$export$1ce1cbcc4f60583f && language.value !== $84937a143e6842b1$export$5ebaabde4fc8cb67 && !recentlyUsedLanguageValues.has(language.value));
    const plainTextOption = languages.find((language)=>language.value === $84937a143e6842b1$export$5ebaabde4fc8cb67);
    const pinnedOptions = (0, $iDrrr.fg)('platform_editor_code_block_language_detection_flow') ? [
        $84937a143e6842b1$export$997b95251f1f16f7(formatMessage)
    ] : [];
    if (plainTextOption) pinnedOptions.push({
        ...plainTextOption,
        selectionSource: 'pinned'
    });
    return [
        {
            label: '',
            options: pinnedOptions
        },
        ...recentlyUsedLanguages.length > 0 ? [
            {
                label: formatMessage((0, $go7uG.codeBlockButtonMessages).recentlyUsed),
                options: recentlyUsedLanguages.map((language)=>({
                        ...language,
                        selectionSource: 'recentlyUsed'
                    }))
            }
        ] : [],
        {
            label: formatMessage((0, $go7uG.codeBlockButtonMessages).all),
            options: allLanguages.map((language)=>({
                    ...language,
                    selectionSource: 'all'
                }))
        }
    ];
};


/* LanguagePicker.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");





var $ad7Ou = parcelRequire("ad7Ou");





var $7sJoX = parcelRequire("7sJoX");





var $iMnC5 = parcelRequire("iMnC5");


var $l9ukq = parcelRequire("l9ukq");

var $3GNtk = parcelRequire("3GNtk");


const $d5ca7acde314367a$var$pickerOptionStyles = null;
const $d5ca7acde314367a$var$styles = {
    divider: "_18otpjYbGa _2R4pr3YbGa _1v3aPqOeNX _39xV02N91d",
    trigger: "_1EqgXlgZxp _11sWcYecOK _4C1lCbYbGa",
    legacyTriggerTextOverflow: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
};
const $d5ca7acde314367a$var$CustomGroup = (props)=>{
    const allGroups = props.selectProps.options;
    const isFirstGroup = allGroups.length > 0 && allGroups[0] === props.data;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            !isFirstGroup && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "hr",
                xcss: $d5ca7acde314367a$var$styles.divider,
                role: "presentation"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).Group, {
                ...props
            })
        ]
    });
};
const $d5ca7acde314367a$var$CustomOption = (props)=>{
    return(// eslint-disable-next-line react/jsx-props-no-spreading -- react-select custom components must forward all props to the default Option.
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_26BoRwE9Al"
            ]),
            children: props.children
        })
    }));
};
const $d5ca7acde314367a$var$popupSelectComponents = {
    Group: $d5ca7acde314367a$var$CustomGroup,
    Option: $d5ca7acde314367a$var$CustomOption
};
const $d5ca7acde314367a$var$focusWithoutScrolling = (element)=>{
    element.focus({
        preventScroll: true
    });
};
const $d5ca7acde314367a$var$getRecentlyUsedLanguages = (recentLanguageValues, optionsByValue)=>{
    const recentlyUsedLanguages = [];
    for (const recentLanguageValue of recentLanguageValues){
        const option = optionsByValue.get(recentLanguageValue);
        if (option) recentlyUsedLanguages.push(option);
    }
    return recentlyUsedLanguages;
};
const $d5ca7acde314367a$export$409dffa5e19bc01a = ({ defaultValue: defaultValue, filterOption: filterOption, formatMessage: formatMessage, languagePickerOptions: languagePickerOptions, recentLanguageValues: recentLanguageValues = [], onMenuOpen: onMenuOpen, onSelection: onSelection, triggerSpacing: triggerSpacing = 'default' })=>{
    const label = defaultValue?.label ?? formatMessage((0, $go7uG.codeBlockButtonMessages).selectLanguage);
    const selectLanguageLabel = formatMessage((0, $go7uG.codeBlockButtonMessages).selectLanguage);
    const [hasSearchQuery, setHasSearchQuery] = (0, $cozmU.useState)(false);
    const [lockedPopperPlacement, setLockedPopperPlacement] = (0, $cozmU.useState)();
    const inputValueRef = (0, $cozmU.useRef)(''); // PopupSelect restores focus based on the trigger/open interaction, not the option
    // interaction. Keep this tied to the trigger so keyboard-open + mouse-select still follows
    // the keyboard focus path.
    const interactionMethodRef = (0, $cozmU.useRef)('keyboard');
    const optionsByValue = (0, $cozmU.useMemo)(()=>new Map(languagePickerOptions.map((option)=>[
                option.value,
                option
            ])), [
        languagePickerOptions
    ]);
    const recentlyUsedLanguages = (0, $cozmU.useMemo)(()=>$d5ca7acde314367a$var$getRecentlyUsedLanguages(recentLanguageValues, optionsByValue), [
        recentLanguageValues,
        optionsByValue
    ]);
    const options = (0, $cozmU.useMemo)(()=>(0, $84937a143e6842b1$export$1bc7cbac729eb361)({
            formatMessage: formatMessage,
            languages: languagePickerOptions,
            recentlyUsedLanguages: recentlyUsedLanguages
        }), [
        formatMessage,
        languagePickerOptions,
        recentlyUsedLanguages
    ]);
    const searchOptions = (0, $cozmU.useMemo)(()=>options.flatMap((group)=>group.options), [
        options
    ]);
    const stableMenuPopperProps = (0, $cozmU.useMemo)(()=>({
            // Allow Popper to choose top on the first open when bottom has no room, then lock the
            // chosen placement so later hover/search renders do not move the open picker.
            placement: lockedPopperPlacement ?? 'bottom-start',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                },
                ...lockedPopperPlacement ? [
                    {
                        name: 'flip',
                        enabled: false
                    }
                ] : []
            ],
            onFirstUpdate: ({ placement: placement })=>{
                setLockedPopperPlacement(placement);
            }
        }), [
        lockedPopperPlacement
    ]);
    const handleChange = (0, $cozmU.useCallback)((option)=>{
        if (!option) return;
        const isSearchSelection = inputValueRef.current.trim().length > 0;
        const selectionSource = isSearchSelection ? 'search' : option.selectionSource ?? 'all';
        if ((0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1')) onSelection(option, selectionSource, interactionMethodRef.current);
        else onSelection(option, selectionSource);
    }, [
        onSelection
    ]);
    const handleInputChange = (0, $cozmU.useCallback)((newInputValue, actionMeta)=>{
        // React-select clears the input as part of selecting a value before onChange fires.
        // Keep the last user-typed query so handleChange can report search selections correctly.
        const isInputChange = !actionMeta || actionMeta.action === 'input-change';
        if (isInputChange) {
            inputValueRef.current = newInputValue;
            setHasSearchQuery(newInputValue.trim().length > 0);
            return newInputValue;
        }
        return inputValueRef.current;
    }, []);
    const handleMenuOpen = (0, $cozmU.useCallback)(()=>{
        inputValueRef.current = '';
        setHasSearchQuery(false);
        setLockedPopperPlacement(undefined);
        onMenuOpen?.();
    }, [
        onMenuOpen
    ]);
    const handleTriggerMouseDown = (0, $cozmU.useCallback)((event)=>{
        // PopupSelect's FocusLock returns focus to the element that was focused before the
        // picker opened. If that is the editor/code block, closing the picker can scroll the
        // whole code block into view. Focus the trigger first without scrolling so FocusLock
        // returns to the trigger; see CodeBlockLanguagePicker's handleSelection for restoring
        // editor focus.
        $d5ca7acde314367a$var$focusWithoutScrolling(event.currentTarget);
    }, []);
    const handleTriggerMouseUp = (0, $cozmU.useCallback)((event)=>{
        if ((0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1')) {
            interactionMethodRef.current = 'mouse'; // Focus the trigger before PopupSelect opens so FocusLock restores focus to the
            // trigger after a mouse selection. Relying on the button's default mouse focus is too
            // late here; FocusLock can still remember the code block as the previous focus target.
            $d5ca7acde314367a$var$focusWithoutScrolling(event.currentTarget);
        }
    }, []);
    const handleTriggerKeyDownCapture = (0, $cozmU.useCallback)(()=>{
        interactionMethodRef.current = 'keyboard';
    }, []);
    const renderTarget = (0, $cozmU.useCallback)(({ isOpen: isOpen, ref: ref, onKeyDown: onKeyDown, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                $d5ca7acde314367a$var$styles.trigger,
                !(0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1') && $d5ca7acde314367a$var$styles.legacyTriggerTextOverflow
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                spacing: triggerSpacing,
                shouldFitContainer: true,
                onMouseDown: (0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1') ? undefined : handleTriggerMouseDown,
                onMouseUp: (0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1') ? handleTriggerMouseUp : undefined,
                onKeyDownCapture: (0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1') ? handleTriggerKeyDownCapture : undefined,
                onKeyDown: onKeyDown,
                ref: ref,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
                appearance: "subtle",
                isSelected: isOpen,
                "aria-controls": ariaControls,
                "aria-expanded": (0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1') ? ariaExpanded : undefined,
                "aria-haspopup": (0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1') ? ariaHasPopup : undefined,
                testId: "code-block-language-picker-trigger",
                children: label
            })
        }), [
        label,
        triggerSpacing,
        handleTriggerMouseDown,
        handleTriggerMouseUp,
        handleTriggerKeyDownCapture
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3GNtk.PopupSelect), {
        components: $d5ca7acde314367a$var$popupSelectComponents,
        filterOption: filterOption,
        label: selectLanguageLabel,
        maxMenuHeight: 300,
        minMenuWidth: 200,
        menuPlacement: "auto",
        onChange: handleChange,
        onInputChange: handleInputChange,
        onMenuOpen: handleMenuOpen,
        options: hasSearchQuery ? searchOptions : options,
        popperProps: stableMenuPopperProps,
        searchThreshold: -1,
        target: renderTarget,
        testId: "code-block-language-picker",
        defaultValue: defaultValue
    });
};



var $6YrB3 = parcelRequire("6YrB3");


var $8Xus6 = parcelRequire("8Xus6");

const $a8bcab340ad4a2dd$export$5a175c817b3d7154 = [
    {
        name: '(None)',
        alias: [
            'none'
        ],
        value: 'none'
    },
    ...(0, $8Xus6.SUPPORTED_LANGUAGES)
];
const $a8bcab340ad4a2dd$export$2253b3fe462d024d = {
    name: 'Mermaid',
    alias: [
        'mermaid'
    ],
    value: 'mermaid'
};
function $a8bcab340ad4a2dd$export$c11db3aa0f1c6401(supportedLanguages, language) {
    if (!language) return undefined;
    const matches = supportedLanguages.filter((supportedLanguage)=>{
        return supportedLanguage.alias.indexOf(language.toLowerCase()) !== -1;
    });
    if (matches.length > 0) return matches[0];
    return undefined;
}
function $a8bcab340ad4a2dd$export$b76ace6a02d76481(supportedLanguages) {
    if (!supportedLanguages || !supportedLanguages.length) return $a8bcab340ad4a2dd$export$5a175c817b3d7154;
    return $a8bcab340ad4a2dd$export$5a175c817b3d7154.filter((language)=>{
        let i = language.alias.length;
        while(i--){
            if (supportedLanguages.indexOf(language.alias[i]) > -1) return true;
        }
        return false;
    });
}
function $a8bcab340ad4a2dd$export$8ef04e71795bc8a6(language) {
    return language.alias[0];
}
function $a8bcab340ad4a2dd$export$e2dc9c8f242e4ee2(supportedLanguages) {
    return supportedLanguages.sort((left, right)=>{
        if (left.alias[0] === 'none') return -1;
        if (left.name.toLowerCase() > right.name.toLowerCase()) return 1;
        if (left.name.toLowerCase() < right.name.toLowerCase()) return -1;
        return 0;
    });
}



const $dc1efcdba61e11a7$export$377b756c63ac664b = 'recently-used-languages';
const $dc1efcdba61e11a7$var$RECENT_LANGUAGES_STORAGE_CLIENT_KEY = '@atlaskit/editor-plugin-code-block';
const $dc1efcdba61e11a7$var$MAX_RECENT_LANGUAGES = 3;
const $dc1efcdba61e11a7$var$RECENT_LANGUAGE_BLOCKLIST = new Set([
    (0, $84937a143e6842b1$export$81fe902fcf56eb7c),
    (0, $84937a143e6842b1$export$1ce1cbcc4f60583f),
    (0, $84937a143e6842b1$export$5ebaabde4fc8cb67)
]);
const $dc1efcdba61e11a7$var$KNOWN_LANGUAGE_VALUES = new Set((0, $a8bcab340ad4a2dd$export$5a175c817b3d7154).map((language)=>(0, $a8bcab340ad4a2dd$export$8ef04e71795bc8a6)(language)));
const $dc1efcdba61e11a7$var$recentLanguagesStorageClient = new (0, $6YrB3.default)($dc1efcdba61e11a7$var$RECENT_LANGUAGES_STORAGE_CLIENT_KEY);
const $dc1efcdba61e11a7$var$isValidRecentLanguage = (language)=>$dc1efcdba61e11a7$var$KNOWN_LANGUAGE_VALUES.has(language) && !$dc1efcdba61e11a7$var$RECENT_LANGUAGE_BLOCKLIST.has(language);
const $dc1efcdba61e11a7$var$readRecentLanguages = ()=>{
    const storedValue = $dc1efcdba61e11a7$var$recentLanguagesStorageClient.getItem($dc1efcdba61e11a7$export$377b756c63ac664b);
    return Array.isArray(storedValue) ? storedValue : [];
};
const $dc1efcdba61e11a7$export$f474067f7cfd10a = ()=>{
    try {
        return $dc1efcdba61e11a7$var$readRecentLanguages();
    } catch  {
        return [];
    }
};
const $dc1efcdba61e11a7$export$40a7fab637911506 = (language)=>{
    if (!$dc1efcdba61e11a7$var$isValidRecentLanguage(language)) return;
    try {
        const recentLanguages = $dc1efcdba61e11a7$var$readRecentLanguages();
        const nextRecentLanguages = Array.from(new Set([
            language,
            ...recentLanguages
        ])).slice(0, $dc1efcdba61e11a7$var$MAX_RECENT_LANGUAGES);
        // StorageClient only exposes setItemWithExpiry; omitting the duration stores without expiry.
        $dc1efcdba61e11a7$var$recentLanguagesStorageClient.setItemWithExpiry($dc1efcdba61e11a7$export$377b756c63ac664b, nextRecentLanguages);
    } catch  {
        return;
    }
};
const $dc1efcdba61e11a7$export$36acc0e2c8b8397d = ()=>{
    $dc1efcdba61e11a7$var$recentLanguagesStorageClient.removeItem($dc1efcdba61e11a7$export$377b756c63ac664b);
};


const $9bf25b968704b031$export$5393582178e4c2a = ({ api: api, defaultValue: defaultValue, editorView: editorView, filterOption: filterOption, formatMessage: formatMessage, languagePickerOptions: languagePickerOptions, triggerSpacing: triggerSpacing })=>{
    const [recentLanguageValues, setRecentLanguageValues] = (0, $cozmU.useState)(()=>(0, $dc1efcdba61e11a7$export$f474067f7cfd10a)());
    const refreshRecentLanguages = (0, $cozmU.useCallback)(()=>{
        setRecentLanguageValues((0, $dc1efcdba61e11a7$export$f474067f7cfd10a)());
    }, []);
    const handleSelection = (0, $cozmU.useCallback)((option, selectionSource, interactionMethod)=>{
        const isDetectLanguageSelected = option.value === (0, $84937a143e6842b1$export$81fe902fcf56eb7c);
        const command = isDetectLanguageSelected && ((0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1') || (0, $iDrrr.fg)('platform_editor_code_block_language_detection_flow')) ? (0, $be654b6d9efea752$export$ae9ea24a1b29b07c)() : (0, $be654b6d9efea752$export$61465194746e7fd2)(api?.analytics?.actions)(option.value, selectionSource);
        const commandSucceeded = command(editorView.state, editorView.dispatch);
        if ((0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1')) {
            if (interactionMethod === 'mouse') requestAnimationFrame(()=>{
                // Mouse-opened picker should return editing focus to the code block. Keyboard-opened
                // picker keeps focus on the trigger to avoid CodeMirror DOM focus without cm.hasFocus.
                api?.core.actions.focus({
                    scrollIntoView: false
                });
            });
        } else requestAnimationFrame(()=>{
            // Let PopupSelect/FocusLock finish returning focus to the trigger, then restore the editor.
            api?.core.actions.focus({
                scrollIntoView: false
            });
        });
        if (commandSucceeded && (option.value !== (0, $84937a143e6842b1$export$81fe902fcf56eb7c) || (0, $iDrrr.fg)('platform_editor_code_block_ga_patch_1'))) {
            (0, $dc1efcdba61e11a7$export$40a7fab637911506)(option.value);
            setRecentLanguageValues((0, $dc1efcdba61e11a7$export$f474067f7cfd10a)());
        }
    }, [
        api?.analytics?.actions,
        api?.core.actions,
        editorView
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5ca7acde314367a$export$409dffa5e19bc01a), {
        defaultValue: defaultValue,
        filterOption: filterOption,
        formatMessage: formatMessage,
        languagePickerOptions: languagePickerOptions,
        recentLanguageValues: recentLanguageValues,
        onMenuOpen: refreshRecentLanguages,
        onSelection: handleSelection,
        triggerSpacing: triggerSpacing
    });
};





parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3FYPH = parcelRequire("3FYPH");

const $c251517e01d96dba$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
            fill: "currentColor",
            clipPath: "url(#clip0_654_431)",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })
        })
    });
const $c251517e01d96dba$export$93a804c703d50d67 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c251517e01d96dba$var$CustomGlyph, {
        "aria-label": intl.formatMessage((0, $3FYPH.messages).wrapIcon)
    });
};



const $34bd78b80e1cd3a5$export$bbd1d07b83fc9327 = (formatCodeProvider, language)=>(_state, dispatch)=>{
        if (!dispatch || !formatCodeProvider || !language) // Hover/focus handlers are command-shaped; keep dry-runs side-effect free.
        return false;
        formatCodeProvider.preload?.(language)?.catch(()=>undefined);
        return false;
    };






const $3d732b150785082d$var$getDetectLanguageOption = (formatMessage)=>({
        alias: [],
        label: formatMessage((0, $go7uG.codeBlockButtonMessages).detectLanguage),
        value: (0, $84937a143e6842b1$export$81fe902fcf56eb7c)
    });
const $3d732b150785082d$var$getNoneDetectedOption = (formatMessage)=>({
        alias: [],
        label: formatMessage((0, $go7uG.codeBlockButtonMessages).noneDetected),
        value: (0, $84937a143e6842b1$export$1ce1cbcc4f60583f)
    });
const $3d732b150785082d$var$getDefaultLanguagePickerValue = (language, languagePickerOptions)=>language ? languagePickerOptions.find((option)=>language === (0, $84937a143e6842b1$export$1ce1cbcc4f60583f) ? option.value === (0, $84937a143e6842b1$export$5ebaabde4fc8cb67) : option.value === language || option.alias.includes(language)) : undefined;
const $3d732b150785082d$var$getAutoDetectPickerValue = ({ autoDetectEntry: autoDetectEntry, formatMessage: formatMessage, language: language, languagePickerOptions: languagePickerOptions })=>{
    const defaultPickerValue = $3d732b150785082d$var$getDefaultLanguagePickerValue(language, languagePickerOptions);
    // A weak re-detection records noneDetected but can leave a previously auto-detected
    // language on the node. Keep showing "(detected)" only while that preserved language
    // still matches the node language, so manual language changes do not inherit the label.
    const shouldShowDetectedLabel = Boolean(defaultPickerValue) && autoDetectEntry?.autoDetectedLanguage === language && Boolean(autoDetectEntry?.detectionResult);
    if (shouldShowDetectedLabel && defaultPickerValue) return {
        ...defaultPickerValue,
        label: formatMessage((0, $go7uG.codeBlockButtonMessages).detectedLanguage, {
            language: defaultPickerValue.label
        })
    };
    if (language || !autoDetectEntry) return defaultPickerValue;
    if (autoDetectEntry.detectionResult === 'noneDetected') return $3d732b150785082d$var$getNoneDetectedOption(formatMessage);
    if (!autoDetectEntry.detectionResult) return $3d732b150785082d$var$getDetectLanguageOption(formatMessage);
    return undefined;
};
const $3d732b150785082d$export$86ce8f8241c20a3 = (allowCopyToClipboard = false, api, overrideLanguageName, formatCodeProvider)=>{
    // Append gated languages (e.g. Mermaid) at runtime. Build a fresh array since
    // createLanguageList sorts in place and would otherwise mutate DEFAULT_LANGUAGES.
    const supportedLanguages = (0, $iDrrr.fg)('platform_editor_code_block_mermaid_language') ? [
        ...(0, $a8bcab340ad4a2dd$export$5a175c817b3d7154),
        (0, $a8bcab340ad4a2dd$export$2253b3fe462d024d)
    ] : (0, $a8bcab340ad4a2dd$export$5a175c817b3d7154);
    const languageList = (0, $a8bcab340ad4a2dd$export$e2dc9c8f242e4ee2)(overrideLanguageName ? supportedLanguages.map((languageOption)=>({
            ...languageOption,
            name: overrideLanguageName(languageOption.name)
        })) : supportedLanguages);
    const languagePickerOptions = languageList.map((lang)=>({
            label: lang.name,
            value: (0, $a8bcab340ad4a2dd$export$8ef04e71795bc8a6)(lang),
            alias: lang.alias
        }));
    return (state, { formatMessage: formatMessage })=>{
        const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const codeBlockState = (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state);
        const pos = codeBlockState?.pos ?? null;
        if (!codeBlockState || pos === null) return;
        const node = state.doc.nodeAt(pos);
        const nodeType = state.schema.nodes.codeBlock;
        if (node?.type !== nodeType) return;
        const isWrapped = (0, $6gBg9.isCodeBlockWordWrapEnabled)(node);
        const areLineNumbersVisible = (0, $6gBg9.areCodeBlockLineNumbersVisible)(node);
        const language = node?.attrs?.language;
        const localId = node?.attrs?.localId;
        const autoDetectState = (0, $4883cccd24c030e0$export$264979d19e499e37).getState(state);
        const isFormatCodePending = typeof localId === 'string' && Boolean(codeBlockState.pendingFormats[localId]);
        // Keep fresh option objects for the legacy toolbar select so reopening it
        // continues to start from the top rather than preserving the previously
        // focused option by reference.
        const languageSelectOptions = languagePickerOptions.map((option)=>({
                ...option
            }));
        const defaultValue = language ? languageSelectOptions.find((option)=>option.value === language) || languageSelectOptions.find((option)=>option.alias.includes(language)) : null;
        const languageSelect = {
            id: 'editor.codeBlock.languageOptions',
            type: 'select',
            selectType: 'list',
            onChange: (option)=>(0, $be654b6d9efea752$export$61465194746e7fd2)(editorAnalyticsAPI)(option.value),
            defaultValue: defaultValue,
            placeholder: formatMessage((0, $go7uG.codeBlockButtonMessages).selectLanguage),
            options: languageSelectOptions,
            filterOption: $3d732b150785082d$export$fffed505cd33273c
        };
        const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        let languagePicker;
        if ((0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_code_block_add_line_number_button')) {
            const autoDetectEntry = typeof localId === 'string' && (0, $iDrrr.fg)('platform_editor_code_block_language_detection_flow') ? autoDetectState?.languageDetectionMap[localId] : undefined;
            const autoDetectPickerValue = $3d732b150785082d$var$getAutoDetectPickerValue({
                autoDetectEntry: autoDetectEntry,
                formatMessage: formatMessage,
                language: language,
                languagePickerOptions: languagePickerOptions
            });
            languagePicker = {
                type: 'custom',
                fallback: [],
                render: (view)=>{
                    if (!view) return null;
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9bf25b968704b031$export$5393582178e4c2a), {
                        api: api,
                        defaultValue: autoDetectPickerValue,
                        editorView: view,
                        filterOption: $3d732b150785082d$export$fffed505cd33273c,
                        formatMessage: formatMessage,
                        languagePickerOptions: languagePickerOptions,
                        triggerSpacing: !areAnyNewToolbarFlagsEnabled ? 'compact' : 'default'
                    });
                }
            };
        }
        const separator = {
            type: 'separator'
        };
        const copyToClipboardItems = !allowCopyToClipboard ? [] : [
            {
                id: 'editor.codeBlock.copy',
                type: 'button',
                supportsViewMode: true,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
                // note: copyContentToClipboardWithAnalytics contains logic that also removes the
                // visual feedback for the copy button
                onClick: (0, $be654b6d9efea752$export$50ffc017f5e54c0)(editorAnalyticsAPI),
                title: formatMessage(codeBlockState.contentCopied ? (0, $go7uG.codeBlockButtonMessages).copiedCodeToClipboard : (0, $go7uG.codeBlockButtonMessages).copyCodeToClipboard),
                onMouseEnter: (0, $7996c95e1ce4924a$export$73dae478fefb96e),
                // note: resetCopiedState contains logic that also removes the
                // visual feedback for the copy button
                onMouseLeave: (0, $be654b6d9efea752$export$3e0b07341e7576a),
                onFocus: (0, $7996c95e1ce4924a$export$73dae478fefb96e),
                onBlur: (0, $7996c95e1ce4924a$export$1ec425a919cc0ea),
                hideTooltipOnClick: false,
                disabled: codeBlockState.isNodeSelected,
                tabIndex: null
            },
            separator
        ];
        let copyAndDeleteButtonMenuItems = [];
        if (areAnyNewToolbarFlagsEnabled) {
            const overflowMenuOptions = [
                {
                    title: formatMessage((0, $2xhuI.default).delete),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs)))({
                        label: ''
                    }),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    onClick: (0, $be654b6d9efea752$export$44b4779780b25933)(editorAnalyticsAPI)
                }
            ];
            if (allowCopyToClipboard) overflowMenuOptions.unshift({
                title: formatMessage((0, $2xhuI.default).copyToClipboard),
                onClick: (0, $be654b6d9efea752$export$50ffc017f5e54c0)(editorAnalyticsAPI),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z)))({
                    label: ''
                }),
                onMouseEnter: (0, $7996c95e1ce4924a$export$73dae478fefb96e),
                onMouseLeave: (0, $be654b6d9efea752$export$3e0b07341e7576a),
                onFocus: (0, $7996c95e1ce4924a$export$73dae478fefb96e),
                onBlur: (0, $7996c95e1ce4924a$export$1ec425a919cc0ea),
                disabled: codeBlockState.isNodeSelected
            });
            copyAndDeleteButtonMenuItems = isViewMode ? [
                ...copyToClipboardItems
            ] : [
                {
                    type: 'separator',
                    fullHeight: true
                },
                {
                    type: 'overflow-dropdown',
                    testId: 'code-block-overflow-dropdown-trigger',
                    options: overflowMenuOptions
                }
            ];
        } else {
            const deleteButton = {
                id: 'editor.codeBlock.delete',
                type: 'button',
                appearance: 'danger',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                onMouseEnter: hoverDecoration?.(nodeType, true),
                onMouseLeave: hoverDecoration?.(nodeType, false),
                onFocus: hoverDecoration?.(nodeType, true),
                onBlur: hoverDecoration?.(nodeType, false),
                onClick: (0, $be654b6d9efea752$export$44b4779780b25933)(editorAnalyticsAPI),
                title: formatMessage((0, $2xhuI.default).remove),
                tabIndex: null
            };
            copyAndDeleteButtonMenuItems = [
                separator,
                ...copyToClipboardItems,
                deleteButton
            ];
        }
        const codeBlockWrapButtonTitle = (0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? formatMessage(isWrapped ? (0, $go7uG.codeBlockButtonMessages).unwrapCodeLabel : (0, $go7uG.codeBlockButtonMessages).wrapCodeLabel) : formatMessage((0, $go7uG.codeBlockButtonMessages).wrapCode);
        const codeBlockWrapButton = {
            id: 'editor.codeBlock.wrap',
            type: 'button',
            // Toggling button now writes to ADF, hence it should be available in view mode
            supportsViewMode: !(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwAVI))),
            iconFallback: (0, $c251517e01d96dba$export$93a804c703d50d67),
            onClick: (0, $be654b6d9efea752$export$160d674382436f98)(editorAnalyticsAPI),
            title: codeBlockWrapButtonTitle,
            tabIndex: null,
            selected: isWrapped
        };
        const codeBlockLineNumbersButton = {
            id: 'editor.codeBlock.lineNumbers',
            type: 'button',
            supportsViewMode: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fTKqO))),
            onClick: (0, $be654b6d9efea752$export$5d4256781e1f4071)(editorAnalyticsAPI),
            title: formatMessage(areLineNumbersVisible ? (0, $go7uG.codeBlockButtonMessages).hideLineNumbersLabel : (0, $go7uG.codeBlockButtonMessages).showLineNumbersLabel),
            tabIndex: null,
            selected: areLineNumbersVisible
        };
        const formatLanguage = formatCodeProvider?.isSupportedLanguage(language) ? language : undefined;
        const canFormatCode = node.textContent.length > 0 && Boolean(formatLanguage);
        const formatCodeButton = {
            id: 'editor.codeBlock.formatCode',
            type: 'button',
            supportsViewMode: false,
            disabled: !canFormatCode || isFormatCodePending,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            onClick: (0, $be654b6d9efea752$export$7f5d8563b7e51b88)({
                api: api,
                editorAnalyticsAPI: editorAnalyticsAPI,
                formatCodeProvider: formatCodeProvider
            }),
            onFocus: (0, $34bd78b80e1cd3a5$export$bbd1d07b83fc9327)(formatCodeProvider, formatLanguage),
            onMouseEnter: (0, $34bd78b80e1cd3a5$export$bbd1d07b83fc9327)(formatCodeProvider, formatLanguage),
            title: formatMessage(canFormatCode ? (0, $go7uG.codeBlockButtonMessages).formatCode : (0, $go7uG.codeBlockButtonMessages).formatCodeUnavailable)
        };
        return {
            title: 'CodeBlock floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $bjg0G.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            items: [
                languagePicker ?? languageSelect,
                ...areAnyNewToolbarFlagsEnabled ? [] : [
                    separator
                ],
                codeBlockWrapButton,
                ...(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_code_block_add_line_number_button') ? [
                    codeBlockLineNumbersButton,
                    ...formatCodeProvider ? [
                        formatCodeButton
                    ] : []
                ] : [],
                ...copyAndDeleteButtonMenuItems
            ],
            scrollable: true
        };
    };
};
const $3d732b150785082d$export$fffed505cd33273c = (option, rawInput)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data: data } = option;
    const searchString = rawInput.toLowerCase();
    return data.label.toLowerCase().includes(searchString) || data.alias.some((alias)=>alias.toLowerCase() === searchString);
};





parcelRequire("cozmU");











var $dVKvM = parcelRequire("dVKvM");




const $b0d9078ee96f736e$var$NODE_NAME = 'codeBlock';
const $b0d9078ee96f736e$var$CodeBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.codeBlock, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $b0d9078ee96f736e$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $3FYPH.messages).codeBlock)
    });
};
const $b0d9078ee96f736e$export$76cec325b897d60 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($b0d9078ee96f736e$var$CodeBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};












var $3k5Tv = parcelRequire("3k5Tv");





var $FKQbh = parcelRequire("FKQbh");

var $lqtHz = parcelRequire("lqtHz");


var $24dy7 = parcelRequire("24dy7");



const $10e3d98e6b122f83$var$FormatCodeErrorFlagItem = ({ formatCodeError: formatCodeError })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $FKQbh.default), {
        description: formatMessage(formatCodeError.languageSource === 'auto-detected' ? (0, $go7uG.codeBlockButtonMessages).formatCodeFailedAutoDetectedDescription : (0, $go7uG.codeBlockButtonMessages).formatCodeFailedDescription),
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        id: formatCodeError.localId,
        title: formatMessage((0, $go7uG.codeBlockButtonMessages).formatCodeFailed)
    });
};
const $10e3d98e6b122f83$export$4481d6fe3f264c4b = ({ api: api })=>{
    const { formatCodeErrors: formatCodeErrors } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'codeBlock'
    ], (states)=>({
            formatCodeErrors: states.codeBlockState?.formatCodeErrors ?? {}
        }));
    const onDismissed = (0, $cozmU.useCallback)((localId)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $ad25e7bd70a42738$export$18d4026d1ea86bb1), {
                type: (0, $89c889278dbe2765$export$92a1a3b7554e9387).CLEAR_FORMAT_CODE_ERROR,
                data: {
                    localId: localId
                }
            });
            return tr;
        });
        api?.core?.actions.focus();
    }, [
        api
    ]);
    const onFlagGroupDismissed = (0, $cozmU.useCallback)((localId)=>onDismissed(String(localId)), [
        onDismissed
    ]);
    const activeFormatCodeErrors = Object.values(formatCodeErrors);
    if (activeFormatCodeErrors.length === 0) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
        onDismissed: onFlagGroupDismissed,
        children: activeFormatCodeErrors.map((formatCodeError)=>/*#__PURE__*/ (0, $8aG6j.jsx)($10e3d98e6b122f83$var$FormatCodeErrorFlagItem, {
                formatCodeError: formatCodeError
            }, formatCodeError.localId))
    });
};





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");




















var $I2MTF = parcelRequire("I2MTF");


const $9ff00b47a7187449$export$959ecdf27b352a49 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorDisabled: editorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorDisabled'
    ], (states)=>({
            editorDisabled: states.editorDisabledState?.editorDisabled
        }));
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, source: source })=>(0, $be654b6d9efea752$export$c0fb2037bfcf75f4)({
            analyticsAPI: api?.analytics?.actions,
            inputMethod: source,
            state: editorView.state
        }), [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconCode), {}),
        isDisabled: editorDisabled,
        onSelect: onSelect,
        shortcut: "```",
        title: formatMessage((0, $5HBT9.messages).codeblock)
    });
};


const $f8c89ebef842159a$export$12608b607d657329 = ({ api: api })=>[
        {
            key: (0, $dCkbP.CODE_BLOCK_MENU_ITEM).key,
            type: (0, $dCkbP.CODE_BLOCK_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.STRUCTURE_SECTION).key,
                    type: (0, $dCkbP.STRUCTURE_SECTION).type,
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[(0, $dCkbP.CODE_BLOCK_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $5HBT9.messages).codeblockDescription),
                    keywords: [
                        'code block'
                    ],
                    shortcut: '```',
                    title: formatMessage((0, $5HBT9.messages).codeblock)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9ff00b47a7187449$export$959ecdf27b352a49), {
                    api: api
                })
        }
    ];


const $04e09f743887d33c$var$CODE_BLOCK_NODE_NAME = 'codeBlock';
const $04e09f743887d33c$var$codeBlockPlugin = ({ config: options, api: api })=>{
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]
            },
            component: (0, $b0d9078ee96f736e$export$76cec325b897d60)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($04e09f743887d33c$var$CODE_BLOCK_NODE_NAME))
        }
    ]);
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $f8c89ebef842159a$export$12608b607d657329)({
        api: api
    }));
    const plugin = {
        name: 'codeBlock',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $jDAs4.codeBlock) : (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $jDAs4.codeBlockWithLocalId) : (0, $jDAs4.codeBlock)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            const codeBlockState = (0, $ad25e7bd70a42738$export$18d4026d1ea86bb1).getState(state);
            return {
                copyButtonHoverNode: (0, $7996c95e1ce4924a$export$97324d26e7dfa2c5).getState(state).codeBlockNode,
                formatCodeErrors: codeBlockState?.formatCodeErrors ?? {},
                pendingFormats: codeBlockState?.pendingFormats ?? {}
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlock',
                    plugin: ({ getIntl: getIntl })=>(0, $9234b13c2c2feb2a$export$ae829ec7b2625219)({
                            ...options,
                            getIntl: getIntl,
                            api: api
                        })
                },
                {
                    name: 'codeBlockInputRule',
                    plugin: ({ schema: schema })=>{
                        return (0, $d8704d2faab835ca$export$bdcd7d8080bcac7f)(schema, api?.analytics?.actions);
                    }
                },
                ...(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_code_block_language_detection_flow') ? [
                    {
                        name: 'codeBlockAutoDetect',
                        plugin: ()=>(0, $ad9bed998b476c35$export$d5142f5b34a5c85b)(api)
                    }
                ] : [],
                {
                    name: 'codeBlockIDEKeyBindings',
                    plugin: ()=>(0, $70113123ec14242c$export$2e2bcd8739ae039)(api)
                },
                {
                    name: 'codeBlockKeyMap',
                    plugin: ({ schema: schema })=>(0, $793c0ceae7c3f5f9$export$2e2bcd8739ae039)(schema)
                },
                {
                    name: 'codeBlockCopySelection',
                    plugin: ()=>(0, $7996c95e1ce4924a$export$bf11b3ffc9027f6b)()
                },
                {
                    name: 'codeBlockAutoFullStopTransform',
                    plugin: ()=>(0, $b585f2453e848da1$export$67e82b3aa944d041)()
                }
            ];
        },
        // Workaround for a firefox issue where dom selection is off sync
        // https://product-fabric.atlassian.net/browse/ED-12442
        onEditorViewStateUpdated (props) {
            (0, $abd0114b86329ca6$export$2e2bcd8739ae039)(props.originalTransaction, props.newEditorState);
        },
        actions: {
            /*
       * Function will insert code block at current selection if block is empty or below current selection and set focus on it.
       */ insertCodeBlock: (inputMethod)=>(0, $be654b6d9efea752$export$a8d9c0f039b6fb43)(inputMethod, api?.analytics?.actions)
        },
        pluginsOptions: {
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'codeblock',
                            title: formatMessage((0, $5HBT9.messages).codeblock),
                            description: formatMessage((0, $5HBT9.messages).codeblockDescription),
                            keywords: [
                                'code block'
                            ],
                            priority: 700,
                            keyshortcut: '```',
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconCode), {}),
                            action (_insert, state, source) {
                                const tr = (0, $be654b6d9efea752$export$c875ffe428b4a5f)({
                                    state: state
                                });
                                api?.analytics?.actions.attachAnalyticsEvent({
                                    action: (0, $krYZG.ACTION).INSERTED,
                                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CODE_BLOCK,
                                    attributes: {
                                        inputMethod: source || (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                                })(tr);
                                return tr;
                            }
                        }
                    ]
            },
            floatingToolbar: (0, $3d732b150785082d$export$86ce8f8241c20a3)(options?.allowCopyToClipboard, api, options?.overrideLanguageName, options?.formatCodeProvider)
        },
        contentComponent: ()=>(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $10e3d98e6b122f83$export$4481d6fe3f264c4b), {
                api: api
            }) : null
    };
    return plugin;
};
var $04e09f743887d33c$export$2e2bcd8739ae039 = $04e09f743887d33c$var$codeBlockPlugin;
module.exports["default"] = $04e09f743887d33c$export$2e2bcd8739ae039;

});

parcelRegister("1TzXg", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $jfFbl = parcelRequire("jfFbl");


var $8dxef = parcelRequire("8dxef");

function $8196ee2ed0ffa571$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $bjg0G.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $bjg0G.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $8196ee2ed0ffa571$export$289411c5a7970646 = (node, schema)=>{
    return (0, $aPdNQ.DOMSerializer).fromSchema(schema).serializeNode(node);
};
const $8196ee2ed0ffa571$export$ccb445b3e5426309 = (domNode, nodeType, selection)=>{
    if (domNode) {
        const div = document.createElement('div');
        div.appendChild(domNode);
        const schema = selection.$from.doc.type.schema;
        const browser = (0, $8dxef.getBrowserInfo)();
        // if copying inline content
        if (nodeType.inlineContent) // The "1 1" refers to the start and end depth of the slice
        // since we're copying the text inside a paragraph, it will always be 1 1
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '1 1 []');
        else // The "0 0" refers to the start and end depth of the slice
        // since we're copying the block node only, it will always be 0 0
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '0 0 []');
        // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
        // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
        if (browser.safari && selection instanceof (0, $kCECX.NodeSelection) && (selection.node.type === schema.nodes.extension || selection.node.type === schema.nodes.mediaSingle)) (0, $jfFbl.copyHTMLToClipboardPolyfill)(div);
        else (0, $jfFbl.copyHTMLToClipboard)(div);
    }
};
module.exports["getSelectedNodeOrNodeParentByNodeType"] = $8196ee2ed0ffa571$export$64477bc469482fd0;
module.exports["toDOM"] = $8196ee2ed0ffa571$export$289411c5a7970646;
module.exports["copyDomNode"] = $8196ee2ed0ffa571$export$ccb445b3e5426309;

});

parcelRegister("iX5Ka", function(module, exports) {
var $0212b62fd8fd2903$export$c8090e81b8640d69 = /*#__PURE__*/ function(INDENT_DIRECTION) {
    INDENT_DIRECTION["INDENT"] = "indent";
    INDENT_DIRECTION["OUTDENT"] = "outdent";
    return INDENT_DIRECTION;
}({});
var $0212b62fd8fd2903$export$303836d45647271d = /*#__PURE__*/ function(INDENT_TYPE) {
    INDENT_TYPE["PARAGRAPH"] = "paragraph";
    INDENT_TYPE["LIST"] = "list";
    INDENT_TYPE["HEADING"] = "heading";
    INDENT_TYPE["CODE_BLOCK"] = "codeBlock";
    INDENT_TYPE["TASK_LIST"] = "taskList";
    return INDENT_TYPE;
}({});
module.exports["INDENT_DIRECTION"] = $0212b62fd8fd2903$export$c8090e81b8640d69;
module.exports["INDENT_TYPE"] = $0212b62fd8fd2903$export$303836d45647271d;

});

parcelRegister("g6uqx", function(module, exports) {

var $anBbz = parcelRequire("anBbz");

const $956da0f993226185$export$c6d9af905adcabd8 = (isNewToolbarEnabled)=>Boolean((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || isNewToolbarEnabled);
module.exports["areToolbarFlagsEnabled"] = $956da0f993226185$export$c6d9af905adcabd8;

});

parcelRegister("e6Dq9", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $fngNp = parcelRequire("fngNp");


var $kCECX = parcelRequire("kCECX");

const $c89b59fc110c7306$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('compositionPlugin');


const $0e71f63156b47296$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $0e71f63156b47296$export$2e2bcd8739ae039 = ()=>new (0, $kpCD8.SafePlugin)({
        key: (0, $c89b59fc110c7306$export$18d4026d1ea86bb1),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $c89b59fc110c7306$export$18d4026d1ea86bb1));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $c89b59fc110c7306$export$18d4026d1ea86bb1), true);
                    // only apply for linux and cursor is at start of line
                    if ($0e71f63156b47296$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $fngNp.ZERO_WIDTH_SPACE));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $c89b59fc110c7306$export$18d4026d1ea86bb1), false);
                    if ($0e71f63156b47296$var$isLinux()) {
                        const zeroWidthSpacePos = (0, $c89b59fc110c7306$export$18d4026d1ea86bb1).getState(view.state)?.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });



const $5e08223a9d83d300$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!(0, $c89b59fc110c7306$export$18d4026d1ea86bb1).getState(editorState)?.isComposing
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $0e71f63156b47296$export$2e2bcd8739ae039)()
                }
            ];
        }
    };
};
module.exports["compositionPlugin"] = $5e08223a9d83d300$export$afd1652ef5208b;

});

parcelRegister("1ZhW4", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");


var $kCECX = parcelRequire("kCECX");

const $5ed56e7997465166$export$e41a18c2cdafffa9 = new (0, $kCECX.PluginKey)('copyButtonPlugin');


function $eeb5c60d15d597e9$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $eeb5c60d15d597e9$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $eeb5c60d15d597e9$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $eeb5c60d15d597e9$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $eeb5c60d15d597e9$export$ea22bdb37423f02c() {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $5ed56e7997465166$export$e41a18c2cdafffa9),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9));
                if (meta?.copied !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta?.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $eeb5c60d15d597e9$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta?.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $eeb5c60d15d597e9$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
}
var $eeb5c60d15d597e9$export$2e2bcd8739ae039 = $eeb5c60d15d597e9$export$ea22bdb37423f02c;



var $2xhuI = parcelRequire("2xhuI");


var $fHs3z = parcelRequire("fHs3z");


var $krYZG = parcelRequire("krYZG");


var $8dxef = parcelRequire("8dxef");


var $jfFbl = parcelRequire("jfFbl");


var $1TzXg = parcelRequire("1TzXg");





var $fqVYq = parcelRequire("fqVYq");


function $4b9b3a16dea0d6de$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $1TzXg.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const linkUrl = domNode.getAttribute('href');
                (0, $jfFbl.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9), {
                copied: true
            });
            const analyticsPayload = (0, $jfFbl.getAnalyticsPayload)(state, (0, $krYZG.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $4b9b3a16dea0d6de$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $4b9b3a16dea0d6de$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9), {
        removeSelection: true
    });
    const copyButtonState = (0, $5ed56e7997465166$export$e41a18c2cdafffa9).getState(state);
    if (copyButtonState?.copied) tr.setMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $4b9b3a16dea0d6de$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi, api, onClickMessage)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $1TzXg.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9), {
            copied: true
        });
        const analyticsPayload = (0, $jfFbl.getAnalyticsPayload)(state, (0, $krYZG.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            analyticsPayload.attributes.inputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $1TzXg.toDOM)(contentNodeWithPos.node, schema);
            if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) (0, $1TzXg.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
            else if (domNode) {
                const div = document.createElement('div');
                const browser = (0, $8dxef.getBrowserInfo)();
                div.appendChild(domNode);
                // if copying inline content
                if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                else // The "0 0" refers to the start and end depth of the slice
                // since we're copying the block node only, it will always be 0 0
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
                // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
                if (browser.safari && state.selection instanceof (0, $kCECX.NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, $jfFbl.copyHTMLToClipboardPolyfill)(div);
                else (0, $jfFbl.copyHTMLToClipboard)(div);
            }
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        /**
		 * A11y-10275 This prop api drilled from the plugin all the way down to the usage
		 * because it's the safest way to ensure accessibilityUtils is available and not
		 * undefined.
		 *
		 * see thread https://atlassian.slack.com/archives/C02CDUS3SUS/p1744256326459569
		 */ if (onClickMessage) api?.accessibilityUtils?.actions.ariaNotify(onClickMessage, {
            priority: 'important'
        });
        return true;
    };
const $4b9b3a16dea0d6de$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $5ed56e7997465166$export$e41a18c2cdafffa9).getState(state);
        if (copyButtonState?.copied) customTr.setMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };



// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2127802b9fe03251$var$isSeparator(item) {
    return item?.type === 'separator';
}
function $2127802b9fe03251$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
const $2127802b9fe03251$export$b372d635c5d31afc = (api)=>(message)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $5ed56e7997465166$export$e41a18c2cdafffa9), {
                copied: true
            }).setMeta('scrollIntoView', false);
        });
        api?.accessibilityUtils?.actions.ariaNotify(message, {
            priority: 'important'
        });
    };
function $2127802b9fe03251$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi, api) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $5ed56e7997465166$export$e41a18c2cdafffa9).getState(state);
    let buttonActionHandlers;
    if ($2127802b9fe03251$var$isNodeOptions(options)) {
        const { onClick: onClick } = options;
        buttonActionHandlers = {
            onClick: (0, $4b9b3a16dea0d6de$export$be806b3b778a7682)(options.nodeType, editorAnalyticsApi, api, formatMessage((0, $2xhuI.default).copiedToClipboard)),
            // Note for future changes: these two handlers should perform
            // the same action.
            onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
            onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
            // Note for future changes: these two handlers should perform
            // the same action.
            onMouseLeave: (0, $4b9b3a16dea0d6de$export$3e0b07341e7576a)(options.nodeType, hoverDecoration, onMouseLeave),
            onBlur: (0, $4b9b3a16dea0d6de$export$3e0b07341e7576a)(options.nodeType, hoverDecoration, onBlur)
        };
        if (onClick) buttonActionHandlers.onClick = (editorState, dispatch, editorView)=>{
            if (onClick(editorState, dispatch, editorView)) {
                $2127802b9fe03251$export$b372d635c5d31afc(api)(formatMessage((0, $2xhuI.default).copiedToClipboard));
                return true;
            }
            return false;
        };
    } else buttonActionHandlers = {
        onClick: (0, $4b9b3a16dea0d6de$export$61f33363e77ed28)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $4b9b3a16dea0d6de$export$5887c7b152626490)(options.markType),
        onFocus: (0, $4b9b3a16dea0d6de$export$5887c7b152626490)(options.markType),
        onMouseLeave: (0, $4b9b3a16dea0d6de$export$e52b1d5c60d367b8),
        onBlur: (0, $4b9b3a16dea0d6de$export$e52b1d5c60d367b8)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
        title: formatMessage(copyButtonState?.copied ? (0, $2xhuI.default).copiedToClipboard : (0, $2xhuI.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        tabIndex: null
    };
}
const $2127802b9fe03251$export$f61ed03c42ac876f = (editorAnalyticsApi, api)=>(_state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item?.hidden) return [];
                        return item?.items.map((copyButtonItem)=>$2127802b9fe03251$var$isSeparator(copyButtonItem) ? copyButtonItem : $2127802b9fe03251$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi, api));
                    default:
                        return [
                            item
                        ];
                }
            });
    };


const $2fcbbe00fea3ae85$export$ea22bdb37423f02c = ({ api: api })=>({
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $eeb5c60d15d597e9$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $2127802b9fe03251$export$f61ed03c42ac876f)(api?.analytics?.actions, api),
            afterCopy: (message)=>(0, $2127802b9fe03251$export$b372d635c5d31afc)(api)(message)
        }
    });
module.exports["copyButtonPlugin"] = $2fcbbe00fea3ae85$export$ea22bdb37423f02c;

});

parcelRegister("2QN3e", function(module, exports) {

var $fqVYq = parcelRequire("fqVYq");


var $lVAkE = parcelRequire("lVAkE");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $8HW7o = parcelRequire("8HW7o");

var $8Z43Z = parcelRequire("8Z43Z");


var $cycWk = parcelRequire("cycWk");





var $kpCD8 = parcelRequire("kpCD8");





var $bjg0G = parcelRequire("bjg0G");





var $anBbz = parcelRequire("anBbz");




const $370fb9c1e84d8dce$export$385f768f10dabdd5 = new (0, $kCECX.PluginKey)('decorationPlugin');
var $370fb9c1e84d8dce$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    return ACTIONS;
}({});
const $370fb9c1e84d8dce$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    const { decoration: decoration } = $370fb9c1e84d8dce$export$385f768f10dabdd5.getState(state);
    if (decoration && dispatch) {
        dispatch(tr.setMeta($370fb9c1e84d8dce$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $370fb9c1e84d8dce$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $kCECX.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $bjg0G.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($370fb9c1e84d8dce$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $8nvEM.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $370fb9c1e84d8dce$export$2e2bcd8739ae039 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $370fb9c1e84d8dce$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration && pluginState.decoration instanceof (0, $8nvEM.Decoration)) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                if (pluginState.decoration && pluginState.decoration instanceof (0, $8nvEM.DecorationSet) && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) pluginState.decoration = pluginState.decoration.map(tr.mapping, tr.doc);
                const meta = tr.getMeta($370fb9c1e84d8dce$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data,
                            hasDangerDecorations: (0, $anBbz.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? meta.hasDangerDecorations : undefined
                        };
                    case 1:
                        return {
                            decoration: undefined,
                            hasDangerDecorations: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $370fb9c1e84d8dce$export$385f768f10dabdd5.getState(state);
                if (decoration instanceof (0, $8nvEM.Decoration)) return (0, $8nvEM.DecorationSet).create(doc, [
                    decoration
                ]);
                if (decoration instanceof (0, $8nvEM.DecorationSet) && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) return decoration;
                return null;
            }
        }
    });
};


const $6a1963e7667e5672$export$84d8b6d3cf5f2fb4 = ({ add: add, className: className = 'danger selected', selection: providedSelection })=>({ tr: tr })=>{
        const selection = providedSelection || tr.selection;
        const decorations = [];
        const handleTableSelection = (pos = selection.$from)=>{
            const table = (0, $cycWk.findTableClosestToPos)(pos);
            if (!table) return tr;
            const tableNode = table.node;
            const tablePos = table.pos;
            decorations.push((0, $8nvEM.Decoration).node(tablePos, tablePos + tableNode.nodeSize, {
                class: className
            }, {
                key: `decorationNode-table-${tablePos}`
            }));
            const map = (0, $8Z43Z.TableMap).get(tableNode);
            const cellPositions = new Set(map.map);
            cellPositions.forEach((cellPos)=>{
                const docPos = tablePos + cellPos + 1;
                const cell = tableNode.nodeAt(cellPos);
                if (cell) decorations.push((0, $8nvEM.Decoration).node(docPos, docPos + cell.nodeSize, {
                    class: className
                }, {
                    key: `decorationNode-cell-${docPos}`
                }));
            });
        };
        const handleNodeSelection = (node, pos)=>{
            const from = pos;
            const to = from + node.nodeSize;
            decorations.push((0, $8nvEM.Decoration).node(from, to, {
                class: className
            }, {
                key: 'decorationNode'
            }));
            if (node.type.name === 'layoutSection' || node.type.name === 'layoutColumn') {
                const startOfInsideOfContainer = tr.doc.resolve(from + 1);
                const endOfInsideOfContainer = tr.doc.resolve(to - 1);
                handleNodesSelection(startOfInsideOfContainer, endOfInsideOfContainer);
            }
        };
        const handleNodesSelection = ($from, $to)=>{
            let currentPos = $from.pos;
            const sourceNodes = (0, $lVAkE.getSourceNodesFromSelectionRange)(tr, (0, $kCECX.TextSelection).create(tr.doc, currentPos, $to.pos));
            sourceNodes.forEach((sourceNode)=>{
                if (sourceNode.type.name === 'table') {
                    const startPosOfTable = tr.doc.resolve(currentPos + 3);
                    handleTableSelection(startPosOfTable);
                } else handleNodeSelection(sourceNode, currentPos);
                currentPos += sourceNode.nodeSize;
            });
        };
        // Selecting a table directly: CellSelection
        if (selection instanceof (0, $8HW7o.CellSelection)) handleTableSelection();
        // multiselect: TextSelection
        if (selection instanceof (0, $kCECX.TextSelection)) handleNodesSelection(selection.$from, selection.$to);
        if (selection instanceof (0, $kCECX.NodeSelection)) handleNodeSelection(selection.node, selection.from);
        // If no decorations were created, return early
        if (decorations.length === 0) return tr;
        const hasDangerDecorations = className.split(' ').includes('danger');
        tr.setMeta((0, $370fb9c1e84d8dce$export$385f768f10dabdd5), {
            action: add ? (0, $370fb9c1e84d8dce$export$92a1a3b7554e9387).DECORATION_ADD : (0, $370fb9c1e84d8dce$export$92a1a3b7554e9387).DECORATION_REMOVE,
            data: (0, $8nvEM.DecorationSet).create(tr.doc, decorations),
            hasDangerDecorations: (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) && hasDangerDecorations
        }).setMeta('addToHistory', false);
        return tr;
    };
const $6a1963e7667e5672$export$14b7848c5cb6944c = ()=>({ tr: tr })=>{
        return tr.setMeta((0, $370fb9c1e84d8dce$export$385f768f10dabdd5), {
            action: (0, $370fb9c1e84d8dce$export$92a1a3b7554e9387).DECORATION_REMOVE
        });
    };



const $932222f3dc1e86ee$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $370fb9c1e84d8dce$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            hoverDecoration: $370fb9c1e84d8dce$export$fbf24964a8aac61c,
            removeDecoration: $370fb9c1e84d8dce$export$ea377ae2b4b58797
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $370fb9c1e84d8dce$export$385f768f10dabdd5).getState(editorState);
        },
        commands: {
            hoverDecoration: (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? ({ add: add, className: className })=>(0, $6a1963e7667e5672$export$84d8b6d3cf5f2fb4)({
                    add: add,
                    className: className
                }) : undefined,
            removeDecoration: (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? ()=>(0, $6a1963e7667e5672$export$14b7848c5cb6944c)() : undefined
        }
    });
module.exports["decorationsPlugin"] = $932222f3dc1e86ee$export$1c07ef1814918eb5;

});

parcelRegister("e273U", function(module, exports) {

var $LQnOI = parcelRequire("LQnOI");


var $kpCD8 = parcelRequire("kpCD8");


var $cI8RZ = parcelRequire("cI8RZ");


var $kCECX = parcelRequire("kCECX");

var $df90344f393b20ff$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["TOGGLE_DISABLED"] = "TOGGLE_DISABLED";
    return ACTION;
}({});
function $df90344f393b20ff$export$1650419e431d3ba3(pluginState, meta) {
    if (meta && 'action' in meta) switch(meta.action){
        case "TOGGLE_DISABLED":
            if (meta.disabled === pluginState.disabledByPlugin) return pluginState;
            return {
                ...pluginState,
                disabledByPlugin: Boolean(meta.disabled)
            };
        default:
            return pluginState;
    }
    return pluginState;
}


const $26eb73bf8dee9865$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('editorDisabledPlugin');
const { getPluginState: $26eb73bf8dee9865$var$getPluginState } = (0, $cI8RZ.pluginFactory)($26eb73bf8dee9865$export$18d4026d1ea86bb1, (0, $df90344f393b20ff$export$1650419e431d3ba3));
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $26eb73bf8dee9865$var$createPlugin(dispatch, options) {
    const scheduleEditorDisabledUpdate = (0, $LQnOI.default)((view)=>{
        if ($26eb73bf8dee9865$var$getPluginState(view.state).editorDisabled !== !view.editable) {
            const disabledMeta = {
                editorDisabled: !view.editable,
                disabledByPlugin: $26eb73bf8dee9865$var$getPluginState(view.state).disabledByPlugin
            };
            const tr = view.state.tr.setMeta($26eb73bf8dee9865$export$18d4026d1ea86bb1, disabledMeta).setMeta('editorDisabledPlugin', disabledMeta);
            tr.setMeta('isLocal', true);
            view.dispatch(tr);
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $26eb73bf8dee9865$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    editorDisabled: options?.initialDisabledState ?? false,
                    disabledByPlugin: false
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($26eb73bf8dee9865$export$18d4026d1ea86bb1);
                if (meta) {
                    if ('action' in meta) return (0, $df90344f393b20ff$export$1650419e431d3ba3)(pluginState, meta);
                    return pluginState.editorDisabled !== meta.editorDisabled ? {
                        ...pluginState,
                        ...meta
                    } : pluginState;
                }
                return pluginState;
            }
        },
        props: {
            // If we set to undefined it respects the previous value.
            // Prosemirror doesn't have this typed correctly for this type of behaviour
            // @ts-expect-error
            editable: (state)=>{
                const { disabledByPlugin: disabledByPlugin } = $26eb73bf8dee9865$export$18d4026d1ea86bb1.getState(state) ?? {
                    disabledByPlugin: false
                };
                return disabledByPlugin ? false : undefined;
            }
        },
        view: (view)=>{
            // schedule on mount
            scheduleEditorDisabledUpdate(view);
            return {
                update (view) {
                    scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $26eb73bf8dee9865$export$db5fb3a4c4390f03 = ({ config: options = {} })=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $26eb73bf8dee9865$export$18d4026d1ea86bb1.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            return {
                editorDisabled: pluginState.disabledByPlugin || pluginState.editorDisabled
            };
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$26eb73bf8dee9865$var$createPlugin(dispatch, options)
                }
            ],
        commands: {
            toggleDisabled: (disabled)=>({ tr: tr })=>{
                    return tr.setMeta($26eb73bf8dee9865$export$18d4026d1ea86bb1, {
                        action: (0, $df90344f393b20ff$export$9523889e0a5da4ba).TOGGLE_DISABLED,
                        disabled: disabled
                    });
                }
        }
    });
module.exports["editorDisabledPlugin"] = $26eb73bf8dee9865$export$db5fb3a4c4390f03;

});

parcelRegister("5tMpU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $j4yZr = parcelRequire("j4yZr");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $h75sz = parcelRequire("h75sz");


var $4y8CY = parcelRequire("4y8CY");


var $794I6 = parcelRequire("794I6");


var $kpCD8 = parcelRequire("kpCD8");


var $g6uqx = parcelRequire("g6uqx");


var $7XIuB = parcelRequire("7XIuB");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $8dxef = parcelRequire("8dxef");


var $jfFbl = parcelRequire("jfFbl");


var $1TzXg = parcelRequire("1TzXg");





var $fqVYq = parcelRequire("fqVYq");

const $a79e953085a5bfff$export$978ef9948557240e = (nodeType, editorAnalyticsApi, inputMethod)=>({ tr: tr })=>{
        // const { tr, schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $1TzXg.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return tr;
        const schema = tr.doc.type.schema;
        const copyToClipboardTr = tr;
        const domNode = (0, $1TzXg.toDOM)(contentNodeWithPos.node, schema);
        if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) (0, $1TzXg.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
        else if (domNode) {
            const div = document.createElement('div');
            const browser = (0, $8dxef.getBrowserInfo)();
            div.appendChild(domNode);
            // if copying inline content
            if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
            // since we're copying the text inside a paragraph, it will always be 1 1
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '1 1 []');
            else // The "0 0" refers to the start and end depth of the slice
            // since we're copying the block node only, it will always be 0 0
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '0 0 []');
            // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
            // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
            if (browser.safari && tr.selection instanceof (0, $kCECX.NodeSelection) && (tr.selection.node.type === schema.nodes.extension || tr.selection.node.type === schema.nodes.mediaSingle)) (0, $jfFbl.copyHTMLToClipboardPolyfill)(div);
            else (0, $jfFbl.copyHTMLToClipboard)(div);
        }
        if (editorAnalyticsApi) {
            const analyticsPayload = (0, $jfFbl.getNodeCopiedAnalyticsPayload)(contentNodeWithPos.node, inputMethod);
            editorAnalyticsApi.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
        }
        copyToClipboardTr.setMeta('scrollIntoView', false);
        return copyToClipboardTr;
    };








const $29ed443963405b0d$export$ded15a80767f6af7 = new (0, $kCECX.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $29ed443963405b0d$export$2e2bcd8739ae039 = ()=>new (0, $kpCD8.SafePlugin)({
        key: $29ed443963405b0d$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($29ed443963405b0d$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $29ed443963405b0d$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($29ed443963405b0d$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $29ed443963405b0d$export$a2ced8424a9be595(view) {
    const state = view?.state;
    if (state) {
        const { selector: selector } = $29ed443963405b0d$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($29ed443963405b0d$export$1470545de94762f5(null)(tr));
            }
        }
    }
}



var $cI8RZ = parcelRequire("cI8RZ");




const $253a2d3532c32782$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('floatingToolbarData');


const $71d38d9102f2c336$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex,
                confirmDialogForItemOption: action.data.optionIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};


const $7c6e4377f3c3b130$var$dest = (0, $cI8RZ.pluginFactory)((0, $253a2d3532c32782$export$18d4026d1ea86bb1), (0, $71d38d9102f2c336$export$1650419e431d3ba3));
const $7c6e4377f3c3b130$export$656c7661095efe2e = $7c6e4377f3c3b130$var$dest.createPluginState;
const $7c6e4377f3c3b130$export$8d4021544bdece00 = $7c6e4377f3c3b130$var$dest.createCommand;
const $7c6e4377f3c3b130$export$f05434c51e3762e = $7c6e4377f3c3b130$var$dest.getPluginState;


const $59392e752502a84a$export$c0076bd4afc29e7a = (buttonIndex, optionIndex)=>(0, $7c6e4377f3c3b130$export$8d4021544bdece00)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex,
            optionIndex: optionIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $59392e752502a84a$export$5a3c1357cfd1045c = ()=>(0, $7c6e4377f3c3b130$export$8d4021544bdece00)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));







const $5979942893154310$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $kpCD8.SafePlugin)({
        state: (0, $7c6e4377f3c3b130$export$656c7661095efe2e)(dispatch, {}),
        key: (0, $253a2d3532c32782$export$18d4026d1ea86bb1)
    });
};



function $51198a3767e977d6$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}





parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aRGok = parcelRequire("aRGok");





var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $2uDbg = parcelRequire("2uDbg");


var $eTVtR = parcelRequire("eTVtR");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");


var $4aRua = parcelRequire("4aRua");

const $e647ac7c14fd5757$export$9c828de50258a892 = (props)=>{
    const [isChecked, setCheckbox] = (0, $cozmU.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $eTVtR.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $eTVtR.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $eTVtR.default).confirmModalCancel);
    const checkboxlabel = options?.checkboxLabel;
    const childrenInfo = options?.getChildrenInfo?.();
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
            children: nodes.map((node)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $cozmU.createElement)(ListItem, {
                    ...node,
                    key: node.id
                }))
        });
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            id: id,
            children: formatMessage((0, $eTVtR.default).confirmModalListUnit, {
                name: name,
                amount: amount
            })
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7aRdF.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $fEPJS.default), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        children: options?.message
                    }),
                    !!childrenInfo?.length && /*#__PURE__*/ (0, $8aG6j.jsx)(ListComponent, {
                        nodes: childrenInfo
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2uDbg.Checkbox), {
                            isChecked: isChecked,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onChange: ()=>setCheckbox(!isChecked),
                            label: checkboxlabel,
                            testId: testId ? `${testId}-checkbox` : undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $eQiT1.default), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "warning",
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>{
                            onConfirm(isChecked);
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};





parcelRequire("cozmU");





















const $5ac491cc2da92909$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $eTVtR.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $eTVtR.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $eTVtR.default).confirmModalCancel);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7aRdF.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fEPJS.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: options?.message
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $eQiT1.default), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        appearance: "warning",
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>{
                            onConfirm();
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};


const $acf6955f8af027ca$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        isReferentialityDialog ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e647ac7c14fd5757$export$9c828de50258a892), {
            ...props
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5ac491cc2da92909$export$f96c193e316d2274), {
            ...props
        });
    return options ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: renderModel(options?.isReferentialityDialog)
    }) : null;
};
const $acf6955f8af027ca$export$1f33f980da756c46 = (0, $kSwu1.injectIntl)($acf6955f8af027ca$var$ConfirmationModalImpl);


/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $7joZr = parcelRequire("7joZr");


var $b4bEA = parcelRequire("b4bEA");


var $9Jc4C = parcelRequire("9Jc4C");





var $7HhCu = parcelRequire("7HhCu");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $575af3ee78abaa91$var$makeSameType(_a, _b) {
    return true;
}
const $575af3ee78abaa91$export$d36bdfa510afb180 = (objA, objB)=>{
    if (objA === objB) return true;
    if (objA == null || objB == null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
const $575af3ee78abaa91$export$fc16749c794bf6ff = (left, right, compareFn = $575af3ee78abaa91$export$d36bdfa510afb180)=>{
    if (left.length !== right.length) return false;
    for(let idx = 0; idx < left.length; idx++){
        if (!compareFn(left[idx], right[idx])) return false;
    }
    return true;
};
const $575af3ee78abaa91$var$compareItemWithKeys = (leftItem, rightItem, excludedKeys = [])=>Object.keys(leftItem).filter((key)=>excludedKeys.indexOf(key) === -1).every((key)=>leftItem[key] instanceof Object ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $575af3ee78abaa91$export$d36bdfa510afb180(leftItem[key], rightItem[key]) : leftItem[key] === rightItem[key]);
const $575af3ee78abaa91$export$b6007c51cfc2eaf0 = (leftItem, rightItem)=>{
    if (leftItem.type !== rightItem.type) return false;
    switch(leftItem.type){
        case 'button':
            // Need to typecast `rightItem as typeof leftItem` otherwise we will
            // have to put the `type !==` inside each case.
            return $575af3ee78abaa91$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onClick',
                'onMouseEnter',
                'onMouseLeave'
            ]);
        case 'copy-button':
            return $575af3ee78abaa91$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'items'
            ]);
        case 'input':
            return $575af3ee78abaa91$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onSubmit',
                'onBlur'
            ]);
        case 'select':
            if ($575af3ee78abaa91$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !$575af3ee78abaa91$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>$575af3ee78abaa91$var$compareItemWithKeys(left, right))) return false;
            return $575af3ee78abaa91$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onChange',
                'options'
            ]);
        case 'overflow-dropdown':
        case 'dropdown':
            if ($575af3ee78abaa91$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // @ts-expect-error TS2345: Argument of type 'DropdownOptionT<Function>[]' is not assignable to parameter of type 'any[][]'
            !$575af3ee78abaa91$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>// @ts-expect-error  TS2322: Type '"onClick"' is not assignable to type 'keyof any[]'
                $575af3ee78abaa91$var$compareItemWithKeys(left, right, [
                    'onClick'
                ]))) return false;
            return $575af3ee78abaa91$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'options'
            ]);
        case 'custom':
            return false;
        case 'separator':
            return $575af3ee78abaa91$var$compareItemWithKeys(leftItem, rightItem);
        case 'extensions-placeholder':
            return $575af3ee78abaa91$var$compareItemWithKeys(leftItem, rightItem);
    }
};
const $575af3ee78abaa91$export$1d04baad505b720e = (leftArr, rightArr)=>{
    if (leftArr === undefined && rightArr === undefined) return true;
    if (leftArr === undefined || rightArr === undefined) return false;
    if (leftArr.length !== rightArr.length) return false;
    return leftArr.every((item, index)=>$575af3ee78abaa91$export$b6007c51cfc2eaf0(rightArr[index], item));
};





var $2xhuI = parcelRequire("2xhuI");





var $k0VoZ = parcelRequire("k0VoZ");

var $4hfky = parcelRequire("4hfky");

var $huoxr = parcelRequire("huoxr");


var $8VCvx = parcelRequire("8VCvx");


var $fNHEL = parcelRequire("fNHEL");

var $bZDJe = parcelRequire("bZDJe");


var $lqPdm = parcelRequire("lqPdm");


var $6TaGl = parcelRequire("6TaGl");






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $7sJoX = parcelRequire("7sJoX");




parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $3c4eebdca3810775$var$styles = (0, $buxP3.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderInline: 'none'
});
const $3c4eebdca3810775$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        as: "hr",
        xcss: $3c4eebdca3810775$var$styles,
        role: "presentation"
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 














var $huzJY = parcelRequire("huzJY");

const $8362646e2e7c6a1a$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $8362646e2e7c6a1a$var$headingStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $8362646e2e7c6a1a$var$menuContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${$8362646e2e7c6a1a$export$1a7f12094b137d20.width}px`,
    // temporary solution to retain spacing defined by @atlaskit/Item
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& button': {
        minHeight: "var(--ds-space-400, 32px)",
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 7px`,
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [data-item-elem-before]': {
            marginRight: "var(--ds-space-050, 4px)"
        }
    }
});
const $8362646e2e7c6a1a$export$e14354b446b68c1f = 4;
const $8362646e2e7c6a1a$var$Dropdown = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { hide: hide, dispatchCommand: dispatchCommand, items: items, intl: intl, editorView: editorView, showSelected: showSelected = true, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    if (areAnyNewToolbarFlagsEnabled) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $8362646e2e7c6a1a$var$menuContainerStyles,
        role: "menu"
    }, items.filter((item)=>item && (!('hidden' in item) || !item.hidden)).map((item, idx)=>{
        if (!('type' in item)) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9Jc4C.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        });
        if (item.type === 'separator') // eslint-disable-next-line react/no-array-index-key
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7HhCu.DropdownSeparator), {
            key: idx
        });
        if (item.type === 'overflow-dropdown-heading') return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            key: item.title,
            css: $8362646e2e7c6a1a$var$headingStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huzJY.default), null, item.title));
        if (item.type === 'custom') {
            const dropdownMenuOptions = {
                hide: hide,
                dispatchCommand: dispatchCommand,
                editorView: editorView,
                showSelected: showSelected,
                intl: intl
            };
            return item.render(editorView, dropdownMenuOptions);
        }
    }));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $8362646e2e7c6a1a$var$menuContainerStyles,
        role: "menu"
    }, items.filter((item)=>!item.hidden).map((item, idx)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $9Jc4C.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        })));
});
const $8362646e2e7c6a1a$var$_default_1 = (0, $kSwu1.injectIntl)($8362646e2e7c6a1a$var$Dropdown);
var $8362646e2e7c6a1a$export$2e2bcd8739ae039 = $8362646e2e7c6a1a$var$_default_1;


function $ed70d2f676bb905b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $ed70d2f676bb905b$var$dropdownExpandContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $ed70d2f676bb905b$var$iconGroup = {
    name: "zjik7",
    styles: "display:flex"
};
const $ed70d2f676bb905b$var$CompositeIcon = ({ icon: icon })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $ed70d2f676bb905b$var$iconGroup
    }, icon, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $ed70d2f676bb905b$var$dropdownExpandContainer
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        color: "currentColor",
        spacing: "spacious",
        label: "Expand dropdown menu",
        size: "small"
    })));
class $ed70d2f676bb905b$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        const { isOpen: isOpen } = this.state;
        const { title: title, icon: icon, iconBefore: iconBefore, options: options, dispatchCommand: dispatchCommand, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, hideExpandIcon: hideExpandIcon, disabled: disabled, tooltip: tooltip, buttonTestId: buttonTestId, dropdownWidth: dropdownWidth, dropdownListId: dropdownListId, alignDropdownWithToolbar: alignDropdownWithToolbar, footer: footer, onMount: onMount, pulse: pulse, shouldFitContainer: shouldFitContainer, alignX: alignX, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
        let trigger;
        if (icon) {
            const TriggerIcon = hideExpandIcon ? icon : /*#__PURE__*/ (0, $lOiVq.jsx)($ed70d2f676bb905b$var$CompositeIcon, {
                icon: icon
            });
            trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: buttonTestId,
                title: title,
                icon: TriggerIcon,
                onClick: this.toggleOpen,
                onKeyDown: this.toggleOpenByKeyboard,
                selected: isOpen,
                disabled: disabled,
                tooltipContent: tooltip,
                ariaHasPopup: areAnyNewToolbarFlagsEnabled ? true : undefined,
                onMount: onMount,
                pulse: pulse,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        } else trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            testId: buttonTestId,
            iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: $ed70d2f676bb905b$var$dropdownExpandContainer
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Expand dropdown menu",
                size: "small"
            })),
            icon: iconBefore,
            onClick: this.toggleOpen,
            onKeyDown: this.toggleOpenByKeyboard,
            selected: isOpen,
            disabled: disabled,
            tooltipContent: tooltip,
            ariaHasPopup: true,
            areaControls: dropdownListId,
            onMount: onMount,
            pulse: pulse,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, title);
        /**
     * We want to change direction of our dropdowns a bit early,
     * not exactly when it hits the boundary.
     */ const fitTolerance = 10;
        const fitWidth = Array.isArray(options) || typeof options === 'function' ? dropdownWidth || (0, $8362646e2e7c6a1a$export$1a7f12094b137d20).width : options.width;
        const fitHeight = Array.isArray(options) ? options.length * (0, $8362646e2e7c6a1a$export$1a7f12094b137d20).height + (0, $8362646e2e7c6a1a$export$e14354b446b68c1f) * 2 : typeof options === 'function' ? this.makeArrayOptionsFromCallback(options).length : options.height;
        return(/**
       * At the moment footer diver is rendered along with footer, if it's provided
       * This is to provide some level of consistency
       * Refer to the PR for more details:
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137394/overview?commentId=8130003
       */ /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
            alignX: alignX,
            mountTo: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isOpen: isOpen,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideOnEsc,
            onOpenChange: this.onOpenChanged,
            fitWidth: fitWidth + fitTolerance,
            fitHeight: fitHeight + fitTolerance,
            trigger: trigger,
            dropdownListId: dropdownListId,
            alignDropdownWithParentElement: alignDropdownWithToolbar,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU
            },
            shouldFitContainer: shouldFitContainer
        }, Array.isArray(options) ? this.renderArrayOptions(options) : typeof options === 'function' ? this.renderArrayOptions(this.makeArrayOptionsFromCallback(options)) : options.render({
            hide: this.hide,
            dispatchCommand: dispatchCommand
        }), footer && /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3c4eebdca3810775$export$2e0a83ec2e27ecbb), null), footer)));
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpen !== this.state.isOpen) {
            if (this.props.setDisableParentScroll) this.props.setDisableParentScroll(this.state.isOpen);
            // ECA11Y-235: no sense in sending keyboard event since the menu popup mounted to the custom element,
            // we will ensure first element focused asap as 'MenuArrowKeyNavigationProvider' is mounted
            if (this.props.mountPoint) return;
            if (this.state.isOpen && this.state.isOpenedByKeyboard) {
                const dropList = document.querySelector('[data-role="droplistContent"]');
                if (dropList) // Add setTimeout so that if a dropdown item has tooltip,
                // the tooltip won't be rendered until next render cycle
                // when the droplist is correctly positioned.
                // This makes tooltip appears at the correct position for the first dropdown item.
                setTimeout(()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        bubbles: true,
                        key: 'ArrowDown'
                    });
                    dropList.dispatchEvent(keyboardEvent);
                }, 0);
            }
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        };
        this.triggerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.makeArrayOptionsFromCallback = (makeOptions)=>{
            const options = makeOptions();
            return options;
        };
        this.renderArrayOptions = (options)=>{
            const { showSelected: showSelected, dispatchCommand: dispatchCommand, editorView: editorView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8362646e2e7c6a1a$export$2e2bcd8739ae039), {
                hide: this.hide,
                dispatchCommand: dispatchCommand,
                items: options,
                showSelected: showSelected,
                editorView: editorView,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        };
        this.toggleOpen = ()=>{
            const onClick = this.props.onClick;
            if (onClick) onClick();
            this.setState({
                isOpen: !this.state.isOpen,
                isOpenedByKeyboard: false
            });
            const onToggle = this.props.onToggle;
            if (!onToggle) return;
            requestAnimationFrame(()=>{
                this.props.dispatchCommand(onToggle);
            });
        };
        this.toggleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen,
                    isOpenedByKeyboard: true
                });
            }
        };
        this.hide = ()=>{
            this.setState({
                ...this.state,
                isOpen: false
            });
        };
        this.hideOnEsc = ()=>{
            // Focus the trigger button only on Escape
            // Focus is done before hiding to ensure onBlur is called
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            document.querySelector(`[data-testid=${this.props.buttonTestId}]`)?.focus();
            this.hide();
        };
        this.onOpenChanged = (openChangedEvent)=>{
            if (!openChangedEvent.isOpen && openChangedEvent.event instanceof KeyboardEvent) openChangedEvent.event?.key === 'Escape' ? this.hideOnEsc() : this.hide();
        };
    }
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $1sCHt = parcelRequire("1sCHt");


var $3k5Tv = parcelRequire("3k5Tv");





var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $lAkJe = parcelRequire("lAkJe");


var $b35Wv = parcelRequire("b35Wv");


var $lpNn5 = parcelRequire("lpNn5");

function $0edeca7dee59bcfb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $0edeca7dee59bcfb$var$emojiPickerButtonWrapperVisualRefresh = {
    name: "1spoyok",
    styles: "position:relative;button{&:not([disabled])::after{border:none;}}"
};
const $0edeca7dee59bcfb$var$selector = (states)=>{
    return states.emojiState?.emojiProvider;
};
const $0edeca7dee59bcfb$var$EmojiPickerWithProvider = (props)=>{
    const emojiProvider = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.pluginInjectionApi, [
        'emoji'
    ], $0edeca7dee59bcfb$var$selector);
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lAkJe.EmojiPicker), {
        emojiProvider: Promise.resolve(emojiProvider),
        onSelection: props.updateEmoji,
        onPickerRef: setOutsideClickTargetRef
    });
};
// Note: These are based on the height and width of the emoji picker at the time
// of writing (2025-05-05). It is 100% prone to change but at least it's vaguely
// written down.
const $0edeca7dee59bcfb$var$EMOJI_PICKER_MAX_HEIGHT = 431;
const $0edeca7dee59bcfb$var$EMOJI_PICKER_MAX_WIDTH = 352;
const $0edeca7dee59bcfb$var$EmojiPickerWithListener = (0, $9Muxb.default)($0edeca7dee59bcfb$var$EmojiPickerWithProvider);
const $0edeca7dee59bcfb$export$428fcc6fc228bd52 = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const togglePopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        setIsPopupOpen,
        isPopupOpen
    ]);
    const updateEmoji = (emoji)=>{
        setIsPopupOpen(false);
        props.onChange && props.onChange(emoji);
        requestAnimationFrame(()=>{
            props.editorView?.focus();
        });
    };
    const isDetachedElement = (0, $cozmU.useCallback)((el)=>!document.body.contains(el), []);
    const handleEmojiClickOutside = (0, $cozmU.useCallback)((e)=>{
        // Ignore click events for detached elements.
        // Workaround for CETI-240 - where two onClicks fire - one when the upload button is
        // still in the document, and one once it's detached. Does not always occur, and
        // may be a side effect of a react render optimisation
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        if (e && e.target && !isDetachedElement(e.target)) togglePopup();
    }, [
        isDetachedElement,
        togglePopup
    ]);
    const handleEmojiPressEscape = (0, $cozmU.useCallback)(()=>{
        setIsPopupOpen(false);
        buttonRef.current?.focus();
    }, [
        setIsPopupOpen,
        buttonRef
    ]);
    const renderPopup = ()=>{
        if (!buttonRef.current || !isPopupOpen) return;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
            target: buttonRef.current,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            mountTo: props.setDisableParentScroll ? props.mountPoint : buttonRef.current.parentElement,
            fitHeight: $0edeca7dee59bcfb$var$EMOJI_PICKER_MAX_HEIGHT,
            fitWidth: $0edeca7dee59bcfb$var$EMOJI_PICKER_MAX_WIDTH,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                10
            ],
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            focusTrap: true,
            preventOverflow: true,
            boundariesElement: props.popupsBoundariesElement
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($0edeca7dee59bcfb$var$EmojiPickerWithListener, {
            handleEscapeKeydown: handleEmojiPressEscape,
            handleClickOutside: handleEmojiClickOutside,
            pluginInjectionApi: props.pluginInjectionApi,
            updateEmoji: updateEmoji
        }));
    };
    const title = props.title || '';
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $0edeca7dee59bcfb$var$emojiPickerButtonWrapperVisualRefresh
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: title,
        position: "top"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1sCHt.default), {
        appearance: "subtle",
        key: props.idx,
        onClick: togglePopup,
        ref: buttonRef,
        isSelected: props.isSelected,
        label: title,
        spacing: "compact",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
                color: "currentColor",
                label: "emoji-picker-button",
                spacing: "spacious"
            })
    })), renderPopup());
};









var $4wH3g = parcelRequire("4wH3g");





var $50UK1 = parcelRequire("50UK1");


var $hZ5o2 = parcelRequire("hZ5o2");

var $9GCRb = parcelRequire("9GCRb");







var $gWBVp = parcelRequire("gWBVp");


const $f4ee47516c68be8d$var$noop = ()=>null;
const $f4ee47516c68be8d$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $f4ee47516c68be8d$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $f4ee47516c68be8d$var$noop;
    const maybeIcon = await getIcon();
    return $f4ee47516c68be8d$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $f4ee47516c68be8d$var$ExtensionButton = (props)=>{
    const { item: item, node: node, extensionApi: extensionApi, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>item.icon ? (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
            __loadable_id__: "aISYW",
            name: "platform.packages.editor.editor-plugin-floating-toolbar.src.ui.ExtensionsPlaceholder",
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            loader: async ()=>$f4ee47516c68be8d$var$resolveExtensionIcon(item.icon),
            loading: $f4ee47516c68be8d$var$noop
        }) : undefined, [
        item.icon
    ]);
    const onClick = ()=>{
        if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
        const targetNodeAdf = (0, $gWBVp.nodeToJSON)(node);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        item.action(targetNodeAdf, extensionApi);
    };
    const getAriaLabel = ()=>{
        if (item.ariaLabel) return item.ariaLabel;
        if (typeof item.tooltip === 'string') return item.tooltip;
        if (item.label) return item.label;
        return '';
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
        title: item.label,
        ariaLabel: getAriaLabel(),
        icon: ButtonIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)(ButtonIcon, {
            label: item.label || ''
        }) : undefined,
        onClick: onClick,
        tooltipContent: item.tooltip,
        tooltipStyle: item.tooltipStyle,
        disabled: item.disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: item.label
    });
};
const $f4ee47516c68be8d$export$8bacfc8aacebb3c1 = (props)=>{
    const { node: node, editorView: editorView, extensionProvider: extensionProvider, separator: separator, applyChangeToContextPanel: applyChangeToContextPanel, extensionApi: extensionApi, scrollable: scrollable, setDisableScroll: setDisableScroll, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, alignDropdownWithToolbar: alignDropdownWithToolbar, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    // leaving dependencies array empty so that this effect runs just once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $gWBVp.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $50UK1.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extensionApi);
    }, [
        extensions,
        nodeAdf,
        extensionApi
    ]);
    if (!extensionItems.length) return null;
    // ButtonGroup wraps each child with another layer
    // but count fragment as 1 child, so here we create the children manually.
    const children = [];
    if (separator && [
        'start',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $huoxr.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    const isNestedTable = (0, $hZ5o2.isNestedTablesSupported)(editorView.state.schema) && (0, $9GCRb.isSelectionTableNestedInTable)(editorView.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extensionItems.forEach((item, index)=>{
        // disable the referentiality and charts extensions for nested tables
        if (isNestedTable && [
            'referentiality:connections',
            'chart:insert-chart'
        ].includes(item.key)) item.disabled = true;
        if ('type' in item && item.type === 'dropdown') children.push(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $ed70d2f676bb905b$export$2e2bcd8739ae039), {
            title: item.title,
            icon: item.icon,
            dispatchCommand: dispatchCommand || (()=>{}),
            options: item.options,
            disabled: item.disabled,
            tooltip: item.tooltip,
            hideExpandIcon: item.hideExpandIcon,
            mountPoint: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            dropdownWidth: item.dropdownWidth,
            showSelected: item.showSelected,
            buttonTestId: item.testId,
            editorView: editorView,
            setDisableParentScroll: scrollable ? setDisableScroll : undefined,
            dropdownListId: item?.id && `${item.id}-dropdownList`,
            alignDropdownWithToolbar: alignDropdownWithToolbar,
            onToggle: item.onToggle,
            footer: item.footer,
            onMount: item.onMount,
            onClick: item.onClick,
            pulse: item.pulse,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, item.id));
        else children.push(/*#__PURE__*/ (0, $8aG6j.jsx)($f4ee47516c68be8d$var$ExtensionButton, {
            node: node,
            item: item,
            editorView: editorView,
            applyChangeToContextPanel: applyChangeToContextPanel,
            extensionApi: extensionApi,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
        if (index < extensionItems.length - 1) children.push(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $huoxr.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    });
    if (separator && [
        'end',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $huoxr.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    // eslint-disable-next-line react/no-children-prop
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7joZr.default), {
        children: children
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $i94vj = parcelRequire("i94vj");

const $91151e103df439e1$export$f5b8910cec6cf069 = (props)=>{
    const { defaultValue: defaultValue, onBlur: onBlur, onSubmit: onSubmit, placeholder: placeholder } = props;
    const [text, setText] = (0, $cozmU.useState)(defaultValue || '');
    const handleChange = (e)=>{
        setText(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSubmit && onSubmit(text);
    };
    const handleBlur = (e)=>{
        e.preventDefault();
        onBlur && onBlur(text);
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("input", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $i94vj.panelTextInput),
        value: text,
        onChange: handleChange,
        placeholder: placeholder,
        onBlur: handleBlur
    }));
};









var $cbY7C = parcelRequire("cbY7C");


var $LQnOI = parcelRequire("LQnOI");








var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");






const $baa96edfc200e64b$var$rightSideStyles = (0, $buxP3.xcss)({
    borderLeft: `solid ${"var(--ds-border, #0B120E24)"} 1px`,
    right: 'space.0',
    borderTopRightRadius: 'radius.small',
    borderBottomRightRadius: 'radius.small'
});
const $baa96edfc200e64b$var$leftSideStyles = (0, $buxP3.xcss)({
    borderRight: `solid ${"var(--ds-border, #0B120E24)"} 1px`,
    left: 'space.0',
    borderTopLeftRadius: 'radius.small',
    borderBottomLeftRadius: 'radius.small'
});
const $baa96edfc200e64b$var$buttonCommonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    zIndex: '1',
    position: 'absolute'
});
const $baa96edfc200e64b$export$93d01adc5582c83e = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, side: side })=>{
    const [needScroll, setNeedScroll] = (0, $cozmU.useState)(false);
    const [canScrollToSide, setCanScrollToSide] = (0, $cozmU.useState)(true);
    const setCanScrollDebounced = (0, $LQnOI.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollToSide(// -1 to account for pixel rounding error
        side === 'left' ? scrollLeft > 0 : scrollLeft < scrollWidth - offsetWidth - 1);
    });
    const onScroll = ()=>{
        setCanScrollDebounced();
    };
    const onClick = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        const scrollTo = side === 'left' ? scrollLeft - scrollContainerWidth : scrollLeft + scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((_t)=>{
        const widthNeededToShowAllItems = scrollContainerRef.current?.scrollWidth || 0;
        const parentNode = scrollContainerRef.current?.parentNode;
        let availableSpace = -1;
        if (parentNode instanceof HTMLElement) availableSpace = parentNode.offsetWidth;
        if (availableSpace === -1) return;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $cozmU.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        let unbind;
        if (scrollContainerRefCurrent) {
            // Adding/removing scroll button depending on scroll position
            unbind = (0, $cbY7C.bind)(scrollContainerRefCurrent, {
                type: 'scroll',
                listener: onScroll
            });
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                unbind?.();
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) // reset scroll position when switching from one node with toolbar to another
        // scroll to made optional as it may not be rendered in testing env
        scrollContainerRefCurrent.scrollTo?.({
            left: 0
        });
    }, [
        node.type,
        scrollContainerRef
    ]);
    const Icon = side === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    return needScroll && (side === 'left' && canScrollToSide || side === 'right' && canScrollToSide) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        padding: "space.050",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            side === 'left' ? $baa96edfc200e64b$var$leftSideStyles : $baa96edfc200e64b$var$rightSideStyles,
            $baa96edfc200e64b$var$buttonCommonStyles
        ],
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            label: intl.formatMessage(side === 'left' ? (0, $eTVtR.default).floatingToolbarScrollLeft : (0, $eTVtR.default).floatingToolbarScrollRight),
            onClick: onClick,
            isDisabled: disabled,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                    label: iconProps.label,
                    size: "small"
                }),
            isTooltipDisabled: false,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            tooltip: {
                position: 'top'
            }
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 




















// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $0d69ea4c2b0a098d$var$toolbarScrollButtons = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    borderLeft: `solid ${"var(--ds-border, #0B120E24)"} ${"var(--ds-border-width, 1px)"}`,
    flexShrink: 0,
    alignItems: 'center'
});
const $0d69ea4c2b0a098d$var$LeftIcon = (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI)));
const $0d69ea4c2b0a098d$var$RightIcon = (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
const $0d69ea4c2b0a098d$export$154bc6e95efc5a0d = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const buttonsContainerRef = (0, $cozmU.useRef)(null);
    const [needScroll, setNeedScroll] = (0, $cozmU.useState)(false);
    const [canScrollLeft, setCanScrollLeft] = (0, $cozmU.useState)(true);
    const [canScrollRight, setCanScrollRight] = (0, $cozmU.useState)(true);
    const setCanScrollDebounced = (0, $LQnOI.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft + offsetWidth < scrollWidth - 1); // -1 to account for half pixel
    });
    const onScroll = ()=>setCanScrollDebounced();
    const scrollLeft = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        // scroll to current position - scroll container width
        const scrollTo = scrollLeft - scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        // scroll to current position + scroll container width
        const scrollTo = scrollLeft + scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((t)=>{
        const widthNeededToShowAllItems = scrollContainerRef.current?.scrollWidth || 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const availableSpace = scrollContainerRef.current?.parentNode?.offsetWidth;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $cozmU.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) {
            // enable/disable scroll buttons depending on scroll position
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollContainerRefCurrent.addEventListener('scroll', onScroll);
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollContainerRefCurrent.removeEventListener('scroll', onScroll);
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) // reset scroll position when switching from one node with toolbar to another
        // scroll to made optional as it may not be rendered in testing env
        scrollContainerRefCurrent.scrollTo?.({
            left: 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        node.type
    ]);
    return needScroll ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: buttonsContainerRef,
        css: $0d69ea4c2b0a098d$var$toolbarScrollButtons,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "scroll-buttons"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
        title: intl.formatMessage((0, $eTVtR.default).floatingToolbarScrollLeft),
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)($0d69ea4c2b0a098d$var$LeftIcon, {
            label: intl.formatMessage((0, $eTVtR.default).floatingToolbarScrollLeft),
            size: "small"
        }),
        onClick: scrollLeft,
        disabled: !canScrollLeft || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
        title: intl.formatMessage((0, $eTVtR.default).floatingToolbarScrollRight),
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)($0d69ea4c2b0a098d$var$RightIcon, {
            label: intl.formatMessage((0, $eTVtR.default).floatingToolbarScrollRight),
            size: "small"
        }),
        onClick: scrollRight,
        disabled: !canScrollRight || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    })) : null;
};









var $6wGOF = parcelRequire("6wGOF");

function $7ca7de4e05fc2cf3$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = (0, $cozmU.useRef)(null);
    const { width: width = 200 } = props;
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            container: (base)=>({
                    ...base,
                    width: width
                }),
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuPortal: (base)=>{
                // ED:16095: We add two possible getter paths for safely reaching into the underlying
                // react-select element. We first try a getter that conforms with react-select v5 APIs,
                // Failing that, we try a getter consistent with react-select v4 APIs. (We
                // handle both as consumers may control the time of the actual dependency version
                // cutover).
                const controlWrapper = selectRef?.current?.select?.controlRef?.parentNode || selectRef?.current?.select?.select?.controlRef?.parentNode;
                const menuPortalStyles = controlWrapper && props.setDisableParentScroll ? {
                    // since the portal is now outside, we need to position it as before
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    top: controlWrapper.offsetTop,
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    left: controlWrapper.offsetLeft,
                    height: controlWrapper.offsetHeight,
                    width: width
                } : {};
                return {
                    ...base,
                    ...menuPortalStyles
                };
            }
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        width
    ]);
    const onMenuOpen = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(true);
    };
    const onMenuClose = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(false);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
        ref: selectRef,
        options: props.options,
        value: props.defaultValue,
        onChange: props.onChange,
        placeholder: props.placeholder,
        spacing: "compact",
        menuPlacement: "auto",
        filterOption: props.filterOption,
        styles: style,
        menuPortalTarget: props.mountPoint,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        label: props.ariaLabel,
        classNamePrefix: props.classNamePrefix
    });
}


function $4424bc712b49a931$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $4424bc712b49a931$export$7abc8284d66f79b1(items, areAnyNewToolbarFlagsEnabled) {
    const groupItems = items.reduce((accumulator, item, i)=>{
        const { finalOutput: finalOutput, buttonGroup: buttonGroup } = accumulator;
        if (item.type === 'button') {
            const notLastItem = i < items.length - 1;
            const nextItemIsButton = items[i + 1] && items[i + 1].type === 'button';
            const wasPreviousButton = items[i - 1] && items[i - 1].type === 'button';
            const shouldBeRadioButton = notLastItem && nextItemIsButton || wasPreviousButton;
            // Only group as radio button if not explicitly set to false
            const isRadioButton = !(0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? shouldBeRadioButton : shouldBeRadioButton && item.isRadioButton !== false;
            if (isRadioButton) {
                item.isRadioButton = true;
                buttonGroup.push(item);
                if (!nextItemIsButton && wasPreviousButton) {
                    finalOutput.push(buttonGroup);
                    accumulator.buttonGroup = [];
                }
            } else finalOutput.push(item);
        } else if (item.type === 'separator' && areAnyNewToolbarFlagsEnabled) {
            const isLeadingSeparator = i === 0;
            const isTrailingSeparator = i === items.length - 1;
            const isDuplicateSeparator = items[i - 1]?.type === 'separator';
            !isLeadingSeparator && !isTrailingSeparator && !isDuplicateSeparator && finalOutput.push(item);
        } else finalOutput.push(item);
        return accumulator;
    }, {
        buttonGroup: [],
        finalOutput: []
    });
    return groupItems.finalOutput;
}
const $4424bc712b49a931$var$ToolbarItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ items: items, groupLabel: groupLabel, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsScrollableElement: popupsScrollableElement, scrollable: scrollable, providerFactory: providerFactory, extensionsProvider: extensionsProvider, node: node, setDisableScroll: setDisableScroll, mountRef: mountRef, api: api, intl: intl })=>{
    const emojiAndColourPickerMountPoint = scrollable ? popupsMountPoint || editorView?.dom.closest('.fabric-editor-popup-scroll-parent') || editorView?.dom.closest('.ak-editor-content-area') || undefined : popupsMountPoint;
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const renderItem = (item, idx)=>{
        switch(item.type){
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                const onClickHandler = ()=>{
                    if (item.confirmDialog) dispatchCommand((0, $59392e752502a84a$export$c0076bd4afc29e7a)(idx));
                    else {
                        dispatchCommand(item.onClick);
                        if (item.focusEditoronEnter && !editorView?.hasFocus()) editorView?.focus();
                    }
                };
                const getIconColor = (disabled, selected)=>{
                    if (disabled) return "var(--ds-icon-disabled, #080F214A)";
                    if (selected) return "var(--ds-icon-selected, #1868DB)";
                    return 'currentColor';
                };
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    className: item.className,
                    key: idx,
                    title: item.title,
                    href: item.href,
                    icon: item.icon ? /*#__PURE__*/ (0, $lOiVq.jsx)(ButtonIcon, {
                        color: getIconColor(item.disabled, item.selected),
                        spacing: "spacious",
                        label: undefined,
                        "aria-hidden": true
                    }) : undefined,
                    iconAfter: item.iconAfter ? /*#__PURE__*/ (0, $lOiVq.jsx)(item.iconAfter, {
                        label: ""
                    }) : undefined,
                    appearance: item.appearance,
                    target: item.target,
                    onClick: onClickHandler,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onMouseEnter: ()=>dispatchCommand(item.onMouseEnter),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onMouseLeave: ()=>dispatchCommand(item.onMouseLeave),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onFocus: ()=>dispatchCommand(item.onFocus),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onBlur: ()=>dispatchCommand(item.onBlur),
                    onMount: item.onMount,
                    onUnmount: item.onUnmount,
                    selected: item.selected,
                    disabled: item.disabled,
                    tooltipContent: item.tooltipContent,
                    testId: item.testId,
                    hideTooltipOnClick: item.hideTooltipOnClick,
                    ariaHasPopup: item.ariaHasPopup,
                    tabIndex: item.tabIndex,
                    isRadioButton: item.isRadioButton,
                    ariaLabel: item?.ariaLabel,
                    pulse: item.pulse,
                    interactionName: item.interactionName,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, item.showTitle && item.title);
            case 'input':
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $91151e103df439e1$export$f5b8910cec6cf069), {
                    key: idx,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    defaultValue: item.defaultValue,
                    placeholder: item.placeholder,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onSubmit: (value)=>dispatchCommand(item.onSubmit(value)),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onBlur: (value)=>dispatchCommand(item.onBlur(value))
                });
            case 'custom':
                return item.render(editorView, idx, dispatchAnalyticsEvent, {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    scrollable: scrollable,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined
                });
            case 'overflow-dropdown':
                // if an option has a confirmDialog, we need to replace its onClick handler
                // to set the state to show the confirm dialog
                // crudely done here to avoid greater coupling with DropdownMenuItem from `floating-toolbar`
                // which would need knowledge of indexes, showConfirmDialog etc.
                const options = item.options.map((option, optionIndex)=>{
                    if (!('type' in option) && option.confirmDialog) {
                        const onClick = option.confirmDialog ? (0, $59392e752502a84a$export$c0076bd4afc29e7a)(idx, optionIndex) : option.onClick;
                        return {
                            ...option,
                            onClick: onClick
                        };
                    }
                    return option;
                });
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ed70d2f676bb905b$export$2e2bcd8739ae039), {
                    alignX: areAnyNewToolbarFlagsEnabled ? 'right' : undefined,
                    key: idx,
                    title: intl.formatMessage((0, $2xhuI.default).viewMore),
                    icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        label: "",
                        spacing: "spacious"
                    }),
                    dispatchCommand: dispatchCommand,
                    options: options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: true,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: item?.id && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onClick: item.onClick,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'dropdown':
                const DropdownIcon = item.icon;
                const BeforeIcon = item.iconBefore;
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ed70d2f676bb905b$export$2e2bcd8739ae039), {
                    key: idx,
                    title: item.title,
                    icon: DropdownIcon && /*#__PURE__*/ (0, $lOiVq.jsx)(DropdownIcon, {
                        label: item.title
                    }),
                    iconBefore: BeforeIcon && /*#__PURE__*/ (0, $lOiVq.jsx)(BeforeIcon, {
                        label: ""
                    }),
                    dispatchCommand: dispatchCommand,
                    options: item.options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: item.hideExpandIcon,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: item?.id && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onToggle: item.onToggle,
                    footer: item.footer,
                    onMount: item.onMount,
                    onClick: item.onClick,
                    pulse: item.pulse,
                    shouldFitContainer: item.shouldFitContainer,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'select':
                if (item.selectType === 'list') {
                    const ariaLabel = item.title || item.placeholder;
                    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7ca7de4e05fc2cf3$export$2e2bcd8739ae039), {
                        key: idx,
                        dispatchCommand: dispatchCommand,
                        options: item.options,
                        hideExpandIcon: item.hideExpandIcon,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        mountPoint: scrollable ? mountRef.current : undefined,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement,
                        defaultValue: item.defaultValue,
                        placeholder: item.placeholder,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                        ariaLabel: ariaLabel,
                        filterOption: item.filterOption,
                        setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                        classNamePrefix: 'floating-toolbar-select'
                    });
                }
                if (item.selectType === 'color') return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fNHEL.default), {
                    skipFocusButtonAfterPick: true,
                    key: idx,
                    isAriaExpanded: item.isAriaExpanded,
                    title: item.title,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onChange: (selected)=>{
                        dispatchCommand(item.onChange(selected));
                    },
                    cols: item.cols,
                    colorPalette: item.options,
                    currentColor: item.defaultValue ? item.defaultValue.value : undefined,
                    placement: "Panels",
                    mountPoint: emojiAndColourPickerMountPoint,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    // Currently in floating toolbar, color picker is only
                    //  used in panel and table cell background color.
                    // Both uses same color palette.
                    // That's why hard-coding hexToEditorBackgroundPaletteColor
                    //  and paletteColorTooltipMessages.
                    // When we need to support different color palette
                    //  in floating toolbar, we need to set hexToPaletteColor
                    //  and paletteColorTooltipMessages in item options.
                    hexToPaletteColor: (0, $lqPdm.hexToEditorBackgroundPaletteColor),
                    paletteColorTooltipMessages: (0, $8VCvx.backgroundPaletteTooltipMessages),
                    returnEscToButton: item.returnEscToButton
                });
                if (item.selectType === 'emoji') return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $0edeca7dee59bcfb$export$428fcc6fc228bd52), {
                    key: idx,
                    editorView: editorView,
                    title: item.title,
                    providerFactory: providerFactory,
                    isSelected: item.selected,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                    mountPoint: emojiAndColourPickerMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    pluginInjectionApi: api
                });
                return null;
            case 'extensions-placeholder':
                if (!editorView || !extensionsProvider) return null;
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f4ee47516c68be8d$export$8bacfc8aacebb3c1), {
                    key: idx,
                    node: node,
                    editorView: editorView,
                    extensionProvider: extensionsProvider,
                    separator: item.separator,
                    applyChangeToContextPanel: api?.contextPanel?.actions.applyChange,
                    extensionApi: api?.extension?.actions.api(),
                    dispatchCommand: dispatchCommand,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    alignDropdownWithToolbar: items.length === 1,
                    scrollable: scrollable,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'separator':
                if (areAnyNewToolbarFlagsEnabled) return item.fullHeight ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    key: idx,
                    fullHeight: true,
                    areAnyNewToolbarFlagsEnabled: true
                }) : null;
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    key: idx,
                    fullHeight: item.fullHeight,
                    areAnyNewToolbarFlagsEnabled: false
                });
        }
    };
    const groupedItems = $4424bc712b49a931$export$7abc8284d66f79b1(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    items.filter((item)=>!item.hidden), areAnyNewToolbarFlagsEnabled);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7joZr.default), {
        testId: "editor-floating-toolbar-items"
    }, groupedItems.map((element, index)=>{
        const isGroup = Array.isArray(element);
        if (isGroup) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            css: areAnyNewToolbarFlagsEnabled ? $4424bc712b49a931$var$buttonGroupStylesNew : $4424bc712b49a931$var$buttonGroupStyles,
            role: "radiogroup",
            "aria-label": groupLabel ?? undefined,
            "data-testid": "editor-floating-toolbar-grouped-buttons"
        }, element.map((element)=>{
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }));
        else {
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }
    }));
}, (prevProps, nextProps)=>{
    if (!nextProps.node) return false;
    // only rerender toolbar items if the node is different
    // otherwise it causes an issue where multiple popups stays open
    return !(prevProps.node.type !== nextProps.node.type || prevProps.node.attrs.localId !== nextProps.node.attrs.localId || prevProps.popupsBoundariesElement !== nextProps.popupsBoundariesElement || prevProps.popupsMountPoint !== nextProps.popupsMountPoint || prevProps.popupsScrollableElement !== nextProps.popupsScrollableElement || prevProps.scrollable !== nextProps.scrollable || prevProps.setDisableScroll !== nextProps.setDisableScroll || !(0, $575af3ee78abaa91$export$1d04baad505b720e)(prevProps.items, nextProps.items) || !prevProps.mounted !== !nextProps.mounted);
});
const $4424bc712b49a931$var$buttonGroupStyles = {
    name: "h1up05",
    styles: "display:flex;gap:var(--ds-space-050, 4px)"
};
const $4424bc712b49a931$var$buttonGroupStylesNew = {
    name: "gcdzb",
    styles: "display:flex;gap:var(--ds-space-075, 6px)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $4424bc712b49a931$var$_ref6 = {
    name: "q568uz",
    styles: "min-height:var(--ds-space-500, 40px)"
};
var $4424bc712b49a931$var$_ref7 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $4424bc712b49a931$var$_ref8 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $4424bc712b49a931$var$_ref9 = {
    name: "s0vnfv",
    styles: "height:32px"
};
var $4424bc712b49a931$var$_ref0 = {
    name: "1k18kha",
    styles: "height:40px"
};
const $4424bc712b49a931$var$toolbarContainer = (areAnyNewToolbarFlagsEnabled, scrollable, hasSelect, firstElementIsSelect)=>/*#__PURE__*/ (0, $lOiVq.css)("background-color:var(--ds-surface-overlay, #FFFFFF);border-radius:var(--ds-radius-small, 3px);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:flex;line-height:1;box-sizing:border-box;& > div > div{align-items:center;}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasSelect ? $4424bc712b49a931$var$_ref0 : $4424bc712b49a931$var$_ref9, "overflow:hidden;") : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0px)"} 4px ${"var(--ds-space-0, 0px)"} 4px`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $4424bc712b49a931$var$_ref8) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $lOiVq.css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $4424bc712b49a931$var$_ref7), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? $4424bc712b49a931$var$_ref6 : undefined);
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $4424bc712b49a931$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $4424bc712b49a931$var$_ref2 = {
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
};
var $4424bc712b49a931$var$_ref3 = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};
var $4424bc712b49a931$var$_ref4 = {
    name: "upho8i",
    styles: "overflow-x:auto;overflow-y:hidden;scrollbar-width:none"
};
var $4424bc712b49a931$var$_ref5 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $4424bc712b49a931$var$toolbarOverflow = ({ scrollable: scrollable, scrollDisabled: scrollDisabled, firstElementIsSelect: firstElementIsSelect, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollDisabled ? $4424bc712b49a931$var$_ref5 : $4424bc712b49a931$var$_ref4, {
        WebkitOverflowScrolling: 'touch',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '> div:first-child': firstElementIsSelect ? $4424bc712b49a931$var$_ref3 : $4424bc712b49a931$var$_ref2,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:nth-last-child(1 of :not(:where([popover], dialog)))': {
                marginRight: "var(--ds-space-100, 8px)"
            }
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0px)"} 4px ${"var(--ds-space-600, 48px)"} 4px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> div': {
            minHeight: "var(--ds-space-500, 40px)",
            gap: "var(--ds-space-075, 6px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:first-child': {
                marginLeft: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:nth-last-child(1 of :not(:where([popover], dialog)))': {
                marginRight: 0
            }
        }
    }) : undefined) : $4424bc712b49a931$var$_ref);
// eslint-disable-next-line @repo/internal/react/no-class-components
class $4424bc712b49a931$var$Toolbar extends (0, $cozmU.Component) {
    // remove any decorations added by toolbar buttons i.e danger and selected styling
    // this prevents https://product-fabric.atlassian.net/browse/ED-10207
    resetStyling() {
        if (this.props.editorView) {
            const { state: state, dispatch: dispatch } = this.props.editorView;
            this.props.api?.decorations?.actions.removeDecoration(state, dispatch);
        }
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
    }
    componentDidUpdate(prevProps) {
        (0, $29ed443963405b0d$export$a2ced8424a9be595)(this.props?.editorView);
        if (this.props.node !== prevProps.node) this.resetStyling();
    }
    componentWillUnmount() {
        const { editorView: editorView } = this.props;
        if (editorView) {
            const { state: { tr: tr }, dispatch: dispatch } = editorView;
            dispatch((0, $29ed443963405b0d$export$1470545de94762f5)(null)(tr));
        }
        this.resetStyling();
    }
    render() {
        const { items: items, className: className, node: node, intl: intl, scrollable: scrollable, mediaAssistiveMessage: mediaAssistiveMessage } = this.props;
        const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(this.props.api?.toolbar));
        if (!items || !items.length) return null;
        // Select has left padding of 4px to the border, everything else 8px
        const firstElementIsSelect = items[0].type === 'select';
        const hasSelect = items.find((item)=>item.type === 'select' && item.selectType === 'list');
        const shouldRenderAssistiveAnnouncer = (0, $ieeJu.expValEquals)('editor_a11y_role_textbox', 'isEnabled', true) ? this.doesNodeRequireAssitiveMessage(node) : true;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
            editorView: this.props.editorView,
            handleEscape: this.handleEscape,
            disableArrowKeyNavigation: !this.shouldHandleArrowKeys(),
            childComponentSelector: "[data-testid='editor-floating-toolbar']",
            isShortcutToFocusToolbar: this.isShortcutToFocusToolbar,
            intl: intl
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            ref: this.toolbarContainerRef,
            css: ()=>[
                    $4424bc712b49a931$var$toolbarContainer(areAnyNewToolbarFlagsEnabled, scrollable, hasSelect !== undefined, firstElementIsSelect)
                ],
            "aria-label": intl.formatMessage((0, $eTVtR.default).floatingToolbarAriaLabel),
            role: "toolbar",
            "data-testid": "editor-floating-toolbar",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            onMouseDown: areAnyNewToolbarFlagsEnabled ? this.captureMouseEvent : undefined
        }, shouldRenderAssistiveAnnouncer && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $k0VoZ.default), {
            text: mediaAssistiveMessage ? `${mediaAssistiveMessage}, ${intl.formatMessage((0, $eTVtR.default).floatingToolbarAnnouncer)}` : intl.formatMessage((0, $eTVtR.default).floatingToolbarAnnouncer),
            delay: 250
        }), scrollable && areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $baa96edfc200e64b$export$93d01adc5582c83e), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "left"
        }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "data-testid": "floating-toolbar-items",
            ref: this.scrollContainerRef,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $4424bc712b49a931$var$toolbarOverflow({
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
                scrollable: scrollable,
                scrollDisabled: this.state.scrollDisabled,
                firstElementIsSelect: firstElementIsSelect
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($4424bc712b49a931$var$ToolbarItems, {
            ...this.props,
            setDisableScroll: this.setDisableScroll,
            mountRef: this.mountRef,
            mounted: this.state.mounted
        })), scrollable && (areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $baa96edfc200e64b$export$93d01adc5582c83e), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "right"
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $0d69ea4c2b0a098d$export$154bc6e95efc5a0d), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }))), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            ref: this.mountRef
        })));
    }
    constructor(props){
        super(props);
        this.scrollContainerRef = void 0;
        this.mountRef = void 0;
        this.toolbarContainerRef = void 0;
        this.setDisableScroll = (disabled)=>{
            // wait before setting disabled state incase users jumping from one popup to another
            if (disabled) requestAnimationFrame(()=>{
                this.setState({
                    scrollDisabled: disabled
                });
            });
            else this.setState({
                scrollDisabled: disabled
            });
        };
        this.shouldHandleArrowKeys = ()=>{
            //To prevent the keydown handling of arrow keys for custom toolbar items with 'disableArrowNavigation' prop enabled,
            //Usually the button which has menus or popups
            return !this.props.items?.find((item)=>item.type === 'custom' && item.disableArrowNavigation);
        };
        this.handleEscape = (event)=>{
            // If any menu is open inside the floating toolbar 'Esc' key should not
            // focus the editorview.
            // Event can't be stopped as they are not childnodes of floating toolbar
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const isDropdownOpen = !!document.querySelector('[data-role="droplistContent"]');
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const isSelectMenuOpen = !!document.querySelector('.floating-toolbar-select__menu');
            if (isDropdownOpen || isSelectMenuOpen) return;
            this.props.editorView?.focus();
            event.preventDefault();
            event.stopPropagation();
        };
        this.captureMouseEvent = (event)=>{
            // Don't capture mouse event for custom toolbars e.g. insert hyperlink
            if (this.props.items?.length === 1 && this.props.items[0].type === 'custom') return;
            // Prevents toolbar from closing when clicking on the toolbar itself and not on the buttons
            event.stopPropagation();
            event.preventDefault();
        };
        this.isShortcutToFocusToolbar = (event)=>{
            //Alt + F10 to reach first element in this floating toolbar
            return event.altKey && (event.key === 'F10' || event.keyCode === 121);
        };
        this.doesNodeRequireAssitiveMessage = (node)=>{
            // Code blocks have an assistive message to announce the content of the code block to screen readers, so we don't need to announce the floating toolbar for those nodes
            const nodesWithAlternativeRoles = [
                'codeBlock'
            ];
            if (nodesWithAlternativeRoles.includes(node.type.name)) return false;
            return true;
        };
        this.scrollContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.mountRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.toolbarContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = {
            scrollDisabled: false,
            mounted: false
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $4424bc712b49a931$var$_default_1 = (0, $kSwu1.injectIntl)($4424bc712b49a931$var$Toolbar);
var $4424bc712b49a931$export$2e2bcd8739ae039 = $4424bc712b49a931$var$_default_1;


const $46dc0e486ec6f0a6$export$2f5751d7b477f660 = (overflowDropdowns)=>{
    if (overflowDropdowns.length <= 1) return overflowDropdowns[0];
    const combinedItems = overflowDropdowns.reduce((acc, item)=>{
        if (item.options) acc.push(...item.options);
        return acc;
    }, []);
    // To filter out items that have a rank property, sort them by rank in descending order (highest rank first)
    const rankedItems = combinedItems.filter((item)=>'rank' in item && typeof item.rank === 'number').sort((a, b)=>(b.rank || 0) - (a.rank || 0));
    const unrankedItems = combinedItems.filter((item)=>!('rank' in item && typeof item.rank === 'number'));
    const sortedItems = [
        ...rankedItems,
        ...unrankedItems
    ];
    const largestDropdownWidth = overflowDropdowns.reduce((acc, item)=>{
        if (item.dropdownWidth && item.dropdownWidth > acc) return item.dropdownWidth;
        return acc;
    }, 0);
    return {
        type: 'overflow-dropdown',
        dropdownWidth: largestDropdownWidth,
        options: sortedItems
    };
};


const $5ae75a7a6c3407a7$var$SUPPRESS_TOOLBAR_USER_INTENTS = [
    'dragging',
    'tableContextualMenuPopupOpen',
    'tableDragMenuPopupOpen',
    'commenting',
    // Suppress while reviewing an AI Suggested Edits card so node floating toolbars don't overlap
    // or mis-position against the suggestion card / diff decorations. Set by the ai-suggestions plugin.
    'reviewing',
    'resizing',
    'blockMenuOpen',
    'statusPickerOpen',
    // Suppress when a modal/overlay is open over the editor (e.g. the Jira remix ephemeral preview),
    // so the floating toolbar does not bleed through on top of the overlay.
    'overlayOpen'
];
const $5ae75a7a6c3407a7$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $bjg0G.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $kCECX.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $51198a3767e977d6$export$5b92d7a8b5d33ee2)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $5ae75a7a6c3407a7$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $krYZG.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $5ae75a7a6c3407a7$var$filterUndefined(x) {
    return !!x;
}
const $5ae75a7a6c3407a7$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            const plugins = [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$5ae75a7a6c3407a7$export$5c1ec0ef773ca0cc({
                            api: api,
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $5979942893154310$export$ae829ec7b2625219)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $29ed443963405b0d$export$2e2bcd8739ae039)()
                }
            ];
            return plugins;
        },
        actions: {
            forceFocusSelector: $29ed443963405b0d$export$1470545de94762f5
        },
        commands: {
            copyNode: (nodeType, inputMethod)=>(0, $a79e953085a5bfff$export$978ef9948557240e)(nodeType, api?.analytics?.actions, inputMethod)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
            const configWithNodeInfo = interactionState !== 'hasNotHadInteraction' ? $5ae75a7a6c3407a7$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined : undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $253a2d3532c32782$export$18d4026d1ea86bb1).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($5ae75a7a6c3407a7$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $5ae75a7a6c3407a7$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, userIntentState: userIntentState } = (0, $4y8CY.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'userIntent'
    ]);
    const { configWithNodeInfo: configWithNodeInfoFromHook, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
    let configWithNodeInfo = configWithNodeInfoFromHook;
    if ((0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) // Read configWithNodeInfo live because the hook snapshot can lag behind the
    // current editor selection and keep the floating toolbar rendered stale.
    // for example, trigger remix on panel will not hide the floating toolbar
    configWithNodeInfo = pluginInjectionApi?.floatingToolbar?.sharedState.currentState()?.configWithNodeInfo;
    if ((0, $4iudd.isSSR)()) return null;
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
    if (userIntentState?.currentUserIntent && $5ae75a7a6c3407a7$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes(userIntentState?.currentUserIntent)) return null;
    const { config: config, node: node } = configWithNodeInfo;
    // When the new inline editor-toolbar is enabled, suppress floating toolbar for text selections.
    if (Boolean(pluginInjectionApi?.toolbar)) {
        const selection = editorView.state.selection;
        const isCellSelection = '$anchorCell' in selection && !selection.empty;
        const isTextSelected = selection instanceof (0, $kCECX.TextSelection) && !selection.empty;
        // don't dismiss table toolbar when a cell selection is caused by clicking the drag handle (which has it's own userIntent)
        if (isTextSelected && config.className !== 'hyperlink-floating-toolbar' || isCellSelection && userIntentState?.currentUserIntent === 'default') return null;
    }
    let { items: items } = config;
    const { groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $5ae75a7a6c3407a7$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
    const isInViewMode = editorViewModeState?.mode === 'view';
    if (!targetRef || isEditorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 - Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : items?.(node);
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    if ((0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
        // Consolidate floating toolbar items
        const toolbarItemsArray = Array.isArray(items) ? items : items?.(node);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        const overflowDropdownItems = toolbarItemsArray.filter((item)=>item.type === 'overflow-dropdown');
        if (overflowDropdownItems.length > 1) {
            const consolidatedOverflowDropdown = (0, $46dc0e486ec6f0a6$export$2f5751d7b477f660)(overflowDropdownItems);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            const otherItems = toolbarItemsArray.filter((item)=>item.type !== 'overflow-dropdown');
            if (otherItems.length > 0) // remove the last separators
            while(otherItems.at(-1)?.type === 'separator')otherItems.pop();
            items = [
                ...otherItems,
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                consolidatedOverflowDropdown
            ];
        }
        // Apply analytics to dropdown
        if (overflowDropdownItems.length > 0 && dispatchAnalyticsEvent) {
            const currentItems = Array.isArray(items) ? items : items?.(node);
            const updatedItems = currentItems.map((item)=>{
                if (item.type !== 'overflow-dropdown') return item;
                const originalOnClick = item.onClick;
                return {
                    ...item,
                    onClick: ()=>{
                        const editorContentMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode;
                        dispatchAnalyticsEvent({
                            action: (0, $krYZG.ACTION).CLICKED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FLOATING_TOOLBAR_OVERFLOW,
                            eventType: (0, $krYZG.EVENT_TYPE).UI,
                            attributes: {
                                editorContentMode: editorContentMode
                            }
                        });
                        // Call original onClick if it exists
                        originalOnClick?.();
                    }
                };
            });
            items = updatedItems;
        }
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    let confirmButtonItem;
    const { confirmDialogForItem: confirmDialogForItem, confirmDialogForItemOption: confirmDialogForItemOption } = floatingToolbarData || {};
    const matchingItem = confirmDialogForItem ? toolbarItems?.[confirmDialogForItem] : undefined;
    if (matchingItem?.type === 'button') confirmButtonItem = matchingItem;
    if (matchingItem?.type === 'overflow-dropdown' && confirmDialogForItemOption !== undefined) {
        const matchingItemOption = matchingItem.options[confirmDialogForItemOption];
        // OverflowDropdownOption is the only member of the union that does not have a 'type' property
        if (!('type' in matchingItemOption)) confirmButtonItem = matchingItemOption;
    }
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $h75sz.ErrorBoundary), {
        component: (0, $krYZG.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
                ariaLabel: title,
                role: 'toolbar',
                offset: offset,
                target: targetRef,
                alignY: "bottom",
                forcePlacement: forcePlacement,
                fitHeight: height,
                fitWidth: width,
                absoluteOffset: absoluteOffset,
                alignX: align,
                stick: stick,
                zIndex: zIndex,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onPositionCalculated: customPositionCalculation,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: scrollable ? {
                    maxWidth: '100%'
                } : {},
                focusTrap: focusTrap,
                preventOverflow: preventPopupOverflow,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
                    providerFactory: providerFactory,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    providers: [
                        'extensionProvider'
                    ],
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    renderNode: (providers)=>{
                        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4424bc712b49a931$export$2e2bcd8739ae039), {
                            target: targetRef,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            items: toolbarItems,
                            groupLabel: groupLabel,
                            node: node,
                            dispatchCommand: dispatchCommand,
                            editorView: editorView,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: className,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            focusEditor: ()=>editorView.focus(),
                            providerFactory: providerFactory,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            extensionsProvider: providers.extensionProvider,
                            scrollable: scrollable,
                            api: pluginInjectionApi,
                            mediaAssistiveMessage: mediaAssistiveMessage
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $acf6955f8af027ca$export$1f33f980da756c46), {
                testId: "ak-floating-toolbar-confirmation-modal",
                options: confirmDialogOptions,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onConfirm: (isChecked = false)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (!!confirmDialogOptions.onConfirm) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmButtonItem.onClick);
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClose: ()=>{
                    dispatchCommand((0, $59392e752502a84a$export$5a3c1357cfd1045c)());
                    // Need to set focus to Editor here,
                    // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
                    // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
                    // instead of the cursor position before the dialog pop up.
                    if (!editorView.hasFocus()) editorView.focus();
                }
            })
        ]
    });
}
const $5ae75a7a6c3407a7$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $5ae75a7a6c3407a7$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($5ae75a7a6c3407a7$var$filterUndefined)
    };
    return config;
}
function $5ae75a7a6c3407a7$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl, api: api } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) {
                if ($5ae75a7a6c3407a7$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes(api?.userIntent?.sharedState.currentState()?.currentUserIntent || '')) {
                    activeConfigs = undefined;
                    break;
                }
                activeConfigs.push($5ae75a7a6c3407a7$var$sanitizeFloatingToolbarConfig(config));
            }
        }
        const relevantConfig = activeConfigs && $5ae75a7a6c3407a7$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const getIsToolbarSuppressed = ()=>{
        return false;
    };
    const apply = ()=>{
        const newPluginState = {
            getConfigWithNodeInfo: getConfigWithNodeInfo
        };
        return newPluginState;
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $5ae75a7a6c3407a7$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: (0, $ieeJu.expValEquals)('platform_editor_lovability_suppress_toolbar_event', 'isEnabled', true) ? (_tr, _pluginState, __oldEditorState)=>{
                const suppressedToolbar = getIsToolbarSuppressed();
                const newPluginState = {
                    getConfigWithNodeInfo: getConfigWithNodeInfo,
                    suppressedToolbar: suppressedToolbar
                };
                return newPluginState;
            } : apply
        },
        view: (0, $ieeJu.expValEquals)('platform_editor_lovability_suppress_toolbar_event', 'isEnabled', true) ? ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = $5ae75a7a6c3407a7$export$18d4026d1ea86bb1.getState(view.state);
                    const prevPluginState = $5ae75a7a6c3407a7$export$18d4026d1ea86bb1.getState(prevState);
                    if (pluginState?.suppressedToolbar && !prevPluginState?.suppressedToolbar) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).SUPPRESSED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FLOATING_TOOLBAR,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK
                    });
                }
            };
        } : undefined
    });
}
module.exports["floatingToolbarPlugin"] = $5ae75a7a6c3407a7$export$baed971c987bc0e;

});

parcelRegister("eTVtR", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $853006ed1219ed7c$var$message = (0, $kSwu1.defineMessages)({
    confirmModalDefaultHeading: {
        id: "fabric.editor.floatingToolbar.confirmModalHeading",
        defaultMessage: "Are you sure?"
    },
    confirmModalOK: {
        id: "fabric.editor.floatingToolbar.confirmModalOK",
        defaultMessage: "OK"
    },
    confirmModalCancel: {
        id: "fabric.editor.floatingToolbar.confirmModalCancel",
        defaultMessage: "Cancel"
    },
    confirmModalListUnit: {
        id: "fabric.editor.floatingToolbar.confirmModalConnectedUnit",
        defaultMessage: "{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    floatingToolbarAriaLabel: {
        id: "fabric.editor.floatingToolbar.floatingToolbarAriaLabel",
        defaultMessage: "Floating Toolbar"
    },
    floatingToolbarAnnouncer: {
        id: "fabric.editor.floatingToolbar.floatingToolbarAnnouncer",
        defaultMessage: "Floating toolbar controls have been opened"
    },
    floatingToolbarScrollLeft: {
        id: "fabric.editor.floatingToolbar.scrollLeft",
        defaultMessage: "Scroll left"
    },
    floatingToolbarScrollRight: {
        id: "fabric.editor.floatingToolbar.scrollRight",
        defaultMessage: "Scroll right"
    }
});
var $853006ed1219ed7c$export$2e2bcd8739ae039 = $853006ed1219ed7c$var$message;
module.exports["default"] = $853006ed1219ed7c$export$2e2bcd8739ae039;

});

parcelRegister("b4bEA", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $50UK1 = parcelRequire("50UK1");


var $gWBVp = parcelRequire("gWBVp");


var $9Jc4C = parcelRequire("9Jc4C");


var $7HhCu = parcelRequire("7HhCu");

const $228392858716502b$var$noop = ()=>null;
const $228392858716502b$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $228392858716502b$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $228392858716502b$var$noop;
    const maybeIcon = await getIcon();
    return $228392858716502b$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $228392858716502b$var$convertExtensionToDropdownMenuItem = ({ item: item, disabled: disabled, node: node, extension: extension, IconComponent: IconComponent })=>{
    let title = '';
    if (item.label) title = item.label;
    else if (typeof item.tooltip === 'string') title = item.tooltip;
    else if (item.ariaLabel) title = item.ariaLabel;
    item.disabled = disabled?.(item.key) || false;
    const getIcon = ()=>{
        const label = item.label || '';
        return IconComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(IconComponent, {
            label: label
        }) : undefined;
    };
    return {
        title: title,
        icon: getIcon(),
        disabled: item.disabled,
        onClick: ()=>{
            if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
            const targetNodeAdf = (0, $gWBVp.nodeToJSON)(node);
            extension.extensionApi && item.action(targetNodeAdf, extension.extensionApi);
            return true;
        }
    };
};
const $228392858716502b$var$DropdownMenuExtensionItem = ({ item: item, editorView: editorView, disabled: disabled, node: node, extension: extension, dropdownOptions: dropdownOptions })=>{
    // Use ref to keep icon component stable across renders
    const iconRef = (0, $cozmU.useRef)(null);
    if (!iconRef.current && item.icon) iconRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "fR-gN",
        name: "platform.packages.editor.editor-common.src.floating-toolbar.DropdownMenuExtensionItems",
        loader: ()=>$228392858716502b$var$resolveExtensionIcon(item.icon),
        loading: $228392858716502b$var$noop
    });
    const dropdownItem = $228392858716502b$var$convertExtensionToDropdownMenuItem({
        item: item,
        disabled: disabled,
        node: node,
        extension: extension,
        IconComponent: iconRef.current
    });
    if (!dropdownItem) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Jc4C.DropdownMenuItem), {
        item: dropdownItem,
        editorView: editorView,
        hide: dropdownOptions.hide,
        dispatchCommand: dropdownOptions.dispatchCommand,
        showSelected: dropdownOptions.showSelected,
        intl: dropdownOptions.intl
    }, item.key);
};
const $228392858716502b$export$24b801b186044441 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(29);
    const { node: node, editorView: editorView, extension: extension, disabled: disabled, dropdownOptions: dropdownOptions, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [extensions, setExtensions] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[1] !== extension.extensionProvider) {
        t1 = ()=>{
            getExtensions();
            async function getExtensions() {
                const provider = await extension.extensionProvider;
                if (provider) setExtensions(await provider.getExtensions());
            }
        };
        t2 = [
            extension.extensionProvider
        ];
        $[1] = extension.extensionProvider;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== node) {
        t3 = (0, $gWBVp.nodeToJSON)(node);
        $[4] = node;
        $[5] = t3;
    } else t3 = $[5];
    const nodeAdf = t3;
    let t4;
    bb0: {
        if (!extension.extensionApi) {
            let t5;
            if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                t5 = [];
                $[6] = t5;
            } else t5 = $[6];
            t4 = t5;
            break bb0;
        }
        let t5;
        if ($[7] !== extension.extensionApi || $[8] !== extensions || $[9] !== nodeAdf) {
            t5 = (0, $50UK1.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extension.extensionApi);
            $[7] = extension.extensionApi;
            $[8] = extensions;
            $[9] = nodeAdf;
            $[10] = t5;
        } else t5 = $[10];
        t4 = t5;
    }
    const extensionItems = t4;
    if (!extensionItems.length || !dropdownOptions) return null;
    let t5;
    if ($[11] !== disabled || $[12] !== dropdownOptions || $[13] !== editorView || $[14] !== extension || $[15] !== extensionItems || $[16] !== node) {
        let t6;
        if ($[18] !== disabled || $[19] !== dropdownOptions || $[20] !== editorView || $[21] !== extension || $[22] !== node) {
            t6 = (item, _idx)=>{
                if (!("key" in item)) return null;
                return /*#__PURE__*/ (0, $8aG6j.jsx)($228392858716502b$var$DropdownMenuExtensionItem, {
                    item: item,
                    editorView: editorView,
                    disabled: disabled,
                    node: node,
                    extension: extension,
                    dropdownOptions: dropdownOptions
                }, item.key);
            };
            $[18] = disabled;
            $[19] = dropdownOptions;
            $[20] = editorView;
            $[21] = extension;
            $[22] = node;
            $[23] = t6;
        } else t6 = $[23];
        t5 = extensionItems.map(t6);
        $[11] = disabled;
        $[12] = dropdownOptions;
        $[13] = editorView;
        $[14] = extension;
        $[15] = extensionItems;
        $[16] = node;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[24] !== areAnyNewToolbarFlagsEnabled) {
        t6 = areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7HhCu.DropdownSeparator), {});
        $[24] = areAnyNewToolbarFlagsEnabled;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== t5 || $[27] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t5,
                t6
            ]
        });
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
    } else t7 = $[28];
    return t7;
} : (props)=>{
    const { node: node, editorView: editorView, extension: extension, disabled: disabled, dropdownOptions: dropdownOptions, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extension.extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    }, [
        extension.extensionProvider
    ]);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $gWBVp.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!extension.extensionApi) return [];
        return (0, $50UK1.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extension.extensionApi);
    }, [
        extensions,
        nodeAdf,
        extension.extensionApi
    ]);
    if (!extensionItems.length || !dropdownOptions) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            extensionItems.map((item, _idx)=>{
                if (!('key' in item)) return null;
                return /*#__PURE__*/ (0, $8aG6j.jsx)($228392858716502b$var$DropdownMenuExtensionItem, {
                    item: item,
                    editorView: editorView,
                    disabled: disabled,
                    node: node,
                    extension: extension,
                    dropdownOptions: dropdownOptions
                }, item.key);
            }),
            areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7HhCu.DropdownSeparator), {})
        ]
    });
};
module.exports["DropdownMenuExtensionItems"] = $228392858716502b$export$24b801b186044441;

});

parcelRegister("4hfky", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $5SGpQ = parcelRequire("5SGpQ");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");

const $13ddb07accc72f08$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px'
    },
    '& > span': {
        margin: '0px'
    }
};


const $c0081857b20fe747$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $c0081857b20fe747$var$backgroundVisualRefresh = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-danger-hovered, #FFD5D2)",
            dark: "var(--ds-background-danger-hovered, #FFD5D2)"
        },
        active: {
            light: "var(--ds-background-danger-pressed, #FFB8B2)",
            dark: "var(--ds-background-danger-pressed, #FFB8B2)"
        }
    }
};
const $c0081857b20fe747$var$colorVisualRefresh = {
    danger: {
        default: {
            light: "var(--ds-icon-subtle, #505258)",
            dark: "var(--ds-icon-subtle, #505258)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $c0081857b20fe747$export$f98ea88a275be66c = (props)=>({
        background: $c0081857b20fe747$var$getStyles($c0081857b20fe747$var$backgroundVisualRefresh, props),
        color: $c0081857b20fe747$var$getStyles($c0081857b20fe747$var$colorVisualRefresh, props)
    }); // eslint-disable-next-line @atlaskit/editor/no-re-export


const $c07584406ea7f9cc$var$customSizeAndPadding = {
    minWidth: "var(--ds-space-400, 32px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`
};
const $c07584406ea7f9cc$var$FloatingToolbarButton = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, interactionName: interactionName, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, pulse: pulse, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled }, forwardedRef)=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $13ddb07accc72f08$export$7d8cec9727d4e603) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    /**
   * If it's a radio button, we need to reflect false values too, hence
   * we cast it as a Boolean
   */ const ariaChecked = isRadioButton ? Boolean(isButtonPressed) : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    (0, $cozmU.useEffect)(()=>{
        onMount?.();
        return ()=>onUnmount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOnClick = (0, $cozmU.useCallback)((event)=>{
        onClick?.(event);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            // Only fallback to title for tooltip if title is not shown
            content: tooltipContent || (iconOnly ? title : undefined),
            component: tooltipStyle,
            hideTooltipOnClick: hideTooltipOnClick,
            position: "top",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                onMouseEnter: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? undefined : onMouseEnter,
                onMouseLeave: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? undefined : onMouseLeave,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SGpQ.default), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    className: className,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    ref: (buttonElement)=>{
                        if (forwardedRef && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
                            if (typeof forwardedRef === 'function') forwardedRef(buttonElement);
                            else if (typeof forwardedRef === 'object') forwardedRef.current = buttonElement;
                        }
                    },
                    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    theme: (adgTheme, themeProps)=>{
                        const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
                        return {
                            buttonStyles: {
                                ...buttonStyles,
                                ...customSpacing,
                                ...appearance === 'danger' && (0, $c0081857b20fe747$export$f98ea88a275be66c)({
                                    appearance: appearance,
                                    state: themeProps.state,
                                    mode: themeProps.mode
                                }),
                                ...areAnyNewToolbarFlagsEnabled ? $c07584406ea7f9cc$var$customSizeAndPadding : {}
                            },
                            ...rest
                        };
                    },
                    "aria-label": ariaLabel || title,
                    "aria-pressed": ariaPressed,
                    "aria-checked": ariaChecked,
                    role: isRadioButton ? 'radio' : undefined,
                    "aria-expanded": ariaHasPopup ? selected : undefined,
                    "aria-controls": ariaHasPopup ? areaControls : undefined,
                    spacing: areAnyNewToolbarFlagsEnabled ? 'default' : 'compact',
                    href: href,
                    target: target,
                    appearance: appearance,
                    "aria-haspopup": ariaHasPopup,
                    iconBefore: icon || undefined,
                    iconAfter: iconAfter,
                    onClick: handleOnClick,
                    onKeyDown: onKeyDown,
                    isSelected: selected,
                    isDisabled: disabled,
                    testId: testId,
                    interactionName: interactionName,
                    onMouseEnter: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onMouseEnter : undefined,
                    onMouseLeave: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onMouseLeave : undefined,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    // @ts-ignore
                    // tabIndex set as 0 by default in the design system  ButtonBase component
                    // this is not expected for all buttons, we have to use tabIndex={null} for some cases
                    // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
                    tabIndex: tabIndex,
                    children: children
                })
            })
        })
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $c07584406ea7f9cc$var$_default_1 = (0, $8m50u.componentWithCondition)(()=>(0, $fqVYq.editorExperiment)('platform_synced_block', true), /*#__PURE__*/ (0, $cozmU.forwardRef)($c07584406ea7f9cc$var$FloatingToolbarButton), $c07584406ea7f9cc$var$FloatingToolbarButton);
var $c07584406ea7f9cc$export$2e2bcd8739ae039 = $c07584406ea7f9cc$var$_default_1;
module.exports["default"] = $c07584406ea7f9cc$export$2e2bcd8739ae039;

});

parcelRegister("huoxr", function(module, exports) {
$parcel$export(module.exports, "default", () => $98626064a7d7ec7a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $lOiVq = parcelRequire("lOiVq");

function $98626064a7d7ec7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $98626064a7d7ec7a$var$separator = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-border, #0B120E24)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
const $98626064a7d7ec7a$var$separatorNew = {
    name: "pange0",
    styles: "background:var(--ds-border, #0B120E24);width:1px;height:20px;align-self:center"
};
const $98626064a7d7ec7a$var$separatorFullHeight = {
    name: "1k18kha",
    styles: "height:40px"
};
var $98626064a7d7ec7a$export$2e2bcd8739ae039 = ({ fullHeight: fullHeight, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            areAnyNewToolbarFlagsEnabled ? $98626064a7d7ec7a$var$separatorNew : $98626064a7d7ec7a$var$separator,
            fullHeight && $98626064a7d7ec7a$var$separatorFullHeight
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "separator"
    });

});

parcelRegister("8VCvx", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jIX6h = parcelRequire("jIX6h");


var $72AfS = parcelRequire("72AfS");


var $cUMTy = parcelRequire("cUMTy");

const $a411c83676d4a1af$var$darkModeTextPaletteOverrides = (0, $kSwu1.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.dark-gray",
        defaultMessage: "Dark gray"
    }
});
const $a411c83676d4a1af$export$cca9f3b863b77c82 = {
    ...(0, $cUMTy.lightTextPaletteTooltipMessages),
    ...$a411c83676d4a1af$var$darkModeTextPaletteOverrides
};
const $a411c83676d4a1af$export$d8fe76863446580e = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $cUMTy.lightTextPaletteTooltipMessages),
    dark: $a411c83676d4a1af$export$cca9f3b863b77c82
};
const $a411c83676d4a1af$var$darkModeBackgroundPaletteOverrides = (0, $kSwu1.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#B3BAC5': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    }
});
const $a411c83676d4a1af$export$d1327856929fda16 = {
    ...(0, $jIX6h.lightBackgroundPaletteTooltipMessages),
    ...$a411c83676d4a1af$var$darkModeBackgroundPaletteOverrides
};
const $a411c83676d4a1af$export$c671ecebb9c48677 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $jIX6h.lightBackgroundPaletteTooltipMessages),
    dark: $a411c83676d4a1af$export$d1327856929fda16
};
const $a411c83676d4a1af$var$darkChartsColorPaletteTooltipMessages = {
    ...(0, $72AfS.lightChartsColorPaletteTooltipMessages)
};
const $a411c83676d4a1af$export$f8b88c9f6c817aff = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $72AfS.lightChartsColorPaletteTooltipMessages),
    dark: $a411c83676d4a1af$var$darkChartsColorPaletteTooltipMessages
};
const $a411c83676d4a1af$var$lightBorderPaletteTooltipMessages = (0, $kSwu1.defineMessages)({
    '#091E4224': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#758195': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#172B4D': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    }
});
const $a411c83676d4a1af$var$darkBorderPaletteTooltipMessages = {
    ...$a411c83676d4a1af$var$lightBorderPaletteTooltipMessages
};
const $a411c83676d4a1af$export$515e8edd15e08de7 = {
    light: $a411c83676d4a1af$var$lightBorderPaletteTooltipMessages,
    dark: $a411c83676d4a1af$var$darkBorderPaletteTooltipMessages
};
module.exports["textPaletteTooltipMessages"] = $a411c83676d4a1af$export$d8fe76863446580e;
module.exports["backgroundPaletteTooltipMessages"] = $a411c83676d4a1af$export$c671ecebb9c48677;
module.exports["chartsColorPaletteTooltipMessages"] = $a411c83676d4a1af$export$f8b88c9f6c817aff;
module.exports["borderPaletteTooltipMessages"] = $a411c83676d4a1af$export$515e8edd15e08de7;

});

parcelRegister("fNHEL", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $gTPfK = parcelRequire("gTPfK");


var $lzgC6 = parcelRequire("lzgC6");


var $ad7Ou = parcelRequire("ad7Ou");


var $7sJoX = parcelRequire("7sJoX");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $krYZG = parcelRequire("krYZG");

var $llCol = parcelRequire("llCol");


var $5TxPB = parcelRequire("5TxPB");


var $7xQNd = parcelRequire("7xQNd");

var $kQOs5 = parcelRequire("kQOs5");

var $3gFnx = parcelRequire("3gFnx");


var $9Muxb = parcelRequire("9Muxb");


var $7XIuB = parcelRequire("7XIuB");


var $g9ric = parcelRequire("g9ric");


var $9RT19 = parcelRequire("9RT19");

function $73de56dad7c36b8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// helps adjusts position of popup
const $73de56dad7c36b8f$var$colorPickerButtonWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $73de56dad7c36b8f$var$colorPickerExpandContainerVisualRefresh = (0, $buxP3.xcss)({
    marginTop: 'space.negative.025',
    marginRight: 'space.negative.050'
});
const $73de56dad7c36b8f$var$colorPickerButtonStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        '&::after': {
            border: 'none'
        },
        '&:hover': {
            backgroundColor: `${"var(--ds-background-selected, #E9F2FE)"}`
        }
    }
});
// Control the size of color picker buttons and preview
// TODO: DSP-4134 - Color picking UI
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $73de56dad7c36b8f$var$colorPickerWrapper = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        padding: `${"var(--ds-space-100, 8px)"} 0px`
    });
const $73de56dad7c36b8f$var$ColorPaletteWithReactViewListeners = (0, $9Muxb.default)((0, $7xQNd.default));
const $73de56dad7c36b8f$var$COLOR_PICKER_POPUP_OFFSET = [
    0,
    10
];
const $73de56dad7c36b8f$var$ColorPickerButton = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isPopupPositioned, setIsPopupPositioned] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const memoizedHandleClose = (0, $cozmU.useCallback)(()=>setIsPopupOpen(false), [
        setIsPopupOpen
    ]);
    const handleClose = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedHandleClose : ()=>setIsPopupOpen(false);
    const memoizedTogglePopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupOpen((prevIsOpen)=>{
            if (!prevIsOpen) {
                setIsOpenedByKeyboard(false);
                setIsPopupPositioned(false);
            }
            return !prevIsOpen;
        });
    }, []);
    const togglePopup = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedTogglePopup : ()=>{
        setIsPopupOpen(!isPopupOpen);
        if (!isPopupOpen) {
            setIsOpenedByKeyboard(false);
            setIsPopupPositioned(false);
        }
    };
    const memoizedOnKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            memoizedTogglePopup();
            setIsOpenedByKeyboard(true);
        }
    }, [
        memoizedTogglePopup
    ]);
    const onKeyDown = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnKeyDown : (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            togglePopup();
            setIsOpenedByKeyboard(true);
        }
    };
    const memoizedPaletteOptions = (0, $cozmU.useMemo)(()=>({
            palette: props.colorPalette,
            hexToPaletteColor: props.hexToPaletteColor,
            paletteColorTooltipMessages: props.paletteColorTooltipMessages
        }), [
        props.colorPalette,
        props.hexToPaletteColor,
        props.paletteColorTooltipMessages
    ]);
    const paletteOptions = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedPaletteOptions : {
        palette: props.colorPalette,
        hexToPaletteColor: props.hexToPaletteColor,
        paletteColorTooltipMessages: props.paletteColorTooltipMessages
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const focusButton = ()=>{
        buttonRef.current?.focus();
    };
    const handleEsc = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        setIsOpenedByKeyboard(false);
        setIsPopupPositioned(false);
        setIsPopupOpen(false);
        focusButton();
    }, []);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((position)=>{
        setIsPopupPositioned(true);
        return position;
    }, []);
    const { onChange: onChange, createAnalyticsEvent: createAnalyticsEvent, colorPalette: colorPalette, placement: placement, skipFocusButtonAfterPick: skipFocusButtonAfterPick } = props;
    const onColorSelected = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((color, label)=>{
        setIsOpenedByKeyboard(false);
        setIsPopupOpen(false);
        setIsPopupPositioned(false);
        if (onChange) {
            if (createAnalyticsEvent) {
                // fire analytics
                const payload = {
                    action: (0, $krYZG.ACTION).UPDATED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_COLOR,
                    attributes: {
                        color: color,
                        label: label,
                        placement: placement
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                createAnalyticsEvent(payload).fire((0, $llCol.editorAnalyticsChannel));
            }
            const newPalette = colorPalette.find((colorPalette)=>colorPalette.value === color);
            newPalette && onChange(newPalette);
        }
        if (!skipFocusButtonAfterPick) focusButton();
    }, [
        colorPalette,
        onChange,
        createAnalyticsEvent,
        placement,
        skipFocusButtonAfterPick
    ]);
    const renderPopup = ()=>{
        if (!isPopupOpen || !buttonRef.current) return;
        const selectedColor = props.currentColor || null;
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $3gFnx.getSelectedRowAndColumnFromPalette)(props.colorPalette, selectedColor, props.cols);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
            target: buttonRef.current,
            fitHeight: 350,
            fitWidth: 350,
            offset: (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $73de56dad7c36b8f$var$COLOR_PICKER_POPUP_OFFSET : [
                0,
                10
            ],
            alignX: props.alignX,
            mountTo: props.setDisableParentScroll ? props.mountPoint : undefined,
            absoluteOffset: props.absoluteOffset,
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            ariaLabel: formatMessage((0, $5TxPB.colorPickerButtonMessages).colorPickerMenuLabel),
            onPositionCalculated: onPositionCalculated
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $73de56dad7c36b8f$var$colorPickerWrapper,
            "data-test-id": "color-picker-menu"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
            type: (0, $9RT19.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            closeOnTab: true,
            handleClose: handleClose,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: isPopupPositioned,
            ignoreEscapeKey: props.returnEscToButton
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($73de56dad7c36b8f$var$ColorPaletteWithReactViewListeners, {
            cols: props.cols,
            selectedColor: selectedColor,
            onClick: onColorSelected,
            handleClickOutside: togglePopup,
            handleEscapeKeydown: handleEsc,
            paletteOptions: paletteOptions
        }))));
    };
    const title = props.title || '';
    const currentColor = props.currentColor && props.hexToPaletteColor ? props.hexToPaletteColor(props.currentColor) : props.currentColor;
    const buttonStyleVisualRefresh = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${!!props.size?.height ? 'inherit' : ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:before': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                content: "''",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `${"var(--ds-border-width, 1px)"} solid ${(0, $kQOs5.DEFAULT_BORDER_COLOR)}`,
                borderRadius: "var(--ds-radius-small, 3px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: currentColor || 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: props.size?.width || '14px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: props.size?.height || '14px',
                marginTop: `${"var(--ds-space-025, 2px)"}`
            }
        });
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $73de56dad7c36b8f$var$colorPickerButtonWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: title,
        position: "top"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $73de56dad7c36b8f$var$colorPickerButtonStyle
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ad7Ou.default), {
        appearance: 'subtle',
        ref: buttonRef,
        "aria-label": title,
        "aria-expanded": props.isAriaExpanded ? isPopupOpen : undefined,
        spacing: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
        onClick: togglePopup,
        onKeyDown: onKeyDown,
        "data-selected-color": props.currentColor,
        isSelected: isPopupOpen
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kz1Yj.Inline), {
        alignBlock: "start"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: buttonStyleVisualRefresh
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $73de56dad7c36b8f$var$colorPickerExpandContainerVisualRefresh
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        color: "currentColor",
        spacing: "spacious",
        label: "color-picker-chevron-down",
        size: "small"
    })))))), renderPopup());
};
const $73de56dad7c36b8f$var$_default_1 = (0, $gTPfK.default)({
    source: 'ConfigPanel'
})((0, $lzgC6.default)()($73de56dad7c36b8f$var$ColorPickerButton));
var $73de56dad7c36b8f$export$2e2bcd8739ae039 = $73de56dad7c36b8f$var$_default_1;
module.exports["default"] = $73de56dad7c36b8f$export$2e2bcd8739ae039;

});

parcelRegister("5TxPB", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f17b7abf55521867$export$46fbf624c87d759a = (0, $kSwu1.defineMessages)({
    colorPickerMenuLabel: {
        id: "fabric.editor.colorPicker.menuLabel",
        defaultMessage: "Color picker menu"
    }
});
module.exports["colorPickerButtonMessages"] = $f17b7abf55521867$export$46fbf624c87d759a;

});

parcelRegister("7xQNd", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $aELWC = parcelRequire("aELWC");


var $kSwu1 = parcelRequire("kSwu1");


var $IQ4Dz = parcelRequire("IQ4Dz");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");





var $eh6Ml = parcelRequire("eh6Ml");


var $lpNn5 = parcelRequire("lpNn5");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $0596ddb45672601b$export$fd4d27a26b4854f3 = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '26px',
    width: '26px',
    background: "var(--ds-background-neutral, #0515240F)",
    padding: 0,
    borderRadius: "var(--ds-radius-small, 4px)",
    border: `1px solid ${"var(--ds-border-inverse, #FFFFFF)"}`,
    cursor: 'pointer',
    display: 'block'
});
const $0596ddb45672601b$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $lOiVq.css)({
    border: '1px solid transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    '&:focus-within, &:focus, &:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderColor: `${"var(--ds-border, #0B120E24)"} !important`
    }
}); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 


const $c19f672b8d505e42$var$Color = (props)=>{
    const { autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, hexToPaletteColor: /**
     * When hexToPaletteColor prop is set,
     * it will be used to get background color style based on
     * value (which will be hexcode) prop
     */ hexToPaletteColor, decorator: decorator } = props;
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const onMouseDown = (e)=>{
        e.preventDefault();
    };
    const onClick = (e)=>{
        const { onClick: onClick, value: value, label: label } = props;
        e.preventDefault();
        onClick(value, label);
    };
    const onKeyDown = (e)=>{
        const { onKeyDown: onKeyDown, value: value, label: label } = props;
        if (!onKeyDown) return undefined;
        e.preventDefault();
        onKeyDown(value, label, e);
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: label
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $0596ddb45672601b$export$7afe8f4b3442c19d)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $0596ddb45672601b$export$fd4d27a26b4854f3),
        "aria-label": label,
        role: "radio",
        "aria-checked": isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${isSelected ? 'selected' : ''}`,
        style: {
            backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
            border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
        },
        autoFocus: autoFocus
    }, !decorator && isSelected && /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: ""
    }), decorator)));
};
var $c19f672b8d505e42$export$2e2bcd8739ae039 = $c19f672b8d505e42$var$Color;



var $xx2Zf = parcelRequire("xx2Zf");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $545a8713c088fa90$export$506342f5c0767858 = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */ display: 'flex'
});



var $3gFnx = parcelRequire("3gFnx");

/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @return Highest contrast color in pool
 */ function $b15664efde900ec2$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $3gFnx.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $aELWC.default).difference(b, colorValue) - (0, $aELWC.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)";
}
const $b15664efde900ec2$var$ColorPalette = (props)=>{
    const { cols: cols = (0, $3gFnx.DEFAULT_COLOR_PICKER_COLUMNS), onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, className: className, intl: { formatMessage: formatMessage }, paletteOptions: paletteOptions } = props;
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $IQ4Dz.default)();
    const useIconToken = !!hexToPaletteColor;
    const colorsPerRow = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return (0, $3gFnx.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, colorsPerRow.map((row)=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $545a8713c088fa90$export$506342f5c0767858),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            key: `row-first-color-${row[0].value}`,
            role: "radiogroup"
        }, row.map(({ value: value, label: label, border: border, message: message, decorator: decorator })=>{
            if (paletteColorTooltipMessages) {
                if (tokenTheme === 'dark') message = (0, $xx2Zf.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                if (tokenTheme === 'light') message = (0, $xx2Zf.default)(paletteColorTooltipMessages.light, value.toUpperCase());
            }
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c19f672b8d505e42$export$2e2bcd8739ae039), {
                key: value,
                value: value,
                borderColor: border,
                label: message ? formatMessage(message) : label,
                onClick: onClick,
                onKeyDown: onKeyDown,
                isSelected: value === selectedColor,
                checkMarkColor: $b15664efde900ec2$var$getCheckMarkColor(value, useIconToken),
                hexToPaletteColor: hexToPaletteColor,
                decorator: decorator
            });
        }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $b15664efde900ec2$var$_default_1 = (0, $kSwu1.injectIntl)($b15664efde900ec2$var$ColorPalette);
var $b15664efde900ec2$export$2e2bcd8739ae039 = $b15664efde900ec2$var$_default_1;
module.exports["default"] = $b15664efde900ec2$export$2e2bcd8739ae039;

});

parcelRegister("xx2Zf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fcf59d843f4e611$export$2e2bcd8739ae039);
function $4fcf59d843f4e611$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Text color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happen when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("3gFnx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d990bbd734a8d8e531136e364654fcbc>>
 * @codegenCommand yarn build tokens
 */ const $3cf630e681b4258b$var$tokens = [
    {
        "value": "#EFFFD6",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EFFFD6",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime100",
        "path": [
            "color",
            "palette",
            "Lime100"
        ]
    },
    {
        "value": "#D3F1A7",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#D3F1A7",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime200",
        "path": [
            "color",
            "palette",
            "Lime200"
        ]
    },
    {
        "value": "#BDE97C",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BDE97C",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime250",
        "path": [
            "color",
            "palette",
            "Lime250"
        ]
    },
    {
        "value": "#B3DF72",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B3DF72",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime300",
        "path": [
            "color",
            "palette",
            "Lime300"
        ]
    },
    {
        "value": "#94C748",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#94C748",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime400",
        "path": [
            "color",
            "palette",
            "Lime400"
        ]
    },
    {
        "value": "#82B536",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#82B536",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime500",
        "path": [
            "color",
            "palette",
            "Lime500"
        ]
    },
    {
        "value": "#6A9A23",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#6A9A23",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime600",
        "path": [
            "color",
            "palette",
            "Lime600"
        ]
    },
    {
        "value": "#5B7F24",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#5B7F24",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime700",
        "path": [
            "color",
            "palette",
            "Lime700"
        ]
    },
    {
        "value": "#4C6B1F",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4C6B1F",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime800",
        "path": [
            "color",
            "palette",
            "Lime800"
        ]
    },
    {
        "value": "#3F5224",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3F5224",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime850",
        "path": [
            "color",
            "palette",
            "Lime850"
        ]
    },
    {
        "value": "#37471F",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#37471F",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime900",
        "path": [
            "color",
            "palette",
            "Lime900"
        ]
    },
    {
        "value": "#28311B",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#28311B",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime1000",
        "path": [
            "color",
            "palette",
            "Lime1000"
        ]
    },
    {
        "value": "#FFECEB",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFECEB",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red100",
        "path": [
            "color",
            "palette",
            "Red100"
        ]
    },
    {
        "value": "#FFD5D2",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFD5D2",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red200",
        "path": [
            "color",
            "palette",
            "Red200"
        ]
    },
    {
        "value": "#FFD5D266",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFD5D266",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red200A40",
        "path": [
            "color",
            "palette",
            "Red200A40"
        ]
    },
    {
        "value": "#FFB8B2",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFB8B2",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red250",
        "path": [
            "color",
            "palette",
            "Red250"
        ]
    },
    {
        "value": "#FD9891",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FD9891",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red300",
        "path": [
            "color",
            "palette",
            "Red300"
        ]
    },
    {
        "value": "#F87168",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F87168",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red400",
        "path": [
            "color",
            "palette",
            "Red400"
        ]
    },
    {
        "value": "#F15B50",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F15B50",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red500",
        "path": [
            "color",
            "palette",
            "Red500"
        ]
    },
    {
        "value": "#E2483D",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E2483D",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red600",
        "path": [
            "color",
            "palette",
            "Red600"
        ]
    },
    {
        "value": "#C9372C",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#C9372C",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red700",
        "path": [
            "color",
            "palette",
            "Red700"
        ]
    },
    {
        "value": "#AE2E24",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#AE2E24",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red800",
        "path": [
            "color",
            "palette",
            "Red800"
        ]
    },
    {
        "value": "#872821",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#872821",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red850",
        "path": [
            "color",
            "palette",
            "Red850"
        ]
    },
    {
        "value": "#5D1F1A",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#5D1F1A",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red900",
        "path": [
            "color",
            "palette",
            "Red900"
        ]
    },
    {
        "value": "#5D1F1AB2",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#5D1F1AB2",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red900A70",
        "path": [
            "color",
            "palette",
            "Red900A70"
        ]
    },
    {
        "value": "#42221F",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#42221F",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red1000",
        "path": [
            "color",
            "palette",
            "Red1000"
        ]
    },
    {
        "value": "#FFF5DB",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFF5DB",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange100",
        "path": [
            "color",
            "palette",
            "Orange100"
        ]
    },
    {
        "value": "#FCE4A6",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FCE4A6",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange200",
        "path": [
            "color",
            "palette",
            "Orange200"
        ]
    },
    {
        "value": "#FBD779",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FBD779",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange250",
        "path": [
            "color",
            "palette",
            "Orange250"
        ]
    },
    {
        "value": "#FBC828",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FBC828",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange300",
        "path": [
            "color",
            "palette",
            "Orange300"
        ]
    },
    {
        "value": "#FCA700",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FCA700",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange400",
        "path": [
            "color",
            "palette",
            "Orange400"
        ]
    },
    {
        "value": "#F68909",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F68909",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange500",
        "path": [
            "color",
            "palette",
            "Orange500"
        ]
    },
    {
        "value": "#E06C00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E06C00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange600",
        "path": [
            "color",
            "palette",
            "Orange600"
        ]
    },
    {
        "value": "#BD5B00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BD5B00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange700",
        "path": [
            "color",
            "palette",
            "Orange700"
        ]
    },
    {
        "value": "#9E4C00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#9E4C00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange800",
        "path": [
            "color",
            "palette",
            "Orange800"
        ]
    },
    {
        "value": "#7A3B00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7A3B00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange850",
        "path": [
            "color",
            "palette",
            "Orange850"
        ]
    },
    {
        "value": "#693200",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#693200",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange900",
        "path": [
            "color",
            "palette",
            "Orange900"
        ]
    },
    {
        "value": "#3A2C1F",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3A2C1F",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange1000",
        "path": [
            "color",
            "palette",
            "Orange1000"
        ]
    },
    {
        "value": "#FEF7C8",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FEF7C8",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow100",
        "path": [
            "color",
            "palette",
            "Yellow100"
        ]
    },
    {
        "value": "#F5E989",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F5E989",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow200",
        "path": [
            "color",
            "palette",
            "Yellow200"
        ]
    },
    {
        "value": "#EFDD4E",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EFDD4E",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow250",
        "path": [
            "color",
            "palette",
            "Yellow250"
        ]
    },
    {
        "value": "#EED12B",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EED12B",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow300",
        "path": [
            "color",
            "palette",
            "Yellow300"
        ]
    },
    {
        "value": "#DDB30E",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DDB30E",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow400",
        "path": [
            "color",
            "palette",
            "Yellow400"
        ]
    },
    {
        "value": "#CF9F02",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CF9F02",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow500",
        "path": [
            "color",
            "palette",
            "Yellow500"
        ]
    },
    {
        "value": "#B38600",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B38600",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow600",
        "path": [
            "color",
            "palette",
            "Yellow600"
        ]
    },
    {
        "value": "#946F00",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#946F00",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow700",
        "path": [
            "color",
            "palette",
            "Yellow700"
        ]
    },
    {
        "value": "#7F5F01",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7F5F01",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow800",
        "path": [
            "color",
            "palette",
            "Yellow800"
        ]
    },
    {
        "value": "#614A05",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#614A05",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow850",
        "path": [
            "color",
            "palette",
            "Yellow850"
        ]
    },
    {
        "value": "#533F04",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#533F04",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow900",
        "path": [
            "color",
            "palette",
            "Yellow900"
        ]
    },
    {
        "value": "#332E1B",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#332E1B",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow1000",
        "path": [
            "color",
            "palette",
            "Yellow1000"
        ]
    },
    {
        "value": "#DCFFF1",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DCFFF1",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green100",
        "path": [
            "color",
            "palette",
            "Green100"
        ]
    },
    {
        "value": "#BAF3DB",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BAF3DB",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green200",
        "path": [
            "color",
            "palette",
            "Green200"
        ]
    },
    {
        "value": "#BAF3DB66",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BAF3DB66",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green200A40",
        "path": [
            "color",
            "palette",
            "Green200A40"
        ]
    },
    {
        "value": "#97EDC9",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#97EDC9",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green250",
        "path": [
            "color",
            "palette",
            "Green250"
        ]
    },
    {
        "value": "#7EE2B8",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7EE2B8",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green300",
        "path": [
            "color",
            "palette",
            "Green300"
        ]
    },
    {
        "value": "#4BCE97",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4BCE97",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green400",
        "path": [
            "color",
            "palette",
            "Green400"
        ]
    },
    {
        "value": "#2ABB7F",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#2ABB7F",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green500",
        "path": [
            "color",
            "palette",
            "Green500"
        ]
    },
    {
        "value": "#22A06B",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#22A06B",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green600",
        "path": [
            "color",
            "palette",
            "Green600"
        ]
    },
    {
        "value": "#1F845A",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1F845A",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green700",
        "path": [
            "color",
            "palette",
            "Green700"
        ]
    },
    {
        "value": "#216E4E",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#216E4E",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green800",
        "path": [
            "color",
            "palette",
            "Green800"
        ]
    },
    {
        "value": "#19573D",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#19573D",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green850",
        "path": [
            "color",
            "palette",
            "Green850"
        ]
    },
    {
        "value": "#164B35",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#164B35",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green900",
        "path": [
            "color",
            "palette",
            "Green900"
        ]
    },
    {
        "value": "#164B35B2",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#164B35B2",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green900A70",
        "path": [
            "color",
            "palette",
            "Green900A70"
        ]
    },
    {
        "value": "#1C3329",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1C3329",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green1000",
        "path": [
            "color",
            "palette",
            "Green1000"
        ]
    },
    {
        "value": "#E7F9FF",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E7F9FF",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal100",
        "path": [
            "color",
            "palette",
            "Teal100"
        ]
    },
    {
        "value": "#C6EDFB",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#C6EDFB",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal200",
        "path": [
            "color",
            "palette",
            "Teal200"
        ]
    },
    {
        "value": "#B1E4F7",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B1E4F7",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal250",
        "path": [
            "color",
            "palette",
            "Teal250"
        ]
    },
    {
        "value": "#9DD9EE",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#9DD9EE",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal300",
        "path": [
            "color",
            "palette",
            "Teal300"
        ]
    },
    {
        "value": "#6CC3E0",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#6CC3E0",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal400",
        "path": [
            "color",
            "palette",
            "Teal400"
        ]
    },
    {
        "value": "#42B2D7",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#42B2D7",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal500",
        "path": [
            "color",
            "palette",
            "Teal500"
        ]
    },
    {
        "value": "#2898BD",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#2898BD",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal600",
        "path": [
            "color",
            "palette",
            "Teal600"
        ]
    },
    {
        "value": "#227D9B",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#227D9B",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal700",
        "path": [
            "color",
            "palette",
            "Teal700"
        ]
    },
    {
        "value": "#206A83",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#206A83",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal800",
        "path": [
            "color",
            "palette",
            "Teal800"
        ]
    },
    {
        "value": "#1A5265",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1A5265",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal850",
        "path": [
            "color",
            "palette",
            "Teal850"
        ]
    },
    {
        "value": "#164555",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#164555",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal900",
        "path": [
            "color",
            "palette",
            "Teal900"
        ]
    },
    {
        "value": "#1E3137",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1E3137",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal1000",
        "path": [
            "color",
            "palette",
            "Teal1000"
        ]
    },
    {
        "value": "#E9F2FE",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E9F2FE",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue100",
        "path": [
            "color",
            "palette",
            "Blue100"
        ]
    },
    {
        "value": "#CFE1FD",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CFE1FD",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue200",
        "path": [
            "color",
            "palette",
            "Blue200"
        ]
    },
    {
        "value": "#ADCBFB",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#ADCBFB",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue250",
        "path": [
            "color",
            "palette",
            "Blue250"
        ]
    },
    {
        "value": "#8FB8F6",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#8FB8F6",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue300",
        "path": [
            "color",
            "palette",
            "Blue300"
        ]
    },
    {
        "value": "#669DF1",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#669DF1",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue400",
        "path": [
            "color",
            "palette",
            "Blue400"
        ]
    },
    {
        "value": "#4688EC",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4688EC",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue500",
        "path": [
            "color",
            "palette",
            "Blue500"
        ]
    },
    {
        "value": "#357DE8",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#357DE8",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue600",
        "path": [
            "color",
            "palette",
            "Blue600"
        ]
    },
    {
        "value": "#1868DB",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1868DB",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue700",
        "path": [
            "color",
            "palette",
            "Blue700"
        ]
    },
    {
        "value": "#1558BC",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1558BC",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue800",
        "path": [
            "color",
            "palette",
            "Blue800"
        ]
    },
    {
        "value": "#144794",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#144794",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue850",
        "path": [
            "color",
            "palette",
            "Blue850"
        ]
    },
    {
        "value": "#123263",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#123263",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue900",
        "path": [
            "color",
            "palette",
            "Blue900"
        ]
    },
    {
        "value": "#1C2B42",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1C2B42",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue1000",
        "path": [
            "color",
            "palette",
            "Blue1000"
        ]
    },
    {
        "value": "#F8EEFE",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F8EEFE",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple100",
        "path": [
            "color",
            "palette",
            "Purple100"
        ]
    },
    {
        "value": "#EED7FC",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EED7FC",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple200",
        "path": [
            "color",
            "palette",
            "Purple200"
        ]
    },
    {
        "value": "#E3BDFA",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E3BDFA",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple250",
        "path": [
            "color",
            "palette",
            "Purple250"
        ]
    },
    {
        "value": "#D8A0F7",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#D8A0F7",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple300",
        "path": [
            "color",
            "palette",
            "Purple300"
        ]
    },
    {
        "value": "#C97CF4",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#C97CF4",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple400",
        "path": [
            "color",
            "palette",
            "Purple400"
        ]
    },
    {
        "value": "#BF63F3",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BF63F3",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple500",
        "path": [
            "color",
            "palette",
            "Purple500"
        ]
    },
    {
        "value": "#AF59E1",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#AF59E1",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple600",
        "path": [
            "color",
            "palette",
            "Purple600"
        ]
    },
    {
        "value": "#964AC0",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#964AC0",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple700",
        "path": [
            "color",
            "palette",
            "Purple700"
        ]
    },
    {
        "value": "#803FA5",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#803FA5",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple800",
        "path": [
            "color",
            "palette",
            "Purple800"
        ]
    },
    {
        "value": "#673286",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#673286",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple850",
        "path": [
            "color",
            "palette",
            "Purple850"
        ]
    },
    {
        "value": "#48245D",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#48245D",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple900",
        "path": [
            "color",
            "palette",
            "Purple900"
        ]
    },
    {
        "value": "#35243F",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#35243F",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple1000",
        "path": [
            "color",
            "palette",
            "Purple1000"
        ]
    },
    {
        "value": "#FFECF8",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFECF8",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta100",
        "path": [
            "color",
            "palette",
            "Magenta100"
        ]
    },
    {
        "value": "#FDD0EC",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FDD0EC",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta200",
        "path": [
            "color",
            "palette",
            "Magenta200"
        ]
    },
    {
        "value": "#FCB6E1",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FCB6E1",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta250",
        "path": [
            "color",
            "palette",
            "Magenta250"
        ]
    },
    {
        "value": "#F797D2",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F797D2",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta300",
        "path": [
            "color",
            "palette",
            "Magenta300"
        ]
    },
    {
        "value": "#E774BB",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E774BB",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta400",
        "path": [
            "color",
            "palette",
            "Magenta400"
        ]
    },
    {
        "value": "#DA62AC",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DA62AC",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta500",
        "path": [
            "color",
            "palette",
            "Magenta500"
        ]
    },
    {
        "value": "#CD519D",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CD519D",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta600",
        "path": [
            "color",
            "palette",
            "Magenta600"
        ]
    },
    {
        "value": "#AE4787",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#AE4787",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta700",
        "path": [
            "color",
            "palette",
            "Magenta700"
        ]
    },
    {
        "value": "#943D73",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#943D73",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta800",
        "path": [
            "color",
            "palette",
            "Magenta800"
        ]
    },
    {
        "value": "#77325B",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#77325B",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta850",
        "path": [
            "color",
            "palette",
            "Magenta850"
        ]
    },
    {
        "value": "#50253F",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#50253F",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta900",
        "path": [
            "color",
            "palette",
            "Magenta900"
        ]
    },
    {
        "value": "#3D2232",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3D2232",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta1000",
        "path": [
            "color",
            "palette",
            "Magenta1000"
        ]
    },
    {
        "value": "#FFFFFF",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFFFFF",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral0",
        "path": [
            "color",
            "palette",
            "Neutral0"
        ]
    },
    {
        "value": "#F8F8F8",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F8F8F8",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral100",
        "path": [
            "color",
            "palette",
            "Neutral100"
        ]
    },
    {
        "value": "#F0F1F2",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F0F1F2",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral200",
        "path": [
            "color",
            "palette",
            "Neutral200"
        ]
    },
    {
        "value": "#DDDEE1",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DDDEE1",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral300",
        "path": [
            "color",
            "palette",
            "Neutral300"
        ]
    },
    {
        "value": "#B7B9BE",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B7B9BE",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral400",
        "path": [
            "color",
            "palette",
            "Neutral400"
        ]
    },
    {
        "value": "#8C8F97",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#8C8F97",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral500",
        "path": [
            "color",
            "palette",
            "Neutral500"
        ]
    },
    {
        "value": "#7D818A",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7D818A",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral600",
        "path": [
            "color",
            "palette",
            "Neutral600"
        ]
    },
    {
        "value": "#6B6E76",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#6B6E76",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral700",
        "path": [
            "color",
            "palette",
            "Neutral700"
        ]
    },
    {
        "value": "#505258",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#505258",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral800",
        "path": [
            "color",
            "palette",
            "Neutral800"
        ]
    },
    {
        "value": "#3B3D42",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3B3D42",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral900",
        "path": [
            "color",
            "palette",
            "Neutral900"
        ]
    },
    {
        "value": "#292A2E",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#292A2E",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral1000",
        "path": [
            "color",
            "palette",
            "Neutral1000"
        ]
    },
    {
        "value": "#1E1F21",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1E1F21",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral1100",
        "path": [
            "color",
            "palette",
            "Neutral1100"
        ]
    },
    {
        "value": "#000000",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#000000",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral1200",
        "path": [
            "color",
            "palette",
            "Neutral1200"
        ]
    },
    {
        "value": "#17171708",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#17171708",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral100A",
        "path": [
            "color",
            "palette",
            "Neutral100A"
        ]
    },
    {
        "value": "#0515240F",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#0515240F",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral200A",
        "path": [
            "color",
            "palette",
            "Neutral200A"
        ]
    },
    {
        "value": "#0B120E24",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#0B120E24",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral300A",
        "path": [
            "color",
            "palette",
            "Neutral300A"
        ]
    },
    {
        "value": "#080F214A",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#080F214A",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral400A",
        "path": [
            "color",
            "palette",
            "Neutral400A"
        ]
    },
    {
        "value": "#050C1F75",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#050C1F75",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral500A",
        "path": [
            "color",
            "palette",
            "Neutral500A"
        ]
    },
    {
        "value": "#111213",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#111213",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral-100",
        "path": [
            "color",
            "palette",
            "DarkNeutral-100"
        ]
    },
    {
        "value": "#18191A",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#18191A",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral0",
        "path": [
            "color",
            "palette",
            "DarkNeutral0"
        ]
    },
    {
        "value": "#1F1F21",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1F1F21",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral100",
        "path": [
            "color",
            "palette",
            "DarkNeutral100"
        ]
    },
    {
        "value": "#242528",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#242528",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral200",
        "path": [
            "color",
            "palette",
            "DarkNeutral200"
        ]
    },
    {
        "value": "#2B2C2F",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#2B2C2F",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral250",
        "path": [
            "color",
            "palette",
            "DarkNeutral250"
        ]
    },
    {
        "value": "#303134",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#303134",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral300",
        "path": [
            "color",
            "palette",
            "DarkNeutral300"
        ]
    },
    {
        "value": "#3D3F43",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3D3F43",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral350",
        "path": [
            "color",
            "palette",
            "DarkNeutral350"
        ]
    },
    {
        "value": "#4B4D51",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4B4D51",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral400",
        "path": [
            "color",
            "palette",
            "DarkNeutral400"
        ]
    },
    {
        "value": "#63666B",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#63666B",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral500",
        "path": [
            "color",
            "palette",
            "DarkNeutral500"
        ]
    },
    {
        "value": "#7E8188",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7E8188",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral600",
        "path": [
            "color",
            "palette",
            "DarkNeutral600"
        ]
    },
    {
        "value": "#96999E",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#96999E",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral700",
        "path": [
            "color",
            "palette",
            "DarkNeutral700"
        ]
    },
    {
        "value": "#A9ABAF",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#A9ABAF",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral800",
        "path": [
            "color",
            "palette",
            "DarkNeutral800"
        ]
    },
    {
        "value": "#BFC1C4",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BFC1C4",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral900",
        "path": [
            "color",
            "palette",
            "DarkNeutral900"
        ]
    },
    {
        "value": "#CECFD2",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CECFD2",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral1000",
        "path": [
            "color",
            "palette",
            "DarkNeutral1000"
        ]
    },
    {
        "value": "#E2E3E4",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E2E3E4",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral1100",
        "path": [
            "color",
            "palette",
            "DarkNeutral1100"
        ]
    },
    {
        "value": "#FFFFFF",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFFFFF",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral1200",
        "path": [
            "color",
            "palette",
            "DarkNeutral1200"
        ]
    },
    {
        "value": "#01040475",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#01040475",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral-100A",
        "path": [
            "color",
            "palette",
            "DarkNeutral-100A"
        ]
    },
    {
        "value": "#BDBDBD0A",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BDBDBD0A",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral100A",
        "path": [
            "color",
            "palette",
            "DarkNeutral100A"
        ]
    },
    {
        "value": "#CECED912",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CECED912",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral200A",
        "path": [
            "color",
            "palette",
            "DarkNeutral200A"
        ]
    },
    {
        "value": "#D9DAE71A",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#D9DAE71A",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral250A",
        "path": [
            "color",
            "palette",
            "DarkNeutral250A"
        ]
    },
    {
        "value": "#E3E4F21F",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E3E4F21F",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral300A",
        "path": [
            "color",
            "palette",
            "DarkNeutral300A"
        ]
    },
    {
        "value": "#E8EDFD2E",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E8EDFD2E",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral350A",
        "path": [
            "color",
            "palette",
            "DarkNeutral350A"
        ]
    },
    {
        "value": "#E5E9F640",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E5E9F640",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral400A",
        "path": [
            "color",
            "palette",
            "DarkNeutral400A"
        ]
    },
    {
        "value": "#E9F0FB5C",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E9F0FB5C",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral500A",
        "path": [
            "color",
            "palette",
            "DarkNeutral500A"
        ]
    },
    {
        "value": 0.2,
        "attributes": {
            "group": "palette",
            "category": "opacity"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": 0.2,
            "attributes": {
                "group": "palette",
                "category": "opacity"
            }
        },
        "name": "value.opacity.Opacity20",
        "path": [
            "value",
            "opacity",
            "Opacity20"
        ]
    },
    {
        "value": 0.4,
        "attributes": {
            "group": "palette",
            "category": "opacity"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": 0.4,
            "attributes": {
                "group": "palette",
                "category": "opacity"
            }
        },
        "name": "value.opacity.Opacity40",
        "path": [
            "value",
            "opacity",
            "Opacity40"
        ]
    }
];
var $3cf630e681b4258b$export$2e2bcd8739ae039 = $3cf630e681b4258b$var$tokens;



var $3osen = parcelRequire("3osen");


var $5d6Y9 = parcelRequire("5d6Y9");

var $2Jj9T = parcelRequire("2Jj9T");


var $iZTi0 = parcelRequire("iZTi0");

const $f7b58a0c779c21e7$export$dc37d14f75a32acb = 7;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f7b58a0c779c21e7$var$CSS_VAR_EXPRESSION_REGEX = /var\(([^,\)]+)(,.*)?\)/;
const $f7b58a0c779c21e7$var$getCSSVariableParts = (variableExpression)=>{
    const matcher = variableExpression.match($f7b58a0c779c21e7$var$CSS_VAR_EXPRESSION_REGEX);
    if (!matcher) return undefined;
    return {
        fallback: matcher[2] ? matcher[2].replace(',', '').trim() : '',
        variable: matcher[1].trim()
    };
};
// Build the reverse lookup (CSS variable -> token name) once at module load so that
// each lookup is O(1) instead of O(n) with an extra array allocation per call.
const $f7b58a0c779c21e7$var$cssVariableToTokenName = new Map(Object.entries((0, $3osen.default)).map(([tokenName, cssVariable])=>[
        cssVariable,
        tokenName
    ]));
const $f7b58a0c779c21e7$var$getTokenName = (cssVariable)=>$f7b58a0c779c21e7$var$cssVariableToTokenName.get(cssVariable);
const $f7b58a0c779c21e7$var$resolveRawTokenValue = (value)=>{
    if (typeof value !== 'string') return undefined;
    const paletteValue = (0, $3cf630e681b4258b$export$2e2bcd8739ae039).find((paletteToken)=>paletteToken.path[paletteToken.path.length - 1] === value)?.value;
    return typeof paletteValue === 'string' ? paletteValue : value;
};
const $f7b58a0c779c21e7$var$getCurrentThemeMode = ()=>{
    if (typeof document === 'undefined') return 'light';
    return document.documentElement.getAttribute('data-color-mode') === 'dark' ? 'dark' : 'light';
};
const $f7b58a0c779c21e7$var$getNonActiveThemeMode = ()=>$f7b58a0c779c21e7$var$getCurrentThemeMode() === 'dark' ? 'light' : 'dark';
function $f7b58a0c779c21e7$export$d97d52770ca27b6f(palette, cols = $f7b58a0c779c21e7$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $f7b58a0c779c21e7$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $f7b58a0c779c21e7$export$dc37d14f75a32acb) {
    const colorsPerRow = $f7b58a0c779c21e7$export$d97d52770ca27b6f(palette, cols);
    return (0, $iZTi0.getSelectedRowAndColumn)(colorsPerRow, selectedColor);
}
const $f7b58a0c779c21e7$export$426cbff16166281c = (variableExpression)=>{
    const matcher = variableExpression.match($f7b58a0c779c21e7$var$CSS_VAR_EXPRESSION_REGEX);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};
const $f7b58a0c779c21e7$export$6c1720cebb7dda4b = (variableExpression, fallback)=>{
    const cssVariableParts = $f7b58a0c779c21e7$var$getCSSVariableParts(variableExpression);
    const tokenName = cssVariableParts ? $f7b58a0c779c21e7$var$getTokenName(cssVariableParts.variable) : undefined;
    const rawToken = ($f7b58a0c779c21e7$var$getNonActiveThemeMode() === 'light' ? (0, $2Jj9T.default) : (0, $5d6Y9.default)).find((token)=>token.cleanName === tokenName);
    if (rawToken) return $f7b58a0c779c21e7$var$resolveRawTokenValue(rawToken.value) || fallback;
    return cssVariableParts?.fallback || fallback;
};
module.exports["DEFAULT_COLOR_PICKER_COLUMNS"] = $f7b58a0c779c21e7$export$dc37d14f75a32acb;
module.exports["getColorsPerRowFromPalette"] = $f7b58a0c779c21e7$export$d97d52770ca27b6f;
module.exports["getSelectedRowAndColumnFromPalette"] = $f7b58a0c779c21e7$export$c16ae5b27ec0c8f6;
module.exports["getTokenCSSVariableValue"] = $f7b58a0c779c21e7$export$426cbff16166281c;
module.exports["getTokenCSSVariableValueForNonActiveTheme"] = $f7b58a0c779c21e7$export$6c1720cebb7dda4b;

});

parcelRegister("kQOs5", function(module, exports) {

var $aELWC = parcelRequire("aELWC");

/**
 * For a given color set the alpha channel to alpha
 *
 * @param color color string, suppports HEX, RGB, RGBA etc.
 * @param alpha Alpha channel value as fraction of 1
 * @return CSS RGBA string with applied alpha channel
 */ function $13d54d722f604b75$var$setAlpha(color, alpha) {
    const { r: r, g: g, b: b } = (0, $aELWC.default).convert(color).rgb;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const $13d54d722f604b75$export$f54f5cacf382b9f2 = $13d54d722f604b75$var$setAlpha('#172B4D', 0.12); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 
module.exports["DEFAULT_BORDER_COLOR"] = $13d54d722f604b75$export$f54f5cacf382b9f2;

});

parcelRegister("9GNtS", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $9RT19 = parcelRequire("9RT19");


var $fPv5h = parcelRequire("fPv5h");


var $bZDJe = parcelRequire("bZDJe");

const $a67897aab259fc4c$export$49166591ec160d97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function DropdownContainer(props) {
    const keyDownHandlerContext = (0, $cozmU.useContext)((0, $bZDJe.KeyDownHandlerContext));
    let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
    // if the dropdown is of type menu, use this keyDownHandlerContext
    if (props.arrowKeyNavigationProviderOptions.type === (0, $9RT19.ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return(//This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fPv5h.default), {
        ...props,
        arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
    }));
});
module.exports["DropdownContainer"] = $a67897aab259fc4c$export$49166591ec160d97;

});

parcelRegister("fPv5h", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $j9oLZ = parcelRequire("j9oLZ");


var $7XIuB = parcelRequire("7XIuB");


var $1jz5K = parcelRequire("1jz5K");


var $g9ric = parcelRequire("g9ric");

class $ea06cbc52fe574eb$export$931cbfb6bfb85fc extends (0, $cozmU.PureComponent) {
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen && this.state.target) {
            // Dropdown flickers when opens as placement is calculated in Popup component and updated after the first render.
            // popupPlacement is set to ['bottom', 'left'] by default, but it may not be the correct placement and is required in DropdownList.
            // To avoid flicker we calculate placement here and set it to state when the dropdown opens.
            const initialPlacement = (0, $1jz5K.calculatePlacement)(this.state.target, this.props.boundariesElement || document.body, this.props.fitWidth, this.props.fitHeight, this.props.alignX, this.props.alignY, this.props.forcePlacement);
            this.setState({
                popupPlacement: initialPlacement
            });
        }
    }
    renderDropdown() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement, target: targetProp, forcePlacement: forcePlacement, alignX: alignX, alignY: alignY, offset: offset, shouldFitContainer: shouldFitContainer = true, testId: testId } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
            target: targetProp ?? (alignDropdownWithParentElement ? // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            target?.closest("[data-testid='editor-floating-toolbar']") : target),
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: forcePlacement ? undefined : this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex,
            allowOutOfBounds: alignDropdownWithParentElement,
            alignX: alignX,
            alignY: alignY,
            forcePlacement: forcePlacement,
            offset: offset,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                ...arrowKeyNavigationProviderOptions,
                closeOnTab: true,
                handleClose: this.handleCloseAndFocus,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: fitWidth || 0
                    },
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j9oLZ.default), {
                        isOpen: true,
                        onOpenChange: onOpenChange,
                        position: popupPlacement.join(' '),
                        shouldFitContainer: shouldFitContainer,
                        id: dropdownListId,
                        testId: testId,
                        children: children
                    })
                })
            })
        });
    }
    render() {
        const { trigger: trigger, isOpen: isOpen } = this.props;
        return trigger ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            ref: this.handleRef(setOutsideClickTargetRef),
                            children: trigger
                        }),
                        isOpen ? this.renderDropdown() : null
                    ]
                })
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: isOpen ? this.renderDropdown() : null
        });
    }
    constructor(props){
        super(props);
        this.handleRef = (setOutsideClickTargetRef)=>(target)=>{
                setOutsideClickTargetRef(target);
                this.setState({
                    target: target || undefined
                });
            };
        this.updatePopupPlacement = (placement)=>{
            this.setState({
                popupPlacement: placement
            });
        };
        this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        };
        this.handleClose = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ]
        };
    }
}
const $ea06cbc52fe574eb$var$DropdownWithOuterListeners = (0, $9Muxb.default)($ea06cbc52fe574eb$export$931cbfb6bfb85fc);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ea06cbc52fe574eb$export$2e2bcd8739ae039 = $ea06cbc52fe574eb$var$DropdownWithOuterListeners;
module.exports["default"] = $ea06cbc52fe574eb$export$2e2bcd8739ae039;

});

parcelRegister("9GCRb", function(module, exports) {

var $cycWk = parcelRequire("cycWk");

const $7c0c758334e190a1$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $cycWk.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};
module.exports["isSelectionTableNestedInTable"] = $7c0c758334e190a1$export$3dd46fa6c35aa514;

});

parcelRegister("3HCXM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $3uRAA = parcelRequire("3uRAA");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $3mD3Q = parcelRequire("3mD3Q");


var $gx3UZ = parcelRequire("gx3UZ");


var $aC6bW = parcelRequire("aC6bW");


var $jGK9e = parcelRequire("jGK9e");


var $gid2f = parcelRequire("gid2f");


var $kTb7m = parcelRequire("kTb7m");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $1Ns7R = parcelRequire("1Ns7R");


var $kwAo1 = parcelRequire("kwAo1");


var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");


var $kCECX = parcelRequire("kCECX");

const $52efe1fa3bb0eaad$export$38c00ed3b117ab26 = new (0, $kCECX.PluginKey)('fakeCursorToolbarPlugin');



var $o2UQ9 = parcelRequire("o2UQ9");

const $07c439e1e228556c$var$createTextCursor = (pos)=>{
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $8nvEM.Decoration).widget(pos, node, {
        key: 'hyperlink-text-cursor'
    });
};
const $07c439e1e228556c$var$createTextSelection = (from, to)=>(0, $8nvEM.Decoration).inline(from, to, {
        class: 'ProseMirror-fake-text-selection'
    });
const $07c439e1e228556c$var$getInsertLinkToolbarState = (editorState)=>{
    const state = (0, $o2UQ9.stateKey).getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === (0, $kwAo1.InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
    }
    return undefined;
};
const $07c439e1e228556c$var$fakeCursorToolbarPlugin = new (0, $kpCD8.SafePlugin)({
    key: (0, $52efe1fa3bb0eaad$export$38c00ed3b117ab26),
    state: {
        init () {
            return (0, $8nvEM.DecorationSet).empty;
        },
        apply (tr, pluginState, oldState, newState) {
            const oldInsertToolbarState = $07c439e1e228556c$var$getInsertLinkToolbarState(oldState);
            const insertToolbarState = $07c439e1e228556c$var$getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                return (0, $8nvEM.DecorationSet).create(tr.doc, [
                    from === to ? $07c439e1e228556c$var$createTextCursor(from) : $07c439e1e228556c$var$createTextSelection(from, to)
                ]);
            }
            return (0, $8nvEM.DecorationSet).empty;
        }
    },
    props: {
        decorations (state) {
            return (0, $52efe1fa3bb0eaad$export$38c00ed3b117ab26).getState(state);
        }
    }
});
var $07c439e1e228556c$export$2e2bcd8739ae039 = $07c439e1e228556c$var$fakeCursorToolbarPlugin;






var $2HZqG = parcelRequire("2HZqG");





var $d8RhQ = parcelRequire("d8RhQ");

var $4wRTw = parcelRequire("4wRTw");

var $cIAPj = parcelRequire("cIAPj");

var $hZrGN = parcelRequire("hZrGN");

var $4IWLk = parcelRequire("4IWLk");


var $91Kwo = parcelRequire("91Kwo");







const $4087fb88f9ced735$export$6cbac557ea601778 = new (0, $kCECX.PluginKey)('hyperlinkToolbarItems');
const $4087fb88f9ced735$export$faf11097578346af = (initialState)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $4087fb88f9ced735$export$6cbac557ea601778,
        state: {
            init: (_, __)=>{
                return initialState;
            },
            apply: (tr, pluginState)=>{
                const metaState = tr.getMeta($4087fb88f9ced735$export$6cbac557ea601778);
                if (metaState) return metaState;
                return pluginState;
            }
        }
    });
};


// [something](link) should convert to a hyperlink
// eslint-disable-next-line require-unicode-regexp
const $4cdb90caca6b6f28$var$MARKDOWN_LINK_RULE_REGEX = /(^|[^!])\[(.*?)\]\((\S+)\)$/;
function $4cdb90caca6b6f28$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
    // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
    return (0, $d8RhQ.createRule)(regexp, (state, match, start, end)=>{
        const { schema: schema } = state;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
        const link = match;
        // Property 'url' does not exist on type 'RegExpExecArray', the type of `match`.
        // This check is in case the match is not a Linkify match, which has a url property.
        if (link.url === undefined) return null;
        if (!(0, $4IWLk.shouldAutoLinkifyMatch)(link)) return null;
        const url = (0, $hZrGN.normalizeUrl)(link.url);
        // Not previously handled; don't create a link if the URL is empty.
        // This will only happen if the `regexp` matches more links than the normalizeUrl validation;
        // if they both use the same linkify instance this shouldn't happen.
        if (url === '') return null;
        const markType = schema.mark('link', {
            href: url
        });
        // Need access to complete text to check if last URL is part of a filepath before linkifying
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
        const filepaths = (0, $4wRTw.findFilepaths)(nodeBefore.text, // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
        start - (nodeBefore.text.length - link.text.length));
        if ((0, $4wRTw.isLinkInMatches)(start, filepaths)) {
            const tr = state.tr;
            return tr;
        }
        const from = start;
        const to = Math.min(start + link.text.length, state.doc.content.size);
        const tr = state.tr.addMark(from, to, markType);
        // Keep old behavior that will delete the space after the link
        if (to === end) tr.insertText(' ');
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $krYZG.INPUT_METHOD).AUTO_DETECT
        });
        const skipAnalytics = (0, $4087fb88f9ced735$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $4wRTw.getLinkCreationAnalyticsEvent)((0, $krYZG.INPUT_METHOD).AUTO_DETECT, url))(tr);
        return tr;
    });
}
function $4cdb90caca6b6f28$export$dc83f374e2af640d(schema, editorAnalyticsApi, autoLinkOnBlur = false) {
    if (!schema.marks.link) return;
    const urlWithASpaceRule = $4cdb90caca6b6f28$export$8d0400fab1d2ed11((0, $cIAPj.LinkMatcher).create(), editorAnalyticsApi);
    const markdownLinkRule = (0, $d8RhQ.createRule)($4cdb90caca6b6f28$var$MARKDOWN_LINK_RULE_REGEX, (state, match, start, end)=>{
        const { schema: schema } = state;
        const [, prefix, linkText, linkUrl] = match;
        // We don't filter this match here by shouldAutoLinkifyMatch
        // because the intent of creating a link is clear
        const url = (0, $hZrGN.normalizeUrl)(linkUrl).trim();
        const markType = schema.mark('link', {
            href: url
        });
        const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
            markType
        ]));
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
        });
        const skipAnalytics = (0, $4087fb88f9ced735$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $4wRTw.getLinkCreationAnalyticsEvent)((0, $krYZG.INPUT_METHOD).FORMATTING, url))(tr);
        return tr;
    });
    return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('hyperlink', [
        urlWithASpaceRule,
        markdownLinkRule
    ], autoLinkOnBlur ? {
        checkOnBlur: true,
        appendTextOnBlur: ' '
    } : undefined));
}
var $4cdb90caca6b6f28$export$2e2bcd8739ae039 = $4cdb90caca6b6f28$export$dc83f374e2af640d;



var $9p0BY = parcelRequire("9p0BY");
















var $44cyU = parcelRequire("44cyU");








function $cce89f36ab55f297$export$1d7b13ce0747fbd(editorAnalyticsApi) {
    const list = {};
    (0, $ldqjS.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addLink).common, (0, $1Ns7R.showLinkToolbar)((0, $krYZG.INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $cce89f36ab55f297$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.insertNewLine).common, $cce89f36ab55f297$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.escape).common, (state, dispatch, view)=>{
        const hyperlinkPlugin = (0, $o2UQ9.stateKey).getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            (0, $1Ns7R.hideLinkToolbar)()(state, dispatch);
            if (view) view.focus();
            return false;
        }
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
/**
 * Convert the last word before the selection to a hyperlink if it's a valid URL with a tld we want to linkify
 */ const $cce89f36ab55f297$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
    return function(state, dispatch) {
        const skipAnalytics = (0, $4087fb88f9ced735$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const words = nodeBefore.text.split(' ');
        const lastWord = words[words.length - 1];
        const match = (0, $9p0BY.getLinkMatch)(lastWord);
        if (match) {
            if (!(0, $4IWLk.shouldAutoLinkifyMatch)(match)) return false;
            const hyperlinkedText = match.raw;
            const start = state.selection.$from.pos - hyperlinkedText.length;
            const end = state.selection.$from.pos;
            if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
            const url = match.url;
            const markType = state.schema.mark('link', {
                href: url
            });
            const filepaths = (0, $4wRTw.findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length));
            if ((0, $4wRTw.isLinkInMatches)(start, filepaths)) return false;
            const tr = state.tr.addMark(start, end, markType);
            if (dispatch) {
                (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                    inputMethod: (0, $krYZG.INPUT_METHOD).AUTO_DETECT
                });
                if (skipAnalytics) dispatch(tr);
                else {
                    editorAnalyticsApi?.attachAnalyticsEvent((0, $4wRTw.getLinkCreationAnalyticsEvent)((0, $krYZG.INPUT_METHOD).AUTO_DETECT, url))(tr);
                    dispatch(tr);
                }
            }
        }
        return false;
    };
};
var $cce89f36ab55f297$export$2e2bcd8739ae039 = $cce89f36ab55f297$export$1d7b13ce0747fbd;









parcelRequire("cozmU");








var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");





var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

















var $I2MTF = parcelRequire("I2MTF");




const $4bebfc609495ce71$export$b993de95dedc883b = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert(undefined);
        tr.setMeta((0, $o2UQ9.stateKey), {
            type: (0, $3mD3Q.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
        });
        const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).INVOKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        })(tr);
        return analyticsAttached !== false ? tr : false;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconLink), {}),
        onSelect: onSelect,
        shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addLink)),
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).link)
    });
};


const $1fe817f7027c351a$export$91d5466719f8efb8 = ({ api: api })=>[
        {
            key: (0, $dCkbP.HYPERLINK_MENU_ITEM).key,
            type: (0, $dCkbP.HYPERLINK_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.MEDIA_SECTION).key,
                    type: (0, $dCkbP.MEDIA_SECTION).type,
                    rank: (0, $dXqu3.MEDIA_SECTION_RANK)[(0, $dCkbP.HYPERLINK_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).linkDescription),
                    keywords: [
                        'hyperlink',
                        'url'
                    ],
                    shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addLink)),
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).link)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4bebfc609495ce71$export$b993de95dedc883b), {
                    api: api
                })
        }
    ];





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");




parcelRequire("cozmU");








var $3k5Tv = parcelRequire("3k5Tv");










var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");

const $6cfdeb761019b16a$export$29d11c0fe2fc51d8 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const canInsertLink = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'hyperlink'
    ], (state)=>state?.hyperlinkState?.canInsertLink ?? true);
    const onClick = ()=>{
        api?.core.actions.execute(api?.hyperlink.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).FLOATING_TB));
    };
    const isEnabled = canInsertLink;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).link),
            keymap: (0, $ldqjS.addLink)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).link),
                size: "small"
            }),
            onClick: onClick,
            testId: 'editor-toolbar__link-button',
            isDisabled: !isEnabled
        })
    });
};


const $1bfb365c933b9fd4$export$a758406ca53b86a5 = (api)=>{
    const toolbarComponents = [
        {
            type: (0, $3nacY.LINKING_GROUP).type,
            key: (0, $3nacY.LINKING_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.LINKING_SECTION).type,
                    key: (0, $3nacY.LINKING_SECTION).key,
                    rank: (0, $hVLmg.LINKING_SECTION_RANK)[(0, $3nacY.LINKING_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3nacY.LINKING_BUTTON).type,
            key: (0, $3nacY.LINKING_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.LINKING_GROUP).type,
                    key: (0, $3nacY.LINKING_GROUP).key,
                    rank: (0, $hVLmg.LINKING_GROUP_RANK)[(0, $3nacY.LINKING_BUTTON).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6cfdeb761019b16a$export$29d11c0fe2fc51d8), {
                    api: api
                });
            }
        }
    ];
    return toolbarComponents;
};














var $eaCAt = parcelRequire("eaCAt");


var $gjTdl = parcelRequire("gjTdl");





var $3FyXx = parcelRequire("3FyXx");


var $91WyP = parcelRequire("91WyP");

var $iEFx5 = parcelRequire("iEFx5");


var $g6uqx = parcelRequire("g6uqx");


var $2VYYv = parcelRequire("2VYYv");


var $3v5aK = parcelRequire("3v5aK");





var $jaFVy = parcelRequire("jaFVy");





var $bjg0G = parcelRequire("bjg0G");


var $gC2EJ = parcelRequire("gC2EJ");


var $8y86q = parcelRequire("8y86q");


var $V3JOP = parcelRequire("V3JOP");











/* type guard for edit links */ function $89be01139bde1e95$var$isEditLink(linkMark) {
    return linkMark.pos !== undefined;
}
const $89be01139bde1e95$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
    if (dispatch) {
        const { tr: tr } = state;
        editorAnalyticsApi?.attachAnalyticsEvent(analyticsBuilder((0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        dispatch(tr);
    }
};
const $89be01139bde1e95$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
        $89be01139bde1e95$var$dispatchAnalytics(dispatch, state, (0, $eaCAt.buildVisitedLinkPayload), editorAnalyticsApi);
        return true;
    };
function $89be01139bde1e95$var$getLinkText(activeLinkMark, state) {
    if (!activeLinkMark.node) return undefined;
    const textToUrl = (0, $hZrGN.normalizeUrl)(activeLinkMark.node.text);
    const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
    const linkHref = linkMark && linkMark.attrs.href;
    if (textToUrl === linkHref) return undefined;
    return activeLinkMark.node.text;
}
const $89be01139bde1e95$var$selector = (states)=>{
    return {
        timesViewed: states.hyperlinkState?.timesViewed,
        inputMethod: states.hyperlinkState?.inputMethod,
        searchSessionId: states.hyperlinkState?.searchSessionId
    };
};
function $89be01139bde1e95$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
    const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'hyperlink'
    ], $89be01139bde1e95$var$selector);
    // This is constant rather than dynamic - because if someone's already got a hyperlink toolbar open,
    // we don't want to dynamically change it on them as this would cause data loss if they've already
    // started typing in the fields.
    const isOffline = (0, $cozmU.useRef)((0, $jaFVy.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState.currentState()?.mode));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3FyXx.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback,
        timesViewed: timesViewed,
        inputMethod: inputMethod,
        searchSessionId: searchSessionId,
        isOffline: isOffline.current
    });
}
const $89be01139bde1e95$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
        if (options.disableFloatingToolbar) return;
        const isToolbarAIFCEnabled = Boolean(pluginInjectionApi?.toolbar);
        const linkState = (0, $o2UQ9.stateKey).getState(state);
        const activeLinkMark = linkState?.activeLinkMark;
        // If range selection, we don't show hyperlink floating toolbar.
        // Text Formattting toolbar is shown instaed.
        if (state.selection instanceof (0, $kCECX.TextSelection) && state.selection.to !== state.selection.from && activeLinkMark?.type === 'EDIT' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) return;
        const { formatMessage: formatMessage } = intl;
        const editorCardActions = pluginInjectionApi?.card?.actions;
        const editorAnalyticsApi = pluginInjectionApi?.analytics?.actions;
        const lpLinkPicker = options.lpLinkPicker ?? true;
        if (activeLinkMark) {
            const hyperLinkToolbar = {
                title: 'Hyperlink floating controls',
                nodeType: [
                    state.schema.nodes.text,
                    state.schema.nodes.paragraph,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem,
                    state.schema.nodes.caption
                ].filter((nodeType)=>!!nodeType),
                // Use only the node types existing in the schema ED-6745
                align: 'left',
                className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : '',
                // getDomRef by default uses view.state.selection.from to position the toolbar.
                // However, when the user clicks in right after the link the view.state.selection.from references to the dom after the selection.
                // So instead we want to use the activeLinkMark.pos which has been calculated as the position before the click so that would be the link node
                getDomRef: activeLinkMark && (activeLinkMark.type === 'EDIT_INSERTED' || activeLinkMark.type === 'EDIT') && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
                    const domRef = (0, $bjg0G.findDomRefAtPos)(activeLinkMark.pos, view.domAtPos.bind(view));
                    return domRef instanceof HTMLElement ? domRef : undefined;
                } : undefined
            };
            switch(activeLinkMark.type){
                case 'EDIT':
                    {
                        const { pos: pos, node: node } = activeLinkMark;
                        const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                        const link = linkMark[0] && linkMark[0].attrs.href;
                        const isValidUrl = (0, $9p0BY.isSafeUrl)(link);
                        const labelOpenLink = formatMessage(isValidUrl ? (0, $91WyP.linkMessages).openLink : (0, $iEFx5.linkToolbarMessages).unableToOpenLink);
                        // TODO: ED-14403 - investigate why these are not translating?
                        const labelUnlink = formatMessage((0, $iEFx5.linkToolbarMessages).unlink);
                        const editLink = formatMessage((0, $iEFx5.linkToolbarMessages).editLink);
                        const metadata = {
                            url: link,
                            title: ''
                        };
                        if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                        const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
                        const cardActions = pluginInjectionApi?.card?.actions;
                        const startingToolbarItems = cardActions?.getStartingToolbarItems(intl, link, (0, $1Ns7R.editInsertedLink)(editorAnalyticsApi), metadata, areAnyNewToolbarFlagsEnabled ? state : undefined) ?? [
                            {
                                id: 'editor.link.edit',
                                testId: 'editor.link.edit',
                                type: 'button',
                                onClick: (0, $1Ns7R.editInsertedLink)(editorAnalyticsApi),
                                title: editLink,
                                showTitle: areAnyNewToolbarFlagsEnabled ? false : true,
                                metadata: metadata,
                                icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))) : undefined
                            },
                            {
                                type: 'separator'
                            }
                        ];
                        const openLinkButton = {
                            id: 'editor.link.openLink',
                            testId: 'editor.link.openLink',
                            type: 'button',
                            disabled: !isValidUrl,
                            target: '_blank',
                            href: isValidUrl ? link : undefined,
                            onClick: $89be01139bde1e95$var$visitHyperlink(editorAnalyticsApi),
                            title: labelOpenLink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                            className: 'hyperlink-open-link',
                            metadata: metadata,
                            tabIndex: null
                        };
                        const unlinkButton = {
                            id: 'editor.link.unlink',
                            testId: 'editor.link.unlink',
                            type: 'button',
                            onClick: (0, $gjTdl.commandWithMetadata)((0, $1Ns7R.removeLink)(pos, editorAnalyticsApi), {
                                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                            }),
                            title: labelUnlink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q))),
                            tabIndex: null
                        };
                        const items = [
                            ...startingToolbarItems,
                            ...areAnyNewToolbarFlagsEnabled ? [
                                unlinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                },
                                openLinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                }
                            ] : [
                                openLinkButton,
                                {
                                    type: 'separator'
                                },
                                unlinkButton,
                                {
                                    type: 'separator'
                                }
                            ],
                            {
                                type: 'copy-button',
                                items: [
                                    {
                                        state: state,
                                        formatMessage: formatMessage,
                                        markType: state.schema.marks.link
                                    }
                                ]
                            },
                            ...cardActions?.getEndingToolbarItems(intl, link) ?? []
                        ];
                        return {
                            ...hyperLinkToolbar,
                            height: 32,
                            width: 250,
                            items: items,
                            scrollable: true
                        };
                    }
                case 'EDIT_INSERTED':
                case 'INSERT':
                    {
                        let link;
                        if ($89be01139bde1e95$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                            const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            link = linkMark[0] && linkMark[0].attrs.href;
                        }
                        const displayText = $89be01139bde1e95$var$isEditLink(activeLinkMark) ? $89be01139bde1e95$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                        const popupHeight = options?.linkPicker?.popupHeight ?? (lpLinkPicker ? (0, $2VYYv.LINKPICKER_HEIGHT_IN_PX) : (0, $2VYYv.RECENT_SEARCH_HEIGHT_IN_PX));
                        const popupWidth = options?.linkPicker?.popupWidth ?? (!lpLinkPicker ? undefined : (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX));
                        return {
                            ...hyperLinkToolbar,
                            preventPopupOverflow: true,
                            height: popupHeight,
                            width: popupWidth,
                            items: [
                                {
                                    type: 'custom',
                                    fallback: [],
                                    disableArrowNavigation: true,
                                    render: (view, idx)=>{
                                        if (!view) return null;
                                        const Toolbar = /*#__PURE__*/ (0, $8aG6j.jsx)($89be01139bde1e95$export$a46cebff622c3cae, {
                                            pluginInjectionApi: pluginInjectionApi,
                                            view: view,
                                            linkPickerOptions: options?.linkPicker,
                                            lpLinkPicker: lpLinkPicker,
                                            displayUrl: link,
                                            displayText: displayText || '',
                                            providerFactory: providerFactory,
                                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                            onCancel: ()=>view.focus(),
                                            onEscapeCallback: (0, $1Ns7R.onEscapeCallback)(editorCardActions),
                                            onClickAwayCallback: (0, $1Ns7R.onClickAwayCallback),
                                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                            onSubmit: (href, title = '', displayText, inputMethod, analytic, appearance)=>{
                                                const isEdit = $89be01139bde1e95$var$isEditLink(activeLinkMark);
                                                const action = isEdit ? (0, $krYZG.ACTION).UPDATED : (0, $krYZG.ACTION).INSERTED;
                                                const skipAnalytics = (0, $4087fb88f9ced735$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
                                                const command = isEdit ? (0, $gjTdl.commandWithMetadata)((0, $1Ns7R.updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                    action: action,
                                                    inputMethod: inputMethod,
                                                    sourceEvent: analytic
                                                }) : (0, $1Ns7R.insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic, appearance);
                                                command(view.state, view.dispatch, view);
                                                view.focus();
                                            }
                                        }, idx);
                                        return isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3v5aK.UserIntentPopupWrapper), {
                                            api: pluginInjectionApi,
                                            children: Toolbar
                                        }) : Toolbar;
                                    }
                                }
                            ]
                        };
                    }
            }
        }
        return;
    };


const $574bf906e439c697$var$getPosFromActiveLinkMark = (state)=>{
    if (state === undefined) return undefined;
    switch(state.type){
        case 'EDIT':
        case 'EDIT_INSERTED':
            return state.pos;
        case 'INSERT':
            return undefined;
    }
};
const $574bf906e439c697$var$selectionToolbarLinkButtonTestId = 'ak-editor-selection-toolbar-link-button';
const $574bf906e439c697$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
    let primaryToolbarComponent;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $1fe817f7027c351a$export$91d5466719f8efb8)({
        api: api
    }));
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $1bfb365c933b9fd4$export$a758406ca53b86a5)(api));
    return {
        name: 'hyperlink',
        marks () {
            return [
                {
                    name: 'link',
                    mark: (0, $3uRAA.link)
                }
            ];
        },
        commands: {
            showLinkToolbar: (inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>(0, $1Ns7R.showLinkToolbar)(inputMethod, api?.analytics?.actions),
            updateLink: (href, text)=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $574bf906e439c697$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $1Ns7R.updateLinkEditorCommand)(href, text, pos);
            },
            removeLink: ()=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $574bf906e439c697$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $1Ns7R.removeLinkEditorCommand)(pos, api?.analytics?.actions);
            }
        },
        actions: {
            hideLinkToolbar: (0, $1Ns7R.hideLinkToolbarSetMeta),
            insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>(0, $1Ns7R.insertLinkWithAnalytics)(inputMethod, from, to, href, api?.card?.actions, api?.analytics?.actions, title, displayText, cardsAvailable, sourceEvent, appearance),
            updateLink: (0, $1Ns7R.updateLink)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $o2UQ9.stateKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'hyperlink',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $o2UQ9.plugin)(dispatch, getIntl(), options?.editorAppearance, api, options?.onClickCallback, // @ts-ignore Temporary solution to check for Live Page editor.
                        options.__livePage)
                },
                {
                    name: 'fakeCursorToolbarPlugin',
                    plugin: ()=>(0, $07c439e1e228556c$export$2e2bcd8739ae039)
                },
                {
                    name: 'hyperlinkInputRule',
                    plugin: ({ schema: schema })=>(0, $4cdb90caca6b6f28$export$dc83f374e2af640d)(schema, api?.analytics?.actions, options.autoLinkOnBlur)
                },
                {
                    name: 'hyperlinkKeymap',
                    plugin: ()=>(0, $cce89f36ab55f297$export$1d7b13ce0747fbd)(api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkToolbarButtons',
                    plugin: ()=>{
                        const hasCard = !!api?.card?.actions;
                        return (0, $4087fb88f9ced735$export$faf11097578346af)(hasCard ? {
                            skipAnalytics: true
                        } : undefined);
                    }
                }
            ];
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'hyperlink',
                            title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).link),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).linkDescription),
                            keywords: [
                                'hyperlink',
                                'url'
                            ],
                            priority: (0, $ieeJu.expValEquals)('confluence_quick_insert_embeds', 'cohort', 'prioritizeLinkInQIM', 'control') ? -300 : 1200,
                            keyshortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addLink)),
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconLink), {}),
                            action (insert, state) {
                                const tr = insert(undefined);
                                tr.setMeta((0, $o2UQ9.stateKey), {
                                    type: (0, $3mD3Q.LinkAction).SHOW_INSERT_TOOLBAR,
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                });
                                const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
                                    action: (0, $krYZG.ACTION).INVOKED,
                                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
                                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                    attributes: {
                                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $krYZG.EVENT_TYPE).UI
                                })(tr);
                                return analyticsAttached !== false ? tr : false;
                            }
                        }
                    ]
            },
            floatingToolbar: (0, $89be01139bde1e95$export$86ce8f8241c20a3)(options, api),
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: (state, { formatMessage: formatMessage })=>{
                    const toolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarButton = ()=>{
                            const { from: from, to: to } = state.selection;
                            const isEnabled = (0, $gid2f.canLinkBeCreatedInRange)(from, to)(state);
                            const title = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).link);
                            return {
                                type: 'button',
                                disabled: !isEnabled,
                                testId: `${$574bf906e439c697$var$selectionToolbarLinkButtonTestId}`,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
                                title: title,
                                tooltipContent: (0, $ldqjS.tooltip)((0, $ldqjS.addLink), title),
                                showTitle: false,
                                onClick: (state, dispatch)=>{
                                    return (0, $aC6bW.editorCommandToPMCommand)((0, $1Ns7R.showLinkToolbar)((0, $krYZG.INPUT_METHOD).FLOATING_TB, api?.analytics?.actions))(state, dispatch);
                                }
                            };
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarButton()
                            ],
                            rank: 2
                        };
                    } else return undefined;
                }
            },
            ...!isToolbarAIFCEnabled && {
                primaryToolbarComponent: !api?.primaryToolbar && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                }) ? primaryToolbarComponent : undefined
            }
        }
    };
};
module.exports["hyperlinkPlugin"] = $574bf906e439c697$export$8143923e8601d272;

});

parcelRegister("1Ns7R", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

var $eaCAt = parcelRequire("eaCAt");


var $2HZqG = parcelRequire("2HZqG");

var $gjTdl = parcelRequire("gjTdl");


var $eEdSM = parcelRequire("eEdSM");


var $IAZGS = parcelRequire("IAZGS");

var $3mD3Q = parcelRequire("3mD3Q");


var $aC6bW = parcelRequire("aC6bW");


var $4wRTw = parcelRequire("4wRTw");

var $hZrGN = parcelRequire("hZrGN");


var $kCECX = parcelRequire("kCECX");


var $o2UQ9 = parcelRequire("o2UQ9");

function $a48c16c135b300fe$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return ({ tr: tr })=>{
        if (!(0, $IAZGS.isTextAtPos)(pos)({
            tr: tr
        })) return null;
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        const linkMark = tr.doc.type.schema.marks.link;
        const mark = linkMark.isInSet(node.marks);
        const url = (0, $hZrGN.normalizeUrl)(href);
        if (mark && mark.attrs.href === url) return null;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        tr.removeMark(pos, rightBound, linkMark);
        if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
            ...mark && mark.attrs || {},
            href: url
        }));
        else editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.unlinkPayload)((0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        if (!isTabPressed) tr.setMeta((0, $o2UQ9.stateKey), {
            type: (0, $3mD3Q.LinkAction).HIDE_TOOLBAR
        });
        return tr;
    };
}
function $a48c16c135b300fe$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return (0, $aC6bW.editorCommandToPMCommand)($a48c16c135b300fe$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
}
function $a48c16c135b300fe$export$1f68f6e2d4509ef7(href, text, pos, to) {
    return ({ tr: tr })=>{
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        if (!node) return null;
        const url = (0, $hZrGN.normalizeUrl)(href);
        const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
        const linkMark = tr.doc.type.schema.marks.link;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        if (!url && text) {
            tr.removeMark(pos, rightBound, linkMark);
            tr.insertText(text, pos, rightBound);
        } else if (!url) return null;
        else {
            tr.insertText(text, pos, rightBound);
            // Casting to LinkAttributes to prevent wrong attributes been passed (Example ED-7951)
            const linkAttrs = {
                ...mark && mark.attrs || {},
                href: url
            };
            tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
            tr.setMeta((0, $o2UQ9.stateKey), {
                type: (0, $3mD3Q.LinkAction).HIDE_TOOLBAR
            });
        }
        return tr;
    };
}
function $a48c16c135b300fe$export$468bc07728835ac4(href, text, pos, to) {
    return (0, $aC6bW.editorCommandToPMCommand)($a48c16c135b300fe$export$1f68f6e2d4509ef7(href, text, pos, to));
}
function $a48c16c135b300fe$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
    return (state, dispatch)=>{
        const link = state.schema.marks.link;
        const { tr: tr } = state;
        if (incomingHref.trim()) {
            const normalizedUrl = (0, $hZrGN.normalizeUrl)(incomingHref);
            // NB: in this context, `currentText` represents text which has been
            // highlighted in the Editor, upon which a link is is being added.
            const currentText = (0, $o2UQ9.stateKey).getState(state)?.activeText;
            let markEnd = to;
            const text = displayText || incomingTitle || incomingHref;
            if (!displayText || displayText !== currentText) {
                tr.insertText(text, from, to);
                // new block created to wrap the link
                if (tr.mapping.map(from) === from + text.length + 2) // +1 is for the block's opening tag
                markEnd = from + text.length + 1;
                else markEnd = from + text.length;
            }
            tr.addMark(from, markEnd, link.create({
                href: normalizedUrl
            }));
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(markEnd)));
            if (!displayText || displayText === incomingHref) {
                const queueCardsFromChangedTr = cardApiActions?.queueCardsFromChangedTr;
                if (queueCardsFromChangedTr) queueCardsFromChangedTr?.(state, tr, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                source, (0, $krYZG.ACTION).INSERTED, false, sourceEvent, appearance);
                else (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                    action: (0, $krYZG.ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
            } else /**
				 * Add link metadata because queue cards would have otherwise handled this for us
				 */ (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                action: (0, $krYZG.ACTION).INSERTED,
                inputMethod: source,
                sourceEvent: sourceEvent
            });
            tr.setMeta((0, $o2UQ9.stateKey), {
                type: (0, $3mD3Q.LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        tr.setMeta((0, $o2UQ9.stateKey), {
            type: (0, $3mD3Q.LinkAction).HIDE_TOOLBAR
        });
        if (dispatch) dispatch(tr);
        return false;
    };
}
const $a48c16c135b300fe$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
    // If smart cards are available, we send analytics for hyperlinks when a smart link is rejected.
    if (cardsAvailable && !title && !displayText) return $a48c16c135b300fe$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
    return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, (0, $4wRTw.getLinkCreationAnalyticsEvent)(inputMethod, href))($a48c16c135b300fe$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
};
function $a48c16c135b300fe$export$91d8072017908bea(pos, editorAnalyticsApi) {
    return (0, $gjTdl.commandWithMetadata)($a48c16c135b300fe$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
        action: (0, $krYZG.ACTION).UNLINK
    });
}
function $a48c16c135b300fe$export$32e967ed59808fd(pos, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        $a48c16c135b300fe$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
            tr: tr
        });
        (0, $2HZqG.addLinkMetadata)(tr.selection, tr, {
            action: (0, $krYZG.ACTION).UNLINK
        });
        return tr;
    };
}
function $a48c16c135b300fe$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
    return (state, dispatch)=>{
        if (dispatch) {
            const { tr: tr } = state;
            tr.setMeta((0, $o2UQ9.stateKey), {
                type: (0, $3mD3Q.LinkAction).EDIT_INSERTED_TOOLBAR,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            });
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildEditLinkPayload)((0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
        return true;
    };
}
function $a48c16c135b300fe$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const newTr = tr.setMeta((0, $o2UQ9.stateKey), {
            type: (0, $3mD3Q.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: inputMethod
        });
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INVOKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        })(newTr);
        return newTr;
    };
}
function $a48c16c135b300fe$export$bd1cd60a9b31da5e() {
    return function(state, dispatch) {
        if (dispatch) dispatch($a48c16c135b300fe$export$534add8453a7a184(state.tr));
        return true;
    };
}
const $a48c16c135b300fe$export$534add8453a7a184 = (tr)=>{
    return tr.setMeta((0, $o2UQ9.stateKey), {
        type: (0, $3mD3Q.LinkAction).HIDE_TOOLBAR
    });
};
const $a48c16c135b300fe$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $a48c16c135b300fe$export$534add8453a7a184(tr);
        cardActions?.hideLinkToolbar?.(tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $a48c16c135b300fe$export$e72685a867c8a4f2 = (state, dispatch)=>{
    if (dispatch) {
        $a48c16c135b300fe$export$bd1cd60a9b31da5e()(state, dispatch);
        return true;
    }
    return false;
};
module.exports["updateLinkEditorCommand"] = $a48c16c135b300fe$export$1f68f6e2d4509ef7;
module.exports["updateLink"] = $a48c16c135b300fe$export$468bc07728835ac4;
module.exports["insertLinkWithAnalytics"] = $a48c16c135b300fe$export$61f4de3ecc2b935b;
module.exports["removeLink"] = $a48c16c135b300fe$export$91d8072017908bea;
module.exports["removeLinkEditorCommand"] = $a48c16c135b300fe$export$32e967ed59808fd;
module.exports["editInsertedLink"] = $a48c16c135b300fe$export$8eb8ea8f98f386b5;
module.exports["showLinkToolbar"] = $a48c16c135b300fe$export$83c364d103479f90;
module.exports["hideLinkToolbar"] = $a48c16c135b300fe$export$bd1cd60a9b31da5e;
module.exports["hideLinkToolbarSetMeta"] = $a48c16c135b300fe$export$534add8453a7a184;
module.exports["onEscapeCallback"] = $a48c16c135b300fe$export$34daa751a305794c;
module.exports["onClickAwayCallback"] = $a48c16c135b300fe$export$e72685a867c8a4f2;

});

parcelRegister("2HZqG", function(module, exports) {

var $73Kv0 = parcelRequire("73Kv0");

function $416a82f72cee0c30$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $73Kv0.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}
module.exports["addLinkMetadata"] = $416a82f72cee0c30$export$e2d4855dca88ecc1;

});

parcelRegister("73Kv0", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

var $5aU9U = parcelRequire("5aU9U");

const $da9581082711d091$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $da9581082711d091$export$2774298c489a128f = 'editor-linking-meta-invert';
class $da9581082711d091$export$40e33c9d27895078 extends (0, $5aU9U.Step) {
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $da9581082711d091$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $da9581082711d091$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    constructor(pos, metadata, isInverted = false){
        super(), this.pos = pos, this.metadata = metadata, this.isInverted = isInverted;
    }
}
/** Register this step with Prosemirror */ (0, $5aU9U.Step).jsonID($da9581082711d091$export$954e3f6aa93d9ba3, $da9581082711d091$export$40e33c9d27895078);
module.exports["LinkMetaStep"] = $da9581082711d091$export$40e33c9d27895078;

});

parcelRegister("gjTdl", function(module, exports) {

var $2HZqG = parcelRequire("2HZqG");


const $053a9df29ccc0b3f$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            (0, $2HZqG.addLinkMetadata)(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};
module.exports["commandWithMetadata"] = $053a9df29ccc0b3f$export$76125a95b70625ac;

});

parcelRegister("9bUBT", function(module, exports) {

var $9joJM = parcelRequire("9joJM");


var $fqVYq = parcelRequire("fqVYq");

const $52a435c85b296fb3$export$f0972e90f14682b1 = '/manage-profile/link-preferences';




const $13483fa4109ec76c$var$STAGING = 'staging';
const $13483fa4109ec76c$var$PRODUCTION = 'prod';
const $13483fa4109ec76c$var$DEV = 'dev';
const $13483fa4109ec76c$export$e5404273592f5dbd = ()=>{
    const envType = $13483fa4109ec76c$var$PRODUCTION;
    return (0, $9joJM.getUrlForDomainInContext)('id', envType) + (0, $52a435c85b296fb3$export$f0972e90f14682b1);
};
const $13483fa4109ec76c$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
const $13483fa4109ec76c$var$isEmptySelectionBeforeLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeAfter?.marks || []);
};
const $13483fa4109ec76c$var$isEmptySelectionAfterLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeBefore?.marks || []);
};
const $13483fa4109ec76c$var$isSelectionAroundLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    const node = $from.nodeAfter;
    return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
};
const $13483fa4109ec76c$export$819e108a65d33088 = (state)=>{
    const { selection: { $from: $from } } = state;
    if ($13483fa4109ec76c$var$isSelectionInsideLink(state) || $13483fa4109ec76c$var$isSelectionAroundLink(state)) {
        const pos = $from.pos - $from.textOffset;
        const node = state.doc.nodeAt(pos);
        return node && node.isText ? {
            node: node,
            pos: pos
        } : undefined;
    }
    if ($13483fa4109ec76c$var$isEmptySelectionBeforeLink(state) && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right before the link, we want to show the toolbar for the link
        // but only if the link is a single character
        const node = state.doc.nodeAt($from.pos);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos
        } : undefined;
    }
    if ($13483fa4109ec76c$var$isEmptySelectionAfterLink(state) && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right after the link, we want to show the toolbar for the link
        // but only if the link is a single character
        // and we return the position of the link
        const node = state.doc.nodeAt($from.pos - 1);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos - 1
        } : undefined;
    }
    return undefined;
};
module.exports["getLinkPreferencesURLFromENV"] = $13483fa4109ec76c$export$e5404273592f5dbd;
module.exports["getActiveLinkMark"] = $13483fa4109ec76c$export$819e108a65d33088;

});

parcelRegister("3FyXx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $794I6 = parcelRequire("794I6");














var $1enXm = parcelRequire("1enXm");


var $gBjHb = parcelRequire("gBjHb");


var $fuSOM = parcelRequire("fuSOM");





var $6pnwK = parcelRequire("6pnwK");










const $05d97dcd9358057a$export$886f2fdec3f419af = (0, $gtMdU.isReactCompilerActivePlatform)() ? (onEscape, onClickAway)=>{
    const $ = (0, $bDgLe.c)(4);
    const ref = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== onClickAway || $[1] !== onEscape) {
        t0 = ()=>{
            const handleClickAway = (event)=>{
                const el = ref.current;
                if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
            };
            const handleKeydown = (event_0)=>{
                if (event_0.key === "Escape") {
                    event_0.preventDefault();
                    onEscape();
                }
            };
            document.addEventListener("mousedown", handleClickAway);
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("mousedown", handleClickAway);
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        t1 = [
            onClickAway,
            onEscape
        ];
        $[0] = onClickAway;
        $[1] = onEscape;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return ref;
} : (onEscape, onClickAway)=>{
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const handleClickAway = (event)=>{
            const el = ref.current;
            if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
        };
        const handleKeydown = (event_0)=>{
            if (event_0.key === 'Escape') {
                event_0.preventDefault();
                onEscape();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', handleClickAway);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('mousedown', handleClickAway);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        onClickAway,
        onEscape
    ]);
    return ref;
};


const $20817bd4f5e2ccf8$var$PREVENT_SCROLL = {
    preventScroll: true
};
const $20817bd4f5e2ccf8$export$da2f76555f5c8d0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    let editorAppearance;
    let onCancel;
    let onClickAwayCallback;
    let onClose;
    let onEscapeCallback;
    let restProps;
    let t1;
    let view;
    if ($[0] !== t0) {
        ({ view: view, onCancel: onCancel, invokeMethod: t1, editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps } = t0);
        $[0] = t0;
        $[1] = editorAppearance;
        $[2] = onCancel;
        $[3] = onClickAwayCallback;
        $[4] = onClose;
        $[5] = onEscapeCallback;
        $[6] = restProps;
        $[7] = t1;
        $[8] = view;
    } else {
        editorAppearance = $[1];
        onCancel = $[2];
        onClickAwayCallback = $[3];
        onClose = $[4];
        onEscapeCallback = $[5];
        restProps = $[6];
        t1 = $[7];
        view = $[8];
    }
    const invokeMethod = t1 === undefined ? "_unknown" : t1;
    const onCloseRef = (0, $cozmU.useRef)(onClose);
    let t2;
    if ($[9] !== onClose) {
        t2 = ()=>{
            onCloseRef.current = onClose;
        };
        $[9] = onClose;
        $[10] = t2;
    } else t2 = $[10];
    (0, $cozmU.useEffect)(t2);
    let t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>()=>onCloseRef.current?.();
        t4 = [];
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[13] !== onCancel || $[14] !== onEscapeCallback || $[15] !== view) {
        t5 = ()=>{
            const { state: state, dispatch: dispatch } = view;
            onEscapeCallback?.(state, dispatch);
            onCancel?.();
        };
        $[13] = onCancel;
        $[14] = onEscapeCallback;
        $[15] = view;
        $[16] = t5;
    } else t5 = $[16];
    const onEscape = t5;
    let t6;
    if ($[17] !== onCancel || $[18] !== onClickAwayCallback || $[19] !== view) {
        t6 = ()=>{
            const { state: state_0, dispatch: dispatch_0 } = view;
            onClickAwayCallback?.(state_0, dispatch_0);
            onCancel?.();
        };
        $[17] = onCancel;
        $[18] = onClickAwayCallback;
        $[19] = view;
        $[20] = t6;
    } else t6 = $[20];
    const onClickAway = t6;
    const ref = (0, $05d97dcd9358057a$export$886f2fdec3f419af)(onEscape, onClickAway);
    let t7;
    if ($[21] !== editorAppearance) {
        t7 = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
        $[21] = editorAppearance;
        $[22] = t7;
    } else t7 = $[22];
    const analyticsEditorAppearance = t7;
    let t8;
    if ($[23] !== analyticsEditorAppearance || $[24] !== invokeMethod) {
        t8 = {
            invokeMethod: invokeMethod,
            location: analyticsEditorAppearance
        };
        $[23] = analyticsEditorAppearance;
        $[24] = invokeMethod;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== analyticsEditorAppearance || $[27] !== t8) {
        t9 = {
            attributes: t8,
            location: analyticsEditorAppearance
        };
        $[26] = analyticsEditorAppearance;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    const analyticsData = t9;
    let t10;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? $20817bd4f5e2ccf8$var$PREVENT_SCROLL : {
            preventScroll: true
        };
        $[29] = t10;
    } else t10 = $[29];
    const returnFocus = t10;
    let t11;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? $20817bd4f5e2ccf8$var$PREVENT_SCROLL : {
            preventScroll: true
        };
        $[30] = t11;
    } else t11 = $[30];
    const focusOptions = t11;
    if ((0, $ieeJu.expValEquals)("platform_editor_a11y_escape_link_dialog", "isEnabled", true)) {
        let t12;
        if ($[31] !== onEscape || $[32] !== restProps) {
            t12 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
                returnFocus: returnFocus,
                focusOptions: focusOptions,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fuSOM.default), {
                    ...restProps,
                    onCancel: onEscape
                })
            });
            $[31] = onEscape;
            $[32] = restProps;
            $[33] = t12;
        } else t12 = $[33];
        let t13;
        if ($[34] !== analyticsData || $[35] !== t12) {
            t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
                data: analyticsData,
                children: t12
            });
            $[34] = analyticsData;
            $[35] = t12;
            $[36] = t13;
        } else t13 = $[36];
        let t14;
        if ($[37] !== ref || $[38] !== t13) {
            t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: ref,
                children: t13
            });
            $[37] = ref;
            $[38] = t13;
            $[39] = t14;
        } else t14 = $[39];
        return t14;
    }
    let t12;
    if ($[40] !== onEscape || $[41] !== restProps) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fuSOM.default), {
            ...restProps,
            onCancel: onEscape
        });
        $[40] = onEscape;
        $[41] = restProps;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== analyticsData || $[44] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
            data: analyticsData,
            children: t12
        });
        $[43] = analyticsData;
        $[44] = t12;
        $[45] = t13;
    } else t13 = $[45];
    let t14;
    if ($[46] !== ref || $[47] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: ref,
            children: t13
        });
        $[46] = ref;
        $[47] = t13;
        $[48] = t14;
    } else t14 = $[48];
    return t14;
} : ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
    /**
   * Track onClose handler in a
   * ref so that we void needing it in the dependency array
   * below
   */ const onCloseRef = (0, $cozmU.useRef)(onClose);
    (0, $cozmU.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    /**
   * Call onClose on mount, usefull to provide
   * a handler for performing an action after the component has been
   * unmounted (e.g. return focus to the editors)
   */ (0, $cozmU.useEffect)(()=>()=>onCloseRef.current?.(), []);
    const onEscape = (0, $cozmU.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onEscapeCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onEscapeCallback
    ]);
    const onClickAway = (0, $cozmU.useCallback)(()=>{
        const { state: state_0, dispatch: dispatch_0 } = view;
        onClickAwayCallback?.(state_0, dispatch_0);
        onCancel?.();
    }, [
        view,
        onCancel,
        onClickAwayCallback
    ]);
    const ref = (0, $05d97dcd9358057a$export$886f2fdec3f419af)(onEscape, onClickAway);
    const analyticsEditorAppearance = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = (0, $cozmU.useMemo)(()=>({
            attributes: {
                invokeMethod: invokeMethod,
                location: analyticsEditorAppearance
            },
            // Below is added for the future implementation of Linking Platform namespaced analytic context
            location: analyticsEditorAppearance
        }), [
        invokeMethod,
        analyticsEditorAppearance
    ]);
    const returnFocus = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $20817bd4f5e2ccf8$var$PREVENT_SCROLL : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        preventScroll: true
    };
    const focusOptions = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $20817bd4f5e2ccf8$var$PREVENT_SCROLL : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        preventScroll: true
    };
    if ((0, $ieeJu.expValEquals)('platform_editor_a11y_escape_link_dialog', 'isEnabled', true)) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
            data: analyticsData,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
                returnFocus: returnFocus,
                focusOptions: focusOptions,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fuSOM.default), {
                    ...restProps,
                    onCancel: onEscape
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
            data: analyticsData,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fuSOM.default), {
                ...restProps,
                onCancel: onEscape
            })
        })
    });
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $55fM8 = parcelRequire("55fM8");


var $9kbTQ = parcelRequire("9kbTQ");





var $kSwu1 = parcelRequire("kSwu1");


var $9p0BY = parcelRequire("9p0BY");


var $lzgC6 = parcelRequire("lzgC6");


var $5avUB = parcelRequire("5avUB");


var $2qJQZ = parcelRequire("2qJQZ");


var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");





var $lpNn5 = parcelRequire("lpNn5");




var $fdQKX = parcelRequire("fdQKX");


var $k0VoZ = parcelRequire("k0VoZ");

var $6BleA = parcelRequire("6BleA");


var $hZrGN = parcelRequire("hZrGN");


var $8dxef = parcelRequire("8dxef");


var $kerfx = parcelRequire("kerfx");


var $clVvI = parcelRequire("clVvI");


var $iRydk = parcelRequire("iRydk");

function $4d2bb5483b9fe8db$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}



var $bzBji = parcelRequire("bzBji");


var $l0lnS = parcelRequire("l0lnS");

const $0e5a2ddc71b67b81$export$5091bdda49ba90f5 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($l0lnS))).createHash().update(input).digest('hex');
};











parcelRequire("cozmU");





var $iW3KC = parcelRequire("iW3KC");


var $fHe6f = parcelRequire("fHe6f");





var $bvjEB = parcelRequire("bvjEB");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");




const $747739eddc696f08$export$ecd9e62648c1046a = (0, $kSwu1.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh",
        defaultMessage: "Work Item"
    }
});





const $9c341b92afe17ea3$var$Issue16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { intl: intl } = props;
    let t0;
    if ($[0] !== intl) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $iDrrr.fg)("confluence-issue-terminology-refresh") ? (0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconIssueLabelIssueTermRefresh : (0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconIssueLabel;
            $[2] = t1;
        } else t1 = $[2];
        t0 = intl.formatMessage(t1);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[3] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $S7fVP.default), {
            label: t0
        });
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $S7fVP.default), {
        label: intl.formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconIssueLabelIssueTermRefresh : (0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconIssueLabel)
    });
};
const $9c341b92afe17ea3$var$Bug16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { intl: intl } = props;
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconBugLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fHe6f.default), {
            label: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fHe6f.default), {
        label: intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconBugLabel)
    });
};
const $9c341b92afe17ea3$var$Story16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { intl: intl } = props;
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconStoryLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bvjEB.default), {
            label: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bvjEB.default), {
        label: intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconStoryLabel)
    });
};
const $9c341b92afe17ea3$var$Task16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { intl: intl } = props;
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconTaskLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a5G9M.default), {
            label: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a5G9M.default), {
        label: intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconTaskLabel)
    });
};
const $9c341b92afe17ea3$var$Page16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { intl: intl } = props;
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconPageLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2qJQZ.default), {
            label: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2qJQZ.default), {
        label: intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconPageLabel)
    });
};
const $9c341b92afe17ea3$var$Blog16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { intl: intl } = props;
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconBlogLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iW3KC.default), {
            label: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iW3KC.default), {
        label: intl.formatMessage((0, $747739eddc696f08$export$ecd9e62648c1046a).hyperlinkIconBlogLabel)
    });
};
const $9c341b92afe17ea3$var$IntlIssue16Icon = (0, $kSwu1.injectIntl)($9c341b92afe17ea3$var$Issue16);
const $9c341b92afe17ea3$var$IntlBug16Icon = (0, $kSwu1.injectIntl)($9c341b92afe17ea3$var$Bug16);
const $9c341b92afe17ea3$var$IntlStory16Icon = (0, $kSwu1.injectIntl)($9c341b92afe17ea3$var$Story16);
const $9c341b92afe17ea3$var$IntlTask16Icon = (0, $kSwu1.injectIntl)($9c341b92afe17ea3$var$Task16);
const $9c341b92afe17ea3$var$IntlPage16Icon = (0, $kSwu1.injectIntl)($9c341b92afe17ea3$var$Page16);
const $9c341b92afe17ea3$var$IntlBlog16Icon = (0, $kSwu1.injectIntl)($9c341b92afe17ea3$var$Blog16);
const $9c341b92afe17ea3$export$80e948449ec854a9 = {
    'jira.issue': /*#__PURE__*/ (0, $8aG6j.jsx)($9c341b92afe17ea3$var$IntlIssue16Icon, {}),
    'jira.issue.bug': /*#__PURE__*/ (0, $8aG6j.jsx)($9c341b92afe17ea3$var$IntlBug16Icon, {}),
    'jira.issue.story': /*#__PURE__*/ (0, $8aG6j.jsx)($9c341b92afe17ea3$var$IntlStory16Icon, {}),
    'jira.issue.task': /*#__PURE__*/ (0, $8aG6j.jsx)($9c341b92afe17ea3$var$IntlTask16Icon, {}),
    'confluence.page': /*#__PURE__*/ (0, $8aG6j.jsx)($9c341b92afe17ea3$var$IntlPage16Icon, {}),
    'confluence.blogpost': /*#__PURE__*/ (0, $8aG6j.jsx)($9c341b92afe17ea3$var$IntlBlog16Icon, {})
};


const $5889646a02dd0a61$export$24d5ff955141c347 = (input)=>{
    return input.split(' ').length;
};


function $1dcf1f56cf573599$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1dcf1f56cf573599$export$8dd524ceb40e3d16 = {
    name: "19nbz8q",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
};
const $1dcf1f56cf573599$export$452f1062ecf44be7 = 5;
const $1dcf1f56cf573599$var$clearTextButtonStyles = (0, $buxP3.xcss)({
    padding: 'space.0',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none'
});
const $1dcf1f56cf573599$var$clearTextWrapper = {
    name: "154v9b4",
    styles: "position:absolute;right:0"
};
const $1dcf1f56cf573599$var$containerPadding = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
});
const $1dcf1f56cf573599$var$textLabelMargin = {
    name: "1s21os8",
    styles: "margin-top:var(--ds-space-150, 12px)"
};
const $1dcf1f56cf573599$var$inputLabel = {
    name: "oad2n7",
    styles: "color:var(--ds-text-subtlest, #6B6E76);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
};
const $1dcf1f56cf573599$var$inputWrapperPosition = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $1dcf1f56cf573599$var$defaultIcon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2qJQZ.default), {
    label: "page"
});
const $1dcf1f56cf573599$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
        objectId: objectId,
        name: name,
        container: container,
        iconUrl: iconUrl,
        url: url,
        lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
        prefetch: true
    });
const $1dcf1f56cf573599$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
        objectId: objectId,
        container: container,
        name: title,
        url: url,
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        icon: contentType && (0, $9c341b92afe17ea3$export$80e948449ec854a9)[contentType] || $1dcf1f56cf573599$var$defaultIcon,
        prefetch: false
    });
class $1dcf1f56cf573599$export$7acbf008e0847b89 extends (0, $cozmU.PureComponent) {
    async componentDidMount() {
        const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners, @atlaskit/platform/no-direct-document-usage
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fireAnalytics({
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                timesViewed: timesViewed ?? 0,
                searchSessionId: searchSessionId ?? '',
                trigger: inputMethod ?? ''
            },
            eventType: (0, $krYZG.EVENT_TYPE).SCREEN
        });
        const [activityProvider, searchProvider] = await Promise.all([
            this.props.activityProvider,
            this.props.searchProvider
        ]);
        // loadInitialLinkSearchResult and updateInput rely on activityProvider being set in state
        (0, $9kbTQ.flushSync)(()=>this.setState({
                activityProvider: activityProvider,
                searchProvider: searchProvider
            }));
        await this.loadInitialLinkSearchResult();
    }
    componentWillUnmount() {
        const { searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners, @atlaskit/platform/no-direct-document-usage
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (!this.submitted) this.fireAnalytics({
            action: (0, $krYZG.ACTION).DISMISSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                source: this.analyticSource,
                searchSessionId: searchSessionId ?? '',
                trigger: 'blur'
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    }
    async getRecentItems(activityProvider, query) {
        const { searchSessionId: searchSessionId } = this.props;
        const perfStart = performance.now();
        try {
            const activityRecentItems = $1dcf1f56cf573599$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
            const items = activityRecentItems.map($1dcf1f56cf573599$var$mapActivityProviderResultToLinkSearchItemData);
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $krYZG.ACTION).INVOKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: items.length
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            this.fireAnalytics({
                action: (0, $krYZG.ACTION).SHOWN,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                attributes: {
                    source: this.analyticSource,
                    preQueryRequestDurationMs: duration,
                    searchSessionId: searchSessionId ?? '',
                    resultCount: items.length,
                    results: activityRecentItems.map((item)=>({
                            resultContentId: item.objectId,
                            resultType: item.type ?? ''
                        }))
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            });
            return items;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $krYZG.ACTION).INVOKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: -1,
                    errorCode: err.status
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return [];
        }
    }
    fireAnalytics(payload) {
        if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: payload
        });
    }
    async loadInitialLinkSearchResult() {
        const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
        try {
            if (!displayUrl && activityProvider) {
                this.setState({
                    isLoading: true
                });
                const items = await this.getRecentItems(activityProvider);
                this.setState({
                    items: items
                });
            }
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    render() {
        const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const formatClearLinkText = formatMessage((0, $bzBji.messages).clearLink);
        const screenReaderDescriptionId = 'search-recent-links-field-description';
        const linkSearchListId = 'hyperlink-search-list';
        const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
        const linkSearchInputId = 'search-recent-links-field-id';
        const displayTextInputId = 'display-text-filed-id';
        const browser = (0, $8dxef.getBrowserInfo)();
        // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
        // as the Aria design pattern for combobox does not work in this case
        // for details: https://a11y-internal.atlassian.net/browse/AK-740
        const screenReaderText = browser.safari && this.getScreenReaderText();
        const hyperlinkElement = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "aria-label": formatMessage((0, $bzBji.messages).hyperlinkAriaLabel),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "recent-list",
            "data-testid": "hyperlink-add-toolbar"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $clVvI.container),
                (0, $clVvI.narrowContainerWidth),
                $1dcf1f56cf573599$var$containerPadding
            ],
            ref: this.wrapperRef
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("label", {
            htmlFor: linkSearchInputId,
            css: $1dcf1f56cf573599$var$inputLabel
        }, formatMessage((0, $bzBji.messages).linkVisibleLabel)), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                (0, $clVvI.inputWrapper),
                $1dcf1f56cf573599$var$inputWrapperPosition
            ]
        }, screenReaderText && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $k0VoZ.default), {
            ariaLive: "assertive",
            text: screenReaderText,
            ariaRelevant: "additions",
            delay: 250
        }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $1dcf1f56cf573599$export$8dd524ceb40e3d16,
            "aria-hidden": "true",
            id: screenReaderDescriptionId
        }, formatMessage((0, $bzBji.messages).searchLinkAriaDescription)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6BleA.default), {
            role: "combobox",
            ariaExpanded: items && items.length > 0 && !isLoading,
            ariaActiveDescendant: ariaActiveDescendant,
            ariaControls: linkSearchListId,
            ariaAutoComplete: true,
            describedById: screenReaderDescriptionId,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (ele)=>this.urlInputContainer = ele,
            testId: 'link-url',
            onSubmit: this.handleSubmit,
            onChange: this.updateInput,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            autoFocus: {
                preventScroll: true
            },
            onCancel: this.handleCancel,
            defaultValue: displayUrl,
            onKeyDown: this.handleKeyDown,
            inputId: linkSearchInputId
        }), displayUrl && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $1dcf1f56cf573599$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: formatClearLinkText
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kh0hi.Pressable), {
            xcss: $1dcf1f56cf573599$var$clearTextButtonStyles,
            onClick: this.handleClearText
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: formatClearLinkText,
            color: "var(--ds-icon-subtle, #505258)"
        }))))), /*#__PURE__*/ (0, $lOiVq.jsx)("label", {
            htmlFor: displayTextInputId,
            css: [
                $1dcf1f56cf573599$var$inputLabel,
                $1dcf1f56cf573599$var$textLabelMargin
            ]
        }, formatMessage((0, $bzBji.messages).textVisibleLabel)), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                (0, $clVvI.inputWrapper),
                $1dcf1f56cf573599$var$inputWrapperPosition
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6BleA.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (ele)=>this.displayTextInputContainer = ele,
            testId: 'link-text',
            onChange: this.updateTextInput,
            onCancel: this.handleCancel,
            defaultValue: displayText,
            onSubmit: this.handleSubmit,
            onKeyDown: this.handleKeyDown,
            inputId: displayTextInputId
        }), displayText && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $1dcf1f56cf573599$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: formatMessage((0, $bzBji.messages).clearText)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kh0hi.Pressable), {
            xcss: $1dcf1f56cf573599$var$clearTextButtonStyles,
            onClick: this.handleClearDisplayText,
            onKeyDown: this.handleClearTextKeyDown
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: formatMessage((0, $bzBji.messages).clearText),
            color: "var(--ds-icon-subtle, #505258)"
        }))))), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $1dcf1f56cf573599$export$8dd524ceb40e3d16,
            "aria-live": "polite",
            "aria-atomic": "true",
            id: "fabric.editor.hyperlink.suggested.results"
        }, displayUrl && formatMessage((0, $bzBji.messages).searchLinkResults, {
            count: items.length
        })), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kerfx.default), {
            ariaControls: "fabric.editor.hyperlink.suggested.results",
            id: linkSearchListId,
            role: "listbox",
            items: items,
            isLoading: isLoading,
            selectedIndex: selectedIndex,
            listItemRefCallback: this.listItemRefCallback,
            onFocus: this.handleListItemFocus,
            onBlur: this.handleListItemBlur,
            onKeyDown: this.handleKeyDown,
            onSelect: this.handleSelected,
            onMouseEnter: this.handleMouseEnterResultItem,
            onMouseLeave: this.handleMouseLeaveResultItem
        })));
        if ((0, $ieeJu.expValEquals)('platform_editor_a11y_escape_link_dialog', 'isEnabled', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1enXm.default), {
            returnFocus: {
                preventScroll: true
            },
            focusOptions: {
                preventScroll: true
            }
        }, hyperlinkElement));
        return hyperlinkElement;
    }
    constructor(props){
        super(props);
        /* To prevent double submit */ this.submitted = false;
        this.urlInputContainer = null;
        this.displayTextInputContainer = null;
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.listItemRefs = {
            current: {}
        };
        this.handleClearText = void 0;
        this.handleClearDisplayText = void 0;
        this.debouncedQuickSearch = void 0;
        this.fireCustomAnalytics = void 0;
        this.quickSearchQueryVersion = 0;
        this.analyticSource = 'createLinkInlineDialog';
        this.quickSearch = async (input, items, quickSearchLimit)=>{
            const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
            const { searchSessionId: searchSessionId } = this.props;
            if (!searchProvider) return;
            const queryVersion = ++this.quickSearchQueryVersion;
            this.fireAnalytics({
                action: (0, $krYZG.ACTION).ENTERED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                attributes: {
                    queryLength: input.length,
                    queryVersion: queryVersion,
                    queryHash: (0, $0e5a2ddc71b67b81$export$5091bdda49ba90f5)(input),
                    searchSessionId: searchSessionId ?? '',
                    wordCount: (0, $5889646a02dd0a61$export$24d5ff955141c347)(input),
                    source: this.analyticSource
                },
                nonPrivacySafeAttributes: {
                    query: input
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            });
            const perfStart = performance.now();
            try {
                const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                const searchItems = $1dcf1f56cf573599$var$limit((0, $4d2bb5483b9fe8db$export$8437fc55448c6e05)([
                    ...items,
                    ...searchProviderResultItems.map($1dcf1f56cf573599$var$mapSearchProviderResultToLinkSearchItemData)
                ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                    items: searchItems,
                    isLoading: false
                });
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $krYZG.ACTION).INVOKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: searchProviderResultItems.length
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, $krYZG.ACTION).SHOWN,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        postQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: searchProviderResultItems.length,
                        results: searchProviderResultItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.contentType
                            }))
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $krYZG.ACTION).INVOKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                });
            }
        };
        this.updateInput = async (input)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
            this.setState({
                displayUrl: input
            });
            if (activityProvider) {
                if (input.length === 0) this.setState({
                    items: await this.getRecentItems(activityProvider),
                    selectedIndex: -1
                });
                else if ((0, $9p0BY.isSafeUrl)(input)) this.setState({
                    items: [],
                    selectedIndex: -1,
                    isLoading: false
                });
                else {
                    const items = await this.getRecentItems(activityProvider, input);
                    const shouldQuerySearchProvider = items.length < $1dcf1f56cf573599$export$452f1062ecf44be7 && !!searchProvider;
                    this.setState({
                        items: items,
                        isLoading: shouldQuerySearchProvider
                    });
                    if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $1dcf1f56cf573599$export$452f1062ecf44be7);
                }
            }
        };
        this.createClearHandler = (field)=>{
            return async ()=>{
                const { activityProvider: activityProvider } = this.state;
                switch(field){
                    case 'displayUrl':
                        this.setState({
                            [field]: '',
                            items: !!activityProvider ? $1dcf1f56cf573599$var$limit(await activityProvider.getRecentItems()) : []
                        });
                        if (this.urlInputContainer) this.urlInputContainer.focus();
                        break;
                    case 'displayText':
                        this.setState({
                            [field]: ''
                        });
                        if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                }
            };
        };
        this.handleClickOutside = (event)=>{
            if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                onClickAwayCallback?.(state, dispatch);
            }
        };
        this.getScreenReaderText = ()=>{
            const { intl: intl } = this.props;
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (items.length && selectedIndex > -1) {
                const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                const date = (0, $iRydk.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                return `${name}, ${container}, ${date?.pageAction} ${date?.dateString} ${date?.timeSince || ''}`;
            }
        };
        this.listItemRefCallback = (el, id)=>{
            if (!this.listItemRefs.current) return;
            if (el === null) delete this.listItemRefs.current[id];
            else this.listItemRefs.current[id] = el;
        };
        this.isUrlPopulatedWithSelectedItem = ()=>{
            /**
       * When we use ArrowKey to navigate through result items,
       * the URL field will be populated with the content of
       * selected item.
       * This function will check if the URL field is populated
       * with selected item.
       * It can be useful to detect whether we want to insert a
       * smartlink or a hyperlink with customized title
       */ const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
            const selectedItem = items[selectedIndex];
            if (selectedItem && selectedItem.url === displayUrl) return true;
            return false;
        };
        this.handleSelected = (href, text)=>{
            this.handleInsert(href, text, (0, $krYZG.INPUT_METHOD).TYPEAHEAD, 'click');
        };
        this.handleInsert = (href, title, inputType, interaction)=>{
            const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
            const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
            if (onSubmit) {
                this.submitted = true;
                onSubmit(href, title, displayText, inputType);
            }
            if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                /**
         * When it's a mouse click even or the selectedItem.url matches displayUrl, we think
         * it's selected from the result list and fire the
         * analytic
         */ const selectedItem = items[selectedIndex];
                this.fireAnalytics({
                    action: (0, $krYZG.ACTION).SELECTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        trigger: interaction,
                        resultCount: items.length,
                        selectedResultId: selectedItem.objectId,
                        selectedRelativePosition: selectedIndex,
                        prefetch: selectedItem.prefetch ?? false
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
            }
        };
        this.handleMouseEnterResultItem = (objectId)=>{
            const { items: items } = this.state;
            const index = $1dcf1f56cf573599$var$findIndex(items, (item)=>item.objectId === objectId);
            this.setState({
                selectedIndex: index
            });
        };
        this.handleMouseLeaveResultItem = (objectId)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const index = $1dcf1f56cf573599$var$findIndex(items, (item)=>item.objectId === objectId);
            // This is to avoid updating index that was set by other mouseenter event
            if (selectedIndex === index) this.setState({
                selectedIndex: -1
            });
        };
        this.handleSubmit = ()=>{
            const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
            const selectedItem = items[selectedIndex];
            if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, $hZrGN.normalizeUrl)(selectedItem.url), selectedItem.name, (0, $krYZG.INPUT_METHOD).TYPEAHEAD, 'keyboard');
            else if (displayUrl && displayUrl.length > 0) {
                const url = (0, $hZrGN.normalizeUrl)(displayUrl);
                if (url) this.handleInsert(url, displayUrl, (0, $krYZG.INPUT_METHOD).MANUAL, 'notselected');
            }
        };
        this.handleClearTextKeyDown = (event)=>{
            const KEY_CODE_TAB = 9;
            const { keyCode: keyCode } = event;
            if (keyCode === KEY_CODE_TAB) {
                /** If there are items in the list, allow normal tabbing so focus moves to the next interactive element (in this case, a search result item).
         */ if (this.state.items.length > 0) return;
                if (!this.submitted) {
                    const { displayUrl: displayUrl, displayText: displayText } = this.state;
                    const url = (0, $hZrGN.normalizeUrl)(displayUrl);
                    this.handleInsert(url, displayText || displayUrl, (0, $krYZG.INPUT_METHOD).MANUAL, 'notselected');
                }
                event.preventDefault();
                return;
            }
        };
        this.handleListItemFocus = (index)=>{
            this.setState({
                selectedIndex: index
            });
        };
        this.handleListItemBlur = ()=>{
            this.setState({
                selectedIndex: -1
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (event)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
            const { keyCode: keyCode } = event;
            const KEY_CODE_ESCAPE = 27;
            const KEY_CODE_ARROW_DOWN = 40;
            const KEY_CODE_ARROW_UP = 38;
            if (keyCode === KEY_CODE_ESCAPE) {
                // escape
                event.preventDefault();
                const { state: state, dispatch: dispatch } = view;
                onEscapeCallback?.(state, dispatch);
                return;
            }
            if (!items || !items.length) return;
            let updatedIndex = selectedIndex;
            if (keyCode === KEY_CODE_ARROW_DOWN) {
                // down
                event.preventDefault();
                updatedIndex = (selectedIndex + 1) % items.length;
            } else if (keyCode === KEY_CODE_ARROW_UP) {
                // up
                event.preventDefault();
                updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
            }
            if ([
                KEY_CODE_ARROW_DOWN,
                KEY_CODE_ARROW_UP
            ].includes(keyCode) && items[updatedIndex]) {
                if (this.listItemRefs.current) this.listItemRefs.current[items[updatedIndex].objectId]?.focus();
                this.setState({
                    selectedIndex: updatedIndex,
                    displayUrl: items[updatedIndex].url
                });
                this.fireAnalytics({
                    action: (0, $krYZG.ACTION).HIGHLIGHTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        selectedResultId: items[updatedIndex].objectId,
                        selectedRelativePosition: updatedIndex
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
            }
        };
        this.updateTextInput = (displayText)=>{
            this.setState({
                displayText: displayText
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleCancel = (e)=>{
            const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
            e.preventDefault();
            onClickAwayCallback?.(state, dispatch);
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            displayUrl: (0, $hZrGN.normalizeUrl)(props.displayUrl),
            displayText: props.displayText,
            items: []
        };
        /* Cache functions */ this.handleClearText = this.createClearHandler('displayUrl');
        this.handleClearDisplayText = this.createClearHandler('displayText');
        this.debouncedQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.quickSearch, 400);
        this.fireCustomAnalytics = (0, $fdQKX.fireAnalyticsEvent)(props.createAnalyticsEvent);
    }
}
function $1dcf1f56cf573599$var$findIndex(array, predicate) {
    let index = -1;
    array.some((item, i)=>{
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $1dcf1f56cf573599$var$limit(items) {
    return items.slice(0, $1dcf1f56cf573599$export$452f1062ecf44be7);
}
const $1dcf1f56cf573599$export$527bb787d3e8324e = (0, $kSwu1.injectIntl)($1dcf1f56cf573599$export$7acbf008e0847b89);
const $1dcf1f56cf573599$var$_default_1 = (0, $lzgC6.default)()($1dcf1f56cf573599$export$527bb787d3e8324e);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1dcf1f56cf573599$export$2e2bcd8739ae039 = $1dcf1f56cf573599$var$_default_1;


const $76cf0d4e6a67b462$var$HYPERLINK_PROVIDERS = [
    'activityProvider',
    'searchProvider'
];
/**
 * Wraps around the editor's onSubmit handler so that the plugin can interface with the link picker
 */ const $76cf0d4e6a67b462$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
        onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, $krYZG.INPUT_METHOD).MANUAL : (0, $krYZG.INPUT_METHOD).TYPEAHEAD, analytic, meta.appearance);
    };
const $76cf0d4e6a67b462$export$8be6a38cd66ace65 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HyperlinkAddToolbar(t0) {
    const $ = (0, $bDgLe.c)(46);
    const { linkPickerOptions: t1, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed, isOffline: isOffline } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let linkPickerOptions;
    if ($[2] !== t2) {
        const { popupWidth: _popupWidth, popupHeight: _popupHeight, ...t3 } = t2;
        linkPickerOptions = t3;
        $[2] = t2;
        $[3] = linkPickerOptions;
    } else linkPickerOptions = $[3];
    let t3;
    if ($[4] !== onSubmit) {
        t3 = $76cf0d4e6a67b462$var$onSubmitInterface(onSubmit);
        $[4] = onSubmit;
        $[5] = t3;
    } else t3 = $[5];
    const memoizedOnSubmitWithInterface = t3;
    let t4;
    if ($[6] !== displayText || $[7] !== displayUrl || $[8] !== editorAppearance || $[9] !== inputMethod || $[10] !== invokeMethod || $[11] !== isOffline || $[12] !== linkPickerOptions || $[13] !== lpLinkPicker || $[14] !== memoizedOnSubmitWithInterface || $[15] !== onCancel || $[16] !== onClickAwayCallback || $[17] !== onClose || $[18] !== onEscapeCallback || $[19] !== onSubmit || $[20] !== searchSessionId || $[21] !== timesViewed || $[22] !== view) {
        t4 = (t5)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = t5;
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $20817bd4f5e2ccf8$export$da2f76555f5c8d0a), {
                view: view,
                invokeMethod: invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: memoizedOnSubmitWithInterface,
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dcf1f56cf573599$export$2e2bcd8739ae039), {
                activityProvider: activityProvider,
                searchProvider: searchProvider,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        };
        $[6] = displayText;
        $[7] = displayUrl;
        $[8] = editorAppearance;
        $[9] = inputMethod;
        $[10] = invokeMethod;
        $[11] = isOffline;
        $[12] = linkPickerOptions;
        $[13] = lpLinkPicker;
        $[14] = memoizedOnSubmitWithInterface;
        $[15] = onCancel;
        $[16] = onClickAwayCallback;
        $[17] = onClose;
        $[18] = onEscapeCallback;
        $[19] = onSubmit;
        $[20] = searchSessionId;
        $[21] = timesViewed;
        $[22] = view;
        $[23] = t4;
    } else t4 = $[23];
    const memoizedRenderNode = t4;
    let t5;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? $76cf0d4e6a67b462$var$HYPERLINK_PROVIDERS : [
            "activityProvider",
            "searchProvider"
        ];
        $[24] = t5;
    } else t5 = $[24];
    const providers = t5;
    let t6;
    if ($[25] !== displayText || $[26] !== displayUrl || $[27] !== editorAppearance || $[28] !== inputMethod || $[29] !== invokeMethod || $[30] !== isOffline || $[31] !== linkPickerOptions || $[32] !== lpLinkPicker || $[33] !== memoizedRenderNode || $[34] !== onCancel || $[35] !== onClickAwayCallback || $[36] !== onClose || $[37] !== onEscapeCallback || $[38] !== onSubmit || $[39] !== searchSessionId || $[40] !== timesViewed || $[41] !== view) {
        t6 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? memoizedRenderNode : (t7)=>{
            const { activityProvider: activityProvider_0, searchProvider: searchProvider_0 } = t7;
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $20817bd4f5e2ccf8$export$da2f76555f5c8d0a), {
                view: view,
                invokeMethod: invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $76cf0d4e6a67b462$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dcf1f56cf573599$export$2e2bcd8739ae039), {
                activityProvider: activityProvider_0,
                searchProvider: searchProvider_0,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        };
        $[25] = displayText;
        $[26] = displayUrl;
        $[27] = editorAppearance;
        $[28] = inputMethod;
        $[29] = invokeMethod;
        $[30] = isOffline;
        $[31] = linkPickerOptions;
        $[32] = lpLinkPicker;
        $[33] = memoizedRenderNode;
        $[34] = onCancel;
        $[35] = onClickAwayCallback;
        $[36] = onClose;
        $[37] = onEscapeCallback;
        $[38] = onSubmit;
        $[39] = searchSessionId;
        $[40] = timesViewed;
        $[41] = view;
        $[42] = t6;
    } else t6 = $[42];
    let t7;
    if ($[43] !== providerFactory || $[44] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
            providers: providers,
            providerFactory: providerFactory,
            renderNode: t6
        });
        $[43] = providerFactory;
        $[44] = t6;
        $[45] = t7;
    } else t7 = $[45];
    return t7;
} : function HyperlinkAddToolbar({ linkPickerOptions: { popupWidth: _popupWidth, popupHeight: _popupHeight, ...linkPickerOptions } = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed, isOffline: isOffline }) {
    const memoizedOnSubmitWithInterface = (0, $cozmU.useMemo)(()=>$76cf0d4e6a67b462$var$onSubmitInterface(onSubmit), [
        onSubmit
    ]);
    const memoizedRenderNode = (0, $cozmU.useCallback)(({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
        // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
        // EditorLinkPicker into the bundle
        if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $20817bd4f5e2ccf8$export$da2f76555f5c8d0a), {
            view: view,
            invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
            // is being used from inside the hyperlink plugin and use inputMethod from plugin state
            invokeMethod ?? inputMethod,
            editorAppearance: editorAppearance,
            ...linkPickerOptions,
            url: displayUrl,
            displayText: displayText,
            onSubmit: memoizedOnSubmitWithInterface,
            onCancel: onCancel,
            onClose: onClose,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dcf1f56cf573599$export$2e2bcd8739ae039), {
            activityProvider: activityProvider,
            searchProvider: searchProvider,
            onSubmit: onSubmit,
            displayText: displayText,
            displayUrl: displayUrl,
            view: view,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback,
            inputMethod: inputMethod,
            searchSessionId: searchSessionId,
            timesViewed: timesViewed
        });
    }, [
        lpLinkPicker,
        isOffline,
        view,
        invokeMethod,
        inputMethod,
        editorAppearance,
        linkPickerOptions,
        displayUrl,
        displayText,
        onSubmit,
        memoizedOnSubmitWithInterface,
        onCancel,
        onClose,
        onEscapeCallback,
        onClickAwayCallback,
        searchSessionId,
        timesViewed
    ]);
    const providers = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $76cf0d4e6a67b462$var$HYPERLINK_PROVIDERS : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    [
        'activityProvider',
        'searchProvider'
    ];
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
        providers: providers,
        providerFactory: providerFactory,
        renderNode: (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedRenderNode : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
        ({ activityProvider: activityProvider_0, searchProvider: searchProvider_0 })=>{
            // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
            // EditorLinkPicker into the bundle
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $20817bd4f5e2ccf8$export$da2f76555f5c8d0a), {
                view: view,
                invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
                // is being used from inside the hyperlink plugin and use inputMethod from plugin state
                invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $76cf0d4e6a67b462$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dcf1f56cf573599$export$2e2bcd8739ae039), {
                activityProvider: activityProvider_0,
                searchProvider: searchProvider_0,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        }
    });
};
module.exports["HyperlinkAddToolbar"] = $76cf0d4e6a67b462$export$8be6a38cd66ace65;

});

parcelRegister("6BleA", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $8dxef = parcelRequire("8dxef");


var $i94vj = parcelRequire("i94vj");

const $6b2af886cb998310$var$KeyZCode = 90;
const $6b2af886cb998310$var$KeyYCode = 89;
class $6b2af886cb998310$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
            value: this.props.defaultValue
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusTimeoutId);
    }
    render() {
        const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $i94vj.panelTextInput),
                width !== undefined && (0, $i94vj.panelTextInputWithCustomWidth)(width)
            ],
            role: role,
            "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-activedescendant": ariaActiveDescendant,
            "aria-describedby": describedById,
            "data-testid": testId || '',
            type: "text",
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onKeyDown: this.handleKeydown,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            ref: this.handleRef,
            maxLength: maxLength,
            "aria-label": ariaLabel,
            "aria-required": this.props?.ariaRequired,
            "aria-invalid": this.props?.ariaInvalid,
            id: inputId
        });
    }
    focus() {
        const { input: input } = this;
        if (input) {
            const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isUndoEvent(event) {
        const browser = (0, $8dxef.getBrowserInfo)();
        return event.keyCode === $6b2af886cb998310$var$KeyZCode && // cmd + z for mac
        (browser.mac && event.metaKey && !event.shiftKey || // ctrl + z for non-mac
        !browser.mac && event.ctrlKey);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isRedoEvent(event) {
        const browser = (0, $8dxef.getBrowserInfo)();
        return(// ctrl + y for non-mac
        !browser.mac && event.ctrlKey && event.keyCode === $6b2af886cb998310$var$KeyYCode || browser.mac && event.metaKey && event.shiftKey && event.keyCode === $6b2af886cb998310$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $6b2af886cb998310$var$KeyZCode);
    }
    constructor(props){
        super(props);
        this.input = void 0;
        this.focusTimeoutId = void 0;
        this.onMouseDown = ()=>{
            const { onMouseDown: onMouseDown } = this.props;
            if (onMouseDown) onMouseDown();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        };
        this.handleChange = ()=>{
            const { onChange: onChange } = this.props;
            if (this.input) this.setState({
                value: this.input.value
            });
            if (onChange && this.input) onChange(this.input.value);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeydown = (e)=>{
            const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onSubmit(this.input.value);
            } else if (e.keyCode === 27 && onCancel) onCancel(e);
            else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        };
        this.handleRef = (input)=>{
            if (input instanceof HTMLInputElement) {
                this.input = input;
                if (this.props.autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                this.focusTimeoutId = window.setTimeout(()=>this.focus());
            } else this.input = undefined;
        };
        this.state = {
            value: props.defaultValue || ''
        };
    }
}
module.exports["default"] = $6b2af886cb998310$export$2e2bcd8739ae039;

});

parcelRegister("kerfx", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $lfoFx = parcelRequire("lfoFx");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");





var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");




const $7d99001521f01276$var$messages = (0, $kSwu1.defineMessages)({
    story: {
        id: "fabric.editor.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.editor.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.editor.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.editor.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.editor.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.editor.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.editor.defaultAltText",
        defaultMessage: "Document"
    }
});
const $7d99001521f01276$export$ac1fda7301622804 = (iconUrl, intl)=>{
    let alt = intl.formatMessage($7d99001521f01276$var$messages.defaultAltText);
    if (iconUrl.includes('story.svg')) alt = intl.formatMessage($7d99001521f01276$var$messages.story);
    if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($7d99001521f01276$var$messages.epic);
    if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($7d99001521f01276$var$messages.task);
    if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($7d99001521f01276$var$messages.bug);
    if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($7d99001521f01276$var$messages.subTask);
    if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($7d99001521f01276$var$messages.improvement);
    return alt;
};



var $iRydk = parcelRequire("iRydk");

function $5284e4863985ef82$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5284e4863985ef82$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $lOiVq.css)({
    backgroundColor: 'transparent',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    cursor: 'pointer',
    display: 'flex',
    marginTop: 0
});
const $5284e4863985ef82$export$624ac72e8eeb8e3d = {
    name: "172qvh2",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #0515240F)"
};
const $5284e4863985ef82$var$nameWrapper = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $5284e4863985ef82$export$d6a1b4d10134b7d7 = {
    name: "15va48x",
    styles: "color:var(--ds-text, #292A2E);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
};
const $5284e4863985ef82$export$ff1446d682f75fb9 = /*#__PURE__*/ (0, $lOiVq.css)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(11)
});
const $5284e4863985ef82$var$iconStyle = {
    name: "r2c2s1",
    styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
};
const $5284e4863985ef82$var$LinkSearchListItem = (props, ref)=>{
    const { id: id, item: item, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onSelect: onSelect, selected: selected, intl: intl } = props;
    const handleSelect = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault(); // don't let editor lose focus
        onSelect(item.url, item.name);
    }, [
        onSelect,
        item.url,
        item.name
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter') onSelect(item.url, item.name);
        onKeyDown?.(event);
    }, [
        onSelect,
        onKeyDown,
        item.url,
        item.name
    ]);
    const handleMouseMove = (0, $cozmU.useCallback)(()=>{
        onMouseMove?.(item.objectId);
    }, [
        onMouseMove,
        item.objectId
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        onMouseEnter?.(item.objectId);
    }, [
        onMouseEnter,
        item.objectId
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        onMouseLeave?.(item.objectId);
    }, [
        onMouseLeave,
        item.objectId
    ]);
    const renderIcon = ()=>{
        if (item.icon) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: $5284e4863985ef82$var$iconStyle
        }, item.icon);
        if (item.iconUrl) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: $5284e4863985ef82$var$iconStyle
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("img", {
            src: item.iconUrl,
            alt: (0, $7d99001521f01276$export$ac1fda7301622804)(item.iconUrl, intl)
        }));
        return null;
    };
    const renderTimeStamp = ()=>{
        const date = (0, $iRydk.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
        return date && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, "\xa0 \u2022", /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "link-search-timestamp",
            "data-testid": "link-search-timestamp"
        }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        css: [
            $5284e4863985ef82$export$34e0f9847d4c02dd,
            selected && $5284e4863985ef82$export$624ac72e8eeb8e3d
        ],
        role: 'option',
        tabIndex: 0,
        id: id,
        "aria-selected": selected,
        "data-testid": "link-search-list-item",
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onBlur : undefined,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        onMouseMove: handleMouseMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleSelect
    }, renderIcon(), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $5284e4863985ef82$var$nameWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $5284e4863985ef82$export$d6a1b4d10134b7d7
    }, item.name), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "link-search-list-item-container",
        css: $5284e4863985ef82$export$ff1446d682f75fb9
    }, item.container, renderTimeStamp())));
};
const $5284e4863985ef82$var$ForwardedLinkSearchListItem = /*#__PURE__*/ (0, $cozmU.forwardRef)($5284e4863985ef82$var$LinkSearchListItem);
const $5284e4863985ef82$export$1896ba66c9a2c53b = (0, $kSwu1.injectIntl)($5284e4863985ef82$var$ForwardedLinkSearchListItem, {
    forwardRef: true
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5284e4863985ef82$export$2e2bcd8739ae039 = $5284e4863985ef82$export$1896ba66c9a2c53b;


function $0a02a0130e304795$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0a02a0130e304795$var$listContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    paddingTop: 0,
    marginTop: "var(--ds-space-150, 12px)",
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $0a02a0130e304795$var$spinnerContainer = {
    name: "q64ud4",
    styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
};
const $0a02a0130e304795$export$ca0620a9deb4a3fe = {
    name: "n1lsvi",
    styles: "padding:0;list-style:none"
};
const $0a02a0130e304795$var$LinkSearchList = ({ listItemRefCallback: listItemRefCallback, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id })=>{
    let itemsContent;
    let loadingContent;
    if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $lOiVq.jsx)("ul", {
        css: $0a02a0130e304795$export$ca0620a9deb4a3fe,
        id: id,
        role: role,
        "aria-controls": ariaControls,
        "data-testid": `${id}--items`
    }, items.map((item, index)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $5284e4863985ef82$export$2e2bcd8739ae039), {
            id: `link-search-list-item-${index}`,
            item: item,
            selected: selectedIndex === index,
            onBlur: onBlur,
            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onFocus: ()=>onFocus?.(index),
            onKeyDown: onKeyDown,
            onMouseMove: onMouseMove,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onSelect: onSelect,
            key: item.objectId,
            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (el)=>listItemRefCallback?.(el, item.objectId)
        })));
    if (isLoading) loadingContent = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        id: id,
        "data-testid": `${id}--loading`,
        css: $0a02a0130e304795$var$spinnerContainer
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfoFx.default), {
        size: "medium",
        interactionName: "link-search-spinner"
    }));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $0a02a0130e304795$var$listContainer
    }, itemsContent, loadingContent);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0a02a0130e304795$export$2e2bcd8739ae039 = $0a02a0130e304795$var$LinkSearchList;
module.exports["default"] = $0a02a0130e304795$export$2e2bcd8739ae039;

});

parcelRegister("clVvI", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $2VYYv = parcelRequire("2VYYv");

function $1eff2925bb5e34d0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1eff2925bb5e34d0$export$248a47518f3a0001 = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $1eff2925bb5e34d0$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $2VYYv.RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX)}px`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $1eff2925bb5e34d0$export$8fb2d297355596b4 = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX)}px`
});
const $1eff2925bb5e34d0$export$b45558f4e00a3f09 = {
    name: "1raezz8",
    styles: "width:292px"
};
module.exports["inputWrapper"] = $1eff2925bb5e34d0$export$248a47518f3a0001;
module.exports["container"] = $1eff2925bb5e34d0$export$34e0f9847d4c02dd;
module.exports["containerWithProvider"] = $1eff2925bb5e34d0$export$8fb2d297355596b4;
module.exports["narrowContainerWidth"] = $1eff2925bb5e34d0$export$b45558f4e00a3f09;

});

parcelRegister("2VYYv", function(module, exports) {
const $3e29c4909fcaa193$export$a62aa932daf22ffe = 420;
const $3e29c4909fcaa193$export$92a2501826f554f6 = 360;
const $3e29c4909fcaa193$export$c04a5ad015d45447 = 360;
const $3e29c4909fcaa193$export$c635b83728f81640 = 570;
const $3e29c4909fcaa193$export$6174bb2f16361f4e = 464;
const $3e29c4909fcaa193$export$6d1047548150003f = 512;
module.exports["RECENT_SEARCH_WIDTH_IN_PX"] = $3e29c4909fcaa193$export$a62aa932daf22ffe;
module.exports["RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX"] = $3e29c4909fcaa193$export$92a2501826f554f6;
module.exports["RECENT_SEARCH_HEIGHT_IN_PX"] = $3e29c4909fcaa193$export$c04a5ad015d45447;
module.exports["LINKPICKER_HEIGHT_IN_PX"] = $3e29c4909fcaa193$export$c635b83728f81640;

});

parcelRegister("3v5aK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ed894899376c2783$export$99ff0262540b54dc = ({ userIntent: userIntent = 'popupOpen', children: children, api: api })=>{
    (0, $cozmU.useEffect)(()=>{
        api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent(userIntent));
        return ()=>{
            if (userIntent === api?.userIntent?.sharedState.currentState()?.currentUserIntent) // Defer the reset to avoid interfering with ongoing ProseMirror transactions
            // This fixes a race condition where cleanup happens during a transaction
            // (e.g., during drag handle mouse over -> unmountDecorations -> flushSync)
            setTimeout(()=>{
                api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            }, 0);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return children;
};
module.exports["UserIntentPopupWrapper"] = $ed894899376c2783$export$99ff0262540b54dc;

});

parcelRegister("hYOOW", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $krYZG = parcelRequire("krYZG");

var $fAWGo = parcelRequire("fAWGo");


var $2HZqG = parcelRequire("2HZqG");


var $5I4Vo = parcelRequire("5I4Vo");


var $50UK1 = parcelRequire("50UK1");


var $hZ5o2 = parcelRequire("hZ5o2");


var $4aSpR = parcelRequire("4aSpR");

var $h6b2D = parcelRequire("h6b2D");


var $5vSgR = parcelRequire("5vSgR");


var $kpCD8 = parcelRequire("kpCD8");


var $95bQO = parcelRequire("95bQO");


var $lMCDO = parcelRequire("lMCDO");




const $1de63454be902e74$export$2dccb54a894dbcd3 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc.querySelectorAll(`div.${(0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK}`).forEach((breakoutDiv)=>{
        // Check if this breakout div directly contains a renderer sync block
        const rendererDiv = breakoutDiv.querySelector(`:scope > div[${(0, $95bQO.SyncBlockRendererDataAttributeName)}]`);
        if (rendererDiv) breakoutDiv.replaceWith(rendererDiv);
    });
    return doc.body.innerHTML;
};


var $5M2nW = parcelRequire("5M2nW");

var $aPdNQ = parcelRequire("aPdNQ");

const $29fba5bb76034c39$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};


var $lGcQw = parcelRequire("lGcQw");

var $jPUdw = parcelRequire("jPUdw");



const $0d5e4f4efdd96eef$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};





var $fud2r = parcelRequire("fud2r");



function $e2ed0dd090521fdb$var$joinCodeBlocks(left, right) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $e2ed0dd090521fdb$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return children.push($e2ed0dd090521fdb$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $aPdNQ.Fragment).from(children);
}
function $e2ed0dd090521fdb$export$5a682e48ed34e262(slice) {
    slice = (0, $fud2r.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($e2ed0dd090521fdb$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $aPdNQ.Slice)($e2ed0dd090521fdb$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}


var $jlFP9 = parcelRequire("jlFP9");

var $aDwKe = parcelRequire("aDwKe");


var $fRYCB = parcelRequire("fRYCB");

var $jGEbn = parcelRequire("jGEbn");

var $4wRTw = parcelRequire("4wRTw");




var $c9zHD = parcelRequire("c9zHD");





var $bjg0G = parcelRequire("bjg0G");


var $h9YGx = parcelRequire("h9YGx");


var $eFgM7 = parcelRequire("eFgM7");


var $bGrTZ = parcelRequire("bGrTZ");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");

var $d112028c0c349284$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    PastePluginActionTypes["SET_ACTIVE_FLAG"] = "SET_ACTIVE_FLAG";
    return PastePluginActionTypes;
}({});



var $aXHNB = parcelRequire("aXHNB");




var $iUNgd = parcelRequire("iUNgd");





var $kCECX = parcelRequire("kCECX");



var $cI8RZ = parcelRequire("cI8RZ");





const $330d43ab1f280a0c$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $d112028c0c349284$export$ad3c0356f902fd97).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $d112028c0c349284$export$ad3c0356f902fd97).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $d112028c0c349284$export$ad3c0356f902fd97).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        case (0, $d112028c0c349284$export$ad3c0356f902fd97).SET_ACTIVE_FLAG:
            return {
                ...state,
                activeFlag: action.activeFlag
            };
        default:
            return state;
    }
};


const $142dabd6f33e6b5c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('pastePlugin');
const $142dabd6f33e6b5c$var$dest = (0, $cI8RZ.pluginFactory)($142dabd6f33e6b5c$export$18d4026d1ea86bb1, (0, $330d43ab1f280a0c$export$1650419e431d3ba3), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});
const $142dabd6f33e6b5c$export$656c7661095efe2e = $142dabd6f33e6b5c$var$dest.createPluginState;
const $142dabd6f33e6b5c$export$8d4021544bdece00 = $142dabd6f33e6b5c$var$dest.createCommand;
const $142dabd6f33e6b5c$export$f05434c51e3762e = $142dabd6f33e6b5c$var$dest.getPluginState;


const $a69d310c7883283b$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $142dabd6f33e6b5c$export$8d4021544bdece00)(()=>{
        return {
            type: (0, $d112028c0c349284$export$ad3c0356f902fd97).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $a69d310c7883283b$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $142dabd6f33e6b5c$export$8d4021544bdece00)(()=>{
        return {
            type: (0, $d112028c0c349284$export$ad3c0356f902fd97).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a69d310c7883283b$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a69d310c7883283b$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $a69d310c7883283b$var$isListItem = (node, schema)=>{
    return Boolean(node && node.type === schema.nodes.listItem);
};
const $a69d310c7883283b$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $a69d310c7883283b$var$bullets
        },
        {
            node: orderedList,
            matcher: $a69d310c7883283b$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $a69d310c7883283b$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $a69d310c7883283b$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $fud2r.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $a69d310c7883283b$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            if (line[0]?.type === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $a69d310c7883283b$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $a69d310c7883283b$var$getListType(line[1], schema);
        }
        if (!listMatch || // CONFCLOUD-79708: If we are inside a list - let's not try to upgrade list as it resolves
        // to invalid content
        $a69d310c7883283b$var$isListItem(parent, schema)) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode?.text?.substr(length);
        const restOfChunk = startingText ? [
            schema.text(startingText, firstNonHardBreakNode?.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $aPdNQ.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $aPdNQ.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $kCECX.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $iUNgd.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $aXHNB.isListNode)(before) && (0, $aXHNB.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $aPdNQ.Fragment).from(result);
    return fragment;
};
const $a69d310c7883283b$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $fud2r.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $a69d310c7883283b$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $a69d310c7883283b$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $a69d310c7883283b$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $aPdNQ.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $a69d310c7883283b$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $a69d310c7883283b$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $aPdNQ.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $aPdNQ.Fragment).from(paragraphs.length ? paragraphs : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};



var $4G6PK = parcelRequire("4G6PK");




var $2T05n = parcelRequire("2T05n");

var $89GtV = parcelRequire("89GtV");

var $kJEpx = parcelRequire("kJEpx");





var $8396x = parcelRequire("8396x");




function $29c0d3539e09a749$export$5ed9534d355a0a0f(slice, schema, api) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $bjg0G.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $fud2r.mapSlice)(newSlice, (node)=>{
            const mediaState = api?.media?.sharedState.currentState();
            const extendedOrLegacyAttrs = mediaState?.mediaOptions?.allowPixelResizing ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $bjg0G.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $bjg0G.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $29c0d3539e09a749$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $29c0d3539e09a749$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($29c0d3539e09a749$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $29c0d3539e09a749$export$77944619eaa3fcd3 = (slice, schema, api)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $fud2r.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) {
            const mediaState = api?.media?.sharedState.currentState();
            return mediaState?.mediaOptions?.allowPixelResizing ? mediaSingle.createChecked({
                width: node.attrs.width || (0, $4G6PK.DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
        }
        return node;
    });
    return (0, $fud2r.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $8396x.getRandomHex)(8);
        if (node.type === media) {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
        }
        if (node.type.name === 'mediaInline') {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
        }
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $29c0d3539e09a749$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $29c0d3539e09a749$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $29c0d3539e09a749$var$canContainImage(element) {
    if (!element) return false;
    return $29c0d3539e09a749$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
/**
 * Determines whether an `<img>` inside a mediaSingle wrapper should be hoisted
 * out of the wrapper and treated as a standalone external image.
 *
 * This should only happen when:
 * - The image source is external (data-source="external"), and
 * - The media wrapper has no valid file reference (no data-id), meaning
 *   ProseMirror cannot reconstruct a proper internal media node from the wrapper.
 *
 * When the wrapper has a valid file reference (e.g. internal media from Jira),
 * we leave the wrapper intact so ProseMirror can reconstruct a proper internal media node with the file reference and fetch fresh auth tokens.
 */ function $29c0d3539e09a749$var$shouldHoistFromMediaSingle(imageTag) {
    const isExternalSource = imageTag.getAttribute('data-source') === 'external';
    if (!isExternalSource) return false;
    const mediaNode = imageTag.closest('[data-node-type="media"]');
    const hasFileReference = mediaNode?.hasAttribute('data-id') ?? false;
    return !hasFileReference;
}
const $29c0d3539e09a749$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $89GtV.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // Bypass emoji
        if (imageTag.className.includes('emoji-common-emoji-image')) return;
        // Bypass mediaInline images - don't hoist images that are inside a mediaInline wrapper
        // as this would break parseDOM matching for mediaInline nodes
        // We remove the img from the DOM since mediaInline is a leaf node with no content
        if (imageTag.closest('[data-node-type="mediaInline"]')) {
            // Remove the img element so ProseMirror doesn't try to parse it
            // mediaInline nodes are leaf nodes and cannot have children
            imageTag.remove();
            return;
        }
        // when copying a jira comment that contains external image (data-source="external"),
        // the 'media' div is like this:
        // <div data-node-type="media"> has no data-id,
        // But when copying a jira comment that contains image that was uploaded to Jira, the div is like this:
        // <div data-node-type="media" data-type="file" data-id="dce9c14b-b857-41fd-9452-5f4ba3a4f679" data-collection="" data-file-name="Screenshot 2026-05-26 at 4.41.05 pm.png" data-file-size="1354355" data-file-mime-type="image/png">
        // ProseMirror fails to parse the media node because it has no data-id,
        // so we hoist the <img> to replace the entire mediaSingle wrapper
        // so the editor can treat it as a plain external image and render/re-upload it correctly.
        const mediaSingleWrapper = imageTag.closest('[data-node-type="mediaSingle"]');
        if (mediaSingleWrapper && $29c0d3539e09a749$var$shouldHoistFromMediaSingle(imageTag) && (0, $ieeJu.expValEquals)('fix_copy_paste_external_media_renderer_to_editor', 'isEnabled', true)) // Hoist the <img> to replace the entire mediaSingle wrapper
        {
            if (mediaSingleWrapper.parentElement) {
                mediaSingleWrapper.parentElement.insertBefore(imageTag, mediaSingleWrapper);
                mediaSingleWrapper.remove();
                return;
            }
        }
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($29c0d3539e09a749$var$isElementInvisible(mediaParent) || $29c0d3539e09a749$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($29c0d3539e09a749$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $kJEpx.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $29c0d3539e09a749$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $2T05n.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};








var $ee2ps = parcelRequire("ee2ps");










var $mW7G5 = parcelRequire("mW7G5");




var $jzpoq = parcelRequire("jzpoq");


var $kAvGB = parcelRequire("kAvGB");


var $iso5o = parcelRequire("iso5o");




var $57Rmq = parcelRequire("57Rmq");











var $fEPSi = parcelRequire("fEPSi");

var $8imfU = parcelRequire("8imfU");


var $6wYuL = parcelRequire("6wYuL");







// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $13a9f9985923029f$var$HTML_CONTAINS_SINGLE_FILE_REGEX = /<img .*>/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $13a9f9985923029f$var$ESCAPE_LINKS_INNER_REGEX = /^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/;
// Allows up to 3 leading spaces before ``` and optional trailing characters
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $13a9f9985923029f$var$OPENING_CODE_FENCE_REGEX = /^( {0,3})```.*$/;
// Allows up to 3 leading spaces before ``` and optional trailing spaces or tabs
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $13a9f9985923029f$var$CLOSING_CODE_FENCE_REGEX = /^( {0,3})```[ 	]*$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $13a9f9985923029f$var$SPLIT_ON_ANCHOR_REGEX = /(?=<a)/;
function $13a9f9985923029f$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $13a9f9985923029f$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $13a9f9985923029f$var$isPastedFromDropboxPaper(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $13a9f9985923029f$var$isPastedFromGoogleDocs(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $13a9f9985923029f$var$isPastedFromGoogleSpreadSheets(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $13a9f9985923029f$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $13a9f9985923029f$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
function $13a9f9985923029f$var$isPastedFromFabricRenderer(html) {
    return !!html && html.indexOf('data-renderer-start-pos="') >= 0 && (0, $iDrrr.fg)('platform_editor_paste_renderer_analytics');
}
const $13a9f9985923029f$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $13a9f9985923029f$export$41d193509f55b76e(html) {
    return !!html.match($13a9f9985923029f$var$HTML_CONTAINS_SINGLE_FILE_REGEX) && !(0, $6wYuL.isMediaBlobUrl)(html);
}
function $13a9f9985923029f$export$e45b5b7458bacd81(event) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const html = event.clipboardData.getData('text/html');
    if ($13a9f9985923029f$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($13a9f9985923029f$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($13a9f9985923029f$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($13a9f9985923029f$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($13a9f9985923029f$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($13a9f9985923029f$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($13a9f9985923029f$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    else if ($13a9f9985923029f$var$isPastedFromFabricRenderer(html)) return 'fabric-renderer';
    return 'uncategorized';
}
function $13a9f9985923029f$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
        return str.match($13a9f9985923029f$var$ESCAPE_LINKS_INNER_REGEX) ? `<${str}>` : str;
    });
}
function $13a9f9985923029f$export$3e81f5aaf68cd698(textInput, options) {
    const shouldEscapeLinks = !options?.skipLinkEscaping;
    // ref: https://spec.commonmark.org/0.31.2/#fenced-code-blocks
    let isInsideCodeBlock = false;
    const lines = textInput.split('\n');
    // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
    return lines.map((line)=>{
        if (!isInsideCodeBlock && $13a9f9985923029f$var$OPENING_CODE_FENCE_REGEX.test(line)) {
            isInsideCodeBlock = true;
            return line;
        }
        if (isInsideCodeBlock && $13a9f9985923029f$var$CLOSING_CODE_FENCE_REGEX.test(line)) {
            isInsideCodeBlock = false;
            return line;
        }
        // not code fence, don't escape anything inside code block
        if (isInsideCodeBlock) return line;
        else {
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            let escaped = line.replace(/\\/g, '\\\\');
            if (shouldEscapeLinks) escaped = $13a9f9985923029f$export$8acd10161c5f8b07(escaped);
            return escaped;
        }
    }).join('\n');
}
function $13a9f9985923029f$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $13a9f9985923029f$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $aPdNQ.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $kAvGB.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if (node.isInline && [
                'inlineCard',
                'emoji',
                'status',
                'date',
                'mention'
            ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
            node.marks = [
                ...node.marks,
                ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
            ];
            return true;
        });
        return sliceCopy;
    };
}
function $13a9f9985923029f$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $aPdNQ.Mark).sameSet(emptyNode.marks, node.marks);
}
function $13a9f9985923029f$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $kCECX.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $13a9f9985923029f$export$c7c9ca5cba02ff5a(node) {
    // panel_c1 is a schema variant of panel (used when a table is nested inside a panel). When the
    // experiment is on, treat it as a panel too.
    if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return Boolean(node && (0, $57Rmq.getBaseNodeTypeName)(node.type) === 'panel');
    return Boolean(node && node.type.name === 'panel');
}
function $13a9f9985923029f$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $kCECX.NodeSelection) && $13a9f9985923029f$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel, panel_c1: panel_c1 } } } } } = selection.$from;
    // When the experiment is on, also match panel_c1 (table-in-panel variant).
    const panelPosition = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $bjg0G.findParentNodeOfType)([
        panel,
        panel_c1
    ].filter(Boolean))(selection) : (0, $bjg0G.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $13a9f9985923029f$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $13a9f9985923029f$export$35ca1bb0581efaf3 = (html)=>{
    if ($13a9f9985923029f$export$3c3a613abe5bb97d(html)) {
        const htmlArray = html.split($13a9f9985923029f$var$SPLIT_ON_ANCHOR_REGEX);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<\/a><\/a>/gi, '</a>')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $13a9f9985923029f$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $8imfU.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $fEPSi.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $jzpoq.TABLE_ACTION).REPLACED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $krYZG.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $13a9f9985923029f$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $fud2r.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$13a9f9985923029f$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $13a9f9985923029f$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $iso5o.isSupportedInParent)(state, frag);
};


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $iwjSV = parcelRequire("iwjSV");


var $hD7pG = parcelRequire("hD7pG");











var $bVxZJ = parcelRequire("bVxZJ");


var $ca4Zc = parcelRequire("ca4Zc");


var $euISL = parcelRequire("euISL");

var $is9bZ = parcelRequire("is9bZ");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $gid2f = parcelRequire("gid2f");

var $2w79Z = parcelRequire("2w79Z");

var $gWBVp = parcelRequire("gWBVp");

var $gPewy = parcelRequire("gPewy");


























var $cycWk = parcelRequire("cycWk");




const $b94e54b9788cb595$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $8imfU.isTableSelected)(state.selection)) {
        const table = (0, $cycWk.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};









var $di3bZ = parcelRequire("di3bZ");







var $9WBFV = parcelRequire("9WBFV");











var $eOaGc = parcelRequire("eOaGc");


























function $6a4face163322ac5$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $6a4face163322ac5$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $kCECX.TextSelection).near(startSlicePosition, direction));
}
function $6a4face163322ac5$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $kCECX.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $6a4face163322ac5$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $aPdNQ.Fragment).from(slice.content))) {
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
         If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
      */ if (schema) {
                const mbeParentOfPanel = (0, $bjg0G.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $aPdNQ.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, $2w79Z.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const temporaryDoc = new (0, $eOaGc.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $kCECX.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}


function $fa6a91bcdc48f73b$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $13a9f9985923029f$export$3befc640b7d49184)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $aXHNB.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $6a4face163322ac5$export$eee44e0848f600ea)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $13a9f9985923029f$export$641fdf56f693bfbc)(panelNode) && $from.node() === $to.node()) return (0, $6a4face163322ac5$export$778b6ddd10a6aad3)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $13a9f9985923029f$export$641fdf56f693bfbc)(tr.doc.resolve($cursor.pos).node())) return (0, $6a4face163322ac5$export$d69afd888d46c7c)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $bjg0G.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $aXHNB.isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $13a9f9985923029f$export$ee1d3ec5b3695690)(selection)) return (0, $6a4face163322ac5$export$7b48cb097052829)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
const $fa6a91bcdc48f73b$var$stripFontSizeInsideBlockquoteLists = (tr, blockquotePos)=>{
    const { marks: { fontSize: fontSize }, nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, blockTaskItem: blockTaskItem } } = tr.doc.type.schema;
    const listItemParentNodeTypes = [
        listItem,
        taskItem,
        blockTaskItem
    ];
    if (!fontSize || !(0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return;
    const containingBlockquote = tr.doc.nodeAt(blockquotePos);
    if (!containingBlockquote) return;
    const from = blockquotePos + 1;
    const to = blockquotePos + containingBlockquote.nodeSize - 1;
    (0, $9WBFV.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, (_schema, node, parent)=>node.type === paragraph && !!parent && listItemParentNodeTypes.some((nodeType)=>nodeType === parent.type))(from, to, tr);
};
function $fa6a91bcdc48f73b$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $fa6a91bcdc48f73b$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
    if ((0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
        const insertedBlockquotePos = (0, $bjg0G.findParentNodeOfType)(schema.nodes.blockquote)(tr.selection);
        if (!insertedBlockquotePos) return;
        $fa6a91bcdc48f73b$var$stripFontSizeInsideBlockquoteLists(tr, insertedBlockquotePos.pos);
    }
}
function $fa6a91bcdc48f73b$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $eOaGc.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kCECX.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $fa6a91bcdc48f73b$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    // The corrected insertion path only applies for the flexible list indentation dogfooding audience
    // (`platform_editor_flexible_list_indentation`), and the kill switch protects that audience from
    // regressions. Fall back to the legacy path when the experiment is OFF or the kill switch is ON.
    if (!(0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true) || (0, $iDrrr.fg)('platform_editor_flexible_list_kill_switch_1')) {
        //To avoid the list being replaced with the tasklist, enclose the slice within a taskItem.
        const selectionBeforeReplace = tr.selection.from;
        tr.replaceSelection(new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
        const nextSelection = (0, $kCECX.Selection).near(tr.doc.resolve(selectionBeforeReplace + 1));
        tr.setSelection(nextSelection);
        tr.replaceSelection(slice);
        return tr;
    }
    // Collapse redundant nested taskList wrappers from the slice context, always keeping a single
    // outermost taskList so the content can be safely inserted as a sibling of the list item's
    // paragraph (a listItem cannot directly contain bare taskItems).
    const { taskList: taskList } = schema.nodes;
    let content = slice.content;
    while(content.childCount === 1 && content.firstChild?.type === taskList && content.firstChild.firstChild?.type === taskList)content = content.firstChild.content;
    // safeInsert keeps the task structure intact at the closest schema-valid position, instead of
    // replacing into an empty taskItem which would add an extra taskList level.
    tr = (0, $bjg0G.safeInsert)(content, tr.selection.$to.pos)(tr);
    $fa6a91bcdc48f73b$export$e57c13697a8b8195({
        tr: tr
    });
    return tr;
}




const $47bc08b8723be306$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $bjg0G.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $47bc08b8723be306$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $47bc08b8723be306$export$7097a0398467de9c(slice, schema) {
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === schema.nodes.mention?.name) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $47bc08b8723be306$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, panel_c1: panel_c1, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $kCECX.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        // panel_c1 is a schema variant of panel (used when a table is nested inside a panel). When the
        // experiment is on we must handle it anywhere we special-case a panel, otherwise partial
        // selections copied from inside a table-in-panel are treated as a foreign container and
        // re-wrapped on paste.
        const selectionHasValidParentNode = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $bjg0G.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel,
            panel_c1
        ].filter(Boolean))(state.selection) : (0, $bjg0G.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $bjg0G.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const selectionIsListItem = (0, $bjg0G.hasParentNodeOfType)([
            listItem
        ])(state.selection);
        const panelNode = (0, $13a9f9985923029f$export$3befc640b7d49184)(selection);
        const selectionIsPanel = Boolean(panelNode);
        const sliceFirstChildIsPanel = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? !!slice.content.firstChild && (0, $57Rmq.getBaseNodeTypeName)(slice.content.firstChild.type) === 'panel' : slice.content.firstChild?.type === panel;
        const isSliceWholePanel = sliceFirstChildIsPanel && slice.openStart === 0 && slice.openEnd === 0;
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        // Partial content copied from panels will have panel in the slice
        // Return false to avoid handling this situation when pasted into list in panel and let `handlePastePanelOrDecisionContentIntoList` handle it
        if (selectionIsPanel && (selectionIsCodeBlock || selectionIsListItem && !isSliceWholePanel)) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading && !(selectionIsPanel && (0, $4o0zT.isExperimentEnabled)('platform_editor_fix_header_paste_in_panel')) || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $bjg0G.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $4wRTw.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $kCECX.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $13a9f9985923029f$export$a4568554bf9b43cd)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $ca4Zc.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $13a9f9985923029f$export$3bf611fd421c1669)(schema, selection.$head.marks()));
        const transformedSlice = $47bc08b8723be306$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $di3bZ.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && sliceFirstChildIsPanel && (0, $13a9f9985923029f$export$641fdf56f693bfbc)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $6a4face163322ac5$export$778b6ddd10a6aad3)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes((0, $57Rmq.getBaseNodeTypeName)(transformedSlice.content.firstChild.type))) && (!(0, $2w79Z.isInListItem)(state) || (0, $2w79Z.isInListItem)(state) && isFirstChildTaskNode) : (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $2w79Z.isInListItem)(state) || (0, $2w79Z.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        // When the experiment is on, validate against the actual destination panel variant (panel or
        // panel_c1) since their content expressions differ (panel_c1 additionally allows a nested
        // table).
        const pastingIntoExtendedPanel = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? selectionIsPanel && (panelNode?.type ?? panel).validContent(transformedSlice.content) : selectionIsPanel && panel.validContent(transformedSlice.content);
        // A task slice carrying its own open taskList wrapper would, on a plain replaceSelection,
        // nest that wrapper inside the current item and add an extra taskList level. Unwrapping one
        // level keeps the pasted task(s) at the same level. Guarded by a kill switch.
        const isOpenTaskListSlice = transformedSlice.content.firstChild?.type === taskList && transformedSlice.openStart >= 2 && transformedSlice.openEnd >= 1;
        // Restrict the unwrap to a taskItem destination: its task content is schema-invalid inside a
        // decisionItem (decisionList only accepts decisionItem), so decisionItem must fall through to
        // the normal replaceSelection path.
        const pastingIntoTaskItem = (0, $bjg0G.hasParentNodeOfType)([
            taskItem
        ])(selection);
        if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true) && !(0, $iDrrr.fg)('platform_editor_flexible_list_kill_switch_1') && isOpenTaskListSlice && pastingIntoTaskItem && !selectionIsPanel) {
            const unwrappedSlice = new (0, $aPdNQ.Slice)(transformedSlice.content.firstChild.content, transformedSlice.openStart - 1, transformedSlice.openEnd - 1);
            tr.replaceSelection(unwrappedSlice).scrollIntoView();
        } else if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $aPdNQ.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $bjg0G.findParentNodeOfType)([
                    panel,
                    panel_c1
                ].filter(Boolean))(selection) : (0, $bjg0G.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $2w79Z.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $bjg0G.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $kCECX.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr?.(state, tr, (0, $krYZG.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $47bc08b8723be306$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $bjg0G.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $bjg0G.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $aXHNB.isListNode)(sliceContent.firstChild) && (0, $aXHNB.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $bjg0G.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        if ($47bc08b8723be306$export$67c0f4368bb304c3(state)) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (slice.content.firstChild?.type.name === 'blockquote' && (0, $bjg0G.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $fa6a91bcdc48f73b$export$2dee216d0a70c94e)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const numOfListItemsInOriginalList = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])?.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $47bc08b8723be306$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $47bc08b8723be306$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$47bc08b8723be306$export$c2473d50cf33051b(selection, findRootParentListNode);
        // When the experiment is on, treat panel_c1 (table-in-panel variant) like a panel.
        const blockNodeIsPanelOrDecision = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
            'panel',
            'decisionList'
        ].includes(blockNode ? (0, $57Rmq.getBaseNodeTypeName)(blockNode.type) : '') : [
            'panel',
            'decisionList'
        ].includes(blockNode?.type.name ?? '');
        if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || !blockNodeIsPanelOrDecision || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $47bc08b8723be306$var$innerTextRangeOfTextblock = (doc, posOfBlock)=>{
    const block = doc.nodeAt(posOfBlock);
    if (!block || !block.isTextblock) return null;
    // raw content bounds
    const contentStart = posOfBlock + 1; // +1 to move from node's start token to content start
    const contentEnd = contentStart + block.content.size;
    // clamp to doc coord space
    const start = Math.max(0, Math.min(contentStart, doc.content.size));
    const end = Math.max(0, Math.min(contentEnd, doc.content.size));
    if (end <= start) return null;
    // snap to nearest valid text positions
    const startSel = (0, $kCECX.TextSelection).findFrom(doc.resolve(start), 1, true);
    const endSel = (0, $kCECX.TextSelection).findFrom(doc.resolve(end), -1, true);
    if (!startSel || !endSel) return null;
    const from = startSel.$from.pos;
    const to = endSel.$to.pos;
    return to > from ? {
        from: from,
        to: to
    } : null;
};
function $47bc08b8723be306$var$resolveSingleTextblockRangeIfAllSelected(state) {
    const sel = state.selection;
    if (!(sel instanceof (0, $kCECX.AllSelection))) return null;
    let count = 0;
    let posOfBlock = -1;
    state.doc.nodesBetween(sel.from, sel.to, (node, pos)=>{
        if (!node.isTextblock) return true;
        count++;
        if (count > 1) return false;
        posOfBlock = pos;
        return true;
    });
    if (count !== 1) return null;
    return $47bc08b8723be306$var$innerTextRangeOfTextblock(state.doc, posOfBlock);
}
function $47bc08b8723be306$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $gWBVp.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $gWBVp.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $gWBVp.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // derive a linkable range if possible for Select‑All over a single textblock
        const selectAllRange = (0, $iDrrr.fg)('platform_editor_link_paste_select_all') ? $47bc08b8723be306$var$resolveSingleTextblockRangeIfAllSelected(state) : null;
        const rangeFrom = selectAllRange?.from ?? from;
        const rangeTo = selectAllRange?.to ?? to;
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && (selection instanceof (0, $kCECX.TextSelection) || Boolean(selectAllRange)) && !selection.empty && (0, $gid2f.canLinkBeCreatedInRange)(rangeFrom, rangeTo)(state)) {
            tr.addMark(rangeFrom, rangeTo, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $47bc08b8723be306$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || view.input?.shiftKey;
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $di3bZ.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $b94e54b9788cb595$export$ea73b328547c6ad5)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $13a9f9985923029f$export$4f704994f6a89bd1)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $47bc08b8723be306$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $kCECX.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $ca4Zc.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $bjg0G.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $13a9f9985923029f$export$a4568554bf9b43cd)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $13a9f9985923029f$export$3bf611fd421c1669)(schema, selectionMarks)(slice);
            const tr = (0, $di3bZ.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, $krYZG.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $47bc08b8723be306$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $47bc08b8723be306$var$insertAutoMacro(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        const macroTr = (0, $di3bZ.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView();
        (0, $2HZqG.addLinkMetadata)(view.state.selection, macroTr, {
            inputMethod: (0, $krYZG.INPUT_METHOD).CLIPBOARD,
            cardAction: 'AUTO_CONVERT'
        });
        view.dispatch(macroTr);
        return true;
    }
    return false;
}
function $47bc08b8723be306$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $aPdNQ.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
        if (macro) {
            /**
			 * if FF enabled, run through smart links and check for result
			 */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $47bc08b8723be306$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const trackingId = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                (0, $a69d310c7883283b$export$4a47d257a3fdbe1c)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $47bc08b8723be306$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $142dabd6f33e6b5c$export$f05434c51e3762e)(view.state);
                    if (dispatch) $47bc08b8723be306$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $142dabd6f33e6b5c$export$f05434c51e3762e)(view.state);
                    $47bc08b8723be306$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $a69d310c7883283b$export$68f98dcea8e59d59)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $47bc08b8723be306$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $47bc08b8723be306$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $bjg0G.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $di3bZ.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $47bc08b8723be306$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $47bc08b8723be306$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle);
}
function $47bc08b8723be306$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($47bc08b8723be306$var$isOnlyMedia(state, slice)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                if ((0, $5I4Vo.insideTable)(state) && $47bc08b8723be306$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $4EksL.GapCursorSelection)(nextPos, (0, $eaLat.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $47bc08b8723be306$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $47bc08b8723be306$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $5I4Vo.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $fud2r.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $47bc08b8723be306$export$113227139658cc8d(slice, isNestingTablesSupported) {
    return (state, dispatch)=>{
        if (!isNestingTablesSupported || !(0, $5I4Vo.insideTable)(state)) return false;
        const { schema: schema, selection: selection } = state;
        let sliceHasTable = false;
        slice.content.forEach((node)=>{
            if (node.type === state.schema.nodes.table) sliceHasTable = true;
        });
        if (sliceHasTable) // if slice has table - if pasting to deeply nested location place paste after top table
        {
            if ((0, $euISL.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1) {
                const positionAfterTopTable = (0, $is9bZ.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                let { tr: tr } = state;
                tr = (0, $bjg0G.safeInsert)(slice.content, positionAfterTopTable)(tr);
                tr.scrollIntoView();
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
        }
        return false;
    };
}
function $47bc08b8723be306$export$a497757c6eac4530(slice) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = !!$47bc08b8723be306$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $5I4Vo.insideTable)(state) && !isInsideNestableExpand || !$47bc08b8723be306$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $fud2r.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch  {
                    tr = (0, $bjg0G.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $aPdNQ.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $bjg0G.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $47bc08b8723be306$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $di3bZ.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $kCECX.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr?.(state, tr, (0, $krYZG.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $47bc08b8723be306$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $47bc08b8723be306$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $47bc08b8723be306$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $aXHNB.isListNode)(child) || (0, $gPewy.isListItemNode)(child) && (0, $aXHNB.isListNode)(child.firstChild)) $47bc08b8723be306$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $47bc08b8723be306$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $5I4Vo.insideTable)(state) && (0, $aXHNB.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $47bc08b8723be306$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $47bc08b8723be306$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
/**
 * Peels container wrapper nodes (e.g. panel, expand) added by ProseMirror's addContext()
 * so that fontSize-marked paragraphs become top-level, preserving the mark on paste.
 */ function $47bc08b8723be306$var$unwrapContainerNodesWithBlockMarks(slice, schema, fontSize) {
    let content = slice.content;
    let levelsUnwrapped = 0;
    while(content.childCount === 1 && content.firstChild && !content.firstChild.isTextblock && slice.openStart - levelsUnwrapped > 1){
        let hasBlockMarkedParagraph = false;
        for(let i = 0; i < content.firstChild.childCount; i++){
            const child = content.firstChild.child(i);
            if (child.type === schema.nodes.paragraph && child.marks.some((m)=>m.type === fontSize)) {
                hasBlockMarkedParagraph = true;
                break;
            }
        }
        if (!hasBlockMarkedParagraph) break;
        content = content.firstChild.content;
        levelsUnwrapped++;
    }
    if (levelsUnwrapped === 0) return slice;
    return new (0, $aPdNQ.Slice)(content, slice.openStart - levelsUnwrapped, Math.max(0, slice.openEnd - levelsUnwrapped));
}
/**
 * Returns the fontSize attrs to apply at the paste destination, or false if none.
 * Checks list and task destinations in priority order.
 */ function $47bc08b8723be306$var$getDestinationFontSizeAttrs(destinationListNode, isInSmallTaskContext, $from, currentNode, fontSize) {
    if (destinationListNode) return (0, $bVxZJ.getFirstParagraphBlockMarkAttrs)(destinationListNode, fontSize);
    if (isInSmallTaskContext) return (0, $bVxZJ.getBlockMarkAttrs)($from.parent, fontSize) || (0, $bVxZJ.getFirstParagraphBlockMarkAttrs)(currentNode, fontSize);
    return false;
}
/**
 * Resolves which marks to apply to a paragraph node after filtering forbidden marks.
 * When a destination block mark is provided, replaces any existing fontSize mark with it.
 * When normalizing for the target context, removes the fontSize mark entirely.
 * Otherwise returns the filtered marks unchanged.
 */ function $47bc08b8723be306$var$resolveParagraphMarks(marks, destinationBlockMarkAttrs, shouldNormalize, fontSize) {
    if (destinationBlockMarkAttrs) return marks.filter((m)=>m.type !== fontSize).concat(fontSize.create(destinationBlockMarkAttrs));
    if (shouldNormalize) return marks.filter((m)=>m.type !== fontSize);
    return marks;
}
function $47bc08b8723be306$export$feb0d61bf65d9267(state, slice) {
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: selection, selection: { $from: $from } } = state;
    const { bulletList: bulletList, orderedList: orderedList, blockTaskItem: blockTaskItem, taskItem: taskItem, paragraph: paragraph, heading: heading } = schema.nodes;
    const { fontSize: fontSize } = schema.marks;
    const isSmallFontSizeEnabled = !!fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    // When copying from inside a container (e.g. panel, expand), ProseMirror wraps the
    // content back in the container via addContext(), increasing openStart/openEnd. Unwrap
    // so the paragraph (with its fontSize mark) becomes top-level.
    if (isSmallFontSizeEnabled) slice = $47bc08b8723be306$var$unwrapContainerNodesWithBlockMarks(slice, schema, fontSize);
    const destinationListNode = (0, $bjg0G.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection)?.node;
    const currentNode = typeof $from.node === 'function' ? $from.node() : undefined;
    const isInNormalTaskContext = currentNode?.type === taskItem || $from.parent.type === taskItem;
    const isInSmallTaskContext = !!blockTaskItem && (currentNode?.type === blockTaskItem || $from.parent.type === blockTaskItem || $from.parent.type === paragraph && $from.depth > 0 && $from.node($from.depth - 1).type === blockTaskItem);
    const destinationBlockMarkAttrs = isSmallFontSizeEnabled ? $47bc08b8723be306$var$getDestinationFontSizeAttrs(destinationListNode, isInSmallTaskContext, $from, currentNode, fontSize) : false;
    const isInHeadingContext = $from.parent.type === heading;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // unless we're pasting into a small-text list and need to add the destination block mark.
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$47bc08b8723be306$var$sliceHasTopLevelMarks(slice) && !destinationBlockMarkAttrs) return slice;
    const shouldNormalizeFontSizeForTarget = isSmallFontSizeEnabled && (!!destinationListNode || isInNormalTaskContext || isInSmallTaskContext || isInHeadingContext);
    // If pasting a single paragraph into pre-existing content, match destination formatting.
    // For bullet/ordered lists under small-text, we still need to normalize the paragraph block mark
    // so pasted content adopts the destination list state.
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent && !shouldNormalizeFontSizeForTarget) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $47bc08b8723be306$var$getTopLevelMarkTypesInSlice(slice);
    const forbiddenMarkTypes = [];
    for (const markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    const normalizedContent = (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type === paragraph) {
            const paragraphMarks = node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type));
            return paragraph.createChecked(undefined, node.content, $47bc08b8723be306$var$resolveParagraphMarks(paragraphMarks, destinationBlockMarkAttrs, shouldNormalizeFontSizeForTarget, fontSize));
        } else if (node.type === heading) // Preserve heading attributes to keep formatting
        return heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
    if (forbiddenMarkTypes.length === 0 && !shouldNormalizeFontSizeForTarget) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $aPdNQ.Slice)(slice.content, openStart, slice.openEnd);
    }
    if (forbiddenMarkTypes.length === 0 && shouldNormalizeFontSizeForTarget) {
        // When pasting into a heading, keep the original openStart so ProseMirror merges inline
        // content into the heading node rather than replacing it with a paragraph.
        const openStart = isInHeadingContext ? slice.openStart : Math.max(0, slice.openStart - 1);
        return new (0, $aPdNQ.Slice)(normalizedContent.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice. For lists under the small
    // text experiment, also normalize fontSize to the destination list state.
    return new (0, $aPdNQ.Slice)(normalizedContent.content, slice.openStart, slice.openEnd);
}
function $47bc08b8723be306$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $47bc08b8723be306$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $aPdNQ.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
const $47bc08b8723be306$var$doesSliceContainBlockquoteListNodes = (slice, listContainerNodeTypes)=>{
    const firstChildOfSlice = slice.content.firstChild;
    const lastChildOfSlice = slice.content.lastChild;
    const isFirstChildBlockquoteListNode = firstChildOfSlice?.type?.name === 'blockquote' && listContainerNodeTypes.some((nodeType)=>nodeType === firstChildOfSlice?.content.firstChild?.type);
    const isLastChildBlockquoteListNode = lastChildOfSlice?.type?.name === 'blockquote' && listContainerNodeTypes.some((nodeType)=>nodeType === lastChildOfSlice?.content.firstChild?.type);
    return isFirstChildBlockquoteListNode || isLastChildBlockquoteListNode;
};
function $47bc08b8723be306$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel, panel_c1: panel_c1, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const { fontSize: fontSize } = state.schema.marks;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = slice.content?.firstChild;
        const lastChildOfSlice = slice.content?.lastChild;
        const listContainerNodeTypes = [
            bulletList,
            orderedList
        ];
        const isSmallFontSizeEnabled = !!fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
        const destinationListNode = isSmallFontSizeEnabled ? (0, $bjg0G.findParentNodeOfType)(listContainerNodeTypes)(selection)?.node : undefined;
        const destinationListFontSizeAttrs = isSmallFontSizeEnabled ? (0, $bVxZJ.getFirstParagraphBlockMarkAttrs)(destinationListNode, fontSize) : false;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($47bc08b8723be306$var$hasInlineCode(state, slice)) $47bc08b8723be306$var$removePrecedingBackTick(tr);
        if ($47bc08b8723be306$var$shouldFlattenList(state, slice)) slice = $47bc08b8723be306$export$79d83373d2946ba6(slice);
        (0, $di3bZ.closeHistory)(tr);
        const isFirstChildListNode = (0, $aXHNB.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $aXHNB.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
        const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        const sliceContentBlockquoteListNodes = $47bc08b8723be306$var$doesSliceContainBlockquoteListNodes(slice, listContainerNodeTypes);
        // Compute once and reuse below to avoid traversing the slice twice.
        const sliceMarkTypes = isSmallFontSizeEnabled ? $47bc08b8723be306$var$getTopLevelMarkTypesInSlice(slice) : new Set();
        const destinationIsEmpty = isSmallFontSizeEnabled && selection.$from.parent.type === paragraph && selection.$from.parent.textContent.length === 0;
        // Capture the destination paragraph's non-fontSize block marks (e.g. alignment, indentation)
        // before the paste so they can be restored if the paste replaces the paragraph entirely
        // (which happens when small text is pasted with openStart=0).
        const destinationNonFontSizeBlockMarks = isSmallFontSizeEnabled && selection.$from.parent.type === paragraph && sliceMarkTypes.has(fontSize) ? selection.$from.parent.marks.filter((m)=>m.type !== fontSize) : [];
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        // panel_c1 is a schema variant of panel; when the experiment is on, treat both together.
        const panelParentOverCurrentSelection = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $bjg0G.findParentNodeOfType)([
            panel,
            panel_c1
        ].filter(Boolean))(tr.selection) : (0, $bjg0G.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $fa6a91bcdc48f73b$export$9beec16307c108ac)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (noNeedForSafeInsert && !((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true) && $47bc08b8723be306$export$f0f8559835c0f076(state, slice))) {
            if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice?.content.firstChild?.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $fa6a91bcdc48f73b$export$2dee216d0a70c94e)({
                tr: tr,
                slice: slice
            });
            else {
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild ? (0, $57Rmq.getBaseNodeTypeName)(slice.content.lastChild.type) : '') : [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild?.type?.name || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild?.type.isTextblock ? (0, $kCECX.TextSelection).findFrom($nextPos, -1, true) : new (0, $4EksL.GapCursorSelection)($nextPos, (0, $eaLat.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $2w79Z.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $4EksL.GapCursorSelection)(nextPos, (0, $eaLat.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $2w79Z.insideTableCell)(state) && (0, $2w79Z.isInListItem)(state) && (0, $bjg0G.canInsert)(selection.$from, slice.content) && (0, $bjg0G.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true) && !(0, $iDrrr.fg)('platform_editor_flexible_list_kill_switch_1') && $47bc08b8723be306$export$f0f8559835c0f076(state, slice) && !$47bc08b8723be306$export$67c0f4368bb304c3(state)) // Corrected task-into-list insertion is gated behind the flexible list indentation
            // experiment and protected by the kill switch.
            tr = (0, $fa6a91bcdc48f73b$export$2982aac953f7c8b6)({
                tr: tr,
                slice: slice
            });
            else if ($47bc08b8723be306$export$f0f8559835c0f076(state, slice) && !$47bc08b8723be306$export$67c0f4368bb304c3(state)) // Legacy path (experiment OFF or kill switch ON): preserve the previous over-nesting
            // behaviour via the function's internal fallback.
            tr = (0, $fa6a91bcdc48f73b$export$2982aac953f7c8b6)({
                tr: tr,
                slice: slice
            });
            else {
                // need safeInsert rather than replaceSelection, so that nodes aren't split in half
                // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
                tr = (0, $bjg0G.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
                if ($47bc08b8723be306$export$f0f8559835c0f076(state, slice)) (0, $fa6a91bcdc48f73b$export$e57c13697a8b8195)({
                    tr: tr
                });
            }
        }
        // font size handling for pasting into lists or blockquotes
        if (isSmallFontSizeEnabled && (isSliceContentListNodes || sliceContentBlockquoteListNodes)) {
            const containingList = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(tr.selection.$from, listContainerNodeTypes);
            if (containingList) (0, $bVxZJ.reconcileBlockMarkForContainerAtPos)(tr, containingList.pos, fontSize, isSliceContentListNodes ? destinationListFontSizeAttrs : false);
        }
        // font size handling for pasting into paragraphs (normal text) - preserve source style
        if (isSmallFontSizeEnabled && destinationIsEmpty && !sliceMarkTypes.has(fontSize) && !destinationListNode && selection.$from.parent.type === paragraph && (0, $bVxZJ.getBlockMarkAttrs)(selection.$from.parent, fontSize)) (0, $bVxZJ.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(selection.$from.pos), fontSize, false);
        // Restore destination block marks (e.g. alignment) that were lost when pasting small text
        // replaced the paragraph entirely (openStart=0 from container unwrap).
        if (isSmallFontSizeEnabled && destinationNonFontSizeBlockMarks.length > 0) {
            const pastedFrom = tr.mapping.map(selection.from, -1);
            const pastedTo = tr.mapping.map(selection.to, 1);
            for (const mark of destinationNonFontSizeBlockMarks)(0, $bVxZJ.reconcileBlockMarkInRange)(tr, pastedFrom, pastedTo, mark.type, mark.attrs);
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $kCECX.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr?.(state, tr, (0, $krYZG.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $47bc08b8723be306$var$isUrlString(text) {
    try {
        new URL(text);
        return true;
    } catch  {
        return false;
    }
}
function $47bc08b8723be306$var$isLinkOrUrlString(slice, schema) {
    if (slice.content.childCount !== 1 || !(0, $gWBVp.isParagraph)(slice.content.child(0), schema)) return false;
    const paragraph = slice.content.child(0);
    if (paragraph.content.childCount !== 1 || !(0, $gWBVp.isText)(paragraph.content.child(0), schema)) return false;
    const { marks: marks, text: text = '' } = paragraph.content.child(0);
    const hasLinkMark = marks.some((mark)=>(0, $gWBVp.isLinkMark)(mark, schema));
    return hasLinkMark || $47bc08b8723be306$var$isUrlString(text);
}
function $47bc08b8723be306$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        if ($47bc08b8723be306$var$isLinkOrUrlString(slice, state.schema)) return false;
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $bjg0G.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $47bc08b8723be306$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $b94e54b9788cb595$export$ea73b328547c6ad5)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $13a9f9985923029f$export$4f704994f6a89bd1)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $47bc08b8723be306$export$f0f8559835c0f076(state, slice) {
    return Boolean((0, $2w79Z.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(slice.content.firstChild?.type?.name || ''));
}
function $47bc08b8723be306$export$67c0f4368bb304c3(state) {
    const { selection: selection, tr: tr } = state;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
    const selectionParentListItemNode = (0, $bjg0G.findParentNodeOfType)(listItem)(selection);
    const selectionParentListNodeWithPos = (0, $bjg0G.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection);
    if (!selectionParentListItemNode || !selectionParentListNodeWithPos) return false;
    const grandParentListNode = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $aXHNB.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    return selectedListItemHasNestedList || selectionIsInNestedList;
}
function $47bc08b8723be306$export$ce28e8ccb2f7a3dd(slice) {
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') {
            const children = [];
            if (node.attrs.title) children.push(node.type.schema.nodes.paragraph.createChecked(undefined, (0, $aPdNQ.Fragment).from(node.type.schema.text(node.attrs.title))));
            node.content.forEach((inner)=>children.push(inner));
            return children;
        }
        return node;
    });
}
function $47bc08b8723be306$export$ce2b3491c532dd9d(slice, schema, destinationParentType) {
    const sliceJson = slice.toJSON();
    if (!sliceJson) return slice;
    const wrappedAdf = {
        type: destinationParentType,
        content: sliceJson.content ?? []
    };
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $hD7pG.transformContainerNodes)(wrappedAdf, schema);
        return isTransformed && transformedAdf && transformedAdf.content && transformedAdf.content.length > 0 ? (0, $aPdNQ.Slice).fromJSON(schema, {
            ...sliceJson,
            content: transformedAdf.content
        }) : slice;
    } catch  {
        return slice;
    }
}
function $47bc08b8723be306$export$f596ff5b0d9c556a(html) {
    if (!html.includes('data-panel-type')) return html;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const panelDivs = Array.from(doc.querySelectorAll('div[data-panel-type]'));
    let changed = false;
    for (const panelDiv of panelDivs){
        const editorTableWrappers = Array.from(panelDiv.querySelectorAll('[data-prosemirror-node-name="table"]'));
        const rendererTableWrappers = (0, $4o0zT.isExperimentEnabled)('platform_editor_nest_in_table_renderer_paste') ? Array.from(panelDiv.querySelectorAll('.pm-table-container')).filter((wrapper)=>wrapper.querySelector('table') !== null) : [];
        const tableWrappers = [
            ...editorTableWrappers,
            ...rendererTableWrappers
        ];
        if (tableWrappers.length === 0) continue;
        changed = true;
        let anchor = panelDiv;
        for (const tableWrapper of tableWrappers){
            tableWrapper.parentNode?.removeChild(tableWrapper);
            anchor.parentNode?.insertBefore(tableWrapper, anchor.nextSibling);
            anchor = tableWrapper;
        }
    }
    return changed ? doc.body.innerHTML : html;
}


const $b8a912ae4e1407d7$var$isAgentUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $b8a912ae4e1407d7$var$shouldSuppressPastedMentionNotification = (node)=>(0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && $b8a912ae4e1407d7$var$isAgentUserType(node.attrs.userType);
const $b8a912ae4e1407d7$var$contentToPasteContent = {
    url: (0, $fAWGo.PasteContents).url,
    paragraph: (0, $fAWGo.PasteContents).text,
    bulletList: (0, $fAWGo.PasteContents).bulletList,
    orderedList: (0, $fAWGo.PasteContents).orderedList,
    heading: (0, $fAWGo.PasteContents).heading,
    blockquote: (0, $fAWGo.PasteContents).blockquote,
    codeBlock: (0, $fAWGo.PasteContents).codeBlock,
    panel: (0, $fAWGo.PasteContents).panel,
    rule: (0, $fAWGo.PasteContents).rule,
    mediaSingle: (0, $fAWGo.PasteContents).mediaSingle,
    mediaCard: (0, $fAWGo.PasteContents).mediaCard,
    mediaGroup: (0, $fAWGo.PasteContents).mediaGroup,
    table: (0, $fAWGo.PasteContents).table,
    tableCells: (0, $fAWGo.PasteContents).tableCells,
    tableHeader: (0, $fAWGo.PasteContents).tableHeader,
    tableRow: (0, $fAWGo.PasteContents).tableRow,
    decisionList: (0, $fAWGo.PasteContents).decisionList,
    decisionItem: (0, $fAWGo.PasteContents).decisionItem,
    taskList: (0, $fAWGo.PasteContents).taskItem,
    extension: (0, $fAWGo.PasteContents).extension,
    bodiedExtension: (0, $fAWGo.PasteContents).bodiedExtension,
    blockCard: (0, $fAWGo.PasteContents).blockCard,
    layoutSection: (0, $fAWGo.PasteContents).layoutSection
};
const $b8a912ae4e1407d7$var$nodeToActionSubjectId = {
    blockquote: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $krYZG.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $b8a912ae4e1407d7$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $fAWGo.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $fAWGo.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
    const pasteContent = $b8a912ae4e1407d7$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $fAWGo.PasteContents).uncategorized;
}
function $b8a912ae4e1407d7$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $b8a912ae4e1407d7$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $bjg0G.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $krYZG.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $b8a912ae4e1407d7$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $krYZG.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $b8a912ae4e1407d7$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $krYZG.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $b8a912ae4e1407d7$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $krYZG.ACTION).PASTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection)=>{
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $b8a912ae4e1407d7$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $b8a912ae4e1407d7$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $b8a912ae4e1407d7$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $fAWGo.PasteContents).url || content === (0, $fAWGo.PasteContents).mixed) (0, $fud2r.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $b8a912ae4e1407d7$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $13a9f9985923029f$export$e45b5b7458bacd81)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId,
                    method: 'pasted',
                    ...$b8a912ae4e1407d7$var$shouldSuppressPastedMentionNotification(node) ? {
                        shouldSuppressMentionNotification: true
                    } : {}
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId,
                            method: 'pasted',
                            ...$b8a912ae4e1407d7$var$shouldSuppressPastedMentionNotification(nodeContent) ? {
                                shouldSuppressMentionNotification: true
                            } : {}
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
        }
        const pastedNodeTypes = (0, $iDrrr.fg)('platform_editor_paste_renderer_analytics') ? [
            ...$b8a912ae4e1407d7$export$629ff5588e070c83(slice.content)
        ].sort().join(',') : undefined;
        if (pasteContext.type === (0, $fAWGo.PasteTypes).plain) return $b8a912ae4e1407d7$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $fAWGo.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList,
            pastedNodeTypes: pastedNodeTypes
        });
        const linkDomains = linkUrls.map((0, $ee2ps.getLinkDomain));
        return $b8a912ae4e1407d7$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList,
            pastedNodeTypes: pastedNodeTypes
        }, linkDomains);
    };
}
function $b8a912ae4e1407d7$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $b8a912ae4e1407d7$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $b8a912ae4e1407d7$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $b8a912ae4e1407d7$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $fAWGo.PasteTypes).plain,
            asPlain: true
        }))((0, $47bc08b8723be306$export$efe55f809fabb910)(slice, event, editorAnalyticsAPI));
const $b8a912ae4e1407d7$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $47bc08b8723be306$export$af959912bf89ae42)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $b8a912ae4e1407d7$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $47bc08b8723be306$export$d399a86cc775ad7e)(slice));
const $b8a912ae4e1407d7$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $fAWGo.PasteTypes).plain
        }))((0, $47bc08b8723be306$export$98135102f7ccdef2)(text));
const $b8a912ae4e1407d7$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $47bc08b8723be306$export$5fb647c5a57bac64)((0, $krYZG.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $b8a912ae4e1407d7$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $47bc08b8723be306$export$de618421675f910e)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $b8a912ae4e1407d7$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $fAWGo.PasteTypes).markdown
    }))((0, $47bc08b8723be306$export$4b83e18c607f848f)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $b8a912ae4e1407d7$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $fAWGo.PasteTypes).richText
    }, pluginInjectionApi))((0, $47bc08b8723be306$export$f9c7e15c780a77d0)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection);
                    editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $b8a912ae4e1407d7$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $fAWGo.PasteTypes).richText
        }))((0, $47bc08b8723be306$export$3fd7f6d89a9d2cac)(slice, findRootParentListNode));
const $b8a912ae4e1407d7$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $fAWGo.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $47bc08b8723be306$export$b8a52be876d0b84f)(slice));
const $b8a912ae4e1407d7$export$6681e5bfb9c8b704 = (editorAnalyticsAPI)=>(view, event, slice)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $fAWGo.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $47bc08b8723be306$export$a497757c6eac4530)(slice));
const $b8a912ae4e1407d7$export$7dc8d4c52517a2f7 = (editorAnalyticsAPI, isNestingTablesSupported)=>(view, event, slice)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $fAWGo.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $47bc08b8723be306$export$113227139658cc8d)(slice, isNestingTablesSupported));
const $b8a912ae4e1407d7$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $fAWGo.PasteTypes).richText
        }))((0, $47bc08b8723be306$export$4ce587bb5876886d)(editorAnalyticsAPI)(slice));
const $b8a912ae4e1407d7$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$b8a912ae4e1407d7$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($b8a912ae4e1407d7$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $47bc08b8723be306$export$5e27b285bdcc71bf)(slice));
const $b8a912ae4e1407d7$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $b8a912ae4e1407d7$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $krYZG.ACTION).PASTED_TIMED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $b8a912ae4e1407d7$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$b8a912ae4e1407d7$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};











/**
 * Builds additional parseDOM rules to inject into the clipboard parser.
 *
 * Adding a rule with a higher priority than the default schema rules, allows
 * specific HTML patterns to be parsed as a different node type than the schema
 * would normally choose.
 */ function $0271413991fefa5a$var$buildAdditionalClipboardParseRules(schema) {
    const rules = [];
    // This means that panels with tables inside always stay as panel_c1,
    // but panels without tables retain standard behaviour
    // of choosing between panel_c1 and panel depending on the context.
    // e.g. panel with table pasted in expand gets lifted out, panel with normal text gets pasted inside expand
    const { panel_c1: panel_c1, panel: panel } = schema.nodes;
    if (!panel_c1 || !panel) return rules;
    const panelGetAttrs = panel.spec.parseDOM?.[0]?.getAttrs;
    rules.push({
        tag: 'div[data-panel-type]',
        priority: 60,
        node: panel_c1.name,
        getAttrs: (dom)=>{
            const hasEditorTable = dom.querySelector('[data-prosemirror-node-name="table"]') !== null;
            const hasRendererTable = (0, $4o0zT.isExperimentEnabled)('platform_editor_nest_in_table_renderer_paste') && dom.querySelector('.pm-table-container table') !== null;
            const hasTable = hasEditorTable || hasRendererTable;
            if (!hasTable) return false; // fall through to standard panel rule
            return panelGetAttrs ? panelGetAttrs(dom) : null;
        }
    });
    return rules;
}
function $0271413991fefa5a$export$973a4e50710cf49d(schema) {
    if (!(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return undefined;
    const additionalRules = $0271413991fefa5a$var$buildAdditionalClipboardParseRules(schema);
    const baseParser = (0, $aPdNQ.DOMParser).fromSchema(schema);
    const customParser = new (0, $aPdNQ.DOMParser)(schema, [
        ...additionalRules,
        ...baseParser.rules
    ]);
    return customParser;
}



var $efgwK = parcelRequire("efgwK");

function $a9ccdcb1e15b0379$export$98b67e7d9513bbaf(intl) {
    return (slice)=>{
        const blockSeparator = '\n\n';
        return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
            switch(leafNode.type.name){
                case 'hardBreak':
                    return '\n';
                case 'text':
                    return leafNode.text;
                case 'inlineCard':
                    return leafNode.attrs.url;
                case 'blockCard':
                    return leafNode.attrs.url;
                // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
                // pasting a mention does not actually work for the in-product Mention implementation.
                // However, this is also true of the previous implementation.
                // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
                case 'mention':
                    return leafNode.attrs.text;
                case 'date':
                    return (0, $efgwK.timestampToString)(leafNode.attrs.timestamp, intl);
                default:
                    // Unsupported node
                    return leafNode.text ?? '';
            }
        });
    };
}





var $8Xus6 = parcelRequire("8Xus6");




function $de22665ebe907027$var$safelyGetVSCodeLanguage(editorData) {
    try {
        const vscodeData = editorData ? JSON.parse(editorData) : undefined;
        return vscodeData?.mode;
    } catch  {}
}
function $de22665ebe907027$export$d920fedcc56c4475({ state: state, slice: slice, text: text, event: event }) {
    const vscodeData = event?.clipboardData?.getData('vscode-editor-data');
    const language = $de22665ebe907027$var$safelyGetVSCodeLanguage(vscodeData);
    if (text && language && (0, $8Xus6.SUPPORTED_LANGUAGES).some((l)=>l.alias[0] === language)) {
        const { schema: schema } = state;
        slice = (0, $fud2r.mapSlice)(slice, (node)=>{
            if (node.type.name === schema.nodes.codeBlock?.name) return schema.nodes.codeBlock.createChecked({
                language: language
            }, schema.text(text));
            return node;
        });
    }
    return slice;
}



var $jv11C = parcelRequire("jv11C");





function $d8c2ec25e2abc102$export$8457533209b7e8af(text, schema, openStart, openEnd, markdownToPmConverter, wrapBareUrls) {
    // The injected GFM converter enables tables, task lists, and strikethrough
    // individually, but does not enable the GFM autolink-literal extension. In
    // the treatment, wrap bare URLs in CommonMark autolink syntax so the card
    // plugin receives a link mark to resolve. Preserve the current behavior in
    // control while the fix rolls out.
    const escapedTextInput = (0, $13a9f9985923029f$export$3e81f5aaf68cd698)(text, {
        skipLinkEscaping: !wrapBareUrls
    });
    try {
        const doc = schema.nodes.doc.createAndFill({}, markdownToPmConverter({
            markdown: escapedTextInput,
            schema: schema
        }));
        if (doc && doc.content) return new (0, $aPdNQ.Slice)(doc.content, openStart, openEnd);
    } catch (e) {
        (0, $jv11C.logException)(e instanceof Error ? e : new Error(String(e)), {
            location: 'editor-plugin-paste/getMarkdownSlice'
        });
    }
    return undefined;
}




var $6gBg9 = parcelRequire("6gBg9");

const $18bfce6691343d17$var$isCodeBlockWithUnsetWrap = (node)=>node.attrs.wrap === null;
const $18bfce6691343d17$var$patchInsertedCodeBlocks = (tr, insertedCodeBlocks)=>{
    insertedCodeBlocks.forEach(({ node: node, pos: pos })=>{
        tr.setNodeMarkup(pos, undefined, (0, $6gBg9.getDefaultCodeBlockAttrs)(node.attrs), node.marks);
    });
};
const $18bfce6691343d17$export$85bff74b6f63f849 = (tr, codeBlockType)=>{
    if (!codeBlockType) return tr;
    const insertedCodeBlocks = (0, $6gBg9.getInsertedCodeBlocksInTransaction)(tr, codeBlockType, {
        filter: $18bfce6691343d17$var$isCodeBlockWithUnsetWrap
    });
    if (insertedCodeBlocks.length) $18bfce6691343d17$var$patchInsertedCodeBlocks(tr, insertedCodeBlocks);
    return tr;
};



var $2nOF5 = parcelRequire("2nOF5");








var $a168a3f757e20222$export$5e592dcf077082fd = /*#__PURE__*/ function(FLAG_TYPE) {
    FLAG_TYPE["WARNING"] = "warning";
    FLAG_TYPE["ERROR"] = "error";
    FLAG_TYPE["INFO"] = "info";
    FLAG_TYPE["SUCCESS"] = "success";
    return FLAG_TYPE;
}({});



// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $982b803339924d73$var$RESOURCE_ID_REGEX = /data-resource-id="(confluence-page|jira-work-item)\//;
var $982b803339924d73$var$FLAG_ID = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_PASTE_CONTENT"] = "cannot-paste-content";
    return FLAG_ID;
}($982b803339924d73$var$FLAG_ID || {});
const $982b803339924d73$var$transformSyncBlockNode = (node, schema, isFromEditor)=>{
    // if copying from renderer, flatten out the content and remove the sync block
    if (!isFromEditor) return node.content;
    // sync blocks need a unique localId to function correctly
    const newAttrs = {
        ...node.attrs,
        localId: (0, $2nOF5.uuid).generate()
    };
    return schema.nodes.syncBlock.create(newAttrs, null, [
        ...node.marks
    ]);
};
const $982b803339924d73$var$transformBodiedSyncBlockNode = (node, isFromEditor)=>{
    // if copying from renderer, flatten out the content and remove the bodied sync block
    if (!isFromEditor) return node.content;
    // this is not possible as all bodiedSyncBlocks have already been converted into a syncBlock by now.
    return node;
};
const $982b803339924d73$var$showWarningFlag = ({ api: api, title: title, description: description, urlText: urlText, urlHref: urlHref })=>{
    // Use setTimeout to dispatch transaction in next tick and avoid re-entrant dispatch
    setTimeout(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const flag = {
                id: "cannot-paste-content",
                description: description,
                title: title,
                urlText: urlText,
                urlHref: urlHref,
                type: (0, $a168a3f757e20222$export$5e592dcf077082fd).WARNING
            };
            return tr.setMeta((0, $142dabd6f33e6b5c$export$18d4026d1ea86bb1), {
                type: (0, $d112028c0c349284$export$ad3c0356f902fd97).SET_ACTIVE_FLAG,
                activeFlag: flag
            });
        });
    }, 0);
};
// Check if rawHtml contains a synced block
// example: "<meta charset='utf-8'><html><head></head><body><div data-sync-block=\"\" data-local-id=\"\" data-resource-id=\"d64883c8-1270-431d-a1d3-51d36a1ed5f4\" data-prosemirror-content-type=\"node\" data-prosemirror-node-name=\"syncBlock\" data-prosemirror-node-block=\"true\" data-pm-slice=\"0 0 []\"></div></body></html>"
const $982b803339924d73$var$hasSyncedBlockInRawHtml = (rawHtml)=>{
    return Boolean(rawHtml?.includes('data-sync-block="'));
};
/**
 * Extracts the source product of a synced block reference from the pasted raw HTML.
 *
 * A reference block's `data-resource-id` is prefixed with the source product, e.g.
 * `confluence-page/5769323474/cdf6a1bc-...`. We only ever emit a controlled,
 * enumerated value (`confluence-page` | `jira-work-item`) so the resulting
 * analytics attribute can never carry user-generated content. Returns `undefined`
 * when the marker is missing or the prefix is unrecognised.
 *
 * Note: this intentionally mirrors `getSourceProductFromResourceIdSafe` from
 * `@atlaskit/editor-synced-block-provider/utils` but is duplicated locally to
 * avoid adding a cross-package dependency from the paste plugin onto the
 * synced-block provider.
 */ const $982b803339924d73$var$getSourceProductFromRawHtml = (rawHtml)=>{
    // The capture group already constrains the match to exactly these two literals,
    // so the assertion is safe. This mirrors `getContentIdAndProductFromResourceId`
    // in `@atlaskit/editor-synced-block-provider`.
    const match = rawHtml.match($982b803339924d73$var$RESOURCE_ID_REGEX);
    return match?.[1];
};
const $982b803339924d73$export$27da60ebda8ac583 = (slice, schema, pasteSource, rawHtml, pasteWarningOptions, api)=>{
    const isFromEditor = pasteSource === 'fabric-editor';
    const isSyncedBlockInRawHtml = $982b803339924d73$var$hasSyncedBlockInRawHtml(rawHtml);
    let hasSyncedBlockInSlice = false;
    slice = (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.syncBlock) {
            hasSyncedBlockInSlice = true;
            return $982b803339924d73$var$transformSyncBlockNode(node, schema, isFromEditor);
        } else if (node.type === schema.nodes.bodiedSyncBlock) {
            hasSyncedBlockInSlice = true;
            return $982b803339924d73$var$transformBodiedSyncBlockNode(node, isFromEditor);
        }
        return node;
    });
    // A synced block reference was on the clipboard (`isSyncedBlockInRawHtml`) but the
    // destination schema dropped it (`!hasSyncedBlockInSlice`) — i.e. the user attempted
    // to insert a synced block into a surface that does not support synced blocks (e.g.
    // Bitbucket). Emit a track event so this can be measured directly instead of relying
    // on the "copied-but-never-landed" proxy. See EDITOR-7749.
    if (!hasSyncedBlockInSlice && isSyncedBlockInRawHtml) {
        api?.analytics?.actions?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).INSERT_ATTEMPTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).UNSUPPORTED_SURFACE,
            attributes: {
                sourceProduct: $982b803339924d73$var$getSourceProductFromRawHtml(rawHtml),
                pasteSource: pasteSource
            }
        });
        if (pasteWarningOptions?.cannotPasteSyncedBlock) $982b803339924d73$var$showWarningFlag({
            api: api,
            title: pasteWarningOptions?.cannotPasteSyncedBlock?.title,
            description: pasteWarningOptions?.cannotPasteSyncedBlock?.description,
            urlText: pasteWarningOptions?.cannotPasteSyncedBlock?.urlText,
            urlHref: pasteWarningOptions?.cannotPasteSyncedBlock?.urlHref
        });
    }
    return slice;
};



var $kgt0V = parcelRequire("kgt0V");

const $ef3d06398a41c8aa$var$isPastedFromTinyMCE = (pasteEvent)=>{
    return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
};
const $ef3d06398a41c8aa$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $ef3d06398a41c8aa$var$isPastedFromTinyMCE(pasteEvent) && !!html && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $ef3d06398a41c8aa$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $ef3d06398a41c8aa$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $ef3d06398a41c8aa$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($ef3d06398a41c8aa$var$exactlyDivisible(thCount, cellCount) || $ef3d06398a41c8aa$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $ef3d06398a41c8aa$var$configureTableRows = (doc, colsInRow)=>{
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($kgt0V)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody?.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $ef3d06398a41c8aa$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    let extraCellsCount = 0;
    while(!$ef3d06398a41c8aa$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell?.parentElement?.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $ef3d06398a41c8aa$export$d749bb0e238929f2 = (doc)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $ef3d06398a41c8aa$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $ef3d06398a41c8aa$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $ef3d06398a41c8aa$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($ef3d06398a41c8aa$var$exactlyDivisible(thCount, possibleColsInRow) && $ef3d06398a41c8aa$var$exactlyDivisible(cellCount, possibleColsInRow)) return $ef3d06398a41c8aa$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $ef3d06398a41c8aa$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $ef3d06398a41c8aa$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $ef3d06398a41c8aa$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $ef3d06398a41c8aa$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};


const $63957a007f7dead9$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $bjg0G.hasParentNodeOfType)(blockquote)(state.selection);
};
const $63957a007f7dead9$var$enableNewDomainCheckToImproveSmartLinkResolveRate = (hostname)=>{
    return(// OneDrive Shortlinks
    hostname.endsWith('1drv.ms') || // MS Teams links
    hostname.endsWith('teams.live.com') || hostname.endsWith('teams.cloud.microsoft') || hostname.endsWith('teams.microsoft.com') || // MS Power BI
    hostname.endsWith('powerbi.com') || // MS Azure devops
    hostname.endsWith('dev.azure.com') || hostname.endsWith('visualstudio.com'));
};
const $63957a007f7dead9$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $63957a007f7dead9$export$c503e2315ac846a7(url) {
    if (!url) return false;
    try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname.toLowerCase();
        const protocol = urlObj.protocol.toLowerCase();
        // Only accept HTTPS URLs for security
        if (protocol !== 'https:') return false;
        // Check if hostname ends with the trusted domains (not just contains them)
        return hostname.endsWith('sharepoint.com') || hostname.endsWith('onedrive.com') || hostname.endsWith('onedrive.live.com') || $63957a007f7dead9$var$enableNewDomainCheckToImproveSmartLinkResolveRate(hostname);
    } catch  {
        // If URL parsing fails, return false for safety
        return false;
    }
}
function $63957a007f7dead9$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, getIntl, cardOptions, sanitizePrivateContent, providerFactory, pasteWarningOptions, markdownToPmConverter) {
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const atlassianMarkDownParser = new (0, $c9zHD.MarkdownTransformer)(schema, (0, $h6b2D.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        if (markdownToPmConverter && (0, $ieeJu.expValEquals)('platform_editor_paste_as_md_use_gfm', 'isEnabled', true)) return (0, $d8c2ec25e2abc102$export$8457533209b7e8af)(text, schema, openStart, openEnd, markdownToPmConverter, (0, $4o0zT.isExperimentEnabled)('platform_editor_gfm_link_paste_fix'));
        const escapedTextInput = (0, $13a9f9985923029f$export$3e81f5aaf68cd698)(text);
        const doc = atlassianMarkDownParser.parse(escapedTextInput);
        if (doc && doc.content) return new (0, $aPdNQ.Slice)(doc.content, openStart, openEnd);
        return;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $50UK1.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $142dabd6f33e6b5c$export$18d4026d1ea86bb1),
        state: (0, $142dabd6f33e6b5c$export$656c7661095efe2e)(dispatch, {
            activeFlag: null,
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            // For serialising to plain text
            clipboardTextSerializer: (0, $a9ccdcb1e15b0379$export$98b67e7d9513bbaf)(getIntl()),
            clipboardParser: (0, $0271413991fefa5a$export$973a4e50710cf49d)(schema),
            handleDOMEvents: {
                // note
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    if (event.clipboardData) (0, $eFgM7.insm).startHeavyTask('paste');
                    return false;
                }
            },
            // note
            handlePaste (view, rawEvent, slice) {
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Extract clientId values from pasted HTML for media cross-product copy/paste
                // This must be done before ProseMirror parses the HTML, as clientId is not stored in ADF
                if ((0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) (0, $bGrTZ.extractClientIdsFromHtml)(html);
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(schema.text(text)), 1, 1);
                }
                if (text?.includes('\r')) // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                text = text.replace(/\r/g, '');
                // Strip Legacy Content Macro (LCM) extensions on paste
                if (!(0, $iDrrr.fg)('platform_editor_legacy_content_macro_insert')) slice = (0, $jlFP9.transformSliceToRemoveLegacyContentMacro)(slice, schema);
                const isPastedFile = (0, $4aSpR.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) {
                        (0, $eFgM7.insm).endHeavyTask('paste');
                        /**
             * Microsoft Office, Number, Pages, etc. adds an image to clipboard
             * with other mime-types so we don't let the event reach media.
             * The detection ration here is that if the payload has both `html` and
             * `files`, then it could be one of above or an image copied from web.
             * Here, we don't have html, so we return true to allow default event behaviour
             */ return true;
                    }
                    /**
           * We want to return false for external copied image to allow
           * it to be uploaded by the client.
           *
           * Scenario where we are pasting an external image inside a block quote
           * is skipped and handled in handleRichText
           */ if ((0, $13a9f9985923029f$export$41d193509f55b76e)(html) && !$63957a007f7dead9$export$eedfdbc6a6bc1442(view.state)) {
                        (0, $eFgM7.insm).endHeavyTask('paste');
                        return true;
                    }
                    /**
           * https://product-fabric.atlassian.net/browse/ED-21993
           * stopImmediatePropagation will run the first event attached to the same element
           * Which chould have race condition issue
           */ event.stopPropagation();
                }
                const { state: state } = view;
                const content = (0, $b8a912ae4e1407d7$export$629ff5588e070c83)(slice.content);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const pasteId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
                const measureName = `${$63957a007f7dead9$var$PASTE}_${pasteId}`;
                (0, $5vSgR.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                    const payload = (0, $b8a912ae4e1407d7$export$5dd5834ba1e07721)({
                        view: view,
                        duration: duration,
                        content: content,
                        distortedDuration: distortedDuration
                    });
                    if (payload) dispatchAnalyticsEvent(payload);
                    (0, $eFgM7.insm).endHeavyTask('paste');
                });
                const getLastReplaceStepSlice = (tr)=>{
                    let slice;
                    for (const step of tr.steps){
                        const stepSlice = (0, $jGEbn.extractSliceFromStep)(step);
                        if (stepSlice) slice = stepSlice;
                    }
                    return slice;
                };
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        const slice = (0, $jGEbn.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice?.content?.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    // Don't flag as a paste event (add closeHistory) when the paste affects a list and
                    // the list plugin's appendTransaction will normalise the structure, and we want the
                    // paste + normalisation to be a single undo step.
                    // Pasting into an existing list — selection is inside a list node.
                    let isPastingIntoList = false;
                    // Pasting list content from an external source — slice top-level contains a list node.
                    let isPastingListContent = false;
                    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true)) {
                        const listNodeTypes = [
                            state.schema.nodes.bulletList,
                            state.schema.nodes.orderedList,
                            state.schema.nodes.taskList
                        ].filter((n)=>Boolean(n));
                        isPastingIntoList = (0, $bjg0G.hasParentNodeOfType)(listNodeTypes)(state.selection);
                        for(let i = 0; i < slice.content.childCount; i++)if (listNodeTypes.includes(slice.content.child(i).type)) {
                            isPastingListContent = true;
                            break;
                        }
                    }
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && !isPastingIntoList && !isPastingListContent && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) tr = (0, $18bfce6691343d17$export$85bff74b6f63f849)(tr, schema.nodes.codeBlock);
                    const isDocChanged = tr.docChanged;
                    (0, $2HZqG.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $krYZG.ACTION).PASTED_AS_PLAIN : (0, $krYZG.ACTION).PASTED,
                        inputMethod: (0, $krYZG.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        const pastedSlice = getLastReplaceStepSlice(tr);
                        if (pastedSlice) {
                            const pasteStartPos = state.selection.from;
                            const pasteEndPos = tr.selection.to;
                            const contentPasted = {
                                pasteStartPos: pasteStartPos,
                                pasteEndPos: pasteEndPos,
                                text: text,
                                isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                                view.shiftKey || view.input?.shiftKey),
                                isPlainText: Boolean(isPlainText),
                                pastedSlice: pastedSlice,
                                pastedAt: Date.now(),
                                pasteSource: (0, $13a9f9985923029f$export$e45b5b7458bacd81)(event),
                                sourcePastedSlice: slice
                            };
                            tr.setMeta((0, $142dabd6f33e6b5c$export$18d4026d1ea86bb1), {
                                type: (0, $d112028c0c349284$export$ad3c0356f902fd97).ON_PASTE,
                                contentPasted: contentPasted
                            });
                        }
                    }
                    // the handlePaste definition overrides the generic prosemirror behaviour which would previously
                    // include a uiEvent meta of paste. To align with the docs (https://prosemirror.net/docs/ref/#state.Transaction)
                    // This will re-add the uiEvent meta.
                    view.dispatch(tr.setMeta('uiEvent', 'paste'));
                };
                slice = (0, $47bc08b8723be306$export$feb0d61bf65d9267)(state, slice);
                if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
                    const destinationParentType = view.state.selection.$from.node(-1)?.type.name ?? view.state.doc.type.name;
                    slice = (0, $47bc08b8723be306$export$ce2b3491c532dd9d)(slice, schema, destinationParentType);
                }
                slice = (0, $de22665ebe907027$export$d920fedcc56c4475)({
                    state: state,
                    slice: slice,
                    event: event,
                    text: text
                });
                slice = (0, $982b803339924d73$export$27da60ebda8ac583)(slice, schema, (0, $13a9f9985923029f$export$e45b5b7458bacd81)(event), html, pasteWarningOptions, pluginInjectionApi);
                const plainTextPasteSlice = (0, $4wRTw.linkifyContent)(state.schema)(slice);
                if ((0, $b8a912ae4e1407d7$export$69d6e3902009956e)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                if ((0, $b8a912ae4e1407d7$export$e1d2fb186881c383)(editorAnalyticsAPI)(view, event, slice, (0, $fAWGo.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                // https://product-fabric.atlassian.net/browse/MEX-1520
                // Converting caption to plain text needs to be handled before transformSliceForMedia
                // as createChecked will fail when trying to create a mediaSingle node with a caption
                // that is not plain text.
                return true;
                // transform slices based on destination
                slice = (0, $29c0d3539e09a749$export$5ed9534d355a0a0f)(slice, schema, pluginInjectionApi)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                    if (markdownSlice) {
                        // linkify text prior to converting to macro
                        if ((0, $b8a912ae4e1407d7$export$b36a7c9ea20b7bbf)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $fAWGo.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $47bc08b8723be306$export$d23738992a74c3a9)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $b8a912ae4e1407d7$export$5ee87eef0a304a1b)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $fAWGo.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $13a9f9985923029f$export$9ffea5586131a948)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode?.type;
                // panel_c1 is a schema variant of panel (table-in-panel); when the experiment is on,
                // handle it the same way as a panel.
                const edgeCaseNodeTypes = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    schema.nodes?.panel,
                    schema.nodes?.panel_c1,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ] : [
                    schema.nodes?.panel,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $b8a912ae4e1407d7$export$9fea421173ba6d7d)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $b8a912ae4e1407d7$export$b49fd82cf59cd44e)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $fAWGo.PasteTypes).binary : (0, $fAWGo.PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $b8a912ae4e1407d7$export$6dbadac5ea22dd7a)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $b8a912ae4e1407d7$export$629ff5588e070c83)(markdownSlice.content).includes(schema.nodes.table?.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // get editor-tables to handle pasting tables if it can
                // otherwise, just the replace the selection with the content
                if ((0, $h9YGx.handlePaste)(view, event, slice, {
                    pasteSource: (0, $13a9f9985923029f$export$e45b5b7458bacd81)(event)
                })) {
                    (0, $b8a912ae4e1407d7$export$5ee87eef0a304a1b)(editorAnalyticsAPI)(view, event, slice, {
                        type: (0, $fAWGo.PasteTypes).richText
                    });
                    return true;
                }
                // handle paste of nested tables to ensure nesting limits are respected
                if ((0, $b8a912ae4e1407d7$export$7dc8d4c52517a2f7)(editorAnalyticsAPI, (0, $hZ5o2.isNestedTablesSupported)(state.schema))(view, event, slice)(state, dispatch)) return true;
                if ((0, $b8a912ae4e1407d7$export$e3873690443e0966)(view, event, slice, isPlainText ? (0, $fAWGo.PasteTypes).plain : (0, $fAWGo.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $b8a912ae4e1407d7$export$ef36b80b79d1d973)(view, event, markdownSlice, (0, $fAWGo.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $b8a912ae4e1407d7$export$d7489d309972091e)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $63957a007f7dead9$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $fud2r.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $bjg0G.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    // linkify the text where possible
                    slice = (0, $4wRTw.linkifyContent)(state.schema)(slice);
                    if ((0, $b8a912ae4e1407d7$export$b36a7c9ea20b7bbf)(editorAnalyticsAPI)(view, event, slice, (0, $fAWGo.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $47bc08b8723be306$export$d23738992a74c3a9)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                        // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $b8a912ae4e1407d7$export$5ee87eef0a304a1b)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $fAWGo.PasteTypes).richText
                        });
                        return true;
                    }
                    // Special handling for SharePoint URLs generated from Share button
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    if ($63957a007f7dead9$export$c503e2315ac846a7(text) && ((0, $iDrrr.fg)('platform_editor_sharepoint_url_smart_card_fallback') || (0, $iDrrr.fg)('platform_editor_sharepoint_url_smart_card_jira'))) {
                        // Create an inline card directly for SharePoint URLs to show the "Connect" button
                        const inlineCardNode = schema.nodes.inlineCard.create({
                            url: text
                        });
                        const cardSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(inlineCardNode), 0, 0);
                        if (dispatch) dispatch(state.tr.replaceSelection(cardSlice));
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $47bc08b8723be306$export$36e0fe2cadced224)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $fRYCB.containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                    if ((0, $b8a912ae4e1407d7$export$ef36b80b79d1d973)(view, event, slice, (0, $fAWGo.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if ((0, $iDrrr.fg)('platform_editor_lovability_resize_patch_2') ? selectionParentType !== state.schema.nodes.doc : // When pasting at a root GapCursor, selection depth is 0 and there is no
                    // parent node to resolve. Treat it as doc-level so valid breakout marks stay.
                    selectionParentType !== state.schema.nodes.doc && selectionDepth !== 0) {
                        const sliceCopy = (0, $aPdNQ.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    if ((0, $b8a912ae4e1407d7$export$6681e5bfb9c8b704)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $5I4Vo.insideTable)(state)) slice = (0, $jPUdw.transformSliceNestedExpandToExpand)(slice, state.schema);
                    if ((0, $b8a912ae4e1407d7$export$2d195c5439ce2ebc)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $b8a912ae4e1407d7$export$bbc9709b7b4a2f6)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    return (0, $b8a912ae4e1407d7$export$3ef868f9e7157717)(view, event, slice, pluginInjectionApi)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                if (sanitizePrivateContent) slice = (0, $47bc08b8723be306$export$7097a0398467de9c)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
         * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $e2ed0dd090521fdb$export$5a682e48ed34e262)(slice);
                // Filter out expand nodes if allowExpand is false
                if (!pluginInjectionApi?.expand?.sharedState?.currentState()?.allowInsertion && (0, $ieeJu.expValEquals)('platform_editor_expand_paste_in_comment_editor', 'isEnabled', true)) slice = (0, $47bc08b8723be306$export$ce28e8ccb2f7a3dd)(slice);
                slice = (0, $29fba5bb76034c39$export$d1dc8019f50dded8)(slice, schema);
                slice = (0, $29c0d3539e09a749$export$bd95a8dd607682c8)(slice, schema);
                slice = (0, $29c0d3539e09a749$export$77944619eaa3fcd3)(slice, schema, pluginInjectionApi);
                slice = (0, $0d5e4f4efdd96eef$export$65d21b4bef5d424b)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $a69d310c7883283b$export$f2dc3112f5c2bd10)(slice, schema);
                slice = (0, $a69d310c7883283b$export$df231bdf1595dd19)(slice, schema);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $aPdNQ.Slice)(slice.content, 0, 0);
                if (!(0, $fqVYq.editorExperiment)('single_column_layouts', true)) slice = (0, $5M2nW.transformSingleColumnLayout)(slice, schema);
                slice = (0, $aDwKe.transformSliceToRemoveMacroId)(slice, schema);
                if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_schema', 'isEnabled', true) && !(0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) // Prevent pasted externally-authored flexible list HTML from producing flexible list structures
                // Only when schema support is enabled but indentation behaviour is not, meaning editor gracefully
                // handles the structure, but ideally does not produce it
                slice = (0, $lGcQw.transformSliceEnsureListItemParagraphFirst)(slice, schema);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre/g, '');
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $ef3d06398a41c8aa$export$4a3cccc9bf9da386)(mostRecentPasteEvent, html) && (0, $ef3d06398a41c8aa$export$120b137b77798e76)(html)) {
                    const completeTableHtml = (0, $ef3d06398a41c8aa$export$253f7bda9f1e0696)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $13a9f9985923029f$export$6ba9f527e53e4ac1)(html) && !(0, $13a9f9985923029f$export$8d0b7622c89b176c)(html) && html.indexOf('<img ') >= 0) html = (0, $29c0d3539e09a749$export$3b69af3aaae9ee54)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $13a9f9985923029f$export$3c3a613abe5bb97d)(html)) html = (0, $13a9f9985923029f$export$35ca1bb0581efaf3)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                // Remove breakout marks HTML around sync block renderer nodes
                // so the breakout mark doesn't get applied to the wrong nodes
                if (html.indexOf((0, $95bQO.SyncBlockRendererDataAttributeName)) >= 0 && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) html = (0, $1de63454be902e74$export$2dccb54a894dbcd3)(html);
                // When platform_editor_nest_table_in_panel is OFF,
                // move tables out of panel divs in the HTML before ProseMirror
                // parses it — otherwise the panel schema drops the table content.
                if (!(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) html = (0, $47bc08b8723be306$export$f596ff5b0d9c556a)(html);
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}











var $0b767f3e55b27796$export$a5fa3822909c7e0 = /*#__PURE__*/ function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    return MoveAnalyticPluginTypes;
}({});








const $67eb2511e64058ce$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('moveAnalyticsPlugin');



// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $41d1ef868ff58ca5$export$49d5fc8cba920a0 = {
    contentMoved: {
        size: undefined,
        nodeDepth: undefined,
        currentActions: [],
        nodeTypes: undefined,
        hasSelectedMultipleNodes: undefined
    }
};


const $23f1c803238eadcd$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $0b767f3e55b27796$export$a5fa3822909c7e0).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $0b767f3e55b27796$export$a5fa3822909c7e0).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $41d1ef868ff58ca5$export$49d5fc8cba920a0).contentMoved
            };
        default:
            return state;
    }
};


const $b5f316287e146a55$var$dest = (0, $cI8RZ.pluginFactory)((0, $67eb2511e64058ce$export$18d4026d1ea86bb1), (0, $23f1c803238eadcd$export$1650419e431d3ba3));
const $b5f316287e146a55$export$656c7661095efe2e = $b5f316287e146a55$var$dest.createPluginState;
const $b5f316287e146a55$export$8d4021544bdece00 = $b5f316287e146a55$var$dest.createCommand;
const $b5f316287e146a55$export$f05434c51e3762e = $b5f316287e146a55$var$dest.getPluginState;



const $d62b7004b23891ed$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $b5f316287e146a55$export$8d4021544bdece00)((state)=>{
        const { contentMoved: contentMoved } = (0, $b5f316287e146a55$export$f05434c51e3762e)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: nextState?.size || contentMoved.size,
            nodeDepth: nextState?.nodeDepth,
            nodeTypes: nextState?.nodeTypes,
            hasSelectedMultipleNodes: nextState?.hasSelectedMultipleNodes
        };
        return {
            type: (0, $0b767f3e55b27796$export$a5fa3822909c7e0).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $d62b7004b23891ed$export$56834735aa39d3eb = ()=>(0, $b5f316287e146a55$export$8d4021544bdece00)(()=>{
        return {
            type: (0, $0b767f3e55b27796$export$a5fa3822909c7e0).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $d62b7004b23891ed$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $0b767f3e55b27796$export$a5fa3822909c7e0).RemoveMovedAction
        };
        return tr.setMeta((0, $67eb2511e64058ce$export$18d4026d1ea86bb1), payload);
    };









var $8HW7o = parcelRequire("8HW7o");




const $76257eba6a42b292$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $76257eba6a42b292$export$75248da1527ddfc1 = (nodeName)=>$76257eba6a42b292$var$excludedNodes.includes(nodeName);
const $76257eba6a42b292$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $76257eba6a42b292$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $76257eba6a42b292$export$82ae59a0847ee78b = (nodeName)=>{
    return $76257eba6a42b292$var$inlineNodes.includes(nodeName);
};
const $76257eba6a42b292$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $76257eba6a42b292$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $8HW7o.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $76257eba6a42b292$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $bjg0G.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $76257eba6a42b292$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};
const $76257eba6a42b292$export$c4a09517c4982d7c = (content)=>{
    for(let i = 0; i < content.childCount; i++){
        const nodeName = content.maybeChild(i)?.type.name || '';
        if ($76257eba6a42b292$export$75248da1527ddfc1(nodeName)) return true;
    }
    return false;
};
const $76257eba6a42b292$export$f3a535d61fe1eda3 = (content)=>{
    const nodeTypes = [];
    if (content.size) content.forEach((node)=>{
        nodeTypes.push(node.type.name);
    });
    return {
        nodeTypes: (0, $iDrrr.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};


const $8e7c1110a74ffc36$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $67eb2511e64058ce$export$18d4026d1ea86bb1),
        state: (0, $b5f316287e146a55$export$656c7661095efe2e)(dispatch, (0, $41d1ef868ff58ca5$export$49d5fc8cba920a0)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, _event, slice)=>{
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $b5f316287e146a55$export$f05434c51e3762e)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = content.firstChild?.type.name;
                if (!nodeName || !contentMoved?.nodeTypes || !(0, $76257eba6a42b292$export$14f96cade94e47c)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).MOVED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeDepth: contentMoved?.nodeDepth,
                        destinationNodeDepth: (0, $76257eba6a42b292$export$568289ef11d607ce)(state.selection),
                        nodeTypes: contentMoved?.nodeTypes,
                        hasSelectedMultipleNodes: contentMoved?.hasSelectedMultipleNodes
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $d62b7004b23891ed$export$47c45651eb91dff0)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                const { selection: selection } = state;
                const isMultiSelectTrackingEnabled = (0, $iDrrr.fg)('platform_editor_track_node_types');
                const nodeName = content.firstChild?.type.name || '';
                let nodeTypes, hasSelectedMultipleNodes = false;
                if (content.childCount > 1) {
                    if (isMultiSelectTrackingEnabled) {
                        if ((0, $76257eba6a42b292$export$c4a09517c4982d7c)(content)) resetState = true;
                        else {
                            const attributes = (0, $76257eba6a42b292$export$f3a535d61fe1eda3)(content);
                            nodeTypes = attributes.nodeTypes;
                            hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                        }
                    } else resetState = true;
                } else if (content.childCount === 1) {
                    // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                    // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                    // These nodes were added to excludedNodes array.
                    if (!resetState && (0, $76257eba6a42b292$export$75248da1527ddfc1)(nodeName)) resetState = true;
                    if (!resetState && !(0, $76257eba6a42b292$export$b6cb43348b690a2d)(selection)) resetState = true;
                    if (!resetState && (0, $76257eba6a42b292$export$82ae59a0847ee78b)(nodeName) && (0, $76257eba6a42b292$export$8cd6af93b47990b9)(selection)) resetState = true;
                    if (!resetState && (0, $76257eba6a42b292$export$78b714f3f17d88b0)(state)) resetState = true;
                } else resetState = true;
                if (resetState) (0, $d62b7004b23891ed$export$56834735aa39d3eb)()(state, dispatch);
                else {
                    let newState = {
                        size: size,
                        nodeTypes: nodeTypes,
                        nodeDepth: (0, $76257eba6a42b292$export$568289ef11d607ce)(selection)
                    };
                    if (isMultiSelectTrackingEnabled) newState = {
                        ...newState,
                        nodeTypes: nodeTypes ?? nodeName,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    };
                    (0, $d62b7004b23891ed$export$7c2867f48317a29d)(newState, 'contentCut')(state, dispatch);
                }
                isCutEvent = false;
                return slice;
            }
        }
    });
};






parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $a2foB = parcelRequire("a2foB");

var $FKQbh = parcelRequire("FKQbh");

var $lqtHz = parcelRequire("lqtHz");


var $24dy7 = parcelRequire("24dy7");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");




const $e34f909bdf94d1fe$export$48ea269755562084 = ({ api: api })=>{
    const { activeFlag: activeFlag } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'paste'
    ], (states)=>({
            activeFlag: states.pasteState?.activeFlag
        }));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!activeFlag) return;
    const { type: type, onDismissed: onDismissedCallback, description: flagDescription, title: flagTitle, urlText: flagUrlText, urlHref: flagUrlHref } = activeFlag;
    const description = flagDescription ? formatMessage(flagDescription) : undefined;
    const title = flagTitle ? formatMessage(flagTitle) : undefined;
    const urlText = flagUrlText ? formatMessage(flagUrlText) : undefined;
    const onDismissed = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            onDismissedCallback?.(tr);
            const oldMeta = tr.getMeta((0, $142dabd6f33e6b5c$export$18d4026d1ea86bb1));
            tr.setMeta((0, $142dabd6f33e6b5c$export$18d4026d1ea86bb1), {
                ...oldMeta,
                type: (0, $d112028c0c349284$export$ad3c0356f902fd97).SET_ACTIVE_FLAG,
                activeFlag: false
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    const getActions = ()=>{
        const action = urlText && flagUrlHref ? {
            content: urlText,
            href: flagUrlHref
        } : undefined;
        if (action) return [
            {
                content: action.content,
                href: action.href,
                target: '_blank'
            }
        ];
        return undefined;
    };
    const getFlagComponent = ()=>{
        if (type === (0, $a168a3f757e20222$export$5e592dcf077082fd).INFO || type === (0, $a168a3f757e20222$export$5e592dcf077082fd).SUCCESS) return 0, $a2foB.default;
        return 0, $FKQbh.default;
    };
    const FlagComponent = getFlagComponent();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(FlagComponent, {
            onDismissed: onDismissed,
            title: title,
            description: description,
            id: activeFlag.id,
            testId: activeFlag.id,
            icon: $e34f909bdf94d1fe$var$typeToIcon(type),
            actions: getActions()
        })
    });
};
const $e34f909bdf94d1fe$var$typeToIcon = (type)=>{
    if (type === 'error') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
    if (type === 'warning') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
};


const $d79ae58d0cfe1bc0$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage, pasteWarningOptions: pasteWarningOptions, markdownToPmConverter: markdownToPmConverter } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, getIntl: getIntl })=>(0, $63957a007f7dead9$export$ae829ec7b2625219)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, getIntl, cardOptions, sanitizePrivateContent, providerFactory, pasteWarningOptions, markdownToPmConverter)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $8e7c1110a74ffc36$export$ae829ec7b2625219)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        contentComponent: ()=>{
            if (!pasteWarningOptions) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e34f909bdf94d1fe$export$48ea269755562084), {
                api: api
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                activeFlag: null,
                lastContentPasted: null
            };
            const pluginState = (0, $142dabd6f33e6b5c$export$18d4026d1ea86bb1).getState(editorState);
            return {
                activeFlag: pluginState.activeFlag,
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};
module.exports["pastePlugin"] = $d79ae58d0cfe1bc0$export$2d7f4bd9c1268cd7;

});

parcelRegister("fAWGo", function(module, exports) {
const $1e3ac9d4c9fc88f4$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $1e3ac9d4c9fc88f4$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $1e3ac9d4c9fc88f4$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};
module.exports["PasteTypes"] = $1e3ac9d4c9fc88f4$export$2ba12a8680458b1e;
module.exports["PasteContents"] = $1e3ac9d4c9fc88f4$export$a82556f999b47168;

});

parcelRegister("5I4Vo", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");

const $5b4c7c5de7b6683b$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $bjg0G.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};
module.exports["insideTable"] = $5b4c7c5de7b6683b$export$244bf4b32387ef62;

});

parcelRegister("4aSpR", function(module, exports) {

var $1efRc = parcelRequire("1efRc");

function $1dbbe5ae25b4b67e$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return (0, $1efRc.checkClipboardTypes)(clipboardData.types, 'Files');
}
module.exports["isPastedFile"] = $1dbbe5ae25b4b67e$export$30c8e5e50a78a591;

});

parcelRegister("h6b2D", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $3GWdi = parcelRequire("3GWdi");

/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $37b6be9e84311b2c$var$handleHeadingOpen(state, token, acc, index) {
    const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $37b6be9e84311b2c$var$handleHeadingClose(state, token, acc, index) {
    const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $37b6be9e84311b2c$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $37b6be9e84311b2c$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $37b6be9e84311b2c$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}


// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $tALAR = parcelRequire("tALAR");


var $9p0BY = parcelRequire("9p0BY");


var $4wRTw = parcelRequire("4wRTw");

var $4IWLk = parcelRequire("4IWLk");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b3367add3f09ffff$var$LINK_OPEN_REGEX = /^<a[>\s]/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b3367add3f09ffff$var$LINK_CLOSE_REGEX = /^<\/a\s*>/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b3367add3f09ffff$var$HTTP_PREFIX_REGEX = /^http:\/\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b3367add3f09ffff$var$MAILTO_CASE_INSENSITIVE_REGEX = /^mailto:/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b3367add3f09ffff$var$MAILTO_REGEX = /^mailto:/;
// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b3367add3f09ffff$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $b3367add3f09ffff$var$isLinkOpen = (str)=>{
    return $b3367add3f09ffff$var$LINK_OPEN_REGEX.test(str);
};
const $b3367add3f09ffff$var$isLinkClose = (str)=>{
    return $b3367add3f09ffff$var$LINK_CLOSE_REGEX.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b3367add3f09ffff$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, $tALAR.default)();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($b3367add3f09ffff$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($b3367add3f09ffff$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $9p0BY.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $4IWLk.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $4wRTw.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $4wRTw.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace($b3367add3f09ffff$var$HTTP_PREFIX_REGEX, '');
                    else if (links[ln].schema === 'mailto:' && !$b3367add3f09ffff$var$MAILTO_CASE_INSENSITIVE_REGEX.test(urlText)) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace($b3367add3f09ffff$var$MAILTO_REGEX, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $b3367add3f09ffff$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$b3367add3f09ffff$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $b3367add3f09ffff$var$linkify);


// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6f667a625ebbc9af$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$6f667a625ebbc9af$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $6f667a625ebbc9af$var$newline);


// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $21a51fb6a3e25ab3$var$paragraph = (state, startLine)=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    const content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$21a51fb6a3e25ab3$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $21a51fb6a3e25ab3$var$paragraph);


const $6bc499e4ca866eb6$export$f4de1c043ce6927 = (0, $3GWdi.default)('zero', {
    html: false
});
$6bc499e4ca866eb6$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$6bc499e4ca866eb6$export$f4de1c043ce6927.use((0, $21a51fb6a3e25ab3$export$2e2bcd8739ae039));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$6bc499e4ca866eb6$export$f4de1c043ce6927.use((0, $b3367add3f09ffff$export$2e2bcd8739ae039));
$6bc499e4ca866eb6$export$f4de1c043ce6927.use((0, $6f667a625ebbc9af$export$2e2bcd8739ae039));
$6bc499e4ca866eb6$export$f4de1c043ce6927.use((0, $37b6be9e84311b2c$export$2e2bcd8739ae039));
module.exports["md"] = $6bc499e4ca866eb6$export$f4de1c043ce6927;

});

parcelRegister("lMCDO", function(module, exports) {
const $c559f906be0f6120$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};
module.exports["BreakoutCssClassName"] = $c559f906be0f6120$export$c21a3b023fccd534;

});

parcelRegister("5M2nW", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

const $777428f96321c8c8$export$ca45027befc3fad2 = (slice, schema)=>{
    if (slice.content.childCount === 1 && slice.openStart === 0 && slice.openEnd === 0) {
        if (slice.content.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $aPdNQ.Slice)(slice.content.firstChild.content, 0, 0);
            return newSlice;
        } else if (slice.content.firstChild?.type === schema.nodes.layoutSection && slice.content.firstChild.childCount === 1 && slice.content.firstChild.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $aPdNQ.Slice)(slice.content.firstChild.firstChild.content, 0, 0);
            return newSlice;
        }
    }
    return slice;
};
module.exports["transformSingleColumnLayout"] = $777428f96321c8c8$export$ca45027befc3fad2;

});

parcelRegister("lGcQw", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $fud2r = parcelRequire("fud2r");

const $d76d5ea421f222b0$export$f19e2607443a4dd2 = (slice, schema)=>{
    const { listItem: listItem, paragraph: paragraph } = schema.nodes;
    if (!listItem || !paragraph) return slice;
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type === listItem) {
            const firstChild = node.firstChild;
            if (firstChild && firstChild.type !== paragraph) {
                const emptyParagraph = paragraph.createAndFill();
                if (emptyParagraph) {
                    const children = [
                        emptyParagraph
                    ];
                    for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                    return node.copy((0, $aPdNQ.Fragment).from(children));
                }
            }
        }
        return node;
    });
};
module.exports["transformSliceEnsureListItemParagraphFirst"] = $d76d5ea421f222b0$export$f19e2607443a4dd2;

});

parcelRegister("jPUdw", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $fud2r = parcelRequire("fud2r");

const $2a96e70db1171dce$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $fud2r.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
module.exports["transformSliceNestedExpandToExpand"] = $2a96e70db1171dce$export$fd33fafbf6b5abc7;

});

parcelRegister("jlFP9", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $aPdNQ = parcelRequire("aPdNQ");


var $fud2r = parcelRequire("fud2r");


const $20a9d6e77eb8f875$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $fud2r.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $aPdNQ.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $20a9d6e77eb8f875$export$d2a1206296dcfa47 = (slice, schema)=>{
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (slice.content.firstChild?.type === multiBodiedExtension && slice.content.firstChild?.firstChild?.type !== extensionFrame) depthToReduce = 1;
    const fragment = (0, $fud2r.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
       *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
       */ {
            if (node.attrs.parameters?.macroMetadata?.macroId?.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $2nOF5.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $aPdNQ.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};
const $20a9d6e77eb8f875$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $20a9d6e77eb8f875$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $20a9d6e77eb8f875$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $20a9d6e77eb8f875$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $20a9d6e77eb8f875$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $20a9d6e77eb8f875$export$23ce34395aea8526 = (slice, schema)=>{
    const { extension: extension } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node.type === extension && $20a9d6e77eb8f875$var$isLegacyContentMacroExtension(node)) // Strip the node
        return null;
        return node;
    });
};
module.exports["transformSliceToRemoveOpenBodiedExtension"] = $20a9d6e77eb8f875$export$c50f82e6f2cff97d;
module.exports["transformSliceToRemoveOpenMultiBodiedExtension"] = $20a9d6e77eb8f875$export$d2a1206296dcfa47;
module.exports["transformSliceToRemoveLegacyContentMacro"] = $20a9d6e77eb8f875$export$23ce34395aea8526;

});

parcelRegister("h9YGx", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $iDrrr = parcelRequire("iDrrr");


var $8HW7o = parcelRequire("8HW7o");


var $8Z43Z = parcelRequire("8Z43Z");


var $b3vr9 = parcelRequire("b3vr9");


var $f719K = parcelRequire("f719K");


var $kWLy1 = parcelRequire("kWLy1");

// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.




var $eOaGc = parcelRequire("eOaGc");








var $ksfbF = parcelRequire("ksfbF");


var $91iSj = parcelRequire("91iSj");





var $gVdWX = parcelRequire("gVdWX");

// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $989d9d919fbe9196$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $f719K.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $aPdNQ.Fragment).from(newCells);
}
function $989d9d919fbe9196$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = $989d9d919fbe9196$export$f09c6b3b06d884fb((0, $f719K.tableNodeTypes)(schema).row, new (0, $aPdNQ.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $989d9d919fbe9196$export$f09c6b3b06d884fb((0, $f719K.tableNodeTypes)(schema).row, new (0, $aPdNQ.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$989d9d919fbe9196$var$stripHeaderType(schema, row));
    return $989d9d919fbe9196$var$ensureRectangular(schema, rowsWithoutHeaders);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $989d9d919fbe9196$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $aPdNQ.Fragment).empty);
        if (widths[r] < width) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const empty = (0, $f719K.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $aPdNQ.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $989d9d919fbe9196$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $eOaGc.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}
function $989d9d919fbe9196$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $ksfbF.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $aPdNQ.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $aPdNQ.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $989d9d919fbe9196$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $f719K.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = empty || (empty = types.cell.createAndFill());
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emptyHead || (emptyHead = types.header_cell.createAndFill()) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $aPdNQ.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $989d9d919fbe9196$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $989d9d919fbe9196$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $ksfbF.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $ksfbF.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $989d9d919fbe9196$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== cell?.type;
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $989d9d919fbe9196$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $91iSj.selectedRect)(state);
    const types = (0, $f719K.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $gVdWX.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $gVdWX.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $8Z43Z.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $8Z43Z.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($989d9d919fbe9196$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($989d9d919fbe9196$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($989d9d919fbe9196$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($989d9d919fbe9196$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($989d9d919fbe9196$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $aPdNQ.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $989d9d919fbe9196$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $8HW7o.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}


const $4c877dcce61c3400$var$SKIP_NESTED_TABLE_PASTE_SOURCES = [
    'microsoft-excel',
    'google-spreadsheets'
];
function $4c877dcce61c3400$export$5dbcc300324fed87(view, _event, slice, options) {
    if (!(0, $kWLy1.isInTable)(view.state)) return false;
    const { schema: schema } = view.state;
    const isPasteFullTableInsideEmptyCellEnabled = (0, $iDrrr.fg)('platform_editor_paste_full_table_inside_empty_cell');
    const isPartialTablePaste = slice.content.childCount === 1 && slice.content.firstChild?.type === schema.nodes.table && slice.openStart !== 0 && slice.openEnd !== 0;
    const sel = view.state.selection;
    const isCellSelection = sel instanceof (0, $8HW7o.CellSelection);
    if (isPasteFullTableInsideEmptyCellEnabled && !isPartialTablePaste && // If the selection is not a cell selection, and the selection is empty then we can insert a nested table
    !isCellSelection && sel.empty && !(options && $4c877dcce61c3400$var$SKIP_NESTED_TABLE_PASTE_SOURCES.includes(options.pasteSource))) {
        const cellRes = (0, $bjg0G.findParentNode)((node)=>node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader)(sel);
        if (cellRes) {
            const canInsertNestedTable = cellRes.node.contentMatchAt(0).matchType(schema.nodes.table)?.validEnd;
            if (canInsertNestedTable) return false;
        }
    }
    let cells = (0, $989d9d919fbe9196$export$f6d8f52489457fc4)(slice);
    if (isCellSelection) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $aPdNQ.Fragment).from((0, $989d9d919fbe9196$export$f09c6b3b06d884fb)((0, $f719K.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $8Z43Z.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $989d9d919fbe9196$export$cdcebd68073bc3f)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $989d9d919fbe9196$export$e0b94385c1fdc132)(view.state, view.dispatch, start, rect, $4c877dcce61c3400$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $b3vr9.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $8Z43Z.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $8Z43Z.TableMap).get($cell.node(-1));
        (0, $989d9d919fbe9196$export$e0b94385c1fdc132)(view.state, view.dispatch, start, rect, $4c877dcce61c3400$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $4c877dcce61c3400$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 - unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};
module.exports["handlePaste"] = $4c877dcce61c3400$export$5dbcc300324fed87;

});

parcelRegister("f719K", function(module, exports) {
function $472cad07d9de4a3c$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}
module.exports["tableNodeTypes"] = $472cad07d9de4a3c$export$c7782132717464bc;

});

parcelRegister("gVdWX", function(module, exports) {

var $8Z43Z = parcelRequire("8Z43Z");


var $91iSj = parcelRequire("91iSj");


var $f719K = parcelRequire("f719K");


var $kWLy1 = parcelRequire("kWLy1");

function $daa8b4e662d1bc81$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}
function $daa8b4e662d1bc81$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $kWLy1.isInTable)(state)) return false;
        if (dispatch) {
            const types = (0, $f719K.tableNodeTypes)(state.schema);
            const rect = (0, $91iSj.selectedRect)(state), tr = state.tr;
            const isHeaderRowEnabled = $daa8b4e662d1bc81$export$96946e3333d0ccc6('row', rect, types);
            const isHeaderColumnEnabled = $daa8b4e662d1bc81$export$96946e3333d0ccc6('column', rect, types);
            const isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            const selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $8Z43Z.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $8Z43Z.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}
module.exports["isHeaderEnabledByType"] = $daa8b4e662d1bc81$export$96946e3333d0ccc6;
module.exports["toggleHeader"] = $daa8b4e662d1bc81$export$dee0ccd8d8f5a56e;

});

parcelRegister("bGrTZ", function(module, exports) {
/**
 * Cache for storing fileId to clientId mapping during paste operations.
 * This avoids the need to store clientId in ADF schema attributes.
 *
 * Used for cross-client copy/paste scenarios
 *
 * Entries persist across reads to support multiple pastes of the same content.
 * An LRU-style max size limit guards against unbounded growth — the oldest entry
 * is evicted whenever the cache exceeds CLIENT_ID_CACHE_MAX_SIZE.
 */ const $a7b9498d98150b41$var$CLIENT_ID_CACHE_MAX_SIZE = 20;
const $a7b9498d98150b41$var$clientIdCache = new Map();
const $a7b9498d98150b41$export$e03a2c36a6c44657 = (fileId, clientId)=>{
    $a7b9498d98150b41$var$clientIdCache.set(fileId, clientId);
    // Evict oldest entries if cache exceeds max size
    if ($a7b9498d98150b41$var$clientIdCache.size > $a7b9498d98150b41$var$CLIENT_ID_CACHE_MAX_SIZE) {
        const oldestKey = $a7b9498d98150b41$var$clientIdCache.keys().next().value;
        if (oldestKey !== undefined) $a7b9498d98150b41$var$clientIdCache.delete(oldestKey);
    }
};
const $a7b9498d98150b41$export$3cac71a2bd99f367 = (fileId)=>{
    return $a7b9498d98150b41$var$clientIdCache.get(fileId);
};
const $a7b9498d98150b41$export$227522d8fd74bd7e = ()=>{
    $a7b9498d98150b41$var$clientIdCache.clear();
};
/**
 * Used to store fileId to clientId mappings on paste of Editor PM Node
 *
 * Handles two sources of pasted HTML:
 *
 * 1. Editor-to-editor copy: the clientId is stored as a `data-client-id` attribute
 *    directly on the `<div data-node-type="media">` element, written by the editor's
 *    clipboard serialiser.
 *
 * 2. Renderer-to-editor copy (e.g. pasting from a published Confluence page): the
 *    renderer does not write `data-client-id` on the media div. Instead, the clientId
 *    is embedded inside the blob URL on the `<img>` child element, in the hash params:
 *    `src="blob:https://...#media-blob-url=true&id=FILE_ID&...&clientId=CLIENT_ID"`
 *
 * All media nodes in a single pasted HTML fragment always share the same clientId,
 * so we extract it once and apply it to all file IDs found in the HTML.
 */ /**
 * Extract the clientId from a blob URL hash fragment (renderer-to-editor path).
 * Returns undefined if not found.
 */ const $a7b9498d98150b41$var$extractClientIdFromBlobUrl = (html)=>{
    // Matches both:
    //   - blob: URLs (client-rendered renderer)
    //   - HTTPS URLs with #media-blob-url=true in the hash (SSR-rendered renderer)
    const imgSrcRegex = /src="([^"]*#media-blob-url=true[^"]*)"/g;
    let match;
    while((match = imgSrcRegex.exec(html)) !== null){
        const src = match[1];
        // clientId is encoded in the hash fragment as a URL param
        // e.g. blob:https://hello.atlassian.net/uuid#media-blob-url=true&id=FILE_ID&clientId=CLIENT_ID
        const hash = src.includes('#') ? src.slice(src.indexOf('#') + 1) : '';
        // Unescape HTML-encoded ampersands that appear in raw clipboard HTML attribute values
        const decodedHash = hash.replace(/&amp;/g, '&');
        const clientId = new URLSearchParams(decodedHash).get('clientId');
        if (clientId) return clientId;
    }
    return undefined;
};
const $a7b9498d98150b41$export$a60ab7931e673c86 = (html)=>{
    if (!html) return;
    // All media nodes in a single paste share the same clientId.
    // Extract it once from either source:
    //   - Editor-to-editor: present as data-client-id="..." attribute
    //   - Renderer-to-editor: embedded in the blob URL hash as clientId=...
    const clientId = /data-client-id="([^"]*)"/.exec(html)?.[1] ?? $a7b9498d98150b41$var$extractClientIdFromBlobUrl(html);
    if (!clientId) return;
    // Map every file ID in the HTML to the single clientId
    const fileIdRegex = /data-id="([^"]*)"/g;
    let match;
    while((match = fileIdRegex.exec(html)) !== null)$a7b9498d98150b41$export$e03a2c36a6c44657(match[1], clientId);
};
module.exports["setClientIdForFile"] = $a7b9498d98150b41$export$e03a2c36a6c44657;
module.exports["getClientIdForFile"] = $a7b9498d98150b41$export$3cac71a2bd99f367;
module.exports["extractClientIdsFromHtml"] = $a7b9498d98150b41$export$a60ab7931e673c86;

});

parcelRegister("bVxZJ", function(module, exports) {

var $9WBFV = parcelRequire("9WBFV");

const $727b848b5dbc9cc2$var$getDefaultBlockNodeTypes = (tr)=>{
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    return paragraph ? [
        paragraph
    ] : [];
};
const $727b848b5dbc9cc2$export$9e2e0ba9b4a3aaa9 = (node, markType)=>{
    if (!node || !markType) return false;
    const blockMark = node.marks.find((mark)=>mark.type === markType);
    return blockMark ? blockMark.attrs : false;
};
const $727b848b5dbc9cc2$export$1b9361dde62c5ad5 = (node, markType)=>{
    if (!node || !markType) return false;
    const { paragraph: paragraph } = node.type.schema.nodes;
    if (!paragraph) return false;
    const findFirstParagraphBlockMarkAttrs = (currentNode)=>{
        if (currentNode.type === paragraph) return $727b848b5dbc9cc2$export$9e2e0ba9b4a3aaa9(currentNode, markType);
        for(let index = 0; index < currentNode.childCount; index++){
            const childResult = findFirstParagraphBlockMarkAttrs(currentNode.child(index));
            if (childResult !== false) return childResult;
        }
        return false;
    };
    return findFirstParagraphBlockMarkAttrs(node);
};
const $727b848b5dbc9cc2$export$d2e4d08c8ba1d788 = (tr, from, to, markType, markAttrs, blockNodeTypes = $727b848b5dbc9cc2$var$getDefaultBlockNodeTypes(tr))=>{
    if (!markType || blockNodeTypes.length === 0) return false;
    return (0, $9WBFV.createToggleBlockMarkOnRangeNext)(markType, ()=>markAttrs, blockNodeTypes)(from, to, tr);
};
const $727b848b5dbc9cc2$export$6ea2388618f50d4a = (tr, containerPos, markType, markAttrs, blockNodeTypes = $727b848b5dbc9cc2$var$getDefaultBlockNodeTypes(tr))=>{
    const containerNode = tr.doc.nodeAt(containerPos);
    if (!containerNode) return false;
    return $727b848b5dbc9cc2$export$d2e4d08c8ba1d788(tr, containerPos, containerPos + containerNode.nodeSize, markType, markAttrs, blockNodeTypes);
};
const $727b848b5dbc9cc2$export$eb81f7a0535d3440 = (tr, pos, markType, markAttrs)=>{
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    if (!paragraph) return false;
    const resolvedPos = tr.doc.resolve(Math.max(0, Math.min(pos, tr.doc.content.size)));
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        const node = resolvedPos.node(depth);
        if (node.type === paragraph) return $727b848b5dbc9cc2$export$d2e4d08c8ba1d788(tr, resolvedPos.before(depth), resolvedPos.before(depth) + node.nodeSize, markType, markAttrs, [
            paragraph
        ]);
    }
    return false;
};
module.exports["getBlockMarkAttrs"] = $727b848b5dbc9cc2$export$9e2e0ba9b4a3aaa9;
module.exports["getFirstParagraphBlockMarkAttrs"] = $727b848b5dbc9cc2$export$1b9361dde62c5ad5;
module.exports["reconcileBlockMarkInRange"] = $727b848b5dbc9cc2$export$d2e4d08c8ba1d788;
module.exports["reconcileBlockMarkForContainerAtPos"] = $727b848b5dbc9cc2$export$6ea2388618f50d4a;
module.exports["reconcileBlockMarkForParagraphAtPos"] = $727b848b5dbc9cc2$export$eb81f7a0535d3440;

});

parcelRegister("hHtwA", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");


var $gx3UZ = parcelRequire("gx3UZ");


var $8hfTK = parcelRequire("8hfTK");


var $dOBRD = parcelRequire("dOBRD");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

const $edff65d9394c50c1$var$SCORE_PROXIMITY_THRESHOLD = 0.2;
/**
 * The extension type for Rovo skills, used to identify skill items in the
 * quick insert menu. Matches the value defined in
 * @atlassian/conversation-assistant-content-transformer/utils/skills.
 *
 * Intentionally duplicated here to avoid adding a runtime dependency from
 * editor-common to the conversation-assistant packages.
 */ const $edff65d9394c50c1$var$ROVO_SKILL_EXTENSION_TYPE = 'com.atlassian.rovo.skill';
function $edff65d9394c50c1$export$148061891b6f53a2(results) {
    const isSkill = (r)=>r.item.extensionType === $edff65d9394c50c1$var$ROVO_SKILL_EXTENSION_TYPE;
    const reordered = results.slice(0);
    for(let i = 1; i < reordered.length; i++){
        if (isSkill(reordered[i])) continue;
        // reordered[i] is a native item — check if there are skills
        // ranked above it that have a similar score.
        let insertAt = i;
        while(insertAt > 0 && isSkill(reordered[insertAt - 1]) && Math.abs((reordered[insertAt - 1].score ?? 0) - (reordered[i].score ?? 0)) < $edff65d9394c50c1$var$SCORE_PROXIMITY_THRESHOLD)insertAt--;
        if (insertAt < i) {
            const [native] = reordered.splice(i, 1);
            reordered.splice(insertAt, 0, native);
        }
    }
    return reordered;
}


const $f78f91cc145cb2d6$var$processQuickInsertItems = (items, intl)=>{
    return items.reduce((acc, item)=>{
        if (typeof item === 'function' && // we preserve handler items with disableMemo so that we
        // can process them in a later step outside of memoizations
        !item.disableMemo) {
            const quickInsertItems = item(intl);
            return acc.concat(quickInsertItems);
        }
        return acc.concat(item);
    }, []);
};
const $f78f91cc145cb2d6$var$memoizedProcessQuickInsertItems = (0, $dOBRD.default)($f78f91cc145cb2d6$var$processQuickInsertItems);
const $f78f91cc145cb2d6$export$4fca091f4ee92b6d = (items, intl)=>{
    const memoizedResults = $f78f91cc145cb2d6$var$memoizedProcessQuickInsertItems(items, intl);
    const hasDisabledMemos = items.some((item)=>typeof item === 'function' && item.disableMemo);
    if (!hasDisabledMemos) return memoizedResults;
    return memoizedResults.flatMap((item)=>typeof item === 'function' && item.disableMemo ? item(intl) : item);
};
const $f78f91cc145cb2d6$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
function $f78f91cc145cb2d6$export$71aa6c912b956294(query, items, prioritySortingFn) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$f78f91cc145cb2d6$var$options
    };
    if (prioritySortingFn) {
        const sortFn = prioritySortingFn(items);
        // prioritySortingFn will trigger the experiment exposure, but sortFn
        // will be undefined for the control group.
        if (sortFn) fuseOptions.sortFn = sortFn;
    }
    const fuse = new (0, $8hfTK.default)(items, fuseOptions);
    const results = fuse.search(query);
    // platform_editor_insert_menu_ai: boost native editor elements above skills
    const rerankedResults = (0, $ieeJu.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) ? (0, $edff65d9394c50c1$export$148061891b6f53a2)(results) : results;
    if ((0, $iDrrr.fg)('jim-lower-ranking-in-jira-macro-search')) {
        // searching for jira work items macro first
        const datasourceIndex = rerankedResults.findIndex((r)=>r.item.id === 'datasource' && r.item.keywords?.includes('jira'));
        //  then searching for the legacy jira macro
        const legacyIndex = rerankedResults.findIndex((r)=>typeof r.item.key === 'string' && r.item.key.endsWith(':jira'));
        // the jira legcy macro is found before the jira work items macro then swap the two
        if (datasourceIndex > 0 && legacyIndex >= 0 && legacyIndex < datasourceIndex && Math.abs((rerankedResults[datasourceIndex].score ?? 0) - (rerankedResults[legacyIndex].score ?? 0)) < 0.2) {
            const [datasource] = rerankedResults.splice(datasourceIndex, 1);
            rerankedResults.splice(legacyIndex, 0, datasource);
        }
    }
    return rerankedResults.map((result)=>result.item);
}



var $kpCD8 = parcelRequire("kpCD8");


var $efqK4 = parcelRequire("efqK4");


var $6TaGl = parcelRequire("6TaGl");


var $4o0zT = parcelRequire("4o0zT");








var $krYZG = parcelRequire("krYZG");


var $79UEV = parcelRequire("79UEV");


var $dCkbP = parcelRequire("dCkbP");

const $232ccc69f6fc1817$export$6f0c8faa54b43db = 10000;
const $232ccc69f6fc1817$var$GUID_ONLY_APP_KEY_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;
const $232ccc69f6fc1817$var$isGuidOnlyAppKey = (appKey)=>$232ccc69f6fc1817$var$GUID_ONLY_APP_KEY_REGEX.test(appKey);
const $232ccc69f6fc1817$var$sectionCategoryKeys = {
    [(0, $dCkbP.BLOCK_TEMPLATES_SECTION).key]: 'blockTemplates',
    [(0, $dCkbP.DATA_AND_CHARTS_SECTION).key]: 'dataAndCharts',
    [(0, $dCkbP.EMBED_SECTION).key]: 'embed',
    [(0, $dCkbP.MEDIA_SECTION).key]: 'media',
    [(0, $dCkbP.OTHER_SECTION).key]: 'other',
    [(0, $dCkbP.ROVO_SECTION).key]: 'rovo',
    [(0, $dCkbP.STRUCTURE_SECTION).key]: 'structure',
    [(0, $dCkbP.TEXT_FORMATTING_SECTION).key]: 'textFormatting'
};
const $232ccc69f6fc1817$var$legacyCategoryKeys = new Set([
    'admin',
    'ai',
    'block-templates',
    'communication',
    'confluence-content',
    'data-and-charts',
    'development',
    'embed',
    'external-content',
    'formatting',
    'media',
    'navigation',
    'other',
    'reporting',
    'skills',
    'structure',
    'text-formatting',
    'visuals'
]);
const $232ccc69f6fc1817$var$isLegacyCategoryKey = (category)=>$232ccc69f6fc1817$var$legacyCategoryKeys.has(category);
const $232ccc69f6fc1817$export$dc378117e8b27887 = ({ providedItems: providedItems })=>{
    const emptyCategoryInformation = ()=>({
            internalMacroCount: 0,
            internalAppCount: 0,
            internalAppMacroMax: 0,
            ecosystemMacroCount: 0,
            ecosystemAppCount: 0,
            ecosystemAppMacroMax: 0,
            allMacroCount: 0,
            allAppCount: 0,
            allAppMacroMax: 0
        });
    const emptyCategoryCounts = {
        blockTemplates: emptyCategoryInformation(),
        dataAndCharts: emptyCategoryInformation(),
        embed: emptyCategoryInformation(),
        media: emptyCategoryInformation(),
        other: emptyCategoryInformation(),
        rovo: emptyCategoryInformation(),
        structure: emptyCategoryInformation(),
        textFormatting: emptyCategoryInformation()
    };
    const emptyLegacyCategoryCounts = {
        admin: emptyCategoryInformation(),
        ai: emptyCategoryInformation(),
        'block-templates': emptyCategoryInformation(),
        communication: emptyCategoryInformation(),
        'confluence-content': emptyCategoryInformation(),
        'data-and-charts': emptyCategoryInformation(),
        development: emptyCategoryInformation(),
        embed: emptyCategoryInformation(),
        'external-content': emptyCategoryInformation(),
        formatting: emptyCategoryInformation(),
        media: emptyCategoryInformation(),
        navigation: emptyCategoryInformation(),
        other: emptyCategoryInformation(),
        reporting: emptyCategoryInformation(),
        skills: emptyCategoryInformation(),
        structure: emptyCategoryInformation(),
        'text-formatting': emptyCategoryInformation(),
        uncategorized: emptyCategoryInformation(),
        visuals: emptyCategoryInformation()
    };
    const attributes = {
        category: emptyCategoryCounts,
        legacyCategory: emptyLegacyCategoryCounts,
        allCategories: emptyCategoryInformation()
    };
    const appMacroCounts = new WeakMap();
    const getAppMacroCounts = (category)=>{
        const existingCounts = appMacroCounts.get(category);
        if (existingCounts) return existingCounts;
        const counts = {
            all: new Map(),
            internal: new Map(),
            ecosystem: new Map()
        };
        appMacroCounts.set(category, counts);
        return counts;
    };
    const countAppMacro = (appKey, counts)=>{
        const appMacroCount = (counts.get(appKey) ?? 0) + 1;
        counts.set(appKey, appMacroCount);
        return appMacroCount;
    };
    const countCategoryItem = (category, item)=>{
        category.allMacroCount += 1;
        const { key: appKey = 'unknown', source: source } = item.app ?? {};
        const appMacroKey = $232ccc69f6fc1817$var$isGuidOnlyAppKey(appKey) ? 'unknown' : appKey;
        const counts = getAppMacroCounts(category);
        const allAppMacroCount = countAppMacro(appMacroKey, counts.all);
        category.allAppCount = counts.all.size;
        category.allAppMacroMax = Math.max(category.allAppMacroMax, allAppMacroCount);
        if (source === 'internal') {
            category.internalMacroCount += 1;
            const internalAppMacroCount = countAppMacro(appMacroKey, counts.internal);
            category.internalAppCount = counts.internal.size;
            category.internalAppMacroMax = Math.max(category.internalAppMacroMax, internalAppMacroCount);
        } else if (source === 'ecosystem') {
            category.ecosystemMacroCount += 1;
            const ecosystemAppMacroCount = countAppMacro(appMacroKey, counts.ecosystem);
            category.ecosystemAppCount = counts.ecosystem.size;
            category.ecosystemAppMacroMax = Math.max(category.ecosystemAppMacroMax, ecosystemAppMacroCount);
        }
    };
    const countItem = (item)=>{
        countCategoryItem(attributes.allCategories, item);
        const categories = item.categories;
        const normalizedCategories = new Set(categories?.map((category)=>category.trim().toLowerCase()).filter(Boolean) ?? []);
        let hasUnknownCategory = normalizedCategories.size === 0;
        for (const category of normalizedCategories)if ($232ccc69f6fc1817$var$isLegacyCategoryKey(category)) countCategoryItem(attributes.legacyCategory[category], item);
        else hasUnknownCategory = true;
        if (hasUnknownCategory) countCategoryItem(attributes.legacyCategory.uncategorized, item);
        for (const { key: key } of (0, $79UEV.getQuickInsertMenuItemParents)({
            categories: categories,
            rank: 0
        })){
            const categoryKey = $232ccc69f6fc1817$var$sectionCategoryKeys[key];
            if (!categoryKey) continue;
            countCategoryItem(attributes.category[categoryKey], item);
        }
    };
    for (const item of providedItems)countItem(item);
    return attributes;
};
const $232ccc69f6fc1817$export$1d3143213b9a5da7 = (dispatchAnalyticsEvent)=>{
    let timeoutId;
    let animationFrameId;
    let idleCallbackId;
    let destroyed = false;
    let scheduled = false;
    const emit = (options)=>{
        if (destroyed) return;
        dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).QUICK_INSERT_INFORMATION,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).QUICK_INSERT,
            attributes: $232ccc69f6fc1817$export$dc378117e8b27887(options),
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    };
    return {
        destroy: ()=>{
            destroyed = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
            if (animationFrameId !== undefined && typeof window !== 'undefined') window.cancelAnimationFrame(animationFrameId);
            if (idleCallbackId !== undefined && typeof window !== 'undefined' && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(idleCallbackId);
        },
        schedule: (options)=>{
            if (scheduled || destroyed) return;
            scheduled = true;
            timeoutId = setTimeout(()=>{
                if (destroyed || typeof window === 'undefined') return;
                if (typeof window.requestIdleCallback === 'function') idleCallbackId = window.requestIdleCallback(()=>emit(options));
                else if (typeof window.requestAnimationFrame === 'function') animationFrameId = window.requestAnimationFrame(()=>emit(options));
            }, $232ccc69f6fc1817$export$6f0c8faa54b43db);
        }
    };
};



var $8tXCb = parcelRequire("8tXCb");


var $kCECX = parcelRequire("kCECX");

const $77e9abb3345cd180$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('quickInsertPluginKey');


const $99678cd654a93b1a$export$efa5e2b745ac3301 = ({ category: category } = {})=>({ tr: tr })=>tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), {
            elementBrowserInitialCategory: category,
            isElementBrowserOpen: true
        });
const $99678cd654a93b1a$export$c1aff7071ceb7d4a = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), {
            elementBrowserInitialCategory: undefined,
            isElementBrowserOpen: false
        }));
        return true;
    };
const $99678cd654a93b1a$export$a37159c5d6f821f5 = ({ tr: tr })=>tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), {
        isElementBrowserModalOpen: true
    });
const $99678cd654a93b1a$export$d7c09ddb7ec80ba9 = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), {
            isElementBrowserModalOpen: false
        }));
        return true;
    };
const $99678cd654a93b1a$export$40b105cb73ed6b94 = (onInsert)=>$99678cd654a93b1a$var$insertItem(onInsert);
// this method was adapted from the typeahead plugin so we respect the API for quick insert items
const $99678cd654a93b1a$var$insertItem = (onInsert)=>(item, source)=>(state, dispatch)=>{
            const insert = (maybeNode, opts = {})=>{
                return (0, $8tXCb.insertSelectedItem)(maybeNode, opts)(state, state.tr, state.selection.head);
            };
            const tr = item.action(insert, state, source);
            /** @note There is no transaction when called without a search currently (different insert) */ if (tr && dispatch) dispatch(tr);
            onInsert?.(item);
            return true;
        };






var $1fBj6 = parcelRequire("1fBj6");

var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $brnfH = parcelRequire("brnfH");

var $6NW7h = parcelRequire("6NW7h");

var $jw4KW = parcelRequire("jw4KW");







const $3de83acb0421d656$var$pluginKey = new (0, $kCECX.PluginKey)('quickInsertOpenExperience');
const $3de83acb0421d656$var$TIMEOUT_DURATION = 1000;
const $3de83acb0421d656$var$START_METHOD = {
    QUICK_INSERT_BUTTON: 'quickInsertButton',
    TYPEAHEAD: 'typeahead'
};
const $3de83acb0421d656$var$ABORT_REASON = {
    USER_CANCELED: 'userCanceled',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $3de83acb0421d656$export$399cc8247eb1f3b5 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let targetEl;
    let editorViewEl;
    let mouseDownPos;
    const getTarget = ()=>{
        if (!targetEl) targetEl = refs.popupsMountPoint || refs.wrapperElement || (0, $jw4KW.getPopupContainerFromEditorView)(editorViewEl);
        return targetEl;
    };
    const experience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_OPEN, {
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).QUICK_INSERT,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $3de83acb0421d656$var$TIMEOUT_DURATION
            }),
            new (0, $brnfH.ExperienceCheckDomMutation)({
                onDomMutation: ({ mutations: mutations })=>{
                    if (mutations.some($3de83acb0421d656$var$isQuickInsertMenuAddedInMutation)) return {
                        status: 'success'
                    };
                },
                observeConfig: ()=>({
                        target: getTarget(),
                        options: {
                            childList: true
                        }
                    })
            })
        ]
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $3de83acb0421d656$var$pluginKey,
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    if ($3de83acb0421d656$var$isTargetQuickInsertButton(event.target)) mouseDownPos = {
                        x: event.clientX,
                        y: event.clientY
                    };
                },
                mouseup: (_view, event)=>{
                    if (mouseDownPos && $3de83acb0421d656$var$isTargetQuickInsertButton(event.target) && event.clientX === mouseDownPos.x && event.clientY === mouseDownPos.y) experience.start({
                        method: $3de83acb0421d656$var$START_METHOD.QUICK_INSERT_BUTTON
                    });
                    mouseDownPos = undefined;
                },
                beforeinput: (view, event)=>{
                    if ($3de83acb0421d656$var$isQuickInsertTrigger(event) && $3de83acb0421d656$var$isSelectionWhichSupportsTypeahead(view) && !$3de83acb0421d656$var$isQuickInsertMenuWithinNode(getTarget())) experience.start({
                        method: $3de83acb0421d656$var$START_METHOD.TYPEAHEAD,
                        forceRestart: true
                    });
                },
                keydown: (_view, event)=>{
                    if ($3de83acb0421d656$var$isCancelKey(event.key) && !$3de83acb0421d656$var$isQuickInsertMenuWithinNode(getTarget())) experience.abort({
                        reason: $3de83acb0421d656$var$ABORT_REASON.USER_CANCELED
                    });
                }
            }
        },
        view: (editorView)=>{
            editorViewEl = editorView.dom;
            return {
                destroy: ()=>{
                    experience.abort({
                        reason: $3de83acb0421d656$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                }
            };
        }
    });
};
const $3de83acb0421d656$var$isQuickInsertTrigger = ({ inputType: inputType, data: data })=>{
    return inputType === 'insertText' && data === '/';
};
const $3de83acb0421d656$var$isSelectionWhichSupportsTypeahead = ({ state: state })=>{
    const { from: from, $from: $from } = state.selection;
    if ($from.parent.type.name === 'codeBlock') return false;
    if ($from.marks().some((mark)=>mark.type.name === 'code')) return false;
    if (from === 0) return true;
    const nodeBefore = state.doc.resolve(from).nodeBefore;
    if (!nodeBefore) return true;
    const charBefore = nodeBefore.textContent?.slice(-1) || '';
    return charBefore.trim().length === 0;
};
const $3de83acb0421d656$var$isCancelKey = (key)=>{
    return key === 'Escape' || key === 'Backspace';
};
const $3de83acb0421d656$var$isTargetQuickInsertButton = (target)=>{
    return target instanceof HTMLElement && (target.dataset.testid === 'editor-quick-insert-button' || !!target.closest('[data-testid="editor-quick-insert-button"]'));
};
const $3de83acb0421d656$var$isQuickInsertMenuAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($3de83acb0421d656$var$isQuickInsertMenuWithinNode);
};
const $3de83acb0421d656$var$isQuickInsertMenuWithinNode = (node)=>{
    return (0, $1fBj6.containsPopupWithNestedElement)(node, '.fabric-editor-typeahead');
};






parcelRequire("cozmU");


var $7SMXM = parcelRequire("7SMXM");




const $cc58b40a4d932f96$export$a3569e804245f959 = (key)=>`quick-insert-provider-${key}`;



var $I2MTF = parcelRequire("I2MTF");


var $9wgTc = parcelRequire("9wgTc");


var $jmUhx = parcelRequire("jmUhx");

const $e8bbe348cb932ce8$var$LegacyQuickInsertProviderMenuItem = ({ item: item, onInsert: onInsert })=>{
    const { editorView: editorView, isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const isDisabled = item.isDisabledOffline === true && isOffline;
    const onSelect = ({ insert: insert, source: source })=>{
        const result = item.action(insert, editorView.state, source);
        if (result) onInsert(item);
        return result;
    };
    const Icon = item.icon;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {}) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
            label: ""
        }),
        isDisabled: isDisabled,
        onSelect: onSelect,
        shortcut: item.keyshortcut,
        title: item.title
    });
};
const $e8bbe348cb932ce8$var$getItemIdentity = (item, index)=>String(item.key ?? item.id ?? index);
const $e8bbe348cb932ce8$var$getComponentsFromLegacyItems = (items, onInsert)=>items.map((item, index)=>{
        const identity = $e8bbe348cb932ce8$var$getItemIdentity(item, index);
        return {
            type: 'menu-item',
            key: (0, $cc58b40a4d932f96$export$a3569e804245f959)(identity),
            parents: (0, $79UEV.getQuickInsertMenuItemParents)({
                categories: item.categories,
                rank: item.priority ?? index
            }),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($e8bbe348cb932ce8$var$LegacyQuickInsertProviderMenuItem, {
                    item: item,
                    onInsert: onInsert
                }),
            match: (0, $7SMXM.createQuickInsertMatcher)(()=>({
                    description: item.description,
                    keywords: item.keywords,
                    shortcut: item.keyshortcut,
                    title: item.title
                }))
        };
    });
const $e8bbe348cb932ce8$export$7ad4c7c38525438d = ({ directComponents: directComponents, itemFilter: itemFilter, onInsert: onInsert, providedItems: providedItems })=>{
    const filteredItems = itemFilter ? providedItems.filter(itemFilter) : providedItems;
    const allowedKeys = new Set(filteredItems.map((item, index)=>$e8bbe348cb932ce8$var$getItemIdentity(item, index)));
    const directComponentsWithRenderer = directComponents.filter((component)=>typeof component.component === 'function');
    const namespacedDirectComponents = directComponentsWithRenderer.filter((component)=>!itemFilter || allowedKeys.has(component.key)).map((component)=>{
        const item = filteredItems.find((candidate, index)=>$e8bbe348cb932ce8$var$getItemIdentity(candidate, index) === component.key);
        return {
            ...component,
            key: (0, $cc58b40a4d932f96$export$a3569e804245f959)(component.key),
            component: item ? (props)=>component.component({
                    ...props,
                    onInsert: ()=>onInsert(item)
                }) : component.component,
            match: component.match ?? (item ? (0, $7SMXM.createQuickInsertMatcher)(()=>({
                    description: item.description,
                    keywords: item.keywords,
                    shortcut: item.keyshortcut,
                    title: item.title
                })) : undefined)
        };
    });
    const directComponentKeys = new Set(directComponentsWithRenderer.map((component)=>component.key));
    const fallbackComponents = $e8bbe348cb932ce8$var$getComponentsFromLegacyItems(filteredItems.filter((item, index)=>!directComponentKeys.has($e8bbe348cb932ce8$var$getItemIdentity(item, index))), onInsert);
    return [
        ...fallbackComponents,
        ...namespacedDirectComponents
    ];
};



var $cozmU = parcelRequire("cozmU");











var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");

const $09388a9e421f9ee3$export$e3bbcc8b2ad059b0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
        children: children
    });











parcelRequire("cozmU");


var $8FgJC = parcelRequire("8FgJC");

const $93c10affb16517a2$export$134421b496083e82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, title: title } = t0;
    let t1;
    if ($[0] !== children || $[1] !== title) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
            title: title,
            children: children
        });
        $[0] = children;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, title: title })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
        title: title,
        children: children
    });



var $lPJNC = parcelRequire("lPJNC");


var $dXqu3 = parcelRequire("dXqu3");


var $kUWm2 = parcelRequire("kUWm2");

const $6d6b303a74441125$export$671aedeb86e8b59a = (menuKey)=>`${menuKey}${0, $kUWm2.MENU_FOOTER_SECTION_KEY_SUFFIX}`;



var $dN8tJ = parcelRequire("dN8tJ");

const $a26e97706c71fd51$export$5436cd2a53179e15 = (sectionKey)=>`${sectionKey}${0, $dN8tJ.SECTION_OVERFLOW_ITEM_KEY_SUFFIX}`;




















const $0bb808cea8a16725$export$58c18b8bb85a91a = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert(undefined);
        return api?.quickInsert?.commands.openElementBrowser()({
            tr: tr
        }) ?? tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        ariaLabel: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).viewMoreAriaLabel),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            label: ""
        }),
        isDisabled: !api?.quickInsert,
        onSelect: onSelect,
        shouldWrapIcon: false,
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).viewMore)
    });
};


















var $gFEZF = parcelRequire("gFEZF");

const $68c9c7e1034cb054$export$51d41dc7948a4ae5 = ({ api: api, category: category })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert(undefined);
        return api?.quickInsert?.commands.openElementBrowser({
            category: category
        })({
            tr: tr
        }) ?? tr;
    }, [
        api,
        category
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: ""
        }),
        isDisabled: !api?.quickInsert,
        onSelect: onSelect,
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).viewMore)
    });
};


const $81cf37cd2037519b$var$categories = [
    {
        message: (0, $lPJNC.messages).categoryRecommended,
        section: (0, $dCkbP.RECOMMENDED_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryStructure,
        section: (0, $dCkbP.STRUCTURE_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryMedia,
        section: (0, $dCkbP.MEDIA_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryEmbed,
        section: (0, $dCkbP.EMBED_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryTextFormatting,
        section: (0, $dCkbP.TEXT_FORMATTING_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryRovo,
        section: (0, $dCkbP.ROVO_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryDataAndCharts,
        section: (0, $dCkbP.DATA_AND_CHARTS_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryBlockTemplates,
        section: (0, $dCkbP.BLOCK_TEMPLATES_SECTION)
    },
    {
        message: (0, $lPJNC.messages).categoryOther,
        section: (0, $dCkbP.OTHER_SECTION)
    }
];
const $81cf37cd2037519b$var$createSectionComponent = (message)=>{
    const SectionComponent = ({ children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93c10affb16517a2$export$134421b496083e82), {
            title: formatMessage(message)
        }, children);
    };
    return SectionComponent;
};
const $81cf37cd2037519b$export$97fd3cfe99274aa2 = ({ api: api, includeElementBrowserItems: includeElementBrowserItems })=>[
        {
            key: (0, $dCkbP.MENU).key,
            type: (0, $dCkbP.MENU).type,
            component: (0, $09388a9e421f9ee3$export$e3bbcc8b2ad059b0)
        },
        ...$81cf37cd2037519b$var$categories.flatMap(({ message: message, section: section })=>[
                {
                    key: section.key,
                    type: section.type,
                    parents: [
                        {
                            key: (0, $dCkbP.MENU).key,
                            type: (0, $dCkbP.MENU).type,
                            rank: (0, $dXqu3.QUICK_INSERT_MENU_RANK)[section.key]
                        }
                    ],
                    component: $81cf37cd2037519b$var$createSectionComponent(message)
                },
                ...includeElementBrowserItems ? [
                    {
                        key: (0, $a26e97706c71fd51$export$5436cd2a53179e15)(section.key),
                        type: 'menu-item',
                        parents: [
                            {
                                key: section.key,
                                type: section.type,
                                rank: (0, $dXqu3.CATEGORY_VIEW_MORE_RANK)
                            }
                        ],
                        component: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $68c9c7e1034cb054$export$51d41dc7948a4ae5), {
                                api: api,
                                category: section.key
                            })
                    }
                ] : []
            ]),
        ...includeElementBrowserItems ? [
            {
                key: (0, $6d6b303a74441125$export$671aedeb86e8b59a)((0, $dCkbP.MENU).key),
                type: 'menu-section',
                parents: [
                    {
                        key: (0, $dCkbP.MENU).key,
                        type: (0, $dCkbP.MENU).type,
                        rank: Number.MAX_SAFE_INTEGER
                    }
                ]
            },
            {
                key: (0, $dCkbP.VIEW_ALL_ELEMENTS_MENU_ITEM).key,
                type: (0, $dCkbP.VIEW_ALL_ELEMENTS_MENU_ITEM).type,
                parents: [
                    {
                        key: (0, $6d6b303a74441125$export$671aedeb86e8b59a)((0, $dCkbP.MENU).key),
                        type: 'menu-section',
                        rank: 100
                    }
                ],
                component: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0bb808cea8a16725$export$58c18b8bb85a91a), {
                        api: api
                    })
            }
        ] : []
    ];












var $jaFVy = parcelRequire("jaFVy");


var $3k5Tv = parcelRequire("3k5Tv");









/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $7ZB0A = parcelRequire("7ZB0A");


var $eWXt3 = parcelRequire("eWXt3");





var $kyJuy = parcelRequire("kyJuy");


var $cDs9S = parcelRequire("cDs9S");

var $7aRdF = parcelRequire("7aRdF");

var $aRGok = parcelRequire("aRGok");

var $aGB72 = parcelRequire("aGB72");




function $1c649d86701e0ca0$export$7a0f33e8df10bd94(intl) {
    return [
        {
            title: intl.formatMessage((0, $lPJNC.messages).all),
            name: 'all'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).AI),
            name: 'AI'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).formatting),
            name: 'formatting'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages)['confluence-content']),
            name: 'confluence-content'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).media),
            name: 'media'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).visuals),
            name: 'visuals'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).navigation),
            name: 'navigation'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages)['external-content']),
            name: 'external-content'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).communication),
            name: 'communication'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).reporting),
            name: 'reporting'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).admin),
            name: 'admin'
        },
        {
            title: intl.formatMessage((0, $lPJNC.messages).development),
            name: 'development'
        }
    ];
}


function $045e3544a1b4e6ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $045e3544a1b4e6ba$export$77ff514ac660f8f8 = 16;
const $045e3544a1b4e6ba$var$actionsStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'inline-flex',
    margin: `0 ${"var(--ds-space-negative-050, -4px)"}`
});
const $045e3544a1b4e6ba$var$actionItemStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    flex: '1 0 auto',
    margin: `0 ${"var(--ds-space-050, 4px)"}`
});
const $045e3544a1b4e6ba$var$wrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 10px`,
    overflow: 'hidden',
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)"
});
const $045e3544a1b4e6ba$var$modalFooterStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"}`,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $045e3544a1b4e6ba$var$modalCloseButtonStyles = {
    name: "1446vv2",
    styles: "display:flex;justify-content:flex-end;padding-block-start:var(--ds-space-200, 16px);padding-inline:var(--ds-space-200, 16px)"
};
const $045e3544a1b4e6ba$var$ModalElementBrowser = (props)=>{
    const [selectedItem, setSelectedItem] = (0, $cozmU.useState)();
    const { helpUrl: helpUrl, intl: intl, onInsertItem: onInsertItemFn } = props;
    const onSelectItem = (0, $cozmU.useCallback)((item)=>{
        setSelectedItem(item);
    }, [
        setSelectedItem
    ]);
    const onInsertItem = (0, $cozmU.useCallback)((item)=>{
        onInsertItemFn(item);
    }, [
        onInsertItemFn
    ]);
    const RenderFooter = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, $lOiVq.jsx)($045e3544a1b4e6ba$var$Footer, {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onInsert: ()=>onInsertItem(selectedItem),
            beforeElement: helpUrl ? $045e3544a1b4e6ba$var$HelpLink(helpUrl, intl.formatMessage((0, $lPJNC.messages).help)) : undefined
        }), [
        onInsertItem,
        selectedItem,
        helpUrl,
        intl
    ]);
    const RenderBody = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $045e3544a1b4e6ba$var$wrapperStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $eWXt3.default), {
            categories: (0, $1c649d86701e0ca0$export$7a0f33e8df10bd94)(props.intl),
            defaultCategory: props.defaultCategory,
            getItems: props.getItems,
            showSearch: true,
            showCategories: true,
            mode: "full",
            onSelectItem: onSelectItem,
            onInsertItem: onInsertItem,
            emptyStateHandler: props.emptyStateHandler,
            autoFocusSearch: false
        })), [
        props.intl,
        props.defaultCategory,
        props.getItems,
        onSelectItem,
        onInsertItem,
        props.emptyStateHandler
    ]);
    const label = intl.formatMessage((0, $lPJNC.messages).browse);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-editor-popup": true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aRGok.default), null, props.isOpen && // eslint-disable-next-line @atlaskit/design-system/no-modal-label
    /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7aRdF.default), {
        label: label,
        testId: "element-browser-modal-dialog",
        stackIndex: 0,
        key: "element-browser-modal",
        onClose: props.onClose,
        onCloseComplete: props.onCloseComplete,
        height: "664px",
        width: "x-large",
        shouldReturnFocus: props.shouldReturnFocus
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $045e3544a1b4e6ba$var$modalCloseButtonStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cDs9S.CloseButton), {
        onClick: props.onClose
    })), /*#__PURE__*/ (0, $lOiVq.jsx)(RenderBody, null), /*#__PURE__*/ (0, $lOiVq.jsx)(RenderFooter, null))));
};
$045e3544a1b4e6ba$var$ModalElementBrowser.displayName = 'ModalElementBrowser';
const $045e3544a1b4e6ba$var$Footer = ({ onInsert: onInsert, beforeElement: beforeElement })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { onClose: onClose } = (0, $aGB72.useModal)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $045e3544a1b4e6ba$var$modalFooterStyles
    }, beforeElement ? beforeElement : /*#__PURE__*/ (0, $lOiVq.jsx)("span", null), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $045e3544a1b4e6ba$var$actionsStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $045e3544a1b4e6ba$var$actionItemStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7ZB0A.default), {
        appearance: "primary",
        onClick: onInsert,
        testId: "ModalElementBrowser__insert-button"
    }, intl.formatMessage((0, $lPJNC.messages).insert))), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $045e3544a1b4e6ba$var$actionItemStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "ModalElementBrowser__close-button"
    }, intl.formatMessage((0, $lPJNC.messages).close)))));
};
const $045e3544a1b4e6ba$var$HelpLink = (url, helpText)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $7ZB0A.default), {
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
            label: ""
        }),
        appearance: "subtle-link",
        href: url,
        target: "_blank",
        testId: "ModalElementBrowser__help-button"
    }, helpText);
const $045e3544a1b4e6ba$var$_default_1 = (0, $kSwu1.injectIntl)($045e3544a1b4e6ba$var$ModalElementBrowser);
var $045e3544a1b4e6ba$export$2e2bcd8739ae039 = $045e3544a1b4e6ba$var$_default_1;


const $c01baa211097b438$var$Modal = ({ quickInsertState: quickInsertState, isOffline: isOffline, editorView: editorView, helpUrl: helpUrl, insertItem: insertItem, getSuggestions: getSuggestions, api: api, defaultCategory: defaultCategory })=>{
    const getItems = (0, $cozmU.useCallback)((query, category)=>getSuggestions?.({
            query: query,
            category: category
        })?.map((item)=>{
            return isOffline && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item;
        }) ?? [], // See: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/157796/overview?commentId=8559952
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getSuggestions,
        quickInsertState.lazyDefaultItems,
        quickInsertState.providedItems,
        isOffline
    ]);
    const focusInEditor = (0, $cozmU.useCallback)(()=>{
        if (!editorView.hasFocus()) editorView.focus();
    }, [
        editorView
    ]);
    // ED-19408 We not store the item ref in the state
    // Instead of adding the item immediately on insert item
    // We wait until modal close is complete, refocus the editor and then add the item
    const insertableItem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const closeBrowser = (0, $cozmU.useCallback)(()=>{
        const closeCommand = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? (0, $99678cd654a93b1a$export$c1aff7071ceb7d4a) : (0, $99678cd654a93b1a$export$d7c09ddb7ec80ba9);
        closeCommand()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const onInsertItem = (0, $cozmU.useCallback)((item)=>{
        closeBrowser();
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        insertableItem.current = item;
    }, [
        closeBrowser,
        api
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>{
        closeBrowser();
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        focusInEditor();
    }, [
        closeBrowser,
        focusInEditor,
        api
    ]);
    const onCloseComplete = (0, $cozmU.useCallback)(()=>{
        if (!insertableItem.current) {
            focusInEditor();
            return;
        }
        const item = insertableItem.current;
        insertableItem.current = null;
        focusInEditor();
        insertItem?.(item, (0, $krYZG.INPUT_METHOD).ELEMENT_BROWSER)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        focusInEditor,
        insertItem
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $045e3544a1b4e6ba$export$2e2bcd8739ae039), {
        defaultCategory: defaultCategory,
        getItems: getItems,
        onInsertItem: onInsertItem,
        helpUrl: helpUrl,
        isOpen: quickInsertState.isElementBrowserOpen || false,
        emptyStateHandler: quickInsertState.emptyStateHandler,
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        shouldReturnFocus: false
    });
};
var $c01baa211097b438$export$2e2bcd8739ae039 = ({ editorView: editorView, helpUrl: helpUrl, pluginInjectionAPI: pluginInjectionAPI })=>{
    const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems, isElementBrowserOpen: isElementBrowserOpen, emptyStateHandler: emptyStateHandler, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionAPI, [
        'quickInsert',
        'connectivity'
    ], (state)=>({
            lazyDefaultItems: state.quickInsertState?.lazyDefaultItems,
            providedItems: state.quickInsertState?.providedItems,
            isElementBrowserOpen: (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? state.quickInsertState?.isElementBrowserOpen : state.quickInsertState?.isElementBrowserModalOpen,
            emptyStateHandler: state.quickInsertState?.emptyStateHandler,
            mode: state.connectivityState?.mode
        }));
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c01baa211097b438$var$Modal, {
        defaultCategory: (0, $77e9abb3345cd180$export$18d4026d1ea86bb1).getState(editorView.state)?.elementBrowserInitialCategory,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        quickInsertState: {
            lazyDefaultItems: lazyDefaultItems,
            providedItems: providedItems,
            isElementBrowserOpen: isElementBrowserOpen,
            emptyStateHandler: emptyStateHandler
        },
        editorView: editorView,
        helpUrl: helpUrl,
        isOffline: (0, $jaFVy.isOfflineMode)(mode),
        insertItem: pluginInjectionAPI?.quickInsert?.actions?.insertItem,
        getSuggestions: pluginInjectionAPI?.quickInsert?.actions?.getSuggestions,
        api: pluginInjectionAPI
    });
};




var $llz2U = parcelRequire("llz2U");




const $3e5bf6e7efbc06ee$var$isRegisteredLayoutQuickInsertItem = (item)=>Boolean(item.id && item.id !== 'layout' && item.keywords?.includes('layout') && item.keywords?.includes('column'));
const $3e5bf6e7efbc06ee$var$getLayoutQuickInsertItemIdRank = (items)=>new Map(items.filter($3e5bf6e7efbc06ee$var$isRegisteredLayoutQuickInsertItem).map((item, index)=>[
            item.id,
            index
        ]));
const $3e5bf6e7efbc06ee$var$getQuickInsertItemId = (items, result)=>items[result.idx]?.id;
const $3e5bf6e7efbc06ee$export$e8643d2543db7695 = (prioritySortingFn)=>(items)=>{
        const consumerSortFn = prioritySortingFn?.(items);
        const layoutItemIdRank = $3e5bf6e7efbc06ee$var$getLayoutQuickInsertItemIdRank(items);
        if (layoutItemIdRank.size < 2) return consumerSortFn;
        return (firstItem, secondItem)=>{
            const firstLayoutItemRank = layoutItemIdRank.get($3e5bf6e7efbc06ee$var$getQuickInsertItemId(items, firstItem));
            const secondLayoutItemRank = layoutItemIdRank.get($3e5bf6e7efbc06ee$var$getQuickInsertItemId(items, secondItem));
            if (firstLayoutItemRank !== undefined && secondLayoutItemRank !== undefined) return firstLayoutItemRank - secondLayoutItemRank;
            if (consumerSortFn) return consumerSortFn(firstItem, secondItem);
            return firstItem.score === secondItem.score ? firstItem.idx < secondItem.idx ? -1 : 1 : firstItem.score < secondItem.score ? -1 : 1;
        };
    };
const $3e5bf6e7efbc06ee$export$f7a129a7d10810d3 = (searchOptions, lazyDefaultItems = ()=>[], providedItems)=>{
    const { query: query, category: category, disableDefaultItems: disableDefaultItems, featuredItems: featuredItems, itemFilter: itemFilter, prioritySortingFn: prioritySortingFn } = searchOptions;
    const defaultItems = disableDefaultItems ? [] : lazyDefaultItems();
    const dedupeFn = (item)=>`${item.title}-${item.description ?? ''}`;
    let items = providedItems ? (0, $llz2U.dedupe)([
        ...defaultItems,
        ...providedItems
    ], dedupeFn) : defaultItems;
    // EDITOR-6558: apply consumer-supplied filter (e.g. Markdown Mode allowlist).
    if (itemFilter) items = items.filter(itemFilter);
    if (featuredItems) return items.filter((item)=>item.featured);
    return (0, $f78f91cc145cb2d6$export$71aa6c912b956294)(((0, $iDrrr.fg)('platform_editor_fix_space_triggering_ai') ? query?.trimEnd() : query) || '', category === 'all' || !category ? items : items.filter((item)=>item.categories && item.categories.includes(category)), prioritySortingFn);
};


const $6c7fa28b5c7dfa87$export$2ff93c7de46a9aaa = ({ config: options, api: api })=>{
    const refs = {};
    const onInsert = (item)=>{
        options?.onInsert?.(item);
    };
    const typeAheadPrioritySortingFn = (0, $ieeJu.expValEquals)('platform_editor_layout_typeahead_reorder', 'isEnabled', true) ? (0, $3e5bf6e7efbc06ee$export$e8643d2543db7695)(options?.prioritySortingFn) : options?.prioritySortingFn;
    const typeAhead = {
        id: (0, $efqK4.TypeAheadAvailableNodes).QUICK_INSERT,
        trigger: '/',
        // Support fullwidth slash (U+FF0F) used by Japanese/CJK keyboards (e.g. typing / on a Japanese keyboard layout)
        customRegex: (0, $ieeJu.expValEquals)('platform_editor_wide_slash_trigger', 'isEnabled', true) ? "[/\uFF0F]" : undefined,
        headless: options?.headless,
        getItems ({ query: query, editorState: editorState }) {
            const quickInsertState = (0, $77e9abb3345cd180$export$18d4026d1ea86bb1).getState(editorState);
            const items = (0, $3e5bf6e7efbc06ee$export$f7a129a7d10810d3)({
                query: query,
                disableDefaultItems: options?.disableDefaultItems,
                prioritySortingFn: typeAheadPrioritySortingFn,
                // EDITOR-6558: pass through consumer-supplied filter (e.g. Markdown Mode allowlist)
                itemFilter: options?.itemFilter
            }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems);
            return Promise.resolve(items);
        },
        getEmptyItem ({ editorState: editorState }) {
            if (!(0, $ieeJu.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true)) return undefined;
            const quickInsertState = (0, $77e9abb3345cd180$export$18d4026d1ea86bb1).getState(editorState);
            const matches = (0, $3e5bf6e7efbc06ee$export$f7a129a7d10810d3)({
                query: '',
                disableDefaultItems: options?.disableDefaultItems,
                prioritySortingFn: options?.prioritySortingFn,
                itemFilter: (item)=>item.categories?.includes('AI') ?? false
            }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems);
            return matches[0];
        },
        selectItem: (state, item, insert)=>{
            const quickInsertItem = item;
            const result = quickInsertItem.action(insert, state);
            if (result) onInsert(quickInsertItem);
            return result;
        },
        getMoreOptionsButtonConfig: options?.enableElementBrowser ? ({ formatMessage: formatMessage })=>{
            return {
                title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).viewMore),
                ariaLabel: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).viewMoreAriaLabel),
                onClick: (0, $99678cd654a93b1a$export$a37159c5d6f821f5),
                iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                    label: ""
                })
            };
        } : undefined
    };
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command')) api?.uiControlRegistry?.actions.register((0, $81cf37cd2037519b$export$97fd3cfe99274aa2)({
        api: api,
        includeElementBrowserItems: options?.enableElementBrowser === true
    }));
    const openElementBrowser = (options)=>({ tr: tr })=>{
            if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                shouldStartTimer: false,
                shouldPersistActiveSession: true
            })({
                tr: tr
            });
            return (0, $99678cd654a93b1a$export$efa5e2b745ac3301)(options)({
                tr: tr
            });
        };
    let intl;
    return {
        name: 'quickInsert',
        pmPlugins (defaultItems) {
            return [
                {
                    name: 'quickInsert',
                    // It's important that this plugin is above TypeAheadPlugin
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl, dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>$6c7fa28b5c7dfa87$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, dispatchAnalyticsEvent, options?.emptyStateHandler, onInsert, options?.itemFilter, api)
                },
                {
                    name: 'quickInsertOpenExperience',
                    plugin: ()=>(0, $3de83acb0421d656$export$399cc8247eb1f3b5)({
                            refs: refs,
                            dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload)
                        })
                }
            ];
        },
        pluginsOptions: {
            typeAhead: typeAhead
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, wrapperElement: wrapperElement }) {
            refs.popupsMountPoint = popupsMountPoint || undefined;
            refs.wrapperElement = wrapperElement || undefined;
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            if (options?.enableElementBrowser) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c01baa211097b438$export$2e2bcd8739ae039), {
                editorView: editorView,
                helpUrl: options?.elementBrowserHelpUrl,
                pluginInjectionAPI: api
            });
            return null;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const quickInsertState = (0, $77e9abb3345cd180$export$18d4026d1ea86bb1).getState(editorState);
            if (!quickInsertState) return null;
            return {
                typeAheadHandler: typeAhead,
                lazyDefaultItems: quickInsertState.lazyDefaultItems,
                emptyStateHandler: quickInsertState.emptyStateHandler,
                providedItems: quickInsertState.providedItems,
                isElementBrowserModalOpen: quickInsertState.isElementBrowserModalOpen,
                isElementBrowserOpen: quickInsertState.isElementBrowserOpen
            };
        },
        actions: {
            insertItem: (0, $99678cd654a93b1a$export$40b105cb73ed6b94)(onInsert),
            openTypeAhead (inputMethod, removePrefixTriggerOnCancel) {
                return Boolean(api?.typeAhead?.actions.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod,
                    removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
                }));
            },
            getSuggestions: (searchOptions)=>{
                const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                if ((0, $ieeJu.expValEquals)('platform_editor_layout_typeahead_reorder', 'isEnabled', true)) searchOptions = {
                    ...searchOptions,
                    prioritySortingFn: (0, $3e5bf6e7efbc06ee$export$e8643d2543db7695)(options?.prioritySortingFn ?? searchOptions.prioritySortingFn)
                };
                else if (options?.prioritySortingFn) searchOptions = {
                    ...searchOptions,
                    prioritySortingFn: options.prioritySortingFn
                };
                // EDITOR-6558: layer the consumer-supplied filter (e.g. Markdown Mode allowlist)
                // over any caller-supplied filter so both apply.
                if (options?.itemFilter) {
                    const consumerFilter = options.itemFilter;
                    const callerFilter = searchOptions.itemFilter;
                    searchOptions = {
                        ...searchOptions,
                        itemFilter: callerFilter ? (item)=>consumerFilter(item) && callerFilter(item) : consumerFilter
                    };
                }
                return (0, $3e5bf6e7efbc06ee$export$f7a129a7d10810d3)(searchOptions, lazyDefaultItems, providedItems);
            }
        },
        commands: {
            openElementBrowser: openElementBrowser,
            openElementBrowserModal: ({ tr: tr })=>{
                if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                return (0, $99678cd654a93b1a$export$a37159c5d6f821f5)({
                    tr: tr
                });
            },
            addQuickInsertItem: (item)=>({ tr: tr })=>{
                    const { lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const memoisedNewItems = (0, $f78f91cc145cb2d6$export$4fca091f4ee92b6d)([
                        item
                    ], intl);
                    return tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), {
                        lazyDefaultItems: ()=>[
                                ...defaultItems,
                                ...memoisedNewItems
                            ]
                    });
                },
            updateQuickInsertItem: (key, item)=>({ tr: tr })=>{
                    const { providedItems: providedItems, lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const newItem = (0, $f78f91cc145cb2d6$export$4fca091f4ee92b6d)([
                        item
                    ], intl);
                    const replaceByKey = (items)=>items.flatMap((i)=>i.key === key ? newItem : i);
                    const meta = {};
                    if (defaultItems.some((i)=>i.key === key)) meta.lazyDefaultItems = ()=>replaceByKey(defaultItems);
                    if (providedItems?.some((i)=>i.key === key)) meta.providedItems = replaceByKey(providedItems);
                    return Object.keys(meta).length > 0 ? tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), meta) : tr;
                },
            removeQuickInsertItem: (key)=>({ tr: tr })=>{
                    const { providedItems: providedItems, lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    return tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), {
                        providedItems: providedItems?.filter((item)=>item.key !== key) ?? [],
                        lazyDefaultItems: ()=>defaultItems.filter((item)=>item.key !== key)
                    });
                }
        },
        usePluginHook: ()=>{
            intl = (0, $kSwu1.useIntl)();
        }
    };
};
const $6c7fa28b5c7dfa87$var$setProviderState = (providerState)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), providerState));
        return true;
    };
function $6c7fa28b5c7dfa87$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, dispatchAnalyticsEvent, emptyStateHandler, onInsert = ()=>{}, itemFilter, api) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $77e9abb3345cd180$export$18d4026d1ea86bb1),
        state: {
            init () {
                return {
                    isElementBrowserModalOpen: false,
                    isElementBrowserOpen: false,
                    emptyStateHandler: emptyStateHandler,
                    // lazy so it doesn't run on editor initialization
                    // memo here to avoid using a singleton cache, avoids editor
                    // getting confused when two editors exist within the same page.
                    lazyDefaultItems: ()=>(0, $f78f91cc145cb2d6$export$4fca091f4ee92b6d)(defaultItems || [], getIntl())
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $77e9abb3345cd180$export$18d4026d1ea86bb1));
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch((0, $77e9abb3345cd180$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view (editorView) {
            let quickInsertItemsAnalyticsScheduler;
            let isDestroyed = false;
            const providerHandler = async (_name, providerPromise)=>{
                if (providerPromise) try {
                    const provider = await providerPromise;
                    const providedItems = await provider.getItems();
                    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command')) {
                        const directComponents = provider.getComponents ? await provider.getComponents() : [];
                        const components = (0, $e8bbe348cb932ce8$export$7ad4c7c38525438d)({
                            directComponents: directComponents,
                            itemFilter: itemFilter,
                            onInsert: onInsert,
                            providedItems: providedItems
                        });
                        api?.uiControlRegistry?.actions.register(components);
                    }
                    $6c7fa28b5c7dfa87$var$setProviderState({
                        provider: provider,
                        providedItems: providedItems
                    })(editorView.state, editorView.dispatch);
                    if (!isDestroyed && !quickInsertItemsAnalyticsScheduler && (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_app_category_analytics')) {
                        quickInsertItemsAnalyticsScheduler = (0, $232ccc69f6fc1817$export$1d3143213b9a5da7)(dispatchAnalyticsEvent);
                        quickInsertItemsAnalyticsScheduler.schedule({
                            providedItems: providedItems
                        });
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Error getting items from quick insert provider', e);
                }
            };
            providerFactory.subscribe('quickInsertProvider', providerHandler);
            return {
                destroy () {
                    isDestroyed = true;
                    quickInsertItemsAnalyticsScheduler?.destroy();
                    providerFactory.unsubscribe('quickInsertProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["quickInsertPlugin"] = $6c7fa28b5c7dfa87$export$2ff93c7de46a9aaa;

});

parcelRegister("efqK4", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8Kvl9 = parcelRequire("8Kvl9");

var $b61b7f2b229e9e79$export$8c4c885c87e5cc07 = /*#__PURE__*/ function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    return TypeAheadAvailableNodes;
}({});
var $b61b7f2b229e9e79$export$4d7d0343c6d95a0e = /*#__PURE__*/ function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    return SelectItemMode;
}({});
module.exports["TypeAheadAvailableNodes"] = $b61b7f2b229e9e79$export$8c4c885c87e5cc07;
module.exports["SelectItemMode"] = $b61b7f2b229e9e79$export$4d7d0343c6d95a0e;

});

parcelRegister("1fBj6", function(module, exports) {
/**
 * Checks if a given node contains a popup with a nested element identified by a specific test ID.
 *
 * @param node - The node to check.
 * @param nestedElementQuery - The query to look for the nested element.
 * @returns True if the node contains the popup, false otherwise.
 */ const $c6bcf7a67d9c4253$export$34b917212c8a3de1 = (node, nestedElementQuery)=>{
    if (!(node instanceof HTMLElement)) return false;
    // Check if node itself has the popup attribute and contains the element matching the nestedElementQuery
    if (node.matches('[data-editor-popup="true"]')) return !!node.querySelector(nestedElementQuery);
    // Check if any direct child with popup attribute contains the element matching the nestedElementQuery
    return !!node.querySelector(`:scope > [data-editor-popup="true"] ${nestedElementQuery}`);
};
module.exports["containsPopupWithNestedElement"] = $c6bcf7a67d9c4253$export$34b917212c8a3de1;

});

parcelRegister("kkC4n", function(module, exports) {

let $ecd334c122517a3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ecd334c122517a3c$var$load("eUsnQ"),
    $ecd334c122517a3c$var$load("hhss7"),
    $ecd334c122517a3c$var$load("Wowvf"),
    $ecd334c122517a3c$var$load("47FHY")
]).then(()=>parcelRequire('fahTL'));

});

parcelRegister("hGZJg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $0352f07bdef9c682$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $0352f07bdef9c682$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $0352f07bdef9c682$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$0352f07bdef9c682$var$componentWillMount.__suppressDeprecationWarning = true;
$0352f07bdef9c682$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$0352f07bdef9c682$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $0352f07bdef9c682$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $0352f07bdef9c682$var$componentWillMount;
        prototype.componentWillReceiveProps = $0352f07bdef9c682$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $0352f07bdef9c682$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}
module.exports["polyfill"] = $0352f07bdef9c682$export$cea1c58a6db52bca;

});

parcelRegister("8i7gn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6095a37411e49579$export$2e2bcd8739ae039);
var $c89a118b971f1e76$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $6095a37411e49579$var$size;
function $6095a37411e49579$export$2e2bcd8739ae039(recalc) {
    if (!$6095a37411e49579$var$size && $6095a37411e49579$var$size !== 0 || recalc) {
        if (0, $c89a118b971f1e76$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $6095a37411e49579$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $6095a37411e49579$var$size;
}

});

parcelRegister("8s6Tr", function(module, exports) {
function $62764920a7b5a8b7$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $62764920a7b5a8b7$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hTncH", function(module, exports) {

var $bzEO3 = parcelRequire("bzEO3");

function $d0699280024b82ce$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $bzEO3(o.key), o);
    }
}
function $d0699280024b82ce$var$_createClass(e, r, t) {
    return r && $d0699280024b82ce$var$_defineProperties(e.prototype, r), t && $d0699280024b82ce$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $d0699280024b82ce$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9U8xV", function(module, exports) {

var $cdkbZ = parcelRequire("cdkbZ");

var $735ff923692cc985$var$_typeof = $cdkbZ.default;

var $gq4zc = parcelRequire("gq4zc");

function $735ff923692cc985$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $735ff923692cc985$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $gq4zc(t);
}
module.exports = $735ff923692cc985$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("deVUU", function(module, exports) {
function $9a39823fd7461484$var$_getPrototypeOf(t) {
    return module.exports = $9a39823fd7461484$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9a39823fd7461484$var$_getPrototypeOf(t);
}
module.exports = $9a39823fd7461484$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("j3nAe", function(module, exports) {

var $4ZTcn = parcelRequire("4ZTcn");

function $ddf09753d758a4cf$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $4ZTcn(t, e);
}
module.exports = $ddf09753d758a4cf$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lfswV", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "CellMeasurer", {
    enumerable: true,
    get: function get() {
        return $f781212c3e00edd7$var$_CellMeasurer["default"];
    }
});
Object.defineProperty(module.exports, "CellMeasurerCache", {
    enumerable: true,
    get: function get() {
        return $f781212c3e00edd7$var$_CellMeasurerCache["default"];
    }
});
module.exports["default"] = void 0;

var $f781212c3e00edd7$var$_CellMeasurer = $5r8BJ((parcelRequire("85yuq")));

var $f781212c3e00edd7$var$_CellMeasurerCache = $5r8BJ((parcelRequire("k1hd6")));
var $f781212c3e00edd7$var$_default = module.exports["default"] = $f781212c3e00edd7$var$_CellMeasurer["default"];

});

parcelRegister("85yuq", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");


var $cdkbZ = parcelRequire("cdkbZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5e398b478d578292$var$_classCallCheck2 = $5r8BJ((parcelRequire("8s6Tr")));

var $5e398b478d578292$var$_createClass2 = $5r8BJ((parcelRequire("hTncH")));

var $5e398b478d578292$var$_possibleConstructorReturn2 = $5r8BJ((parcelRequire("9U8xV")));

var $5e398b478d578292$var$_getPrototypeOf2 = $5r8BJ((parcelRequire("deVUU")));

var $5e398b478d578292$var$_inherits2 = $5r8BJ((parcelRequire("j3nAe")));

var $5e398b478d578292$var$_defineProperty2 = $5r8BJ((parcelRequire("hDDkw")));

var $5e398b478d578292$var$_react = $5e398b478d578292$var$_interopRequireWildcard((parcelRequire("cozmU")));
var $5e398b478d578292$var$React = $5e398b478d578292$var$_react;
function $5e398b478d578292$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5e398b478d578292$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5e398b478d578292$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $cdkbZ(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $5e398b478d578292$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5e398b478d578292$var$_callSuper(t, o, e) {
    return o = (0, $5e398b478d578292$var$_getPrototypeOf2["default"])(o), (0, $5e398b478d578292$var$_possibleConstructorReturn2["default"])(t, $5e398b478d578292$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $5e398b478d578292$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $5e398b478d578292$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5e398b478d578292$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {CellMeasureCache} from './types';*/ 
/*:: type Children = (params: {measure: () => void}) => React.Element<*>;*/ /*:: type Cell = {
  columnIndex: number,
  rowIndex: number,
};*/ /*:: type Props = {
  cache: CellMeasureCache,
  children: Children | React.Element<*>,
  columnIndex?: number,
  index?: number,
  parent: {
    invalidateCellSizeAfterRender?: (cell: Cell) => void,
    recomputeGridSize?: (cell: Cell) => void,
  },
  rowIndex?: number,
};*/ /**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $5e398b478d578292$var$CellMeasurer = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function CellMeasurer() {
        var _this;
        (0, $5e398b478d578292$var$_classCallCheck2["default"])(this, CellMeasurer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $5e398b478d578292$var$_callSuper(this, CellMeasurer, [].concat(args));
        (0, $5e398b478d578292$var$_defineProperty2["default"])(_this, "_child", /*#__PURE__*/ $5e398b478d578292$var$React.createRef());
        (0, $5e398b478d578292$var$_defineProperty2["default"])(_this, "_measure", function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        });
        (0, $5e398b478d578292$var$_defineProperty2["default"])(_this, "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('CellMeasurer registerChild expects to be passed Element or null');
            _this._child.current = element;
            if (element) _this._maybeMeasureCell();
        });
        return _this;
    }
    (0, $5e398b478d578292$var$_inherits2["default"])(CellMeasurer, _React$PureComponent);
    return (0, $5e398b478d578292$var$_createClass2["default"])(CellMeasurer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var children = this.props.children;
                var resolvedChildren = typeof children === 'function' ? children({
                    measure: this._measure,
                    registerChild: this._registerChild
                }) : children;
                if (resolvedChildren === null) return resolvedChildren;
                return /*#__PURE__*/ (0, $5e398b478d578292$var$_react.cloneElement)(resolvedChildren, {
                    ref: function ref(node) {
                        if (typeof resolvedChildren.ref === 'function') resolvedChildren.ref(node);
                        else if (resolvedChildren.ref) resolvedChildren.ref.current = node;
                        _this2._child.current = node;
                    }
                });
            }
        },
        {
            key: "_getCellMeasurements",
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = this._child.current;
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: "_maybeMeasureCell",
            value: function _maybeMeasureCell() {
                var _this$props2 = this.props, cache = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
}($5e398b478d578292$var$React.PureComponent); // Used for DEV mode warning check
(0, $5e398b478d578292$var$_defineProperty2["default"])($5e398b478d578292$var$CellMeasurer, "__internalCellMeasurerFlag", false);

});

parcelRegister("k1hd6", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = void 0;

var $e931403b62e67abc$var$_classCallCheck2 = $5r8BJ((parcelRequire("8s6Tr")));

var $e931403b62e67abc$var$_createClass2 = $5r8BJ((parcelRequire("hTncH")));

var $e931403b62e67abc$var$_defineProperty2 = $5r8BJ((parcelRequire("hDDkw")));
/*:: import type {CellMeasureCache} from './types';*/ var $e931403b62e67abc$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $e931403b62e67abc$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/*:: type KeyMapper = (rowIndex: number, columnIndex: number) => any;*/ /*:: type CellMeasurerCacheParams = {
  defaultHeight?: number,
  defaultWidth?: number,
  fixedHeight?: boolean,
  fixedWidth?: boolean,
  minHeight?: number,
  minWidth?: number,
  keyMapper?: KeyMapper,
};*/ /*:: type Cache = {
  [key: any]: number,
};*/ /*:: type IndexParam = {
  index: number,
};*/ /**
 * Caches measurements for a given cell.
 */ var $e931403b62e67abc$var$CellMeasurerCache = module.exports["default"] = /*#__PURE__*/ function() {
    function CellMeasurerCache() {
        var _this = this;
        var params /*: CellMeasurerCacheParams*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $e931403b62e67abc$var$_classCallCheck2["default"])(this, CellMeasurerCache);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_cellHeightCache", {});
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_cellWidthCache", {});
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_columnWidthCache", {});
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_rowHeightCache", {});
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_defaultHeight", void 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_defaultWidth", void 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_minHeight", void 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_minWidth", void 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_keyMapper", void 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_hasFixedHeight", void 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_hasFixedWidth", void 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_columnCount", 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "_rowCount", 0);
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "columnWidth", function(_ref /*:: */ ) {
            var index = _ref /*:: */ .index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
        });
        (0, $e931403b62e67abc$var$_defineProperty2["default"])(this, "rowHeight", function(_ref2 /*:: */ ) {
            var index = _ref2 /*:: */ .index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
        });
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $e931403b62e67abc$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $e931403b62e67abc$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $e931403b62e67abc$var$DEFAULT_WIDTH);
    }
    return (0, $e931403b62e67abc$var$_createClass2["default"])(CellMeasurerCache, [
        {
            key: "clear",
            value: function clear(rowIndex /*: number*/ ) {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: "defaultHeight",
            get: function get() /*: number*/ {
                return this._defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() /*: number*/ {
                return this._defaultWidth;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() /*: boolean*/ {
                return this._hasFixedHeight;
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() /*: boolean*/ {
                return this._hasFixedWidth;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: "has",
            value: function has(rowIndex /*: number*/ ) /*: boolean*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache[key] !== undefined;
            }
        },
        {
            key: "set",
            value: function set(rowIndex /*: number*/ , columnIndex /*: number*/ , width /*: number*/ , height /*: number*/ ) /*: void*/ {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "_updateCachedColumnAndRowSizes",
            value: function _updateCachedColumnAndRowSizes(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        }
    ]);
}();
function $e931403b62e67abc$var$defaultKeyMapper(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
    return "".concat(rowIndex, "-").concat(columnIndex);
}

});

parcelRegister("kojjU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lhCmf = parcelRequire("lhCmf");

const $4853f2347a5fb14c$var$IconFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconFallback() {
    const $ = (0, $bDgLe.c)(38);
    const { iconThemed: iconThemed } = (0, $lhCmf.useIconThemed)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsxs)("linearGradient", {
            x1: "-26.046%",
            y1: "100%",
            x2: "62.626%",
            y2: "0%",
            id: "fallback-a",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                    stopColor: "#B3BAC5",
                    offset: "0%"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                    stopColor: "#A5ADBA",
                    offset: "100%"
                })
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsxs)("defs", {
            children: [
                t0,
                /*#__PURE__*/ (0, $8aG6j.jsxs)("linearGradient", {
                    x1: "-12.24%",
                    y1: "100%",
                    x2: "82.44%",
                    y2: "0%",
                    id: "fallback-b",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                            stopColor: "#5A6977",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                            stopColor: "#454F59",
                            offset: "100%"
                        })
                    ]
                })
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== iconThemed) {
        t2 = iconThemed({
            light: "#FFF",
            dark: "#161A1D"
        });
        $[2] = iconThemed;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fill: t2,
            d: "M0 0h40v40H0z"
        });
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== iconThemed) {
        t4 = iconThemed({
            light: "#DFE1E6",
            dark: "#738496"
        });
        $[6] = iconThemed;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fill: t4,
            d: "M20 16h12v12H20z"
        });
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== iconThemed) {
        t6 = iconThemed({
            light: "url(#fallback-a)",
            dark: "url(#fallback-b)"
        });
        $[10] = iconThemed;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fill: t6,
            d: "M8 16h12v12H8z"
        });
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== iconThemed) {
        t8 = iconThemed({
            light: "#A5ADBA",
            dark: "#454F59"
        });
        $[14] = iconThemed;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
            fill: t8
        });
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== iconThemed) {
        t10 = iconThemed({
            light: "#B3BAC5",
            dark: "#454F59"
        });
        $[18] = iconThemed;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fill: t10,
            d: "M17.5 13h5v3h-5z"
        });
        $[20] = t10;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== iconThemed) {
        t12 = iconThemed({
            light: "#A5ADBA",
            dark: "#454F59"
        });
        $[22] = iconThemed;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fill: t12,
            d: "M10 13h5v3h-5z"
        });
        $[24] = t12;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] !== iconThemed) {
        t14 = iconThemed({
            light: "#DFE1E6",
            dark: "#738496"
        });
        $[26] = iconThemed;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== t14) {
        t15 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fill: t14,
            d: "M25 13h5v3h-5z"
        });
        $[28] = t14;
        $[29] = t15;
    } else t15 = $[29];
    let t16;
    if ($[30] !== t11 || $[31] !== t13 || $[32] !== t15 || $[33] !== t3 || $[34] !== t5 || $[35] !== t7 || $[36] !== t9) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            focusable: "false",
            "aria-hidden": true,
            width: 40,
            height: 40,
            viewBox: "0 0 40 40",
            children: [
                t1,
                /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: [
                        t3,
                        t5,
                        t7,
                        t9,
                        t11,
                        t13,
                        t15
                    ]
                })
            ]
        });
        $[30] = t11;
        $[31] = t13;
        $[32] = t15;
        $[33] = t3;
        $[34] = t5;
        $[35] = t7;
        $[36] = t9;
        $[37] = t16;
    } else t16 = $[37];
    return t16;
} : function IconFallback() {
    const { iconThemed: iconThemed } = (0, $lhCmf.useIconThemed)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("linearGradient", {
                        x1: "-26.046%",
                        y1: "100%",
                        x2: "62.626%",
                        y2: "0%",
                        id: "fallback-a",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                stopColor: "#B3BAC5",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                stopColor: "#A5ADBA",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("linearGradient", {
                        x1: "-12.24%",
                        y1: "100%",
                        x2: "82.44%",
                        y2: "0%",
                        id: "fallback-b",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                stopColor: "#5A6977",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                stopColor: "#454F59",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fill: iconThemed({
                            light: '#FFF',
                            dark: '#161A1D'
                        }),
                        d: "M0 0h40v40H0z"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M20 16h12v12H20z"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fill: iconThemed({
                            light: 'url(#fallback-a)',
                            dark: 'url(#fallback-b)'
                        }),
                        d: "M8 16h12v12H8z"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fill: iconThemed({
                            light: '#B3BAC5',
                            dark: '#454F59'
                        }),
                        d: "M17.5 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        }),
                        d: "M10 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M25 13h5v3h-5z"
                    })
                ]
            })
        ]
    });
};
var $4853f2347a5fb14c$export$2e2bcd8739ae039 = $4853f2347a5fb14c$var$IconFallback;
module.exports["default"] = $4853f2347a5fb14c$export$2e2bcd8739ae039;

});

parcelRegister("grjTL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bwEl8 = parcelRequire("bwEl8");

var $6nekq = parcelRequire("6nekq");

var $fyiBi = parcelRequire("fyiBi");

var $fa9Se = parcelRequire("fa9Se");

var $lhe5G = parcelRequire("lhe5G");

var $cI9Wu = parcelRequire("cI9Wu");


var $iDrrr = parcelRequire("iDrrr");


var $fqVYq = parcelRequire("fqVYq");


var $krYZG = parcelRequire("krYZG");


var $bhf6v = parcelRequire("bhf6v");


var $hXuXM = parcelRequire("hXuXM");


var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");




const $24a86a9ef44d1e7a$export$21e1076136e25038 = (markType, api, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $kCECX.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $24a86a9ef44d1e7a$var$nextToggleMarkInRange(mark, api)({
            tr: tr
        });
    };
const $24a86a9ef44d1e7a$var$nextToggleMarkInRange = (mark, api)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $8HW7o.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $hXuXM.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $24a86a9ef44d1e7a$export$2b94ea0e39917015(from, to, removeMark, mark, tr, api);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $hXuXM.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $24a86a9ef44d1e7a$export$2b94ea0e39917015($from.pos, $to.pos, removeMark, mark, tr, api);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $24a86a9ef44d1e7a$export$2b94ea0e39917015 = (from, to, removeMark, mark, tr, api)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) api?.base?.actions?.resolveMarks(from, to, tr);
    /**
	 * We should refactor this so text formatting doesn't reference plugins it doesn't know about.
	 */ tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};


const $b0a32d3ef086f313$export$3032060d929f850a = ({ tr: tr })=>{
    const { em: em } = tr.doc.type.schema.marks;
    if (!em) // No transaction to apply
    return null;
    return (0, $bhf6v.toggleMark)(em)({
        tr: tr
    });
};
const $b0a32d3ef086f313$export$fe8278eb0d365433 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $b0a32d3ef086f313$export$3032060d929f850a({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_ITALIC,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $b0a32d3ef086f313$export$2670450dfa0f0caf = ({ tr: tr })=>{
    const { strike: strike } = tr.doc.type.schema.marks;
    if (!strike) // No transaction to apply
    return null;
    return (0, $bhf6v.toggleMark)(strike)({
        tr: tr
    });
};
const $b0a32d3ef086f313$export$f08ef336cb688397 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $b0a32d3ef086f313$export$2670450dfa0f0caf({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRIKE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $b0a32d3ef086f313$export$52f111485e4791e7 = ({ tr: tr })=>{
    const { strong: strong } = tr.doc.type.schema.marks;
    if (!strong) // No transaction to apply
    return null;
    return (0, $bhf6v.toggleMark)(strong)({
        tr: tr
    });
};
const $b0a32d3ef086f313$export$686bc7c29753e27 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $b0a32d3ef086f313$export$52f111485e4791e7({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRONG,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $b0a32d3ef086f313$export$6bcc93697958b66d = ({ tr: tr })=>{
    const { underline: underline } = tr.doc.type.schema.marks;
    if (!underline) // No transaction to apply
    return null;
    return (0, $bhf6v.toggleMark)(underline)({
        tr: tr
    });
};
const $b0a32d3ef086f313$export$bf3c86b5abdb857d = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $b0a32d3ef086f313$export$6bcc93697958b66d({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $b0a32d3ef086f313$export$4af6b58e12324fd = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $bhf6v.toggleMark)(subsup, {
        type: 'sup'
    })({
        tr: tr
    });
};
const $b0a32d3ef086f313$export$ca1c98793b67ba6b = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $b0a32d3ef086f313$export$4af6b58e12324fd({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_SUPER,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $b0a32d3ef086f313$export$d26ab98fee0c804 = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $bhf6v.toggleMark)(subsup, {
        type: 'sub'
    })({
        tr: tr
    });
};
const $b0a32d3ef086f313$export$8d0c92ae27a193 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $b0a32d3ef086f313$export$d26ab98fee0c804({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_SUB,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $b0a32d3ef086f313$export$70686c6e7e15ed46 = ({ api: api })=>({ tr: tr })=>{
        const { code: code } = tr.doc.type.schema.marks;
        if (!code) // No transaction to apply
        return null;
        return (0, $24a86a9ef44d1e7a$export$21e1076136e25038)(code, api)({
            tr: tr
        });
    };
const $b0a32d3ef086f313$export$2d4f5a54f840ba91 = (editorAnalyticsApi, api)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $b0a32d3ef086f313$export$70686c6e7e15ed46({
                api: api
            })({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CODE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };



var $kpCD8 = parcelRequire("kpCD8");





var $ca4Zc = parcelRequire("ca4Zc");





var $eOaGc = parcelRequire("eOaGc");




const $f2e9620656cdc3ed$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};


const $24e404e609d25c50$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $24e404e609d25c50$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $24e404e609d25c50$var$formatTypes = {
    em: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
function $24e404e609d25c50$export$332a1f720fc2ba0(inputMethod, editorAnalyticsAPI) {
    return $24e404e609d25c50$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI);
}
const $24e404e609d25c50$var$clearNodeFormattingOnSelectionNext = (schema, tr, formattedNodeType, nodeName, formattingCleared)=>{
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $eOaGc.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
};
function $24e404e609d25c50$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $eOaGc.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}
function $24e404e609d25c50$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        const formattingCleared = [];
        $24e404e609d25c50$export$73b50f8f13648c71.forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = state.schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $8HW7o.CellSelection)) (0, $f2e9620656cdc3ed$export$bd443c1dba3019b8)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === state.schema.nodes.tableCell || node.type === state.schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push($24e404e609d25c50$var$formatTypes[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push($24e404e609d25c50$var$formatTypes[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        $24e404e609d25c50$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
            const formattedNodeType = state.schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $8HW7o.CellSelection)) (0, $f2e9620656cdc3ed$export$bd443c1dba3019b8)(tr.selection, tr.doc, $24e404e609d25c50$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, $24e404e609d25c50$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length && inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).FORMATTED,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: inputMethod === (0, $krYZG.INPUT_METHOD).TOOLBAR || inputMethod === (0, $krYZG.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $24e404e609d25c50$export$38c6848f9e966bd5 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const formattingCleared = [];
            const { schema: schema } = tr.doc.type;
            $24e404e609d25c50$export$73b50f8f13648c71.forEach((mark)=>{
                const { from: from, to: to } = tr.selection;
                const markType = schema.marks[mark];
                if (!markType) return;
                if (tr.selection instanceof (0, $8HW7o.CellSelection)) (0, $f2e9620656cdc3ed$export$bd443c1dba3019b8)(tr.selection, tr.doc, (node, pos)=>{
                    const isTableCell = node.type === tr.doc.type.schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                    if (!isTableCell) return true;
                    if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                        formattingCleared.push($24e404e609d25c50$var$formatTypes[mark]);
                        tr.removeMark(pos, pos + node.nodeSize, markType);
                    }
                    return false;
                });
                else if (tr.doc.rangeHasMark(from, to, markType)) {
                    formattingCleared.push($24e404e609d25c50$var$formatTypes[mark]);
                    tr.removeMark(from, to, markType);
                }
            });
            $24e404e609d25c50$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
                const formattedNodeType = schema.nodes[nodeName];
                const { $from: $from, $to: $to } = tr.selection;
                if (tr.selection instanceof (0, $8HW7o.CellSelection)) (0, $f2e9620656cdc3ed$export$bd443c1dba3019b8)(tr.selection, tr.doc, $24e404e609d25c50$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
                else tr.doc.nodesBetween($from.pos, $to.pos, $24e404e609d25c50$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
            });
            tr.setStoredMarks([]);
            if (formattingCleared.length && inputMethod) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CLEAR,
                attributes: {
                    inputMethod: inputMethod,
                    formattingCleared: formattingCleared,
                    dropdownMenu: inputMethod === (0, $krYZG.INPUT_METHOD).TOOLBAR || inputMethod === (0, $krYZG.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
                }
            })(tr);
            return tr;
        };


const $3b1be4d5b50fca83$export$435b7561880b778c = (state, pos)=>{
    const { code: code } = state.schema.marks;
    const node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) return !!node.marks.filter((mark)=>mark.type === code).length;
    return false;
};
const $3b1be4d5b50fca83$export$c91f8b3cbd625635 = (state, mark)=>{
    const { from: from, to: to, empty: empty } = state.selection;
    // When the selection is empty, only the active marks apply.
    if (empty) return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    // For a non-collapsed selection, the marks on the nodes matter.
    let found = false;
    state.doc.nodesBetween(from, to, (node)=>{
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
const $3b1be4d5b50fca83$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $24e404e609d25c50$export$a5cb0c20bd02ce0c).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $3b1be4d5b50fca83$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $24e404e609d25c50$export$73b50f8f13648c71).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $ca4Zc.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $3b1be4d5b50fca83$export$4b48a1fc423972ea = (state)=>{
    return $3b1be4d5b50fca83$var$marksArePresent(state) || $3b1be4d5b50fca83$var$blockStylingIsPresent(state);
};
const $3b1be4d5b50fca83$export$53d327693050b221 = (items, prevItems)=>{
    return items && items.filter((item)=>!prevItems.includes(item));
};
const $3b1be4d5b50fca83$export$f8f79f933a3fce55 = (items, content)=>items.filter((item)=>item.content === content).length > 0;


const $0fe51b24ed8ed7f4$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('clearFormattingPlugin');
const $0fe51b24ed8ed7f4$export$ca524d3785e2543 = (dispatch)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init (_config, state) {
                return {
                    formattingIsPresent: (0, $3b1be4d5b50fca83$export$4b48a1fc423972ea)(state)
                };
            },
            apply (_tr, pluginState, _oldState, newState) {
                const formattingIsPresent = (0, $3b1be4d5b50fca83$export$4b48a1fc423972ea)(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch($0fe51b24ed8ed7f4$export$18d4026d1ea86bb1, {
                        formattingIsPresent: formattingIsPresent
                    });
                    return {
                        formattingIsPresent: formattingIsPresent
                    };
                }
                return pluginState;
            }
        },
        key: $0fe51b24ed8ed7f4$export$18d4026d1ea86bb1
    });






var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");


function $554c0bd9c56a8393$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.clearFormatting)), (0, $24e404e609d25c50$export$38c6848f9e966bd5)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    return (0, $44cyU.keymap)(list);
}
var $554c0bd9c56a8393$export$2e2bcd8739ae039 = $554c0bd9c56a8393$export$e832373cff8dec22;








// Don't apply in Edge as per ED-4546
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $cd146205887072a2$var$EDGE_USER_AGENT_REGEX = /Edge\/\d/;
// eslint-disable-next-line import/no-anonymous-default-export
const $cd146205887072a2$var$_default_1 = new (0, $kpCD8.SafePlugin)({
    props: {
        handleClick (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            if (navigator && $cd146205887072a2$var$EDGE_USER_AGENT_REGEX.test(navigator.userAgent)) return false;
            // @see ED-6231
            if (clickPos > view.state.doc.content.size) return false;
            const { code: code } = view.state.schema.marks;
            const { paragraph: paragraph } = view.state.schema.nodes;
            const $click = view.state.doc.resolve(clickPos);
            const clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) && ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) && $click.textOffset === 0;
            const clickWasNearACodeMark = code && ($click.nodeBefore && code.isInSet($click.nodeBefore.marks) || $click.nodeAfter && code.isInSet($click.nodeAfter.marks));
            // Find the starting position of the clicked dom-element
            // TODO: ED-26962 - Remove calls to private API
            const clickedDOMElementPosition = event.target && event.target instanceof Node && view.posAtDOM(event.target);
            const clickNode = view.state.doc.nodeAt(clickPos);
            const clickWasAtTextNode = !!(clickNode && clickNode.isText);
            const clickWasAtEndOfAParagraphNode = $click.parent.type === paragraph && $click.textOffset === 0 && $click.nodeAfter === null;
            if (clickWasAtEdgeOfATextNode && clickWasNearACodeMark && clickedDOMElementPosition && // if click did not occur at a text node or end of paragraph, then
            // it was at a directly adjacent non-text node, so we skip this manual
            // text selection logic to preserve that non-text node's selection
            (clickWasAtTextNode || clickWasAtEndOfAParagraphNode)) {
                const clickWasInsideNodeDOM = event.target.parentNode === view.domAtPos(clickedDOMElementPosition).node && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                const nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks) ? $click.nodeAfter : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                const tr = view.state.tr.setSelection((0, $kCECX.TextSelection).near($click));
                if (clickWasInsideNodeDOM) tr.setStoredMarks([
                    code.create()
                ]);
                else tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                view.dispatch(tr);
                return true;
            }
            return false;
        }
    }
});
var $cd146205887072a2$export$2e2bcd8739ae039 = $cd146205887072a2$var$_default_1;









var $d8RhQ = parcelRequire("d8RhQ");

var $c2pcC = parcelRequire("c2pcC");


var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");


var $ieeJu = parcelRequire("ieeJu");

var $aecbe08ed18ad6e3$var$ValidAutoformatChars = /*#__PURE__*/ function(ValidAutoformatChars) {
    ValidAutoformatChars["STRONG"] = "__";
    ValidAutoformatChars["STRIKE"] = "~~";
    ValidAutoformatChars["STRONG_MARKDOWN"] = "**";
    ValidAutoformatChars["ITALIC_MARKDOWN"] = "*";
    ValidAutoformatChars["ITALIC"] = "_";
    ValidAutoformatChars["CODE"] = "`";
    return ValidAutoformatChars;
}($aecbe08ed18ad6e3$var$ValidAutoformatChars || {});
const $aecbe08ed18ad6e3$export$ab511c819612d3bc = {
    ["~~"]: [
        "_",
        "__",
        "**",
        "*"
    ],
    ["__"]: [
        "~~",
        "*"
    ],
    ["**"]: [
        "_",
        "~~"
    ],
    ["*"]: [
        "~~",
        "__"
    ],
    ["_"]: [
        "~~",
        "**"
    ],
    ["`"]: [
        // e.g: loko (`some code`
        '( '
    ]
};
function $aecbe08ed18ad6e3$var$addMark(markType, _schema, char, api) {
    return (state, _match, start, end)=>{
        const { doc: doc, schema: schema, tr: tr } = state;
        const textPrefix = state.doc.textBetween(start, start + char.length);
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (textPrefix !== char || schema?.marks?.code?.isInSet(doc.resolve(start + 1).marks())) {
            if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) return null;
            // if the prefix is not a character but the suffix is, continue
            const suffix = state.doc.textBetween(end - char.length, end);
            if (suffix !== char) return null;
        }
        // Prevent autoformatting across hardbreaks
        let containsHardBreak;
        doc.nodesBetween(start, end, (node)=>{
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) return null;
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        const startPosResolved = doc.resolve(start);
        const endPosResolved = doc.resolve(end);
        if (startPosResolved.sameParent(endPosResolved) && !startPosResolved.parent.type.allowsMarkType(markType)) return null;
        if (markType.name === 'code') api?.base?.actions?.resolveMarks(tr.mapping.map(start), tr.mapping.map(end), tr);
        const mappedStart = tr.mapping.map(start);
        const mappedEnd = tr.mapping.map(end);
        tr.addMark(mappedStart, mappedEnd, markType.create());
        const textSuffix = tr.doc.textBetween(mappedEnd - char.length, mappedEnd);
        if (textSuffix === char) tr.delete(mappedEnd - char.length, mappedEnd);
        if (textPrefix === char) tr.delete(mappedStart, mappedStart + char.length);
        return tr.removeStoredMark(markType);
    };
}
class $aecbe08ed18ad6e3$var$ReverseRegexExp extends RegExp {
    exec(str) {
        if (!str) return null;
        const reverseStr = [
            ...str
        ].reverse().join('');
        const result = super.exec(reverseStr);
        if (!result) return null;
        for(let i = 0; i < result.length; i++)if (result[i] && typeof result[i] === 'string') result[i] = [
            ...result[i]
        ].reverse().join('');
        if (result.input && typeof result.input === 'string') result.input = [
            ...result.input
        ].reverse().join('');
        if (result.input && result[0]) result.index = result.input.length - result[0].length;
        return result;
    }
}
const $aecbe08ed18ad6e3$var$buildRegex = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const combinations = $aecbe08ed18ad6e3$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    const baseRegex = '^X(?=[^X\\s]).*?[^\\sX]X(?=[\\sOBJECT_REPLACEMENT_CHARACTER]COMBINATIONS|$)'.replace('OBJECT_REPLACEMENT_CHARACTER', (0, $3brWT.leafNodeReplacementCharacter)).replace('COMBINATIONS', combinations ? `|${combinations}` : '');
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $aecbe08ed18ad6e3$var$ReverseRegexExp(replacedRegex);
};
const $aecbe08ed18ad6e3$var$buildRegexNew = (char, allowsBackwardMatch = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const combinations = $aecbe08ed18ad6e3$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    // if backwards matches are allowed, do not prefix the regex with an anchor (^)
    const maybeAnchor = allowsBackwardMatch ? '' : '^';
    const orCombinations = combinations ? `|${combinations}` : '';
    const baseRegex = `${maybeAnchor}X(?=[^X\\s]).*?[^\\sX]X(?=[\\s${(0, $3brWT.leafNodeReplacementCharacter)}]${orCombinations}|$)`;
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $aecbe08ed18ad6e3$var$ReverseRegexExp(replacedRegex);
};
const $aecbe08ed18ad6e3$export$3312a15c47701971 = $aecbe08ed18ad6e3$var$buildRegex("__");
const $aecbe08ed18ad6e3$export$b2c5e5dc4b85ebff = $aecbe08ed18ad6e3$var$buildRegex("**");
const $aecbe08ed18ad6e3$export$5293ac529581c0f9 = $aecbe08ed18ad6e3$var$buildRegex("_");
const $aecbe08ed18ad6e3$export$bef0fedfe2c8027e = $aecbe08ed18ad6e3$var$buildRegex("*");
const $aecbe08ed18ad6e3$export$6dd2d2a62884fadf = $aecbe08ed18ad6e3$var$buildRegex("~~");
const $aecbe08ed18ad6e3$export$b311ac3b6caef479 = $aecbe08ed18ad6e3$var$buildRegex("`");
const $aecbe08ed18ad6e3$export$6e92f28cddbb8b0c = $aecbe08ed18ad6e3$var$buildRegexNew("`", true);
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $aecbe08ed18ad6e3$var$getStrongInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrongAnalytics = (0, $c2pcC.inputRuleWithAnalytics)({
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRONG,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    // **string** or __strong__ should bold the text
    const doubleUnderscoreRule = (0, $d8RhQ.createRule)($aecbe08ed18ad6e3$export$3312a15c47701971, $aecbe08ed18ad6e3$var$addMark(schema.marks.strong, schema, "__"));
    const doubleAsterixRule = (0, $d8RhQ.createRule)($aecbe08ed18ad6e3$export$b2c5e5dc4b85ebff, $aecbe08ed18ad6e3$var$addMark(schema.marks.strong, schema, "**"));
    return [
        ruleWithStrongAnalytics(doubleUnderscoreRule),
        ruleWithStrongAnalytics(doubleAsterixRule)
    ];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $aecbe08ed18ad6e3$var$getItalicInputRules(schema, editorAnalyticsAPI) {
    const ruleWithItalicAnalytics = (0, $c2pcC.inputRuleWithAnalytics)({
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_ITALIC,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const underscoreRule = (0, $d8RhQ.createRule)($aecbe08ed18ad6e3$export$5293ac529581c0f9, $aecbe08ed18ad6e3$var$addMark(schema.marks.em, schema, "_"));
    const asterixRule = (0, $d8RhQ.createRule)($aecbe08ed18ad6e3$export$bef0fedfe2c8027e, $aecbe08ed18ad6e3$var$addMark(schema.marks.em, schema, "*"));
    return [
        ruleWithItalicAnalytics(underscoreRule),
        ruleWithItalicAnalytics(asterixRule)
    ];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $aecbe08ed18ad6e3$var$getStrikeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrikeAnalytics = (0, $c2pcC.inputRuleWithAnalytics)({
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRIKE,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const doubleTildeRule = (0, $d8RhQ.createRule)($aecbe08ed18ad6e3$export$6dd2d2a62884fadf, $aecbe08ed18ad6e3$var$addMark(schema.marks.strike, schema, "~~"));
    return [
        ruleWithStrikeAnalytics(doubleTildeRule)
    ];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $aecbe08ed18ad6e3$var$getCodeInputRules(schema, editorAnalyticsAPI, api) {
    const ruleWithCodeAnalytics = (0, $c2pcC.inputRuleWithAnalytics)({
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CODE,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const allowsBackwardMatch = (0, $ieeJu.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true);
    const backTickRule = (0, $d8RhQ.createRule)(allowsBackwardMatch ? $aecbe08ed18ad6e3$export$6e92f28cddbb8b0c : $aecbe08ed18ad6e3$export$b311ac3b6caef479, $aecbe08ed18ad6e3$var$addMark(schema.marks.code, schema, "`", api), allowsBackwardMatch);
    return [
        ruleWithCodeAnalytics(backTickRule)
    ];
}
function $aecbe08ed18ad6e3$export$568a7ed6897c4817(schema, editorAnalyticsAPI, api) {
    const rules = [];
    if (schema.marks.strong) rules.push(...$aecbe08ed18ad6e3$var$getStrongInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.em) rules.push(...$aecbe08ed18ad6e3$var$getItalicInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.strike) rules.push(...$aecbe08ed18ad6e3$var$getStrikeInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.code) rules.push(...$aecbe08ed18ad6e3$var$getCodeInputRules(schema, editorAnalyticsAPI, api));
    if (rules.length !== 0) return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('text-formatting', rules));
    return;
}
var $aecbe08ed18ad6e3$export$2e2bcd8739ae039 = $aecbe08ed18ad6e3$export$568a7ed6897c4817;





















const $8f71687d31171b9c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('textFormatting');


function $50ed4064618db7ba$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    if (schema.marks.strong) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleBold)), (0, $b0a32d3ef086f313$export$686bc7c29753e27)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.em) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleItalic)), (0, $b0a32d3ef086f313$export$fe8278eb0d365433)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.code) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleCode)), (0, $b0a32d3ef086f313$export$2d4f5a54f840ba91)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.strike) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleStrikethrough)), (0, $b0a32d3ef086f313$export$f08ef336cb688397)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleSubscript)), (0, $b0a32d3ef086f313$export$8d0c92ae27a193)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleSuperscript)), (0, $b0a32d3ef086f313$export$ca1c98793b67ba6b)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.underline) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleUnderline)), (0, $b0a32d3ef086f313$export$bf3c86b5abdb857d)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    const getEnabledKeylist = (view)=>{
        const textFormattingState = (0, $8f71687d31171b9c$export$18d4026d1ea86bb1).getState(view.state);
        const list = {};
        if (schema.marks.strong && !textFormattingState?.strongDisabled) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleBold)), (0, $b0a32d3ef086f313$export$686bc7c29753e27)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.em && !textFormattingState?.emDisabled) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleItalic)), (0, $b0a32d3ef086f313$export$fe8278eb0d365433)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.code && !textFormattingState?.codeDisabled) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleCode)), (0, $b0a32d3ef086f313$export$2d4f5a54f840ba91)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.strike && !textFormattingState?.strikeDisabled) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleStrikethrough)), (0, $b0a32d3ef086f313$export$f08ef336cb688397)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.subscriptDisabled) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleSubscript)), (0, $b0a32d3ef086f313$export$8d0c92ae27a193)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.superscriptDisabled) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleSuperscript)), (0, $b0a32d3ef086f313$export$ca1c98793b67ba6b)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.underline && !textFormattingState?.underlineDisabled) (0, $ldqjS.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleUnderline)), (0, $b0a32d3ef086f313$export$bf3c86b5abdb857d)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
        return list;
    };
    return new (0, $kpCD8.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $ldqjS.isCapsLockOnAndModifyKeyboardEvent)(event);
                const keymapList = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? getEnabledKeylist(view) : list;
                return (0, $44cyU.keydownHandler)(keymapList)(view, keyboardEvent);
            }
        }
    });
}


// TODO: ED-26962 - Ideally this should use the custom toggleMark function from @atlaskit/editor-common so we also disable the options when selecting inline nodes but it disables the marks when the selection is empty at this point in time which is undesirable
// import { toggleMark } from '@atlaskit/editor-common/mark';






var $aPdNQ = parcelRequire("aPdNQ");







const $ce08caf63142cd2c$var$allMarksAreRuledOut = (marks)=>Array.from(marks.values()).every((mark)=>!mark);
const $ce08caf63142cd2c$export$a4048c78ac7b54c8 = (state, markTypes)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return new Map(markTypes.map((markType)=>[
            markType,
            !!markType.isInSet(state.storedMarks || $from.marks())
        ]));
    if (state.selection instanceof (0, $8HW7o.CellSelection)) return $ce08caf63142cd2c$var$cellSelectionHasMarks(state.doc, state.selection, markTypes);
    return $ce08caf63142cd2c$var$wholeRangeHasMarks(from, to, state.doc, markTypes);
};
const $ce08caf63142cd2c$var$cellSelectionHasMarks = (doc, selection, markTypes)=>{
    // Warning: This is micro-optimized and is a total pain to actually read.
    // Will attempt to explain in comments.
    // Start with map of booleans for each mark
    let cellsHaveMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    selection.forEachCell((cell, cellPos)=>{
        // Early exit if all marks are already ruled out
        if ($ce08caf63142cd2c$var$allMarksAreRuledOut(cellsHaveMarks)) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        // On first cell just do a regular check
        if (!cellsHaveMarks) cellsHaveMarks = $ce08caf63142cd2c$var$wholeRangeHasMarks(from, to, doc, markTypes);
        else {
            // Find the marks that are still true ie the ones that haven't been ruled out in
            // previous cells. The idea here is to whittle down the list of marks so that we check
            // less and less as we go, giving `wholeRangeHasMarks` more opportunities to exit early
            const marksToCheck = [];
            for (const [markType, hasMark] of cellsHaveMarks)if (hasMark) marksToCheck.push(markType);
            // Look specifically for the marks that are not yet ruled out.
            const cellHasMarks = $ce08caf63142cd2c$var$wholeRangeHasMarks(from, to, doc, marksToCheck);
            // Map these results back into the original array of results and repeat!
            for (const [markType, hasMark] of cellHasMarks)cellsHaveMarks.set(markType, hasMark);
        }
    });
    return cellsHaveMarks;
};
const $ce08caf63142cd2c$var$wholeRangeHasMarks = (from, to, doc, markTypes)=>{
    const hasMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    const hasNoMarks = new Map(markTypes.map((markType)=>[
            markType,
            false
        ]));
    let isTextContent = false;
    doc.nodesBetween(from, to, (node)=>{
        if ($ce08caf63142cd2c$var$allMarksAreRuledOut(hasMarks)) // This won't be a true early exit, but will prevent diving into nodes and
        // any checks further down the function.
        return false;
        if (!node.type.isText) return true; // continue traversing
        isTextContent = true;
        for (const [markType, hasMark] of hasMarks){
            if (!hasMark) continue; // already ruled out the mark, skip further checks
            const value = markType instanceof (0, $aPdNQ.Mark) ? markType.isInSet(node.marks) : node.marks.some((mark)=>mark.type === markType);
            hasMarks.set(markType, value);
        }
    });
    return isTextContent ? hasMarks : hasNoMarks;
};






var $2w79Z = parcelRequire("2w79Z");


var $iUNgd = parcelRequire("iUNgd");

















var $eEdSM = parcelRequire("eEdSM");








const $fbb313273b8f3bd4$export$e2c874fbfec7201 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = (0, $3b1be4d5b50fca83$export$c91f8b3cbd625635)(state, code.create());
            const currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            const nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            const exitingCode = !currentPosHasCode && !nextPosHasCode && (!storedMarks || !!storedMarks.length);
            const enteringCode = !currentPosHasCode && nextPosHasCode && (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $fbb313273b8f3bd4$export$108f27160c89e515 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = code && (0, $3b1be4d5b50fca83$export$c91f8b3cbd625635)(state, code.create());
            const currentPosHasCode = (0, $3b1be4d5b50fca83$export$435b7561880b778c)(state, $cursor.pos);
            const nextPosHasCode = (0, $3b1be4d5b50fca83$export$435b7561880b778c)(state, $cursor.pos - 1);
            const nextNextPosHasCode = (0, $3b1be4d5b50fca83$export$435b7561880b778c)(state, $cursor.pos - 2);
            const exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            const atLeftEdge = nextPosHasCode && !nextNextPosHasCode && (storedMarks === null || Array.isArray(storedMarks) && !!storedMarks.length);
            const atRightEdge = (exitingCode && Array.isArray(storedMarks) && !storedMarks.length || !exitingCode && storedMarks === null) && !nextPosHasCode && nextNextPosHasCode;
            const enteringCode = !currentPosHasCode && nextPosHasCode && Array.isArray(storedMarks) && !storedMarks.length;
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                const tr = state.tr.setSelection((0, $kCECX.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.removeStoredMark(code));
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                const tr = state.tr.setSelection((0, $kCECX.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            const isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode && (exitingCode || !$cursor.nodeBefore && isFirstChild)) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $fbb313273b8f3bd4$var$createInlineCodeFromTextInput = (from, to, text)=>{
    return (state, dispatch)=>{
        if (state.selection.empty) {
            const { nodeBefore: before } = state.doc.resolve(from);
            const { nodeAfter: after } = state.doc.resolve(to);
            const hasTickBefore = before && before.text && before.text.endsWith('`');
            const hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                let tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    const codeMark = state.schema.marks.code.create();
                    tr = (0, $bhf6v.applyMarkOnRange)(tr.mapping.map(from - 1), tr.mapping.map(to + 1), false, codeMark, tr).setStoredMarks([
                        codeMark
                    ]);
                    dispatch(tr);
                }
                return true;
            }
        }
        return false;
    };
};
const $fbb313273b8f3bd4$export$7a99a2b030134bb0 = (editorAnalyticsAPI)=>(from, to, text)=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).FORMATTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CODE,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
            }
        })($fbb313273b8f3bd4$var$createInlineCodeFromTextInput(from, to, text));
    };



const $209076d176b346ea$var$isSelectionInlineCursor = (selection)=>{
    if (selection instanceof (0, $kCECX.NodeSelection)) return true;
    return false;
};
const $209076d176b346ea$var$checkNodeSelection = (mark, editorState, type)=>{
    const selection = editorState.selection;
    if ($209076d176b346ea$var$isSelectionInlineCursor(selection)) return false;
    return (0, $iUNgd.toggleMark)(mark, {
        type: type
    })(editorState);
};
const $209076d176b346ea$var$getTextFormattingState = (editorState, _editorAnalyticsAPI)=>{
    const { em: em, code: code, strike: strike, strong: strong, subsup: subsup, underline: underline } = editorState.schema.marks;
    const state = {
        isInitialised: true
    };
    const showOnlyCommonMarks = (0, $ieeJu.expValEquals)('platform_editor_controls', 'cohort', 'variant1');
    if (showOnlyCommonMarks) {
        // Code marks will disable all other formatting options when they are included in a
        // selection but (for now) we do not want to make it behave differently in regards to which
        // toolbar items are highlighted on selection. We need to track code in selection seperately
        // to ensure all other formatting options are disabled appropriately.
        if (code) state.codeInSelection = (0, $ca4Zc.anyMarkActive)(editorState, code.create());
        const marks = [
            [
                code,
                'code'
            ],
            [
                em,
                'em'
            ],
            [
                strike,
                'strike'
            ],
            [
                strong,
                'strong'
            ],
            [
                underline,
                'underline'
            ],
            [
                subsup?.create({
                    type: 'sub'
                }),
                'subscript'
            ],
            [
                subsup?.create({
                    type: 'sup'
                }),
                'superscript'
            ]
        ].filter(([mark])=>mark);
        const marksToName = new Map(marks);
        const activeMarks = (0, $ce08caf63142cd2c$export$a4048c78ac7b54c8)(editorState, Array.from(marksToName.keys()));
        for (const [mark, markName] of marks){
            const active = activeMarks.get(mark);
            if (active !== undefined) state[`${markName}Active`] = active;
            state[`${markName}Disabled`] = // Disable when code is active, except for code itself which should not be disabled
            // when code is in selection 😅
            state.codeInSelection && markName !== 'code' ? true : !$209076d176b346ea$var$checkNodeSelection(mark instanceof (0, $aPdNQ.MarkType) ? mark : mark.type, editorState);
        }
        return state;
    }
    if (code) {
        state.codeActive = (0, $ca4Zc.anyMarkActive)(editorState, code.create());
        state.codeDisabled = !$209076d176b346ea$var$checkNodeSelection(code, editorState);
    }
    if (em) {
        state.emActive = (0, $ca4Zc.anyMarkActive)(editorState, em);
        state.emDisabled = state.codeActive ? true : !$209076d176b346ea$var$checkNodeSelection(em, editorState);
    }
    if (strike) {
        state.strikeActive = (0, $ca4Zc.anyMarkActive)(editorState, strike);
        state.strikeDisabled = state.codeActive ? true : !$209076d176b346ea$var$checkNodeSelection(strike, editorState);
    }
    if (strong) {
        state.strongActive = (0, $ca4Zc.anyMarkActive)(editorState, strong);
        state.strongDisabled = state.codeActive ? true : !$209076d176b346ea$var$checkNodeSelection(strong, editorState);
    }
    if (subsup) {
        const subMark = subsup.create({
            type: 'sub'
        });
        const supMark = subsup.create({
            type: 'sup'
        });
        state.subscriptActive = (0, $ca4Zc.anyMarkActive)(editorState, subMark);
        state.superscriptActive = (0, $ca4Zc.anyMarkActive)(editorState, supMark);
        state.subscriptDisabled = state.codeActive ? true : !$209076d176b346ea$var$checkNodeSelection(subsup, editorState, 'sub');
        state.superscriptDisabled = state.codeActive ? true : !$209076d176b346ea$var$checkNodeSelection(subsup, editorState, 'sup');
    }
    if (underline) {
        state.underlineActive = (0, $ca4Zc.anyMarkActive)(editorState, underline);
        state.underlineDisabled = state.codeActive ? true : !$209076d176b346ea$var$checkNodeSelection(underline, editorState);
    }
    return state;
};
const $209076d176b346ea$export$ca524d3785e2543 = (dispatch, editorAnalyticsAPI)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init (_config, state) {
                return $209076d176b346ea$var$getTextFormattingState(state, editorAnalyticsAPI);
            },
            apply (_tr, pluginState, _oldState, newState) {
                const state = $209076d176b346ea$var$getTextFormattingState(newState, editorAnalyticsAPI);
                if (!(0, $2w79Z.shallowEqual)(pluginState, state)) {
                    dispatch((0, $8f71687d31171b9c$export$18d4026d1ea86bb1), state);
                    return state;
                }
                return pluginState;
            }
        },
        key: (0, $8f71687d31171b9c$export$18d4026d1ea86bb1),
        props: {
            handleKeyDown (view, event) {
                const { state: state, dispatch: dispatch } = view;
                if (event.key === (0, $ldqjS.moveRight).common && !event.metaKey) return $fbb313273b8f3bd4$export$e2c874fbfec7201()(state, dispatch);
                else if (event.key === (0, $ldqjS.moveLeft).common && !event.metaKey) return $fbb313273b8f3bd4$export$108f27160c89e515()(state, dispatch);
                else if (event.key === 'u' && event.metaKey && (0, $8f71687d31171b9c$export$18d4026d1ea86bb1).getState(state)?.underlineDisabled && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) // This is a workaround for browser behaviour with cmd+u (in Chrome only) where the underline mark being applied around the selection
                event.preventDefault();
                return false;
            },
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const { schema: schema, selection: { $from: { parent: { type: parentNodeType } } } } = state;
                if (parentNodeType.allowsMarkType(schema.marks.code)) return (0, $fbb313273b8f3bd4$export$7a99a2b030134bb0)(editorAnalyticsAPI)(from, to, text)(state, dispatch);
                return false;
            }
        }
    });





var $614152db155f94f0$export$27c95a7104c1f7aa = /*#__PURE__*/ function(SYMBOL) {
    SYMBOL["ARROW_RIGHT"] = "rightArrow";
    SYMBOL["ARROW_LEFT"] = "leftArrow";
    SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
    return SYMBOL;
}({});
var $614152db155f94f0$export$3530f2dd0e78fdc2 = /*#__PURE__*/ function(PUNC) {
    PUNC["DASH"] = "emDash";
    PUNC["ELLIPSIS"] = "ellipsis";
    PUNC["QUOTE_SINGLE"] = "singleQuote";
    PUNC["QUOTE_DOUBLE"] = "doubleQuote";
    return PUNC;
}({});
















// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
// wrapped text
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$WRAPPED_SINGLE_QUOTE_REGEX = /(\s|^)'(\S+.*\S+)'$/;
// apostrophe
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$APOSTROPHE_REGEX = /(\w+)(')(\w+)$/;
// Product rules
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$ATLASSIAN_REGEX = /(\s+|^)(atlassian)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$JIRA_REGEX = /(\s+|^)(jira|JIRA)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$BITBUCKET_REGEX = /(\s+|^)(bitbucket|BitBucket)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$HIPCHAT_REGEX = /(\s+|^)(hipchat|HipChat)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$TRELLO_REGEX = /(\s+|^)(trello)(\s)$/;
// Symbol rules
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$ARROW_RIGHT_REGEX = /(\s+|^)(--?>)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$ARROW_LEFT_REGEX = /(\s+|^)(<--?)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$ARROW_DOUBLE_REGEX = /(\s+|^)(<->?)(\s)$/;
// Punctuation rules
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$DASH_REGEX = /(\s+|^)(--)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$ELLIPSIS_REGEX = /()(\.\.\.)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$OPEN_DOUBLE_QUOTE_REGEX = /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7b9cfc85920f40ae$var$CLOSE_DOUBLE_QUOTE_REGEX = /"$/;
/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */ function $7b9cfc85920f40ae$var$replaceTextUsingCaptureGroup(text) {
    return (state, match, start, end)=>{
        const [, prefix, , suffix] = match;
        const replacement = text + (suffix || '');
        const { tr: tr, selection: { $to: $to } } = state;
        const startPos = start + (prefix || '').length;
        const safePos = Math.min(// I know it is almost impossible to have a negative value at this point.
        // But, this is JS #trustnoone
        Math.max(startPos, 0), end);
        tr.replaceWith(safePos, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function $7b9cfc85920f40ae$var$createReplacementRule(to, from) {
    return (0, $d8RhQ.createRule)(from, $7b9cfc85920f40ae$var$replaceTextUsingCaptureGroup(to));
}
/**
 * Create replacement rules fiven a replacement map
 * @param replMap - Replacement map
 * @param trackingEventName - Analytics V2 tracking event name
 * @param replacementRuleWithAnalytics - Analytics GAS V3 middleware for replacement and rules.
 */ function $7b9cfc85920f40ae$var$createReplacementRules(replMap, replacementRuleWithAnalytics) {
    return Object.keys(replMap).map((replacement)=>{
        const regex = replMap[replacement];
        const rule = $7b9cfc85920f40ae$var$createReplacementRule(replacement, regex);
        if (replacementRuleWithAnalytics) return replacementRuleWithAnalytics(replacement)(rule);
        return rule;
    });
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function $7b9cfc85920f40ae$var$createSingleQuotesRules() {
    return [
        // wrapped text
        (0, $d8RhQ.createRule)($7b9cfc85920f40ae$var$WRAPPED_SINGLE_QUOTE_REGEX, (state, match, start, end)=>{
            const OPEN_SMART_QUOTE_CHAR = "\u2018";
            const CLOSED_SMART_QUOTE_CHAR = "\u2019";
            const [, spacing, innerContent] = match;
            // Edge case where match begins with some spacing. We need to add
            // it back to the document
            const openQuoteReplacement = spacing + OPEN_SMART_QUOTE_CHAR;
            // End is not always where the closed quote is, edge case exists
            // when there is spacing after the closed quote. We need to
            // determine position of closed quote from the start position.
            const positionOfClosedQuote = start + openQuoteReplacement.length + innerContent.length;
            return state.tr.insertText(CLOSED_SMART_QUOTE_CHAR, positionOfClosedQuote, end).insertText(openQuoteReplacement, start, start + openQuoteReplacement.length);
        }),
        // apostrophe
        $7b9cfc85920f40ae$var$createReplacementRule("\u2019", $7b9cfc85920f40ae$var$APOSTROPHE_REGEX)
    ];
}
/**
 * Get replacement rules related to product
 */ function $7b9cfc85920f40ae$var$getProductRules(editorAnalyticsAPI) {
    const productRuleWithAnalytics = (product)=>(0, $c2pcC.inputRuleWithAnalytics)((_, match)=>({
                action: (0, $krYZG.ACTION).SUBSTITUTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PRODUCT_NAME,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    product: product,
                    originalSpelling: match[2]
                }
            }), editorAnalyticsAPI);
    return $7b9cfc85920f40ae$var$createReplacementRules({
        Atlassian: $7b9cfc85920f40ae$var$ATLASSIAN_REGEX,
        Jira: $7b9cfc85920f40ae$var$JIRA_REGEX,
        Bitbucket: $7b9cfc85920f40ae$var$BITBUCKET_REGEX,
        Hipchat: $7b9cfc85920f40ae$var$HIPCHAT_REGEX,
        Trello: $7b9cfc85920f40ae$var$TRELLO_REGEX
    }, productRuleWithAnalytics);
}
/**
 * Get replacement rules related to symbol
 */ function $7b9cfc85920f40ae$var$getSymbolRules(editorAnalyticsAPI) {
    const symbolToString = {
        "\u2192": (0, $614152db155f94f0$export$27c95a7104c1f7aa).ARROW_RIGHT,
        "\u2190": (0, $614152db155f94f0$export$27c95a7104c1f7aa).ARROW_LEFT,
        "\u2194\uFE0E": (0, $614152db155f94f0$export$27c95a7104c1f7aa).ARROW_DOUBLE
    };
    const symbolRuleWithAnalytics = (symbol)=>(0, $c2pcC.inputRuleWithAnalytics)({
            action: (0, $krYZG.ACTION).SUBSTITUTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYMBOL,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                symbol: symbolToString[symbol]
            }
        }, editorAnalyticsAPI);
    return $7b9cfc85920f40ae$var$createReplacementRules({
        "\u2192": $7b9cfc85920f40ae$var$ARROW_RIGHT_REGEX,
        "\u2190": $7b9cfc85920f40ae$var$ARROW_LEFT_REGEX,
        "\u2194\uFE0E": $7b9cfc85920f40ae$var$ARROW_DOUBLE_REGEX
    }, symbolRuleWithAnalytics);
}
/**
 * Get replacement rules related to punctuation
 */ function $7b9cfc85920f40ae$var$getPunctuationRules(editorAnalyticsAPI) {
    const punctuationToString = {
        "\u2013": (0, $614152db155f94f0$export$3530f2dd0e78fdc2).DASH,
        "\u2026": (0, $614152db155f94f0$export$3530f2dd0e78fdc2).ELLIPSIS,
        "\u201D": (0, $614152db155f94f0$export$3530f2dd0e78fdc2).QUOTE_DOUBLE,
        [(0, $614152db155f94f0$export$3530f2dd0e78fdc2).QUOTE_SINGLE]: (0, $614152db155f94f0$export$3530f2dd0e78fdc2).QUOTE_SINGLE
    };
    const punctuationRuleWithAnalytics = (punctuation)=>(0, $c2pcC.inputRuleWithAnalytics)({
            action: (0, $krYZG.ACTION).SUBSTITUTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PUNC,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                punctuation: punctuationToString[punctuation]
            }
        }, editorAnalyticsAPI);
    const dashEllipsisRules = $7b9cfc85920f40ae$var$createReplacementRules({
        "\u2013": $7b9cfc85920f40ae$var$DASH_REGEX,
        "\u2026": $7b9cfc85920f40ae$var$ELLIPSIS_REGEX
    }, punctuationRuleWithAnalytics);
    const doubleQuoteRules = $7b9cfc85920f40ae$var$createReplacementRules({
        "\u201C": $7b9cfc85920f40ae$var$OPEN_DOUBLE_QUOTE_REGEX,
        "\u201D": $7b9cfc85920f40ae$var$CLOSE_DOUBLE_QUOTE_REGEX
    }, punctuationRuleWithAnalytics);
    const singleQuoteRules = $7b9cfc85920f40ae$var$createSingleQuotesRules();
    return [
        ...dashEllipsisRules,
        ...doubleQuoteRules,
        ...singleQuoteRules.map((rule)=>punctuationRuleWithAnalytics((0, $614152db155f94f0$export$3530f2dd0e78fdc2).QUOTE_SINGLE)(rule))
    ];
}
var $7b9cfc85920f40ae$export$2e2bcd8739ae039 = (editorAnalyticsAPI)=>new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('text-formatting:smart-input', [
        ...$7b9cfc85920f40ae$var$getProductRules(editorAnalyticsAPI),
        ...$7b9cfc85920f40ae$var$getSymbolRules(editorAnalyticsAPI),
        ...$7b9cfc85920f40ae$var$getPunctuationRules(editorAnalyticsAPI)
    ]));


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $6OREF = parcelRequire("6OREF");







var $7381c682d57cc411$export$f84ca76848e3ed34 = /*#__PURE__*/ function(IconTypes) {
    IconTypes["strong"] = "strong";
    IconTypes["em"] = "em";
    IconTypes["underline"] = "underline";
    IconTypes["strike"] = "strike";
    IconTypes["code"] = "code";
    IconTypes["subscript"] = "subscript";
    IconTypes["superscript"] = "superscript";
    return IconTypes;
}({});
var $7381c682d57cc411$export$c1fb0eb1ea3f6fb6 = /*#__PURE__*/ function(FormatOptions) {
    FormatOptions["strong"] = "strong";
    FormatOptions["em"] = "em";
    FormatOptions["underline"] = "underline";
    FormatOptions["strike"] = "strike";
    FormatOptions["code"] = "code";
    FormatOptions["subscript"] = "subscript";
    FormatOptions["superscript"] = "superscript";
    return FormatOptions;
}({});
var $7381c682d57cc411$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


const $39ee68b5e1b493f1$export$37a675a4731536c = [
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).strong,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).em
];
const $39ee68b5e1b493f1$export$9930ae1c7f6b53f3 = [
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).strong
];
const $39ee68b5e1b493f1$export$def34bf0ee813055 = [
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).strong,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).em,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).underline
];
const $39ee68b5e1b493f1$export$5789feaf6941ee12 = [
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).em,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).underline,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).strike,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).code,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).subscript,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).superscript
];
const $39ee68b5e1b493f1$export$f40ebaa61bfc4d53 = [
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).underline,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).strike,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).code,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).subscript,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).superscript
];
const $39ee68b5e1b493f1$export$b1ac64c82cac61ce = [
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).strike,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).code,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).subscript,
    (0, $7381c682d57cc411$export$f84ca76848e3ed34).superscript
];
const $39ee68b5e1b493f1$export$13589e95a4a6fb40 = {
    [(0, $6OREF.ToolbarSize).XXL]: $39ee68b5e1b493f1$export$9930ae1c7f6b53f3,
    [(0, $6OREF.ToolbarSize).XL]: $39ee68b5e1b493f1$export$9930ae1c7f6b53f3,
    [(0, $6OREF.ToolbarSize).L]: $39ee68b5e1b493f1$export$9930ae1c7f6b53f3,
    [(0, $6OREF.ToolbarSize).M]: $39ee68b5e1b493f1$export$9930ae1c7f6b53f3,
    [(0, $6OREF.ToolbarSize).S]: $39ee68b5e1b493f1$export$9930ae1c7f6b53f3,
    [(0, $6OREF.ToolbarSize).XXXS]: []
};
const $39ee68b5e1b493f1$export$fdd1bbcb63018330 = {
    [(0, $6OREF.ToolbarSize).XXL]: $39ee68b5e1b493f1$export$37a675a4731536c,
    [(0, $6OREF.ToolbarSize).XL]: $39ee68b5e1b493f1$export$37a675a4731536c,
    [(0, $6OREF.ToolbarSize).L]: $39ee68b5e1b493f1$export$37a675a4731536c,
    [(0, $6OREF.ToolbarSize).M]: $39ee68b5e1b493f1$export$37a675a4731536c,
    [(0, $6OREF.ToolbarSize).S]: $39ee68b5e1b493f1$export$37a675a4731536c,
    [(0, $6OREF.ToolbarSize).XXXS]: []
};
const $39ee68b5e1b493f1$export$861ad8d05e95bc1e = {
    [(0, $6OREF.ToolbarSize).XXL]: $39ee68b5e1b493f1$export$def34bf0ee813055,
    [(0, $6OREF.ToolbarSize).XL]: $39ee68b5e1b493f1$export$def34bf0ee813055,
    [(0, $6OREF.ToolbarSize).L]: $39ee68b5e1b493f1$export$def34bf0ee813055,
    [(0, $6OREF.ToolbarSize).M]: $39ee68b5e1b493f1$export$37a675a4731536c,
    [(0, $6OREF.ToolbarSize).S]: $39ee68b5e1b493f1$export$37a675a4731536c,
    [(0, $6OREF.ToolbarSize).XXXS]: $39ee68b5e1b493f1$export$9930ae1c7f6b53f3
};
const $39ee68b5e1b493f1$export$1b53a931a2dd9e07 = {
    [(0, $6OREF.ToolbarSize).XXL]: $39ee68b5e1b493f1$export$5789feaf6941ee12,
    [(0, $6OREF.ToolbarSize).XL]: $39ee68b5e1b493f1$export$5789feaf6941ee12,
    [(0, $6OREF.ToolbarSize).L]: $39ee68b5e1b493f1$export$5789feaf6941ee12,
    [(0, $6OREF.ToolbarSize).M]: $39ee68b5e1b493f1$export$5789feaf6941ee12,
    [(0, $6OREF.ToolbarSize).S]: $39ee68b5e1b493f1$export$5789feaf6941ee12,
    [(0, $6OREF.ToolbarSize).XXXS]: [
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).strong,
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).em,
        ...$39ee68b5e1b493f1$export$5789feaf6941ee12
    ]
};
const $39ee68b5e1b493f1$export$53d57ab9be604153 = {
    [(0, $6OREF.ToolbarSize).XXL]: $39ee68b5e1b493f1$export$f40ebaa61bfc4d53,
    [(0, $6OREF.ToolbarSize).XL]: $39ee68b5e1b493f1$export$f40ebaa61bfc4d53,
    [(0, $6OREF.ToolbarSize).L]: $39ee68b5e1b493f1$export$f40ebaa61bfc4d53,
    [(0, $6OREF.ToolbarSize).M]: $39ee68b5e1b493f1$export$f40ebaa61bfc4d53,
    [(0, $6OREF.ToolbarSize).S]: $39ee68b5e1b493f1$export$f40ebaa61bfc4d53,
    [(0, $6OREF.ToolbarSize).XXXS]: [
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).strong,
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).em,
        ...$39ee68b5e1b493f1$export$f40ebaa61bfc4d53
    ]
};
const $39ee68b5e1b493f1$export$77ad87491c5fbf88 = {
    [(0, $6OREF.ToolbarSize).XXL]: $39ee68b5e1b493f1$export$b1ac64c82cac61ce,
    [(0, $6OREF.ToolbarSize).XL]: $39ee68b5e1b493f1$export$b1ac64c82cac61ce,
    [(0, $6OREF.ToolbarSize).L]: $39ee68b5e1b493f1$export$b1ac64c82cac61ce,
    [(0, $6OREF.ToolbarSize).M]: [
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).underline,
        ...$39ee68b5e1b493f1$export$b1ac64c82cac61ce
    ],
    [(0, $6OREF.ToolbarSize).S]: [
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).underline,
        ...$39ee68b5e1b493f1$export$b1ac64c82cac61ce
    ],
    [(0, $6OREF.ToolbarSize).XXXS]: [
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).em,
        (0, $7381c682d57cc411$export$f84ca76848e3ed34).underline,
        ...$39ee68b5e1b493f1$export$b1ac64c82cac61ce
    ]
};









var $bq13E = parcelRequire("bq13E");


var $gLi18 = parcelRequire("gLi18");


var $7Y8M5 = parcelRequire("7Y8M5");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");





var $9iFhC = parcelRequire("9iFhC");

var $6DhDg = parcelRequire("6DhDg");


var $ldbHR = parcelRequire("ldbHR");


var $7sJoX = parcelRequire("7sJoX");


var $aHWpe = parcelRequire("aHWpe");


const $5dd18c6b4b865e27$export$7c43b97d70f40057 = ({ label: label, isReducedSpacing: isReducedSpacing, isDisabled: isDisabled, isSelected: isSelected, 'aria-expanded': ariaExpanded, onClick: onClick, onKeyDown: onKeyDown, toolbarType: toolbarType, iconBefore: iconBefore, activeIconName: activeIconName })=>{
    const reducedSpacing = toolbarType === (0, $7381c682d57cc411$export$a5d11b3163e4b1a5).FLOATING ? 'compact' : 'none';
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
        css: (0, $9iFhC.disableBlueBorderStyles),
        testId: 'ak-editor-selection-toolbar-format-text-button',
        spacing: isReducedSpacing ? reducedSpacing : 'default',
        disabled: isDisabled,
        selected: isSelected,
        "aria-label": label,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": true,
        title: label,
        onClick: onClick,
        onKeyDown: onKeyDown,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9iFhC.triggerWrapperStylesWithPadding),
            "data-testid": activeIconName ? `editor-toolbar__${activeIconName}` : undefined
        }, iconBefore ? iconBefore : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aHWpe))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: (0, $6DhDg.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            color: "currentColor",
            size: "small"
        })))
    });
};





const $1007128856121d75$export$8091e3849c182a6 = ()=>{
    const [isMenuOpen, setIsMenuOpened] = (0, $cozmU.useState)(false);
    const toggleMenu = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpened(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    const closeMenu = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpened(false);
    }, []);
    return [
        isMenuOpen,
        toggleMenu,
        closeMenu
    ];
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $6TaGl = parcelRequire("6TaGl");

function $66d33971129083c8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $66d33971129083c8$var$MoreIconStyle = {
    name: "1m17jn9",
    styles: "display:flex;align-items:center;height:var(--ds-space-300, 24px)"
};
const $66d33971129083c8$export$7f94856880993f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ label: label, 'aria-expanded': ariaExpanded, isReducedSpacing: isReducedSpacing, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        disabled: isDisabled,
        selected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: label,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $66d33971129083c8$var$MoreIconStyle
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            size: "small"
        })),
        "aria-expanded": ariaExpanded,
        "aria-label": label,
        "aria-haspopup": true
    });
});


const $561497b655f68199$export$52e9a2bbe5d185e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ editorView: editorView, moreButtonLabel: moreButtonLabel, isReducedSpacing: isReducedSpacing, items: items, hasFormattingActive: hasFormattingActive, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, hasMoreButton: hasMoreButton, intl: intl, toolbarType: toolbarType, isDisabled: isDisabled })=>{
    const [isMenuOpen, toggleMenu, closeMenu] = (0, $1007128856121d75$export$8091e3849c182a6)();
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    const onItemActivated = (0, $cozmU.useCallback)(({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        if (item) {
            item.command(editorView.state, editorView.dispatch);
            if (shouldCloseMenu) closeMenu();
        }
    }, [
        editorView.state,
        editorView.dispatch,
        closeMenu
    ]);
    const activeItem = items[0].items.find((item)=>item.isActive);
    const defaultIcon = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? items[0].items[0]?.elemBefore : undefined;
    const defaultIconName = items[0].items[0]?.value.name;
    const iconBefore = activeItem ? activeItem?.elemBefore : defaultIcon;
    const activeIconName = activeItem?.value.name || defaultIconName;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gLi18.DropdownMenuWithKeyboardNavigation), {
        mountTo: popupsMountPoint,
        onOpenChange: closeMenu,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onItemActivated: onItemActivated,
        isOpen: isMenuOpen,
        items: items,
        zIndex: (0, $7Y8M5.akEditorMenuZIndex),
        fitHeight: 188,
        fitWidth: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') ? 136 : 230,
        shouldUseDefaultRole: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        section: {
            hasSeparator: true
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setIsOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        },
        children: hasMoreButton ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $66d33971129083c8$export$7f94856880993f27), {
            isSelected: isMenuOpen || hasFormattingActive,
            label: moreButtonLabel,
            isReducedSpacing: isReducedSpacing,
            isDisabled: false,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            "aria-expanded": isMenuOpen
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5dd18c6b4b865e27$export$7c43b97d70f40057), {
            isReducedSpacing: isReducedSpacing,
            isDisabled: Boolean(isDisabled),
            isSelected: isMenuOpen,
            label: intl.formatMessage((0, $bq13E.toolbarMessages).textFormat),
            "aria-expanded": isMenuOpen,
            "aria-haspopup": true,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            toolbarType: toolbarType,
            iconBefore: iconBefore,
            activeIconName: activeIconName
        })
    });
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 












var $lrTDq = parcelRequire("lrTDq");


var $bWjzw = parcelRequire("bWjzw");









const $0e2924d6081bc1f0$export$ec2f5afcaf7ee094 = {
    [(0, $7381c682d57cc411$export$a5d11b3163e4b1a5).PRIMARY]: (0, $krYZG.INPUT_METHOD).TOOLBAR,
    [(0, $7381c682d57cc411$export$a5d11b3163e4b1a5).FLOATING]: (0, $krYZG.INPUT_METHOD).FLOATING_TB
};
const $0e2924d6081bc1f0$export$8213a6fbfa466e73 = (toolbarType)=>$0e2924d6081bc1f0$export$ec2f5afcaf7ee094[toolbarType];


const $6dcd2d05d8c8a616$export$4ff17fae4b9914b = ({ intl: intl, formattingPluginInitialised: formattingPluginInitialised, formattingIsPresent: formattingPresent, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const isPluginAvailable = Boolean(formattingPluginInitialised);
    const formattingIsPresent = Boolean(formattingPresent);
    const clearFormattingLabel = intl.formatMessage((0, $bq13E.toolbarMessages).clearFormatting);
    const clearFormattingToolbar = (0, $cozmU.useCallback)((state, dispatch)=>(0, $24e404e609d25c50$export$332a1f720fc2ba0)((0, $0e2924d6081bc1f0$export$8213a6fbfa466e73)(toolbarType), editorAnalyticsAPI)(state, dispatch), [
        editorAnalyticsAPI,
        toolbarType
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (!isPluginAvailable) return null;
        return {
            key: 'clearFormatting',
            command: clearFormattingToolbar,
            content: clearFormattingLabel,
            elemBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bWjzw))), {
                label: ""
            }) : undefined,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $lrTDq.shortcutStyle)
            }, (0, $ldqjS.tooltip)((0, $ldqjS.clearFormatting))),
            value: {
                name: 'clearFormatting'
            },
            isActive: false,
            isDisabled: !formattingIsPresent,
            'aria-label': (0, $ldqjS.clearFormatting) ? (0, $ldqjS.tooltip)((0, $ldqjS.clearFormatting), String(clearFormattingLabel)) : String(clearFormattingLabel)
        };
    }, [
        isPluginAvailable,
        clearFormattingToolbar,
        clearFormattingLabel,
        formattingIsPresent
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $aiL0G = parcelRequire("aiL0G");








var $aC6bW = parcelRequire("aC6bW");





var $6YkHb = parcelRequire("6YkHb");


var $iaH8x = parcelRequire("iaH8x");





var $96adu = parcelRequire("96adu");


var $g4d3e = parcelRequire("g4d3e");





/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 


parcelRequire("cozmU");

const $b706317c847f38f3$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        children: children
    });
const $b706317c847f38f3$export$54eb3b8088f84d2b = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($b706317c847f38f3$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.10609 6.54799L7.88895 2.09448L9.16102 2.88936L5.99047 7.9633L9.21219 13.1191L7.94012 13.914L5.10609 9.37861L2.27207 13.914L1 13.1191L4.2217 7.9633L1.05117 2.88939L2.32324 2.09451L5.10609 6.54799ZM10.858 15.0001V13.696H12.3499V10.3153L10.8418 11.4343V9.86413L12.3138 8.83114H13.8161V13.696H14.9999V15.0001H10.858Z",
                fill: "currentColor"
            })
        })
    });
const $b706317c847f38f3$export$a4eac561e2e9d419 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($b706317c847f38f3$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.858 7.16892V5.86487H12.3499V2.4842L10.8418 3.60312V2.03298L12.3138 1H13.8161V5.86487H14.9999V7.16892H10.858ZM5.10609 6.5479L7.88895 2.09439L9.16102 2.88927L5.99047 7.96321L9.21219 13.119L7.94012 13.9139L5.10609 9.37852L2.27207 13.9139L1 13.119L4.2217 7.96321L1.05117 2.8893L2.32324 2.09442L5.10609 6.5479Z",
                fill: "currentColor"
            })
        })
    });




const $9a8dbe51ac99095f$var$withInputMethod = (toolbarType, func)=>(0, $aC6bW.editorCommandToPMCommand)(func((0, $0e2924d6081bc1f0$export$8213a6fbfa466e73)(toolbarType)));
const $9a8dbe51ac99095f$var$IconButtons = (editorAnalyticsAPI, toolbarType)=>({
        strong: {
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_STRONG,
            command: $9a8dbe51ac99095f$var$withInputMethod(toolbarType, (0, $b0a32d3ef086f313$export$686bc7c29753e27)(editorAnalyticsAPI)),
            message: (0, $bq13E.toolbarMessages).bold,
            tooltipKeymap: (0, $ldqjS.toggleBold),
            component: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iaH8x))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        em: {
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_ITALIC,
            command: $9a8dbe51ac99095f$var$withInputMethod(toolbarType, (0, $b0a32d3ef086f313$export$fe8278eb0d365433)(editorAnalyticsAPI)),
            message: (0, $bq13E.toolbarMessages).italic,
            tooltipKeymap: (0, $ldqjS.toggleItalic),
            component: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aHWpe))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        underline: {
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_UNDERLINE,
            command: $9a8dbe51ac99095f$var$withInputMethod(toolbarType, (0, $b0a32d3ef086f313$export$bf3c86b5abdb857d)(editorAnalyticsAPI)),
            message: (0, $bq13E.toolbarMessages).underline,
            tooltipKeymap: (0, $ldqjS.toggleUnderline),
            component: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4d3e))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        strike: {
            command: $9a8dbe51ac99095f$var$withInputMethod(toolbarType, (0, $b0a32d3ef086f313$export$f08ef336cb688397)(editorAnalyticsAPI)),
            message: (0, $bq13E.toolbarMessages).strike,
            tooltipKeymap: (0, $ldqjS.toggleStrikethrough)
        },
        code: {
            command: $9a8dbe51ac99095f$var$withInputMethod(toolbarType, (0, $b0a32d3ef086f313$export$2d4f5a54f840ba91)(editorAnalyticsAPI)),
            message: (0, $bq13E.toolbarMessages).code,
            tooltipKeymap: (0, $ldqjS.toggleCode)
        },
        subscript: {
            command: $9a8dbe51ac99095f$var$withInputMethod(toolbarType, (0, $b0a32d3ef086f313$export$8d0c92ae27a193)(editorAnalyticsAPI)),
            message: (0, $bq13E.toolbarMessages).subscript,
            tooltipKeymap: (0, $ldqjS.toggleSubscript)
        },
        superscript: {
            command: $9a8dbe51ac99095f$var$withInputMethod(toolbarType, (0, $b0a32d3ef086f313$export$ca1c98793b67ba6b)(editorAnalyticsAPI)),
            message: (0, $bq13E.toolbarMessages).superscript,
            tooltipKeymap: (0, $ldqjS.toggleSuperscript)
        }
    });
const $9a8dbe51ac99095f$var$IconBefore = {
    strong: {
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iaH8x))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    em: {
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aHWpe))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    underline: {
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4d3e))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    strike: {
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96adu))), {
            label: ""
        })
    },
    code: {
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    subscript: {
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b706317c847f38f3$export$54eb3b8088f84d2b), null)
    },
    superscript: {
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b706317c847f38f3$export$a4eac561e2e9d419), null)
    }
};
const $9a8dbe51ac99095f$var$getIcon = ({ iconType: iconType, isDisabled: isDisabled, isActive: isActive, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const icon = $9a8dbe51ac99095f$var$IconButtons(editorAnalyticsAPI, toolbarType)[iconType];
    const iconBefore = $9a8dbe51ac99095f$var$IconBefore[iconType].icon;
    const content = intl.formatMessage(icon.message);
    const { tooltipKeymap: tooltipKeymap } = icon;
    return {
        content: content,
        buttonId: icon.buttonId,
        iconMark: iconType,
        key: iconType,
        command: icon.command,
        iconElement: icon.component ? icon.component() : undefined,
        tooltipElement: tooltipKeymap ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
            description: content,
            keymap: tooltipKeymap
        }) : undefined,
        elemBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? iconBefore : undefined,
        elemAfter: tooltipKeymap ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $lrTDq.shortcutStyle)
        }, (0, $ldqjS.tooltip)(tooltipKeymap)) : undefined,
        value: {
            name: iconType
        },
        isActive: isActive,
        isDisabled: isDisabled,
        'aria-label': tooltipKeymap ? (0, $ldqjS.tooltip)(tooltipKeymap, String(content)) : String(content),
        'aria-keyshortcuts': (0, $ldqjS.getAriaKeyshortcuts)(tooltipKeymap)
    };
};
const $9a8dbe51ac99095f$var$IconsMarkSchema = {
    [(0, $7381c682d57cc411$export$f84ca76848e3ed34).strong]: 'strong',
    [(0, $7381c682d57cc411$export$f84ca76848e3ed34).em]: 'em',
    [(0, $7381c682d57cc411$export$f84ca76848e3ed34).strike]: 'strike',
    [(0, $7381c682d57cc411$export$f84ca76848e3ed34).code]: 'code',
    [(0, $7381c682d57cc411$export$f84ca76848e3ed34).underline]: 'underline',
    [(0, $7381c682d57cc411$export$f84ca76848e3ed34).superscript]: 'subsup',
    [(0, $7381c682d57cc411$export$f84ca76848e3ed34).subscript]: 'subsup'
};
const $9a8dbe51ac99095f$var$buildMenuIconState = (iconMark)=>({ schema: schema, textFormattingState: textFormattingState })=>{
        const hasPluginState = Boolean(textFormattingState?.isInitialised);
        const markSchema = $9a8dbe51ac99095f$var$IconsMarkSchema[iconMark];
        const hasSchemaMark = Boolean(schema.marks[markSchema]);
        if (!hasPluginState) return {
            isActive: false,
            isDisabled: true,
            isHidden: false,
            hasSchemaMark: hasSchemaMark
        };
        const isActive = textFormattingState?.[`${iconMark}Active`];
        const isDisabled = textFormattingState?.[`${iconMark}Disabled`];
        const isHidden = textFormattingState?.[`${iconMark}Hidden`];
        return {
            isActive: Boolean(isActive),
            isDisabled: Boolean(isDisabled),
            isHidden: Boolean(isHidden),
            hasSchemaMark: hasSchemaMark
        };
    };
const $9a8dbe51ac99095f$var$buildIcon = (iconMark, editorAnalyticsAPI, toolbarType)=>{
    const getState = $9a8dbe51ac99095f$var$buildMenuIconState(iconMark);
    return ({ schema: schema, textFormattingState: textFormattingState, intl: intl, isToolbarDisabled: isToolbarDisabled })=>{
        const iconState = getState({
            schema: schema,
            textFormattingState: textFormattingState
        });
        const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, hasSchemaMark: hasSchemaMark } = iconState;
        const iconComponent = (0, $cozmU.useMemo)(()=>$9a8dbe51ac99095f$var$getIcon({
                iconType: (0, $7381c682d57cc411$export$f84ca76848e3ed34)[iconMark],
                isDisabled: isToolbarDisabled || isDisabled,
                isActive: isActive,
                intl: intl,
                editorAnalyticsAPI: editorAnalyticsAPI,
                toolbarType: toolbarType
            }), [
            isToolbarDisabled,
            isDisabled,
            isActive,
            intl
        ]);
        const shouldRenderIcon = hasSchemaMark && !isHidden;
        return (0, $cozmU.useMemo)(()=>shouldRenderIcon ? iconComponent : null, [
            shouldRenderIcon,
            iconComponent
        ]);
    };
};
const $9a8dbe51ac99095f$export$6f298ec13df828 = ({ isToolbarDisabled: isToolbarDisabled, textFormattingState: textFormattingState, schema: schema, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const props = {
        schema: schema,
        textFormattingState: textFormattingState,
        intl: intl,
        isToolbarDisabled: Boolean(isToolbarDisabled),
        toolbarType: toolbarType
    };
    const buildStrongIcon = $9a8dbe51ac99095f$var$buildIcon((0, $7381c682d57cc411$export$f84ca76848e3ed34).strong, editorAnalyticsAPI, toolbarType);
    const buildEmIcon = $9a8dbe51ac99095f$var$buildIcon((0, $7381c682d57cc411$export$f84ca76848e3ed34).em, editorAnalyticsAPI, toolbarType);
    const buildUnderlineIcon = $9a8dbe51ac99095f$var$buildIcon((0, $7381c682d57cc411$export$f84ca76848e3ed34).underline, editorAnalyticsAPI, toolbarType);
    const buildStrikeIcon = $9a8dbe51ac99095f$var$buildIcon((0, $7381c682d57cc411$export$f84ca76848e3ed34).strike, editorAnalyticsAPI, toolbarType);
    const buildCodeIcon = $9a8dbe51ac99095f$var$buildIcon((0, $7381c682d57cc411$export$f84ca76848e3ed34).code, editorAnalyticsAPI, toolbarType);
    const buildSubscriptIcon = $9a8dbe51ac99095f$var$buildIcon((0, $7381c682d57cc411$export$f84ca76848e3ed34).subscript, editorAnalyticsAPI, toolbarType);
    const buildSuperscriptIcon = $9a8dbe51ac99095f$var$buildIcon((0, $7381c682d57cc411$export$f84ca76848e3ed34).superscript, editorAnalyticsAPI, toolbarType);
    const strongIcon = buildStrongIcon(props);
    const emIcon = buildEmIcon(props);
    const underlineIcon = buildUnderlineIcon(props);
    const strikeIcon = buildStrikeIcon(props);
    const codeIcon = buildCodeIcon(props);
    const subscriptIcon = buildSubscriptIcon(props);
    const superscriptIcon = buildSuperscriptIcon(props);
    const result = (0, $cozmU.useMemo)(()=>[
            strongIcon,
            emIcon,
            underlineIcon,
            strikeIcon,
            codeIcon,
            subscriptIcon,
            superscriptIcon
        ], [
        strongIcon,
        emIcon,
        underlineIcon,
        strikeIcon,
        codeIcon,
        subscriptIcon,
        superscriptIcon
    ]);
    return result;
};
const $9a8dbe51ac99095f$export$cb0a2ed6e982a08f = ({ iconTypeList: iconTypeList, textFormattingState: textFormattingState })=>{
    const hasActiveFormatting = (0, $cozmU.useMemo)(()=>{
        if (!textFormattingState?.isInitialised) return false;
        return iconTypeList.some((iconType)=>textFormattingState[`${iconType}Active`]);
    }, [
        textFormattingState,
        iconTypeList
    ]);
    return hasActiveFormatting;
};





const $94c96f91316d911b$export$894adbec036a07c6 = ({ icons: icons, iconTypeList: iconTypeList })=>{
    return (0, $cozmU.useMemo)(()=>{
        return icons.reduce((acc, icon)=>{
            if (!icon || !icon.iconMark) return acc;
            const isIconSingleButton = iconTypeList.includes(icon.iconMark);
            if (isIconSingleButton) return {
                dropdownItems: acc.dropdownItems,
                singleItems: [
                    ...acc.singleItems,
                    icon
                ]
            };
            return {
                dropdownItems: [
                    ...acc.dropdownItems,
                    icon
                ],
                singleItems: acc.singleItems
            };
        }, {
            dropdownItems: [],
            singleItems: []
        });
    }, [
        icons,
        iconTypeList
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 











const $09efe36f0fdf1f93$export$e3e9702c9c21585 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ items: items, isReducedSpacing: isReducedSpacing, editorView: editorView })=>{
    const onClick = (0, $cozmU.useCallback)((command)=>{
        return ()=>{
            command(editorView.state, editorView.dispatch);
            return false;
        };
    }, [
        editorView.state,
        editorView.dispatch
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $9iFhC.buttonGroupStyle)
    }, items.map((item)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            key: item.key,
            testId: `editor-toolbar__${String(item.content)}`,
            buttonId: item.buttonId,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: onClick(item.command),
            selected: item.isActive,
            disabled: item.isDisabled,
            title: item.tooltipElement,
            iconBefore: item.iconElement,
            "aria-pressed": item.isActive,
            "aria-label": item['aria-label'] ?? String(item.content),
            "aria-keyshortcuts": item['aria-keyshortcuts']
        }))));
});



const $bd63528f75c69bdb$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true,
    shouldUseResponsiveToolbar: false,
    toolbarSize: (0, $6OREF.ToolbarSize).S,
    hasMoreButton: false,
    moreButtonLabel: '',
    toolbarType: (0, $7381c682d57cc411$export$a5d11b3163e4b1a5).FLOATING
};
const $bd63528f75c69bdb$var$selector = (states)=>{
    return {
        isInitialised: Boolean(states.textFormattingState?.isInitialised),
        formattingIsPresent: states.textFormattingState?.formattingIsPresent,
        emActive: states.textFormattingState?.emActive,
        emDisabled: states.textFormattingState?.emDisabled,
        emHidden: states.textFormattingState?.emHidden,
        codeActive: states.textFormattingState?.codeActive,
        codeDisabled: states.textFormattingState?.codeDisabled,
        codeHidden: states.textFormattingState?.codeHidden,
        underlineActive: states.textFormattingState?.underlineActive,
        underlineDisabled: states.textFormattingState?.underlineDisabled,
        underlineHidden: states.textFormattingState?.underlineHidden,
        strikeActive: states.textFormattingState?.strikeActive,
        strikeDisabled: states.textFormattingState?.strikeDisabled,
        strikeHidden: states.textFormattingState?.strikeHidden,
        strongActive: states.textFormattingState?.strongActive,
        strongDisabled: states.textFormattingState?.strongDisabled,
        strongHidden: states.textFormattingState?.strongHidden,
        superscriptActive: states.textFormattingState?.superscriptActive,
        superscriptDisabled: states.textFormattingState?.superscriptDisabled,
        superscriptHidden: states.textFormattingState?.superscriptHidden,
        subscriptActive: states.textFormattingState?.subscriptActive,
        subscriptDisabled: states.textFormattingState?.subscriptDisabled,
        subscriptHidden: states.textFormattingState?.subscriptHidden
    };
};
const $bd63528f75c69bdb$var$FloatingToolbarTextFormat = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, editorView: editorView, intl: intl })=>{
    const textFormattingState = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $bd63528f75c69bdb$var$selector);
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $9a8dbe51ac99095f$export$6f298ec13df828)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: $bd63528f75c69bdb$var$FloatingToolbarSettings.disabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: $bd63528f75c69bdb$var$FloatingToolbarSettings.toolbarType
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $94c96f91316d911b$export$894adbec036a07c6)({
        icons: defaultIcons,
        iconTypeList: (0, $39ee68b5e1b493f1$export$9930ae1c7f6b53f3)
    });
    const clearIcon = (0, $6dcd2d05d8c8a616$export$4ff17fae4b9914b)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: $bd63528f75c69bdb$var$FloatingToolbarSettings.toolbarType
    });
    const items = (0, $cozmU.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $09efe36f0fdf1f93$export$e3e9702c9c21585), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: false
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $561497b655f68199$export$52e9a2bbe5d185e8), {
        editorView: editorView,
        items: items,
        isReducedSpacing: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? false : $bd63528f75c69bdb$var$FloatingToolbarSettings.isReducedSpacing,
        moreButtonLabel: $bd63528f75c69bdb$var$FloatingToolbarSettings.moreButtonLabel,
        hasFormattingActive: $bd63528f75c69bdb$var$FloatingToolbarSettings.hasMoreButton,
        hasMoreButton: $bd63528f75c69bdb$var$FloatingToolbarSettings.hasMoreButton,
        intl: intl,
        toolbarType: $bd63528f75c69bdb$var$FloatingToolbarSettings.toolbarType
    }));
};
const $bd63528f75c69bdb$export$d728f1bdde37938b = (0, $kSwu1.injectIntl)($bd63528f75c69bdb$var$FloatingToolbarTextFormat);











/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $2InGJ = parcelRequire("2InGJ");








var $k0VoZ = parcelRequire("k0VoZ");












var $anBbz = parcelRequire("anBbz");



const $59653b92b8e7e570$export$29ca18d8ace26dd8 = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomButtonToolbar = (0, $39ee68b5e1b493f1$export$fdd1bbcb63018330);
    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) ResponsiveCustomButtonToolbar = (0, $39ee68b5e1b493f1$export$13589e95a4a6fb40);
    const iconTypeList = (0, $cozmU.useMemo)(()=>ResponsiveCustomButtonToolbar[toolbarSize], [
        toolbarSize,
        ResponsiveCustomButtonToolbar
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) return 0, $39ee68b5e1b493f1$export$9930ae1c7f6b53f3;
    else return 0, $39ee68b5e1b493f1$export$37a675a4731536c;
};
const $59653b92b8e7e570$export$110e6c3d6580196f = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomMenu = (0, $39ee68b5e1b493f1$export$53d57ab9be604153);
    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) ResponsiveCustomMenu = (0, $39ee68b5e1b493f1$export$1b53a931a2dd9e07);
    const iconTypeList = (0, $cozmU.useMemo)(()=>ResponsiveCustomMenu[toolbarSize], [
        toolbarSize,
        ResponsiveCustomMenu
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) return 0, $39ee68b5e1b493f1$export$5789feaf6941ee12;
    else return 0, $39ee68b5e1b493f1$export$37a675a4731536c;
};
const $59653b92b8e7e570$export$efa5449fdb315092 = ({ icons: icons, toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const iconTypeList = $59653b92b8e7e570$export$29ca18d8ace26dd8({
        toolbarSize: toolbarSize,
        responsivenessEnabled: responsivenessEnabled
    });
    const iconsPosition = (0, $94c96f91316d911b$export$894adbec036a07c6)({
        icons: icons,
        iconTypeList: iconTypeList
    });
    return iconsPosition;
};




const $17e96e8fcecf1e0a$var$ToolbarFormatting = ({ shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, isToolbarDisabled: isToolbarDisabled, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    const [message, setMessage] = (0, $cozmU.useState)('');
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $9a8dbe51ac99095f$export$6f298ec13df828)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: isToolbarDisabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: toolbarType
    });
    const clearIcon = (0, $6dcd2d05d8c8a616$export$4ff17fae4b9914b)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: toolbarType
    });
    const menuIconTypeList = (0, $59653b92b8e7e570$export$110e6c3d6580196f)({
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const hasFormattingActive = (0, $9a8dbe51ac99095f$export$cb0a2ed6e982a08f)({
        iconTypeList: menuIconTypeList,
        textFormattingState: textFormattingState
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $59653b92b8e7e570$export$efa5449fdb315092)({
        icons: defaultIcons,
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const clearFormattingStatus = intl.formatMessage((0, $bq13E.toolbarMessages).textFormattingOff);
    const superscriptOffSubscriptOnStatus = intl.formatMessage((0, $bq13E.toolbarMessages).superscriptOffSubscriptOn);
    const subscriptOffSuperscriptOnStatus = intl.formatMessage((0, $bq13E.toolbarMessages).subscriptOffSuperscriptOn);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const activeItems = [
        ...dropdownItems,
        ...singleItems
    ].filter((item)=>item.isActive);
    const prevActiveItems = (0, $2InGJ.default)(activeItems) ?? [];
    const fromSuperscriptToSubscript = (0, $3b1be4d5b50fca83$export$f8f79f933a3fce55)(activeItems, 'Subscript') && (0, $3b1be4d5b50fca83$export$f8f79f933a3fce55)(prevActiveItems, 'Superscript');
    const fromSubscriptToSuperscript = (0, $3b1be4d5b50fca83$export$f8f79f933a3fce55)(activeItems, 'Superscript') && (0, $3b1be4d5b50fca83$export$f8f79f933a3fce55)(prevActiveItems, 'Subscript');
    let comparedItems;
    let screenReaderMessage = '';
    if (prevActiveItems && activeItems.length > prevActiveItems.length) {
        comparedItems = (0, $3b1be4d5b50fca83$export$53d327693050b221)(activeItems, prevActiveItems);
        screenReaderMessage = intl.formatMessage((0, $bq13E.toolbarMessages).on, {
            formattingType: comparedItems[0].content
        });
    } else {
        comparedItems = (0, $3b1be4d5b50fca83$export$53d327693050b221)(prevActiveItems, activeItems);
        if (comparedItems && comparedItems.length) {
            screenReaderMessage = intl.formatMessage((0, $bq13E.toolbarMessages).off, {
                formattingType: comparedItems[0].content
            });
            if (activeItems[0]?.content === 'Code') screenReaderMessage = intl.formatMessage((0, $bq13E.toolbarMessages).codeOn, {
                textFormattingOff: prevActiveItems?.length > 1 ? clearFormattingStatus : screenReaderMessage
            });
            if (fromSuperscriptToSubscript) screenReaderMessage = superscriptOffSubscriptOnStatus;
            if (fromSubscriptToSuperscript) screenReaderMessage = subscriptOffSuperscriptOnStatus;
        }
    }
    // handle 'Clear formatting' status for screen readers
    if (!activeItems?.length && prevActiveItems?.length > 1) screenReaderMessage = clearFormattingStatus;
    const items = (0, $cozmU.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    const moreFormattingButtonLabel = intl.formatMessage((0, $bq13E.toolbarMessages).moreFormatting);
    const labelTextFormat = intl.formatMessage((0, $bq13E.toolbarMessages).textFormatting);
    (0, $cozmU.useEffect)(()=>{
        if (screenReaderMessage) setMessage(screenReaderMessage);
    }, [
        screenReaderMessage
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $9iFhC.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        role: "group",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'js-text-format-wrap',
        "aria-label": labelTextFormat
    }, message && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $k0VoZ.default), {
        ariaLive: "assertive",
        text: message,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $09efe36f0fdf1f93$export$e3e9702c9c21585), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $9iFhC.wrapperStyle)
    }, isToolbarDisabled && !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $66d33971129083c8$export$7f94856880993f27), {
        label: moreFormattingButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: true,
        isSelected: false,
        "aria-expanded": undefined,
        "aria-pressed": undefined
    })) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $561497b655f68199$export$52e9a2bbe5d185e8), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing,
        moreButtonLabel: moreFormattingButtonLabel,
        hasFormattingActive: hasFormattingActive,
        hasMoreButton: !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1'),
        items: items,
        intl: intl,
        toolbarType: toolbarType,
        isDisabled: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? isToolbarDisabled : false
    }))), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $9iFhC.separatorStyles)
    })));
};
const $17e96e8fcecf1e0a$var$Toolbar = ({ popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, editorView: editorView, isToolbarDisabled: isToolbarDisabled, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)($17e96e8fcecf1e0a$var$ToolbarFormatting, {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: isToolbarDisabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        api: api,
        toolbarType: toolbarType
    });
};
const $17e96e8fcecf1e0a$var$_default_1 = (0, $kSwu1.injectIntl)($17e96e8fcecf1e0a$var$Toolbar);
var $17e96e8fcecf1e0a$export$2e2bcd8739ae039 = $17e96e8fcecf1e0a$var$_default_1;



const $8b574e9f606a8dc6$var$selector = (states)=>{
    return {
        isInitialised: Boolean(states.textFormattingState?.isInitialised),
        formattingIsPresent: states.textFormattingState?.formattingIsPresent,
        emActive: states.textFormattingState?.emActive,
        emDisabled: states.textFormattingState?.emDisabled,
        emHidden: states.textFormattingState?.emHidden,
        codeActive: states.textFormattingState?.codeActive,
        codeDisabled: states.textFormattingState?.codeDisabled,
        codeHidden: states.textFormattingState?.codeHidden,
        underlineActive: states.textFormattingState?.underlineActive,
        underlineDisabled: states.textFormattingState?.underlineDisabled,
        underlineHidden: states.textFormattingState?.underlineHidden,
        strikeActive: states.textFormattingState?.strikeActive,
        strikeDisabled: states.textFormattingState?.strikeDisabled,
        strikeHidden: states.textFormattingState?.strikeHidden,
        strongActive: states.textFormattingState?.strongActive,
        strongDisabled: states.textFormattingState?.strongDisabled,
        strongHidden: states.textFormattingState?.strongHidden,
        superscriptActive: states.textFormattingState?.superscriptActive,
        superscriptDisabled: states.textFormattingState?.superscriptDisabled,
        superscriptHidden: states.textFormattingState?.superscriptHidden,
        subscriptActive: states.textFormattingState?.subscriptActive,
        subscriptDisabled: states.textFormattingState?.subscriptDisabled,
        subscriptHidden: states.textFormattingState?.subscriptHidden
    };
};
const $8b574e9f606a8dc6$export$94516d5cccf573e3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, editorView: editorView, disabled: disabled, isReducedSpacing: isReducedSpacing, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar })=>{
    const textFormattingState = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $8b574e9f606a8dc6$var$selector);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $17e96e8fcecf1e0a$export$2e2bcd8739ae039), {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: disabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        editorAnalyticsAPI: api?.analytics?.actions,
        api: api,
        toolbarType: (0, $7381c682d57cc411$export$a5d11b3163e4b1a5).PRIMARY
    });
});





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");

var $bFSJa = parcelRequire("bFSJa");


var $7T88d = parcelRequire("7T88d");

var $5AKbu = parcelRequire("5AKbu");





parcelRequire("cozmU");














var $is7KY = parcelRequire("is7KY");






var $8px0e = parcelRequire("8px0e");

var $6t3CY = parcelRequire("6t3CY");

var $dVKvM = parcelRequire("dVKvM");

var $jgJIe = parcelRequire("jgJIe");

var $a6nzD = parcelRequire("a6nzD");

var $i9j2V = parcelRequire("i9j2V");

var $lslMH = parcelRequire("lslMH");

































var $lb5Vp = parcelRequire("lb5Vp");

var $aZ6Nw = parcelRequire("aZ6Nw");










/**
 * Maps the text-formatting plugin's `FormatOptions` keys to their
 * `SourceViewInlineFormat` equivalents for the CM6 source view.
 * Only formats that have a markdown syntax equivalent are included —
 * underline, subscript, and superscript have no GFM equivalent and
 * are left as undefined (they remain PM-only).
 */ const $af61691460b22096$var$FORMAT_OPTION_TO_SOURCE_VIEW = {
    strong: 'bold',
    em: 'italic',
    code: 'inlineCode',
    strike: 'strikethrough'
};
const $af61691460b22096$var$SOURCE_VIEW_ANALYTICS_ACTION_SUBJECT_ID = {
    bold: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRONG,
    italic: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    inlineCode: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_CODE,
    strikethrough: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_STRIKE
};
const $af61691460b22096$var$TEXT_FORMATTING_PLUGIN_STATE_KEYS = [
    'textFormatting'
];
const $af61691460b22096$var$TEXT_FORMATTING_MARKDOWN_PLUGIN_STATE_KEYS = [
    'textFormatting',
    'markdownMode'
];
const $af61691460b22096$var$FormatMarkSchema = {
    strong: 'strong',
    em: 'em',
    underline: 'underline',
    strike: 'strike',
    code: 'code',
    subscript: 'subsup',
    superscript: 'subsup'
};
const $af61691460b22096$export$fd1f6c37ffd41092 = ({ api: api, optionType: optionType, title: title, shortcut: shortcut, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, parents: parents })=>{
    const isMarkdownBridgeEnabled = (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar');
    const pluginStateKeys = isMarkdownBridgeEnabled ? $af61691460b22096$var$TEXT_FORMATTING_MARKDOWN_PLUGIN_STATE_KEYS : $af61691460b22096$var$TEXT_FORMATTING_PLUGIN_STATE_KEYS;
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, isPluginInitialised: isPluginInitialised, markdownModeView: markdownModeView, sourceFormatState: sourceFormatState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, pluginStateKeys, (states)=>({
            isActive: states.textFormattingState?.[`${optionType}Active`],
            isDisabled: states.textFormattingState?.[`${optionType}Disabled`],
            isHidden: states.textFormattingState?.[`${optionType}Hidden`],
            isPluginInitialised: states.textFormattingState?.isInitialised,
            markdownModeView: isMarkdownBridgeEnabled ? states.markdownModeState?.view : undefined,
            sourceFormatState: isMarkdownBridgeEnabled ? states.markdownModeState?.sourceInlineFormatState : null
        }));
    const hasMarkSchema = api?.core?.sharedState.currentState()?.schema?.marks[$af61691460b22096$var$FormatMarkSchema[optionType]];
    let formatOptionState;
    if (!isPluginInitialised) formatOptionState = {
        isActive: false,
        isDisabled: true,
        isHidden: false
    };
    else formatOptionState = {
        isActive: Boolean(isActive),
        isDisabled: Boolean(isDisabled),
        isHidden: Boolean(!hasMarkSchema || isHidden)
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const formatTitle = formatMessage(title);
    const shortcutContent = (0, $ldqjS.tooltip)(shortcut);
    const ariaLabel = (0, $ldqjS.tooltip)(shortcut, formatTitle);
    // The SourceViewInlineFormat key for this format option, if it has one.
    // undefined for underline, subscript, superscript (no GFM equivalent).
    const sourceViewFormat = $af61691460b22096$var$FORMAT_OPTION_TO_SOURCE_VIEW[optionType];
    // The CM6 source view is authoritative when the user has switched to it.
    // We rely on `markdownModeState.view === 'syntax'` (synchronous, set on
    // `setView`) rather than the presence of `sourceFormatState` — the latter
    // is `null` until the CM6 update listener fires for the first time, so
    // using it as the sentinel would let the first toolbar click after entering
    // source view fall through to the PM path and mutate the hidden PM doc.
    const isInSourceView = markdownModeView === 'syntax';
    if (isInSourceView && !sourceViewFormat) // Underline, subscript, superscript have no GFM equivalent. Disable
    // them immediately on entering source view — independent of whether
    // the CM6 update listener has fired yet — so the buttons don't briefly
    // appear active/enabled during that race window.
    formatOptionState = {
        isActive: false,
        isDisabled: true,
        isHidden: false
    };
    else if (isInSourceView && sourceFormatState && sourceViewFormat) {
        // Map each SourceViewInlineFormat to its isActive field on the snapshot.
        const activeByFormat = {
            bold: sourceFormatState.boldActive,
            italic: sourceFormatState.italicActive,
            inlineCode: sourceFormatState.codeActive,
            strikethrough: sourceFormatState.strikeActive
        };
        formatOptionState = {
            isActive: activeByFormat[sourceViewFormat],
            isDisabled: !sourceFormatState.inlineFormattingAvailable,
            isHidden: false
        };
    } else if (isInSourceView) // Race window: the user has switched to source view but the CM6 update
    // listener hasn't pushed its first format state snapshot yet
    // (`sourceFormatState` is still `null`). Without this branch the
    // button would render stale PM-cursor state (e.g. "Bold active" based
    // on where the PM selection was) until CM6 catches up. Render a
    // neutral, non-disabled state instead.
    formatOptionState = {
        isActive: false,
        isDisabled: false,
        isHidden: false
    };
    const onClick = ()=>{
        // Route to CM6 when in source view and the format has a CM6 equivalent.
        if (isInSourceView) {
            if (sourceViewFormat) {
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).FORMATTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    actionSubjectId: $af61691460b22096$var$SOURCE_VIEW_ANALYTICS_ACTION_SUBJECT_ID[sourceViewFormat],
                    attributes: {
                        inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
                    }
                });
                switch(sourceViewFormat){
                    case 'bold':
                        api?.markdownMode?.actions.toggleSourceBold();
                        break;
                    case 'italic':
                        api?.markdownMode?.actions.toggleSourceItalic();
                        break;
                    case 'inlineCode':
                        api?.markdownMode?.actions.toggleSourceInlineCode();
                        break;
                    case 'strikethrough':
                        api?.markdownMode?.actions.toggleSourceStrike();
                        break;
                }
            }
            return;
        }
        // Default PM path.
        api?.core.actions.execute(toggleMarkWithAnalyticsCallback(api?.analytics?.actions)((0, $is7KY.getInputMethodFromParentKeys)(parents)));
    };
    return {
        ...formatOptionState,
        formatTitle: formatTitle,
        shortcutContent: shortcutContent,
        ariaLabel: ariaLabel || formatTitle,
        onClick: onClick
    };
};
const $af61691460b22096$export$fb6751f88f91d177 = ()=>({
        strong: {
            rank: (0, $hVLmg.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3nacY.BOLD_MENU_ITEM).key],
            key: (0, $3nacY.BOLD_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iaH8x))),
            title: (0, $bq13E.toolbarMessages).bold,
            command: (0, $b0a32d3ef086f313$export$686bc7c29753e27),
            shortcut: (0, $ldqjS.toggleBold)
        },
        em: {
            rank: (0, $hVLmg.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3nacY.ITALIC_MENU_ITEM).key],
            key: (0, $3nacY.ITALIC_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aHWpe))),
            title: (0, $bq13E.toolbarMessages).italic,
            command: (0, $b0a32d3ef086f313$export$fe8278eb0d365433),
            shortcut: (0, $ldqjS.toggleItalic)
        },
        underline: {
            rank: (0, $hVLmg.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3nacY.UNDERLINE_MENU_ITEM).key],
            key: (0, $3nacY.UNDERLINE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g4d3e))),
            title: (0, $bq13E.toolbarMessages).underline,
            command: (0, $b0a32d3ef086f313$export$bf3c86b5abdb857d),
            shortcut: (0, $ldqjS.toggleUnderline)
        },
        strike: {
            rank: (0, $hVLmg.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3nacY.STRIKE_MENU_ITEM).key],
            key: (0, $3nacY.STRIKE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($96adu))),
            title: (0, $bq13E.toolbarMessages).strike,
            command: (0, $b0a32d3ef086f313$export$f08ef336cb688397),
            shortcut: (0, $ldqjS.toggleStrikethrough)
        },
        code: {
            rank: (0, $hVLmg.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3nacY.CODE_MENU_ITEM).key],
            key: (0, $3nacY.CODE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            title: (0, $bq13E.toolbarMessages).code,
            command: (0, $b0a32d3ef086f313$export$2d4f5a54f840ba91),
            shortcut: (0, $ldqjS.toggleCode)
        },
        subscript: {
            rank: (0, $hVLmg.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3nacY.SUBSCRIPT_MENU_ITEM).key],
            key: (0, $3nacY.SUBSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lb5Vp))),
            title: (0, $bq13E.toolbarMessages).subscript,
            command: (0, $b0a32d3ef086f313$export$8d0c92ae27a193),
            shortcut: (0, $ldqjS.toggleSubscript)
        },
        superscript: {
            rank: (0, $hVLmg.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $3nacY.SUPERSCRIPT_MENU_ITEM).key],
            key: (0, $3nacY.SUPERSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aZ6Nw))),
            title: (0, $bq13E.toolbarMessages).superscript,
            command: (0, $b0a32d3ef086f313$export$ca1c98793b67ba6b),
            shortcut: (0, $ldqjS.toggleSuperscript)
        }
    });


const $b7a2cb1054fcc35f$export$ddf8e5968f0fbf06 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, shortcutContent: shortcutContent, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $af61691460b22096$export$fd1f6c37ffd41092)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: isDisabled,
        isSelected: isActive,
        onClick: onClick,
        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)(shortcut),
        "aria-label": ariaLabel,
        children: formatTitle
    });
};
const $b7a2cb1054fcc35f$export$4ce756b69a643bb2 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $af61691460b22096$export$fd1f6c37ffd41092)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatTitle,
            keymap: shortcut
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                label: ariaLabel,
                size: "small"
            }),
            onClick: onClick,
            isSelected: isActive,
            isDisabled: isDisabled,
            ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)(shortcut),
            testId: `editor-toolbar__${formatTitle}`
        })
    });
};
const $b7a2cb1054fcc35f$export$2d10ff258f7812b8 = ({ api: api, parents: parents })=>{
    const { isInitialised: isInitialised, isFormattingPresent: isFormattingPresent } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], (states)=>({
            isInitialised: states.textFormattingState?.isInitialised,
            isFormattingPresent: states.textFormattingState?.formattingIsPresent
        }));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!isInitialised) return null;
    const formatTitle = formatMessage((0, $bq13E.toolbarMessages).clearFormatting);
    const shortcutContent = (0, $ldqjS.tooltip)((0, $ldqjS.clearFormatting));
    const onClick = ()=>{
        api?.core.actions.execute((0, $24e404e609d25c50$export$38c6848f9e966bd5)(api?.analytics?.actions)((0, $is7KY.getInputMethodFromParentKeys)(parents)));
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bWjzw))), {
            label: "",
            size: "small"
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: !isFormattingPresent,
        onClick: onClick,
        ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.clearFormatting)),
        children: formatTitle
    });
};
const $b7a2cb1054fcc35f$export$f2e08b351bba4df = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const content = formatMessage((0, $bq13E.toolbarMessages).moreFormatting);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8px0e.MoreItemsIcon), {
            label: "",
            testId: "more-formatting"
        }),
        label: content,
        tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: formatMessage((0, $bq13E.toolbarMessages).textFormat)
        }),
        children: children
    });
};
const $b7a2cb1054fcc35f$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3nacY.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};



const $e5ab5670387f2e3a$var$BoldButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $e5ab5670387f2e3a$export$838bd3df7e6d113c = (api)=>[
        {
            type: (0, $3nacY.BOLD_BUTTON_GROUP).type,
            key: (0, $3nacY.BOLD_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.BOLD_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($e5ab5670387f2e3a$var$BoldButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.BOLD_BUTTON).type,
            key: (0, $3nacY.BOLD_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.BOLD_BUTTON_GROUP).type,
                    key: (0, $3nacY.BOLD_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $af61691460b22096$export$fb6751f88f91d177)().strong;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $7381c682d57cc411$export$c1fb0eb1ea3f6fb6).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];





parcelRequire("cozmU");












const $a5c14b91ca3031af$export$653d8b3e035cd6f7 = (api)=>[
        {
            type: (0, $3nacY.TEXT_FORMATTING_GROUP_INLINE).type,
            key: (0, $3nacY.TEXT_FORMATTING_GROUP_INLINE).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION).type,
                    key: (0, $3nacY.TEXT_SECTION).key,
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $3nacY.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_GROUP_RANK)[(0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $af61691460b22096$export$fb6751f88f91d177)().strong;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $7381c682d57cc411$export$c1fb0eb1ea3f6fb6).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];





parcelRequire("cozmU");
















const $3359b7dd3c6ebe4a$var$TextFormattingGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $3359b7dd3c6ebe4a$var$TextFormattingGroupCollapsed = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
        below: "xl",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
            children: children
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
        children: children
    });
};
const $3359b7dd3c6ebe4a$export$ed04d15827dc03ae = (api)=>[
        {
            type: (0, $3nacY.TEXT_FORMATTING_GROUP).type,
            key: (0, $3nacY.TEXT_FORMATTING_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($3359b7dd3c6ebe4a$var$TextFormattingGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_FORMATTING_GROUP_COLLAPSED).type,
            key: (0, $3nacY.TEXT_FORMATTING_GROUP_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($3359b7dd3c6ebe4a$var$TextFormattingGroupCollapsed, {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_FORMATTING_GROUP).type,
                    key: (0, $3nacY.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_GROUP_RANK)[(0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $af61691460b22096$export$fb6751f88f91d177)().em;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $7381c682d57cc411$export$c1fb0eb1ea3f6fb6).em,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).type,
            key: (0, $3nacY.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $3nacY.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_GROUP_COLLAPSED_RANK)[(0, $3nacY.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $af61691460b22096$export$fb6751f88f91d177)().strong;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $7381c682d57cc411$export$c1fb0eb1ea3f6fb6).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];





parcelRequire("cozmU");











const $fea5de0104ac5086$export$922904c4345b3461 = (api)=>{
    return Object.entries((0, $af61691460b22096$export$fb6751f88f91d177)()).map(([optionType, { icon: icon, shortcut: shortcut, title: title, command: command, rank: rank, key: key }])=>{
        return {
            type: 'menu-item',
            key: key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_FORMATTING_MENU_SECTION).type,
                    key: (0, $3nacY.TEXT_FORMATTING_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$ddf8e5968f0fbf06), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    shortcut: shortcut,
                    title: title,
                    optionType: optionType,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        };
    });
};
const $fea5de0104ac5086$export$21e1245c68e20dce = (api)=>[
        {
            type: (0, $3nacY.TEXT_FORMATTING_MENU).type,
            key: (0, $3nacY.TEXT_FORMATTING_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_FORMATTING_GROUP).type,
                    key: (0, $3nacY.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_GROUP_RANK)[(0, $3nacY.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $3nacY.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $3nacY.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_GROUP_RANK)[(0, $3nacY.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $3nacY.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $3nacY.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_GROUP_RANK)[(0, $3nacY.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$f2e08b351bba4df), {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.TEXT_FORMATTING_MENU_SECTION).type,
            key: (0, $3nacY.TEXT_FORMATTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_FORMATTING_MENU).type,
                    key: (0, $3nacY.TEXT_FORMATTING_MENU).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_MENU_RANK)[(0, $3nacY.TEXT_FORMATTING_MENU_SECTION).key]
                },
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $hVLmg.TEXT_COLLAPSED_MENU_RANK)[(0, $3nacY.TEXT_FORMATTING_MENU_SECTION).key]
                }
            ],
            component: (0, $b7a2cb1054fcc35f$export$4b1545b4f2016d26)
        },
        ...$fea5de0104ac5086$export$922904c4345b3461(api),
        {
            type: (0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).type,
            key: (0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_FORMATTING_MENU).type,
                    key: (0, $3nacY.TEXT_FORMATTING_MENU).key,
                    rank: (0, $hVLmg.TEXT_FORMAT_MENU_RANK)[(0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).key]
                },
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $hVLmg.TEXT_COLLAPSED_MENU_RANK)[(0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.CLEAR_FORMATTING_MENU_ITEM).type,
            key: (0, $3nacY.CLEAR_FORMATTING_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).type,
                    key: (0, $3nacY.CLEAR_FORMARTTING_MENU_SECTION).key,
                    rank: (0, $hVLmg.CLEAR_FORMARTTING_MENU_SECTION_RANK)[(0, $3nacY.CLEAR_FORMATTING_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$2d10ff258f7812b8), {
                        parents: parents,
                        api: api
                    })
                });
            }
        }
    ];





parcelRequire("cozmU");
















const $46930dcc0ad96c0f$var$UnderlineButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $46930dcc0ad96c0f$export$8988dc22a0ee54a7 = (api)=>[
        {
            type: (0, $3nacY.UNDERLINE_BUTTON_GROUP).type,
            key: (0, $3nacY.UNDERLINE_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.UNDERLINE_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($46930dcc0ad96c0f$var$UnderlineButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.UNDERLINE_BUTTON).type,
            key: (0, $3nacY.UNDERLINE_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.UNDERLINE_BUTTON_GROUP).type,
                    key: (0, $3nacY.UNDERLINE_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $af61691460b22096$export$fb6751f88f91d177)().underline;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b7a2cb1054fcc35f$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $7381c682d57cc411$export$c1fb0eb1ea3f6fb6).underline,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];


const $e042108a45cc028d$export$a758406ca53b86a5 = (api, options)=>{
    return [
        ...(0, $3359b7dd3c6ebe4a$export$ed04d15827dc03ae)(api),
        ...(0, $a5c14b91ca3031af$export$653d8b3e035cd6f7)(api),
        ...(0, $e5ab5670387f2e3a$export$838bd3df7e6d113c)(api),
        ...options?.disableUnderline ? [] : (0, $46930dcc0ad96c0f$export$8988dc22a0ee54a7)(api),
        ...(0, $fea5de0104ac5086$export$21e1245c68e20dce)(api)
    ];
};


const $286e7cfd1afa11c2$export$2db686be056cb923 = ({ config: options, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8b574e9f606a8dc6$export$94516d5cccf573e3), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $e042108a45cc028d$export$a758406ca53b86a5)(api, options));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'textFormatting',
        component: primaryToolbarComponent
    });
    return {
        name: 'textFormatting',
        marks () {
            return [
                {
                    name: 'em',
                    mark: (0, $6nekq.em)
                },
                {
                    name: 'strong',
                    mark: (0, $fa9Se.strong)
                }
            ].concat(options?.disableStrikethrough ? [] : {
                name: 'strike',
                mark: (0, $fyiBi.strike)
            }).concat(options?.disableCode ? [] : {
                name: 'code',
                mark: (0, $bwEl8.code)
            }).concat(options?.disableSuperscriptAndSubscript ? [] : {
                name: 'subsup',
                mark: (0, $lhe5G.subsup)
            }).concat(options?.disableUnderline ? [] : {
                name: 'underline',
                mark: (0, $cI9Wu.underline)
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'textFormatting',
                    plugin: ({ dispatch: dispatch })=>(0, $209076d176b346ea$export$ca524d3785e2543)(dispatch, api?.analytics?.actions)
                },
                {
                    name: 'textFormattingCursor',
                    plugin: ()=>(0, $cd146205887072a2$export$2e2bcd8739ae039)
                },
                {
                    name: 'textFormattingInputRule',
                    plugin: ({ schema: schema })=>(0, $aecbe08ed18ad6e3$export$2e2bcd8739ae039)(schema, api?.analytics?.actions, api)
                },
                {
                    name: 'textFormattingSmartRule',
                    plugin: ()=>!options?.disableSmartTextCompletion ? (0, $7b9cfc85920f40ae$export$2e2bcd8739ae039)(api?.analytics?.actions) : undefined
                },
                {
                    name: 'textFormattingClear',
                    plugin: ({ dispatch: dispatch })=>(0, $0fe51b24ed8ed7f4$export$ca524d3785e2543)(dispatch)
                },
                {
                    name: 'textFormattingClearKeymap',
                    plugin: ()=>(0, $554c0bd9c56a8393$export$2e2bcd8739ae039)(api?.analytics?.actions)
                },
                {
                    name: 'textFormattingKeymap',
                    plugin: ({ schema: schema })=>(0, $50ed4064618db7ba$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const textFormattingState = (0, $8f71687d31171b9c$export$18d4026d1ea86bb1).getState(editorState);
            return {
                ...textFormattingState,
                formattingIsPresent: (0, $0fe51b24ed8ed7f4$export$18d4026d1ea86bb1).getState(editorState)?.formattingIsPresent,
                isInitialised: !!textFormattingState?.isInitialised
            };
        },
        pluginsOptions: isToolbarAIFCEnabled ? {} : {
            selectionToolbar: ()=>{
                const toolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bd63528f75c69bdb$export$d728f1bdde37938b), {
                                api: api,
                                editorView: view,
                                editorAnalyticsAPI: api?.analytics?.actions
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 7,
                        pluginName: 'textFormatting'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined,
        commands: {
            toggleSuperscript: (0, $b0a32d3ef086f313$export$ca1c98793b67ba6b)(api?.analytics?.actions),
            toggleSubscript: (0, $b0a32d3ef086f313$export$8d0c92ae27a193)(api?.analytics?.actions),
            toggleStrike: (0, $b0a32d3ef086f313$export$f08ef336cb688397)(api?.analytics?.actions),
            toggleCode: (0, $b0a32d3ef086f313$export$2d4f5a54f840ba91)(api?.analytics?.actions),
            toggleUnderline: (0, $b0a32d3ef086f313$export$bf3c86b5abdb857d)(api?.analytics?.actions),
            toggleEm: (0, $b0a32d3ef086f313$export$fe8278eb0d365433)(api?.analytics?.actions),
            toggleStrong: (0, $b0a32d3ef086f313$export$686bc7c29753e27)(api?.analytics?.actions)
        }
    };
};
module.exports["textFormattingPlugin"] = $286e7cfd1afa11c2$export$2db686be056cb923;

});

parcelRegister("bhf6v", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");


var $iDrrr = parcelRequire("iDrrr");


var $hXuXM = parcelRequire("hXuXM");



const $65945a88d139e7b8$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $65945a88d139e7b8$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($65945a88d139e7b8$var$SMART_TO_ASCII).join('')}]`, 'g');
function $65945a88d139e7b8$export$abc5e6e01568db39(from, to, tr) {
    const { doc: doc } = tr;
    const { schema: schema } = doc.type;
    const { mention: mentionNodeType, text: textNodeType, emoji: emojiNodeType, inlineCard: inlineCardNodeType } = schema.nodes;
    const nodesToChange = [];
    doc.nodesBetween(from, to, (node, pos, _parent)=>{
        if ([
            mentionNodeType,
            textNodeType,
            emojiNodeType,
            inlineCardNodeType
        ].includes(node.type)) nodesToChange.push({
            node: node,
            pos: pos
        });
    });
    nodesToChange.forEach(({ node: node, pos: pos })=>{
        if (node.type !== textNodeType) {
            const newText = node.attrs.url || // url for inlineCard
            node.attrs.text || `${node.type.name} text missing`; // fallback for missing text
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        } else if (node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const newText = textForReplacing.replace($65945a88d139e7b8$var$FIND_SMART_CHAR, (match)=>$65945a88d139e7b8$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
}
const $65945a88d139e7b8$export$94a1aa532f5398df = (from, to, removeMark, mark, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) $65945a88d139e7b8$export$abc5e6e01568db39(from, to, tr);
    tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};
const $65945a88d139e7b8$var$toggleMarkInRange = (mark)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $8HW7o.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $hXuXM.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $65945a88d139e7b8$export$94a1aa532f5398df(from, to, removeMark, mark, tr);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $hXuXM.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $65945a88d139e7b8$export$94a1aa532f5398df($from.pos, $to.pos, removeMark, mark, tr);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $65945a88d139e7b8$export$797ad2667b8015a8 = (markType, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $kCECX.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $65945a88d139e7b8$var$toggleMarkInRange(mark)({
            tr: tr
        });
    };
module.exports["applyMarkOnRange"] = $65945a88d139e7b8$export$94a1aa532f5398df;
module.exports["toggleMark"] = $65945a88d139e7b8$export$797ad2667b8015a8;

});

parcelRegister("hXuXM", function(module, exports) {
const $449293b01b3ceb01$export$cc5a5f0a00f537f5 = (mark, doc, fromPos, toPos)=>{
    let onlyContainsMark = true;
    doc.nodesBetween(fromPos, toPos, (node)=>{
        // Skip recursion once we've found text which doesn't include the mark
        if (!onlyContainsMark) return false;
        if (node.isText) onlyContainsMark && (onlyContainsMark = !!mark?.isInSet(node.marks));
    });
    return onlyContainsMark;
};
module.exports["entireSelectionContainsMark"] = $449293b01b3ceb01$export$cc5a5f0a00f537f5;

});

parcelRegister("5tsXu", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");

const $59e3729bf52c91cf$export$5c9d031211c1b7c9 = (mark)=>({ tr: tr })=>{
        const { selection: selection } = tr;
        if (selection instanceof (0, $8HW7o.CellSelection)) selection.forEachCell((cell, cellPos)=>{
            const from = cellPos;
            const to = cellPos + cell.nodeSize;
            tr.removeMark(from, to, mark);
        });
        else if (selection instanceof (0, $kCECX.TextSelection) && selection.$cursor) tr.removeStoredMark(mark);
        else {
            const { from: from, to: to } = selection;
            tr.removeMark(from, to, mark);
        }
        return tr;
    };
module.exports["removeMark"] = $59e3729bf52c91cf$export$5c9d031211c1b7c9;

});

parcelRegister("kzHT3", function(module, exports) {
const $e21b53203c1409bd$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
    for(let i = 0; i < ranges.length; i++){
        const { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
            return;
        });
        if (can) return can;
    }
    return false;
};
module.exports["isMarkAllowedInRange"] = $e21b53203c1409bd$export$22a8bb98a26ef60;

});

parcelRegister("adJV7", function(module, exports) {
const $23e7515d8b1df9f4$export$87b559fec4a10a1a = (type, marks)=>{
    if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
    return false;
};
module.exports["isMarkExcluded"] = $23e7515d8b1df9f4$export$87b559fec4a10a1a;

});

parcelRegister("aiL0G", function(module, exports) {
var $8d798bd79454726b$export$f90c25d407b3694a = /*#__PURE__*/ function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    return TOOLBAR_ACTION_SUBJECT_ID;
}({});
module.exports["TOOLBAR_ACTION_SUBJECT_ID"] = $8d798bd79454726b$export$f90c25d407b3694a;

});

parcelRegister("7T88d", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");

/**
 * Generate a className based on the breakpoints provided.
 *
 * **Warning** - must much classnames defined in ResponsiveContainer.tsx
 * @param above - The breakpoint to show the element above.
 * @param below - The breakpoint to show the element below.
 * @returns The className to apply to the element.
 */ const $137f1c3bef2c2b9a$var$generateClassName = (above, below, only)=>{
    if (only) return `show-only-${only}`;
    const classes = [];
    if (above) classes.push(`show-above-${above}`);
    if (below) classes.push(`show-below-${below}`);
    return classes.length > 0 ? classes.join(' ') : undefined;
};
const $137f1c3bef2c2b9a$export$f6a3d19be20f5819 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, above: above, below: below, only: only } = t0;
    let t1;
    if ($[0] !== above || $[1] !== below || $[2] !== only) {
        t1 = $137f1c3bef2c2b9a$var$generateClassName(above, below, only);
        $[0] = above;
        $[1] = below;
        $[2] = only;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t1,
            children: children
        });
        $[4] = children;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, above: above, below: below, only: only })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: $137f1c3bef2c2b9a$var$generateClassName(above, below, only),
        children: children
    });
};
module.exports["Show"] = $137f1c3bef2c2b9a$export$f6a3d19be20f5819;

});

parcelRegister("is7KY", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $3nacY = parcelRequire("3nacY");

const $72280de31ad72253$export$19f6cf3733198aff = (parents)=>parents.at(0)?.key === (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR ? (0, $krYZG.INPUT_METHOD).FLOATING_TB : (0, $krYZG.INPUT_METHOD).TOOLBAR;
module.exports["getInputMethodFromParentKeys"] = $72280de31ad72253$export$19f6cf3733198aff;

});

parcelRegister("8px0e", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7sJoX = parcelRequire("7sJoX");

const $45c6dc8dda4071ad$export$fab3805c25b17109 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing } = t0;
    let t1;
    if ($[0] !== color || $[1] !== label || $[2] !== shouldRecommendSmallIcon || $[3] !== spacing || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: label,
            testId: testId,
            color: color,
            shouldRecommendSmallIcon: shouldRecommendSmallIcon,
            spacing: spacing,
            size: "small"
        });
        $[0] = color;
        $[1] = label;
        $[2] = shouldRecommendSmallIcon;
        $[3] = spacing;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });
module.exports["MoreItemsIcon"] = $45c6dc8dda4071ad$export$fab3805c25b17109;

});

parcelRegister("d1HsG", function(module, exports) {
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $koZsE = parcelRequire("koZsE");


var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $efqK4 = parcelRequire("efqK4");


var $8nvEM = parcelRequire("8nvEM");


var $iDrrr = parcelRequire("iDrrr");

var $c76f078940ffa50e$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
    ACTIONS["CLEAR_LIST_ERROR"] = "CLEAR_LIST_ERROR";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    ACTIONS["UPDATE_SECTION_TITLE"] = "UPDATE_SECTION_TITLE";
    return ACTIONS;
}({});



var $kCECX = parcelRequire("kCECX");

const $8e9f417e2f7326e3$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('typeAheadPlugin');


const $609861d2c745601d$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
        action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).CLOSE_TYPE_AHEAD
    });
};



var $gT4iv = parcelRequire("gT4iv");





var $aPdNQ = parcelRequire("aPdNQ");


var $di3bZ = parcelRequire("di3bZ");



class $63f5f75c33c83e19$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: this.keyCount?.arrowUp || 0,
                    arrowDown: this.keyCount?.arrowDown || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}





var $8Kvl9 = parcelRequire("8Kvl9");





var $fqVYq = parcelRequire("fqVYq");



var $jaFVy = parcelRequire("jaFVy");

const $bb95ceffb7708bae$export$1ebf03cc1b973f80 = (item, api)=>{
    const isOffline = (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
    return isOffline && item?.isDisabledOffline === true;
};



const $89435a8b382f1be8$export$9993709486a96a6b = (selectedIndex, api)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(state);
        if (pluginState?.selectedIndex === selectedIndex) return false;
        // If the new index is disabled ignore this call, we can use the previous index
        if ((0, $bb95ceffb7708bae$export$1ebf03cc1b973f80)(pluginState?.items[selectedIndex], api)) return false;
        const tr = state.tr;
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};





const $23d4fc3cd3760671$export$be092076596418f1 = (handler)=>{
    return handler && Object.values((0, $efqK4.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $23d4fc3cd3760671$export$564dcc295d6ce147 = (editorState)=>{
    return !!(0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1)?.getState(editorState)?.decorationSet?.find().length;
};
const $23d4fc3cd3760671$export$f05434c51e3762e = (editorState)=>{
    return (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(editorState);
};
const $23d4fc3cd3760671$export$c1eba975d6442029 = (editorState)=>{
    return (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(editorState)?.triggerHandler;
};
const $23d4fc3cd3760671$export$7a55deb43cd1340e = (editorState)=>{
    return (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(editorState)?.query;
};
const $23d4fc3cd3760671$export$74b0f581633f8412 = (state)=>{
    const isOpen = $23d4fc3cd3760671$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $23d4fc3cd3760671$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $23d4fc3cd3760671$export$84a03e6192df0237 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next selectable item
    for(let idx = nextIndex; idx < listSize; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the end of the list ^, now try from the start
    if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = 0; idx < nextIndex; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no selectable items are found, return currentIndex
    return currentIndex;
};
const $23d4fc3cd3760671$export$723aff40bcdce278 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next non-selectable item when going backwards
    for(let idx = nextIndex; idx >= 0; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the start of the list ^, now try from the end
    if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = listSize; idx > nextIndex; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no non-selectable items are found, return currentIndex
    return currentIndex;
};
const $23d4fc3cd3760671$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $23d4fc3cd3760671$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction, api: api })=>()=>{
        const typeAheadState = $23d4fc3cd3760671$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $63f5f75c33c83e19$export$630efe5940bb4d41) ? typeAheadState.stats : new (0, $63f5f75c33c83e19$export$630efe5940bb4d41)();
        let nextIndex;
        const isDisabled = (idx)=>(0, $bb95ceffb7708bae$export$1ebf03cc1b973f80)(items[idx], api);
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
     * See: https://product-fabric.atlassian.net/browse/ED-17200
     * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
     * and only do so when there is explicit logic to focus into the typeahead
     * options.
     *
     * This check for "set index to 1 when -1"
     * - is a temporary workaround to get back the previous behaviour without
     *    entirely reverting the a11y improvements
     *
     */ if (selectedIndex === -1 && items.length > 1) // If the first item is disabled we actually want to skip to the 3rd item
            // on the first arrow down
            nextIndex = isDisabled(0) && items.length > 2 ? 2 : 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            nextIndex = $23d4fc3cd3760671$export$84a03e6192df0237({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            nextIndex = $23d4fc3cd3760671$export$723aff40bcdce278({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        }
        (0, $89435a8b382f1be8$export$9993709486a96a6b)(nextIndex, api)(editorView.state, editorView.dispatch);
    };
const $23d4fc3cd3760671$export$19cacaa810ba988a = (trigger, intl, item)=>{
    switch(trigger){
        case '@':
            {
                const description = (0, $fqVYq.editorExperiment)('platform_editor_agent_mentions', true) && (0, $iDrrr.fg)('platform_editor_mention_typeahead_profilecard') ? item?.mention?.description : undefined;
                const name = item?.mention?.name || '';
                const shortName = item?.mention?.mentionName || '';
                return {
                    popupAriaLabel: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).mentionPopupLabel),
                    listItemAriaLabel: description ? intl.formatMessage((0, $8Kvl9.typeAheadListMessages).mentionListItemLabelWithDescription, {
                        name: name,
                        shortName: shortName,
                        description: description
                    }) : intl.formatMessage((0, $8Kvl9.typeAheadListMessages).metionListItemLabel, {
                        name: name,
                        shortName: shortName
                    })
                };
            }
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.title || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.emoji?.name || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};




var $8tXCb = parcelRequire("8tXCb");


var $Sz3hx = parcelRequire("Sz3hx");


var $57Rmq = parcelRequire("57Rmq");








var $ieeJu = parcelRequire("ieeJu");

function $d2ef3c51ac419783$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $d2ef3c51ac419783$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $8tXCb.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
		 * panel (
		 *   1. text (insertion)
		 * )
		 * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
		 */ const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
        const isGGreatGrandParentOfSameType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? ggreatGrandParentNodeType && (0, $57Rmq.isNodeOfSameBaseType)(ggreatGrandParentNodeType, node.type) : ggreatGrandParentNodeType === node.type;
        if (grandParentNodeType === listItem && !isGGreatGrandParentOfSameType) return (0, $Sz3hx.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $8tXCb.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $aPdNQ.Slice).maxOpen((0, $aPdNQ.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $d2ef3c51ac419783$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $kCECX.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $d2ef3c51ac419783$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $aPdNQ.Node) ? (0, $aPdNQ.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};


const $5bffb32f6167acf4$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $aPdNQ.Node) || maybeNode instanceof (0, $aPdNQ.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $aPdNQ.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
const $5bffb32f6167acf4$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $5bffb32f6167acf4$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $609861d2c745601d$export$daba40574d0568e3)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        node instanceof (0, $aPdNQ.Node) && node.isBlock ? (0, $d2ef3c51ac419783$export$faec73a52dd47a2c)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $d2ef3c51ac419783$export$a6d430434014dc1c)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $di3bZ.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $gT4iv.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $gT4iv.InsertTypeAheadStep)(config));
        return tr;
    };
const $5bffb32f6167acf4$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $di3bZ.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $gT4iv.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $gT4iv.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $5bffb32f6167acf4$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $63f5f75c33c83e19$export$630efe5940bb4d41)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $efqK4.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $efqK4.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $5bffb32f6167acf4$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $di3bZ.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1))) (0, $609861d2c745601d$export$daba40574d0568e3)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).INSERT_RAW_QUERY,
            params: $5bffb32f6167acf4$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $di3bZ.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };
const $5bffb32f6167acf4$var$executeTypeAheadSelection = (view)=>({ selectItem: selectItem, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $63f5f75c33c83e19$export$630efe5940bb4d41)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $efqK4.SelectItemMode).SPACE) text = text.trim().concat(' ');
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $efqK4.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorState)=>{
            const insertCallback = $5bffb32f6167acf4$var$createInsertCallback({
                editorState: newEditorState,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            const insertCallbackProxy = new Proxy(insertCallback, {
                apply (target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            });
            const nextTr = selectItem(newEditorState, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $di3bZ.closeHistory)(nextTr);
                if (!nextTr.getMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1))) (0, $609861d2c745601d$export$daba40574d0568e3)(nextTr);
            }
            return nextTr || false;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).INSERT_RAW_QUERY,
            params: $5bffb32f6167acf4$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $di3bZ.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };
const $5bffb32f6167acf4$export$cf9e900b30aef2ea = (view)=>({ inputMethod: inputMethod, selectionHandler: selectionHandler, handler: handler, query: query })=>{
        $5bffb32f6167acf4$var$executeTypeAheadSelection(view)({
            handler: handler,
            mode: (0, $efqK4.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: [],
            selectItem: (_state, insert)=>selectionHandler({
                    insert: insert,
                    source: inputMethod
                })
        });
    };



var $4EksL = parcelRequire("4EksL");









const $8c86625311d23646$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            }
        });
    };
const $8c86625311d23646$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>({ tr: tr })=>{
        $8c86625311d23646$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $kCECX.TextSelection) || selection instanceof (0, $4EksL.GapCursorSelection) || selection instanceof (0, $kCECX.NodeSelection))) return tr;
        if (selection instanceof (0, $4EksL.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            if (selection instanceof (0, $kCECX.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            // Check if the text ends with the trigger character (or any character matched
            // by customRegex, to support wide-char variants like fullwidth slash ／)
            const triggerPattern = (0, $ieeJu.expValEquals)('platform_editor_wide_slash_trigger', 'isEnabled', true) && triggerHandler.customRegex ? new RegExp(`(${triggerHandler.customRegex})$`, 'u') : null;
            const endsWithTrigger = selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger) || triggerPattern && triggerPattern.test(selection.$head.parent.textContent);
            if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && endsWithTrigger) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };




const $0cfc7cdfeccc101c$export$9edb4b0ea764e965 = ({ id: id, title: title, sectionTitleDisplay: sectionTitleDisplay })=>{
    return (state, dispatch)=>{
        if (!dispatch) return false;
        const tr = state.tr;
        const update = {
            title: title
        };
        if (sectionTitleDisplay !== undefined) update.sectionTitleDisplay = sectionTitleDisplay;
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_SECTION_TITLE,
            params: {
                id: id,
                update: update
            }
        });
        dispatch(tr);
        return true;
    };
};









var $d8RhQ = parcelRequire("d8RhQ");


var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");


function $c0cd05a8b173e804$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp(`(^|[.!?\\s${(0, $3brWT.leafNodeReplacementCharacter)}])(${trigger})$`);
        acc.push((0, $d8RhQ.createRule)(regex, (state, match)=>{
            return (0, $8c86625311d23646$export$e7ce737179b76875)({
                triggerHandler: typeAhead,
                inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $c0cd05a8b173e804$export$2e2bcd8739ae039 = $c0cd05a8b173e804$export$568a7ed6897c4817;







const $d749ef22a21c524c$export$e715282b081c154e = (transactions, action)=>{
    const tr = transactions.find((tr)=>tr.getMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1))?.action === action);
    if (!tr) return null;
    return tr.getMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1))?.params;
};


function $9ffdcf9d3145cb05$export$ae829ec7b2625219() {
    return new (0, $kpCD8.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $d749ef22a21c524c$export$e715282b081c154e)(transactions, (0, $c76f078940ffa50e$export$92a1a3b7554e9387).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}













var $btvbC = parcelRequire("btvbC");












const $9056b5b25d13b1e3$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $9056b5b25d13b1e3$export$be8a8259777b339f = 'typeaheadDecoration';
const $9056b5b25d13b1e3$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $9056b5b25d13b1e3$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1 = /*#__PURE__*/ function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    return CloseSelectionOptions;
}({});





parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kHija = parcelRequire("kHija");


var $iqS60 = parcelRequire("iqS60");

















var $cozmU = parcelRequire("cozmU");

















var $mW7G5 = parcelRequire("mW7G5");




const $e313a08cd9f207d5$export$4a6068dadc2c7771 = (api, closeAction, hasQuery, inputMethod, invocationMethod = null)=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).CLOSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
        attributes: {
            inputMethod: inputMethod,
            closeAction: closeAction,
            hasQuery: hasQuery,
            invocationMethod: invocationMethod
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
};




const $8ce5a4e5713734e6$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(state);
        if (pluginState?.query === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};















const $0cd72a1c50194051$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $kCECX.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };




const $e56262612162b97c$var$onlyHasViewMoreItem = (items)=>items.at(0)?.title === 'View more';
const $e56262612162b97c$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $609861d2c745601d$export$daba40574d0568e3)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED) (0, $0cd72a1c50194051$export$5af11333ab9d7643)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $e56262612162b97c$export$3a3385069392b26f = (triggerHandler, editorView, items, api)=>{
    const editorViewRef = (0, $cozmU.useRef)(editorView);
    const itemsRef = (0, $cozmU.useRef)(items);
    const onTextInsert = (0, $cozmU.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $e56262612162b97c$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $cozmU.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler || // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        $e56262612162b97c$var$onlyHasViewMoreItem(sourceListItem)) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const isDisabled = (0, $bb95ceffb7708bae$export$1ebf03cc1b973f80)(itemToInsert, api);
        if (isDisabled) return;
        const { current: view } = editorViewRef;
        (0, $5bffb32f6167acf4$export$173ade35125a6637)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert,
        api
    ]);
    const onItemMatch = (0, $cozmU.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1 && // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        !$e56262612162b97c$var$onlyHasViewMoreItem(_items)) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                    text: mode === (0, $efqK4.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};













const $07a2c6d711ddeaba$export$265c9044700bb67 = ()=>{
    return ({ tr: tr })=>{
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).CLEAR_LIST_ERROR,
            params: {
                errorInfo: null
            }
        });
        return tr;
    };
};




const $af0e5ae0c1629c3b$export$4f4014ebb73e8d41 = (errorInfo)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_LIST_ERROR,
            params: {
                errorInfo: errorInfo,
                items: []
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};




const $58d69c44b573110a$export$e482099e4c227d2 = (items, sections = [])=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), {
            action: (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_LIST_ITEMS,
            params: {
                items: items,
                sections: sections
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};


const $70a56a2ee5c49632$export$ba9956bced492649 = ({ items: items, triggerHandler: triggerHandler, intl: intl })=>{
    if (!intl) return {
        items: items,
        sections: []
    };
    const sectionDefinitions = triggerHandler.getSections?.({
        intl: intl
    });
    if (!sectionDefinitions || sectionDefinitions.length === 0) return {
        items: items,
        sections: []
    };
    // Track which item indexes have been claimed by a section, or excluded (matched a section but
    // cut by that section's limit). Items excluded by limit should not appear anywhere in the output.
    const assignedToSection = new Set();
    const excludedByLimit = new Set();
    const groupedBySection = new Map();
    for (const section of sectionDefinitions){
        const matchingIndexes = [];
        for(let i = 0; i < items.length; i++){
            if (assignedToSection.has(i) || excludedByLimit.has(i)) continue;
            if (section.filter(items[i])) matchingIndexes.push(i);
        }
        const acceptedIndexes = section.limit !== undefined ? matchingIndexes.slice(0, section.limit) : matchingIndexes;
        const rejectedByLimit = matchingIndexes.slice(acceptedIndexes.length);
        for (const i of acceptedIndexes)assignedToSection.add(i);
        for (const i of rejectedByLimit)excludedByLimit.add(i);
        if (acceptedIndexes.length === 0) continue;
        groupedBySection.set(section.id, {
            indexes: acceptedIndexes,
            section: section
        });
    }
    const flattenedItems = [];
    const sections = [];
    for (const section of sectionDefinitions){
        const grouped = groupedBySection.get(section.id);
        if (!grouped) continue;
        const startIndex = flattenedItems.length;
        flattenedItems.push(...grouped.indexes.map((i)=>items[i]));
        const endIndex = flattenedItems.length - 1;
        const resolvedSection = {
            endIndex: endIndex,
            id: section.id,
            startIndex: startIndex,
            title: section.title
        };
        if (section.lozenge !== undefined) resolvedSection.lozenge = section.lozenge;
        if (section.sectionTitleDisplay) resolvedSection.sectionTitleDisplay = section.sectionTitleDisplay;
        sections.push(resolvedSection);
    }
    // Append items not claimed by any section and not excluded by a limit
    for(let i = 0; i < items.length; i++)if (!assignedToSection.has(i) && !excludedByLimit.has(i)) flattenedItems.push(items[i]);
    return {
        items: flattenedItems,
        sections: sections
    };
};


const $fdfc8cd629994464$var$EMPTY_LIST_ITEM = [];
const $fdfc8cd629994464$export$36f5628e43bc3fcd = (triggerHandler, editorView, query, showViewMore, api, intl, enabled = true)=>{
    const [items, setItems] = (0, $cozmU.useState)($fdfc8cd629994464$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $cozmU.useRef)(true);
    const editorViewRef = (0, $cozmU.useRef)(editorView);
    const latestQueryRef = (0, $cozmU.useRef)(query);
    latestQueryRef.current = query;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) {
            setItems($fdfc8cd629994464$var$EMPTY_LIST_ITEM);
            return;
        }
        const requestQuery = query;
        const isStaleRequest = ()=>latestQueryRef.current !== requestQuery;
        const options = {
            query: requestQuery || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) // Clear any existing error state before making a new request
        queueMicrotask(()=>{
            api?.core.actions.execute((0, $07a2c6d711ddeaba$export$265c9044700bb67)());
        });
        /**
     * Shared render pipeline used by both the single-shot `getItems`
     * Promise path and the opt-in multi-emit `subscribeToItemsUpdates`
     * path. Renders the dropdown with whatever items it is given.
     *
     * Both paths share the empty-state injection, section-building
     * and "View more" placeholder logic — extracting this helper
     * avoids any chance the two paths drift in subtle rendering
     * behaviour.
     */ const renderResult = (result)=>{
            const emptyItem = result.length === 0 && (0, $ieeJu.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) ? triggerHandler.getEmptyItem?.({
                editorState: editorView.state
            }) : undefined;
            const rawList = result.length > 0 ? result : emptyItem ? [
                emptyItem
            ] : $fdfc8cd629994464$var$EMPTY_LIST_ITEM;
            const { items: list, sections: sections } = (0, $70a56a2ee5c49632$export$ba9956bced492649)({
                items: rawList,
                triggerHandler: triggerHandler,
                intl: intl ?? null
            });
            if (componentIsMounted.current) setItems(list);
            const viewMoreItem = {
                title: 'View more'
            };
            queueMicrotask(()=>{
                (0, $58d69c44b573110a$export$e482099e4c227d2)(showViewMore ? list.concat(viewMoreItem) : list, sections)(view.state, view.dispatch);
            });
        };
        // Matches the pre-refactor implicit-any contract for the original
        // `.catch((e) => updateListError(e)(...))` path.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handleError = (e)=>{
            if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
                if (e) {
                    if (componentIsMounted.current) setItems($fdfc8cd629994464$var$EMPTY_LIST_ITEM);
                    queueMicrotask(()=>{
                        (0, $af0e5ae0c1629c3b$export$4f4014ebb73e8d41)(e)(view.state, view.dispatch);
                    });
                }
            }
        };
        // Multi-emit path: handler opts in by implementing
        // `subscribeToItemsUpdates`. The handler controls when to push
        // updates; we re-render on every push for the lifetime of this
        // effect.
        const subscribeToItemsUpdates = triggerHandler?.subscribeToItemsUpdates;
        if (subscribeToItemsUpdates) {
            let stale = false;
            const { initial: initial, subscribe: subscribe } = subscribeToItemsUpdates(options);
            initial.then((result)=>{
                if (!stale && !isStaleRequest()) renderResult(result);
            }).catch(handleError);
            const unsubscribe = subscribe((items)=>{
                if (stale || isStaleRequest() || !componentIsMounted.current) return;
                renderResult(items);
            });
            return ()=>{
                stale = true;
                unsubscribe();
            };
        }
        // Existing single-shot path. Unchanged in behaviour.
        const getItems = triggerHandler?.getItems;
        if (!getItems) {
            setItems($fdfc8cd629994464$var$EMPTY_LIST_ITEM);
            return;
        }
        getItems(options).then(renderResult).catch(handleError);
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query,
        intl,
        enabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};









const $5dc9c068d6df9154$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $cozmU.useRef)(editorView);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $5bffb32f6167acf4$export$173ade35125a6637)(view)({
                item: item,
                mode: (0, $efqK4.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");








var $8dxef = parcelRequire("8dxef");







var $lnOAf = parcelRequire("lnOAf");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");









function $83bcd7c3c9310b7e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $83bcd7c3c9310b7e$var$placeholderStyles = {
    name: "qn4qy1",
    styles: "&::after{content:attr(data-place-holder);color:var(--ds-text-subtlest, #6B6E76);position:relative;padding:var(--ds-space-025, 2px);left:var(--ds-space-negative-050, -4px);background-color:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);}"
};
const $83bcd7c3c9310b7e$var$queryWithoutPlaceholderStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&::after': {
        content: `''`
    }
});
const $83bcd7c3c9310b7e$var$querySpanStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // TODO: ED-17022 - Fixes firefox caret position
        // Do not migrate font when em is used as unit
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $7Y8M5.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #1558BC)"
    }
});
const $83bcd7c3c9310b7e$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $83bcd7c3c9310b7e$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $iqS60.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $83bcd7c3c9310b7e$var$getAriaLabel = (triggerPrefix, _intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $8Kvl9.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $8Kvl9.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $8Kvl9.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $8Kvl9.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $83bcd7c3c9310b7e$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ activeDescendantId: activeDescendantId, triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items, listId: listId, optionCount: optionCount, shouldKeepOpenOnRegisteredMenu: shouldKeepOpenOnRegisteredMenu })=>{
    const resolvedOptionCount = optionCount ?? items?.length ?? 0;
    const ref = (0, $cozmU.useRef)(document.createElement('span'));
    const inputRef = (0, $cozmU.useRef)(null);
    const [query, setQuery] = (0, $cozmU.useState)(null);
    const isEditorControlsEnabled = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1');
    const isSearchPlaceholderEnabled = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && (0, $iDrrr.fg)('platform_editor_quick_insert_placeholder');
    const selection = editorView.state.selection;
    const { table: table } = editorView.state.schema.nodes;
    const [showPlaceholder, setShowPlaceholder] = (0, $cozmU.useState)(isSearchPlaceholderEnabled && triggerQueryPrefix === '/' && // When triggered in very narrow table column, placeholder becomes ellipsis only
    // hence we disable it for now and revisit this scenario in ED-27480
    !(0, $bjg0G.findParentNodeOfType)(table)(selection));
    const cleanedInputContent = (0, $cozmU.useCallback)(()=>{
        const raw = ref.current?.textContent || '';
        return raw;
    }, []);
    const onKeyUp = (0, $cozmU.useCallback)((_event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const onInput = (0, $cozmU.useCallback)(()=>{
        if (cleanedInputContent()) setShowPlaceholder(false);
    }, [
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $cozmU.useState)(false);
    const checkKeyEvent = (0, $cozmU.useCallback)((event)=>{
        const key = (0, $iqS60.keyName)(event);
        const sel = document.getSelection();
        const raw = ref.current?.textContent || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                        setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || sel?.anchorOffset === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // TODO: ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $efqK4.SelectItemMode).SHIFT_ENTER : (0, $efqK4.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                event.shiftKey ? selectPreviousItem() : selectNextItem();
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $83bcd7c3c9310b7e$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($83bcd7c3c9310b7e$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const browser = (0, $8dxef.getBrowserInfo)();
        const { current: element } = ref;
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorView.state) || {};
        const onFocusIn = (_event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $iqS60.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                const q = ref.current?.textContent || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED : (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onPaste = (event)=>{
            const html = event.clipboardData?.getData('text/html');
            const plainText = event.clipboardData?.getData('text/plain');
            if (html && plainText) {
                event.preventDefault();
                // insert the plain text into the type-ahead input field
                const selection = window.getSelection();
                if (selection && ref.current) {
                    if (selection.rangeCount > 0) {
                        const range = selection.getRangeAt(0);
                        range.deleteContents();
                        range.insertNode(document.createTextNode(plainText));
                        range.collapse(false);
                    }
                }
            }
        };
        const onFocusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $9056b5b25d13b1e3$export$a5cdf6890cae94d6)}`) || shouldKeepOpenOnRegisteredMenu && relatedTarget.closest('[data-registered-type-ahead-menu]'))) return;
            // Chrome and Edge may emit focusout events without direct input.
            // This path handles dismissals that don't involve item selection, so we ignore these events.
            // In Edge this also lead to duplication in the trigger character (@, /, :) as `cancel` would be called twice
            if ((browser.ie || browser.chrome) && !(window.getSelection()?.type === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !event.sourceCapabilities) return;
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if (browser.safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        };
        const onInput = ()=>{};
        if (browser.safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.addEventListener('input', onInput);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusout', onFocusOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusin', onFocusIn);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('keydown', keyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('beforeinput', beforeinput);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('paste', onPaste);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusout', onFocusOut);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusin', onFocusIn);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('keydown', keyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('beforeinput', beforeinput);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('paste', onPaste);
            if (browser.safari) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state,
        isEditorControlsEnabled,
        shouldKeepOpenOnRegisteredMenu
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            setQuery(hasReopenQuery ? reopenQuery : null);
            requestAnimationFrame(()=>{
                if (!ref?.current) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            });
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const classNames = (0, $cozmU.useMemo)(()=>{
        const classes = [];
        if (showPlaceholder) {
            // to avoid the placeholder wrapped to next line when triggered at the end of the line
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-wrap');
            if (selection.$from.depth > 1) // to hide placeholder overflow as ellipsis
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-hide-overflow');
        }
        return classes.join(' ');
    }, [
        showPlaceholder,
        selection
    ]);
    const assistiveHintID = (0, $9056b5b25d13b1e3$export$a38374e9651d6165) + '__assistiveHint';
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            $83bcd7c3c9310b7e$var$querySpanStyles,
            isSearchPlaceholderEnabled && $83bcd7c3c9310b7e$var$queryWithoutPlaceholderStyles,
            showPlaceholder && $83bcd7c3c9310b7e$var$placeholderStyles
        ],
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        tabIndex: -1,
        onInput: isSearchPlaceholderEnabled ? onInput : undefined,
        role: "combobox",
        "aria-activedescendant": activeDescendantId,
        "aria-controls": listId ?? (0, $9056b5b25d13b1e3$export$a38374e9651d6165),
        "aria-autocomplete": "list",
        "aria-expanded": resolvedOptionCount !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: classNames,
        "data-place-holder": intl.formatMessage((0, $8Kvl9.typeAheadListMessages).quickInsertInputPlaceholderLabel)
    }, query === null ? /*#__PURE__*/ (0, $lOiVq.jsx)("input", {
        ref: inputRef,
        type: "text",
        "aria-label": intl.formatMessage($83bcd7c3c9310b7e$var$getAriaLabel(triggerQueryPrefix, intl))
    }) : query), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage((0, $8Kvl9.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lnOAf.AssistiveText), {
        assistiveText: resolvedOptionCount === 0 ? intl.formatMessage((0, $8Kvl9.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: resolvedOptionCount
        }) : '',
        isInFocus: resolvedOptionCount === 0 || isInFocus,
        id: (0, $9056b5b25d13b1e3$export$a38374e9651d6165)
    }));
});
$83bcd7c3c9310b7e$export$efc9b80896822e63.displayName = 'InputQuery';


/* RegisteredTypeAheadMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $dN8tJ = parcelRequire("dN8tJ");

const $6cfd73cf4d96636d$export$f5728aa6537ffb8 = (key)=>key.endsWith((0, $dN8tJ.SECTION_OVERFLOW_ITEM_KEY_SUFFIX));



var $7XIuB = parcelRequire("7XIuB");





var $iMnC5 = parcelRequire("iMnC5");



var $kUWm2 = parcelRequire("kUWm2");

const $d9dfc76dc6c4bd7a$export$c16d021774078d85 = (key)=>key.endsWith((0, $kUWm2.MENU_FOOTER_SECTION_KEY_SUFFIX));




var $kejMu = parcelRequire("kejMu");

const $d90f0719cccd36a8$export$425b8a747fe0773f = (components, rootComponent, sectionOverflowLimit)=>{
    const { root: root, childrenMap: childrenMap, topLevelChildren: topLevelChildren } = (0, $kejMu.resolveSurface)(components, rootComponent);
    const sections = [];
    let footer;
    for (const section of topLevelChildren ?? []){
        if (section.type !== 'menu-section' || !(0, $kejMu.willComponentRender)(section, childrenMap)) continue;
        const children = childrenMap.get(section.key) ?? [];
        if ((0, $d9dfc76dc6c4bd7a$export$c16d021774078d85)(section.key)) {
            footer = children.find((child)=>child.type === 'menu-item' && (0, $kejMu.willComponentRender)(child, childrenMap));
            continue;
        }
        let viewMoreItem;
        for(let index = children.length - 1; index >= 0; index--){
            const child = children[index];
            if (child?.type === 'menu-item' && (0, $6cfd73cf4d96636d$export$f5728aa6537ffb8)(child.key) && (0, $kejMu.willComponentRender)(child, childrenMap)) {
                viewMoreItem = child;
                break;
            }
        }
        const items = children.filter((child)=>child.type === 'menu-item' && !(0, $6cfd73cf4d96636d$export$f5728aa6537ffb8)(child.key) && (0, $kejMu.willComponentRender)(child, childrenMap));
        if (items.length === 0) continue;
        if (sectionOverflowLimit !== undefined && viewMoreItem !== undefined && items.length > sectionOverflowLimit) {
            sections.push([
                section,
                ...items.slice(0, sectionOverflowLimit),
                viewMoreItem
            ]);
            continue;
        }
        sections.push([
            section,
            ...items
        ]);
    }
    return {
        footer: footer,
        root: root,
        sections: sections
    };
};







const $640087b6ba101cfa$var$getRank = (component, parentKey)=>component.parents?.find((parent)=>parent.key === parentKey)?.rank ?? Number.MAX_SAFE_INTEGER;
const $640087b6ba101cfa$var$compareMatchedItems = (a, b)=>a.score - b.score || a.sectionRank - b.sectionRank || a.itemRank - b.itemRank || a.identity.localeCompare(b.identity);
const $640087b6ba101cfa$export$a3b8e7b4639eb21a = (components, rootComponent, query, formatMessage)=>{
    const { childrenMap: childrenMap, root: root, topLevelChildren: topLevelChildren } = (0, $kejMu.resolveSurface)(components, rootComponent);
    if (!root || !topLevelChildren) return {
        footer: undefined,
        root: root,
        sections: []
    };
    const matches = new Map();
    for (const section of topLevelChildren){
        if (section.type !== 'menu-section' || (0, $d9dfc76dc6c4bd7a$export$c16d021774078d85)(section.key) || !(0, $kejMu.willComponentRender)(section, childrenMap)) continue;
        for (const item of childrenMap.get(section.key) ?? []){
            if (item.type !== 'menu-item' || (0, $6cfd73cf4d96636d$export$f5728aa6537ffb8)(item.key) || !(0, $kejMu.willComponentRender)(item, childrenMap)) continue;
            const match = item.match?.({
                formatMessage: formatMessage,
                query: query
            });
            if (item.match && match === null) continue;
            const candidate = {
                identity: `${item.type}:${item.key}`,
                item: item,
                itemRank: $640087b6ba101cfa$var$getRank(item, section.key),
                score: Math.min(1, Math.max(0, match?.score ?? 0)),
                section: section,
                sectionRank: $640087b6ba101cfa$var$getRank(section, root.key)
            };
            const existing = matches.get(candidate.identity);
            if (!existing || $640087b6ba101cfa$var$compareMatchedItems(candidate, existing) < 0) matches.set(candidate.identity, candidate);
        }
    }
    const sectionsByKey = new Map();
    for (const match of Array.from(matches.values()).sort($640087b6ba101cfa$var$compareMatchedItems)){
        const existing = sectionsByKey.get(match.section.key);
        if (existing) existing.push(match.item);
        else sectionsByKey.set(match.section.key, [
            match.section,
            match.item
        ]);
    }
    return {
        footer: undefined,
        root: root,
        sections: Array.from(sectionsByKey.values())
    };
};


const $f60f0e347796a1b7$export$d5cc5bf265d75b59 = (listId)=>`${listId}-view-all`;


const $8b30dbdf11411867$export$320b63df33dc0c73 = (listId, itemIndex)=>`${listId}--${itemIndex}`;












var $lfswV = parcelRequire("lfswV");


var $2F1us = parcelRequire("2F1us");







var $4aRua = parcelRequire("4aRua");




parcelRequire("cozmU");










const $df1ff249a437c159$export$c36f87108246a02a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, measure: measure, index: index, style: style, isVisible: isVisible, isScrolling: isScrolling, onMouseMove: onMouseMove }, ref)=>{
    const childElementRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Do not measure if the row is not visible or is scrolling for performance reasons.
        if (!childElementRef.current || !isVisible || isScrolling) return;
        const observer = new ResizeObserver(()=>measure());
        observer.observe(childElementRef.current);
        return ()=>observer.disconnect();
    }, [
        isScrolling,
        isVisible,
        measure
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: ref,
        style: style,
        "data-index": index,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: childElementRef,
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: onMouseMove,
            children: children
        })
    }));
});









const $ab679ce64163ae31$export$8715aee5e047a437 = ({ isSelected: isSelected, itemIndex: itemIndex, Item: Item, listId: listId, onItemHover: onItemHover, registration: registration, rowIndex: rowIndex })=>{
    const onMouseMove = (0, $cozmU.useCallback)(()=>onItemHover(itemIndex), [
        itemIndex,
        onItemHover
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        onMouseMove: onMouseMove,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Item, {
            id: (0, $8b30dbdf11411867$export$320b63df33dc0c73)(listId, rowIndex),
            isSelected: isSelected,
            registration: registration
        })
    });
};





parcelRequire("cozmU");

const $cff6060104225e14$export$b5d6a35b0cce4297 = ({ children: children })=>children;


const $3f734bc099782706$export$87a2b9822a704853 = ({ registration: registration })=>{
    const Component = registration.component ?? (0, $cff6060104225e14$export$b5d6a35b0cce4297);
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        children: null
    });
};


const $fd36c9a097037b67$var$noOp = ()=>{};
const $fd36c9a097037b67$export$3952e20305e1e33e = ({ cache: cache, itemIndexByRowIndex: itemIndexByRowIndex, Item: Item, listId: listId, onItemHover: onItemHover, rows: rows, selectedItemIndex: selectedItemIndex })=>({ index: index, key: key, parent: parent, style: style, isScrolling: isScrolling, isVisible: isVisible })=>{
        const registration = rows[index];
        if (!registration) return null;
        const itemIndex = itemIndexByRowIndex.get(index);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfswV.CellMeasurer), {
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index,
            children: ({ measure: measure })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $df1ff249a437c159$export$c36f87108246a02a), {
                    index: index,
                    isScrolling: isScrolling,
                    isVisible: isVisible,
                    measure: measure,
                    onMouseMove: $fd36c9a097037b67$var$noOp,
                    style: style,
                    children: registration.type === 'menu-section' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3f734bc099782706$export$87a2b9822a704853), {
                        registration: registration
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ab679ce64163ae31$export$8715aee5e047a437), {
                        Item: Item,
                        isSelected: itemIndex === selectedItemIndex,
                        itemIndex: itemIndex ?? 0,
                        listId: listId,
                        onItemHover: onItemHover,
                        registration: registration,
                        rowIndex: index
                    })
                })
        }, key);
    };




/* TypeAheadMenuFooter.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");




const $feae6f36e18fbcaf$var$styles = {
    footer: "_4c065U1Y8M _3zygPU9r67 _2IVJ4M6wH8 _22sfPnNvrM"
};
const $feae6f36e18fbcaf$export$a1e87b60326ef5d2 = ({ id: id, isSelected: isSelected, Item: Item, onMouseMove: onMouseMove, registration: registration })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        onMouseMove: onMouseMove,
        xcss: $feae6f36e18fbcaf$var$styles.footer,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Item, {
            id: id,
            isSelected: isSelected,
            registration: registration
        })
    });


const $5dc53460f67a26e1$var$LIST_WIDTH = 340;
const $5dc53460f67a26e1$var$ESTIMATED_ROW_HEIGHT = 56;
const $5dc53460f67a26e1$var$MENU_FOOTER_HEIGHT = 48;
const $5dc53460f67a26e1$export$ee6db55bff9a708b = ({ Item: Item, listLabel: listLabel, listId: listId, maxHeight: maxHeight, model: model, onItemHover: onItemHover, selectedItemIndex: selectedItemIndex })=>{
    const intl = (0, $kSwu1.useIntl)();
    const listRef = (0, $cozmU.useRef)(null);
    const rows = (0, $cozmU.useMemo)(()=>model.sections.flat(), [
        model.sections
    ]);
    const cache = (0, $cozmU.useMemo)(()=>new (0, $lfswV.CellMeasurerCache)({
            defaultHeight: $5dc53460f67a26e1$var$ESTIMATED_ROW_HEIGHT,
            fixedWidth: true
        }), []);
    const itemIndexByRowIndex = (0, $cozmU.useMemo)(()=>{
        const indexes = new Map();
        let itemIndex = 0;
        rows.forEach((registration, rowIndex)=>{
            if (registration.type === 'menu-item') indexes.set(rowIndex, itemIndex++);
        });
        return indexes;
    }, [
        rows
    ]);
    const selectedRowIndex = (0, $cozmU.useMemo)(()=>{
        for (const [rowIndex, itemIndex] of itemIndexByRowIndex){
            if (itemIndex === selectedItemIndex) return rowIndex;
        }
        return -1;
    }, [
        itemIndexByRowIndex,
        selectedItemIndex
    ]);
    const rowKeySignature = (0, $cozmU.useMemo)(()=>rows.map(({ key: key, type: type })=>`${type}:${key}`).join('\0'), [
        rows
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        cache.clearAll();
        listRef.current?.recomputeRowHeights();
        listRef.current?.scrollToPosition(0);
    }, [
        cache,
        rowKeySignature
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (selectedRowIndex >= 0) listRef.current?.scrollToRow(selectedRowIndex);
    }, [
        selectedRowIndex
    ]);
    const renderRow = (0, $fd36c9a097037b67$export$3952e20305e1e33e)({
        cache: cache,
        itemIndexByRowIndex: itemIndexByRowIndex,
        Item: Item,
        listId: listId,
        onItemHover: onItemHover,
        rows: rows,
        selectedItemIndex: selectedItemIndex
    });
    const footerItemIndex = itemIndexByRowIndex.size;
    const onFooterItemHover = (0, $cozmU.useCallback)(()=>onItemHover(footerItemIndex), [
        footerItemIndex,
        onItemHover
    ]);
    if (!model.root) return null;
    const RootComponent = model.root.component ?? (0, $cff6060104225e14$export$b5d6a35b0cce4297);
    const listMaxHeight = Math.max(0, maxHeight - (model.footer ? $5dc53460f67a26e1$var$MENU_FOOTER_HEIGHT : 0));
    return /*#__PURE__*/ (0, $8aG6j.jsx)(RootComponent, {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            "aria-label": intl.formatMessage(listLabel),
            id: listId,
            role: "listbox",
            children: [
                rows.length === 0 ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    paddingBlock: "space.150",
                    paddingInline: "space.250",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        align: "center",
                        as: "p",
                        children: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).emptySearchResults)
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2F1us.List), {
                    containerRole: "presentation",
                    height: Math.min(rows.length * $5dc53460f67a26e1$var$ESTIMATED_ROW_HEIGHT, listMaxHeight),
                    overscanRowCount: 3,
                    ref: listRef,
                    role: "presentation",
                    rowCount: rows.length,
                    rowHeight: cache.rowHeight,
                    rowRenderer: renderRow,
                    scrollToAlignment: "auto",
                    width: $5dc53460f67a26e1$var$LIST_WIDTH
                }),
                model.footer && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $feae6f36e18fbcaf$export$a1e87b60326ef5d2), {
                    id: (0, $f60f0e347796a1b7$export$d5cc5bf265d75b59)(listId),
                    isSelected: selectedItemIndex === footerItemIndex,
                    Item: Item,
                    onMouseMove: onFooterItemHover,
                    registration: model.footer
                })
            ]
        })
    });
};





const $c4ea2a2fe0cb7bd4$export$7488bf1bf6aaa4fb = (0, $cozmU.createContext)(null);


const $3df22ffc0e6e90a9$export$3e26cf75568c2e04 = (0, $c4ea2a2fe0cb7bd4$export$7488bf1bf6aaa4fb).Provider;


const $5bc6aa0606d58337$var$styles = {
    menu: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _4c065U1Y8M _0KLXruoI2d _2OUyjtGk8v _39xV02e9dk"
};
const $5bc6aa0606d58337$var$DEFAULT_MENU_MAX_HEIGHT = 520;
const $5bc6aa0606d58337$var$POPUP_OFFSET = [
    0,
    8
];
const $5bc6aa0606d58337$var$SECTION_OVERFLOW_LIMIT = 30;
const $5bc6aa0606d58337$export$45c92bf768c8130 = ({ anchorElement: anchorElement, api: api, cancel: cancel, editorView: editorView, forceFocus: forceFocus, maxHeight: maxHeight = $5bc6aa0606d58337$var$DEFAULT_MENU_MAX_HEIGHT, onClose: onClose, onUndoRedo: onUndoRedo, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, query: query, reopenQuery: reopenQuery, setQuery: setQuery, surface: surface, triggerHandler: triggerHandler })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const generatedId = (0, $cozmU.useId)();
    const listId = `${surface.listIdPrefix}-${generatedId}`;
    const menuRef = (0, $cozmU.useRef)(null);
    const [selectedItemIndex, setSelectedItemIndex] = (0, $cozmU.useState)(0);
    const components = (0, $cozmU.useMemo)(()=>api?.uiControlRegistry?.actions.getComponents(surface.root.key) ?? [], [
        api,
        surface.root.key
    ]);
    const hasSectionOverflowItems = (0, $cozmU.useMemo)(()=>components.some(({ key: key })=>(0, $6cfd73cf4d96636d$export$f5728aa6537ffb8)(key)), [
        components
    ]);
    const menuModel = (0, $cozmU.useMemo)(()=>query === '' ? (0, $d90f0719cccd36a8$export$425b8a747fe0773f)(components, surface.root, hasSectionOverflowItems ? $5bc6aa0606d58337$var$SECTION_OVERFLOW_LIMIT : undefined) : (0, $640087b6ba101cfa$export$a3b8e7b4639eb21a)(components, surface.root, query, formatMessage), [
        components,
        formatMessage,
        hasSectionOverflowItems,
        query,
        surface.root
    ]);
    const rows = (0, $cozmU.useMemo)(()=>menuModel.sections.flat(), [
        menuModel.sections
    ]);
    const selectableRowIndexes = (0, $cozmU.useMemo)(()=>rows.flatMap((registration, rowIndex)=>registration.type === 'menu-item' ? [
                rowIndex
            ] : []), [
        rows
    ]);
    const selectableRowKeys = selectableRowIndexes.map((index)=>rows[index]?.key).join(',');
    const selectableItemCount = selectableRowIndexes.length + (menuModel.footer ? 1 : 0);
    (0, $cozmU.useLayoutEffect)(()=>{
        setSelectedItemIndex(selectableItemCount > 0 ? 0 : -1);
    }, [
        query,
        selectableItemCount,
        selectableRowKeys
    ]);
    const selectActiveItem = (0, $cozmU.useCallback)((_mode)=>{
        const rowIndex = selectableRowIndexes[selectedItemIndex];
        const selectedId = rowIndex !== undefined ? (0, $8b30dbdf11411867$export$320b63df33dc0c73)(listId, rowIndex) : menuModel.footer && selectedItemIndex === selectableRowIndexes.length ? (0, $f60f0e347796a1b7$export$d5cc5bf265d75b59)(listId) : undefined;
        if (selectedId) menuRef.current?.ownerDocument.getElementById(selectedId)?.click();
    }, [
        listId,
        menuModel.footer,
        selectableRowIndexes,
        selectedItemIndex
    ]);
    const selectNextItem = (0, $cozmU.useCallback)(()=>{
        setSelectedItemIndex((currentIndex)=>{
            if (selectableItemCount === 0) return -1;
            return currentIndex < 0 || currentIndex === selectableItemCount - 1 ? 0 : currentIndex + 1;
        });
    }, [
        selectableItemCount
    ]);
    const selectPreviousItem = (0, $cozmU.useCallback)(()=>{
        setSelectedItemIndex((currentIndex)=>{
            if (selectableItemCount === 0) return -1;
            return currentIndex <= 0 ? selectableItemCount - 1 : currentIndex - 1;
        });
    }, [
        selectableItemCount
    ]);
    const typeAheadContextValue = (0, $cozmU.useMemo)(()=>({
            api: api,
            editorView: editorView,
            inputMethod: surface.inputMethod,
            onClose: onClose,
            query: query,
            triggerHandler: triggerHandler
        }), [
        api,
        editorView,
        onClose,
        query,
        surface.inputMethod,
        triggerHandler
    ]);
    const noOp = (0, $cozmU.useCallback)(()=>{}, []);
    const SurfaceProvider = surface.Provider;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83bcd7c3c9310b7e$export$efc9b80896822e63), {
                activeDescendantId: selectableRowIndexes[selectedItemIndex] !== undefined ? (0, $8b30dbdf11411867$export$320b63df33dc0c73)(listId, selectableRowIndexes[selectedItemIndex]) : menuModel.footer && selectedItemIndex === selectableRowIndexes.length ? (0, $f60f0e347796a1b7$export$d5cc5bf265d75b59)(listId) : undefined,
                cancel: cancel,
                editorView: editorView,
                forceFocus: forceFocus,
                listId: listId,
                onItemSelect: selectActiveItem,
                onQueryChange: setQuery,
                onQueryFocus: noOp,
                onUndoRedo: onUndoRedo,
                optionCount: selectableItemCount,
                reopenQuery: reopenQuery,
                selectNextItem: selectNextItem,
                selectPreviousItem: selectPreviousItem,
                shouldKeepOpenOnRegisteredMenu: true,
                triggerQueryPrefix: triggerHandler.trigger
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
                ariaLabel: null,
                boundariesElement: popupsBoundariesElement,
                fitHeight: maxHeight,
                fitWidth: 340,
                mountTo: popupsMountPoint,
                offset: $5bc6aa0606d58337$var$POPUP_OFFSET,
                preventOverflow: true,
                scrollableElement: popupsScrollableElement,
                target: anchorElement,
                zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    ref: menuRef,
                    "data-registered-type-ahead-menu": "",
                    xcss: $5bc6aa0606d58337$var$styles.menu,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3df22ffc0e6e90a9$export$3e26cf75568c2e04), {
                        value: typeAheadContextValue,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)(SurfaceProvider, {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5dc53460f67a26e1$export$ee6db55bff9a708b), {
                                Item: surface.Item,
                                listLabel: surface.listLabel,
                                listId: listId,
                                maxHeight: maxHeight,
                                model: menuModel,
                                onItemHover: setSelectedItemIndex,
                                selectedItemIndex: selectedItemIndex
                            })
                        })
                    })
                })
            })
        ]
    });
};






var $dCkbP = parcelRequire("dCkbP");







var $4o0zT = parcelRequire("4o0zT");








var $h7AEq = parcelRequire("h7AEq");

const $ef4a0bc104b473a8$export$8ef13bedce759b55 = (0, $h7AEq.QuickInsertContext).Provider;



var $9wgTc = parcelRequire("9wgTc");


const $0a20ff00be43231f$export$35133215e25e10c7 = ({ id: id, isSelected: isSelected, registration: registration })=>{
    const quickInsertContext = (0, $9wgTc.useQuickInsertContext)();
    const Component = registration.component ?? (0, $cff6060104225e14$export$b5d6a35b0cce4297);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            editorView: quickInsertContext.editorView,
            isOffline: quickInsertContext.isOffline,
            item: {
                id: id,
                isSelected: isSelected
            },
            select: quickInsertContext.select
        }), [
        id,
        isSelected,
        quickInsertContext
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ef4a0bc104b473a8$export$8ef13bedce759b55), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            children: null
        })
    });
};












var $3k5Tv = parcelRequire("3k5Tv");







const $c13b02dfb2ae24ce$export$ca9af919503437c9 = ()=>{
    const value = (0, $cozmU.useContext)((0, $c4ea2a2fe0cb7bd4$export$7488bf1bf6aaa4fb));
    if (!value) throw new Error('useTypeAheadContext must be used within TypeAheadProvider');
    return value;
};


const $715e19a8796e4d1b$export$212ead6007f88306 = ({ children: children })=>{
    const { api: api, editorView: editorView, inputMethod: inputMethod, onClose: onClose, query: query, triggerHandler: triggerHandler } = (0, $c13b02dfb2ae24ce$export$ca9af919503437c9)();
    const { isOffline: isOffline } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], ({ connectivityState: connectivityState })=>({
            isOffline: (0, $jaFVy.isOfflineMode)(connectivityState?.mode)
        }));
    const select = (0, $cozmU.useCallback)((selectionHandler)=>{
        onClose();
        queueMicrotask(()=>{
            (0, $5bffb32f6167acf4$export$cf9e900b30aef2ea)(editorView)({
                handler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                selectionHandler: selectionHandler
            });
        });
    }, [
        editorView,
        inputMethod,
        onClose,
        query,
        triggerHandler
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            editorView: editorView,
            isOffline: isOffline,
            select: select
        }), [
        editorView,
        isOffline,
        select
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ef4a0bc104b473a8$export$8ef13bedce759b55), {
        value: contextValue,
        children: children
    });
};


const $e6affb8a18ac907e$var$quickInsertSurface = {
    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
    Item: (0, $0a20ff00be43231f$export$35133215e25e10c7),
    listIdPrefix: 'quick-insert-menu',
    listLabel: (0, $8Kvl9.typeAheadListMessages).quickInsertInputLabel,
    Provider: (0, $715e19a8796e4d1b$export$212ead6007f88306),
    root: (0, $dCkbP.MENU)
};
const $e6affb8a18ac907e$export$4ac2535e78a0590b = (id)=>{
    if (id === (0, $efqK4.TypeAheadAvailableNodes).QUICK_INSERT && (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command')) return $e6affb8a18ac907e$var$quickInsertSurface;
    return undefined;
};


const $5b2180e84be84eaf$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo, api: api })=>{
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    const intl = (0, $kSwu1.useIntl)();
    const [closed, setClosed] = (0, $cozmU.useState)(false);
    const [query, setQuery] = (0, $cozmU.useState)(reopenQuery || '');
    const queryRef = (0, $cozmU.useRef)(query);
    const editorViewRef = (0, $cozmU.useRef)(editorView);
    const registeredSurface = (0, $e6affb8a18ac907e$export$4ac2535e78a0590b)(triggerHandler.id);
    const items = (0, $fdfc8cd629994464$export$36f5628e43bc3fcd)(triggerHandler, editorView, query, showMoreOptionsButton, api, intl, !registeredSurface);
    (0, $cozmU.useEffect)(()=>{
        if (!closed && (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        closed,
        api
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $e56262612162b97c$export$3a3385069392b26f)(triggerHandler, editorView, items, api);
    const selectNextItem = (0, $cozmU.useMemo)(()=>(0, $23d4fc3cd3760671$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $cozmU.useMemo)(()=>(0, $23d4fc3cd3760671$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const cancel = (0, $cozmU.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) (0, $e313a08cd9f207d5$export$4a6068dadc2c7771)(api, (0, $krYZG.ACTION).CANCELLED, !!queryRef.current, (0, $krYZG.INPUT_METHOD).KEYBOARD, (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorView.state)?.inputMethod);
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        triggerHandler.trigger,
        onTextInsert,
        api,
        editorView.state
    ]);
    const insertSelectedItem = (0, $cozmU.useCallback)((mode = (0, $efqK4.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { selectedIndex: selectedIndex } = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(view.state);
        const safeSelectedIndex = (0, $23d4fc3cd3760671$export$84a03e6192df0237)({
            currentIndex: selectedIndex,
            nextIndex: 1,
            listSize: items.length,
            itemIsDisabled: (idx)=>(0, $bb95ceffb7708bae$export$1ebf03cc1b973f80)(items[idx], api)
        });
        // If the only safe index is -1 then none are safe - do not insert item
        if (safeSelectedIndex === -1) return;
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) (0, $e313a08cd9f207d5$export$4a6068dadc2c7771)(api, (0, $krYZG.ACTION).INSERTED, !!queryRef.current, (0, $krYZG.INPUT_METHOD).KEYBOARD, (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorView.state)?.inputMethod);
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        items,
        api,
        editorView.state,
        onItemInsert
    ]);
    const showTypeAheadPopupList = (0, $cozmU.useCallback)(()=>{}, []);
    const closePopup = (0, $cozmU.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(view.state);
        const shouldSkipEmptyQuery = !(0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && query.length === 0;
        if (shouldSkipEmptyQuery || query === pluginState?.query || !pluginState?.triggerHandler) return;
        (0, $8ce5a4e5713734e6$export$4d1bf8b2f67bcb1)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $5dc9c068d6df9154$export$4715c10ec9ca9321)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    if (!triggerHandler) return null;
    if (registeredSurface) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5bc6aa0606d58337$export$45c92bf768c8130), {
        anchorElement: anchorElement,
        api: api,
        cancel: cancel,
        editorView: editorView,
        forceFocus: shouldFocusCursorInsideQuery,
        onClose: closePopup,
        onUndoRedo: onUndoRedo,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        query: query,
        reopenQuery: reopenQuery,
        setQuery: setQuery,
        surface: registeredSurface,
        triggerHandler: triggerHandler
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83bcd7c3c9310b7e$export$efc9b80896822e63), {
        triggerQueryPrefix: triggerHandler?.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$5b2180e84be84eaf$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';






const $e7f8a4dedb99c991$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $kCECX.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $8nvEM.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const decorationId = `decoration_id_${(0, $9056b5b25d13b1e3$export$65dc1d975bd3407b)}_${(0, $kHija.v4)()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $63f5f75c33c83e19$export$630efe5940bb4d41)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $8nvEM.Decoration).widget($cursor.pos, (editorView, getDecorationPositionUnsafe)=>{
            const getDecorationPosition = ()=>{
                try {
                    return getDecorationPositionUnsafe();
                } catch (e) {
                    return undefined;
                }
            };
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $9056b5b25d13b1e3$export$be8a8259777b339f);
            typeaheadComponent.style.color = "var(--ds-text-accent-blue, #1558BC)";
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $23d4fc3cd3760671$export$7a55deb43cd1340e)(editorView.state);
                if (hasReopenQuery || currentQuery?.length === 0) {
                    const command = inputType === 'historyUndo' ? (0, $di3bZ.undo) : (0, $di3bZ.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $609861d2c745601d$export$daba40574d0568e3)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
                    defaultLocale: intl.defaultLocale || 'en-US',
                    locale: intl.locale || 'en-US',
                    messages: intl.messages,
                    formats: intl.formats,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5b2180e84be84eaf$export$970faf6afe0d9376), {
                        triggerHandler: triggerHandler,
                        editorView: editorView,
                        anchorElement: typeaheadComponent,
                        inputMethod: inputMethod,
                        getDecorationPosition: getDecorationPosition,
                        shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                        onUndoRedo: onUndoRedo,
                        reopenQuery: reopenQuery,
                        api: api
                    })
                }), typeaheadComponent, decorationId, undefined, // @portal-render-immediately
            true);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $iqS60.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $8nvEM.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $8nvEM.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            nodeViewPortalProviderAPI.remove(spec.key);
        });
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};














var $eFgM7 = parcelRequire("eFgM7");




const $b82f84f8a214c421$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $gT4iv.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $gT4iv.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $gT4iv.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $b82f84f8a214c421$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $gT4iv.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $gT4iv.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $gT4iv.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $b82f84f8a214c421$var$applySectionTitleUpdates = ({ sections: sections, sectionTitleUpdates: sectionTitleUpdates })=>{
    const updatedSections = sections.map((section)=>{
        const update = sectionTitleUpdates[section.id];
        if (!update) return section;
        return {
            ...section,
            ...update
        };
    });
    return updatedSections;
};
const $b82f84f8a214c421$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $gT4iv.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $b82f84f8a214c421$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $b82f84f8a214c421$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>{
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        (0, $eFgM7.insm).session?.startFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            sectionTitleUpdates: {},
            sections: [],
            query: reopenQuery || '',
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        };
    };
    const closeMenu = (currentPluginState)=>{
        removeDecorations(currentPluginState.decorationSet);
        (0, $eFgM7.insm).session?.endFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $8nvEM.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: [],
            sections: [],
            sectionTitleUpdates: {},
            removePrefixTriggerOnCancel: undefined
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $b82f84f8a214c421$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($b82f84f8a214c421$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $c76f078940ffa50e$export$92a1a3b7554e9387).OPEN_TYPEAHEAD_AT_CURSOR && (0, $23d4fc3cd3760671$export$be092076596418f1)(params?.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $c76f078940ffa50e$export$92a1a3b7554e9387).CLOSE_TYPE_AHEAD,
            (0, $c76f078940ffa50e$export$92a1a3b7554e9387).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $c76f078940ffa50e$export$92a1a3b7554e9387).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_LIST_ITEMS;
        const shouldUpdateListError = action === (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_LIST_ERROR;
        const shouldUpdateSelectedIndex = action === (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_SELECTED_INDEX;
        const shouldUpdateSectionTitleState = action === (0, $c76f078940ffa50e$export$92a1a3b7554e9387).UPDATE_SECTION_TITLE;
        const shouldClearListError = action === (0, $c76f078940ffa50e$export$92a1a3b7554e9387).CLEAR_LIST_ERROR;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query,
            removePrefixTriggerOnCancel: params.removePrefixTriggerOnCancel
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListError) {
            const { errorInfo: errorInfo } = params;
            return {
                ...currentPluginState,
                errorInfo: errorInfo,
                items: [],
                sections: [],
                selectedIndex: -1
            };
        } else if (shouldUpdateListItems) {
            const { items: items, sections: sections = [] } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                sections: $b82f84f8a214c421$var$applySectionTitleUpdates({
                    sections: sections,
                    sectionTitleUpdates: currentPluginState.sectionTitleUpdates
                }),
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSectionTitleState) {
            const { id: id, update: update } = params;
            const sectionTitleUpdates = {
                ...currentPluginState.sectionTitleUpdates,
                [id]: {
                    ...currentPluginState.sectionTitleUpdates[id],
                    ...update
                }
            };
            return {
                ...currentPluginState,
                sectionTitleUpdates: sectionTitleUpdates,
                sections: $b82f84f8a214c421$var$applySectionTitleUpdates({
                    sections: currentPluginState.sections,
                    sectionTitleUpdates: sectionTitleUpdates
                })
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        else if (shouldClearListError) return {
            ...currentPluginState,
            errorInfo: null
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4f41df2ab28ab735$var$ASCII_CHAR_REGEX = /^[\x00-\x7F]$/;
const $4f41df2ab28ab735$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $gT4iv.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $4f41df2ab28ab735$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $e7f8a4dedb99c991$export$116b677c5744e397)({
        intl: intl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        popupMountRef: popupMountRef,
        api: api
    });
    const reducer = (0, $b82f84f8a214c421$export$473eb76d322d0290)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    // Tracks a wide-char trigger handler detected during IME composition (e.g. ／).
    // Set by compositionupdate, cleared by compositionend. Used by handleKeyDown
    // to intercept Enter that confirms the composition.
    let pendingWideSlashHandler = null;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $8nvEM.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    sectionTitleUpdates: {},
                    sections: [],
                    errorInfo: null,
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null,
                    removePrefixTriggerOnCancel: undefined
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $4f41df2ab28ab735$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $d749ef22a21c524c$export$e715282b081c154e)(transactions, (0, $c76f078940ffa50e$export$92a1a3b7554e9387).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) {
                    if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                    return tr;
                }
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                return (0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1).getState(state)?.decorationSet;
            },
            handleKeyDown: (view, event)=>{
                // When composing a wide-char trigger (e.g. ／), intercept the Enter key
                // that confirms the composition so we can open the typeahead instead.
                if (pendingWideSlashHandler && event.isComposing && (event.key === 'Enter' || event.keyCode === 13)) {
                    const handler = pendingWideSlashHandler;
                    pendingWideSlashHandler = null;
                    // Defer until ProseMirror has flushed the composed text into its state.
                    setTimeout(()=>{
                        const command = (0, $8c86625311d23646$export$e7ce737179b76875)({
                            triggerHandler: handler,
                            inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD
                        });
                        const tr = command({
                            tr: view.state.tr
                        });
                        if (tr) view.dispatch(tr);
                    }, 0);
                    return true;
                }
                return false;
            },
            handleDOMEvents: {
                compositionupdate: (view, event)=>{
                    // When the experiment is on, track whether the current composition
                    // exactly matches a wide-char trigger (e.g. ／ from Japanese keyboard).
                    // We can't open the typeahead yet because composition is still active,
                    // but we record the matching handler so the next keydown (Enter) can use it.
                    if ((0, $ieeJu.expValEquals)('platform_editor_wide_slash_trigger', 'isEnabled', true)) {
                        const pendingData = event.data ?? '';
                        pendingWideSlashHandler = typeAheadHandlers.find((handler)=>{
                            if (!handler.customRegex) return false;
                            // Only match if the composition is a NON-ASCII trigger character.
                            // ASCII triggers (e.g. '/') are handled by the normal input rule
                            // path and must NOT be intercepted here — otherwise typing '/' on
                            // a macOS Japanese IME (which briefly fires compositionupdate with
                            // data='/') would cause the Enter-confirm to open the typeahead.
                            // Matches any single ASCII character (U+0000–U+007F).
                            // No 'u' flag needed for ASCII-only ranges.
                            if ($4f41df2ab28ab735$var$ASCII_CHAR_REGEX.test(pendingData)) return false;
                            const pattern = new RegExp(`^(${handler.customRegex})$`, 'u');
                            return pattern.test(pendingData);
                        }) ?? null;
                    }
                    return false;
                },
                compositionend: (view, event)=>{
                    // Clear the pending handler when composition ends (cancelled or committed
                    // via a non-Enter key like Space, which we don't want to intercept).
                    pendingWideSlashHandler = null;
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $btvbC.closest)(target, `[data-type-ahead=${(0, $9056b5b25d13b1e3$export$be8a8259777b339f)}]`)) return true;
                    return false;
                }
            }
        }
    });
}







parcelRequire("cozmU");






















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $LQnOI = parcelRequire("LQnOI");











var $1jz5K = parcelRequire("1jz5K");







var $cXtTj = parcelRequire("cXtTj");










/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports












parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $kA6Zo = parcelRequire("kA6Zo");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");

const $99580d8f55a9a73c$var$containerStyles = (0, $buxP3.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $99580d8f55a9a73c$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kA6Zo.Flex), {
        xcss: $99580d8f55a9a73c$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kA6Zo.Flex), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports



const $61801df32b33fbd8$var$HEIGHT = 90;
const $61801df32b33fbd8$var$genericErrorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    height: `${$61801df32b33fbd8$var$HEIGHT}px`,
    display: 'block'
});
const $61801df32b33fbd8$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $lOiVq.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $61801df32b33fbd8$var$genericErrorStyles,
        ...props
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("defs", null, /*#__PURE__*/ (0, $lOiVq.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};


function $c816d348bf365efa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c816d348bf365efa$var$minHeightComponentStyles = {
    name: "2omrkj",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:290px"
};
const $c816d348bf365efa$export$71ea07f9d4f4ab38 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage((0, $8Kvl9.typeAheadListMessages).typeAheadErrorFallbackHeading);
    const description = intl.formatMessage((0, $8Kvl9.typeAheadListMessages).typeAheadErrorFallbackDesc);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "typeahead-error-boundary-ui",
        css: $c816d348bf365efa$var$minHeightComponentStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $99580d8f55a9a73c$export$fddf379e22a74b00), {
        header: header,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        renderImage: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $61801df32b33fbd8$export$e54420a1a27457a4), null),
        description: description
    }));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


















var $gx3UZ = parcelRequire("gx3UZ");










var $6IL1T = parcelRequire("6IL1T");







var $1l0kj = parcelRequire("1l0kj");











/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $9d7Pd = parcelRequire("9d7Pd");

var $8FgJC = parcelRequire("8FgJC");

function $85d3d906ac0ee863$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $85d3d906ac0ee863$var$buttonStyles = {
    name: "t1j6cq",
    styles: "& > button:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}& > button:focus{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}"
};
const $85d3d906ac0ee863$export$76421314069e32e1 = ({ onClick: onClick, isFocused: isFocused, title: title, ariaLabel: ariaLabel, iconBefore: iconBefore, lastInputMethodRef: lastInputMethodRef })=>{
    const ref = (0, $cozmU.useRef)(null);
    const isSafari = (0, $8dxef.getBrowserInfo)().safari;
    (0, $cozmU.useEffect)(()=>{
        if (isFocused && ref.current) {
            const skipFocusOnSafariHover = isSafari && lastInputMethodRef?.current === 'mouse';
            if (!skipFocusOnSafariHover) ref.current.focus();
        }
    }, [
        isFocused,
        lastInputMethodRef,
        isSafari
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const handleEnter = (e)=>{
            if (e.key === 'Enter') {
                onClick();
                // Prevent keydown listener in TypeaheadList from handling Enter pressed
                e.stopPropagation();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleEnter);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleEnter);
        };
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $85d3d906ac0ee863$var$buttonStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
        ref: ref,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onMouseDown: (e)=>{
            if (isSafari) e.preventDefault();
        },
        onClick: onClick,
        iconBefore: iconBefore,
        "aria-label": ariaLabel,
        testId: "type-ahead-more-options-button"
    }, title)));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















var $kojjU = parcelRequire("kojjU");













var $lrTDq = parcelRequire("lrTDq");








var $9GVkD = parcelRequire("9GVkD");

function $644227fc17b36c36$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $644227fc17b36c36$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $lOiVq.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $644227fc17b36c36$var$itemIconSizeUpdated = {
    name: "1pc97kj",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $644227fc17b36c36$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $644227fc17b36c36$var$itemText = /*#__PURE__*/ (0, $lOiVq.css)({
    whiteSpace: 'initial',
    color: `${"var(--ds-text, #292A2E)"}`
});
const $644227fc17b36c36$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $644227fc17b36c36$var$itemTitleOverride = {
    name: "1mdt16o",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $644227fc17b36c36$var$itemDescription = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $7Y8M5.relativeFontSizeToBase16)(12)};`,
    color: `${"var(--ds-text-subtle, #505258)"};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
const $644227fc17b36c36$var$itemDescriptionOverride = {
    name: "11i1ezp",
    styles: "font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $644227fc17b36c36$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $644227fc17b36c36$var$customRenderItemDivStyle = {
    name: "1679gcj",
    styles: "overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px var(--ds-border-focused, #4688EC);background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);outline:none;}"
};
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $644227fc17b36c36$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${"var(--ds-border-focused, #4688EC)"};`,
        backgroundColor: `${"var(--ds-background-neutral-subtle-hovered, #0515240F)"}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $644227fc17b36c36$var$selectedStyle = {
    name: "2atq5y",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);box-shadow:inset 2px 0px 0px var(--ds-border-focused, #4688EC)"
};
const $644227fc17b36c36$var$disabledStyle = {
    name: "v9x70u",
    styles: "color:var(--ds-text-disabled, #080F214A)"
};
const $644227fc17b36c36$var$titleWithLozengeStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    alignItems: 'center',
    gap: `${"var(--ds-space-050, 4px)"}`
});
const $644227fc17b36c36$var$lozengeWrapperStyle = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $644227fc17b36c36$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kojjU.default), null);
});
const $644227fc17b36c36$var$noop = ()=>{};
const $644227fc17b36c36$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, itemIsDisabled: itemIsDisabled, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $cozmU.useMemo)(()=>{
        return [
            $644227fc17b36c36$var$customRenderItemDivStyle,
            isSelected && !itemIsDisabled && $644227fc17b36c36$var$selectedStyle,
            itemIsDisabled && $644227fc17b36c36$var$disabledStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex + 1,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $644227fc17b36c36$var$noop
    })));
});
const $644227fc17b36c36$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, firstOnlineSupportedIndex: firstOnlineSupportedIndex, lastInputMethodRef: lastInputMethodRef })=>{
    const isSafari = (0, $8dxef.getBrowserInfo)().safari;
    const { connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>{
        return {
            connectivityMode: states.connectivityState?.mode
        };
    });
    const isItemDisabled = (item)=>(0, $jaFVy.isOfflineMode)(connectivityMode) && (item?.isDisabledOffline ?? false);
    const itemIsDisabled = isItemDisabled(item);
    const isFirstEnabledIndex = (0, $jaFVy.isOfflineMode)(connectivityMode) && itemIndex === firstOnlineSupportedIndex && selectedIndex === -1;
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ let isSelected = false;
    // Feature gated - connectivity is only available on desktop and behind a feature gate on full page mode
    if (connectivityMode === undefined) isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    else isSelected = itemIndex === selectedIndex || selectedIndex === -1 && (itemIndex === 0 || isFirstEnabledIndex) && !itemIsDisabled;
    // Assistive text
    const intl = (0, $kSwu1.useIntl)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $8Kvl9.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const descriptionId = `typeahead-item-description-${itemIndex}`;
    const { icon: icon, title: title, render: customRenderItem } = item;
    const elementIcon = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                $644227fc17b36c36$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $644227fc17b36c36$var$itemIconSizeUpdated
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $lOiVq.jsx)($644227fc17b36c36$var$FallbackIcon, null));
    }, [
        icon,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $cozmU.useCallback)(()=>{
        if (itemIsDisabled) return;
        onItemClick((0, $efqK4.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex,
        itemIsDisabled
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex && !isFirstEnabledIndex;
    const listItemClasses = (0, $cozmU.useMemo)(()=>{
        return [
            $644227fc17b36c36$var$selectionFrame,
            isSelected && !itemIsDisabled && $644227fc17b36c36$var$selectedStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) {
            const skipFocusOnSafariHover = isSafari && lastInputMethodRef?.current === 'mouse';
            if (!skipFocusOnSafariHover) customItemRef?.current?.focus();
        }
    }, [
        customItemRef,
        shouldUpdateFocus,
        lastInputMethodRef,
        isSafari
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) {
            const skipFocusOnSafariHover = isSafari && lastInputMethodRef?.current === 'mouse';
            if (!skipFocusOnSafariHover) buttonItemRef?.current?.focus();
        }
    }, [
        buttonItemRef,
        shouldUpdateFocus,
        lastInputMethodRef,
        isSafari
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $lOiVq.jsx)($644227fc17b36c36$var$CustomItemComponentWrapper, {
        itemIsDisabled: itemIsDisabled,
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: listItemClasses
    }, (descriptionText || shortcutText) && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GVkD.default), {
        id: descriptionId
    }, descriptionText, " ", shortcutText), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        "aria-selected": isSelected,
        "aria-label": title,
        "aria-describedby": descriptionText || shortcutText ? descriptionId : undefined,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex + 1,
        role: "option",
        ref: buttonItemRef,
        isDisabled: itemIsDisabled,
        testId: (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? item.testId : undefined,
        css: listItemClasses
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $644227fc17b36c36$var$itemText
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $644227fc17b36c36$var$itemBody
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $644227fc17b36c36$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $644227fc17b36c36$var$itemTitleOverride,
            itemIsDisabled && $644227fc17b36c36$var$disabledStyle,
            item.lozenge && $644227fc17b36c36$var$titleWithLozengeStyle
        ]
    }, item.title, item.lozenge && /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $644227fc17b36c36$var$lozengeWrapperStyle
    }, item.lozenge)), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $644227fc17b36c36$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $lrTDq.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $644227fc17b36c36$var$itemDescription,
            moreElementsInQuickInsertViewEnabled && $644227fc17b36c36$var$itemDescriptionOverride,
            itemIsDisabled && $644227fc17b36c36$var$disabledStyle
        ]
    }, item.description))))));
});


const $d4df94088a75cba3$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $d4df94088a75cba3$var$LIST_WIDTH = 320;
const $d4df94088a75cba3$var$list = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
/**
 * Resolves section title visibility before rows are built so hidden titles do not
 * occupy virtualized list rows. A single populated section keeps the existing
 * no-title behaviour unless it opts in with `showWhenOnlySection`; multiple
 * populated sections show titles by default. `showWhenQueryPresent: false`
 * takes precedence once the query is non-empty.
 */ const $d4df94088a75cba3$var$shouldRenderSectionTitle = ({ isEmptyQuery: isEmptyQuery, populatedSectionCount: populatedSectionCount, section: section })=>{
    if (!isEmptyQuery && section.sectionTitleDisplay?.showWhenQueryPresent === false) return false;
    if (populatedSectionCount === 1) return section.sectionTitleDisplay?.showWhenOnlySection === true;
    return true;
};
const $d4df94088a75cba3$export$8db52dab09acd16e = ({ isEmptyQuery: isEmptyQuery, itemsLength: itemsLength, sections: sections })=>{
    if (sections.length === 0) return Array.from({
        length: itemsLength
    }, (_, itemIndex)=>({
            type: 'item',
            itemIndex: itemIndex
        }));
    const sortedSections = [
        ...sections
    ].sort((left, right)=>left.startIndex - right.startIndex);
    const sectionsByStartIndex = new Map(sortedSections.map((section)=>[
            section.startIndex,
            section
        ]));
    const rows = [];
    const populatedSectionCount = sortedSections.length;
    for(let itemIndex = 0; itemIndex < itemsLength; itemIndex++){
        const section = sectionsByStartIndex.get(itemIndex);
        if (section) {
            const shouldRenderTitle = $d4df94088a75cba3$var$shouldRenderSectionTitle({
                isEmptyQuery: isEmptyQuery,
                populatedSectionCount: populatedSectionCount,
                section: section
            });
            if (shouldRenderTitle) rows.push({
                type: 'section',
                section: section
            });
        }
        rows.push({
            type: 'item',
            itemIndex: itemIndex
        });
    }
    return rows;
};
const $d4df94088a75cba3$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lnOAf.AssistiveText), {
        assistiveText: intl.formatMessage((0, $8Kvl9.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $9056b5b25d13b1e3$export$a38374e9651d6165) + '__popup'
    });
});
const $d4df94088a75cba3$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ items: items, sections: sections, emptyItem: emptyItem, selectedIndex: selectedIndex, isEmptyQuery: isEmptyQuery = true, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, showMoreOptionsButton: showMoreOptionsButton, onMoreOptionsClicked: onMoreOptionsClicked })=>{
    const listRef = (0, $cozmU.useRef)();
    const listContainerRef = (0, $cozmU.useRef)(null);
    const lastInputMethodRef = (0, $cozmU.useRef)('keyboard');
    const mouseMovedRef = (0, $cozmU.useRef)(false);
    const lastVisibleIndexes = (0, $cozmU.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    // Exclude view more item from the count
    const itemsLength = showMoreOptionsButton ? Math.max(items.length - 1, 0) : items.length;
    const isEmptyStateActive = (0, $ieeJu.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) && !!emptyItem && itemsLength === 1 && items[0] === emptyItem;
    const estimatedHeight = itemsLength * $d4df94088a75cba3$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $cozmU.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $cozmU.useState)(new (0, $lfswV.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $d4df94088a75cba3$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const listRows = (0, $cozmU.useMemo)(()=>$d4df94088a75cba3$export$8db52dab09acd16e({
            isEmptyQuery: isEmptyQuery,
            itemsLength: itemsLength,
            sections: sections || []
        }), [
        isEmptyQuery,
        itemsLength,
        sections
    ]);
    const itemRowIndexByItemIndex = (0, $cozmU.useMemo)(()=>{
        const rowIndexByItemIndex = new Map();
        listRows.forEach((row, rowIndex)=>{
            if (row.type === 'item') rowIndexByItemIndex.set(row.itemIndex, rowIndex);
        });
        return rowIndexByItemIndex;
    }, [
        listRows
    ]);
    const selectedItemRowIndex = selectedIndex >= 0 ? itemRowIndexByItemIndex.get(selectedIndex) ?? -1 : -1;
    const onItemsRendered = (0, $cozmU.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter',
            'Shift'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $cozmU.useCallback)(()=>{
        //To reset the selected index
        (0, $89435a8b382f1be8$export$9993709486a96a6b)(-1, api)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement?.querySelector(`[role='combobox']`)?.focus();
    }, [
        editorView,
        listRef,
        decorationElement,
        api
    ]);
    const selectNextItem = (0, $cozmU.useMemo)(()=>(0, $23d4fc3cd3760671$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $cozmU.useMemo)(()=>(0, $23d4fc3cd3760671$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $cozmU.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
                const isSelectedItemVisible = selectedItemRowIndex >= lastVisibleStartIndex && selectedItemRowIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
                isViewMoreSelected;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedItemRowIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton,
        selectedItemRowIndex
    ]);
    const onMouseMove = (event, row)=>{
        if (row.type !== 'item') return;
        const itemIndex = row.itemIndex;
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === itemIndex) return;
        mouseMovedRef.current = true;
        lastInputMethodRef.current = 'mouse';
        (0, $89435a8b382f1be8$export$9993709486a96a6b)(itemIndex, api)(editorView.state, editorView.dispatch);
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        if (mouseMovedRef.current) mouseMovedRef.current = false;
        else lastInputMethodRef.current = 'keyboard';
    }, [
        selectedIndex
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
        const isSelectedItemVisible = selectedItemRowIndex >= lastVisibleStartIndex && selectedItemRowIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
        isViewMoreSelected;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedItemRowIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton,
        selectedItemRowIndex
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        setCache(new (0, $lfswV.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $d4df94088a75cba3$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            if (listContainerRef.current?.firstChild) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items,
        sections
    ]);
    const hasSections = sections && sections.length > 0;
    (0, $cozmU.useLayoutEffect)(()=>{
        // Exclude view more item from the count
        const itemsToRender = hasSections ? listRows : showMoreOptionsButton ? items.slice(0, -1) : items;
        const height = Math.min(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        itemsToRender.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        listRows,
        items,
        cache,
        fitHeight,
        hasSections,
        showMoreOptionsButton
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     * @example
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) {
                lastInputMethodRef.current = 'keyboard';
                switch(event.key){
                    case 'ArrowDown':
                        selectNextItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'ArrowUp':
                        selectPreviousItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'Tab':
                        event.shiftKey ? selectPreviousItem() : selectNextItem();
                        event.preventDefault();
                        break;
                    case 'Enter':
                        //Enter key quick inserts the selected item.
                        if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                            onItemClick(event.shiftKey ? (0, $efqK4.SelectItemMode).SHIFT_ENTER : (0, $efqK4.SelectItemMode).ENTER, selectedIndex, (0, $krYZG.INPUT_METHOD).KEYBOARD);
                            event.preventDefault();
                        }
                        break;
                    default:
                        event.preventDefault();
                }
            } else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        itemsLength
    ]);
    const firstOnlineSupportedRow = (0, $cozmU.useMemo)(()=>{
        return items.findIndex((item)=>item.isDisabledOffline !== true);
    }, [
        items
    ]);
    const config = triggerHandler?.getMoreOptionsButtonConfig?.(intl);
    const handleClick = ()=>{
        if (onMoreOptionsClicked) onMoreOptionsClicked();
        api?.core.actions.execute(({ tr: tr })=>{
            (0, $609861d2c745601d$export$daba40574d0568e3)(tr);
            config?.onClick({
                tr: tr
            });
            return tr;
        });
    };
    const renderRow = ({ index: index, key: key, style: style, parent: parent, isScrolling: isScrolling, isVisible: isVisible })=>{
        const currentRow = listRows[index];
        if (!currentRow) return null;
        const sectionLozenge = currentRow.type === 'section' ? currentRow.section.lozenge : null;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfswV.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, ({ measure: measure })=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $df1ff249a437c159$export$c36f87108246a02a), {
                measure: measure,
                index: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: style,
                isVisible: isVisible,
                isScrolling: isScrolling,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onMouseMove: (e)=>onMouseMove(e, currentRow)
            }, currentRow.type === 'section' ? (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? sectionLozenge ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iMnC5.Box), {
                paddingInline: "space.150",
                paddingBlockStart: "space.150",
                paddingBlockEnd: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1l0kj.Inline), {
                as: "span",
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title), sectionLozenge)) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iMnC5.Box), {
                paddingInline: "space.150",
                paddingBlockStart: "space.100",
                paddingBlockEnd: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title)) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iMnC5.Box), {
                paddingInline: "space.150",
                paddingBlock: "space.050"
            }, sectionLozenge ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1l0kj.Inline), {
                as: "span",
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title), sectionLozenge) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title)) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $644227fc17b36c36$export$913373331e95c13e), {
                key: items[currentRow.itemIndex].title,
                item: items[currentRow.itemIndex],
                firstOnlineSupportedIndex: firstOnlineSupportedRow,
                itemsLength: itemsLength,
                itemIndex: currentRow.itemIndex,
                selectedIndex: selectedIndex,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onItemClick: (mode, itemIndex)=>{
                    actions.onItemClick(mode, itemIndex, (0, $krYZG.INPUT_METHOD).MOUSE);
                },
                ariaLabel: (0, $23d4fc3cd3760671$export$19cacaa810ba988a)(triggerHandler?.trigger, intl, items[currentRow.itemIndex]).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
                api: api,
                lastInputMethodRef: lastInputMethodRef
            })));
    };
    const popupAriaLabel = (0, $23d4fc3cd3760671$export$19cacaa810ba988a)(triggerHandler?.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, $9056b5b25d13b1e3$export$a38374e9651d6165);
    const EmptyResultView = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iMnC5.Box), {
        paddingBlock: "space.150",
        paddingInline: "space.250"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $8Kvl9.typeAheadListMessages).emptySearchResults)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $ieeJu.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) ? showMoreOptionsButton ? (0, $8Kvl9.typeAheadListMessages).emptySearchResultsSuggestionNew : (0, $8Kvl9.typeAheadListMessages).emptySearchResultsSuggestionAskRovoOnly : (0, $8Kvl9.typeAheadListMessages).emptySearchResultsSuggestion, {
        askRovoName: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
            weight: "medium"
        }, intl.formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).askRovo)),
        buttonName: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.Text), {
            weight: "medium"
        }, intl.formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).viewMore))
    })));
    const ListContent = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2F1us.List), {
        rowRenderer: renderRow,
        ref: listRef,
        // Skip rendering the view more button in the list
        rowCount: listRows.length,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $d4df94088a75cba3$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        "aria-label": (0, $23d4fc3cd3760671$export$19cacaa810ba988a)(undefined, intl).popupAriaLabel,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $d4df94088a75cba3$var$list
        ]
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6IL1T.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef
    }, isEmptyStateActive && EmptyResultView, isEmptyStateActive ? ListContent : !showMoreOptionsButton || itemsLength ? ListContent : EmptyResultView, showMoreOptionsButton && config && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $85d3d906ac0ee863$export$76421314069e32e1), {
        title: config.title,
        ariaLabel: config.ariaLabel,
        onClick: handleClick,
        isFocused: selectedIndex === itemsLength,
        iconBefore: config.iconBefore,
        lastInputMethodRef: lastInputMethodRef
    }), /*#__PURE__*/ (0, $lOiVq.jsx)($d4df94088a75cba3$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: itemsLength.toString()
    })));
});
const $d4df94088a75cba3$export$81b66b5b19964713 = (0, $kSwu1.injectIntl)($d4df94088a75cba3$var$TypeAheadListComponent);
$d4df94088a75cba3$export$81b66b5b19964713.displayName = 'TypeAheadList';


function $58ce3179fcc7cf75$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $58ce3179fcc7cf75$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $58ce3179fcc7cf75$var$VIEWMORE_BUTTON_HEIGHT = 53;
const $58ce3179fcc7cf75$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $58ce3179fcc7cf75$var$ITEM_PADDING = 12;
const $58ce3179fcc7cf75$var$typeAheadContent = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $58ce3179fcc7cf75$var$typeAheadContentOverride = /*#__PURE__*/ (0, $lOiVq.css)({
    maxHeight: `${$58ce3179fcc7cf75$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $58ce3179fcc7cf75$var$typeAheadWrapperWithViewMoreOverride = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $58ce3179fcc7cf75$var$typeAheadContentOverrideBorder = {
    name: "1ghozw",
    styles: "border-radius:var(--ds-radius-large, 8px)"
};
const $58ce3179fcc7cf75$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!triggerHandler?.getHighlight) return null;
    return triggerHandler.getHighlight(state);
};
const $58ce3179fcc7cf75$var$OFFSET = [
    0,
    8
];
const $58ce3179fcc7cf75$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, sections: sections = [], emptyItem: emptyItem, errorInfo: errorInfo, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, showMoreOptionsButton: showMoreOptionsButton } = props;
    const ref = (0, $cozmU.useRef)(null);
    const { moreElementsInQuickInsertView: moreElementsInQuickInsertView } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>({
            moreElementsInQuickInsertView: states.featureFlagsState?.moreElementsInQuickInsertView
        }));
    const moreElementsInQuickInsertViewEnabled = moreElementsInQuickInsertView && triggerHandler.id === (0, $efqK4.TypeAheadAvailableNodes).QUICK_INSERT;
    const isEditorControlsEnabled = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1');
    const defaultMenuHeight = (0, $cozmU.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $58ce3179fcc7cf75$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $58ce3179fcc7cf75$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const activityStateRef = (0, $cozmU.useRef)({
        inputMethod: null,
        closeAction: null,
        invocationMethod: (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorView.state)?.inputMethod
    });
    const startTime = (0, $cozmU.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $cozmU.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $cXtTj.default).getExperimentValue('cc_fd_db_quick_insert_options', 'isEnabled', false);
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).RENDERED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $cozmU.useState)(defaultMenuHeight);
    const fitHeightWithViewMore = (0, $cozmU.useMemo)(()=>{
        if (showMoreOptionsButton) return fitHeight - $58ce3179fcc7cf75$var$VIEWMORE_BUTTON_HEIGHT;
        return fitHeight;
    }, [
        fitHeight,
        showMoreOptionsButton
    ]);
    const getFitHeight = (0, $cozmU.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $58ce3179fcc7cf75$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $LQnOI.default)(getFitHeight);
    (0, $cozmU.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $1jz5K.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorView.state) || {};
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $9056b5b25d13b1e3$export$a5cdf6890cae94d6)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $9056b5b25d13b1e3$export$be8a8259777b339f)}"]`))) return;
            // Handles cases like emoji (:) and mention (@) typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            const innerEditor = anchorElement.closest('.extension-editable-area');
            if (innerEditor) {
                // When there is no related target, we default to not closing the popup
                let newFocusInsideCurrentEditor = !relatedTarget;
                if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                if (!isTextSelected && newFocusInsideCurrentEditor) return;
            } else {
                // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $cozmU.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorView.state) || {};
        const escape = (event)=>{
            if (event.key === 'Escape') {
                activityStateRef.current.inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD;
                cancel({
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $9056b5b25d13b1e3$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: true
                });
            }
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const onMoreOptionsClicked = (0, $cozmU.useCallback)(()=>{
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        openElementBrowserModal && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && triggerHandler.id === (0, $efqK4.TypeAheadAvailableNodes).QUICK_INSERT) activityStateRef.current = {
            inputMethod: (0, $krYZG.INPUT_METHOD).MOUSE,
            closeAction: (0, $krYZG.ACTION).VIEW_MORE,
            invocationMethod: activityStateRef.current.invocationMethod
        };
    }, [
        openElementBrowserModal,
        triggerHandler.id
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $58ce3179fcc7cf75$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onUnmount: ()=>{
            if (selectedIndex > -1 && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
                // if selectedIndex is -1, it means that the user has not selected any item
                // will be handled by WrapperTypeAhead
                (0, $e313a08cd9f207d5$export$4a6068dadc2c7771)(api, activityStateRef.current.closeAction || (0, $krYZG.ACTION).CANCELLED, !isEmptyQuery, activityStateRef.current.inputMethod || (0, $krYZG.INPUT_METHOD).MOUSE, activityStateRef.current.invocationMethod);
                // reset activity state
                activityStateRef.current = {
                    inputMethod: null,
                    closeAction: null,
                    invocationMethod: null
                };
            }
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $58ce3179fcc7cf75$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $58ce3179fcc7cf75$var$typeAheadContentOverride,
            showMoreOptionsButton && $58ce3179fcc7cf75$var$typeAheadWrapperWithViewMoreOverride,
            (0, $ieeJu.expValEquals)('cc-markdown-mode', 'isEnabled', true) && $58ce3179fcc7cf75$var$typeAheadContentOverrideBorder
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9056b5b25d13b1e3$export$a5cdf6890cae94d6),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c816d348bf365efa$export$71ea07f9d4f4ab38), null) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)($58ce3179fcc7cf75$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $d4df94088a75cba3$export$81b66b5b19964713), {
        items: items,
        isEmptyQuery: isEmptyQuery,
        sections: sections,
        emptyItem: emptyItem,
        selectedIndex: selectedIndex,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onItemClick: (mode, index, inputMethod)=>{
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) activityStateRef.current = {
                inputMethod: inputMethod || null,
                closeAction: (0, $krYZG.ACTION).INSERTED,
                invocationMethod: activityStateRef.current.invocationMethod
            };
            onItemInsert(mode, index);
        },
        fitHeight: fitHeightWithViewMore,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton,
        onMoreOptionsClicked: onMoreOptionsClicked
    }))));
});
$58ce3179fcc7cf75$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';


const $3078cdbf9f0ba6af$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, selectedIndex: selectedIndex, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, sections: sections = [], errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $e56262612162b97c$export$3a3385069392b26f)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $89435a8b382f1be8$export$9993709486a96a6b)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((mode = (0, $efqK4.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $efqK4.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    const emptyItem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $ieeJu.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) ? triggerHandler?.getEmptyItem?.({
            editorState: editorView.state
        }) : undefined, [
        triggerHandler,
        editorView.state
    ]);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || !openElementBrowserModal && items.length === 0 && !errorInfo && !emptyItem) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $58ce3179fcc7cf75$export$fbc0702507873a7d), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        sections: sections,
        emptyItem: emptyItem,
        errorInfo: errorInfo,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton
    });
});


function $5b80e4baae47985f$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { triggerHandler: triggerHandler, items: items, sections: sections, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query, selectedIndex: selectedIndex } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'typeAhead'
    ], (states)=>({
            triggerHandler: states.typeAheadState?.triggerHandler,
            items: states.typeAheadState?.items,
            sections: states.typeAheadState?.sections,
            errorInfo: states.typeAheadState?.errorInfo,
            decorationElement: states.typeAheadState?.decorationElement,
            decorationSet: states.typeAheadState?.decorationSet,
            query: states.typeAheadState?.query,
            selectedIndex: states.typeAheadState?.selectedIndex
        }));
    if (items === undefined || sections === undefined || decorationSet === undefined || errorInfo === undefined || decorationElement === undefined || query === undefined || selectedIndex === undefined) return null;
    if ((0, $e6affb8a18ac907e$export$4ac2535e78a0590b)(triggerHandler?.id)) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3078cdbf9f0ba6af$export$b11addef9209139), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            sections: sections,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        selectedIndex: selectedIndex,
        api: api
    });
}


const $0b49ac0d5936fe8a$var$createOpenAtTransaction = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        (0, $8c86625311d23646$export$e7ce737179b76875)({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })({
            tr: tr
        });
        return true;
    };
const $0b49ac0d5936fe8a$var$createOpenTypeAhead = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        $0b49ac0d5936fe8a$var$createOpenAtTransaction(props)(tr);
        view.dispatch(tr);
        return true;
    };
const $0b49ac0d5936fe8a$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $5bffb32f6167acf4$export$173ade35125a6637)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $efqK4.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $0b49ac0d5936fe8a$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $23d4fc3cd3760671$export$2bae95e359577df4)(trigger, view.state);
    };
const $0b49ac0d5936fe8a$var$createUpdateSectionTitle = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        return (0, $0cfc7cdfeccc101c$export$9edb4b0ea764e965)(props)(view.state, view.dispatch);
    };
const $0b49ac0d5936fe8a$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $23d4fc3cd3760671$export$7a55deb43cd1340e)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $609861d2c745601d$export$daba40574d0568e3)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $23d4fc3cd3760671$export$c1eba975d6442029)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $0b49ac0d5936fe8a$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $koZsE.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $4f41df2ab28ab735$export$ae829ec7b2625219)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                            api: api
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $9ffdcf9d3145cb05$export$ae829ec7b2625219)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $c0cd05a8b173e804$export$568a7ed6897c4817)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $8nvEM.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                sections: [],
                errorInfo: null,
                selectedIndex: 0
            };
            const isOpen = (0, $23d4fc3cd3760671$export$564dcc295d6ce147)(editorState);
            const state = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(editorState);
            return {
                query: (0, $23d4fc3cd3760671$export$7a55deb43cd1340e)(editorState) || '',
                currentHandler: (0, $23d4fc3cd3760671$export$c1eba975d6442029)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: state?.decorationSet ?? (0, $8nvEM.DecorationSet).empty,
                decorationElement: state?.decorationElement ?? null,
                triggerHandler: state?.triggerHandler,
                items: state?.items ?? [],
                sections: state?.sections ?? [],
                errorInfo: state?.errorInfo ?? null,
                selectedIndex: state?.selectedIndex ?? 0
            };
        },
        actions: {
            isOpen: (0, $23d4fc3cd3760671$export$564dcc295d6ce147),
            isAllowed: (0, $23d4fc3cd3760671$export$74b0f581633f8412),
            open: $0b49ac0d5936fe8a$var$createOpenTypeAhead(editorViewRef),
            openAtTransaction: $0b49ac0d5936fe8a$var$createOpenAtTransaction,
            findHandlerByTrigger: $0b49ac0d5936fe8a$var$createFindHandlerByTrigger(editorViewRef),
            insert: $0b49ac0d5936fe8a$var$createInsertTypeAheadItem(editorViewRef),
            close: $0b49ac0d5936fe8a$var$createCloseTypeAhead(editorViewRef),
            updateSectionTitle: $0b49ac0d5936fe8a$var$createUpdateSectionTitle(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5b80e4baae47985f$export$2dda1e4a1d1f6a81), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(oldEditorState);
            const newPluginState = (0, $23d4fc3cd3760671$export$f05434c51e3762e)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler?.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $8e9f417e2f7326e3$export$18d4026d1ea86bb1));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $63f5f75c33c83e19$export$630efe5940bb4d41)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler?.onOpen && isANewHandler) {
                if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                });
                newTriggerHandler.onOpen(newEditorState);
            }
            const oldIsOpen = (0, $23d4fc3cd3760671$export$564dcc295d6ce147)(oldEditorState);
            const newIsOpen = (0, $23d4fc3cd3760671$export$564dcc295d6ce147)(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $krYZG.INPUT_METHOD).QUICK_INSERT && Object.values((0, $efqK4.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) api?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).INVOKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
                    actionSubjectId: newTriggerHandler.id || 'not_set',
                    attributes: {
                        inputMethod: newPluginState.inputMethod || (0, $krYZG.INPUT_METHOD).KEYBOARD
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                }, undefined, {
                    context: {
                        selection: newEditorState.selection
                    }
                });
            } else if (oldIsOpen && !newIsOpen && (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        }
    };
};
module.exports["typeAheadPlugin"] = $0b49ac0d5936fe8a$export$a023c922ef32b883;

});

parcelRegister("gT4iv", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

var $5aU9U = parcelRequire("5aU9U");

const $3943383f56327a0d$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
var $3943383f56327a0d$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $3943383f56327a0d$export$5ca6d15deb246b5d extends (0, $5aU9U.Step) {
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $3943383f56327a0d$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $3943383f56327a0d$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = void 0;
        this.selectedIndex = void 0;
        this.stage = void 0;
        this.query = void 0;
        this.trigger = void 0;
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
}
/** Register this step with Prosemirror */ (0, $5aU9U.Step).jsonID($3943383f56327a0d$export$2f0b0962a5993fe0, $3943383f56327a0d$export$5ca6d15deb246b5d);
module.exports["InsertTypeAheadStages"] = $3943383f56327a0d$export$1b2be0bed116d664;
module.exports["InsertTypeAheadStep"] = $3943383f56327a0d$export$5ca6d15deb246b5d;

});

parcelRegister("lnOAf", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $55fM8 = parcelRequire("55fM8");

function $42d7029df7117d9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $42d7029df7117d9b$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
const $42d7029df7117d9b$export$568f929105953699 = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: _statusDebounceMillis = 1400 })=>{
    const [bump, setBump] = (0, $cozmU.useState)(false);
    const [debounced, setDebounced] = (0, $cozmU.useState)(false);
    const [silenced, setSilenced] = (0, $cozmU.useState)(false);
    const debounceStatusUpdate = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            const shouldSilence = !isInFocus;
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(shouldSilence);
        }), [
        isInFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!debounced) {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            debounceStatusUpdate();
            return ()=>{
                debounceStatusUpdate.cancel();
            };
        }
    }, [
        assistiveText,
        isInFocus,
        debounced,
        debounceStatusUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (debounced) {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setBump((prevBump)=>!prevBump);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setDebounced(true);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setSilenced(!isInFocus);
        }
    }, [
        assistiveText,
        isInFocus,
        debounced
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $42d7029df7117d9b$var$assitiveTextStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && bump ? assistiveText : ''), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && !bump ? assistiveText : ''));
};
module.exports["AssistiveText"] = $42d7029df7117d9b$export$568f929105953699;

});

parcelRegister("kejMu", function(module, exports) {
const $166e831ed2e10f58$export$b5d6a35b0cce4297 = (props)=>props.children ?? null;
const $166e831ed2e10f58$export$c3213ee7169ceb28 = (components, surface)=>{
    return components.find((c)=>c.key === surface.key && c.type === surface.type && (!c.parents || c.parents.length === 0));
};
const $166e831ed2e10f58$export$93e686d60d327014 = (components)=>{
    const childrenMap = new Map();
    for (const component of components){
        if (component.parents && component.parents.length > 0) for (const parent of component.parents){
            const existing = childrenMap.get(parent.key) || [];
            existing.push(component);
            childrenMap.set(parent.key, existing);
        }
    }
    for (const [parentKey, children] of childrenMap.entries())children.sort((a, b)=>{
        const rankA = a.parents?.find((p)=>p.key === parentKey)?.rank ?? 0;
        const rankB = b.parents?.find((p)=>p.key === parentKey)?.rank ?? 0;
        return rankA - rankB;
    });
    return childrenMap;
};
const $166e831ed2e10f58$export$fe6905bc20e8faef = (components, surface)=>{
    const root = $166e831ed2e10f58$export$c3213ee7169ceb28(components, surface);
    const childrenMap = $166e831ed2e10f58$export$93e686d60d327014(components);
    return {
        root: root,
        childrenMap: childrenMap,
        topLevelChildren: root ? childrenMap.get(root.key) : undefined
    };
};
const $166e831ed2e10f58$export$51a8f8a5d7877637 = (component, childrenMap)=>{
    if (component.isHidden?.()) return false;
    const children = childrenMap.get(component.key);
    if (!children || children.length === 0) return true;
    return children.some((child)=>$166e831ed2e10f58$export$51a8f8a5d7877637(child, childrenMap));
};
module.exports["PassThrough"] = $166e831ed2e10f58$export$b5d6a35b0cce4297;
module.exports["findSurface"] = $166e831ed2e10f58$export$c3213ee7169ceb28;
module.exports["buildChildrenMap"] = $166e831ed2e10f58$export$93e686d60d327014;
module.exports["resolveSurface"] = $166e831ed2e10f58$export$fe6905bc20e8faef;
module.exports["willComponentRender"] = $166e831ed2e10f58$export$51a8f8a5d7877637;

});

parcelRegister("4BAKK", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");


var $cdkbZ = parcelRequire("cdkbZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $35a72085b17506fa$var$_extends2 = $5r8BJ((parcelRequire("5em8g")));

var $35a72085b17506fa$var$_classCallCheck2 = $5r8BJ((parcelRequire("8s6Tr")));

var $35a72085b17506fa$var$_createClass2 = $5r8BJ((parcelRequire("hTncH")));

var $35a72085b17506fa$var$_possibleConstructorReturn2 = $5r8BJ((parcelRequire("9U8xV")));

var $35a72085b17506fa$var$_getPrototypeOf2 = $5r8BJ((parcelRequire("deVUU")));

var $35a72085b17506fa$var$_inherits2 = $5r8BJ((parcelRequire("j3nAe")));

var $35a72085b17506fa$var$_defineProperty2 = $5r8BJ((parcelRequire("hDDkw")));

var $35a72085b17506fa$var$_Grid = $35a72085b17506fa$var$_interopRequireWildcard((parcelRequire("S9RNu")));

var $35a72085b17506fa$var$React = $35a72085b17506fa$var$_interopRequireWildcard((parcelRequire("cozmU")));

var $35a72085b17506fa$var$_clsx = $5r8BJ((parcelRequire("5wPlS")));
function $35a72085b17506fa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($35a72085b17506fa$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $35a72085b17506fa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $cdkbZ(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $35a72085b17506fa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $35a72085b17506fa$var$_callSuper(t, o, e) {
    return o = (0, $35a72085b17506fa$var$_getPrototypeOf2["default"])(o), (0, $35a72085b17506fa$var$_possibleConstructorReturn2["default"])(t, $35a72085b17506fa$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $35a72085b17506fa$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $35a72085b17506fa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($35a72085b17506fa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  NoContentRenderer,
  Alignment,
  CellSize,
  CellPosition,
  OverscanIndicesGetter,
  RenderedSection,
  CellRendererParams,
  Scroll as GridScroll,
} from '../Grid';*/ 
/*:: import type {RowRenderer, RenderedRows, Scroll} from './types';*/ /**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ /*:: type Props = {
  'aria-label'?: string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /** Optional CSS class name *-/
  className?: string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Height constraint for list (determines how many actual rows are rendered) *-/
  height: number,

  /** Optional renderer to be used in place of rows when rowCount is 0 *-/
  noRowsRenderer: NoContentRenderer,

  /** Callback invoked with information about the slice of rows that were just rendered.  *-/

  onRowsRendered: (params: RenderedRows) => void,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /** See Grid#overscanIndicesGetter *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   *-/
  overscanRowCount: number,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  *-/
  rowHeight: CellSize,

  /** Responsible for rendering a row given an index; ({ index: number }): node *-/
  rowRenderer: RowRenderer,

  /** Number of rows in list. *-/
  rowCount: number,

  /** See Grid#scrollToAlignment *-/
  scrollToAlignment: Alignment,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToIndex: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex?: number,

  /** Width of list *-/
  width: number,
};*/ var $35a72085b17506fa$var$List = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function List() {
        var _this;
        (0, $35a72085b17506fa$var$_classCallCheck2["default"])(this, List);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $35a72085b17506fa$var$_callSuper(this, List, [].concat(args));
        (0, $35a72085b17506fa$var$_defineProperty2["default"])(_this, "Grid", void 0);
        (0, $35a72085b17506fa$var$_defineProperty2["default"])(_this, "_cellRenderer", function(_ref /*:: */ ) {
            var parent = _ref /*:: */ .parent, rowIndex = _ref /*:: */ .rowIndex, style = _ref /*:: */ .style, isScrolling = _ref /*:: */ .isScrolling, isVisible = _ref /*:: */ .isVisible, key = _ref /*:: */ .key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
            if (widthDescriptor && widthDescriptor.writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        });
        (0, $35a72085b17506fa$var$_defineProperty2["default"])(_this, "_setRef", function(ref /*: ?React.ElementRef<typeof Grid>*/ ) {
            _this.Grid = ref;
        });
        (0, $35a72085b17506fa$var$_defineProperty2["default"])(_this, "_onScroll", function(_ref2 /*:: */ ) {
            var clientHeight = _ref2 /*:: */ .clientHeight, scrollHeight = _ref2 /*:: */ .scrollHeight, scrollTop = _ref2 /*:: */ .scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        });
        (0, $35a72085b17506fa$var$_defineProperty2["default"])(_this, "_onSectionRendered", function(_ref3 /*:: */ ) {
            var rowOverscanStartIndex = _ref3 /*:: */ .rowOverscanStartIndex, rowOverscanStopIndex = _ref3 /*:: */ .rowOverscanStopIndex, rowStartIndex = _ref3 /*:: */ .rowStartIndex, rowStopIndex = _ref3 /*:: */ .rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        });
        return _this;
    }
    (0, $35a72085b17506fa$var$_inherits2["default"])(List, _React$PureComponent);
    return (0, $35a72085b17506fa$var$_createClass2["default"])(List, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref4 /*:: */ ) {
                var alignment = _ref4 /*:: */ .alignment, index = _ref4 /*:: */ .index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref6$columnIndex = _ref6.columnIndex, columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex, _ref6$rowIndex = _ref6.rowIndex, rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, noRowsRenderer = _this$props.noRowsRenderer, scrollToIndex = _this$props.scrollToIndex, width = _this$props.width;
                var classNames = (0, $35a72085b17506fa$var$_clsx["default"])('ReactVirtualized__List', className);
                return /*#__PURE__*/ $35a72085b17506fa$var$React.createElement($35a72085b17506fa$var$_Grid["default"], (0, $35a72085b17506fa$var$_extends2["default"])({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
}($35a72085b17506fa$var$React.PureComponent);
(0, $35a72085b17506fa$var$_defineProperty2["default"])($35a72085b17506fa$var$List, "defaultProps", {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $35a72085b17506fa$var$_Grid.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});

});

parcelRegister("S9RNu", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function get() {
        return $0a2cb294b118961c$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "accessibilityOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $0a2cb294b118961c$var$_accessibilityOverscanIndicesGetter["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $0a2cb294b118961c$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "defaultCellRangeRenderer", {
    enumerable: true,
    get: function get() {
        return $0a2cb294b118961c$var$_defaultCellRangeRenderer["default"];
    }
});
Object.defineProperty(module.exports, "defaultOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $0a2cb294b118961c$var$_defaultOverscanIndicesGetter["default"];
    }
});

var $0a2cb294b118961c$var$_Grid = $5r8BJ((parcelRequire("6t5lB")));

var $0a2cb294b118961c$var$_accessibilityOverscanIndicesGetter = $5r8BJ((parcelRequire("6NKcv")));

var $0a2cb294b118961c$var$_defaultCellRangeRenderer = $5r8BJ((parcelRequire("1AO8l")));

var $0a2cb294b118961c$var$_defaultOverscanIndicesGetter = $5r8BJ((parcelRequire("bEUU3")));

});

parcelRegister("6t5lB", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");


Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var $4b59996a66008e92$var$_extends2 = $5r8BJ((parcelRequire("5em8g")));

var $4b59996a66008e92$var$_typeof2 = $5r8BJ((parcelRequire("cdkbZ")));

var $4b59996a66008e92$var$_classCallCheck2 = $5r8BJ((parcelRequire("8s6Tr")));

var $4b59996a66008e92$var$_createClass2 = $5r8BJ((parcelRequire("hTncH")));

var $4b59996a66008e92$var$_possibleConstructorReturn2 = $5r8BJ((parcelRequire("9U8xV")));

var $4b59996a66008e92$var$_getPrototypeOf2 = $5r8BJ((parcelRequire("deVUU")));

var $4b59996a66008e92$var$_inherits2 = $5r8BJ((parcelRequire("j3nAe")));

var $4b59996a66008e92$var$_defineProperty2 = $5r8BJ((parcelRequire("hDDkw")));

var $4b59996a66008e92$var$React = $4b59996a66008e92$var$_interopRequireWildcard((parcelRequire("cozmU")));

var $4b59996a66008e92$var$_clsx = $5r8BJ((parcelRequire("5wPlS")));

var $4b59996a66008e92$var$_calculateSizeAndPositionDataAndUpdateScrollOffset = $5r8BJ((parcelRequire("lEOdL")));

var $4b59996a66008e92$var$_ScalingCellSizeAndPositionManager = $5r8BJ((parcelRequire("iXyJg")));

var $4b59996a66008e92$var$_createCallbackMemoizer = $5r8BJ((parcelRequire("mQ81s")));

var $4b59996a66008e92$var$_defaultOverscanIndicesGetter = $4b59996a66008e92$var$_interopRequireWildcard((parcelRequire("bEUU3")));

var $4b59996a66008e92$var$_updateScrollIndexHelper = $5r8BJ((parcelRequire("cbgXM")));

var $4b59996a66008e92$var$_defaultCellRangeRenderer = $5r8BJ((parcelRequire("1AO8l")));

var $4b59996a66008e92$var$_scrollbarSize = $5r8BJ((parcelRequire("8i7gn")));

var $hGZJg = parcelRequire("hGZJg");


var $6XFzX = parcelRequire("6XFzX");

function $4b59996a66008e92$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4b59996a66008e92$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4b59996a66008e92$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (parcelRequire("cdkbZ"))(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $4b59996a66008e92$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4b59996a66008e92$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b59996a66008e92$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b59996a66008e92$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4b59996a66008e92$var$_defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b59996a66008e92$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4b59996a66008e92$var$_callSuper(t, o, e) {
    return o = (0, $4b59996a66008e92$var$_getPrototypeOf2["default"])(o), (0, $4b59996a66008e92$var$_possibleConstructorReturn2["default"])(t, $4b59996a66008e92$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4b59996a66008e92$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $4b59996a66008e92$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4b59996a66008e92$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  CellRenderer,
  CellRangeRenderer,
  CellPosition,
  CellSize,
  CellSizeGetter,
  NoContentRenderer,
  Scroll,
  ScrollbarPresenceChange,
  RenderedSection,
  OverscanIndicesGetter,
  Alignment,
  CellCache,
  StyleCache,
} from './types';*/ 
/*:: import type {AnimationTimeoutId} from '../utils/requestAnimationTimeout';*/ /**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $4b59996a66008e92$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $4b59996a66008e92$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $4b59996a66008e92$var$renderNull /*: NoContentRenderer*/  = function renderNull() {
    return null;
};
/*:: type ScrollPosition = {
  scrollTop?: number,
  scrollLeft?: number,
};*/ /*:: type Props = {
  'aria-label': string,
  'aria-readonly'?: boolean,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   *-/
  autoContainerWidth: boolean,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoWidth: boolean,

  /** Responsible for rendering a cell given an row and column index.  *-/
  cellRenderer: CellRenderer,

  /** Responsible for rendering a group of cells given their index ranges.  *-/
  cellRangeRenderer: CellRangeRenderer,

  /** Optional custom CSS class name to attach to root Grid element.  *-/
  className?: string,

  /** Number of columns in grid.  *-/
  columnCount: number,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  *-/
  columnWidth: CellSize,

  /** Unfiltered props for the Grid container. *-/
  containerProps?: Object,

  /** ARIA role for the cell-container.  *-/
  containerRole: string,

  /** Optional inline style applied to inner cell-container *-/
  containerStyle: Object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   *-/
  deferredMeasurementCache?: Object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   *-/
  estimatedColumnSize: number,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Exposed for testing purposes only.  *-/
  getScrollbarSize: () => number,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  *-/
  height: number,

  /** Optional custom id to attach to root Grid element.  *-/
  id?: string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   *-/
  isScrolling?: boolean,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   *-/
  isScrollingOptOut: boolean,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  *-/
  noContentRenderer: NoContentRenderer,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   *-/
  onScrollbarPresenceChange: (params: ScrollbarPresenceChange) => void,

  /** Callback invoked with information about the section of the Grid that was just rendered.  *-/
  onSectionRendered: (params: RenderedSection) => void,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanColumnCount: number,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanRowCount: number,

  /** ARIA role for the grid element.  *-/
  role: string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   *-/
  rowHeight: CellSize,

  /** Number of rows in grid.  *-/
  rowCount: number,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. *-/
  scrollingResetTimeInterval: number,

  /** Horizontal offset. *-/
  scrollLeft?: number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   *-/
  scrollToAlignment: Alignment,

  /** Column index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToColumn: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToRow: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex: ?number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  *-/
  width: number,

  /** Reference to DOM node *-/
  elementRef?: React.Ref<React.ElementType>,
};*/ /*:: type InstanceProps = {
  prevColumnWidth: CellSize,
  prevRowHeight: CellSize,

  prevColumnCount: number,
  prevRowCount: number,
  prevIsScrolling: boolean,
  prevScrollToColumn: number,
  prevScrollToRow: number,

  columnSizeAndPositionManager: ScalingCellSizeAndPositionManager,
  rowSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  scrollbarSize: number,
  scrollbarSizeMeasured: boolean,
};*/ /*:: type State = {
  instanceProps: InstanceProps,
  isScrolling: boolean,
  scrollDirectionHorizontal: -1 | 1,
  scrollDirectionVertical: -1 | 1,
  scrollLeft: number,
  scrollTop: number,
  scrollPositionChangeReason: 'observed' | 'requested' | null,
  needToResetStyleCache: boolean,
};*/ /**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $4b59996a66008e92$var$Grid = /*#__PURE__*/ function(_React$PureComponent) {
    function Grid(props /*: Props*/ ) {
        var _this;
        (0, $4b59996a66008e92$var$_classCallCheck2["default"])(this, Grid);
        _this = $4b59996a66008e92$var$_callSuper(this, Grid, [
            props
        ]);
        // Invokes onSectionRendered callback only when start/stop row or column indices change
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_onGridRenderedMemoizer", (0, $4b59996a66008e92$var$_createCallbackMemoizer["default"])());
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_onScrollMemoizer", (0, $4b59996a66008e92$var$_createCallbackMemoizer["default"])(false));
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_deferredInvalidateColumnIndex", null);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_deferredInvalidateRowIndex", null);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_recomputeScrollLeftFlag", false);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_recomputeScrollTopFlag", false);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_horizontalScrollBarSize", 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_verticalScrollBarSize", 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_scrollbarPresenceChanged", false);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_scrollingContainer", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_childrenToDisplay", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_columnStartIndex", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_columnStopIndex", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_rowStartIndex", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_rowStopIndex", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_renderedColumnStartIndex", 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_renderedColumnStopIndex", 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_renderedRowStartIndex", 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_renderedRowStopIndex", 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_initialScrollTop", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_initialScrollLeft", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_disablePointerEventsTimeoutId", void 0);
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_styleCache", {});
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_cellCache", {});
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_debounceScrollEndedCallback", function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        });
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_invokeOnGridRenderedHelper", function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        });
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_setScrollingContainerRef", function(ref /*: Element*/ ) {
            _this._scrollingContainer = ref;
            if (typeof _this.props.elementRef === 'function') _this.props.elementRef(ref);
            else if ((0, $4b59996a66008e92$var$_typeof2["default"])(_this.props.elementRef) === 'object') _this.props.elementRef.current = ref;
        });
        (0, $4b59996a66008e92$var$_defineProperty2["default"])(_this, "_onScroll", function(event /*: Event*/ ) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target /*: any*/ );
        });
        var columnSizeAndPositionManager = new $4b59996a66008e92$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $4b59996a66008e92$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $4b59996a66008e92$var$_inherits2["default"])(Grid, _React$PureComponent);
    return (0, $4b59996a66008e92$var$_createClass2["default"])(Grid, [
        {
            key: "getOffsetForCell",
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = $4b59996a66008e92$var$_objectSpread($4b59996a66008e92$var$_objectSpread({}, this.props), {}, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: "getTotalRowsHeight",
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "getTotalColumnsWidth",
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "handleScrollEvent",
            value: function handleScrollEvent(_ref2 /*:: */ ) {
                var _ref2$scrollLeft = _ref2 /*:: */ .scrollLeft, scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2 /*:: */ .scrollTop, scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _this$props = this.props, autoHeight = _this$props.autoHeight, autoWidth = _this$props.autoWidth, height = _this$props.height, width = _this$props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState /*: $Shape<State>*/  = {
                        isScrolling: true,
                        scrollDirectionHorizontal: scrollDirectionHorizontal,
                        scrollDirectionVertical: scrollDirectionVertical,
                        scrollPositionChangeReason: $4b59996a66008e92$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref3 /*:: */ ) {
                var columnIndex = _ref3 /*:: */ .columnIndex, rowIndex = _ref3 /*:: */ .rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                var _this$props2 = this.props, columnCount = _this$props2.columnCount, rowCount = _this$props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
                var _this$props3 = this.props, scrollToColumn = _this$props3.scrollToColumn, scrollToRow = _this$props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: "scrollToCell",
            value: function scrollToCell(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn($4b59996a66008e92$var$_objectSpread($4b59996a66008e92$var$_objectSpread({}, props), {}, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow($4b59996a66008e92$var$_objectSpread($4b59996a66008e92$var$_objectSpread({}, props), {}, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, getScrollbarSize = _this$props4.getScrollbarSize, height = _this$props4.height, scrollLeft = _this$props4.scrollLeft, scrollToColumn = _this$props4.scrollToColumn, scrollTop = _this$props4.scrollTop, scrollToRow = _this$props4.scrollToRow, width = _this$props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = $4b59996a66008e92$var$_objectSpread($4b59996a66008e92$var$_objectSpread({}, prevState), {}, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
                var _this2 = this;
                var _this$props5 = this.props, autoHeight = _this$props5.autoHeight, autoWidth = _this$props5.autoWidth, columnCount = _this$props5.columnCount, height = _this$props5.height, rowCount = _this$props5.rowCount, scrollToAlignment = _this$props5.scrollToAlignment, scrollToColumn = _this$props5.scrollToColumn, scrollToRow = _this$props5.scrollToRow, width = _this$props5.width;
                var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollPositionChangeReason = _this$state.scrollPositionChangeReason, scrollTop = _this$state.scrollTop, instanceProps = _this$state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $4b59996a66008e92$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $4b59996a66008e92$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $4b59996a66008e92$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $6XFzX.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoContainerWidth = _this$props6.autoContainerWidth, autoHeight = _this$props6.autoHeight, autoWidth = _this$props6.autoWidth, className = _this$props6.className, containerProps = _this$props6.containerProps, containerRole = _this$props6.containerRole, containerStyle = _this$props6.containerStyle, height = _this$props6.height, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, role = _this$props6.role, style = _this$props6.style, tabIndex = _this$props6.tabIndex, width = _this$props6.width;
                var _this$state2 = this.state, instanceProps = _this$state2.instanceProps, needToResetStyleCache = _this$state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle /*: Object*/  = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return /*#__PURE__*/ $4b59996a66008e92$var$React.createElement("div", (0, $4b59996a66008e92$var$_extends2["default"])({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    "aria-label": this.props['aria-label'],
                    "aria-readonly": this.props['aria-readonly'],
                    className: (0, $4b59996a66008e92$var$_clsx["default"])('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $4b59996a66008e92$var$_objectSpread($4b59996a66008e92$var$_objectSpread({}, gridStyle), style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && /*#__PURE__*/ $4b59996a66008e92$var$React.createElement("div", {
                    className: "ReactVirtualized__Grid__innerScrollContainer",
                    role: containerRole,
                    style: $4b59996a66008e92$var$_objectSpread({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: "_calculateChildrenToRender",
            value: function _calculateChildrenToRender() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: "_debounceScrollEnded",
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $6XFzX.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $6XFzX.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            value: /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref6 /*:: */ ) {
                var _this3 = this;
                var scrollLeft = _ref6 /*:: */ .scrollLeft, scrollTop = _ref6 /*:: */ .scrollTop, totalColumnsWidth = _ref6 /*:: */ .totalColumnsWidth, totalRowsHeight = _ref6 /*:: */ .totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_isScrolling",
            value: function _isScrolling() /*: boolean*/ {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: "_maybeCallOnScrollbarPresenceChange",
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: "scrollToPosition",
            value: /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ function scrollToPosition(_ref8 /*:: */ ) {
                var scrollLeft = _ref8 /*:: */ .scrollLeft, scrollTop = _ref8 /*:: */ .scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: "_updateScrollLeftForScrollToColumn",
            value: function _updateScrollLeftForScrollToColumn() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: "_resetStyleCache",
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = "".concat(rowIndex, "-").concat(columnIndex);
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: "_updateScrollTopForScrollToRow",
            value: function _updateScrollTopForScrollToRow() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) Object.assign(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) Object.assign(newState, {
                    isScrolling: false
                });
                var maybeStateA;
                var maybeStateB;
                (0, $4b59996a66008e92$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $4b59996a66008e92$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return $4b59996a66008e92$var$_objectSpread($4b59996a66008e92$var$_objectSpread($4b59996a66008e92$var$_objectSpread({}, newState), maybeStateA), maybeStateB);
            }
        },
        {
            key: "_getEstimatedColumnSize",
            value: function _getEstimatedColumnSize(props /*: Props*/ ) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: "_getEstimatedRowSize",
            value: function _getEstimatedRowSize(props /*: Props*/ ) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: "_getScrollToPositionStateUpdate",
            value: /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ function _getScrollToPositionStateUpdate(_ref9 /*:: */ ) /*: $Shape<State>*/ {
                var prevState = _ref9 /*:: */ .prevState, scrollLeft = _ref9 /*:: */ .scrollLeft, scrollTop = _ref9 /*:: */ .scrollTop;
                var newState /*: Object*/  = {
                    scrollPositionChangeReason: $4b59996a66008e92$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $4b59996a66008e92$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return {};
            }
        },
        {
            key: "_wrapSizeGetter",
            value: function _wrapSizeGetter(value /*: CellSize*/ ) /*: CellSizeGetter*/ {
                return typeof value === 'function' ? value : function() {
                    return value /*: any*/ ;
                };
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollLeftForScrollToColumnStateUpdate",
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return {};
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollTopForScrollToRowStateUpdate",
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return {};
            }
        }
    ]);
}($4b59996a66008e92$var$React.PureComponent);
(0, $4b59996a66008e92$var$_defineProperty2["default"])($4b59996a66008e92$var$Grid, "defaultProps", {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $4b59996a66008e92$var$_defaultCellRangeRenderer["default"],
    containerRole: 'row',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $4b59996a66008e92$var$_scrollbarSize["default"],
    noContentRenderer: $4b59996a66008e92$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $4b59996a66008e92$var$_defaultOverscanIndicesGetter["default"],
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $4b59996a66008e92$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
});
(0, $hGZJg.polyfill)($4b59996a66008e92$var$Grid);
var $4b59996a66008e92$var$_default = module.exports["default"] = $4b59996a66008e92$var$Grid;

});

parcelRegister("lEOdL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $fc444a3ef1134251$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 */ /*:: type Params<T> = {
  // Number of rows or columns in the current axis
  cellCount: number,

  // Width or height of cells for the current axis
  cellSize: ?number,

  // Method to invoke if cell metadata should be recalculated
  computeMetadataCallback: (props: T) => void,

  // Parameters to pass to :computeMetadataCallback
  computeMetadataCallbackProps: T,

  // Newly updated number of rows or columns in the current axis
  nextCellsCount: number,

  // Newly updated width or height of cells for the current axis
  nextCellSize: ?number,

  // Newly updated scroll-to-index
  nextScrollToIndex: number,

  // Scroll-to-index
  scrollToIndex: number,

  // Callback to invoke if the scroll position should be recalculated
  updateScrollOffsetForScrollToIndex: () => void,
};*/ function $fc444a3ef1134251$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref /*:: */ ) {
    var cellCount = _ref /*:: */ .cellCount, cellSize = _ref /*:: */ .cellSize, computeMetadataCallback = _ref /*:: */ .computeMetadataCallback, computeMetadataCallbackProps = _ref /*:: */ .computeMetadataCallbackProps, nextCellsCount = _ref /*:: */ .nextCellsCount, nextCellSize = _ref /*:: */ .nextCellSize, nextScrollToIndex = _ref /*:: */ .nextScrollToIndex, scrollToIndex = _ref /*:: */ .scrollToIndex, updateScrollOffsetForScrollToIndex = _ref /*:: */ .updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
}

});

parcelRegister("iXyJg", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dcd8ad2ab83b851c$var$_objectWithoutProperties2 = $5r8BJ((parcelRequire("inpzg")));

var $dcd8ad2ab83b851c$var$_classCallCheck2 = $5r8BJ((parcelRequire("8s6Tr")));

var $dcd8ad2ab83b851c$var$_createClass2 = $5r8BJ((parcelRequire("hTncH")));

var $dcd8ad2ab83b851c$var$_defineProperty2 = $5r8BJ((parcelRequire("hDDkw")));

var $dcd8ad2ab83b851c$var$_CellSizeAndPositionManager = $5r8BJ((parcelRequire("i9HSy")));

var $kaABV = parcelRequire("kaABV");

var $dcd8ad2ab83b851c$var$_excluded = [
    "maxScrollSize"
];
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type ContainerSizeAndOffset = {
  containerSize: number,
  offset: number,
};*/ /*:: type Params = {
  maxScrollSize?: number,
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ /**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ var $dcd8ad2ab83b851c$var$ScalingCellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function ScalingCellSizeAndPositionManager(_ref /*:: */ ) {
        var _ref$maxScrollSize = _ref /*:: */ .maxScrollSize, maxScrollSize = _ref$maxScrollSize === void 0 ? (0, $kaABV.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $dcd8ad2ab83b851c$var$_objectWithoutProperties2["default"])(_ref /*:: */ , $dcd8ad2ab83b851c$var$_excluded);
        (0, $dcd8ad2ab83b851c$var$_classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
        (0, $dcd8ad2ab83b851c$var$_defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
        (0, $dcd8ad2ab83b851c$var$_defineProperty2["default"])(this, "_maxScrollSize", void 0);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $dcd8ad2ab83b851c$var$_CellSizeAndPositionManager["default"](params);
        this._maxScrollSize = maxScrollSize;
    }
    return (0, $dcd8ad2ab83b851c$var$_createClass2["default"])(ScalingCellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() /*: boolean*/ {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: "configure",
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment(_ref2 /*:: */ ) /*: number*/ {
                var containerSize = _ref2 /*:: */ .containerSize, offset = _ref2 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(_ref4 /*:: */ ) /*: VisibleCellRange*/ {
                var containerSize = _ref4 /*:: */ .containerSize, offset = _ref4 /*:: */ .offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: "_getOffsetPercentage",
            value: function _getOffsetPercentage(_ref5 /*:: */ ) {
                var containerSize = _ref5 /*:: */ .containerSize, offset = _ref5 /*:: */ .offset, totalSize = _ref5 /*:: */ .totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: "_offsetToSafeOffset",
            value: function _offsetToSafeOffset(_ref6 /*:: */ ) /*: number*/ {
                var containerSize = _ref6 /*:: */ .containerSize, offset = _ref6 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: "_safeOffsetToOffset",
            value: function _safeOffsetToOffset(_ref7 /*:: */ ) /*: number*/ {
                var containerSize = _ref7 /*:: */ .containerSize, offset = _ref7 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
}();

});

parcelRegister("inpzg", function(module, exports) {

var $6FDAx = parcelRequire("6FDAx");

function $d60e3538cda699e3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6FDAx(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $d60e3538cda699e3$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i9HSy", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d37b1ab0c30d555a$var$_classCallCheck2 = $5r8BJ((parcelRequire("8s6Tr")));

var $d37b1ab0c30d555a$var$_createClass2 = $5r8BJ((parcelRequire("hTncH")));

var $d37b1ab0c30d555a$var$_defineProperty2 = $5r8BJ((parcelRequire("hDDkw")));
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type CellSizeAndPositionManagerParams = {
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /*:: type ConfigureParams = {
  cellCount: number,
  estimatedCellSize: number,
  cellSizeGetter: CellSizeGetter,
};*/ /*:: type GetUpdatedOffsetForIndex = {
  align: Alignment,
  containerSize: number,
  currentOffset: number,
  targetIndex: number,
};*/ /*:: type GetVisibleCellRangeParams = {
  containerSize: number,
  offset: number,
};*/ /*:: type SizeAndPositionData = {
  offset: number,
  size: number,
};*/ /**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $d37b1ab0c30d555a$var$CellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function CellSizeAndPositionManager(_ref /*:: */ ) {
        var cellCount = _ref /*:: */ .cellCount, cellSizeGetter = _ref /*:: */ .cellSizeGetter, estimatedCellSize = _ref /*:: */ .estimatedCellSize;
        (0, $d37b1ab0c30d555a$var$_classCallCheck2["default"])(this, CellSizeAndPositionManager);
        // Cache of size and position data for cells, mapped by cell index.
        // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
        (0, $d37b1ab0c30d555a$var$_defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
        // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
        (0, $d37b1ab0c30d555a$var$_defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
        // Used in deferred mode to track which cells have been queued for measurement.
        (0, $d37b1ab0c30d555a$var$_defineProperty2["default"])(this, "_lastBatchedIndex", -1);
        (0, $d37b1ab0c30d555a$var$_defineProperty2["default"])(this, "_cellCount", void 0);
        (0, $d37b1ab0c30d555a$var$_defineProperty2["default"])(this, "_cellSizeGetter", void 0);
        (0, $d37b1ab0c30d555a$var$_defineProperty2["default"])(this, "_estimatedCellSize", void 0);
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    return (0, $d37b1ab0c30d555a$var$_createClass2["default"])(CellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: "configure",
            value: function configure(_ref2 /*:: */ ) {
                var cellCount = _ref2 /*:: */ .cellCount, estimatedCellSize = _ref2 /*:: */ .estimatedCellSize, cellSizeGetter = _ref2 /*:: */ .cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellCount;
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._estimatedCellSize;
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) /*: SizeAndPositionData*/ {
                if (index < 0 || index >= this._cellCount) throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (size === undefined || isNaN(size)) throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
                        else if (size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: size
                            };
                            offset += size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() /*: SizeAndPositionData*/ {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) /*: number*/ {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(params /*: GetVisibleCellRangeParams*/ ) /*: VisibleCellRange*/ {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: "_binarySearch",
            value: function _binarySearch(high /*: number*/ , low /*: number*/ , offset /*: number*/ ) /*: number*/ {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (currentOffset === offset) return middle;
                    else if (currentOffset < offset) low = middle + 1;
                    else if (currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: "_exponentialSearch",
            value: function _exponentialSearch(index /*: number*/ , offset /*: number*/ ) /*: number*/ {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: "_findNearestCell",
            value: function _findNearestCell(offset /*: number*/ ) /*: number*/ {
                if (isNaN(offset)) throw Error("Invalid offset ".concat(offset, " specified"));
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
}();

});

parcelRegister("mQ81s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $044a7dcd5173f5b6$var$createCallbackMemoizer;
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $044a7dcd5173f5b6$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = Object.keys(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});

parcelRegister("bEUU3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $87cf91ea32d630cd$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $87cf91ea32d630cd$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $87cf91ea32d630cd$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $87cf91ea32d630cd$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $87cf91ea32d630cd$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $87cf91ea32d630cd$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    if (scrollDirection === $87cf91ea32d630cd$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("cbgXM", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8de3aba0bb8a2c28$var$updateScrollIndexHelper;

var $8de3aba0bb8a2c28$var$_ScalingCellSizeAndPositionManager = $5r8BJ((parcelRequire("iXyJg")));
/*:: import type {Alignment, CellSize} from '../types';*/ /**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ /*:: type Params = {
  // Width or height of cells for the current axis
  cellSize?: CellSize,

  // Manages size and position metadata of cells
  cellSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  // Previous number of rows or columns
  previousCellsCount: number,

  // Previous width or height of cells
  previousCellSize: CellSize,

  previousScrollToAlignment: Alignment,

  // Previous scroll-to-index
  previousScrollToIndex: number,

  // Previous width or height of the virtualized container
  previousSize: number,

  // Current scrollLeft or scrollTop
  scrollOffset: number,

  scrollToAlignment: Alignment,

  // Scroll-to-index
  scrollToIndex: number,

  // Width or height of the virtualized container
  size: number,

  sizeJustIncreasedFromZero: boolean,

  // Callback to invoke with an scroll-to-index value
  updateScrollIndexCallback: (index: number) => void,
};*/ function $8de3aba0bb8a2c28$var$updateScrollIndexHelper(_ref /*:: */ ) {
    var cellSize = _ref /*:: */ .cellSize, cellSizeAndPositionManager = _ref /*:: */ .cellSizeAndPositionManager, previousCellsCount = _ref /*:: */ .previousCellsCount, previousCellSize = _ref /*:: */ .previousCellSize, previousScrollToAlignment = _ref /*:: */ .previousScrollToAlignment, previousScrollToIndex = _ref /*:: */ .previousScrollToIndex, previousSize = _ref /*:: */ .previousSize, scrollOffset = _ref /*:: */ .scrollOffset, scrollToAlignment = _ref /*:: */ .scrollToAlignment, scrollToIndex = _ref /*:: */ .scrollToIndex, size = _ref /*:: */ .size, sizeJustIncreasedFromZero = _ref /*:: */ .sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref /*:: */ .updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("1AO8l", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $12900abfb3ab8dfa$var$defaultCellRangeRenderer;

var $12900abfb3ab8dfa$var$_react = $5r8BJ((parcelRequire("cozmU")));
/*:: import type {CellRangeRendererParams} from './types';*/ /**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $12900abfb3ab8dfa$var$defaultCellRangeRenderer(_ref /*:: */ ) {
    var cellCache = _ref /*:: */ .cellCache, cellRenderer = _ref /*:: */ .cellRenderer, columnSizeAndPositionManager = _ref /*:: */ .columnSizeAndPositionManager, columnStartIndex = _ref /*:: */ .columnStartIndex, columnStopIndex = _ref /*:: */ .columnStopIndex, deferredMeasurementCache = _ref /*:: */ .deferredMeasurementCache, horizontalOffsetAdjustment = _ref /*:: */ .horizontalOffsetAdjustment, isScrolling = _ref /*:: */ .isScrolling, isScrollingOptOut = _ref /*:: */ .isScrollingOptOut, parent = _ref /*:: */ .parent, rowSizeAndPositionManager = _ref /*:: */ .rowSizeAndPositionManager, rowStartIndex = _ref /*:: */ .rowStartIndex, rowStopIndex = _ref /*:: */ .rowStopIndex, styleCache = _ref /*:: */ .styleCache, verticalOffsetAdjustment = _ref /*:: */ .verticalOffsetAdjustment, visibleColumnIndices = _ref /*:: */ .visibleColumnIndices, visibleRowIndices = _ref /*:: */ .visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = "".concat(rowIndex, "-").concat(columnIndex);
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            if (!renderedCell.props.role) renderedCell = /*#__PURE__*/ $12900abfb3ab8dfa$var$_react["default"].cloneElement(renderedCell, {
                role: 'gridcell'
            });
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $12900abfb3ab8dfa$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("6NKcv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $4f3b282cd691fd5a$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $4f3b282cd691fd5a$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $4f3b282cd691fd5a$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $4f3b282cd691fd5a$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $4f3b282cd691fd5a$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $4f3b282cd691fd5a$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $4f3b282cd691fd5a$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});

parcelRegister("6keIx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $229fe9f63703afdf$var$shortcutStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $229fe9f63703afdf$var$shortcutStyleUnbounded = null;
const $229fe9f63703afdf$export$59451aa6b6270879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Shortcut(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0bjKvDzXzM _4xdlr0z9WS _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _1Znuxb1Y8M _1UtDYzZpcK _0KLXruDMqu _3sFDPKYbGa",
            "_4ya3eEAbBT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function Shortcut({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _4xdlr0z9WS _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _1Znuxb1Y8M _1UtDYzZpcK _0KLXruDMqu _3sFDPKYbGa",
            "_4ya3eEAbBT"
        ]),
        children: children
    });
};
module.exports["Shortcut"] = $229fe9f63703afdf$export$59451aa6b6270879;

});

parcelRegister("hFvHs", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $9nUB4 = parcelRequire("9nUB4");

var $f5nzM = parcelRequire("f5nzM");

var $ab7A2 = parcelRequire("ab7A2");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $h4y3S = parcelRequire("h4y3S");


var $jGK9e = parcelRequire("jGK9e");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $fqVYq = parcelRequire("fqVYq");





var $9WBFV = parcelRequire("9WBFV");


var $bVxZJ = parcelRequire("bVxZJ");

var $3TgtB = parcelRequire("3TgtB");

var $eOaGc = parcelRequire("eOaGc");


const $e38cc9b115741c11$export$cbf2f67c120cb8dd = ({ insertPosition: insertPosition, $target: $target })=>{
    // take the text content of the paragraph and insert after the paragraph up until before the the cut
    const from = insertPosition;
    const to = $target.pos + ($target.nodeAfter?.nodeSize || 0); //$cut.pos + $cut.nodeAfter.nodeSize;
    const gapFrom = $target.posAtIndex(0, $target.depth + 1); // start pos of the child
    const gapTo = $target.doc.resolve(gapFrom).end(); // end pos of the paragraph
    if (gapTo - gapFrom === 0) return new (0, $eOaGc.ReplaceStep)(from, to, $target.doc.slice(insertPosition, $target.pos));
    const step = new (0, $eOaGc.ReplaceAroundStep)(from, to, gapFrom, gapTo, $target.doc.slice(insertPosition, $target.pos), 0, true);
    return step;
};



var $aC6bW = parcelRequire("aC6bW");


var $4EksL = parcelRequire("4EksL");


var $dTPhv = parcelRequire("dTPhv");

var $5Q6OE = parcelRequire("5Q6OE");

var $77KCc = parcelRequire("77KCc");


var $iUNgd = parcelRequire("iUNgd");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");





var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");


var $gPewy = parcelRequire("gPewy");

var $aXHNB = parcelRequire("aXHNB");


var $9ULBF = parcelRequire("9ULBF");


var $2CYgA = parcelRequire("2CYgA");




const $193dbff9c95d08f3$export$d113ea522b2117ee = (tr, taskListStart, previousListStart)=>{
    const $taskListStart = tr.doc.resolve(taskListStart);
    /* Safecheck: if not passed a taskList node, return */ if ($taskListStart.node().type.name !== 'taskList') return;
    const $previousListStart = tr.doc.resolve(previousListStart);
    const taskList = tr.doc.slice($taskListStart.pos, $taskListStart.after());
    const frag = (0, $aPdNQ.Fragment).from(taskList.content);
    /*
     Delete the existing taskList at the same level and insert inside above list provided
     1. To delete the tasklist, we need wrapping positions before and after it to completely delete it.
       $taskListStart.after() would give us closing position enclosed by node itself using it would remove only the contents of taskList
       so we add 1 to it to get the position after the taskList node and completly remove it.
     2. Inserting the taskList at the end() position safe inserts the taskList to next available position which would lead to deleting and inserting taskList at same place.
       Reason: $previousListStart.end() gives us end position of listItem but we can add content only inside listItem not at same level
       so we subtract 1 to get the position inside the list item and insert the TaskList same level as paragraph/content inside listItem.
   */ tr.delete($taskListStart.before(), $taskListStart.after() + 1);
    tr.insert($previousListStart.end() - 1, frag);
};


const $9b333e0f090d351f$export$e400d0e3efb40bf0 = ({ tr: tr, direction: direction, forceListType: forceListType })=>{
    const result = {
        orderedList: 0,
        bulletList: 0
    };
    const { doc: doc, selection: { $from: $from, $to: $to }, selection: selection } = tr;
    const range = $from.blockRange($to, (0, $9ULBF.isListNodeValidContent));
    if (!range) return result;
    const rootListNode = doc.nodeAt(range.start);
    const from = (0, $aXHNB.isListNode)(rootListNode) ? range.start : 0;
    const to = (0, $aXHNB.isListNode)(rootListNode) ? range.end : tr.doc.content.size;
    const joins = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        const resolvedPos = doc.resolve(pos);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (!nodeBefore || !nodeAfter || !(0, $aXHNB.isListNode)(nodeBefore) || !(0, $aXHNB.isListNode)(nodeAfter)) return;
        const isNestedList = (0, $gPewy.isListItemNode)(parent);
        if (!isNestedList && nodeBefore.type !== nodeAfter.type && !forceListType) return;
        const index = resolvedPos.index();
        const positionPreviousNode = resolvedPos.posAtIndex(index - 1);
        const positionCurrentNode = resolvedPos.posAtIndex(index);
        // If the previous node is part of the selection, OR
        // If the previous node is not part of the selection and the previous node has the same list type that we’re converting to
        const joinBefore = positionPreviousNode >= from || nodeBefore.type === forceListType;
        if (forceListType) {
            if (joinBefore) tr.setNodeMarkup(positionPreviousNode, forceListType);
            tr.setNodeMarkup(positionCurrentNode, forceListType);
        }
        if (isNestedList && nodeBefore.type !== nodeAfter.type) {
            const nodeType = direction === (0, $2CYgA.JoinDirection).RIGHT ? nodeAfter.type : nodeBefore.type;
            tr.setNodeMarkup(positionPreviousNode, nodeType);
        }
        if (joinBefore) joins.push(pos);
    });
    if (selection.empty && rootListNode && (0, $aXHNB.isListNode)(rootListNode)) {
        const resolvedPos = doc.resolve(range.start + rootListNode.nodeSize);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (nodeBefore && nodeAfter && (0, $aXHNB.isListNode)(nodeBefore) && (0, $aXHNB.isListNode)(nodeAfter) && nodeAfter.type === nodeBefore.type) joins.push(resolvedPos.pos);
    }
    for(let i = joins.length - 1; i >= 0; i--){
        const listNode = tr.doc.nodeAt(joins[i]);
        const listName = listNode?.type.name;
        if (listName && (listName === 'orderedList' || listName === 'bulletList')) {
            const amount = result[listName] || 0;
            result[listName] = amount + 1;
        }
        tr.join(joins[i]);
    }
    return result;
};
/**
 * Returns the prosemirror position for the child at give index inside the parent node.
 * Example: Considering doc structure as below using the function
 *          passing parent resolved position for li and index 2
 *          would return starting position of taskList
 * DOC STRUCTURE:
 * ol()
 *  ( li(
 *      p('text'),
 *      ul(content),
 *      taskList(),
 *    )
 *  )
 * @param $from Starting resolved position for the parent node of the child we are looking for.
 * @param index Index of the child node we want the position for.
 * @returns
 */ const $9b333e0f090d351f$var$findStartPositionOfChildWithIndex = ($from, index)=>{
    const parent = $from.node();
    let currentPos = $from.pos + 1;
    for(let i = 0; i < index; i++)currentPos += parent.child(i).nodeSize;
    return currentPos;
};
const $9b333e0f090d351f$var$findGrandParentResolvedPos = (tr, $from)=>{
    return $from.depth > 2 ? tr.doc.resolve($from.start($from.depth - 2)) : null;
};
const $9b333e0f090d351f$var$findNestedTaskListsIndexAtSameLevel = (tr, $from)=>{
    /*
     Currently our cursor would be inside a pargraph of a list of type numbered/bullet list,
     we need to find the grandparent of the cursor which is the list at same level of taskList.
     We can get the root list item(inside which various lists are being resolved before outdenting) by going one depth above that list.
   */ const nestedListResolvedPos = $9b333e0f090d351f$var$findGrandParentResolvedPos(tr, $from);
    const rootListItem = nestedListResolvedPos?.node(nestedListResolvedPos.depth - 1);
    const nestedTaskListsIndexes = [];
    const rootListItemChildCount = rootListItem?.childCount || 0;
    // first child of list item is always paragraph (i = 0) so we start from 1
    for(let i = 1; i < rootListItemChildCount; i++)if (rootListItem?.child(i).type.name === 'taskList') nestedTaskListsIndexes.push(i);
    return nestedTaskListsIndexes;
};
const $9b333e0f090d351f$export$d676b534bbdcdb6d = (tr)=>{
    const { $from: $from } = tr.selection;
    const nestedTaskListIndexes = $9b333e0f090d351f$var$findNestedTaskListsIndexAtSameLevel(tr, $from);
    if (nestedTaskListIndexes.length === 0) return;
    const nestedListResolvedPos = $9b333e0f090d351f$var$findGrandParentResolvedPos(tr, $from);
    const rootListItemStart = nestedListResolvedPos?.start(nestedListResolvedPos.depth - 1);
    /* We need not wrap the taskList present above other lists since it doesn't affect the flow. */ const nestedTaskListIndexesToWrap = nestedTaskListIndexes.filter((index)=>index > 1);
    /*
     Wraps the taskLists present at each index mentioned in the nestedTaskListIndexesToWrap to the list above it.
     After each wrap the indexes changes since two lists are being merged into one,
     so we keep track of it and use it to access actual calculated taskList indexes.
   */ if (rootListItemStart) {
        let taskListsFixedNested = 0;
        nestedTaskListIndexesToWrap.forEach((index)=>{
            (0, $193dbff9c95d08f3$export$d113ea522b2117ee)(tr, $9b333e0f090d351f$var$findStartPositionOfChildWithIndex(tr.doc.resolve(rootListItemStart), index - taskListsFixedNested), $9b333e0f090d351f$var$findStartPositionOfChildWithIndex(tr.doc.resolve(rootListItemStart), index - 1 - taskListsFixedNested));
            taskListsFixedNested++;
        });
    }
    return;
};






var $2w79Z = parcelRequire("2w79Z");























function $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $aXHNB.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $bjg0G.findParentNodeClosestToPos)($pos, (0, $aXHNB.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
function $6ddfc8bedba79b46$export$112d93610a31ac47($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    const listItemNodePosition = (0, $gPewy.isListItemNode)(currentNode) ? $pos : (0, $bjg0G.findParentNodeClosestToPos)($pos, (0, $gPewy.isListItemNode));
    if (!listItemNodePosition || listItemNodePosition.pos === null) return null;
    const node = $pos.doc.nodeAt(listItemNodePosition.pos);
    if (!node) return null;
    return {
        node: node,
        pos: listItemNodePosition.pos
    };
}
const $6ddfc8bedba79b46$export$cd55a6653375f672 = ($pos)=>{
    const { doc: doc } = $pos;
    if ($pos.pos + 1 > doc.content.size) return null;
    if ($pos.depth === 0) return doc.resolve($pos.pos + 1);
    const currentNode = doc.nodeAt($pos.pos);
    const beforePosition = $pos.before();
    const nodeBefore = doc.nodeAt(beforePosition);
    if ((0, $aXHNB.isListNode)(currentNode) && !(0, $gPewy.isListItemNode)(nodeBefore)) return doc.resolve($pos.pos + 1);
    const parentList = (0, $bjg0G.findParentNodeClosestToPos)($pos, (0, $aXHNB.isListNode));
    if (!parentList) return null;
    const listNodePosition = doc.resolve(parentList.pos);
    return $6ddfc8bedba79b46$export$cd55a6653375f672(listNodePosition);
};


function $76ec2b16794afe73$export$193e29566e093d19({ tr: tr, nextListNodeType: nextListNodeType }) {
    const { doc: doc, selection: { $from: $from, $to: $to } } = tr;
    let listRange;
    if (tr.selection instanceof (0, $4EksL.GapCursorSelection)) {
        const nodeSize = $from.nodeAfter?.nodeSize || 1;
        listRange = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else listRange = $from.blockRange($to, (0, $aXHNB.isListNode));
    if (listRange) return $76ec2b16794afe73$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    const nodeRangeAroundList = $from.blockRange($to);
    if (!nodeRangeAroundList) return;
    const parentNode = nodeRangeAroundList.parent;
    const { startIndex: startIndex, endIndex: endIndex, depth: depth } = nodeRangeAroundList;
    // Checking for invalid nodes to prevent conversion
    // eg. a panel cannot be wrapped in a list so return
    // It will skip this check if the selection begins within a list
    // This is to match the behaviour of the toolbar buttons being disabled
    if (!(0, $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7)($from)) for(let i = startIndex; i < endIndex; i++){
        const position = nodeRangeAroundList.$from.posAtIndex(i, depth);
        const resolvedPosition = doc.resolve(position);
        const currentChild = parentNode.child(i);
        const currentNodeRange = resolvedPosition.blockRange(tr.doc.resolve(position + currentChild.nodeSize));
        if (currentNodeRange && !(0, $aXHNB.isListNode)(currentChild) && !(0, $eOaGc.findWrapping)(currentNodeRange, nextListNodeType)) return;
    }
    // Checking for any non list nodes and wrapping them in a list
    // so they can be converted
    tr.doc.nodesBetween(nodeRangeAroundList.start, nodeRangeAroundList.end, (node, pos)=>{
        // Skip over any nodes that are part of a list
        if ((0, $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7)(tr.doc.resolve(tr.mapping.map(pos)))) return false;
        // The following applies to suitable nodes that are not within a list
        const currentNodeNotWrappedInList = node;
        const isNotAnEmptyParagraphAndIsParagraphOrLeafNode = !(0, $2w79Z.isEmptyParagraph)(currentNodeNotWrappedInList) && (!node.type.isBlock || node.type.name === 'paragraph');
        if (isNotAnEmptyParagraphAndIsParagraphOrLeafNode && nodeRangeAroundList) {
            const remainingNodeRange = new (0, $aPdNQ.NodeRange)(tr.doc.resolve(tr.mapping.map(pos)), tr.doc.resolve(tr.mapping.map(pos) + currentNodeNotWrappedInList.nodeSize), nodeRangeAroundList.depth);
            $76ec2b16794afe73$var$convertAroundList({
                tr: tr,
                nextListNodeType: nextListNodeType,
                nodeRange: remainingNodeRange
            });
            return false;
        }
    });
    $76ec2b16794afe73$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    if (tr.docChanged) (0, $9b333e0f090d351f$export$e400d0e3efb40bf0)({
        tr: tr,
        forceListType: nextListNodeType
    });
}
const $76ec2b16794afe73$var$convertSelectedList = ({ tr: tr, nextListNodeType: nextListNodeType })=>{
    const { selection: selection, selection: { from: from, to: to } } = tr;
    const { codeBlock: codeBlock } = tr.doc.type.schema.nodes;
    // get the positions of all the leaf nodes within the selection
    const nodePositions = [];
    if (selection instanceof (0, $kCECX.TextSelection) && selection.$cursor || selection instanceof (0, $4EksL.GapCursorSelection)) nodePositions.push(from);
    else // nodesBetween doesn't return leaf nodes that are outside of from and to
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        // isLeaf is false for empty codeBlock so adding additional check for childCount
        if (!node.isLeaf && !(node.type === codeBlock && node.childCount === 0)) return true;
        nodePositions.push(pos);
    });
    // use those positions to get the closest parent list nodes
    nodePositions.reduce((acc, pos)=>{
        const closestParentListNode = (0, $bjg0G.findParentNodeClosestToPos)(tr.doc.resolve(pos), (0, $aXHNB.isListNode));
        if (!closestParentListNode) return acc;
        // don't add duplicates if the parent has already been added into the array
        const existingParent = acc.find((node)=>{
            return node.pos === closestParentListNode.pos && node.start === closestParentListNode.start && node.depth === closestParentListNode.depth;
        });
        if (!existingParent) acc.push(closestParentListNode);
        return acc;
    }, []).forEach((item)=>{
        tr.setNodeMarkup(item.pos, nextListNodeType);
    });
};
const $76ec2b16794afe73$var$convertAroundList = ({ tr: tr, nextListNodeType: nextListNodeType, nodeRange: nodeRange })=>{
    for(let i = nodeRange.endIndex - 1; i >= nodeRange.startIndex; i--){
        const position = nodeRange.$from.posAtIndex(i, nodeRange.depth);
        const resolvedPos = tr.doc.resolve(position + 1);
        const range = resolvedPos.blockRange(resolvedPos);
        if (!range) return;
        const wrappings = (0, $eOaGc.findWrapping)(range, nextListNodeType);
        if (!range || !wrappings) return;
        tr.wrap(range, wrappings);
    }
};






var $liXVw = parcelRequire("liXVw");















var $51m9Q = parcelRequire("51m9Q");







const $15716090c6bb5c37$export$27bb641e25fad24d = ($pos)=>{
    return $pos.parent.type.name === 'paragraph';
};
const $15716090c6bb5c37$export$4639440f68939b8a = ($pos)=>{
    const posGrandParent = $pos.node(-1);
    return (0, $gPewy.isListItemNode)($pos.parent) || (0, $aXHNB.isListNode)($pos.parent) || (0, $gPewy.isListItemNode)(posGrandParent);
};
const $15716090c6bb5c37$export$af251811cd857645 = (nodeType, selection)=>{
    const { $from: $from, $to: $to } = selection;
    let range;
    if (selection instanceof (0, $4EksL.GapCursorSelection) && $from.nodeAfter) {
        const nodeSize = $from.nodeAfter.nodeSize || 1;
        range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else range = $from.blockRange($to);
    if (!range) return false;
    const wrap = (0, $eOaGc.findWrapping)(range, nodeType);
    if (!wrap) return false;
    return true;
};
const $15716090c6bb5c37$export$fd64e4ef922c42f3 = (tr)=>{
    const { parent: parent } = tr.selection.$from;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    if (tr.selection instanceof (0, $4EksL.GapCursorSelection)) return (0, $gPewy.isListItemNode)(parent);
    return (0, $bjg0G.hasParentNodeOfType)(listItem)(tr.selection) && (0, $51m9Q.isParagraphNode)(parent);
};
const $15716090c6bb5c37$export$cb2b92f281f91c40 = (tr)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
    return !!(0, $bjg0G.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(tr.selection);
};
const $15716090c6bb5c37$export$6ec51e240036c4ab = (tr)=>{
    const { $from: $from } = tr.selection;
    const $before = tr.doc.resolve($from.pos - 1);
    let nodeBefore = $before ? $before.nodeBefore : null;
    if (tr.selection instanceof (0, $4EksL.GapCursorSelection)) nodeBefore = $from.nodeBefore;
    return (0, $aXHNB.isListNode)(nodeBefore);
};
const $15716090c6bb5c37$export$f0dda2b070101c76 = (tr)=>{
    const { selection: { from: from, to: to } } = tr;
    let foundListNode = null;
    tr.doc.nodesBetween(from, to, (node)=>{
        if ((0, $aXHNB.isListNode)(node)) foundListNode = node;
        if (foundListNode) return false;
        return true;
    });
    return foundListNode;
};
const $15716090c6bb5c37$export$44fa515643dd6860 = ({ selection: selection })=>{
    const { $from: $from, $to: $to } = selection;
    const range = $from.blockRange($to, (0, $aXHNB.isListNode));
    if (!range) return null;
    return range;
};


function $10c5013ef83e12a6$export$dc4f1f9730c3e037(nodeType, tr) {
    $10c5013ef83e12a6$export$a8aef45c6262afee(nodeType)(tr);
    (0, $liXVw.autoJoinTr)(tr, (before, after)=>before.type === after.type && before.type === nodeType);
}
function $10c5013ef83e12a6$export$a8aef45c6262afee(listType, attrs) {
    return function(tr) {
        const { $from: $from, $to: $to } = tr.selection;
        let range;
        if (tr.selection instanceof (0, $4EksL.GapCursorSelection) && $from.nodeAfter && (0, $15716090c6bb5c37$export$af251811cd857645)(listType, tr.selection)) {
            const nodeSize = $from.nodeAfter.nodeSize || 1;
            range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
        } else range = $from.blockRange($to);
        let doJoin = false;
        let outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            const $insert = tr.doc.resolve(range.start - 2);
            outerRange = new (0, $aPdNQ.NodeRange)($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) range = new (0, $aPdNQ.NodeRange)($from, tr.doc.resolve($to.end(range.depth)), range.depth);
            doJoin = true;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const wrap = (0, $eOaGc.findWrapping)(outerRange, listType, attrs, range);
        if (!wrap) return false;
        tr = $10c5013ef83e12a6$var$doWrapInList(tr, range, wrap, doJoin, listType);
        return true;
    };
}
/**
 * Internal function used by wrapInList
 *
 * Adapted from https://github.com/ProseMirror/prosemirror-schema-list/blob/master/src/schema-list.js#L91-L112
 */ function $10c5013ef83e12a6$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $aPdNQ.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $aPdNQ.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $eOaGc.ReplaceAroundStep)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $aPdNQ.Slice)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type === listType) found = i + 1;
    const splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    const parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $eOaGc.canSplit)(tr.doc, splitPos, splitDepth)) {
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}






















const $2b797914cdc6f8fc$export$624f45cf4fef090e = (resPos)=>{
    let target = resPos.depth;
    for(let i = resPos.depth; i > 0; i--){
        const node = resPos.node(i);
        if ((0, $aXHNB.isListNode)(node)) target = i;
        if (!(0, $gPewy.isListItemNode)(node) && !(0, $aXHNB.isListNode)(node)) break;
    }
    return target - 1;
};


function $2b4d25e51054885d$var$liftListItem(selection, tr) {
    const { $from: $from, $to: $to } = selection;
    const nodeType = tr.doc.type.schema.nodes.listItem;
    let range = $from.blockRange($to, (node)=>!!node.childCount && !!node.firstChild && node.firstChild.type === nodeType);
    if (!range || range.depth < 2 || $from.node(range.depth - 1).type !== nodeType) return tr;
    const end = range.end;
    const endOfList = $to.end(range.depth);
    if (end < endOfList) {
        tr.step(new (0, $eOaGc.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodeType.create(undefined, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $aPdNQ.NodeRange)(tr.doc.resolve($from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    return tr.lift(range, (0, $eOaGc.liftTarget)(range)).scrollIntoView();
}
function $2b4d25e51054885d$export$4ed538bc5a7d756f(from, to, rootListDepth, tr) {
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    let lifted = false;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!lifted && node.type === listItem && pos > from) {
            lifted = true;
            let listDepth = rootListDepth + 3;
            while(listDepth > rootListDepth + 2){
                const start = tr.doc.resolve(tr.mapping.map(pos));
                listDepth = start.depth;
                const end = tr.doc.resolve(tr.mapping.map(pos + node.textContent.length));
                const sel = new (0, $kCECX.TextSelection)(start, end);
                tr = $2b4d25e51054885d$var$liftListItem(sel, tr);
            }
        }
    });
    return tr;
}
function $2b4d25e51054885d$export$2b630c4fa336fee7(selection, tr) {
    const { from: from } = selection;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    const mappedPosition = tr.mapping.map(from);
    const nodeAtPos = tr.doc.nodeAt(mappedPosition);
    const start = tr.doc.resolve(mappedPosition);
    if (start?.parent.type !== listItem) return tr;
    const end = tr.doc.resolve(mappedPosition + (nodeAtPos?.nodeSize || 1));
    const range = start.blockRange(end);
    if (range) {
        const liftTarget = (0, $2b797914cdc6f8fc$export$624f45cf4fef090e)(start);
        tr.lift(range, liftTarget);
    }
    return tr;
}
function $2b4d25e51054885d$export$a88bd9b6e3aac8d6(selection, tr) {
    const { from: from, to: to } = selection;
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    const listCol = [];
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type === paragraph) listCol.push({
            node: node,
            pos: pos
        });
    });
    for(let i = listCol.length - 1; i >= 0; i--){
        const paragraph = listCol[i];
        const start = tr.doc.resolve(tr.mapping.map(paragraph.pos));
        if (start.depth > 0) {
            let end;
            if (paragraph.node.textContent && paragraph.node.textContent.length > 0) end = tr.doc.resolve(tr.mapping.map(paragraph.pos + paragraph.node.textContent.length));
            else end = tr.doc.resolve(tr.mapping.map(paragraph.pos + 1));
            const range = start.blockRange(end);
            if (range) tr.lift(range, (0, $2b797914cdc6f8fc$export$624f45cf4fef090e)(start));
        }
    }
    return tr;
}
/**
 * Finds the top-level list nodes (bulletList/orderedList) that contain the positions
 * affected by the given transactions. Returns a map of list node position → list node,
 * so callers can scan only the affected subtrees rather than the entire document.
 */ function $2b4d25e51054885d$var$getAffectedListsFromTransactions(transactions, doc, schema) {
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    const listTypes = [
        bulletList,
        orderedList
    ].filter(Boolean);
    if (listTypes.length === 0) return new Map();
    const result = new Map();
    for (const tr of transactions)for (const step of tr.steps){
        // ReplaceStep and ReplaceAroundStep both have from/to — other step types are skipped.
        if (!(step instanceof (0, $eOaGc.ReplaceStep)) && !(step instanceof (0, $eOaGc.ReplaceAroundStep))) continue;
        // Check both the start and end of each changed range, mapped to post-transaction positions.
        for (const rawPos of [
            step.from,
            step.to
        ]){
            const mappedPos = Math.min(tr.mapping.map(rawPos), doc.content.size - 1);
            const $pos = doc.resolve(mappedPos);
            // Walk ancestors from inner to outer, recording the outermost list node.
            // Once we find a list and then exit list structure (hit a non-list ancestor),
            // break early — prevents container nodes (e.g. panel) from causing us to
            // return an outer list that is in a different structural context.
            // $pos.node(depth) is O(1) array access.
            let rootListPos = null;
            let rootListNode = null;
            for(let depth = $pos.depth; depth >= 0; depth--){
                const node = $pos.node(depth);
                if (listTypes.includes(node.type)) {
                    rootListPos = $pos.before(depth);
                    rootListNode = node;
                } else if (rootListNode !== null && node.type !== schema.nodes.listItem) break;
            }
            if (rootListPos !== null && rootListNode !== null) result.set(rootListPos, rootListNode);
        }
    }
    return result;
}
function $2b4d25e51054885d$export$da6cb9e5038a61a({ tr: tr, transactions: transactions, doc: doc, schema: schema }) {
    const affectedLists = $2b4d25e51054885d$var$getAffectedListsFromTransactions(transactions, doc, schema);
    if (affectedLists.size === 0) return tr;
    const { listItem: listItem, paragraph: paragraph, bulletList: bulletList, orderedList: orderedList, taskList: taskList } = schema.nodes;
    if (!listItem) return tr;
    const nestedListTypes = [
        bulletList,
        orderedList,
        taskList
    ].filter(Boolean);
    // Process lists in reverse position order so fixes at higher positions
    // don't shift the positions of fixes at lower positions.
    const sortedEntries = [
        ...affectedLists.entries()
    ].sort(([posA], [posB])=>posB - posA);
    for (const [listPos] of sortedEntries){
        // Re-resolve the list node from the current transaction doc (post-paste state),
        // as the original listNode snapshot may be stale after the paste transaction.
        const mappedListPos = tr.mapping.map(listPos);
        const currentListNode = tr.doc.nodeAt(mappedListPos);
        if (!currentListNode) continue;
        // Collect all listItem positions at all depths in document order, then process in
        // reverse so that fixes at higher positions don't shift positions of lower ones.
        const listItemPositions = [];
        currentListNode.descendants((node, offsetPos)=>{
            if (node.type === listItem) listItemPositions.push(mappedListPos + 1 + offsetPos);
            return true;
        });
        for(let i = listItemPositions.length - 1; i >= 0; i--){
            const mappedPos = tr.mapping.map(listItemPositions[i]);
            const node = tr.doc.nodeAt(mappedPos);
            if (!node || node.type !== listItem) continue;
            // Merge adjacent same-type list nodes (highest boundary first within the listItem).
            for(let j = node.childCount - 1; j > 0; j--){
                const child = node.child(j);
                const prevChild = node.child(j - 1);
                if ((0, $aXHNB.isListNode)(child) && child.type === prevChild.type) {
                    let offset = 1; // +1 for listItem opening token
                    for(let k = 0; k < j; k++)offset += node.child(k).nodeSize;
                    try {
                        tr.join(mappedPos + offset);
                    } catch (e) {
                        // join may fail if position is invalid after earlier transforms — skip
                        // eslint-disable-next-line no-console
                        console.warn('[editor-plugin-list] applyListNormalisationFixes: unexpected join failure', e);
                    }
                }
            }
            // Insert empty paragraph before a list-type first child when _indentation is off.
            // Only list types (bulletList, orderedList, taskList) are invalid as a first child —
            // other non-paragraph types (mediaSingle, codeBlock, extension) are valid per the schema.
            if (paragraph && !(0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) {
                // Re-map position after any join steps that may have been added above.
                const remappedPos = tr.mapping.map(listItemPositions[i]);
                const currentNode = tr.doc.nodeAt(remappedPos);
                const firstChild = currentNode?.firstChild;
                if (firstChild && nestedListTypes.includes(firstChild.type)) {
                    const emptyParagraph = paragraph.createAndFill();
                    if (emptyParagraph) tr.insert(remappedPos + 1, emptyParagraph);
                }
            }
        }
    }
    return tr;
}





const $32fcf02f6bd510e5$var$listContainerTypes = new Set([
    'bulletList',
    'orderedList'
]);
/**
 * When wrapping in a list, the paragraph's direct parent will be listItem,
 * not the list container itself. For fontSize marks, resolve to listItem
 * so mark compatibility is checked against the actual parent.
 */ const $32fcf02f6bd510e5$var$resolveEffectiveParentType = (newParentType)=>{
    if (newParentType && $32fcf02f6bd510e5$var$listContainerTypes.has(newParentType.name) && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return newParentType.schema.nodes.listItem;
    return newParentType;
};
const $32fcf02f6bd510e5$var$isMarkDisallowed = (mark, parent, effectiveParentType)=>!parent?.type.allowsMarkType(mark.type) || effectiveParentType && !effectiveParentType.allowsMarkType(mark.type);
const $32fcf02f6bd510e5$export$bec007f49d03125c = (tr, newParentType)=>{
    const { from: from, to: to } = tr.selection;
    const nodesSanitized = [];
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (node.isText) return false;
        // Skip expands and layouts if they are outside selection
        // but continue to iterate over their children.
        if ([
            'expand',
            'layoutSection'
        ].includes(node.type.name) && (pos < from || pos > to)) return true;
        node.marks.forEach((mark)=>{
            const effectiveParentType = $32fcf02f6bd510e5$var$resolveEffectiveParentType(newParentType);
            if ($32fcf02f6bd510e5$var$isMarkDisallowed(mark, parent, effectiveParentType)) {
                const filteredMarks = node.marks.filter((m)=>m.type !== mark.type);
                const position = pos > 0 ? pos : 0;
                const marksRemoved = node.marks.filter((m)=>m.type === mark.type);
                nodesSanitized.push({
                    node: node,
                    marksRemoved: marksRemoved
                });
                tr.setNodeMarkup(position, undefined, node.attrs, filteredMarks);
            }
        });
    });
    return nodesSanitized;
};






const $b7947b8c3968a6d0$export$1d357fa6aecde5b8 = (state)=>{
    const { $from: $from } = state.selection;
    return $from.depth > 1 ? state.selection instanceof (0, $4EksL.GapCursorSelection) && $from.parentOffset === 0 || $from.index($from.depth - 1) === 0 : true;
};





var $iaHsT = parcelRequire("iaHsT");

























var $cSlMN = parcelRequire("cSlMN");






const $aced79b17884355b$export$fc9859705a1e8274 = ({ tr: tr, $next: $next, $head: $head })=>{
    // For empty paragraphs before a list
    if ($head.parent.content.size < 1) {
        (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), [], [
            [
                $head.pos - 1,
                $head.pos
            ]
        ]);
        return true;
    }
    const paragraphPosition = $head.pos;
    const list = tr.doc.nodeAt($next.pos - 1);
    const firstListItem = tr.doc.nodeAt($next.pos);
    if (!list || !firstListItem) return false;
    const firstChildNodeOfFirstListItem = firstListItem.firstChild;
    if (!firstChildNodeOfFirstListItem) return false;
    const lastChildOfFirstListItem = firstListItem.lastChild;
    const firstGrandchildOfFirstListItem = firstChildNodeOfFirstListItem.firstChild;
    const firstListItemHasOneChildWithNoNestedLists = $aced79b17884355b$var$hasSingleChild(firstListItem) && firstChildNodeOfFirstListItem.childCount < 2 && $next.nodeAfter;
    const firstListItemContainsParagraphAndNestedList = !$aced79b17884355b$var$hasSingleChild(firstListItem) && lastChildOfFirstListItem && (0, $aXHNB.isListNode)(lastChildOfFirstListItem);
    const insertions = [];
    const deletions = [];
    // For lists that only have one list item with no children - need to remove remaining list
    if ($aced79b17884355b$var$hasSingleChild(list) && $aced79b17884355b$var$hasSingleChild(firstListItem) && $next.nodeAfter) deletions.push([
        tr.mapping.map($next.pos - 1),
        tr.mapping.map($next.pos + $next.nodeAfter.nodeSize + 1)
    ]);
    // For first list items that have a paragraph and a list
    if (firstListItemContainsParagraphAndNestedList) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstListItemNestedList = (0, $aPdNQ.Fragment).from(lastChildOfFirstListItem.content);
        insertions.push([
            firstListItemNestedList,
            tr.mapping.map($next.pos)
        ]);
    }
    // For first list item has one child & no nested lists OR first list items that have a paragraph and a list
    if (firstListItemHasOneChildWithNoNestedLists || firstListItemContainsParagraphAndNestedList) {
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + firstListItem.nodeSize - 1)
        ]);
        const firstListItemText = (0, $aPdNQ.Fragment).from(firstChildNodeOfFirstListItem.content);
        insertions.push([
            firstListItemText,
            paragraphPosition
        ]);
        (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any first list items that have multiple children (eg. multiple paragraphs)
    if (firstListItem.childCount > 1) {
        insertions.push([
            (0, $aPdNQ.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        deletions.push([
            tr.mapping.map($next.pos + 1),
            tr.mapping.map($next.pos + firstChildNodeOfFirstListItem.nodeSize + 1)
        ]);
        (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any remaining first list items that have a single child (eg. single paragraph, multiple lines of text)
    if (firstGrandchildOfFirstListItem && firstGrandchildOfFirstListItem.type.name === 'hardBreak') {
        const nodeSizeOfGrandchild = firstGrandchildOfFirstListItem ? firstGrandchildOfFirstListItem.nodeSize : 0;
        deletions.push([
            tr.mapping.map($next.pos + 2),
            tr.mapping.map($next.pos + 2 + nodeSizeOfGrandchild)
        ]);
    } else {
        insertions.push([
            (0, $aPdNQ.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        const nodeSizeOfFirstChild = firstChildNodeOfFirstListItem.nodeSize;
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + 2 + nodeSizeOfFirstChild)
        ]);
    }
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
    return true;
};
const $aced79b17884355b$var$hasSingleChild = (node)=>{
    return node.childCount === 1;
};







const $ba3b1c84565957b0$export$2d042119f7337416 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 4
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {       //May be multiple levels of lists
	 *           ...Children G
	 *           ListItem H {        //Last node of the block
	 *             ...Children I
	 *             Paragraph J { text2 |$head||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
	 *           }
	 *         }
	 *       ...
	 *     |childrenOInsertPos| }
	 *   }
	 *   ListItem K { |$next|
	 *      Paragraph L { text3 }
	 *      ...Children M
	 *      List? N {
	 *       ...Children O
	 *      }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {
	 *           ...Children G
	 *           ListItem H {
	 *             ...Children I
	 *             Paragraph J { text2text3 }
	 *             ...Children M
	 *           }
	 *         }
	 *       ...
	 *       ...Children O
	 *     }
	 *   }
	 * }
	 *
	 */ const listItemK = $next.parent; //List must have at least one child
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const beforeListItemK = $next.before();
    const afterListItemB = $next.before();
    const afterListItemK = $next.after();
    const containsChildrenO = (0, $aXHNB.isListNode)(listItemK.lastChild);
    const textInsertPos = $head.pos;
    const childrenMInsertPos = $head.pos + 1;
    const childrenOInsertPos = afterListItemB - 2;
    const textContent = listItemK.firstChild.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    return true;
};







const $46517f304bbfe3db$export$a4a1ba570b242c2c = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 3
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| } |childrenHInsertPos|
	 *     List E { |$next||childrenJInsertPos|
	 *       ListItem F {
	 *         Paragraph G { text2 }
	 *         ...Children H
	 *         List? I {
	 *           ...Children J
	 *         }
	 *       }
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *     ...Children H
	 *     List E {
	 *       ...Children J
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 */ const listE = $next.parent;
    const listItemF = $next.nodeAfter; //We know next is before a ListItem. ListItem must have at least one child
    if (!listItemF || !listItemF.lastChild) return false;
    const paragraphG = listItemF.firstChild; //ListItem must have at least one child
    if (!paragraphG) return false;
    const beforeListE = $next.before();
    const beforeListItemF = $next.pos;
    const afterParagraphD = $head.after();
    const afterListE = $next.after();
    const afterListItemF = tr.doc.resolve($next.pos + 1).after(); //List must always have at least one listItem
    const containsChildrenJ = (0, $aXHNB.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $head.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = $next.pos;
    const textContent = paragraphG.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(paragraphG.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(paragraphG.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    return true;
};





const $2de2093c03ee273e$export$676f199e6d2601c5 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 1
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| }
	 *   }
	 * }
	 * Paragraph E { |$next| text 2 }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *   }
	 * }
	 *
	 */ const paragraphE = $next.parent;
    const beforeParagraphE = $next.before();
    const afterParagraphE = $next.after();
    const textInsertPos = $head.pos;
    const textContent = paragraphE.content;
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ]
    ], [
        [
            beforeParagraphE,
            afterParagraphE
        ]
    ]);
    return true;
};





const $14a99102c72a5f8d$export$1a90e697acce0e2d = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 2
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$head||textInsertPos| }       //Cant have children since that would be Case 4
	 *   |childrenGInsertPos| }
	 *   ListItem E { |$next|
	 *     Paragraph F { text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph C { text1text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 */ const listItemE = $next.parent;
    const paragraphF = $next.nodeAfter; //ListItem must have at least one child
    if (!paragraphF) return false;
    const beforeListItemE = $next.before();
    const afterListItemE = $next.after();
    const endListItemB = $head.end(-1);
    const textInsertPos = $head.pos;
    const childrenGInsertPos = endListItemB;
    const textContent = paragraphF.content;
    const childrenGContent = listItemE.content.cut(paragraphF.nodeSize);
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    return true;
};


const $6ca5be0731f04f3e$export$c60ae92c9826748a = (walkNode, $head)=>{
    const { $pos: $next, foundNode: nextFoundNode } = walkNode;
    const headParent = $head.parent;
    const headGrandParent = $head.node(-1);
    const headInList = (0, $15716090c6bb5c37$export$4639440f68939b8a)($head);
    const headInParagraph = (0, $15716090c6bb5c37$export$27bb641e25fad24d)($head);
    const headInLastNonListChild = headGrandParent && headGrandParent.lastChild && (headGrandParent.lastChild === headParent || headGrandParent.childCount > 1 && headGrandParent.child(headGrandParent.childCount - 2) === headParent && //find the second last child if a list item may be the last child
    (0, $aXHNB.isListNode)(headGrandParent.lastChild));
    const nextInList = (0, $15716090c6bb5c37$export$4639440f68939b8a)($next);
    const nextInParagraph = (0, $15716090c6bb5c37$export$27bb641e25fad24d)($next);
    if (!headInList && headInParagraph && nextInList) return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_LIST_ITEM_WITH_PARAGRAPH,
        (0, $aced79b17884355b$export$fc9859705a1e8274)
    ];
    if (!nextFoundNode || !headInList || !headInParagraph || !headInLastNonListChild) return false;
    if (!nextInList && nextInParagraph) return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_PARAGRAPH_WITH_LIST,
        (0, $2de2093c03ee273e$export$676f199e6d2601c5)
    ];
    if (!nextInList) return false;
    const nextNodeAfter = $next.nodeAfter;
    const nextGrandParent = $next.node(-1);
    const headGreatGrandParent = $head.node(-2);
    const nextInListItem = (0, $gPewy.isListItemNode)($next.parent);
    const nextNodeAfterListItem = (0, $gPewy.isListItemNode)(nextNodeAfter);
    const nextListItemHasFirstChildParagraph = nextNodeAfter && //Redundant check but the linter complains otherwise
    nextNodeAfterListItem && (0, $51m9Q.isParagraphNode)(nextNodeAfter.firstChild);
    if (!nextInListItem && nextListItemHasFirstChildParagraph) return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        (0, $46517f304bbfe3db$export$a4a1ba570b242c2c)
    ];
    if (!nextInListItem) return false;
    const nextParentSiblingOfHeadParent = nextGrandParent && nextGrandParent === headGreatGrandParent;
    const nextNodeAfterIsParagraph = (0, $51m9Q.isParagraphNode)(nextNodeAfter);
    if (!nextNodeAfterIsParagraph) return false;
    if (nextParentSiblingOfHeadParent) return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        (0, $14a99102c72a5f8d$export$1a90e697acce0e2d)
    ];
    return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_PARENT_SIBLING_TO_PARENT_CHILD,
        (0, $ba3b1c84565957b0$export$2d042119f7337416)
    ];
};


const $fc648a393d823459$export$6851baf5987dd2cb = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $77KCc.walkNextNode)($head);
        if (!(0, $77KCc.isEmptySelectionAtEnd)(state)) return false;
        if ((0, $iDrrr.fg)('platform_editor_blocks_patch_7')) {
            let interveningSyncBlockPos;
            // walkNextNode can skip leaf nodes because they have no resolvable content position.
            state.doc.nodesBetween($head.pos, walkNode.$pos.pos, (node, pos)=>{
                if (interveningSyncBlockPos === undefined && node.type.name === 'syncBlock') interveningSyncBlockPos = pos;
                return interveningSyncBlockPos === undefined;
            });
            if (interveningSyncBlockPos !== undefined) {
                if (dispatch) {
                    const selection = (0, $kCECX.NodeSelection).create(state.doc, interveningSyncBlockPos);
                    dispatch(tr.setSelection(selection).scrollIntoView());
                }
                return true;
            }
        }
        const scenarios = (0, $6ca5be0731f04f3e$export$c60ae92c9826748a)(walkNode, $head);
        if (!scenarios) return false;
        const [scenario, action] = scenarios;
        const result = action({
            tr: tr,
            $next: walkNode.$pos,
            $head: $head
        });
        if (!result) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $bjg0G.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD,
                direction: (0, $iaHsT.DELETE_DIRECTION).FORWARD,
                scenario: scenario
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };


























//Cases below refer to the cases found in this document: https://product-fabric.atlassian.net/wiki/spaces/E/pages/1146954996/List+Backspace+and+Delete+Behaviour
//Case for two adjacent list items of the same indentation
const $1caea1c6baa80a52$var$listBackspaceCase2 = (tr, dispatch, $prev, $head)=>{
    /* CASE 2
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |textInsertPos| }       //Cant have children since that would be Case 4
	 *   |$prev||childrenGInsertPos| }
	 *   ListItem E {
	 *     Paragraph F { |$head| text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph C { text1text2 }
	 *     ...Children G
	 *   }
	 * }
	 *
	 */ const listItemE = $head.node(-1); //Head is inside listItem E so it must have a first and last child
    const { fontSize: fontSize } = tr.doc.type.schema.marks;
    if (!listItemE.firstChild) return false;
    const beforeListItemE = $head.before(-1);
    const afterListItemE = $head.after(-1);
    const textInsertPos = $prev.pos - 1; //Paragraph D must be directly behind $prev otherwise it would be case 4
    const childrenGInsertPos = $prev.pos;
    const textContent = $head.parent.content;
    const childrenGContent = listItemE.content.cut(listItemE.firstChild.nodeSize);
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    if (fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
        const targetParagraphFontSizeAttrs = (0, $bVxZJ.getBlockMarkAttrs)($prev.parent.lastChild, fontSize);
        (0, $bVxZJ.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(textInsertPos), fontSize, targetParagraphFontSizeAttrs);
    }
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of lower indentation
const $1caea1c6baa80a52$var$listBackspaceCase3 = (tr, dispatch, $prev, $head)=>{
    /* CASE 3
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1 |$prev||textInsertPos| } |childrenHInsertPos|
	 *     List E { |childrenJInsertPos|
	 *       ListItem F {
	 *         Paragraph G { |$head| text2 }
	 *         ...Children H
	 *         List? I {
	 *           ...Children J
	 *         }
	 *       }
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     ...Children C
	 *     Paragraph D { text1text2 }
	 *     ...Children H
	 *     List E {
	 *       ...Children J
	 *       ...Children K
	 *     }
	 *   }
	 * }
	 *
	 */ const listE = $head.node(-2);
    const listItemF = $head.node(-1); //Head is inside listItem F so it must have a first and last child
    const { fontSize: fontSize } = tr.doc.type.schema.marks;
    if (!listItemF.firstChild || !listItemF.lastChild) return false;
    const beforeListE = $head.before(-2);
    const beforeListItemF = $head.before(-1);
    const afterParagraphD = $prev.after();
    const afterListE = $head.after(-2);
    const afterListItemF = $head.after(-1);
    const startListE = $head.start(-2);
    const containsChildrenJ = (0, $aXHNB.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $prev.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = startListE;
    const textContent = $head.parent.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(listItemF.firstChild.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(listItemF.firstChild.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    if (fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
        const targetParagraphFontSizeAttrs = (0, $bVxZJ.getBlockMarkAttrs)($prev.parent, fontSize);
        (0, $bVxZJ.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(textInsertPos), fontSize, targetParagraphFontSizeAttrs);
    }
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of greater indentation
const $1caea1c6baa80a52$var$listBackspaceCase4 = (tr, dispatch, $prev, $head, $last)=>{
    /* CASE 4
	 * Initial Structure:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {       //May be multiple levels of lists
	 *           ...Children G
	 *           ListItem H {        //Last node of the block
	 *             ...Children I
	 *             Paragraph J { text2 |$last||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
	 *           }
	 *         }
	 *       ...
	 *     |childrenOInsertPosition| }
	 *   |$prev| }
	 *   ListItem K {
	 *      Paragraph L { |$head| text3 }
	 *      ...Children M
	 *      List? N {
	 *       ...Children O
	 *      }
	 *   }
	 * }
	 *
	 * Converts to:
	 *
	 * List A {
	 *   ListItem B {
	 *     Paragraph C { text1 }
	 *     ...Children D
	 *     List E {
	 *       ...
	 *         List F {
	 *           ...Children G
	 *           ListItem H {
	 *             ...Children I
	 *             Paragraph J { text2text3 }
	 *             ...Children M
	 *           }
	 *         }
	 *       ...
	 *       ...Children O
	 *     }
	 *   }
	 * }
	 *
	 */ if (!$last) //Exit if an invalid last was given as a parameter
    return false;
    const listItemK = $head.node(-1); //Head is inside listItem K so it must have a first and last child
    const { fontSize: fontSize } = tr.doc.type.schema.marks;
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const paragraphL = $head.parent;
    const beforeListItemK = $head.before(-1);
    const afterParagraphJ = $last.after();
    const afterListItemK = $head.after(-1);
    const containsChildrenO = (0, $aXHNB.isListNode)(listItemK.lastChild);
    const textInsertPos = $last.pos;
    const childrenMInsertPos = afterParagraphJ;
    const childrenOInsertPos = $prev.pos - 1; //Last item of listItem B must be a list therefore we can simply decrement $prev to get there
    const textContent = paragraphL.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $cSlMN.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    if (fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
        const targetParagraphFontSizeAttrs = (0, $bVxZJ.getBlockMarkAttrs)($last.parent, fontSize);
        (0, $bVxZJ.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(textInsertPos), fontSize, targetParagraphFontSizeAttrs);
    }
    if (dispatch) dispatch(tr);
    return true;
};
const $1caea1c6baa80a52$var$BACKSPACE_COMMANDS = {
    [(0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS]: $1caea1c6baa80a52$var$listBackspaceCase2,
    [(0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT]: $1caea1c6baa80a52$var$listBackspaceCase3,
    [(0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT]: $1caea1c6baa80a52$var$listBackspaceCase4
};
const $1caea1c6baa80a52$export$c60ae92c9826748a = (walkNode, $head, tr)=>{
    const { $pos: $prev, foundNode: prevFoundNode } = walkNode;
    const prevInList = (0, $15716090c6bb5c37$export$4639440f68939b8a)($prev);
    const headInParagraph = (0, $15716090c6bb5c37$export$27bb641e25fad24d)($head);
    const headInFirstChild = $head.index(-1) === 0;
    const headInList = (0, $15716090c6bb5c37$export$4639440f68939b8a)($head);
    //Must be at the start of the selection of the first child in the listItem
    if (!prevFoundNode || !prevInList || !headInParagraph || !headInFirstChild || !headInList) return false;
    const prevInParagraph = (0, $15716090c6bb5c37$export$27bb641e25fad24d)($prev);
    if (prevInParagraph) return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        null
    ];
    const prevParentLastChildIsList = $prev.parent.lastChild && (0, $aXHNB.isListNode)($prev.parent.lastChild);
    const prevParentLastChildIsParagraph = (0, $51m9Q.isParagraphNode)($prev.parent.lastChild);
    // Will search for the possible last node for case 4 (where the list could be indented multiple times)
    // $last is required to determine whether we are in case 2 or 4
    let $last = tr.doc.resolve($prev.pos);
    let lastFoundNode;
    do {
        const walkNode = (0, $77KCc.walkPrevNode)($last);
        $last = walkNode.$pos;
        lastFoundNode = walkNode.foundNode;
    }while (lastFoundNode && !$last.parent.isTextblock);
    const lastInParagraph = (0, $15716090c6bb5c37$export$27bb641e25fad24d)($last);
    if (lastFoundNode && prevParentLastChildIsList && lastInParagraph) return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT,
        $last
    ];
    else if (prevParentLastChildIsParagraph) return [
        (0, $iaHsT.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        null
    ];
    return false;
};
const $1caea1c6baa80a52$export$7d25b69a3ad4526e = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $77KCc.walkPrevNode)($head);
        if (!(0, $77KCc.isEmptySelectionAtStart)(state)) return false;
        const scenario = $1caea1c6baa80a52$export$c60ae92c9826748a(walkNode, $head, tr);
        if (!scenario) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $bjg0G.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD,
                direction: (0, $iaHsT.DELETE_DIRECTION).BACKWARD,
                scenario: scenario[0]
            }
        })(tr);
        return $1caea1c6baa80a52$var$BACKSPACE_COMMANDS[scenario[0]](tr, dispatch, walkNode.$pos, $head, scenario[1]);
    };











var $3Wkl8 = parcelRequire("3Wkl8");


var $hqLXn = parcelRequire("hqLXn");


var $di3bZ = parcelRequire("di3bZ");





var $hJh89 = parcelRequire("hJh89");

var $hnsob = parcelRequire("hnsob");

const $d5c800ae1cd773fe$export$eb55a67f55930af1 = 6;




var $iwBlG = parcelRequire("iwBlG");

var $dxhaW = parcelRequire("dxhaW");









/**
 * Returns true if a listItem has at least one non-list child (paragraph, etc.).
 */ function $0053c3aab8515d12$var$hasContentChildren(listItem) {
    return listItem.children.some((child)=>!(0, $aXHNB.isListNode)(child));
}
/**
 * Compute the size of non-list (content) children of a listItem, which
 * represents the "visible" bounds of the item for selection purposes.
 */ function $0053c3aab8515d12$var$contentSize(listItem) {
    return listItem.children.reduce((size, child)=>{
        return size + ((0, $aXHNB.isListNode)(child) ? 0 : child.nodeSize);
    }, 0);
}
/**
 * Flattens a list, splitting each list item into one item per run of content.
 * An item like `li(p, ul, p, ul)` becomes separate sibling items, so content
 * placed between sub-lists keeps its order. Also records which items the
 * selection touches.
 */ function $0053c3aab8515d12$var$flattenListImpl(options) {
    const { doc: doc, rootListStart: rootListStart, selectionFrom: selectionFrom, selectionTo: selectionTo, indentDelta: indentDelta, maxDepth: maxDepth } = options;
    const rootList = doc.nodeAt(rootListStart);
    if (!rootList) return null;
    const schema = rootList.type.schema;
    const items = [];
    let startIndex = -1;
    let endIndex = -1;
    let exceedsMaxDepth = false;
    const isPointSelection = selectionFrom === selectionTo;
    const pushSegment = (segmentNode, contentStart, contentEnd, depth, parentList)=>{
        const isSelected = isPointSelection ? selectionFrom >= contentStart && selectionFrom <= contentEnd : contentStart < selectionTo && contentEnd > selectionFrom;
        const effectiveDepth = depth + (isSelected ? indentDelta : 0);
        items.push({
            node: segmentNode,
            pos: contentStart - 1,
            depth: effectiveDepth,
            isSelected: isSelected,
            listType: parentList.type.name,
            parentListAttrs: parentList.attrs
        });
        if (isSelected) {
            const index = items.length - 1;
            if (startIndex === -1) startIndex = index;
            endIndex = index;
            if (maxDepth != null && effectiveDepth >= maxDepth) exceedsMaxDepth = true;
        }
    };
    const walkList = (listNode, listPos, depth)=>{
        let childPos = listPos + 1;
        listNode.forEach((listItemNode)=>{
            if (!(0, $gPewy.isListItemNode)(listItemNode)) {
                childPos += listItemNode.nodeSize;
                return;
            }
            const itemStart = childPos;
            let innerPos = itemStart + 1;
            // Content collected since the last sub-list. Each run becomes its own item.
            let segmentContent = [];
            let segmentContentStart = innerPos;
            let segmentContentSize = 0;
            const emitSegment = (parentList)=>{
                if (segmentContent.length === 0) return;
                const segmentItem = schema.nodes.listItem.create(listItemNode.attrs, segmentContent);
                pushSegment(segmentItem, segmentContentStart, segmentContentStart + segmentContentSize, depth, parentList);
            };
            listItemNode.forEach((child)=>{
                if ((0, $aXHNB.isListNode)(child)) {
                    // A sub-list ends the current run: emit it, then walk the sub-list deeper.
                    emitSegment(listNode);
                    segmentContent = [];
                    segmentContentSize = 0;
                    walkList(child, innerPos, depth + 1);
                    innerPos += child.nodeSize;
                    segmentContentStart = innerPos;
                } else {
                    if (segmentContent.length === 0) segmentContentStart = innerPos;
                    segmentContent.push(child);
                    segmentContentSize += child.nodeSize;
                    innerPos += child.nodeSize;
                }
            });
            // Emit any remaining content after the last sub-list.
            emitSegment(listNode);
            childPos += listItemNode.nodeSize;
        });
    };
    walkList(rootList, rootListStart, 0);
    if (items.length === 0 || startIndex === -1 || exceedsMaxDepth) return null;
    return {
        items: items,
        startIndex: startIndex,
        endIndex: endIndex
    };
}
function $0053c3aab8515d12$export$8824054d4a42eac8(options) {
    if ((0, $iDrrr.fg)('platform_editor_flexible_list_normalization_fix')) return $0053c3aab8515d12$var$flattenListImpl(options);
    return (0, $dxhaW.flattenList)(options, {
        isContentNode: (node, parent)=>(0, $gPewy.isListItemNode)(node) && $0053c3aab8515d12$var$hasContentChildren(node) && (0, $aXHNB.isListNode)(parent),
        // +1 shifts from the listItem node boundary to the start of its content children
        getSelectionBounds: (node, pos)=>({
                start: pos + 1,
                end: pos + 1 + $0053c3aab8515d12$var$contentSize(node)
            }),
        getDepth: (resolvedDepth, rootDepth)=>(resolvedDepth - rootDepth - 1) / 2
    });
}
/**
 * Extract non-list (content) children from a listItem node.
 */ function $0053c3aab8515d12$var$extractContentChildren(listItem) {
    const children = [];
    for(let i = 0; i < listItem.childCount; i++){
        const child = listItem.child(i);
        if (!(0, $aXHNB.isListNode)(child)) children.push(child);
    }
    return children;
}
/**
 * Rebuild a ProseMirror list tree from a flat array of `FlattenedItem` objects
 * using a bottom-up stack approach.
 *
 * The algorithm tracks open list/listItem wrappers on a stack. As depth
 * transitions occur between consecutive elements, wrapper nodes are opened
 * (depth increase) or closed (depth decrease).
 */ function $0053c3aab8515d12$var$rebuildPMList(elements, schema) {
    if (elements.length === 0) return null;
    const stack = [];
    function openList(listType, listAttrs) {
        stack.push({
            listType: listType,
            listAttrs: listAttrs,
            items: []
        });
    }
    /**
	 * Close lists on the stack down to `targetDepth`, wrapping each closed
	 * list into the last listItem of its parent.
	 */ function closeToDepth(targetDepth) {
        while(stack.length > targetDepth + 1){
            const closed = stack.pop();
            if (!closed) break;
            const listNode = schema.nodes[closed.listType].create(closed.listAttrs, closed.items);
            // Attach the closed list to the last listItem on the parent frame
            const parentFrame = stack[stack.length - 1];
            const lastItem = parentFrame.items[parentFrame.items.length - 1];
            if (lastItem) {
                // Append the nested list to this listItem's children
                const newContent = [];
                lastItem.forEach((child)=>newContent.push(child));
                newContent.push(listNode);
                parentFrame.items[parentFrame.items.length - 1] = schema.nodes.listItem.create(lastItem.attrs, newContent);
            } else {
                // Edge case: no listItem to attach to. Create a wrapper.
                const wrapperItem = schema.nodes.listItem.create(null, [
                    listNode
                ]);
                parentFrame.items.push(wrapperItem);
            }
        }
    }
    // Seed the root list with the first element's parent list attributes
    openList(elements[0].listType, elements[0].parentListAttrs);
    for (const el of elements){
        const targetDepth = el.depth;
        // Close lists if we're going shallower
        if (stack.length > targetDepth + 1) closeToDepth(targetDepth);
        // Open lists if we need to go deeper.
        // We do NOT create wrapper listItems here — closeToDepth handles
        // creating wrappers that contain only the nested list (no empty paragraph).
        // For unselected elements, the list structure already existed so we
        // preserve the parent list's attributes. For selected (moved) elements,
        // this is a new nesting level so we use null (the localId plugin will
        // backfill a fresh UUID).
        while(stack.length < targetDepth + 1)openList(el.listType, el.isSelected ? null : el.parentListAttrs);
        // Build the listItem for this element using its content children
        const contentChildren = $0053c3aab8515d12$var$extractContentChildren(el.node);
        const listItem = schema.nodes.listItem.create(el.node.attrs, contentChildren);
        stack[stack.length - 1].items.push(listItem);
    }
    // Close all remaining open lists
    closeToDepth(0);
    const root = stack[0];
    const rebuilt = schema.nodes[root.listType].create(root.listAttrs, root.items);
    // Compute content start offsets by walking the rebuilt tree.
    const contentStartOffsets = new Array(elements.length);
    let segIdx = 0;
    rebuilt.descendants((node, pos)=>{
        if ((0, $gPewy.isListItemNode)(node) && $0053c3aab8515d12$var$hasContentChildren(node)) {
            // +1 for rebuilt's opening tag, +1 for listItem's opening tag
            contentStartOffsets[segIdx] = 1 + pos + 1;
            segIdx++;
        }
        return true;
    });
    return {
        node: rebuilt,
        contentStartOffsets: contentStartOffsets
    };
}
function $0053c3aab8515d12$export$861e2120f3e445e9(elements, schema) {
    return (0, $iwBlG.buildReplacementFragment)({
        items: elements,
        schema: schema,
        rebuildFn: $0053c3aab8515d12$var$rebuildPMList,
        extractContentFn: (item)=>$0053c3aab8515d12$var$extractContentChildren(item.node)
    });
}


function $11ab465691864a3c$export$d06b49236c055472(tr, indentDelta) {
    const originalSelection = tr.selection;
    const rootListResolved = (0, $6ddfc8bedba79b46$export$cd55a6653375f672)(originalSelection.$from);
    if (!rootListResolved) return;
    const rootList = (0, $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7)(rootListResolved);
    if (!rootList) return;
    const rootListStart = rootList.pos;
    const rootListEnd = rootListStart + rootList.node.nodeSize;
    const result = (0, $0053c3aab8515d12$export$8824054d4a42eac8)({
        doc: tr.doc,
        rootListStart: rootListStart,
        rootListEnd: rootListEnd,
        selectionFrom: originalSelection.from,
        selectionTo: originalSelection.to,
        indentDelta: indentDelta,
        maxDepth: (0, $d5c800ae1cd773fe$export$eb55a67f55930af1)
    });
    if (!result) return;
    const { items: items, startIndex: startIndex, endIndex: endIndex } = result;
    const { fragment: fragment, contentStartOffsets: contentStartOffsets } = (0, $0053c3aab8515d12$export$861e2120f3e445e9)(items, tr.doc.type.schema);
    if (fragment.size === 0) return;
    // Narrow the replacement to the minimal changed range for collab-friendly
    // cursor preservation on unaffected list items.
    const narrowed = (0, $hnsob.narrowReplacementRange)(tr.doc, rootListStart, rootListEnd, fragment, contentStartOffsets);
    tr.replaceWith(narrowed.start, narrowed.end, narrowed.fragment);
    const { from: from, to: to } = (0, $hJh89.computeSelectionOffsets)({
        items: items,
        startIndex: startIndex,
        endIndex: endIndex,
        originalFrom: originalSelection.from,
        originalTo: originalSelection.to,
        contentStartOffsets: narrowed.adjustedContentStartOffsets,
        rootListStart: narrowed.start,
        docSize: tr.doc.content.size
    });
    (0, $hJh89.restoreSelection)({
        tr: tr,
        originalSelection: originalSelection,
        from: from,
        to: to
    });
}








var $32JQq = parcelRequire("32JQq");





var $eTXkv = parcelRequire("eTXkv");














const $944b09e564183800$export$8a03eb72bd3998d1 = 'restartListsAnalytics';
const $944b09e564183800$export$a5d23221f6e92f0d = (tr)=>tr.getMeta($944b09e564183800$export$8a03eb72bd3998d1) ?? {};
const $944b09e564183800$export$2279077d1a24e505 = (tr, attributes)=>{
    const meta = $944b09e564183800$export$a5d23221f6e92f0d(tr);
    tr.setMeta($944b09e564183800$export$8a03eb72bd3998d1, {
        ...meta,
        ...attributes
    });
};




const $f9d9e86e6414cca6$export$af0010ffaabe3f83 = (tr)=>{
    const originalSelection = tr.selection;
    const normalizedSelection = (0, $32JQq.normalizeListItemsSelection)({
        selection: tr.selection,
        doc: tr.doc
    });
    const rootList = (0, $6ddfc8bedba79b46$export$cd55a6653375f672)(normalizedSelection.$from);
    if (!rootList) return;
    const commonList = normalizedSelection.$from.blockRange(rootList, (0, $aXHNB.isListNode));
    if (!commonList) return;
    let hasNormalizedToPositionLiftedOut = false;
    let hasNormalizedFromPositionLiftedOut = false;
    const { from: oldFrom, to: oldTo } = normalizedSelection;
    const nodeRanges = $f9d9e86e6414cca6$var$splitRangeSelection(normalizedSelection);
    nodeRanges.forEach((range)=>{
        const $from = tr.doc.resolve(tr.mapping.map(range.from));
        const $to = tr.doc.resolve(tr.mapping.map(range.to));
        const mappedRange = $from.blockRange($to, (0, $aXHNB.isListNode));
        if (!mappedRange) return;
        if ((0, $gPewy.isListItemNode)($from.node(mappedRange.depth - 1))) $f9d9e86e6414cca6$var$outdentRangeToParentList({
            tr: tr,
            range: mappedRange
        });
        else {
            $f9d9e86e6414cca6$var$extractListItemsRangeFromList({
                tr: tr,
                range: mappedRange
            });
            hasNormalizedToPositionLiftedOut = hasNormalizedToPositionLiftedOut || oldTo >= range.from && oldTo < range.to;
            hasNormalizedFromPositionLiftedOut = hasNormalizedFromPositionLiftedOut || oldFrom >= range.from && oldFrom < range.to;
        }
    });
    const hasCommonListMoved = commonList.start !== tr.mapping.map(commonList.start);
    const nextSelection = $f9d9e86e6414cca6$var$calculateNewSelection({
        originalSelection: originalSelection,
        normalizedSelection: normalizedSelection,
        tr: tr,
        hasCommonListMoved: hasCommonListMoved,
        hasNormalizedToPositionLiftedOut: hasNormalizedToPositionLiftedOut,
        hasNormalizedFromPositionLiftedOut: hasNormalizedFromPositionLiftedOut
    });
    tr.setSelection(nextSelection);
    // processNestedTaskListsInSameLevel(tr);
    (0, $9b333e0f090d351f$export$e400d0e3efb40bf0)({
        tr: tr,
        direction: (0, $2CYgA.JoinDirection).RIGHT
    });
};
const $f9d9e86e6414cca6$var$calculateNewSelection = ({ tr: tr, originalSelection: originalSelection, normalizedSelection: normalizedSelection, hasCommonListMoved: hasCommonListMoved, hasNormalizedToPositionLiftedOut: hasNormalizedToPositionLiftedOut, hasNormalizedFromPositionLiftedOut: hasNormalizedFromPositionLiftedOut })=>{
    const { $from: $from, $to: $to } = normalizedSelection;
    const isCursorSelection = normalizedSelection.empty;
    let from = tr.mapping.map($from.pos);
    let to = tr.mapping.map($to.pos);
    const LIST_STRUCTURE_CHANGED_OFFSET = 2;
    const isToFromSameListItem = $from.sameParent($to);
    if (hasNormalizedFromPositionLiftedOut) {
        const fromMapped = isToFromSameListItem ? $from.pos : from;
        from = hasNormalizedFromPositionLiftedOut ? $from.pos : fromMapped;
        from = hasCommonListMoved ? from - LIST_STRUCTURE_CHANGED_OFFSET : from;
        from = Math.max(from, 0);
    }
    if (hasNormalizedToPositionLiftedOut) {
        const toMapped = isToFromSameListItem ? $to.pos : to;
        to = hasNormalizedToPositionLiftedOut ? $to.pos : toMapped;
        to = hasCommonListMoved ? to - LIST_STRUCTURE_CHANGED_OFFSET : to;
        to = Math.min(to, tr.doc.nodeSize - 2);
    }
    if (normalizedSelection instanceof (0, $4EksL.GapCursorSelection)) {
        const nextSelectionFrom = tr.doc.resolve(from);
        return new (0, $4EksL.GapCursorSelection)(nextSelectionFrom, normalizedSelection.side);
    }
    if (originalSelection instanceof (0, $kCECX.NodeSelection)) return (0, $kCECX.NodeSelection).create(tr.doc, from);
    if (isCursorSelection) return (0, $kCECX.TextSelection).between(tr.doc.resolve(to), tr.doc.resolve(to), -1);
    return (0, $kCECX.TextSelection).between(tr.doc.resolve(from), tr.doc.resolve(to), -1);
};
const $f9d9e86e6414cca6$var$splitRangeSelection = (selection)=>{
    const commonListRange = (0, $15716090c6bb5c37$export$44fa515643dd6860)({
        selection: selection
    });
    if (!commonListRange) return [];
    const { $from: $from, $to: $to } = selection;
    if ($from.pos === $to.pos && $from.sameParent($to)) return [
        {
            from: commonListRange.start,
            to: commonListRange.end,
            depth: commonListRange.depth
        }
    ];
    const lastListItem = $f9d9e86e6414cca6$var$findPreviousListItemSibling($from);
    if (!lastListItem) return [];
    const nodeRanges = [];
    const { doc: doc } = $from;
    let previousListItem = $f9d9e86e6414cca6$var$findPreviousListItemSibling($to);
    while(previousListItem && previousListItem.pos >= lastListItem.pos && previousListItem.pos >= commonListRange.start){
        const node = doc.nodeAt(previousListItem.pos);
        if (!node || !(0, $gPewy.isListItemNode)(node)) return [];
        let offset = 0;
        if (node && node.lastChild && (0, $aXHNB.isListNode)(node.lastChild)) offset = node.lastChild.nodeSize;
        const start = previousListItem.pos + 1;
        nodeRanges.push({
            from: start,
            to: doc.resolve(start).end() - offset,
            depth: previousListItem.depth
        });
        previousListItem = $f9d9e86e6414cca6$var$findPreviousListItemSibling(previousListItem);
    }
    return nodeRanges;
};
const $f9d9e86e6414cca6$var$outdentRangeToParentList = ({ tr: tr, range: range })=>{
    const end = range.end;
    const endOfList = range.$to.end(range.depth);
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    if (end < endOfList) {
        const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(listItem.create(null, range.parent.copy())), 1, 0);
        const step = new (0, $eOaGc.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, slice, 1, true);
        tr.step(step);
        range = new (0, $aPdNQ.NodeRange)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $eOaGc.liftTarget)(range);
    if (target) tr.lift(range, target);
};
const $f9d9e86e6414cca6$var$extractListItemsRangeFromList = ({ tr: tr, range: range })=>{
    const list = range.parent;
    const $start = tr.doc.resolve(range.start);
    const listStart = $start.start(range.depth);
    const listEnd = $start.end(range.depth);
    const isAtTop = listStart === range.start;
    const isAtBottom = listEnd === range.end;
    const isTheEntireList = isAtTop && isAtBottom;
    let listItemContent = isAtTop ? (0, $aPdNQ.Fragment).empty : (0, $aPdNQ.Fragment).from(list.copy((0, $aPdNQ.Fragment).empty));
    for(let i = range.startIndex; i < range.endIndex; i++)listItemContent = listItemContent.append(list.child(i).content);
    if (isAtTop) for(let i = 0; i < listItemContent.childCount; i++){
        const child = listItemContent.child(i);
        if (child && (0, $aXHNB.isListNode)(child) && child.type !== list.type) {
            const newNestedList = list.type.create(null, child.content);
            listItemContent = listItemContent.replaceChild(i, newNestedList);
        }
    }
    const nextList = list.copy((0, $aPdNQ.Fragment).empty);
    let nextListStartNumber;
    // if splitting a numbered list, keep the splitted item
    // counter as the start of the next (second half) list (instead
    // of reverting back to 1 as a starting number)
    const order = (0, $eTXkv.getOrderFromOrderedListNode)(list);
    if (list.type.name === 'orderedList') {
        nextListStartNumber = range.endIndex - 1 + order;
        // @ts-ignore - [unblock prosemirror bump] assigning to readonly attrs
        nextList.attrs = {
            ...nextList.attrs,
            order: nextListStartNumber
        };
        const { splitListStartNumber: splitListStartNumber } = (0, $944b09e564183800$export$a5d23221f6e92f0d)(tr);
        if (typeof splitListStartNumber !== 'number') (0, $944b09e564183800$export$2279077d1a24e505)(tr, {
            splitListStartNumber: nextListStartNumber
        });
    }
    const nextListFragment = listItemContent.append((0, $aPdNQ.Fragment).from(nextList));
    // if the split list with nextListStartNumber is below another list
    // with order (e.g due to multi-level indent items being lifted), track the
    // list above's order instead, as it will be the split list's order after sibling joins
    nextListFragment.forEach((node, _offset, index)=>{
        if (node.type.name === 'orderedList' && node.attrs?.order === nextListStartNumber) {
            const prev = nextListFragment.child(index - 1);
            if (prev?.attrs?.order >= 0) (0, $944b09e564183800$export$2279077d1a24e505)(tr, {
                splitListStartNumber: prev?.attrs?.order
            });
        }
    });
    if (isTheEntireList) {
        const slice = new (0, $aPdNQ.Slice)(listItemContent, 0, 0);
        const step = new (0, $eOaGc.ReplaceStep)($start.pos - 1, range.end + 1, slice, false);
        (0, $944b09e564183800$export$2279077d1a24e505)(tr, {
            outdentScenario: undefined
        });
        tr.step(step);
    } else if (isAtTop) {
        const slice = new (0, $aPdNQ.Slice)(nextListFragment, 0, 1);
        const step = new (0, $eOaGc.ReplaceStep)($start.pos - 1, range.end, slice, false);
        tr.step(step);
    } else if (isAtBottom) {
        const slice = new (0, $aPdNQ.Slice)(listItemContent, 1, 0);
        const step = new (0, $eOaGc.ReplaceStep)($start.pos, listEnd + 1, slice, false);
        tr.step(step);
    } else {
        (0, $944b09e564183800$export$2279077d1a24e505)(tr, {
            outdentScenario: (0, $iaHsT.OUTDENT_SCENARIOS).SPLIT_LIST
        });
        const slice = new (0, $aPdNQ.Slice)(nextListFragment, 1, 1);
        const step = new (0, $eOaGc.ReplaceAroundStep)($start.pos, listEnd, range.end, listEnd, slice, slice.size, false);
        tr.step(step);
    }
};
const $f9d9e86e6414cca6$var$findPreviousListItemSibling = ($pos)=>{
    const doc = $pos.doc;
    const isPositionListItem = (0, $aXHNB.isListNode)($pos.node());
    const listItemPosition = $pos;
    if (!isPositionListItem) {
        const listItem = (0, $6ddfc8bedba79b46$export$112d93610a31ac47)($pos);
        if (!listItem) return null;
        return doc.resolve(listItem.pos);
    }
    const resolved = doc.resolve(listItemPosition.pos);
    const foundPosition = (0, $kCECX.Selection).findFrom(resolved, -1);
    if (!foundPosition) return null;
    const parentListItemNode = (0, $6ddfc8bedba79b46$export$112d93610a31ac47)(foundPosition.$from);
    if (!parentListItemNode) return null;
    return doc.resolve(parentListItemNode.pos);
};





/**
 * Handler for flexible list outdentation.
 * Lifts items independently and cleans up wrapper structures.
 */ const $174364528088cbb3$var$handleOutdentListItems = (tr, editorAnalyticsAPI, inputMethod)=>{
    (0, $11ab465691864a3c$export$d06b49236c055472)(tr, -1);
    // If no changes were made, handle based on context
    if (!tr.docChanged) // If inside table cell and can't outdent list, then let it handle by table keymap
    return !(0, $15716090c6bb5c37$export$cb2b92f281f91c40)(tr) ? new (0, $3Wkl8.PassiveTransaction)() : null;
    // Determine the action subject ID from the parent list type
    const { selection: { $from: $from } } = tr;
    const currentListNode = (0, $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7)($from)?.node;
    const actionSubjectId = currentListNode && (0, $hqLXn.isBulletList)(currentListNode) ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    // Get restart list attributes for analytics
    const restartListsAttributes = {};
    const { outdentScenario: outdentScenario, splitListStartNumber: splitListStartNumber } = (0, $944b09e564183800$export$a5d23221f6e92f0d)(tr);
    if (outdentScenario === (0, $iaHsT.OUTDENT_SCENARIOS).SPLIT_LIST) {
        restartListsAttributes.outdentScenario = outdentScenario;
        restartListsAttributes.splitListStartNumber = splitListStartNumber;
    }
    // Attach analytics event with flexibleIndentation attribute
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).OUTDENTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            ...(0, $3TgtB.getCommonListAnalyticsAttributes)(tr),
            ...restartListsAttributes,
            inputMethod: inputMethod
        }
    })(tr);
    return tr;
};
const $174364528088cbb3$export$959569198ddbbe17 = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            if (!(0, $15716090c6bb5c37$export$fd64e4ef922c42f3)(tr)) return null;
            const { $from: $from } = tr.selection;
            const parentListNode = (0, $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7)($from);
            if (!parentListNode) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            return new (0, $3Wkl8.PassiveTransaction)();
            // Save the history, so it could undo/revert to the same state before the outdent, see https://product-fabric.atlassian.net/browse/ED-14753
            (0, $di3bZ.closeHistory)(tr);
            // Route to new or original implementation based on feature flag
            if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) return $174364528088cbb3$var$handleOutdentListItems(tr, editorAnalyticsAPI, inputMethod);
            const actionSubjectId = (0, $hqLXn.isBulletList)(parentListNode.node) ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            const customTr = tr;
            (0, $f9d9e86e6414cca6$export$af0010ffaabe3f83)(customTr);
            if (!customTr || !customTr.docChanged) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            // If inside table cell and can't outdent list, then let it handle by table keymap
            return !(0, $15716090c6bb5c37$export$cb2b92f281f91c40)(customTr) ? new (0, $3Wkl8.PassiveTransaction)() : null;
            const restartListsAttributes = {};
            const { outdentScenario: outdentScenario, splitListStartNumber: splitListStartNumber } = (0, $944b09e564183800$export$a5d23221f6e92f0d)(customTr);
            if (outdentScenario === (0, $iaHsT.OUTDENT_SCENARIOS).SPLIT_LIST) {
                restartListsAttributes.outdentScenario = outdentScenario;
                restartListsAttributes.splitListStartNumber = splitListStartNumber;
            }
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).OUTDENTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                actionSubjectId: actionSubjectId,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    ...(0, $3TgtB.getCommonListAnalyticsAttributes)(customTr),
                    ...restartListsAttributes,
                    inputMethod: inputMethod
                }
            })(customTr);
            return customTr;
        };
    };


const $8b7713d756143665$export$476a01d760cd8a14 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection.empty) {
                const { $from: $from } = selection;
                const { listItem: listItem, codeBlock: codeBlock } = state.schema.nodes;
                // the list item is the parent of the gap cursor
                // while for text, list item is the grandparent of the text node
                const isGapCursorSelection = selection instanceof (0, $4EksL.GapCursorSelection);
                const wrapper = isGapCursorSelection ? $from.parent : $from.node($from.depth - 1);
                if (wrapper && wrapper.type === listItem) {
                    /** Check if the wrapper has any visible content */ const wrapperHasContent = (0, $5Q6OE.hasVisibleContent)(wrapper);
                    if (!wrapperHasContent) return (0, $aC6bW.editorCommandToPMCommand)((0, $174364528088cbb3$export$959569198ddbbe17)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD))(state, dispatch);
                    else if (!(0, $bjg0G.hasParentNodeOfType)(codeBlock)(selection)) return $8b7713d756143665$var$splitListItem(listItem)(state, dispatch);
                }
            }
            return false;
        };
const $8b7713d756143665$export$c1d6e1a8db28fd58 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            // Select an adjacent syncBlock before the list command chain can outdent the current list.
            if ((0, $77KCc.isEmptySelectionAtStart)(state) && (0, $iDrrr.fg)('platform_editor_blocks_patch_7')) {
                const $cut = (0, $9WBFV.findCutBefore)(state.selection.$from);
                if ($cut?.nodeBefore?.type.name === 'syncBlock') {
                    if (dispatch) dispatch(state.tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, $cut.pos - $cut.nodeBefore.nodeSize)).scrollIntoView());
                    return true;
                }
            }
            return (0, $iUNgd.chainCommands)((0, $1caea1c6baa80a52$export$7d25b69a3ad4526e)(editorAnalyticsAPI), // if we're at the start of a list item, we need to either backspace
            // directly to an empty list item above, or outdent this node
            (0, $dTPhv.filter)([
                (0, $77KCc.isEmptySelectionAtStart),
                // list items might have multiple paragraphs; only do this at the first one
                (0, $b7947b8c3968a6d0$export$1d357fa6aecde5b8),
                (state)=>(0, $15716090c6bb5c37$export$fd64e4ef922c42f3)(state.tr)
            ], (0, $iUNgd.chainCommands)($8b7713d756143665$var$deletePreviousEmptyListItem, (0, $aC6bW.editorCommandToPMCommand)((0, $174364528088cbb3$export$959569198ddbbe17)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)))), // if we're just inside a paragraph node (or gapcursor is shown) and backspace, then try to join
            // the text to the previous list item, if one exists
            (0, $dTPhv.filter)([
                (0, $77KCc.isEmptySelectionAtStart),
                (state)=>(0, $15716090c6bb5c37$export$6ec51e240036c4ab)(state.tr)
            ], $8b7713d756143665$var$joinToPreviousListItem))(state, dispatch);
        };
const $8b7713d756143665$export$ca522099b17e5b55 = (editorAnalyticsAPI)=>(0, $fc648a393d823459$export$6851baf5987dd2cb)(editorAnalyticsAPI);
const $8b7713d756143665$export$3ee0594e8fdf55d5 = (pos, nodes)=>{
    const { bulletList: bulletList, orderedList: orderedList, listItem: listItem } = nodes;
    let depth;
    for(let i = pos.depth - 1; i > 0; i--){
        const node = pos.node(i);
        if (node.type === bulletList || node.type === orderedList) depth = i;
        if (node.type !== bulletList && node.type !== orderedList && node.type !== listItem) break;
    }
    return depth;
};
function $8b7713d756143665$var$untoggleSelectedList(tr) {
    const { selection: selection } = tr;
    const depth = $8b7713d756143665$export$3ee0594e8fdf55d5(selection.$to, tr.doc.type.schema.nodes);
    tr = (0, $2b4d25e51054885d$export$4ed538bc5a7d756f)(selection.$to.pos, selection.$to.end(depth), depth || 0, tr);
    if (selection instanceof (0, $kCECX.NodeSelection) || selection instanceof (0, $4EksL.GapCursorSelection)) return (0, $2b4d25e51054885d$export$2b630c4fa336fee7)(selection, tr);
    return (0, $2b4d25e51054885d$export$a88bd9b6e3aac8d6)(selection, tr);
}
const $8b7713d756143665$export$78da663726cb9398 = (editorAnalyticsAPI)=>(inputMethod, listType)=>{
        return function({ tr: tr }) {
            const { taskList: taskList } = tr.doc.type.schema.nodes;
            if ((0, $bjg0G.hasParentNodeOfType)(taskList)(tr.selection)) return tr;
            const listInsideSelection = (0, $15716090c6bb5c37$export$f0dda2b070101c76)(tr);
            const listNodeType = tr.doc.type.schema.nodes[listType];
            const actionSubjectId = listType === 'bulletList' ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            if (listInsideSelection) {
                const { selection: selection } = tr;
                // for gap cursor or node selection - list is expected 1 level up (listItem -> list)
                // for text selection - list is expected 2 levels up (paragraph -> listItem -> list)
                const positionDiff = selection instanceof (0, $4EksL.GapCursorSelection) || selection instanceof (0, $kCECX.NodeSelection) ? 1 : 2;
                const fromNode = selection.$from.node(selection.$from.depth - positionDiff);
                const toNode = selection.$to.node(selection.$to.depth - positionDiff);
                const transformedFrom = listInsideSelection.type.name === 'bulletList' ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                if (fromNode?.type.name === listType && toNode?.type.name === listType) {
                    const commonAttributes = (0, $3TgtB.getCommonListAnalyticsAttributes)(tr);
                    $8b7713d756143665$var$untoggleSelectedList(tr);
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).CONVERTED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TEXT,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            ...commonAttributes,
                            transformedFrom: transformedFrom,
                            inputMethod: inputMethod
                        }
                    })(tr);
                    return tr;
                }
                (0, $76ec2b16794afe73$export$193e29566e093d19)({
                    tr: tr,
                    nextListNodeType: listNodeType
                });
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CONVERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        ...(0, $3TgtB.getCommonListAnalyticsAttributes)(tr),
                        transformedFrom: transformedFrom,
                        inputMethod: inputMethod
                    }
                })(tr);
            } else {
                // Need to have this before wrapInList so the wrapping is done with valid content
                // For example, if trying to convert centre or right aligned paragraphs to lists
                (0, $32fcf02f6bd510e5$export$bec007f49d03125c)(tr, listNodeType);
                (0, $10c5013ef83e12a6$export$dc4f1f9730c3e037)(listNodeType, tr);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod
                    }
                })(tr);
            }
            // If document wasn't changed, return false from the command to indicate that the
            // editing action failed
            if (!tr.docChanged) return null;
            return tr;
        };
    };
const $8b7713d756143665$export$c0e115f47553645e = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>{
        return $8b7713d756143665$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'bulletList');
    };
const $8b7713d756143665$export$dca848a1b50b6a31 = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>{
        return $8b7713d756143665$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'orderedList');
    };
/**
 * Implementation taken and modified for our needs from PM
 * @param itemType Node
 * Splits the list items, specific implementation take from PM
 */ function $8b7713d756143665$var$splitListItem(itemType) {
    return function(state, dispatch) {
        const ref = state.selection;
        const $from = ref.$from;
        const $to = ref.$to;
        const node = ref.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        // list item is the parent of the gap cursor instead of grandparent
        const isGapCursorSelection = ref instanceof (0, $4EksL.GapCursorSelection);
        const wrapperListItem = isGapCursorSelection ? $from.parent : $from.node(-1);
        if (wrapperListItem.type !== itemType) return false;
        /** --> The following line changed from the original PM implementation to allow list additions with multiple paragraphs */ if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrapperListItem.content.content.length <= 1 && $from.parent.content.size === 0 && !(wrapperListItem.content.size === 0)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== itemType || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $aPdNQ.Fragment).empty;
                const keepItem = $from.index(-1) > 0;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)wrap = (0, $aPdNQ.Fragment).from($from.node(d).copy(wrap));
                // Add a second list item with an empty default start node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                wrap = wrap.append((0, $aPdNQ.Fragment).from(itemType.createAndFill()));
                const tr$1 = state.tr.replace($from.before(keepItem ? undefined : -1), $from.after(-3), new (0, $aPdNQ.Slice)(wrap, keepItem ? 3 : 2, 2));
                tr$1.setSelection(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
                dispatch(tr$1.scrollIntoView());
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? wrapperListItem.contentMatchAt(0).defaultType : null;
        const tr = state.tr.delete($from.pos, $to.pos);
        const types = nextType && [
            null,
            {
                type: nextType
            }
        ];
        const fontSize = state.schema.marks.fontSize;
        const isFontSizeSupported = fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
        const currentFontSizeAttrs = isFontSizeSupported ? (0, $bVxZJ.getBlockMarkAttrs)($from.parent, fontSize) : false;
        if (dispatch) {
            if (ref instanceof (0, $kCECX.TextSelection)) {
                const splitTr = tr.split($from.pos, 2, types ?? undefined);
                if (isFontSizeSupported) (0, $bVxZJ.reconcileBlockMarkForParagraphAtPos)(splitTr, splitTr.selection.from, fontSize, currentFontSizeAttrs);
                dispatch(splitTr.scrollIntoView());
                return true;
            }
            // create new list item with empty paragraph when user clicks enter on gap cursor
            if (isGapCursorSelection && $from.nodeBefore?.isBlock) {
                // For gap cursor selection, we cannot split the list item directly
                // We need to insert a new list item after the current list item to simulate the split behaviour
                const { listItem: listItem, paragraph: paragraph } = state.schema.nodes;
                const newListItem = listItem.createChecked({}, paragraph.createChecked({}, undefined, currentFontSizeAttrs && isFontSizeSupported ? [
                    fontSize.create(currentFontSizeAttrs)
                ] : undefined));
                dispatch(tr.insert($from.pos, newListItem).setSelection((0, $kCECX.Selection).near(tr.doc.resolve($to.pos + 1))).scrollIntoView());
                return true;
            }
        }
        return false;
    };
}
const $8b7713d756143665$var$deletePreviousEmptyListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { listItem: listItem } = state.schema.nodes;
    const $cut = (0, $9WBFV.findCutBefore)($from);
    if (!$cut || !$cut.nodeBefore || !($cut.nodeBefore.type === listItem)) return false;
    const nodeBeforeIsExtension = $cut.nodeBefore.firstChild && $cut.nodeBefore.firstChild.type.name === 'extension';
    const previousListItemEmpty = // Ignored via go/ees005
    $cut.nodeBefore.childCount === 1 && $cut.nodeBefore.firstChild && $cut.nodeBefore.firstChild.nodeSize <= 2 && !nodeBeforeIsExtension;
    if (previousListItemEmpty) {
        const { tr: tr } = state;
        if (dispatch) dispatch(tr.delete($cut.pos - $cut.nodeBefore.nodeSize, $from.pos).scrollIntoView());
        return true;
    }
    return false;
};
const $8b7713d756143665$var$joinToPreviousListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { paragraph: paragraph, listItem: listItem, codeBlock: codeBlock, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    const { fontSize: fontSize } = state.schema.marks;
    const isGapCursorShown = state.selection instanceof (0, $4EksL.GapCursorSelection);
    const $cutPos = isGapCursorShown ? state.doc.resolve($from.pos + 1) : $from;
    const $cut = (0, $9WBFV.findCutBefore)($cutPos);
    if (!$cut) return false;
    // see if the containing node is a list
    if ($cut.nodeBefore && [
        bulletList,
        orderedList
    ].indexOf($cut.nodeBefore.type) > -1) // and the node after this is a paragraph or a codeBlock
    {
        if ($cut.nodeAfter && ($cut.nodeAfter.type === paragraph || $cut.nodeAfter.type === codeBlock)) {
            // find the nearest paragraph that precedes this node
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            while($lastNode.parent.type !== paragraph && $lastNode.pos > 1)$lastNode = state.doc.resolve($lastNode.pos - 1);
            let { tr: tr } = state;
            if (isGapCursorShown) {
                const nodeBeforePos = (0, $bjg0G.findPositionOfNodeBefore)(tr.selection);
                if (typeof nodeBeforePos !== 'number') return false;
                // append the codeblock to the list node
                const list = $cut.nodeBefore.copy($cut.nodeBefore.content.append((0, $aPdNQ.Fragment).from(listItem.createChecked({}, $cut.nodeAfter))));
                tr.replaceWith(nodeBeforePos, $from.pos + $cut.nodeAfter.nodeSize, list);
            } else {
                const step = (0, $e38cc9b115741c11$export$cbf2f67c120cb8dd)({
                    insertPosition: $lastNode.pos,
                    $target: $cut
                });
                // ED-13966: check if the step will cause an ProseMirror error
                // if there's an error don't apply the step as it will might lead into a data loss.
                // It doesn't play well with media being a leaf node.
                const stepResult = state.tr.maybeStep(step);
                if (stepResult.failed) return false;
                else tr = state.tr.step(step);
            }
            // find out if there's now another list following and join them
            // as in, [list, p, list] => [list with p, list], and we want [joined list]
            const $postCut = tr.doc.resolve(tr.mapping.map($cut.pos + $cut.nodeAfter.nodeSize));
            if ($postCut.nodeBefore && $postCut.nodeAfter && $postCut.nodeBefore.type === $postCut.nodeAfter.type && [
                bulletList,
                orderedList
            ].indexOf($postCut.nodeBefore.type) > -1) tr = tr.join($postCut.pos);
            if (fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
                const prevListFontSizeAttrs = (0, $bVxZJ.getFirstParagraphBlockMarkAttrs)($cut.nodeBefore, fontSize);
                const containingList = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(tr.mapping.map($cut.pos)), [
                    bulletList,
                    orderedList
                ]);
                if (containingList) (0, $bVxZJ.reconcileBlockMarkForContainerAtPos)(tr, containingList.pos, fontSize, prevListFontSizeAttrs);
            }
            if (dispatch) {
                if (!tr.doc.resolve($lastNode.pos).nodeBefore?.isBlock || tr.doc.resolve($lastNode.pos).nodeBefore === null) tr = tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(tr.mapping.map($cut.pos)), -1));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
};










var $kPujW = parcelRequire("kPujW");

const $d04cf8d85fd62307$export$925f3cc2bf62e47a = ({ tr: tr, maxIndentation: maxIndentation })=>{
    const initialIndentationLevel = (0, $kPujW.numberNestedLists)(tr.selection.$from);
    let currentIndentationLevel;
    let currentPos = tr.selection.$to.pos;
    do {
        const resolvedPos = tr.doc.resolve(currentPos);
        currentIndentationLevel = (0, $kPujW.numberNestedLists)(resolvedPos);
        if (currentIndentationLevel > maxIndentation) return false;
        currentPos++;
    }while (currentIndentationLevel >= initialIndentationLevel);
    return true;
};

































const $4a8273bba5eae97b$export$cbf684996d8a31a2 = (tr)=>{
    const originalSelection = tr.selection;
    const normalizedSelection = (0, $32JQq.normalizeListItemsSelection)({
        selection: originalSelection,
        doc: tr.doc
    });
    const { $from: $from, $to: $to } = normalizedSelection;
    const range = $4a8273bba5eae97b$var$calculateRange({
        selection: normalizedSelection
    });
    if (!range) return false;
    const listItemsSelected = {
        from: (0, $6ddfc8bedba79b46$export$112d93610a31ac47)($from),
        to: (0, $6ddfc8bedba79b46$export$112d93610a31ac47)($to)
    };
    if (listItemsSelected.from === null || listItemsSelected.to === null) return null;
    const resolvedPos = tr.doc.resolve(listItemsSelected.from.pos);
    const listItemIndex = resolvedPos.index();
    const positionListItemPosition = resolvedPos.posAtIndex(listItemIndex - 1);
    const currentListItemPosition = resolvedPos.posAtIndex(listItemIndex);
    const previousListItem = tr.doc.nodeAt(positionListItemPosition);
    const currentListItem = tr.doc.nodeAt(currentListItemPosition);
    const currentListItemContent = currentListItem?.content?.content;
    const hasLastItemExtension = currentListItemContent !== undefined && currentListItemContent?.length > 0 ? currentListItemContent[currentListItemContent.length - 1].type.name === 'extension' : false;
    if (!previousListItem || !(0, $gPewy.isListItemNode)(previousListItem)) return null;
    if ((0, $gPewy.isListItemNode)(previousListItem) && listItemIndex === 0) return null;
    const listItemSelectedCommonParent = range.parent;
    const previousNestedList = (0, $aXHNB.isListNode)(previousListItem.lastChild) ? previousListItem.lastChild : null;
    const listNodeType = previousNestedList ? previousNestedList.type : listItemSelectedCommonParent.type;
    const nestedList = listItemsSelected.to.node.lastChild;
    const nestedItemsOffset = nestedList && (0, $aXHNB.isListNode)(nestedList) ? nestedList.nodeSize : 0;
    const from = listItemsSelected.from.pos;
    const to = listItemsSelected.to.pos + listItemsSelected.to.node.nodeSize - nestedItemsOffset;
    const [sliceSelected, nestedListItemsLeftover] = $4a8273bba5eae97b$var$createIndentedListItemsSlice({
        tr: tr,
        listNodeType: listNodeType,
        range: range,
        from: from,
        to: to,
        hasLastItemExtension: hasLastItemExtension
    });
    const hasPreviousNestedList = Boolean(previousNestedList);
    const start = from - 1;
    tr.replaceRange(hasPreviousNestedList ? start - 1 : start, range.end, sliceSelected);
    const leftoverContentPosition = tr.mapping.map(to) - 2;
    if (nestedListItemsLeftover.openStart === 0) tr.insert(leftoverContentPosition, nestedListItemsLeftover.content);
    else tr.replace(leftoverContentPosition - nestedListItemsLeftover.openStart, leftoverContentPosition - nestedListItemsLeftover.openStart, nestedListItemsLeftover);
    const nextSelection = $4a8273bba5eae97b$var$calculateNewSelection({
        originalSelection: originalSelection,
        normalizedSelection: normalizedSelection,
        tr: tr,
        hasPreviousNestedList: hasPreviousNestedList
    });
    tr.setSelection(nextSelection);
};
const $4a8273bba5eae97b$var$calculateRange = ({ selection: selection })=>{
    const { $from: $from, $to: $to } = selection;
    const range = $from.blockRange($to, (0, $aXHNB.isListNode));
    if (!range) return null;
    return range;
};
const $4a8273bba5eae97b$var$calculateNewSelection = ({ tr: tr, normalizedSelection: normalizedSelection, originalSelection: originalSelection, hasPreviousNestedList: hasPreviousNestedList })=>{
    const offset = hasPreviousNestedList ? 2 : 0;
    const { $from: $from, $to: $to } = normalizedSelection;
    if (normalizedSelection instanceof (0, $4EksL.GapCursorSelection)) {
        const nextSelectionFrom = tr.doc.resolve($from.pos - offset);
        return new (0, $4EksL.GapCursorSelection)(nextSelectionFrom, normalizedSelection.side);
    }
    if (originalSelection instanceof (0, $kCECX.NodeSelection)) return (0, $kCECX.NodeSelection).create(tr.doc, $from.pos - offset);
    const { $from: nextSelectionFrom } = (0, $kCECX.Selection).near(tr.doc.resolve($from.pos - offset));
    const { $to: nextSelectionTo } = (0, $kCECX.Selection).near(tr.doc.resolve($to.pos - offset), -1);
    return new (0, $kCECX.TextSelection)(nextSelectionFrom, nextSelectionTo);
};
const $4a8273bba5eae97b$var$createIndentedListItemsSlice = ({ tr: tr, from: from, to: to, listNodeType: listNodeType, range: range, hasLastItemExtension: hasLastItemExtension })=>{
    const listItemsSlice = tr.doc.slice(from, hasLastItemExtension ? to : to - 2);
    const listFragment = (0, $aPdNQ.Fragment).from(listNodeType.create(null, listItemsSlice.content));
    const nonSelectedListItemsSlice = tr.doc.slice(to, range.end - 2);
    const openStart = tr.doc.slice(from - 1, range.end).openStart;
    const slice = new (0, $aPdNQ.Slice)(listFragment, openStart, 0);
    return [
        slice,
        nonSelectedListItemsSlice
    ];
};





/**
 * Handler for flexible list indentation.
 * Allows indenting the first item by creating wrapper structures.
 */ const $18c3db1d37f16708$var$handleIndentListItems = (tr, editorAnalyticsAPI, inputMethod)=>{
    (0, $11ab465691864a3c$export$d06b49236c055472)(tr, 1);
    // If no changes were made, return PassiveTransaction to prevent browser from handling this as a tab key event (e.g. moving focus)
    if (!tr.docChanged) return new (0, $3Wkl8.PassiveTransaction)();
    const { selection: { $from: $from } } = tr;
    const currentListNode = (0, $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7)($from)?.node;
    const actionSubjectId = currentListNode && (0, $hqLXn.isBulletList)(currentListNode) ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INDENTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            ...(0, $3TgtB.getCommonListAnalyticsAttributes)(tr),
            inputMethod: inputMethod
        }
    })(tr);
    return tr;
};
const $18c3db1d37f16708$export$8066a906978eedb2 = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            const { selection: { $from: $from } } = tr;
            // don't indent if selection is not inside a list
            if (!(0, $15716090c6bb5c37$export$fd64e4ef922c42f3)(tr)) return null;
            // Save the history, so it could undo/revert to the same state before the indent, see https://product-fabric.atlassian.net/browse/ED-14753
            (0, $di3bZ.closeHistory)(tr);
            // Route to new or original implementation based on feature flag
            if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) return $18c3db1d37f16708$var$handleIndentListItems(tr, editorAnalyticsAPI, inputMethod);
            const firstListItemSelectedAttributes = (0, $32JQq.getListItemAttributes)($from);
            const parentListNode = (0, $6ddfc8bedba79b46$export$cd0bf0d386a8d5a7)($from);
            if (!parentListNode || firstListItemSelectedAttributes && firstListItemSelectedAttributes.indentLevel === 0 && firstListItemSelectedAttributes.itemIndex === 0) {
                if ((0, $15716090c6bb5c37$export$cb2b92f281f91c40)(tr)) // dont consume tab, as table-keymap should move cursor to next cell
                return null;
                else // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
                return new (0, $3Wkl8.PassiveTransaction)();
            }
            const currentListNode = parentListNode.node;
            const actionSubjectId = (0, $hqLXn.isBulletList)(currentListNode) ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            (0, $4a8273bba5eae97b$export$cbf684996d8a31a2)(tr);
            const maximimunNestedLevelReached = !(0, $d04cf8d85fd62307$export$925f3cc2bf62e47a)({
                tr: tr,
                maxIndentation: (0, $d5c800ae1cd773fe$export$eb55a67f55930af1)
            });
            if (maximimunNestedLevelReached || !tr.docChanged) // Even though this is a non-operation, we don't want to send this event to the browser. Because if we return false, the browser will move the focus to another place
            return new (0, $3Wkl8.PassiveTransaction)();
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INDENTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                actionSubjectId: actionSubjectId,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    ...(0, $3TgtB.getCommonListAnalyticsAttributes)(tr),
                    inputMethod: inputMethod
                }
            })(tr);
            return tr;
        };
    };




var $kpCD8 = parcelRequire("kpCD8");


var $91Kwo = parcelRequire("91Kwo");







var $c2pcC = parcelRequire("c2pcC");





var $d8RhQ = parcelRequire("d8RhQ");







const $0af73cdad67c1aad$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $eOaGc.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        // if an orderedList node would be inserted by the input rule match, and
        // that orderedList node is being added directly after another orderedList
        const $end = tr.doc.resolve(tr.mapping.map(end));
        const nodeWithPos = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($end, nodeType);
        if (nodeType === state.schema.nodes.orderedList) // otherwise join the lists
        {
            if (nodeWithPos) {
                const nodeEnd = nodeWithPos.pos + nodeWithPos.node.nodeSize;
                const after = tr.doc.resolve(nodeEnd).nodeAfter;
                if (after && after.type === nodeType && (0, $eOaGc.canJoin)(tr.doc, nodeEnd) && (!joinPredicate || joinPredicate(match, after, (0, $iaHsT.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_BELOW))) tr.join(nodeEnd);
            }
        }
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $eOaGc.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $iaHsT.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return (0, $d8RhQ.createRule)(match, handler);
};


const $9b6ab826f8daab12$var$getOrder = (matchResult)=>Number(matchResult[1]);
function $9b6ab826f8daab12$export$7c19b3e2f55f7141({ listType: listType, expression: expression, editorAnalyticsApi: editorAnalyticsApi }) {
    let joinScenario = (0, $iaHsT.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
    const isBulletList = listType.name === 'bulletList';
    const actionSubjectId = isBulletList ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    const getAnalyticsPayload = (state, matchResult)=>{
        const analyticsPayload = {
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FORMATTING
            }
        };
        if (listType === state.schema.nodes.orderedList && analyticsPayload.attributes) {
            analyticsPayload.attributes.listStartNumber = $9b6ab826f8daab12$var$getOrder(matchResult);
            analyticsPayload.attributes.joinScenario = joinScenario;
            // we reset the tracked joinScenario after storing it in the event payload
            joinScenario = (0, $iaHsT.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
        }
        return analyticsPayload;
    };
    const joinToNeighbourIfSameListType = (_, node, scenario)=>{
        const shouldJoin = node.type === listType;
        if (shouldJoin) joinScenario = scenario;
        return shouldJoin;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getAttrs = (matchResult)=>{
        return {
            order: $9b6ab826f8daab12$var$getOrder(matchResult)
        };
    };
    const inputRule = (0, $0af73cdad67c1aad$export$6341edfa2d147bc)({
        match: expression,
        nodeType: listType,
        getAttrs: getAttrs,
        joinPredicate: joinToNeighbourIfSameListType
    });
    return (0, $c2pcC.inputRuleWithAnalytics)(getAnalyticsPayload, editorAnalyticsApi)(inputRule);
}


// Using UTF instead of • character
// because of issue where product converted the
// character into an escaped version.
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $385efcb279d807ee$var$BULLET_LIST_EXPRESSION = /^\s*([\*\-\u2022]) $/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $385efcb279d807ee$var$ORDERED_LIST_EXPRESSION = /((^[1-9]{1}[0-9]{0,2})|^(0))[\.\)] $/;
function $385efcb279d807ee$export$2e2bcd8739ae039(schema, editorAnalyticsApi) {
    const { nodes: { bulletList: bulletList, orderedList: orderedList } } = schema;
    const rules = [];
    if (bulletList) rules.push((0, $9b6ab826f8daab12$export$7c19b3e2f55f7141)({
        expression: $385efcb279d807ee$var$BULLET_LIST_EXPRESSION,
        listType: bulletList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    if (orderedList) rules.push((0, $9b6ab826f8daab12$export$7c19b3e2f55f7141)({
        expression: $385efcb279d807ee$var$ORDERED_LIST_EXPRESSION,
        listType: orderedList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    if (rules.length !== 0) return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('lists', rules));
    return;
}









var $44cyU = parcelRequire("44cyU");




function $32a1a3b5e289f911$export$e832373cff8dec22(featureFlags, editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleOrderedList)), (0, $8b7713d756143665$export$78da663726cb9398)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD, 'orderedList'), list);
    (0, $ldqjS.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.toggleBulletList)), (0, $8b7713d756143665$export$78da663726cb9398)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD, 'bulletList'), list);
    (0, $ldqjS.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.indentList).common, (0, $18c3db1d37f16708$export$8066a906978eedb2)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), list);
    (0, $ldqjS.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.outdentList).common, (0, $174364528088cbb3$export$959569198ddbbe17)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, (0, $8b7713d756143665$export$476a01d760cd8a14)(editorAnalyticsAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.backspace).common, (0, $8b7713d756143665$export$c1d6e1a8db28fd58)(editorAnalyticsAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.deleteKey).common, (0, $8b7713d756143665$export$ca522099b17e5b55)(editorAnalyticsAPI), list);
    // This shortcut is Mac only
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.findKeyMapForBrowser)((0, $ldqjS.forwardDelete)), (0, $8b7713d756143665$export$ca522099b17e5b55)(editorAnalyticsAPI), list);
    return (0, $44cyU.keymap)(list);
}
var $32a1a3b5e289f911$export$2e2bcd8739ae039 = $32a1a3b5e289f911$export$e832373cff8dec22;






var $e2j05 = parcelRequire("e2j05");

var $eaLat = parcelRequire("eaLat");


var $cRhiT = parcelRequire("cRhiT");

var $g2MiL = parcelRequire("g2MiL");






var $cI8RZ = parcelRequire("cI8RZ");








var $8nvEM = parcelRequire("8nvEM");


var $anBbz = parcelRequire("anBbz");



const $a9ab5ee9b4f58f69$var$listPluginKey = new (0, $kCECX.PluginKey)('listPlugin');
const $a9ab5ee9b4f58f69$export$18d4026d1ea86bb1 = $a9ab5ee9b4f58f69$var$listPluginKey;
const $a9ab5ee9b4f58f69$var$initialState = {
    bulletListActive: false,
    bulletListDisabled: false,
    orderedListActive: false,
    orderedListDisabled: false,
    decorationSet: (0, $8nvEM.DecorationSet).empty
};
const $a9ab5ee9b4f58f69$export$968abecb43309c32 = (doc, _state, _featureFlags)=>{
    const decorations = [];
    // this stack keeps track of each (nested) list to calculate the indentation level
    const processedListsStack = [];
    doc.nodesBetween(0, doc.content.size, (node, currentNodeStartPos)=>{
        if (processedListsStack.length > 0) {
            let isOutsideLastList = true;
            while(isOutsideLastList && processedListsStack.length > 0){
                const lastList = processedListsStack[processedListsStack.length - 1];
                const lastListEndPos = lastList.startPos + lastList.node.nodeSize;
                isOutsideLastList = currentNodeStartPos >= lastListEndPos;
                // once we finish iterating over each innermost list, pop the stack to
                // decrease the indent level attribute accordingly
                if (isOutsideLastList) processedListsStack.pop();
            }
        }
        if ((0, $aXHNB.isListNode)(node)) {
            processedListsStack.push({
                node: node,
                startPos: currentNodeStartPos
            });
            const from = currentNodeStartPos;
            const to = currentNodeStartPos + node.nodeSize;
            const depth = processedListsStack.length;
            decorations.push((0, $8nvEM.Decoration).node(from, to, {
                'data-indent-level': `${depth}`
            }));
            if (node.type.name === 'orderedList') {
                // If a numbered list has item counters numbering >= 100, we'll need to add special
                // spacing to account for the extra digit chars
                const digitsSize = (0, $eTXkv.getItemCounterDigitsSize)({
                    itemsCount: node?.childCount,
                    order: node?.attrs?.order
                });
                if (digitsSize && digitsSize > 1) decorations.push((0, $8nvEM.Decoration).node(from, to, {
                    style: (0, $g2MiL.getOrderedListInlineStyles)(digitsSize, 'string')
                }));
            }
        }
    });
    return (0, $8nvEM.DecorationSet).empty.add(doc, decorations);
};
const $a9ab5ee9b4f58f69$var$getListState = (doc, selection)=>{
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = doc.type.schema.nodes;
    const listParent = (0, $bjg0G.findParentNodeOfType)([
        bulletList,
        orderedList,
        taskList
    ])(selection);
    const bulletListActive = !!listParent && listParent.node.type === bulletList;
    const orderedListActive = !!listParent && listParent.node.type === orderedList;
    const bulletListDisabled = !(bulletListActive || orderedListActive || (0, $15716090c6bb5c37$export$af251811cd857645)(bulletList, selection));
    const orderedListDisabled = !(bulletListActive || orderedListActive || (0, $15716090c6bb5c37$export$af251811cd857645)(orderedList, selection));
    return {
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled
    };
};
const $a9ab5ee9b4f58f69$var$handleDocChanged = (featureFlags)=>(tr, pluginState, editorState)=>{
        const nextPluginState = $a9ab5ee9b4f58f69$var$handleSelectionChanged(tr, pluginState);
        const decorationSet = $a9ab5ee9b4f58f69$export$968abecb43309c32(tr.doc, editorState, featureFlags);
        return {
            ...nextPluginState,
            decorationSet: decorationSet
        };
    };
const $a9ab5ee9b4f58f69$var$handleSelectionChanged = (tr, pluginState)=>{
    const { bulletListActive: bulletListActive, orderedListActive: orderedListActive, bulletListDisabled: bulletListDisabled, orderedListDisabled: orderedListDisabled } = $a9ab5ee9b4f58f69$var$getListState(tr.doc, tr.selection);
    if (bulletListActive !== pluginState.bulletListActive || orderedListActive !== pluginState.orderedListActive || bulletListDisabled !== pluginState.bulletListDisabled || orderedListDisabled !== pluginState.orderedListDisabled) {
        const nextPluginState = {
            ...pluginState,
            bulletListActive: bulletListActive,
            orderedListActive: orderedListActive,
            bulletListDisabled: bulletListDisabled,
            orderedListDisabled: orderedListDisabled
        };
        return nextPluginState;
    }
    return pluginState;
};
const $a9ab5ee9b4f58f69$var$reducer = ()=>(state)=>{
        return state;
    };
const $a9ab5ee9b4f58f69$var$createInitialState = (featureFlags, api)=>(state)=>{
        const isToolbarAIFCEnabled = Boolean(api?.toolbar);
        return {
            // When plugin is initialised, editor state is defined with selection
            // hence returning the list state based on the selection to avoid list button in primary toolbar flickering during initial load
            ...isToolbarAIFCEnabled ? $a9ab5ee9b4f58f69$var$getListState(state.doc, state.selection) : $a9ab5ee9b4f58f69$var$initialState,
            decorationSet: $a9ab5ee9b4f58f69$export$968abecb43309c32(state.doc, state, featureFlags)
        };
    };
const $a9ab5ee9b4f58f69$export$ae829ec7b2625219 = (eventDispatch, featureFlags, api)=>{
    const { getPluginState: getPluginState, createPluginState: createPluginState } = (0, $cI8RZ.pluginFactory)($a9ab5ee9b4f58f69$var$listPluginKey, $a9ab5ee9b4f58f69$var$reducer(), {
        onDocChanged: $a9ab5ee9b4f58f69$var$handleDocChanged(featureFlags),
        onSelectionChanged: $a9ab5ee9b4f58f69$var$handleSelectionChanged
    });
    return new (0, $kpCD8.SafePlugin)({
        state: createPluginState(eventDispatch, $a9ab5ee9b4f58f69$var$createInitialState(featureFlags, api)),
        key: $a9ab5ee9b4f58f69$var$listPluginKey,
        appendTransaction (transactions, _oldState, newState) {
            if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true)) return null;
            if (!transactions.some((t)=>t.docChanged)) return null;
            // Efficiently scans only affected list nodes — exits early if none are found.
            const tr = (0, $2b4d25e51054885d$export$da6cb9e5038a61a)({
                tr: newState.tr,
                transactions: transactions,
                doc: newState.doc,
                schema: newState.schema
            });
            if (tr.docChanged) return tr;
            return null;
        },
        props: {
            decorations (state) {
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            },
            handleClick: (view, pos, event)=>{
                const { state: state } = view;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if ([
                    'LI',
                    'UL'
                ].includes((event?.target).tagName)) {
                    const nodeAtPos = state.tr.doc.nodeAt(pos);
                    const { listItem: listItem, codeBlock: codeBlock } = view.state.schema.nodes;
                    if (nodeAtPos?.type === listItem && nodeAtPos?.firstChild?.type === codeBlock) {
                        const bufferPx = 50;
                        const isCodeBlockNextToListMarker = Boolean(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                        document?.elementFromPoint(event.clientX + ((0, $g2MiL.listItemCounterPadding) + bufferPx), event.clientY)?.closest(`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`));
                        if (isCodeBlockNextToListMarker) {
                            // +1 needed to put cursor inside li
                            // otherwise gap cursor markup will be injected as immediate child of ul resulting in invalid html
                            (0, $e2j05.setGapCursorSelection)(view, pos + 1, (0, $eaLat.Side).LEFT);
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    });
};





var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");




parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");








var $dVKvM = parcelRequire("dVKvM");


var $3fO5l = parcelRequire("3fO5l");

const $d91ded04d9d44bd0$var$NODE_NAME = 'bulletList';
const $d91ded04d9d44bd0$var$BulletedListBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.bulletList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $d91ded04d9d44bd0$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $h4y3S.messages).bulletedList)
    });
};
const $d91ded04d9d44bd0$export$a10d73d60d04133e = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($d91ded04d9d44bd0$var$BulletedListBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};





parcelRequire("cozmU");














var $fTKqO = parcelRequire("fTKqO");

const $459063743bf61ae7$var$NODE_NAME = 'orderedList';
const $459063743bf61ae7$var$NumberedListBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.orderedList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $459063743bf61ae7$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fTKqO))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $h4y3S.messages).orderedList)
    });
};
const $459063743bf61ae7$export$43d7befaff491a1f = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($459063743bf61ae7$var$NumberedListBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};


const $d3ba6a5cb6590a67$var$BULLET_LIST_NODE_NAME = 'bulletList';
const $d3ba6a5cb6590a67$var$ORDERED_LIST_NODE_NAME = 'orderedList';
const $d3ba6a5cb6590a67$export$eb84e5278d4ad5e0 = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]
            },
            component: (0, $d91ded04d9d44bd0$export$a10d73d60d04133e)({
                api: api
            }),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($d3ba6a5cb6590a67$var$BULLET_LIST_NODE_NAME))
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]
            },
            component: (0, $459063743bf61ae7$export$43d7befaff491a1f)({
                api: api
            }),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($d3ba6a5cb6590a67$var$ORDERED_LIST_NODE_NAME))
        }
    ];
};





parcelRequire("cozmU");








var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");





var $cozmU = parcelRequire("cozmU");

















var $I2MTF = parcelRequire("I2MTF");

const $25d511fd485b6143$export$b59ff37788c63e2 = ({ api: api, type: type })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isOrdered = type === 'ordered';
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        const { schema: schema } = editorView.state;
        const listNode = isOrdered ? schema.nodes.orderedList : schema.nodes.bulletList;
        const actionSubjectId = isOrdered ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        const tr = insert(listNode.createChecked({}, schema.nodes.listItem.createChecked({}, schema.nodes.paragraph.createChecked())));
        api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            attributes: {
                inputMethod: source
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api,
        isOrdered
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: isOrdered ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconListNumber), {}) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconList), {}),
        onSelect: onSelect,
        shortcut: (0, $ldqjS.tooltip)(isOrdered ? (0, $ldqjS.toggleOrderedList) : (0, $ldqjS.toggleBulletList)),
        title: formatMessage(isOrdered ? (0, $h4y3S.messages).orderedList : (0, $h4y3S.messages).unorderedList)
    });
};


const $ba17558d8e5b3a5a$export$863f69203d9d228a = ({ api: api })=>[
        {
            item: (0, $dCkbP.UNORDERED_LIST_MENU_ITEM),
            type: 'unordered'
        },
        {
            item: (0, $dCkbP.ORDERED_LIST_MENU_ITEM),
            type: 'ordered'
        }
    ].map(({ item: item, type: type })=>{
        const isOrdered = type === 'ordered';
        return {
            key: item.key,
            type: item.type,
            parents: [
                {
                    key: (0, $dCkbP.TEXT_FORMATTING_SECTION).key,
                    type: (0, $dCkbP.TEXT_FORMATTING_SECTION).type,
                    rank: (0, $dXqu3.TEXT_FORMATTING_SECTION_RANK)[item.key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage(isOrdered ? (0, $h4y3S.messages).orderedListDescription : (0, $h4y3S.messages).unorderedListDescription),
                    keywords: isOrdered ? [
                        'ol',
                        'ordered'
                    ] : [
                        'ul',
                        'unordered'
                    ],
                    shortcut: (0, $ldqjS.tooltip)(isOrdered ? (0, $ldqjS.toggleOrderedList) : (0, $ldqjS.toggleBulletList)),
                    title: formatMessage(isOrdered ? (0, $h4y3S.messages).orderedList : (0, $h4y3S.messages).unorderedList)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $25d511fd485b6143$export$b59ff37788c63e2), {
                    api: api,
                    type: type
                })
        };
    });


const $c6a21d506d16709b$export$aab29c128be6b8b2 = ({ api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents((0, $d3ba6a5cb6590a67$export$eb84e5278d4ad5e0)(api));
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $ba17558d8e5b3a5a$export$863f69203d9d228a)({
        api: api
    }));
    return {
        name: 'list',
        actions: {
            isInsideListItem: $15716090c6bb5c37$export$fd64e4ef922c42f3,
            findRootParentListNode: $6ddfc8bedba79b46$export$cd55a6653375f672
        },
        commands: {
            indentList: (0, $18c3db1d37f16708$export$8066a906978eedb2)(editorAnalyticsAPI),
            outdentList: (inputMethod)=>(0, $174364528088cbb3$export$959569198ddbbe17)(editorAnalyticsAPI)(inputMethod),
            toggleOrderedList: (0, $8b7713d756143665$export$dca848a1b50b6a31)(editorAnalyticsAPI),
            toggleBulletList: (0, $8b7713d756143665$export$c0e115f47553645e)(editorAnalyticsAPI)
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $a9ab5ee9b4f58f69$export$18d4026d1ea86bb1).getState(editorState);
        },
        nodes () {
            const getListItemNode = ()=>{
                if ((0, $iDrrr.fg)('platform_editor_adf_with_localid')) return 0, $f5nzM.listItemWithLocalId;
                return 0, $f5nzM.listItem;
            };
            return [
                {
                    name: 'bulletList',
                    node: (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $9nUB4.bulletListWithLocalId) : (0, $9nUB4.bulletList)
                },
                {
                    name: 'orderedList',
                    node: (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $ab7A2.orderedListWithOrderAndLocalId) : (0, $ab7A2.orderedListWithOrder)
                },
                {
                    name: 'listItem',
                    node: getListItemNode()
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'list',
                    plugin: ({ dispatch: dispatch })=>(0, $a9ab5ee9b4f58f69$export$ae829ec7b2625219)(dispatch, featureFlags, api)
                },
                {
                    name: 'listInputRule',
                    plugin: ({ schema: schema })=>(0, $385efcb279d807ee$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                },
                {
                    name: 'listKeymap',
                    plugin: ()=>(0, $32a1a3b5e289f911$export$2e2bcd8739ae039)(featureFlags, api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: isRegisteredSlashCommandEnabled ? {} : {
            quickInsert: ({ formatMessage: formatMessage })=>{
                return [
                    {
                        id: 'unorderedList',
                        title: formatMessage((0, $h4y3S.messages).unorderedList),
                        description: formatMessage((0, $h4y3S.messages).unorderedListDescription),
                        keywords: [
                            'ul',
                            'unordered'
                        ],
                        priority: 1100,
                        keyshortcut: (0, $ldqjS.tooltip)((0, $ldqjS.toggleBulletList)),
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconList), {}),
                        action (insert, state) {
                            const tr = insert(state.schema.nodes.bulletList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET,
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'orderedList',
                        title: formatMessage((0, $h4y3S.messages).orderedList),
                        description: formatMessage((0, $h4y3S.messages).orderedListDescription),
                        keywords: [
                            'ol',
                            'ordered'
                        ],
                        priority: 1200,
                        keyshortcut: (0, $ldqjS.tooltip)((0, $ldqjS.toggleOrderedList)),
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconListNumber), {}),
                        action (insert, state) {
                            const tr = insert(state.schema.nodes.orderedList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER,
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};
module.exports["listPlugin"] = $c6a21d506d16709b$export$aab29c128be6b8b2;

});

parcelRegister("3TgtB", function(module, exports) {

var $f4zz7 = parcelRequire("f4zz7");


var $32JQq = parcelRequire("32JQq");

const $489413b37372f0b6$export$b4f9b2b8a958b87c = (tr)=>{
    const { selection: { $from: $from, $to: $to } } = tr;
    const fromAttrs = (0, $32JQq.getListItemAttributes)($from);
    const toAttrs = (0, $32JQq.getListItemAttributes)($to);
    return {
        itemIndexAtSelectionStart: fromAttrs.itemIndex,
        itemIndexAtSelectionEnd: toAttrs.itemIndex,
        indentLevelAtSelectionStart: fromAttrs.indentLevel,
        indentLevelAtSelectionEnd: toAttrs.indentLevel,
        itemsInSelection: (0, $f4zz7.countListItemsInSelection)(tr)
    };
};
module.exports["getCommonListAnalyticsAttributes"] = $489413b37372f0b6$export$b4f9b2b8a958b87c;

});

parcelRegister("hJh89", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $4EksL = parcelRequire("4EksL");

function $ff1aba116dffc5e5$export$76f89e56a88b45c7({ items: items, startIndex: startIndex, endIndex: endIndex, originalFrom: originalFrom, originalTo: originalTo, contentStartOffsets: contentStartOffsets, rootListStart: rootListStart, docSize: docSize }) {
    // +1 shifts from the outer edge of the list item node to the start of the content within
    const fromContentStart = items[startIndex].pos + 1;
    const toContentStart = items[endIndex].pos + 1;
    const fromOffset = originalFrom - fromContentStart;
    const toOffset = originalTo - toContentStart;
    const clamp = (pos)=>Math.min(Math.max(0, pos), docSize);
    return {
        from: clamp(rootListStart + contentStartOffsets[startIndex] + fromOffset),
        to: clamp(rootListStart + contentStartOffsets[endIndex] + toOffset)
    };
}
function $ff1aba116dffc5e5$export$df4382c94ffa9da5({ tr: tr, originalSelection: originalSelection, from: from, to: to }) {
    const maxPos = tr.doc.content.size;
    if (originalSelection instanceof (0, $kCECX.NodeSelection)) try {
        tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, Math.min(from, maxPos - 1)));
    } catch  {
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(from)));
    }
    else if (originalSelection instanceof (0, $4EksL.GapCursorSelection)) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(from), originalSelection.side));
    else tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from, to));
}
module.exports["computeSelectionOffsets"] = $ff1aba116dffc5e5$export$76f89e56a88b45c7;
module.exports["restoreSelection"] = $ff1aba116dffc5e5$export$df4382c94ffa9da5;

});

parcelRegister("hnsob", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

function $cf55afd4d024c22c$export$1d19d37d675fc1b8(doc, rootListStart, rootListEnd, fragment, contentStartOffsets) {
    const oldNode = doc.nodeAt(rootListStart);
    const newNode = fragment.childCount === 1 ? fragment.firstChild : null;
    if (!oldNode || !newNode || newNode.type !== oldNode.type) return {
        start: rootListStart,
        end: rootListEnd,
        fragment: fragment,
        adjustedContentStartOffsets: contentStartOffsets
    };
    const minChildCount = Math.min(oldNode.childCount, newNode.childCount);
    let commonPrefixChildren = 0;
    let prefixSize = 0;
    for(let i = 0; i < minChildCount; i++){
        const oldChild = oldNode.child(i);
        const newChild = newNode.child(i);
        if (oldChild.eq(newChild)) {
            commonPrefixChildren++;
            prefixSize += oldChild.nodeSize;
        } else break;
    }
    let commonSuffixChildren = 0;
    let suffixSize = 0;
    for(let i = 0; i < minChildCount - commonPrefixChildren; i++){
        const oldChild = oldNode.child(oldNode.childCount - 1 - i);
        const newChild = newNode.child(newNode.childCount - 1 - i);
        if (oldChild.eq(newChild)) {
            commonSuffixChildren++;
            suffixSize += oldChild.nodeSize;
        } else break;
    }
    const totalCommon = commonPrefixChildren + commonSuffixChildren;
    if (totalCommon >= oldNode.childCount && totalCommon >= newNode.childCount) return {
        start: rootListStart,
        end: rootListStart,
        fragment: (0, $aPdNQ.Fragment).empty,
        adjustedContentStartOffsets: contentStartOffsets
    };
    const narrowedStart = rootListStart + 1 + prefixSize;
    const narrowedEnd = rootListEnd - 1 - suffixSize;
    const changedChildStart = commonPrefixChildren;
    const changedChildEnd = newNode.childCount - commonSuffixChildren;
    const changedNodes = [];
    for(let i = changedChildStart; i < changedChildEnd; i++)changedNodes.push(newNode.child(i));
    const narrowedFragment = (0, $aPdNQ.Fragment).from(changedNodes);
    const prefixOffset = 1 + prefixSize;
    const adjustedContentStartOffsets = contentStartOffsets.map((offset)=>offset - prefixOffset);
    return {
        start: narrowedStart,
        end: narrowedEnd,
        fragment: narrowedFragment,
        adjustedContentStartOffsets: adjustedContentStartOffsets
    };
}
module.exports["narrowReplacementRange"] = $cf55afd4d024c22c$export$1d19d37d675fc1b8;

});

parcelRegister("iwBlG", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

function $15fa4ce53d4d0133$export$861e2120f3e445e9({ items: items, schema: schema, rebuildFn: rebuildFn, extractContentFn: extractContentFn }) {
    let fragment = (0, $aPdNQ.Fragment).empty;
    let pendingListSegment = [];
    let pendingStartIdx = 0;
    const contentStartOffsets = new Array(items.length);
    const flushListSegment = ()=>{
        if (pendingListSegment.length > 0) {
            const fragmentOffset = fragment.size;
            const result = rebuildFn(pendingListSegment, schema);
            if (result) {
                // Map the rebuild's content start offsets into the overall fragment.
                for(let i = 0; i < pendingListSegment.length; i++)contentStartOffsets[pendingStartIdx + i] = fragmentOffset + result.contentStartOffsets[i];
                fragment = fragment.addToEnd(result.node);
            }
            pendingListSegment = [];
        }
    };
    let elIdx = 0;
    for (const item of items){
        if (item.depth < 0) {
            flushListSegment();
            // Extracted element — content children become top-level nodes.
            // Record offset of first content child.
            contentStartOffsets[elIdx] = fragment.size;
            for (const node of extractContentFn(item, schema))fragment = fragment.addToEnd(node);
        } else {
            if (pendingListSegment.length === 0) pendingStartIdx = elIdx;
            pendingListSegment.push(item);
        }
        elIdx++;
    }
    flushListSegment();
    return {
        fragment: fragment,
        contentStartOffsets: contentStartOffsets
    };
}
module.exports["buildReplacementFragment"] = $15fa4ce53d4d0133$export$861e2120f3e445e9;

});

parcelRegister("dxhaW", function(module, exports) {
function $3b0c57bdaeeffde0$export$8824054d4a42eac8(options, predicates) {
    const { doc: doc, rootListStart: rootListStart, rootListEnd: rootListEnd, selectionFrom: selectionFrom, selectionTo: selectionTo, indentDelta: indentDelta, maxDepth: maxDepth } = options;
    const { isContentNode: isContentNode, getSelectionBounds: getSelectionBounds, getDepth: getDepth } = predicates;
    const items = [];
    let startIndex = -1;
    let endIndex = -1;
    let exceedsMaxDepth = false;
    const rootDepth = doc.resolve(rootListStart).depth;
    doc.nodesBetween(rootListStart, rootListEnd, (node, pos, parent)=>{
        if (!isContentNode(node, parent) || parent == null) return true;
        const { start: start, end: end } = getSelectionBounds(node, pos);
        const isSelected = selectionFrom === selectionTo ? selectionFrom >= start && selectionFrom <= end : start < selectionTo && end > selectionFrom;
        const resolvedDepth = doc.resolve(pos).depth;
        const depth = getDepth(resolvedDepth, rootDepth) + (isSelected ? indentDelta : 0);
        items.push({
            node: node,
            pos: pos,
            depth: depth,
            isSelected: isSelected,
            listType: parent.type.name,
            parentListAttrs: parent.attrs
        });
        if (isSelected) {
            const index = items.length - 1;
            if (startIndex === -1) startIndex = index;
            endIndex = index;
            if (maxDepth != null && depth >= maxDepth) exceedsMaxDepth = true;
        }
        return true;
    });
    if (items.length === 0 || startIndex === -1 || exceedsMaxDepth) return null;
    return {
        items: items,
        startIndex: startIndex,
        endIndex: endIndex
    };
}
module.exports["flattenList"] = $3b0c57bdaeeffde0$export$8824054d4a42eac8;

});

parcelRegister("gkbos", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $jj5Xg = parcelRequire("jj5Xg");


var $iDrrr = parcelRequire("iDrrr");


var $fqVYq = parcelRequire("fqVYq");


var $krYZG = parcelRequire("krYZG");


var $2RAus = parcelRequire("2RAus");


var $ieeJu = parcelRequire("ieeJu");

const $999ee779dc37338e$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $999ee779dc37338e$export$fc59e1ed5414eef9 = 4.5;
const $999ee779dc37338e$export$423a5169d8af406a = 3;
const $999ee779dc37338e$export$617cdcc6afaae4f7 = '#FFFFFF';
const $999ee779dc37338e$export$3bfbdac4444b01ff = '#00000000';
const $999ee779dc37338e$export$37394b0fa44b998c = {
    // TODO: DSP-4137 - Remove usage of hardcoded color
    /* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */ color: '#172b4d',
    label: 'Dark gray'
};


const $8c3b83b2c4c683bd$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $999ee779dc37338e$export$37394b0fa44b998c).color;
};
const $8c3b83b2c4c683bd$export$9ed72cbbcfbf2a15 = (tr)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = tr.selection;
    const { textColor: textColor } = tr.doc.type.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(tr.storedMarks || $cursor.marks()) || undefined);
    else tr.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $999ee779dc37338e$export$37394b0fa44b998c).color;
};



var $5tsXu = parcelRequire("5tsXu");


var $kpCD8 = parcelRequire("kpCD8");





var $9Av6M = parcelRequire("9Av6M");


const $b3f2d51e5ac7d910$export$25c6a5f643998d29 = [];
(0, $jj5Xg.colorPalette).forEach((label, color)=>{
    $b3f2d51e5ac7d910$export$25c6a5f643998d29.push((0, $9Av6M.mapPaletteColor)(label, color));
});







const $ba9daade9fcae792$export$5c94a41a055ef872 = [];
(0, $jj5Xg.colorPaletteNew).forEach((label, color)=>{
    $ba9daade9fcae792$export$5c94a41a055ef872.push((0, $9Av6M.mapPaletteColor)(label, color));
});



var $kCECX = parcelRequire("kCECX");


var $anBbz = parcelRequire("anBbz");




var $kzHT3 = parcelRequire("kzHT3");

var $adJV7 = parcelRequire("adJV7");


const $8381795b4a3fa9fc$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $8381795b4a3fa9fc$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $8381795b4a3fa9fc$var$hasLinkMark($cursor) || (0, $kzHT3.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $999ee779dc37338e$export$ccbc17c7832f26ef).includes(mark.type.name);
        };
        if ((0, $adJV7.isMarkExcluded)(textColor, state.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};
const $8381795b4a3fa9fc$export$bc7d0019d5b59541 = (tr)=>{
    const { textColor: textColor } = tr.doc.type.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = tr.selection;
        if (empty && !$cursor || $cursor && $8381795b4a3fa9fc$var$hasLinkMark($cursor) || (0, $kzHT3.isMarkAllowedInRange)(tr.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $999ee779dc37338e$export$ccbc17c7832f26ef).includes(mark.type.name);
        };
        if ((0, $adJV7.isMarkExcluded)(textColor, tr.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};


function $2153a7c50016f73c$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = pluginConfig?.defaultColor || (0, $999ee779dc37338e$export$37394b0fa44b998c);
    const paletteColors = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $ba9daade9fcae792$export$5c94a41a055ef872) : (0, $b3f2d51e5ac7d910$export$25c6a5f643998d29);
    const palette = [
        {
            value: defaultColor.color,
            label: defaultColor.label,
            border: "var(--ds-border, #0B120E24)"
        },
        ...paletteColors
    ];
    const color = (0, $8c3b83b2c4c683bd$export$1c6fa8f53a5fb47f)(editorState);
    const state = {
        color: color,
        disabled: (0, $8381795b4a3fa9fc$export$4af1020a67b5ec91)(editorState),
        palette: palette,
        defaultColor: defaultColor.color,
        isPaletteOpen: false
    };
    return state;
}
var $2153a7c50016f73c$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
    ACTIONS[ACTIONS["SET_PALETTE"] = 3] = "SET_PALETTE";
    return ACTIONS;
}({});
const $2153a7c50016f73c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('textColorPlugin');
function $2153a7c50016f73c$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $kpCD8.SafePlugin)({
        key: $2153a7c50016f73c$export$18d4026d1ea86bb1,
        state: {
            init (_config, editorState) {
                return $2153a7c50016f73c$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($2153a7c50016f73c$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false,
                            isPaletteOpen: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    case 3:
                        nextState = {
                            ...pluginState,
                            isPaletteOpen: meta.isPaletteOpen
                        };
                        break;
                    default:
                        const color = (0, $8c3b83b2c4c683bd$export$1c6fa8f53a5fb47f)(newState);
                        nextState = {
                            ...pluginState,
                            color: color,
                            disabled: (0, $8381795b4a3fa9fc$export$4af1020a67b5ec91)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled || pluginState && pluginState.isPaletteOpen !== nextState.isPaletteOpen) {
                    dispatch($2153a7c50016f73c$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        }
    });
}


const $f90b1c2bba5b1714$export$4a26621adcb675d6 = ({ tr: tr })=>{
    const { textColor: textColor } = tr.doc.type.schema.marks;
    (0, $5tsXu.removeMark)(textColor)({
        tr: tr
    });
    tr.setMeta((0, $2153a7c50016f73c$export$18d4026d1ea86bb1), {
        action: (0, $2153a7c50016f73c$export$92a1a3b7554e9387).RESET_COLOR
    });
    return tr;
};





var $bhf6v = parcelRequire("bhf6v");







const $eaf568bb745444e6$export$afb561a73dff6672 = (color)=>({ tr: tr })=>{
        const { textColor: textColor } = tr.doc.type.schema.marks;
        const disabledState = (0, $8381795b4a3fa9fc$export$bc7d0019d5b59541)(tr);
        if (disabledState) {
            tr.setMeta((0, $2153a7c50016f73c$export$18d4026d1ea86bb1), {
                action: (0, $2153a7c50016f73c$export$92a1a3b7554e9387).DISABLE
            });
            return tr;
        }
        if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) (0, $999ee779dc37338e$export$ccbc17c7832f26ef).forEach((mark)=>{
            const { marks: marks } = tr.doc.type.schema;
            if (marks[mark]) (0, $5tsXu.removeMark)(marks[mark])({
                tr: tr
            });
        });
        (0, $bhf6v.toggleMark)(textColor, {
            color: color
        })({
            tr: tr
        });
        return tr;
    };


const $e6090b152dd7da09$var$maybeSyncSelectionAfterFormat = (tr)=>{
    if (tr.docChanged && (0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) tr.setMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META), true);
};
/**
 * Helper to create an analytics payload
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @returns Higher order command with analytics logic inside.
 */ function $e6090b152dd7da09$var$createColorAnalyticsPayload(newColor, previousColor, palette, inputMethod) {
    const newColorFromPalette = palette.find(({ value: value })=>value === newColor);
    const previousColorFromPalette = palette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
    return {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel.toLowerCase(),
            inputMethod: inputMethod
        }
    };
}
const $e6090b152dd7da09$export$917538e4f4eb20f9 = (color, api, inputMethod)=>({ tr: tr })=>{
        const { textColor: textColor } = tr.doc.type.schema.marks;
        const pluginState = api?.textColor.sharedState.currentState();
        if (!textColor || !pluginState) return tr;
        const activeColor = (0, $8c3b83b2c4c683bd$export$9ed72cbbcfbf2a15)(tr);
        const colorAnalyticsPayload = $e6090b152dd7da09$var$createColorAnalyticsPayload(color, activeColor, pluginState.palette, inputMethod);
        if (pluginState.disabled) return tr;
        if (color === pluginState.defaultColor) {
            api?.analytics?.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
            (0, $f90b1c2bba5b1714$export$4a26621adcb675d6)({
                tr: tr
            });
            $e6090b152dd7da09$var$maybeSyncSelectionAfterFormat(tr);
            return tr;
        }
        api?.analytics?.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
        (0, $eaf568bb745444e6$export$afb561a73dff6672)(color)({
            tr: tr
        });
        $e6090b152dd7da09$var$maybeSyncSelectionAfterFormat(tr);
        return tr;
    };



const $0ad86716b6f040bb$export$7c9cf3bdfeac3246 = (api)=>({ tr: tr })=>{
        const pluginState = api?.textColor.sharedState.currentState();
        const isPaletteOpen = pluginState?.isPaletteOpen;
        tr.setMeta((0, $2153a7c50016f73c$export$18d4026d1ea86bb1), {
            action: (0, $2153a7c50016f73c$export$92a1a3b7554e9387).SET_PALETTE,
            isPaletteOpen: !isPaletteOpen
        });
        return tr;
    };
const $0ad86716b6f040bb$export$9567774ece486a9 = (isPaletteOpen)=>({ tr: tr })=>{
        tr.setMeta((0, $2153a7c50016f73c$export$18d4026d1ea86bb1), {
            action: (0, $2153a7c50016f73c$export$92a1a3b7554e9387).SET_PALETTE,
            isPaletteOpen: isPaletteOpen
        });
        return tr;
    };






var $eEdSM = parcelRequire("eEdSM");













const $4b108299c6b23690$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema } = state;
        const { textColor: textColor } = schema.marks;
        const tr = state.tr;
        (0, $5tsXu.removeMark)(textColor)({
            tr: tr
        });
        if (dispatch) {
            if (tr.docChanged && (0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) tr.setMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META), true);
            dispatch(tr.setMeta((0, $2153a7c50016f73c$export$18d4026d1ea86bb1), {
                action: (0, $2153a7c50016f73c$export$92a1a3b7554e9387).RESET_COLOR
            }));
        }
        return true;
    };
















const $ae1d67900ec81244$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        const tr = state.tr;
        const disabledState = (0, $8381795b4a3fa9fc$export$4af1020a67b5ec91)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $2153a7c50016f73c$export$18d4026d1ea86bb1), {
                action: (0, $2153a7c50016f73c$export$92a1a3b7554e9387).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) (0, $999ee779dc37338e$export$ccbc17c7832f26ef).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $5tsXu.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $bhf6v.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            if (tr.docChanged && (0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) tr.setMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META), true);
            dispatch(tr);
        }
        return true;
    };


/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $5a4deb662451a466$var$createWithColorAnalytics(newColor, previousColor, palette, editorAnalyticsApi, inputMethod) {
    const newColorFromPalette = palette.find(({ value: value })=>value === newColor);
    const previousColorFromPalette = palette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
    return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel.toLowerCase(),
            inputMethod: inputMethod
        }
    });
}
const $5a4deb662451a466$export$917538e4f4eb20f9 = (color, editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $2153a7c50016f73c$export$18d4026d1ea86bb1).getState(state);
            const activeColor = (0, $8c3b83b2c4c683bd$export$1c6fa8f53a5fb47f)(state);
            const withColorAnalytics = $5a4deb662451a466$var$createWithColorAnalytics(color, activeColor, pluginState?.palette || [], editorAnalyticsApi, inputMethod);
            if (pluginState?.disabled) return false;
            if (color === pluginState?.defaultColor) {
                withColorAnalytics((0, $4b108299c6b23690$export$4a26621adcb675d6)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $ae1d67900ec81244$export$afb561a73dff6672)(color))(state, dispatch);
            return true;
        }
        return false;
    };



var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");


function $d4b6680cb3374a02$export$e832373cff8dec22({ api: api }) {
    const list = {};
    if ((0, $ldqjS.toggleHighlightPalette).common) (0, $ldqjS.bindKeymapWithEditorCommand)((0, $ldqjS.toggleHighlightPalette).common, (0, $0ad86716b6f040bb$export$7c9cf3bdfeac3246)(api), list);
    return (0, $eBSR7.keymap)(list);
}






parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");

var $ca775ccde5aff38e$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");





var $f1UXy = parcelRequire("f1UXy");


var $8Ajok = parcelRequire("8Ajok");


var $6DhDg = parcelRequire("6DhDg");

var $9iFhC = parcelRequire("9iFhC");


var $7xQNd = parcelRequire("7xQNd");

var $3gFnx = parcelRequire("3gFnx");

var $8VCvx = parcelRequire("8VCvx");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");

var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $g8ETs = parcelRequire("g8ETs");


var $7Y8M5 = parcelRequire("7Y8M5");


var $7sJoX = parcelRequire("7sJoX");


var $9FyRG = parcelRequire("9FyRG");












const $99476e1a29c02f2b$var$toolbarTypeToInputMethod = {
    [(0, $ca775ccde5aff38e$export$a5d11b3163e4b1a5).PRIMARY]: (0, $krYZG.INPUT_METHOD).TOOLBAR,
    [(0, $ca775ccde5aff38e$export$a5d11b3163e4b1a5).FLOATING]: (0, $krYZG.INPUT_METHOD).FLOATING_TB
};
const $99476e1a29c02f2b$export$8213a6fbfa466e73 = (toolbarType)=>$99476e1a29c02f2b$var$toolbarTypeToInputMethod[toolbarType];



function $0af2bfb405cfc084$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0af2bfb405cfc084$var$addMarginToWrapper = {
    name: "we4ryv",
    styles: "margin-right:var(--ds-space-050, 4px)"
};
class $0af2bfb405cfc084$export$2985b35a9cfdee76 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { isOpen: isOpen, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, pluginState: pluginState, intl: { formatMessage: formatMessage }, disabled: disabled, pluginInjectionApi: pluginInjectionApi } = this.props;
        const palette = pluginState.palette;
        const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
        const colorPickerColumns = isNewColorPaletteEnabled ? 10 : undefined;
        let fitWidth;
        if (document.body.clientWidth <= 740) // This was originally hard-coded, but moved here to a const
        // My guess is it's based off (width of button * columns) + left/right padding
        // 7 cols: 240 = (32 * 7) + (8 + 8)
        // 10 cols: 338 = (32 * 10) + (8 + 8)
        // Not sure where the extra 2px comes from
        fitWidth = isNewColorPaletteEnabled ? 338 : 242;
        const selectedColor = this.getSelectedColor(pluginState);
        // TODO: ED-26959 - This doesn't work, the label isn't translated
        const selectedColorPaletteItemLabel = palette.find((paletteItem)=>paletteItem.value === pluginState.color)?.label;
        const selectedColorPaletteItemLabelText = selectedColorPaletteItemLabel || '';
        const labelTextColor = formatMessage((0, $8Ajok.textColorMessages).textColor, {
            selectedColorName: selectedColorPaletteItemLabelText
        });
        const tooltipTextColor = formatMessage((0, $8Ajok.textColorMessages).textColorTooltip);
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $3gFnx.getSelectedRowAndColumnFromPalette)(palette, pluginState.color, colorPickerColumns);
        const reducedSpacing = this.props.toolbarType === (0, $ca775ccde5aff38e$export$a5d11b3163e4b1a5).FLOATING ? 'compact' : 'none';
        return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                (0, $9iFhC.wrapperStyle),
                $0af2bfb405cfc084$var$addMarginToWrapper
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isOpen && !pluginState.disabled,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideonEsc,
            zIndex: (0, $7Y8M5.akEditorMenuZIndex),
            fitWidth: fitWidth,
            closeOnTab: true,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $9RT19.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                isOpenedByKeyboard: isOpenedByKeyboard,
                isPopupPositioned: true
            },
            trigger: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
                buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).TEXT_COLOR,
                spacing: !isReducedSpacing || (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : reducedSpacing,
                disabled: disabled || pluginState.disabled,
                selected: isOpen,
                "aria-label": labelTextColor,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                title: tooltipTextColor,
                onClick: this.toggleOpen,
                onKeyDown: this.onKeyDown,
                ref: this.toolbarItemRef,
                iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $9iFhC.triggerWrapperStylesWithPadding)
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1UXy.DynamicStrokeIconDecoration), {
                    selectedColor: selectedColor,
                    disabled: pluginState.disabled,
                    icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    })
                }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    css: (0, $6DhDg.expandIconContainerStyle)
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "",
                    color: "currentColor",
                    size: "small"
                })))
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "data-testid": "text-color-palette"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7xQNd.default), {
            cols: colorPickerColumns,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (color)=>this.changeTextColor(color, pluginInjectionApi?.analytics?.actions, pluginState.disabled),
            selectedColor: pluginState.color,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            paletteOptions: {
                palette: palette,
                hexToPaletteColor: (0, $g8ETs.hexToEditorTextPaletteColor),
                paletteColorTooltipMessages: (0, $8VCvx.textPaletteTooltipMessages)
            }
        }))), !pluginInjectionApi?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: (0, $9iFhC.separatorStyles)
        }));
    }
    getSelectedColor(pluginState) {
        const selectedColor = pluginState.color !== pluginState.defaultColor ? pluginState.color ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $g8ETs.hexToEditorTextPaletteColor)(pluginState.color) : pluginState.color : null;
        return selectedColor;
    }
    buildAnalyticsPalette(action, data) {
        return {
            action: action,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_COLOR,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                ...data
            }
        };
    }
    dispatchAnalyticsEvent(payload) {
        const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent(payload);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        };
        this.toolbarItemRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.changeColor = (color, editorAnalyticsApi)=>(0, $5a4deb662451a466$export$917538e4f4eb20f9)(color, editorAnalyticsApi, (0, $99476e1a29c02f2b$export$8213a6fbfa466e73)(this.props.toolbarType))(this.props.editorView.state, this.props.editorView.dispatch);
        this.changeTextColor = (color, editorAnalyticsApi, disabled)=>{
            if (!disabled) {
                this.handleOpenChange({
                    isOpen: false,
                    logCloseEvent: false
                });
                this.changeColor(color, editorAnalyticsApi);
                //To set the focus on the textcolor button when the menu is closed by 'Esc' only to meet aria guidelines
                this.props.editorView?.focus();
            }
            return false;
        };
        this.toggleOpen = ()=>{
            this.handleOpenChange({
                isOpen: !this.state.isOpen,
                logCloseEvent: true
            });
        };
        this.onKeyDown = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpenedByKeyboard: true
                });
                this.toggleOpen();
            }
        };
        this.handleOpenChange = ({ isOpen: isOpen, logCloseEvent: logCloseEvent })=>{
            this.setState({
                isOpen: isOpen
            });
            if (!isOpen) this.setState({
                isOpenedByKeyboard: false
            });
            if (logCloseEvent) this.dispatchAnalyticsEvent(this.buildAnalyticsPalette(isOpen ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED, {
                noSelect: isOpen === false
            }));
        };
        this.hide = (e)=>{
            const { isOpen: isOpen } = this.state;
            if (isOpen === true) {
                this.dispatchAnalyticsEvent(this.buildAnalyticsPalette((0, $krYZG.ACTION).CLOSED, {
                    noSelect: true
                }));
                this.setState({
                    isOpen: false
                });
                if (e instanceof KeyboardEvent && e.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        };
        this.hideonEsc = (e)=>{
            this.hide(e);
            this.toolbarItemRef?.current?.focus();
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $0af2bfb405cfc084$var$_default_1 = (0, $kSwu1.injectIntl)($0af2bfb405cfc084$export$2985b35a9cfdee76);
var $0af2bfb405cfc084$export$2e2bcd8739ae039 = $0af2bfb405cfc084$var$_default_1;


const $7e32c07e15adfdd9$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true
};
const $7e32c07e15adfdd9$var$selector = (states)=>{
    return {
        color: states.textColorState?.color,
        defaultColor: states.textColorState?.defaultColor,
        palette: states.textColorState?.palette,
        disabled: states.textColorState?.disabled
    };
};
const $7e32c07e15adfdd9$export$b15abb95157a91c7 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { color: color, defaultColor: defaultColor, palette: palette, disabled: disabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], $7e32c07e15adfdd9$var$selector);
    if (color === undefined || defaultColor === undefined || palette === undefined) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0af2bfb405cfc084$export$2e2bcd8739ae039), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            palette: palette,
            disabled: disabled
        },
        isReducedSpacing: $7e32c07e15adfdd9$var$FloatingToolbarSettings.isReducedSpacing,
        editorView: editorView,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: $7e32c07e15adfdd9$var$FloatingToolbarSettings.disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $ca775ccde5aff38e$export$a5d11b3163e4b1a5).FLOATING
    });
};





parcelRequire("cozmU");






const $ce4472f0d522d003$var$selector = (states)=>{
    return {
        color: states.textColorState?.color,
        defaultColor: states.textColorState?.defaultColor,
        palette: states.textColorState?.palette,
        disabled: states.textColorState?.disabled
    };
};
const $ce4472f0d522d003$export$94516d5cccf573e3 = ({ api: api, isReducedSpacing: isReducedSpacing, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
    const { color: color, defaultColor: defaultColor, palette: palette, disabled: textColorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], $ce4472f0d522d003$var$selector);
    if (color === undefined || defaultColor === undefined || palette === undefined) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0af2bfb405cfc084$export$2e2bcd8739ae039), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            palette: palette,
            disabled: textColorDisabled
        },
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $ca775ccde5aff38e$export$a5d11b3163e4b1a5).PRIMARY
    });
};





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");




/* ColorAccessibilityMenuItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $jVdlG = parcelRequire("jVdlG");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");





var $4KjiO = parcelRequire("4KjiO");


var $45O09 = parcelRequire("45O09");


var $bFSJa = parcelRequire("bFSJa");







const $3535827cfdecaa47$export$fde37617ba913701 = (color, defaultColor)=>{
    if (!color || color === defaultColor) return (0, $3gFnx.getTokenCSSVariableValueForNonActiveTheme)("var(--ds-text, #292A2E)", defaultColor);
    const colorValue = (0, $g8ETs.hexToEditorTextPaletteColor)(color) || color;
    return (0, $3gFnx.getTokenCSSVariableValueForNonActiveTheme)(colorValue, color);
};





var $lqPdm = parcelRequire("lqPdm");

var $9Rqjc = parcelRequire("9Rqjc");







var $dCk1A = parcelRequire("dCk1A");


var $kyJuy = parcelRequire("kyJuy");





var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $89bON = parcelRequire("89bON");

// from platform/packages/design-system/tokens/src/utils/get-contrast-ratio.tsx

var $kf78l = parcelRequire("kf78l");

function $830e736ef6972ff0$var$hexToRgb(hex) {
    if (!(0, $kf78l.isHex)(hex)) throw new Error('Invalid HEX');
    const colorParts = hex.substring(1).split('');
    const color = colorParts.length === 3 || colorParts.length === 4 ? `${colorParts[0]}${colorParts[0]}${colorParts[1]}${colorParts[1]}${colorParts[2]}${colorParts[2]}` : colorParts.slice(0, 6).join('');
    const colorValue = Number(`0x${color}`);
    return [
        colorValue >> 16 & 255,
        colorValue >> 8 & 255,
        colorValue & 255
    ];
}
function $830e736ef6972ff0$var$relativeLuminanceW3C(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}
function $830e736ef6972ff0$export$d061e26956a60b0a(foreground, background) {
    if (!(0, $kf78l.isHex)(foreground) || !(0, $kf78l.isHex)(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $830e736ef6972ff0$var$hexToRgb(foreground);
    const backgroundRgb = $830e736ef6972ff0$var$hexToRgb(background);
    const foregroundLuminance = $830e736ef6972ff0$var$relativeLuminanceW3C(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $830e736ef6972ff0$var$relativeLuminanceW3C(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    const brightest = Math.max(foregroundLuminance, backgroundLuminance);
    const darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}



const $0f006af7f4f6b644$var$resolveColorValue = (color, fallback)=>{
    return (0, $3gFnx.getTokenCSSVariableValue)(color) || (color.startsWith('var(') ? fallback : color);
};
const $0f006af7f4f6b644$var$getForegroundColor = (textColor, defaultColor)=>{
    if (!textColor || defaultColor && textColor === defaultColor) return (0, $89bON.default)('color.text', defaultColor || (0, $999ee779dc37338e$export$37394b0fa44b998c).color);
    const colorValue = (0, $g8ETs.hexToEditorTextPaletteColor)(textColor) || textColor;
    return $0f006af7f4f6b644$var$resolveColorValue(colorValue, textColor);
};
const $0f006af7f4f6b644$var$getBackgroundColor = (backgroundColor, palette = 'text')=>{
    if (!backgroundColor || backgroundColor === 'none') return (0, $89bON.default)('elevation.surface', (0, $999ee779dc37338e$export$617cdcc6afaae4f7));
    const colorValue = palette === 'element' ? (0, $lqPdm.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(backgroundColor) || backgroundColor;
    return $0f006af7f4f6b644$var$resolveColorValue(colorValue, backgroundColor);
};
const $0f006af7f4f6b644$var$getBackgroundColorInNonActiveTheme = (backgroundColor, palette = 'text')=>{
    if (!backgroundColor || backgroundColor === 'none') return (0, $3gFnx.getTokenCSSVariableValueForNonActiveTheme)("var(--ds-surface, #FFFFFF)", (0, $999ee779dc37338e$export$617cdcc6afaae4f7));
    const colorValue = palette === 'element' ? (0, $lqPdm.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(backgroundColor) || backgroundColor;
    return (0, $3gFnx.getTokenCSSVariableValueForNonActiveTheme)(colorValue, backgroundColor);
};
const $0f006af7f4f6b644$var$STANDARD_PANEL_BACKGROUND_COLORS = new Map([
    [
        (0, $jVdlG.PanelType).INFO,
        (0, $45O09.getPanelTypeBackgroundNoTokens)((0, $jVdlG.PanelType).INFO)
    ],
    [
        (0, $jVdlG.PanelType).NOTE,
        (0, $45O09.getPanelTypeBackgroundNoTokens)((0, $jVdlG.PanelType).NOTE)
    ],
    [
        (0, $jVdlG.PanelType).SUCCESS,
        (0, $45O09.getPanelTypeBackgroundNoTokens)((0, $jVdlG.PanelType).SUCCESS)
    ],
    [
        (0, $jVdlG.PanelType).WARNING,
        (0, $45O09.getPanelTypeBackgroundNoTokens)((0, $jVdlG.PanelType).WARNING)
    ],
    [
        (0, $jVdlG.PanelType).ERROR,
        (0, $45O09.getPanelTypeBackgroundNoTokens)((0, $jVdlG.PanelType).ERROR)
    ]
]);
const $0f006af7f4f6b644$var$getResolvedBackgroundFromHighlight = (highlightColor)=>{
    if (!highlightColor) return {
        color: null,
        source: 'text'
    };
    return {
        color: highlightColor,
        source: 'text'
    };
}; /**
    * Resolves a background color from a container node that paints behind text.
    * Callers walk ancestors so the nearest painted container wins.
    */ 
const $0f006af7f4f6b644$var$getSupportedAncestorBackgroundColor = (node)=>{
    let backgroundColor;
    if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') backgroundColor = node.attrs.background;
    else if (node.type.name === 'panel' || node.type.name === 'panel_c1') {
        if (node.attrs.panelType === (0, $jVdlG.PanelType).CUSTOM) backgroundColor = node.attrs.panelColor;
        else backgroundColor = $0f006af7f4f6b644$var$STANDARD_PANEL_BACKGROUND_COLORS.get(node.attrs.panelType);
    }
    return backgroundColor ? {
        color: backgroundColor,
        source: 'element'
    } : null;
}; /**
    * Resolves the visible background behind a text node.
    * Text highlight wins before falling back to the nearest element background.
    */ 
const $0f006af7f4f6b644$export$b51989a8ef7747fa = ($pos, node)=>{
    for (const mark of node.marks){
        if (mark.type.name === 'backgroundColor' && mark.attrs.color) return {
            color: mark.attrs.color,
            source: 'text'
        };
    }
    for(let depth = $pos.depth; depth > 0; depth--){
        const resolvedBackgroundColor = $0f006af7f4f6b644$var$getSupportedAncestorBackgroundColor($pos.node(depth));
        if (resolvedBackgroundColor) return resolvedBackgroundColor;
    }
    return {
        color: null,
        source: 'text'
    };
};
const $0f006af7f4f6b644$var$getResolvedBackgroundColorForPosition = ($pos, highlightColor)=>{
    const highlightBackground = $0f006af7f4f6b644$var$getResolvedBackgroundFromHighlight(highlightColor);
    if (highlightColor) return highlightBackground;
    for(let depth = $pos.depth; depth > 0; depth--){
        const resolvedBackgroundColor = $0f006af7f4f6b644$var$getSupportedAncestorBackgroundColor($pos.node(depth));
        if (resolvedBackgroundColor) return resolvedBackgroundColor;
    }
    return highlightBackground;
};
const $0f006af7f4f6b644$var$getResolvedBackgroundColorValue = (backgroundColor)=>{
    if (backgroundColor.source === 'element') return $0f006af7f4f6b644$var$getBackgroundColor(backgroundColor.color, 'element');
    return $0f006af7f4f6b644$var$getBackgroundColor(backgroundColor.color);
};
const $0f006af7f4f6b644$var$getResolvedBackgroundColorValueInNonActiveTheme = (backgroundColor)=>{
    if (backgroundColor.source === 'element') return $0f006af7f4f6b644$var$getBackgroundColorInNonActiveTheme(backgroundColor.color, 'element');
    return $0f006af7f4f6b644$var$getBackgroundColorInNonActiveTheme(backgroundColor.color);
};
const $0f006af7f4f6b644$var$useColorAccessibilityState = (api)=>{
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textColor',
        'highlight'
    ], (states)=>({
            defaultColor: states.textColorState?.defaultColor,
            highlightColor: states.highlightState?.activeColor,
            textColor: states.textColorState?.color
        }));
};
const $0f006af7f4f6b644$var$getContrastRatio = (defaultColor, backgroundColor, textColor)=>{
    try {
        const contrastRatio = (0, $830e736ef6972ff0$export$d061e26956a60b0a)($0f006af7f4f6b644$var$getForegroundColor(textColor, defaultColor), $0f006af7f4f6b644$var$getResolvedBackgroundColorValue(backgroundColor));
        return contrastRatio;
    } catch  {
        // if we failed to calculate the contrast ratio, return null
        return null;
    }
}; // Computes the contrast ratio as it would appear in the non-active theme.
const $0f006af7f4f6b644$var$getNonActiveThemeContrastRatio = (defaultColor, backgroundColor, textColor)=>{
    try {
        return (0, $830e736ef6972ff0$export$d061e26956a60b0a)((0, $3535827cfdecaa47$export$fde37617ba913701)(textColor ?? null, defaultColor || (0, $999ee779dc37338e$export$37394b0fa44b998c).color), $0f006af7f4f6b644$var$getResolvedBackgroundColorValueInNonActiveTheme(backgroundColor));
    } catch  {
        // if we failed to calculate the contrast ratio, return null
        return null;
    }
};
const $0f006af7f4f6b644$var$getAccessibilityStatus = (contrastRatio)=>{
    if (contrastRatio >= (0, $999ee779dc37338e$export$fc59e1ed5414eef9)) return 'accessible';
    else if (contrastRatio >= (0, $999ee779dc37338e$export$423a5169d8af406a)) return 'difficultToRead';
    else return 'inaccessible';
}; /**
    * Computes status from active foreground/background colors only.
    * Used by the gate-off path so legacy behavior stays isolated.
    */ 
const $0f006af7f4f6b644$var$getAccessibilityStatusFromColorPair = (defaultColor, backgroundColor, textColor)=>{
    const contrastRatio = $0f006af7f4f6b644$var$getContrastRatio(defaultColor, backgroundColor, textColor);
    return contrastRatio === null ? null : $0f006af7f4f6b644$var$getAccessibilityStatus(contrastRatio);
}; /**
    * Returns the lowest contrast ratio across active and non-active themes.
    */ 
const $0f006af7f4f6b644$var$getMostCriticalContrastRatioAcrossThemes = (defaultColor, backgroundColor, textColor)=>{
    const contrastRatio = $0f006af7f4f6b644$var$getContrastRatio(defaultColor, backgroundColor, textColor);
    const nonActiveThemeContrastRatio = $0f006af7f4f6b644$var$getNonActiveThemeContrastRatio(defaultColor, backgroundColor, textColor);
    if (contrastRatio !== null && nonActiveThemeContrastRatio !== null) return Math.min(contrastRatio, nonActiveThemeContrastRatio);
    return contrastRatio;
};
const $0f006af7f4f6b644$var$getAccessibilityStatusFromColorPairAcrossThemes = (defaultColor, backgroundColor, textColor)=>{
    const mostCriticalContrastRatio = $0f006af7f4f6b644$var$getMostCriticalContrastRatioAcrossThemes(defaultColor, backgroundColor, textColor);
    return mostCriticalContrastRatio === null ? null : $0f006af7f4f6b644$var$getAccessibilityStatus(mostCriticalContrastRatio);
}; /**
    * Collects the worst accessibility status across all unique foreground/background
    * combinations in the current selection.
    *
    * When the selection spans multiple text colors and/or resolved backgrounds,
    * this checks each unique pair across both the active and non-active theme and
    * returns the worst status found.
    */ 
const $0f006af7f4f6b644$var$getWorstAccessibilityStatusFromEditorState = (state, defaultColor)=>{
    let worstContrastRatio = null; // Text/highlight colors only apply to a text range. If the selection is
    // not a text selection (e.g. a node, cell or all selection) there is no
    // meaningful range of colored text to evaluate.
    if (!(state.selection instanceof (0, $kCECX.TextSelection)) || state.selection.empty) return null;
    const { from: from, to: to } = state.selection;
    const seen = new Set();
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isText) return !node.isLeaf;
        let textColor = null;
        for (const mark of node.marks)if (mark.type.name === 'textColor') textColor = mark.attrs.color ?? null;
        const backgroundColor = $0f006af7f4f6b644$export$b51989a8ef7747fa(state.doc.resolve(pos), node);
        const pairKey = `${textColor ?? 'default'}|${backgroundColor.source}|${backgroundColor.color ?? 'default'}`; // Skip foreground/background pairs already evaluated. The source is
        // part of the key because text highlights and element backgrounds use
        // different editor palettes.
        if (seen.has(pairKey)) return;
        seen.add(pairKey);
        const mostCriticalContrastRatio = $0f006af7f4f6b644$var$getMostCriticalContrastRatioAcrossThemes(defaultColor, backgroundColor, textColor);
        if (mostCriticalContrastRatio === null) return;
        if (worstContrastRatio === null || mostCriticalContrastRatio < worstContrastRatio) worstContrastRatio = mostCriticalContrastRatio;
    });
    return worstContrastRatio === null ? null : $0f006af7f4f6b644$var$getAccessibilityStatus(worstContrastRatio);
};
const $0f006af7f4f6b644$export$347a4f417fdc66ea = (state, defaultColor, highlightColor, textColor)=>{
    if (state.selection instanceof (0, $kCECX.TextSelection)) {
        if (!state.selection.empty) return $0f006af7f4f6b644$var$getWorstAccessibilityStatusFromEditorState(state, defaultColor);
        return $0f006af7f4f6b644$var$getAccessibilityStatusFromColorPairAcrossThemes(defaultColor, $0f006af7f4f6b644$var$getResolvedBackgroundColorForPosition(state.selection.$from, highlightColor), textColor);
    }
    return null;
};
const $0f006af7f4f6b644$var$AccessibilityStatus = ({ accessibilityStatus: accessibilityStatus, formatMessage: formatMessage })=>{
    if (accessibilityStatus === 'accessible') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: "color.text.success",
        children: formatMessage((0, $4KjiO.colorAccessibilityMessages).accessibleLabel)
    });
    else if (accessibilityStatus === 'difficultToRead') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: "color.text.warning",
        children: formatMessage((0, $4KjiO.colorAccessibilityMessages).difficultToReadLabel)
    });
    else return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: "color.text.danger",
        children: formatMessage((0, $4KjiO.colorAccessibilityMessages).inaccessibleLabel)
    });
};
const $0f006af7f4f6b644$var$styles = {
    container: "_30huDKYbGa _3138422ADO _0Of8r21Y8M _1wydGW1Y8M _2Zuz6Q2ADO _1Znuxb1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    containerPatch: "_313842Pgdg _0Of8r2Pgdg _1wydGWPgdg _2Zuz6QPgdg _1ZnuxbPgdg"
};
const $0f006af7f4f6b644$export$8e34e17dd957d56 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { defaultColor: defaultColor, highlightColor: highlightColor, textColor: textColor } = $0f006af7f4f6b644$var$useColorAccessibilityState(api);
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const editorState = editorView?.state;
    const accessibilityStatus = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>editorState && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? $0f006af7f4f6b644$export$347a4f417fdc66ea(editorState, defaultColor, highlightColor, textColor) : $0f006af7f4f6b644$var$getAccessibilityStatusFromColorPair(defaultColor, $0f006af7f4f6b644$var$getResolvedBackgroundFromHighlight(highlightColor), textColor), [
        defaultColor,
        editorState,
        highlightColor,
        textColor
    ]);
    if (accessibilityStatus === null) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {});
    const tooltipContent = (accessibilityStatus)=>{
        if (accessibilityStatus === 'accessible') return formatMessage((0, $4KjiO.colorAccessibilityMessages).accessibleTooltip);
        else if (accessibilityStatus === 'difficultToRead') return formatMessage((0, $4KjiO.colorAccessibilityMessages).difficultToReadTooltip);
        else return formatMessage((0, $4KjiO.colorAccessibilityMessages).inaccessibleTooltip);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0f006af7f4f6b644$var$styles.container, (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') && $0f006af7f4f6b644$var$styles.containerPatch),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dCk1A))), {
                        label: "",
                        size: "medium",
                        color: (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? "var(--ds-icon-subtle, #505258)" : undefined
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "span",
                        size: "small",
                        color: "color.text.subtle",
                        children: formatMessage((0, $4KjiO.colorAccessibilityMessages).accessibility)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "span",
                        size: "small",
                        color: "color.text.subtle",
                        "aria-hidden": "true",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($0f006af7f4f6b644$var$AccessibilityStatus, {
                        accessibilityStatus: accessibilityStatus,
                        formatMessage: formatMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
                shape: "circle",
                label: tooltipContent(accessibilityStatus),
                isTooltipDisabled: false,
                spacing: "compact",
                appearance: "subtle"
            })
        ]
    });
};


/* RemoveColorMenuItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");





var $ad7Ou = parcelRequire("ad7Ou");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $evFm2 = parcelRequire("evFm2");


var $kwf4Z = parcelRequire("kwf4Z");


var $cBcXO = parcelRequire("cBcXO");










const $d10d4601a49597a0$var$styles = {
    removeColorButton: "_0bjKvDKxmn _2YLqiKFQfX _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _313842gVvo",
    removeColorButtonPatch: "_2YLqiKPgdg _313842Pgdg",
    iconContainer: "_2mHwu8gVvo _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $d10d4601a49597a0$export$cb635404e02af50a = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const onClick = (event)=>{
        if (!api) return;
        const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
        if (!defaultColor) return;
        api.core.actions.execute(({ tr: tr })=>{
            if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) || !(0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_2')) api.textColor.commands.changeColor(defaultColor, (0, $is7KY.getInputMethodFromParentKeys)(parents))({
                tr: tr
            });
            api.highlight?.commands.changeColor({
                color: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            })({
                tr: tr
            });
            return tr;
        });
        if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) closeMenu?.(event);
    };
    if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
        if ((0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_2')) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                $d10d4601a49597a0$var$styles.removeColorButton,
                $d10d4601a49597a0$var$styles.removeColorButtonPatch
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                shouldFitContainer: true,
                appearance: "subtle",
                onClick: onClick,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                    className: (0, $hekY6.default)([
                        $d10d4601a49597a0$var$styles.iconContainer
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBcXO))), {
                            size: "medium",
                            label: ""
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            color: "color.text.subtle",
                            children: formatMessage((0, $hzZPp.highlightMessages).removeHighlight)
                        })
                    ]
                })
            })
        });
        else if ((0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1')) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                $d10d4601a49597a0$var$styles.removeColorButton,
                $d10d4601a49597a0$var$styles.removeColorButtonPatch
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                shouldFitContainer: true,
                appearance: "subtle",
                onClick: onClick,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                    className: (0, $hekY6.default)([
                        $d10d4601a49597a0$var$styles.iconContainer
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBcXO))), {
                            size: "medium",
                            label: ""
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            color: "color.text.subtle",
                            children: formatMessage((0, $hzZPp.highlightMessages).clearColors)
                        })
                    ]
                })
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                $d10d4601a49597a0$var$styles.removeColorButton
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                shouldFitContainer: true,
                appearance: "subtle",
                onClick: onClick,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                    className: (0, $hekY6.default)([
                        $d10d4601a49597a0$var$styles.iconContainer
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBcXO))), {
                            size: "medium",
                            label: ""
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            weight: "medium",
                            children: formatMessage((0, $hzZPp.highlightMessages).clearColors)
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $d10d4601a49597a0$var$styles.removeColorButton
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                weight: "medium",
                children: formatMessage((0, $hzZPp.highlightMessages).removeColor)
            })
        })
    });
};
























var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $8xvQD = parcelRequire("8xvQD");

const $c2c2ab66c2135039$export$1c83d9b6bb9a01e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, defaultColor: defaultColor, textColor: textColor } = t0;
    let t1;
    if ($[0] !== defaultColor || $[1] !== textColor) {
        t1 = {
            defaultColor: defaultColor,
            textColor: textColor
        };
        $[0] = defaultColor;
        $[1] = textColor;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8xvQD.SelectedTextColorContext).Provider, {
            value: value,
            children: children
        });
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, defaultColor: defaultColor, textColor: textColor })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            defaultColor: defaultColor,
            textColor: textColor
        }), [
        defaultColor,
        textColor
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8xvQD.SelectedTextColorContext).Provider, {
        value: value,
        children: children
    });
};



var $4Qu9h = parcelRequire("4Qu9h");







var $imx1A = parcelRequire("imx1A");

var $WcuYo = parcelRequire("WcuYo");

var $a6nzD = parcelRequire("a6nzD");



var $lslMH = parcelRequire("lslMH");

var $b2jdX = parcelRequire("b2jdX");


var $isuYJ = parcelRequire("isuYJ");




const $d79094ec1a8acd8d$var$getIconColor = (textColor, defaultColor, highlightColor)=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
        if (!textColor || textColor === defaultColor && defaultColor) return "var(--ds-text, #292A2E)";
        return (0, $g8ETs.hexToEditorTextPaletteColor)(textColor) || "var(--ds-text, #292A2E)";
    }
    if (highlightColor || !textColor || textColor === defaultColor && defaultColor) return "var(--ds-text, #292A2E)";
    return (0, $g8ETs.hexToEditorTextPaletteColor)(textColor) || "var(--ds-text, #292A2E)";
};
const $d79094ec1a8acd8d$var$getHighlightColorIcon = (highlightColor)=>{
    if (highlightColor) return (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(highlightColor);
    return undefined;
};
const $d79094ec1a8acd8d$var$useTextColorHighlightMenuStateNew = (api)=>{
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textColor',
        'highlight',
        'interaction'
    ], (states)=>{
        const useDefaultToolbarState = states.interactionState?.interactionState === 'hasNotHadInteraction';
        return {
            isTextColorDisabled: states.textColorState?.disabled,
            textColor: states.textColorState?.color,
            defaultColor: states.textColorState?.defaultColor,
            isPaletteOpen: states.textColorState?.isPaletteOpen,
            highlightColor: useDefaultToolbarState ? undefined : states.highlightState?.activeColor
        };
    });
};
const $d79094ec1a8acd8d$var$useTextColorHighlightMenuStateOld = (api)=>{
    const isTextColorDisabled = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'textColor.disabled');
    const textColor = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'textColor.color');
    const defaultColor = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'textColor.defaultColor');
    const isPaletteOpen = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'textColor.isPaletteOpen');
    const highlightColor = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    return {
        isTextColorDisabled: isTextColorDisabled,
        textColor: textColor,
        defaultColor: defaultColor,
        isPaletteOpen: isPaletteOpen,
        highlightColor: highlightColor
    };
};
const $d79094ec1a8acd8d$var$useTextColorHighlightMenuState = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $ieeJu.expValEquals)('platform_editor_default_toolbar_state', 'isEnabled', true), $d79094ec1a8acd8d$var$useTextColorHighlightMenuStateNew, $d79094ec1a8acd8d$var$useTextColorHighlightMenuStateOld);
const $d79094ec1a8acd8d$export$c448885240fc43ad = ({ children: children, api: api })=>{
    const isHighlightPluginExisted = !!api?.highlight;
    const { isDisabled: isToolbarDisabled } = (0, $b2jdX.useToolbarUI)();
    const { isTextColorDisabled: isTextColorDisabled, textColor: textColor, defaultColor: defaultColor, isPaletteOpen: isPaletteOpen, highlightColor: highlightColor } = $d79094ec1a8acd8d$var$useTextColorHighlightMenuState(api);
    const isDisabled = Boolean(isToolbarDisabled || isTextColorDisabled);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const setIsPaletteOpen = (0, $cozmU.useCallback)((isOpen)=>{
        if (api?.textColor?.commands?.setPalette) api.core.actions.execute(({ tr: tr })=>{
            api.textColor.commands.setPalette(isOpen)({
                tr: tr
            });
            return tr;
        });
    }, [
        api?.textColor?.commands,
        api?.core.actions
    ]);
    // use isPaletteOpenRef to "close" the palette on unmount, and not on state changes
    const isPaletteOpenRef = (0, $cozmU.useRef)(isPaletteOpen);
    isPaletteOpenRef.current = isPaletteOpen;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
                if (isPaletteOpenRef.current) setIsPaletteOpen(false);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) return;
            if (isPaletteOpen) setIsPaletteOpen(false);
        };
    }, [
        setIsPaletteOpen,
        isPaletteOpen
    ]);
    const iconColor = $d79094ec1a8acd8d$var$getIconColor(textColor, defaultColor, highlightColor);
    if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kwf4Z.ToolbarDropdownMenuProvider), {
        isOpen: isPaletteOpen,
        setIsOpen: setIsPaletteOpen,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $WcuYo.ToolbarColorSwatch), {
                highlightColor: $d79094ec1a8acd8d$var$getHighlightColorIcon(highlightColor),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $imx1A.TextColorIcon), {
                    label: formatMessage((0, $8Ajok.textColorMessages).textColorTooltip),
                    iconColor: iconColor,
                    shouldRecommendSmallIcon: true,
                    size: 'small',
                    isDisabled: isDisabled,
                    spacing: 'compact'
                })
            }),
            isDisabled: isDisabled,
            testId: "text-color-highlight-menu",
            hasSectionMargin: false,
            tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                    description: formatMessage(isHighlightPluginExisted ? (0, $8Ajok.textColorMessages).textColorHighlightTooltip : (0, $8Ajok.textColorMessages).textColorTooltip),
                    keymap: (0, $ldqjS.toggleHighlightPalette)
                })
            }),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c2c2ab66c2135039$export$1c83d9b6bb9a01e), {
                textColor: textColor,
                defaultColor: defaultColor,
                children: children
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kwf4Z.ToolbarDropdownMenuProvider), {
        isOpen: isPaletteOpen,
        setIsOpen: setIsPaletteOpen,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $WcuYo.ToolbarColorSwatch), {
                highlightColor: $d79094ec1a8acd8d$var$getHighlightColorIcon(highlightColor),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $imx1A.TextColorIcon), {
                    label: formatMessage((0, $8Ajok.textColorMessages).textColorTooltip),
                    iconColor: iconColor,
                    shouldRecommendSmallIcon: true,
                    size: 'small',
                    isDisabled: isDisabled,
                    spacing: 'compact'
                })
            }),
            isDisabled: isDisabled,
            testId: "text-color-highlight-menu",
            hasSectionMargin: false,
            tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                    description: formatMessage(isHighlightPluginExisted ? (0, $8Ajok.textColorMessages).textColorHighlightTooltip : (0, $8Ajok.textColorMessages).textColorTooltip),
                    keymap: (0, $ldqjS.toggleHighlightPalette)
                })
            }),
            children: children
        })
    });
};


/* TextColorMenuItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 


























var $74bCf = parcelRequire("74bCf");




var $I7hWB = parcelRequire("I7hWB");





var $22YX5 = parcelRequire("22YX5");

var $dinVW = parcelRequire("dinVW");




const $3d44570196074431$var$TEXT_COLOR_PICKER_COLUMNS = 10;
const $3d44570196074431$var$styles = {
    container: "_2mHwu8gVvo"
};
function $3d44570196074431$export$12b1414e9754f110({ api: api, parents: parents }) {
    const { color: color, defaultColor: defaultColor, palette: palette } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], (states)=>({
            color: states.textColorState?.color,
            defaultColor: states.textColorState?.defaultColor || null,
            palette: states.textColorState?.palette || []
        }));
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const handleTextColorChange = (0, $cozmU.useCallback)((color, event)=>{
        if (!editorView?.state || !editorView?.dispatch) return;
        if (api?.textColor?.actions?.changeColor) {
            api.textColor.actions.changeColor(color, (0, $is7KY.getInputMethodFromParentKeys)(parents))(editorView.state, editorView.dispatch);
            if (!isNewColorPaletteEnabled) closeMenu?.(event);
        }
    }, [
        editorView?.state,
        editorView?.dispatch,
        api?.textColor.actions,
        parents,
        closeMenu,
        isNewColorPaletteEnabled
    ]);
    const colorPalette = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $74bCf.default), {
        cols: isNewColorPaletteEnabled ? $3d44570196074431$var$TEXT_COLOR_PICKER_COLUMNS : undefined,
        gap: isNewColorPaletteEnabled && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? 'space.0' : undefined,
        onClick: (color, _, event)=>{
            handleTextColorChange(color, event);
        },
        selectedColor: color || defaultColor,
        paletteOptions: {
            palette: palette,
            hexToPaletteColor: (0, $g8ETs.hexToEditorTextPaletteColor),
            paletteColorTooltipMessages: (0, $8VCvx.textPaletteTooltipMessages)
        }
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: $3d44570196074431$var$styles.container,
        testId: "text-color-menu-item",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                size: "xxsmall",
                children: formatMessage((0, $8Ajok.textColorMessages).textColorTooltip)
            }),
            isNewColorPaletteEnabled && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $22YX5.Bleed), {
                inline: "space.025",
                children: colorPalette
            }) : colorPalette
        ]
    });
}


/* TextMenuSection.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");





var $jgJIe = parcelRequire("jgJIe");










const $8efc7a327ac0f8b0$var$styles = {
    menuOld: "_4c065UFQfX _2Y7lL42ADO",
    menu: "_2mHwu82ADO _4c065UgVvo _2Y7lL48HPE _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $8efc7a327ac0f8b0$export$95716c110be351d7 = ({ children: children, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3nacY.TEXT_COLLAPSED_MENU).key);
    const onMouseDown = (event)=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1')) event.stopPropagation();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? $8efc7a327ac0f8b0$var$styles.menu : $8efc7a327ac0f8b0$var$styles.menuOld,
            onMouseDown: onMouseDown,
            children: children
        })
    });
};


const $954b1bc41de43a55$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP),
            parents: [
                {
                    ...(0, $3nacY.TEXT_SECTION),
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                },
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                }
            ]
        },
        {
            ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU),
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP),
                    rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_GROUP_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d79094ec1a8acd8d$export$c448885240fc43ad), {
                    api: api,
                    children: children
                })
        },
        {
            ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU),
                    rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_MENU_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]
                },
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $hVLmg.TEXT_COLLAPSED_MENU_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]
                }
            ],
            component: (0, $8efc7a327ac0f8b0$export$95716c110be351d7)
        },
        {
            ...(0, $3nacY.TEXT_COLOR_MENU_ITEM),
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3nacY.TEXT_COLOR_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3d44570196074431$export$12b1414e9754f110), {
                    api: api,
                    parents: parents
                })
        },
        {
            ...(0, $3nacY.CLEAR_COLOR_MENU_ITEM),
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3nacY.CLEAR_COLOR_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d10d4601a49597a0$export$cb635404e02af50a), {
                    api: api,
                    parents: parents
                });
            }
        },
        ...(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? [
            {
                ...(0, $3nacY.COLOR_ACCESSIBILITY_MENU_ITEM),
                parents: [
                    {
                        ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                        rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3nacY.COLOR_ACCESSIBILITY_MENU_ITEM).key]
                    }
                ],
                component: ()=>{
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0f006af7f4f6b644$export$8e34e17dd957d56), {
                        api: api
                    });
                }
            }
        ] : []
    ];
};


const $70ec4ff7aa9855bd$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $70ec4ff7aa9855bd$var$isToolbarComponentEnabled = (textColorConfig)=>{
    return textColorConfig === undefined || textColorConfig.toolbarConfig === undefined || textColorConfig.toolbarConfig.enabled !== false;
};
const $70ec4ff7aa9855bd$export$7658bf1f1b6f477d = ({ config: textColorConfig, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ce4472f0d522d003$export$94516d5cccf573e3), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    if (isToolbarAIFCEnabled) {
        if (api?.toolbar?.actions.registerComponents && $70ec4ff7aa9855bd$var$isToolbarComponentEnabled($70ec4ff7aa9855bd$var$pluginConfig(textColorConfig))) api.toolbar.actions.registerComponents((0, $954b1bc41de43a55$export$a758406ca53b86a5)(api));
    } else api?.primaryToolbar?.actions.registerComponent({
        name: 'textColor',
        component: primaryToolbarComponent
    });
    return {
        name: 'textColor',
        marks () {
            return [
                {
                    name: 'textColor',
                    mark: (0, $jj5Xg.textColor)
                }
            ];
        },
        pmPlugins () {
            return isToolbarAIFCEnabled ? [
                {
                    name: 'textColor',
                    plugin: ({ dispatch: dispatch })=>(0, $2153a7c50016f73c$export$ae829ec7b2625219)(dispatch, $70ec4ff7aa9855bd$var$pluginConfig(textColorConfig))
                },
                {
                    name: 'textColorKeymap',
                    plugin: ()=>(0, $d4b6680cb3374a02$export$e832373cff8dec22)({
                            api: api
                        })
                }
            ] : [
                {
                    name: 'textColor',
                    plugin: ({ dispatch: dispatch })=>(0, $2153a7c50016f73c$export$ae829ec7b2625219)(dispatch, $70ec4ff7aa9855bd$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $2153a7c50016f73c$export$18d4026d1ea86bb1).getState(editorState);
        },
        actions: {
            changeColor: (color, inputMethod)=>{
                return (0, $5a4deb662451a466$export$917538e4f4eb20f9)(color, api?.analytics?.actions, inputMethod);
            }
        },
        commands: {
            changeColor: (color, inputMethod)=>{
                return (0, $e6090b152dd7da09$export$917538e4f4eb20f9)(color, api, inputMethod);
            },
            setPalette: (isPaletteOpen)=>{
                return (0, $0ad86716b6f040bb$export$9567774ece486a9)(isPaletteOpen);
            }
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar: ()=>{
                const toolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState?.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7e32c07e15adfdd9$export$b15abb95157a91c7), {
                                editorView: view,
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                api: api
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 6,
                        pluginName: 'textColor'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["textColorPlugin"] = $70ec4ff7aa9855bd$export$7658bf1f1b6f477d;

});

parcelRegister("9Av6M", function(module, exports) {

var $xx2Zf = parcelRequire("xx2Zf");


var $j1hRT = parcelRequire("j1hRT");

const $48f8210f239760b6$export$cf81161afbd9f18c = (label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $xx2Zf.default)((0, $j1hRT.default), key);
    return {
        value: color,
        label: label,
        border: "var(--ds-border, #0B120E24)",
        message: message
    };
};
module.exports["mapPaletteColor"] = $48f8210f239760b6$export$cf81161afbd9f18c;

});

parcelRegister("j1hRT", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $59b09dccca4964f8$var$_default_1 = (0, $kSwu1.defineMessages)({
    white: {
        id: "fabric.theme.white",
        defaultMessage: "White"
    },
    'light-blue': {
        id: "fabric.theme.light-blue",
        defaultMessage: "Light blue"
    },
    'light-teal': {
        id: "fabric.theme.light-teal",
        defaultMessage: "Light teal"
    },
    'light-green': {
        id: "fabric.theme.light-green",
        defaultMessage: "Light green"
    },
    'light-lime': {
        id: "fabric.theme.light-lime",
        defaultMessage: "Light lime"
    },
    'light-yellow': {
        id: "fabric.theme.light-yellow",
        defaultMessage: "Light yellow"
    },
    'light-orange': {
        id: "fabric.theme.light-orange",
        defaultMessage: "Light orange"
    },
    'light-red': {
        id: "fabric.theme.light-red",
        defaultMessage: "Light red"
    },
    'light-magenta': {
        id: "fabric.theme.light-magenta",
        defaultMessage: "Light magenta"
    },
    'light-purple': {
        id: "fabric.theme.light-purple",
        defaultMessage: "Light purple"
    },
    'light-gray': {
        id: "fabric.theme.light-gray",
        defaultMessage: "Light gray"
    },
    blue: {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    teal: {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    green: {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    yellow: {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    red: {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    orange: {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    purple: {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    gray: {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    'dark-blue': {
        id: "fabric.theme.dark-blue",
        defaultMessage: "Dark blue"
    },
    'dark-teal': {
        id: "fabric.theme.dark-teal",
        defaultMessage: "Dark teal"
    },
    'dark-green': {
        id: "fabric.theme.dark-green",
        defaultMessage: "Dark green"
    },
    'dark-lime': {
        id: "fabric.theme.dark-lime",
        defaultMessage: "Dark lime"
    },
    'dark-yellow': {
        id: "fabric.theme.dark-yellow",
        defaultMessage: "Dark yellow"
    },
    'dark-orange': {
        id: "fabric.theme.dark-orange",
        defaultMessage: "Dark orange"
    },
    'dark-red': {
        id: "fabric.theme.dark-red",
        defaultMessage: "Dark red"
    },
    'dark-magenta': {
        id: "fabric.theme.dark-magenta",
        defaultMessage: "Dark magenta"
    },
    'dark-purple': {
        id: "fabric.theme.dark-purple",
        defaultMessage: "Dark purple"
    },
    'subtle-gray': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    'bold-gray': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    },
    'subtle-lime': {
        id: "fabric.theme.subtle-lime",
        defaultMessage: "Subtle lime"
    },
    'bold-lime': {
        id: "fabric.theme.bold-lime",
        defaultMessage: "Bold lime"
    },
    'subtle-orange': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    'bold-orange': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    'subtle-magenta': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    'bold-magenta': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    'bold-blue': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    'bold-teal': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    'bold-green': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    'bold-yellow': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    'bold-red': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    'bold-purple': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    // Colors only used in highlight palette
    'no-color': {
        id: "fabric.theme.no-color",
        defaultMessage: "No highlight"
    },
    lime: {
        id: "fabric.theme.lime",
        defaultMessage: "Lime"
    },
    magenta: {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    }
});
var $59b09dccca4964f8$export$2e2bcd8739ae039 = $59b09dccca4964f8$var$_default_1;
module.exports["default"] = $59b09dccca4964f8$export$2e2bcd8739ae039;

});

parcelRegister("evFm2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $1ptyh = parcelRequire("1ptyh");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $xx2Zf = parcelRequire("xx2Zf");


var $9Av6M = parcelRequire("9Av6M");


var $j1hRT = parcelRequire("j1hRT");

const $79fee612fdb3574f$export$7af0d402d86db2f8 = '#00000000';
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $79fee612fdb3574f$var$DiagonalLineGlyph = (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.2038 7.70388C17.5955 8.09565 17.5941 8.73128 17.2005 9.12127L9.1213 17.1277C8.73027 17.5152 8.09958 17.5138 7.71031 17.1245C7.31854 16.7328 7.31997 16.0971 7.71351 15.7071L15.7928 7.70069C16.1838 7.31318 16.8145 7.31461 17.2038 7.70388Z",
        fill: "currentColor",
        fillOpacity: "0.5"
    }));
const $79fee612fdb3574f$export$b875e193f77236ba = ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const primaryColor = colorMode === 'dark' ? "var(--ds-background-accent-gray-bolder, #6B6E76)" : "var(--ds-background-accent-gray-subtle, #8C8F97)";
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $lOiVq.jsx)($79fee612fdb3574f$var$DiagonalLineGlyph, {
        style: {
            color: primaryColor
        }
    }));
};
const $79fee612fdb3574f$export$d0f14653c33da02f = [
    {
        value: $79fee612fdb3574f$export$7af0d402d86db2f8,
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #0B120E24)",
        message: (0, $xx2Zf.default)((0, $j1hRT.default), 'no-color'),
        decorator: /*#__PURE__*/ (0, $lOiVq.jsx)($79fee612fdb3574f$export$b875e193f77236ba, null)
    }
];
(0, $1ptyh.backgroundColorPalette).forEach((label, color)=>{
    $79fee612fdb3574f$export$d0f14653c33da02f.push((0, $9Av6M.mapPaletteColor)(label, color));
});
module.exports["REMOVE_HIGHLIGHT_COLOR"] = $79fee612fdb3574f$export$7af0d402d86db2f8;
module.exports["highlightColorPalette"] = $79fee612fdb3574f$export$d0f14653c33da02f;

});

parcelRegister("8xvQD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $af1c10638e0f9f1e$export$72b8ac8e2a7bb722 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
module.exports["SelectedTextColorContext"] = $af1c10638e0f9f1e$export$72b8ac8e2a7bb722;

});

parcelRegister("imx1A", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $9FyRG = parcelRequire("9FyRG");


var $iMnC5 = parcelRequire("iMnC5");

const $3bb8da3c5ea3ad74$var$styles = {
    icon: "_313842gVvo"
};
const $3bb8da3c5ea3ad74$export$36ed63fbff8ebdac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, shouldRecommendSmallIcon: shouldRecommendSmallIcon, size: size, spacing: spacing, testId: testId, iconColor: iconColor, isDisabled: isDisabled } = t0;
    const t1 = isDisabled ? "var(--ds-icon-disabled, #080F214A)" : iconColor;
    let t2;
    if ($[0] !== label || $[1] !== shouldRecommendSmallIcon || $[2] !== size || $[3] !== spacing || $[4] !== t1 || $[5] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $3bb8da3c5ea3ad74$var$styles.icon,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
                label: label,
                testId: testId,
                color: t1,
                shouldRecommendSmallIcon: shouldRecommendSmallIcon,
                spacing: spacing,
                size: size
            })
        });
        $[0] = label;
        $[1] = shouldRecommendSmallIcon;
        $[2] = size;
        $[3] = spacing;
        $[4] = t1;
        $[5] = testId;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ label: label, shouldRecommendSmallIcon: shouldRecommendSmallIcon, size: size, spacing: spacing, testId: testId, iconColor: iconColor, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: $3bb8da3c5ea3ad74$var$styles.icon,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
            label: label,
            testId: testId,
            color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : iconColor,
            shouldRecommendSmallIcon: shouldRecommendSmallIcon,
            spacing: spacing,
            size: size
        })
    });
};
module.exports["TextColorIcon"] = $3bb8da3c5ea3ad74$export$36ed63fbff8ebdac;

});

parcelRegister("WcuYo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $b0aad844e00c642d$var$styles = {
    colorSwatch: "_30huDKOeNX _0bjKvDKxmn _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39xV02SPN1 _0jFU0VSPN1 _2XsHFM5UaJ _0adFHs5UaJ"
};
const $b0aad844e00c642d$export$772f650f1e0be5db = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, highlightColor: highlightColor } = t0;
    let t1;
    if ($[0] !== highlightColor) {
        t1 = {
            backgroundColor: highlightColor
        };
        $[0] = highlightColor;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $b0aad844e00c642d$var$styles.colorSwatch,
            testId: "toolbar-color-swatch",
            style: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, highlightColor: highlightColor })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $b0aad844e00c642d$var$styles.colorSwatch,
        testId: "toolbar-color-swatch",
        style: {
            backgroundColor: highlightColor
        },
        children: children
    });
};
module.exports["ToolbarColorSwatch"] = $b0aad844e00c642d$export$772f650f1e0be5db;

});

parcelRegister("74bCf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aELWC = parcelRequire("aELWC");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");


var $ieeJu = parcelRequire("ieeJu");


var $IQ4Dz = parcelRequire("IQ4Dz");











var $hekY6 = parcelRequire("hekY6");





var $eh6Ml = parcelRequire("eh6Ml");





var $anBbz = parcelRequire("anBbz");


var $lpNn5 = parcelRequire("lpNn5");

const $fb121074a77d574d$var$buttonWrapperStyles = null;
const $fb121074a77d574d$var$buttonWrapperStylesNew = null;
const $fb121074a77d574d$var$buttonStyles = null; /**
                            * Individual color palette item component
                            * Displays a single color swatch with tooltip and selection state
                            */ 
const $fb121074a77d574d$export$892596cec99bc70e = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(55);
    const { autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: t1, hexToPaletteColor: hexToPaletteColor, decorator: decorator, onClick: onClick, onKeyDown: onKeyDown } = t0;
    const checkMarkColor = t1 === undefined ? "var(--ds-icon-inverse, #FFFFFF)" : t1;
    let t2;
    if ($[0] !== hexToPaletteColor || $[1] !== value) {
        t2 = hexToPaletteColor ? hexToPaletteColor(value) : value;
        $[0] = hexToPaletteColor;
        $[1] = value;
        $[2] = t2;
    } else t2 = $[2];
    const colorStyle = t2;
    const handleMouseDown = $fb121074a77d574d$var$_temp;
    let t3;
    if ($[3] !== label || $[4] !== onClick || $[5] !== value) {
        t3 = (e_0)=>{
            e_0.preventDefault();
            onClick(value, label, e_0);
        };
        $[3] = label;
        $[4] = onClick;
        $[5] = value;
        $[6] = t3;
    } else t3 = $[6];
    const handleClick = t3;
    let t4;
    if ($[7] !== label || $[8] !== onKeyDown || $[9] !== value) {
        t4 = (e_1)=>{
            if (!onKeyDown) return;
            e_1.preventDefault();
            onKeyDown(value, label, e_1);
        };
        $[7] = label;
        $[8] = onKeyDown;
        $[9] = value;
        $[10] = t4;
    } else t4 = $[10];
    const handleKeyDown = t4;
    if ((0, $anBbz.expValEqualsNoExposure)("platform_editor_lovability_text_bg_color", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_lovability_text_bg_color_patch_1")) {
        let t5;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = (0, $hekY6.default)([
                "_0bjKvDKTcp _3vBAKHjOvk _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _0xkEdp9r67 _1jJ2xk9r67 _0hPERG9r67"
            ]);
            $[11] = t5;
        } else t5 = $[11];
        const t6 = colorStyle || "var(--ds-background-input, #FFFFFF)";
        const t7 = `${"var(--ds-border-width, 1px)"} solid ${borderColor}`;
        let t8;
        if ($[12] !== t6 || $[13] !== t7) {
            t8 = {
                backgroundColor: t6,
                border: t7
            };
            $[12] = t6;
            $[13] = t7;
            $[14] = t8;
        } else t8 = $[14];
        let t9;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t9 = (0, $hekY6.default)([
                "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0bjKvDKxmn _30huDKPrhC _0jFU0VNHnM _39xV02NHnM _0KLXruDMqu _0wOv4Q7zJH _3iDTPbvLZJ _1mT5xdRAKS _2fqI0WXzJH _38a67RFQfX"
            ]);
            $[15] = t9;
        } else t9 = $[15];
        let t10;
        if ($[16] !== checkMarkColor || $[17] !== decorator || $[18] !== isSelected) {
            t10 = !decorator && isSelected && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                color: checkMarkColor,
                label: ""
            });
            $[16] = checkMarkColor;
            $[17] = decorator;
            $[18] = isSelected;
            $[19] = t10;
        } else t10 = $[19];
        let t11;
        if ($[20] !== autoFocus || $[21] !== decorator || $[22] !== handleClick || $[23] !== handleKeyDown || $[24] !== isSelected || $[25] !== label || $[26] !== t10 || $[27] !== t8 || $[28] !== tabIndex) {
            t11 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: t5,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
                    type: "button",
                    "aria-label": label,
                    role: "radio",
                    "aria-checked": isSelected,
                    onClick: handleClick,
                    onKeyDown: handleKeyDown,
                    onMouseDown: handleMouseDown,
                    tabIndex: tabIndex,
                    style: t8,
                    autoFocus: autoFocus,
                    className: t9,
                    children: [
                        t10,
                        decorator
                    ]
                })
            });
            $[20] = autoFocus;
            $[21] = decorator;
            $[22] = handleClick;
            $[23] = handleKeyDown;
            $[24] = isSelected;
            $[25] = label;
            $[26] = t10;
            $[27] = t8;
            $[28] = tabIndex;
            $[29] = t11;
        } else t11 = $[29];
        let t12;
        if ($[30] !== label || $[31] !== t11) {
            t12 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: label,
                children: t11
            });
            $[30] = label;
            $[31] = t11;
            $[32] = t12;
        } else t12 = $[32];
        return t12;
    }
    let t5;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_0bjKvDKxmn _3vBAKHjOvk _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _0xkEdp9r67 _1jJ2xk9r67 _0hPERG9r67"
        ]);
        $[33] = t5;
    } else t5 = $[33];
    const t6 = colorStyle || "var(--ds-background-input, #FFFFFF)";
    const t7 = `${"var(--ds-border-width, 1px)"} solid ${borderColor}`;
    let t8;
    if ($[34] !== t6 || $[35] !== t7) {
        t8 = {
            backgroundColor: t6,
            border: t7
        };
        $[34] = t6;
        $[35] = t7;
        $[36] = t8;
    } else t8 = $[36];
    let t9;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0bjKvDKxmn _30huDKPrhC _0jFU0VNHnM _39xV02NHnM _0KLXruDMqu _0wOv4Q7zJH _3iDTPbvLZJ _1mT5xdRAKS _2fqI0WXzJH _38a67RFQfX"
        ]);
        $[37] = t9;
    } else t9 = $[37];
    let t10;
    if ($[38] !== checkMarkColor || $[39] !== decorator || $[40] !== isSelected) {
        t10 = !decorator && isSelected && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            color: checkMarkColor,
            label: ""
        });
        $[38] = checkMarkColor;
        $[39] = decorator;
        $[40] = isSelected;
        $[41] = t10;
    } else t10 = $[41];
    let t11;
    if ($[42] !== autoFocus || $[43] !== decorator || $[44] !== handleClick || $[45] !== handleKeyDown || $[46] !== isSelected || $[47] !== label || $[48] !== t10 || $[49] !== t8 || $[50] !== tabIndex) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t5,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
                type: "button",
                "aria-label": label,
                role: "radio",
                "aria-checked": isSelected,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                onMouseDown: handleMouseDown,
                tabIndex: tabIndex,
                style: t8,
                autoFocus: autoFocus,
                className: t9,
                children: [
                    t10,
                    decorator
                ]
            })
        });
        $[42] = autoFocus;
        $[43] = decorator;
        $[44] = handleClick;
        $[45] = handleKeyDown;
        $[46] = isSelected;
        $[47] = label;
        $[48] = t10;
        $[49] = t8;
        $[50] = tabIndex;
        $[51] = t11;
    } else t11 = $[51];
    let t12;
    if ($[52] !== label || $[53] !== t11) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: label,
            children: t11
        });
        $[52] = label;
        $[53] = t11;
        $[54] = t12;
    } else t12 = $[54];
    return t12;
} : ({ autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: checkMarkColor = "var(--ds-icon-inverse, #FFFFFF)", hexToPaletteColor: hexToPaletteColor, decorator: decorator, onClick: onClick, onKeyDown: onKeyDown })=>{
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const handleMouseDown = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const handleClick = (0, $cozmU.useCallback)((e_0)=>{
        e_0.preventDefault();
        onClick(value, label, e_0);
    }, [
        onClick,
        value,
        label
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e_1)=>{
        if (!onKeyDown) return;
        e_1.preventDefault();
        onKeyDown(value, label, e_1);
    }, [
        onKeyDown,
        value,
        label
    ]);
    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: label,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_0bjKvDKTcp _3vBAKHjOvk _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _0xkEdp9r67 _1jJ2xk9r67 _0hPERG9r67"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
                type: "button",
                "aria-label": label,
                role: "radio",
                "aria-checked": isSelected,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                onMouseDown: handleMouseDown,
                tabIndex: tabIndex,
                style: {
                    backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
                    border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
                },
                autoFocus: autoFocus,
                className: (0, $hekY6.default)([
                    "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0bjKvDKxmn _30huDKPrhC _0jFU0VNHnM _39xV02NHnM _0KLXruDMqu _0wOv4Q7zJH _3iDTPbvLZJ _1mT5xdRAKS _2fqI0WXzJH _38a67RFQfX"
                ]),
                children: [
                    !decorator && isSelected && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                        color: checkMarkColor,
                        label: ""
                    }),
                    decorator
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: label,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_0bjKvDKxmn _3vBAKHjOvk _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _0xkEdp9r67 _1jJ2xk9r67 _0hPERG9r67"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
                type: "button",
                "aria-label": label,
                role: "radio",
                "aria-checked": isSelected,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                onMouseDown: handleMouseDown,
                tabIndex: tabIndex,
                style: {
                    backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
                    border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
                },
                autoFocus: autoFocus,
                className: (0, $hekY6.default)([
                    "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0bjKvDKxmn _30huDKPrhC _0jFU0VNHnM _39xV02NHnM _0KLXruDMqu _0wOv4Q7zJH _3iDTPbvLZJ _1mT5xdRAKS _2fqI0WXzJH _38a67RFQfX"
                ]),
                children: [
                    !decorator && isSelected && /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                        color: checkMarkColor,
                        label: ""
                    }),
                    decorator
                ]
            })
        })
    });
});
function $fb121074a77d574d$var$_temp(e) {
    e.preventDefault();
}


function $c288d033f747f201$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happened when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}


const $0f8c33f1c98627f4$export$dc37d14f75a32acb = 7;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0f8c33f1c98627f4$var$CSS_VAR_REGEX = /var\(([^,\)]+)(,.*)?/;
function $0f8c33f1c98627f4$export$d97d52770ca27b6f(palette, cols = $0f8c33f1c98627f4$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $0f8c33f1c98627f4$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
function $0f8c33f1c98627f4$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $0f8c33f1c98627f4$export$dc37d14f75a32acb) {
    const colorsPerRow = $0f8c33f1c98627f4$export$d97d52770ca27b6f(palette, cols);
    return $0f8c33f1c98627f4$export$17092ffd56d3b3b2(colorsPerRow, selectedColor);
}
const $0f8c33f1c98627f4$export$426cbff16166281c = (variableExpression)=>{
    // Match CSS variable pattern: var(--variable-name, fallback)
    const matcher = variableExpression.match($0f8c33f1c98627f4$var$CSS_VAR_REGEX);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        // Return fallback if we're in a server environment
        if (typeof document === 'undefined') return fallback;
        // Get the computed value from the document
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};


/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @returns Highest contrast color in pool
 */ function $2e44d41dc267266a$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $0f8c33f1c98627f4$export$426cbff16166281c)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $aELWC.default).difference(b, colorValue) - (0, $aELWC.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)";
}
/**
 * ColorPalette component for displaying a grid of selectable colors
 *
 * Features:
 * - Responsive grid layout
 * - Keyboard navigation support
 * - Accessibility compliance (ARIA attributes)
 * - Theme-aware tooltips
 * - Design token integration
 * - Customizable color mapping
 */ const $2e44d41dc267266a$var$ColorPalette = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { cols: t1, gap: t2, onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, paletteOptions: paletteOptions } = t0;
    const cols = t1 === undefined ? (0, $0f8c33f1c98627f4$export$dc37d14f75a32acb) : t1;
    const gap = t2 === undefined ? "space.050" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $IQ4Dz.default)();
    const useIconToken = !!hexToPaletteColor;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_lovability_text_bg_color", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_lovability_text_bg_color_patch_1");
        $[0] = t3;
    } else t3 = $[0];
    const shouldUseInlineColorGap = t3;
    const paletteRef = (0, $cozmU.useRef)(null);
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            row: 0,
            col: 0
        };
        $[1] = t4;
    } else t4 = $[1];
    const currentFocusRef = (0, $cozmU.useRef)(t4);
    let t5;
    if ($[2] !== cols || $[3] !== palette) {
        t5 = (0, $0f8c33f1c98627f4$export$d97d52770ca27b6f)(palette, cols);
        $[2] = cols;
        $[3] = palette;
        $[4] = t5;
    } else t5 = $[4];
    const colorsPerRow = t5;
    let t6;
    if ($[5] !== cols || $[6] !== palette || $[7] !== selectedColor) {
        t6 = (0, $0f8c33f1c98627f4$export$c16ae5b27ec0c8f6)(palette, selectedColor, cols);
        $[5] = cols;
        $[6] = palette;
        $[7] = selectedColor;
        $[8] = t6;
    } else t6 = $[8];
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = t6;
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (row, col)=>{
            if (!paletteRef.current) return;
            const rowElement = paletteRef.current.children[row];
            if (!(rowElement instanceof HTMLElement)) return;
            const colorButtonCandidate = rowElement.children[col]?.querySelector?.("button");
            const colorButton = colorButtonCandidate instanceof HTMLButtonElement ? colorButtonCandidate : null;
            if (colorButton) {
                colorButton.focus();
                currentFocusRef.current = {
                    row: row,
                    col: col
                };
            }
        };
        $[9] = t7;
    } else t7 = $[9];
    const focusColorAt = t7;
    let t8;
    let t9;
    if ($[10] !== selectedColumnIndex || $[11] !== selectedRowIndex) {
        t8 = ()=>{
            if (selectedRowIndex >= 0 && selectedColumnIndex >= 0) currentFocusRef.current = {
                row: selectedRowIndex,
                col: selectedColumnIndex
            };
            else currentFocusRef.current = {
                row: 0,
                col: 0
            };
        };
        t9 = [
            selectedRowIndex,
            selectedColumnIndex
        ];
        $[10] = selectedColumnIndex;
        $[11] = selectedRowIndex;
        $[12] = t8;
        $[13] = t9;
    } else {
        t8 = $[12];
        t9 = $[13];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[14] !== colorsPerRow || $[15] !== onClick || $[16] !== onKeyDown) {
        t10 = (value, label, event)=>{
            const { row: row_0, col: col_0 } = currentFocusRef.current;
            const maxRow = colorsPerRow.length - 1;
            const maxCol = colorsPerRow[row_0]?.length - 1 || 0;
            bb54: switch(event.key){
                case "ArrowRight":
                    event.preventDefault();
                    if (col_0 < maxCol) focusColorAt(row_0, col_0 + 1);
                    else if (row_0 < maxRow) focusColorAt(row_0 + 1, 0);
                    else focusColorAt(0, 0);
                    break bb54;
                case "ArrowLeft":
                    event.preventDefault();
                    if (col_0 > 0) focusColorAt(row_0, col_0 - 1);
                    else if (row_0 > 0) {
                        const prevRowMaxCol_0 = colorsPerRow[row_0 - 1]?.length - 1 || 0;
                        focusColorAt(row_0 - 1, prevRowMaxCol_0);
                    } else {
                        const lastRowMaxCol_1 = colorsPerRow[maxRow]?.length - 1 || 0;
                        focusColorAt(maxRow, lastRowMaxCol_1);
                    }
                    break bb54;
                case "ArrowDown":
                    event.preventDefault();
                    if (row_0 < maxRow) {
                        const nextRowMaxCol = colorsPerRow[row_0 + 1]?.length - 1 || 0;
                        const targetCol_2 = Math.min(col_0, nextRowMaxCol);
                        focusColorAt(row_0 + 1, targetCol_2);
                    } else {
                        const firstRowMaxCol = colorsPerRow[0]?.length - 1 || 0;
                        const targetCol_3 = Math.min(col_0, firstRowMaxCol);
                        focusColorAt(0, targetCol_3);
                    }
                    break bb54;
                case "ArrowUp":
                    event.preventDefault();
                    if (row_0 > 0) {
                        const prevRowMaxCol = colorsPerRow[row_0 - 1]?.length - 1 || 0;
                        const targetCol_0 = Math.min(col_0, prevRowMaxCol);
                        focusColorAt(row_0 - 1, targetCol_0);
                    } else {
                        const lastRowMaxCol_0 = colorsPerRow[maxRow]?.length - 1 || 0;
                        const targetCol_1 = Math.min(col_0, lastRowMaxCol_0);
                        focusColorAt(maxRow, targetCol_1);
                    }
                    break bb54;
                case "Home":
                    event.preventDefault();
                    focusColorAt(row_0, 0);
                    break bb54;
                case "End":
                    event.preventDefault();
                    focusColorAt(row_0, maxCol);
                    break bb54;
                case "PageUp":
                    event.preventDefault();
                    focusColorAt(0, col_0);
                    break bb54;
                case "PageDown":
                    {
                        event.preventDefault();
                        const lastRowMaxCol = colorsPerRow[maxRow]?.length - 1 || 0;
                        const targetCol = Math.min(col_0, lastRowMaxCol);
                        focusColorAt(maxRow, targetCol);
                        break bb54;
                    }
                case "Tab":
                    if (onKeyDown) onKeyDown(value, label, event);
                    break bb54;
                case "Enter":
                case " ":
                    event.preventDefault();
                    onClick(value, label, event);
                    break bb54;
                default:
                    if (onKeyDown) onKeyDown(value, label, event);
            }
        };
        $[14] = colorsPerRow;
        $[15] = onClick;
        $[16] = onKeyDown;
        $[17] = t10;
    } else t10 = $[17];
    const handleKeyDown = t10;
    let t11;
    if ($[18] !== colorsPerRow || $[19] !== formatMessage || $[20] !== gap || $[21] !== handleKeyDown || $[22] !== hexToPaletteColor || $[23] !== onClick || $[24] !== paletteColorTooltipMessages || $[25] !== selectedColor || $[26] !== tokenTheme || $[27] !== useIconToken) {
        let t12;
        if ($[29] !== formatMessage || $[30] !== gap || $[31] !== handleKeyDown || $[32] !== hexToPaletteColor || $[33] !== onClick || $[34] !== paletteColorTooltipMessages || $[35] !== selectedColor || $[36] !== tokenTheme || $[37] !== useIconToken) {
            t12 = (row_1, rowIndex)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    space: shouldUseInlineColorGap ? gap : undefined,
                    rowSpace: shouldUseInlineColorGap ? undefined : gap,
                    role: "radiogroup",
                    children: row_1.map((t13, colIndex)=>{
                        const { value: value_0, label: label_0, border: border, message: message, decorator: decorator } = t13;
                        let tooltipMessage = message;
                        if (paletteColorTooltipMessages) {
                            if (tokenTheme === "dark") tooltipMessage = (0, $c288d033f747f201$export$2e2bcd8739ae039)(paletteColorTooltipMessages.dark, value_0.toUpperCase());
                            if (tokenTheme === "light") tooltipMessage = (0, $c288d033f747f201$export$2e2bcd8739ae039)(paletteColorTooltipMessages.light, value_0.toUpperCase());
                        }
                        const isSelectedColor = value_0 === selectedColor;
                        const isFirstColor = rowIndex === 0 && colIndex === 0;
                        const shouldBeFocusable = isSelectedColor || !selectedColor && isFirstColor;
                        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fb121074a77d574d$export$892596cec99bc70e), {
                            value: value_0,
                            borderColor: border,
                            label: tooltipMessage ? formatMessage(tooltipMessage) : label_0,
                            onClick: onClick,
                            onKeyDown: handleKeyDown,
                            isSelected: isSelectedColor,
                            checkMarkColor: $2e44d41dc267266a$var$getCheckMarkColor(value_0, useIconToken),
                            hexToPaletteColor: hexToPaletteColor,
                            decorator: decorator,
                            tabIndex: shouldBeFocusable ? 0 : -1
                        }, value_0);
                    })
                }, `row-first-color-${row_1[0].value}`);
            $[29] = formatMessage;
            $[30] = gap;
            $[31] = handleKeyDown;
            $[32] = hexToPaletteColor;
            $[33] = onClick;
            $[34] = paletteColorTooltipMessages;
            $[35] = selectedColor;
            $[36] = tokenTheme;
            $[37] = useIconToken;
            $[38] = t12;
        } else t12 = $[38];
        t11 = colorsPerRow.map(t12);
        $[18] = colorsPerRow;
        $[19] = formatMessage;
        $[20] = gap;
        $[21] = handleKeyDown;
        $[22] = hexToPaletteColor;
        $[23] = onClick;
        $[24] = paletteColorTooltipMessages;
        $[25] = selectedColor;
        $[26] = tokenTheme;
        $[27] = useIconToken;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[39] !== gap || $[40] !== t11) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3pCca.Grid), {
            gap: gap,
            ref: paletteRef,
            role: "group",
            children: t11
        });
        $[39] = gap;
        $[40] = t11;
        $[41] = t12;
    } else t12 = $[41];
    return t12;
} : ({ cols: cols = (0, $0f8c33f1c98627f4$export$dc37d14f75a32acb), gap: gap = 'space.050', onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, paletteOptions: paletteOptions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $IQ4Dz.default)();
    const useIconToken = !!hexToPaletteColor;
    const shouldUseInlineColorGap = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1');
    // Refs for keyboard navigation
    const paletteRef = (0, $cozmU.useRef)(null);
    const currentFocusRef = (0, $cozmU.useRef)({
        row: 0,
        col: 0
    });
    const colorsPerRow = (0, $cozmU.useMemo)(()=>{
        return (0, $0f8c33f1c98627f4$export$d97d52770ca27b6f)(palette, cols);
    }, [
        palette,
        cols
    ]);
    // Get initial focus position based on selected color
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $cozmU.useMemo)(()=>{
        return (0, $0f8c33f1c98627f4$export$c16ae5b27ec0c8f6)(palette, selectedColor, cols);
    }, [
        palette,
        selectedColor,
        cols
    ]);
    // Focus management utility
    const focusColorAt = (0, $cozmU.useCallback)((row, col)=>{
        if (!paletteRef.current) return;
        const rowElement = paletteRef.current.children[row];
        if (!(rowElement instanceof HTMLElement)) return;
        const colorButtonCandidate = rowElement.children[col]?.querySelector?.('button');
        const colorButton = colorButtonCandidate instanceof HTMLButtonElement ? colorButtonCandidate : null;
        if (colorButton) {
            colorButton.focus();
            currentFocusRef.current = {
                row: row,
                col: col
            };
        }
    }, []);
    // Initialize focus position and handle autofocus
    (0, $cozmU.useEffect)(()=>{
        if (selectedRowIndex >= 0 && selectedColumnIndex >= 0) currentFocusRef.current = {
            row: selectedRowIndex,
            col: selectedColumnIndex
        };
        else currentFocusRef.current = {
            row: 0,
            col: 0
        };
    }, [
        selectedRowIndex,
        selectedColumnIndex
    ]);
    // Keyboard navigation handler
    const handleKeyDown = (0, $cozmU.useCallback)((value, label, event)=>{
        const { row: row_0, col: col_0 } = currentFocusRef.current;
        const maxRow = colorsPerRow.length - 1;
        const maxCol = colorsPerRow[row_0]?.length - 1 || 0;
        switch(event.key){
            case 'ArrowRight':
                event.preventDefault();
                if (col_0 < maxCol) focusColorAt(row_0, col_0 + 1);
                else if (row_0 < maxRow) // Move to first color of next row
                focusColorAt(row_0 + 1, 0);
                else // Wrap to first color of first row
                focusColorAt(0, 0);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                if (col_0 > 0) focusColorAt(row_0, col_0 - 1);
                else if (row_0 > 0) {
                    // Move to last color of previous row
                    const prevRowMaxCol_0 = colorsPerRow[row_0 - 1]?.length - 1 || 0;
                    focusColorAt(row_0 - 1, prevRowMaxCol_0);
                } else {
                    // Wrap to last color of last row
                    const lastRowMaxCol_1 = colorsPerRow[maxRow]?.length - 1 || 0;
                    focusColorAt(maxRow, lastRowMaxCol_1);
                }
                break;
            case 'ArrowDown':
                event.preventDefault();
                if (row_0 < maxRow) {
                    // Move to same column in next row, or last available column
                    const nextRowMaxCol = colorsPerRow[row_0 + 1]?.length - 1 || 0;
                    const targetCol_2 = Math.min(col_0, nextRowMaxCol);
                    focusColorAt(row_0 + 1, targetCol_2);
                } else {
                    // Wrap to same column in first row
                    const firstRowMaxCol = colorsPerRow[0]?.length - 1 || 0;
                    const targetCol_3 = Math.min(col_0, firstRowMaxCol);
                    focusColorAt(0, targetCol_3);
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (row_0 > 0) {
                    // Move to same column in previous row, or last available column
                    const prevRowMaxCol = colorsPerRow[row_0 - 1]?.length - 1 || 0;
                    const targetCol_0 = Math.min(col_0, prevRowMaxCol);
                    focusColorAt(row_0 - 1, targetCol_0);
                } else {
                    // Wrap to same column in last row
                    const lastRowMaxCol_0 = colorsPerRow[maxRow]?.length - 1 || 0;
                    const targetCol_1 = Math.min(col_0, lastRowMaxCol_0);
                    focusColorAt(maxRow, targetCol_1);
                }
                break;
            case 'Home':
                event.preventDefault();
                focusColorAt(row_0, 0);
                break;
            case 'End':
                event.preventDefault();
                focusColorAt(row_0, maxCol);
                break;
            case 'PageUp':
                event.preventDefault();
                focusColorAt(0, col_0);
                break;
            case 'PageDown':
                {
                    event.preventDefault();
                    const lastRowMaxCol = colorsPerRow[maxRow]?.length - 1 || 0;
                    const targetCol = Math.min(col_0, lastRowMaxCol);
                    focusColorAt(maxRow, targetCol);
                    break;
                }
            case 'Tab':
                // Allow Tab to move to next focusable element (don't prevent default)
                // This will allow Tab to move between color palettes
                if (onKeyDown) onKeyDown(value, label, event);
                break;
            case 'Enter':
            case ' ':
                event.preventDefault();
                onClick(value, label, event);
                break;
            default:
                // Pass through to custom onKeyDown handler if provided
                if (onKeyDown) onKeyDown(value, label, event);
                break;
        }
    }, [
        colorsPerRow,
        focusColorAt,
        onClick,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3pCca.Grid), {
        gap: gap,
        ref: paletteRef,
        role: "group",
        children: colorsPerRow.map((row_1, rowIndex)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                space: shouldUseInlineColorGap ? gap : undefined,
                rowSpace: shouldUseInlineColorGap ? undefined : gap,
                role: "radiogroup",
                children: row_1.map(({ value: value_0, label: label_0, border: border, message: message, decorator: decorator }, colIndex)=>{
                    let tooltipMessage = message;
                    // Override with theme-specific tooltip messages if provided
                    if (paletteColorTooltipMessages) {
                        if (tokenTheme === 'dark') tooltipMessage = (0, $c288d033f747f201$export$2e2bcd8739ae039)(paletteColorTooltipMessages.dark, value_0.toUpperCase());
                        if (tokenTheme === 'light') tooltipMessage = (0, $c288d033f747f201$export$2e2bcd8739ae039)(paletteColorTooltipMessages.light, value_0.toUpperCase());
                    }
                    // Determine if this color should be focusable
                    const isSelectedColor = value_0 === selectedColor;
                    const isFirstColor = rowIndex === 0 && colIndex === 0;
                    // Only the selected color or first color should be focusable via Tab
                    // This allows Tab to move between color palettes
                    const shouldBeFocusable = isSelectedColor || !selectedColor && isFirstColor;
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fb121074a77d574d$export$892596cec99bc70e), {
                        value: value_0,
                        borderColor: border,
                        label: tooltipMessage ? formatMessage(tooltipMessage) : label_0,
                        onClick: onClick,
                        onKeyDown: handleKeyDown,
                        isSelected: isSelectedColor,
                        checkMarkColor: $2e44d41dc267266a$var$getCheckMarkColor(value_0, useIconToken),
                        hexToPaletteColor: hexToPaletteColor,
                        decorator: decorator,
                        tabIndex: shouldBeFocusable ? 0 : -1
                    }, value_0);
                })
            }, `row-first-color-${row_1[0].value}`))
    });
};
var $2e44d41dc267266a$export$2e2bcd8739ae039 = $2e44d41dc267266a$var$ColorPalette;
module.exports["default"] = $2e44d41dc267266a$export$2e2bcd8739ae039;

});

parcelRegister("5aXzT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $0998f7da930f49ce$var$separatorStyles = null;
const $0998f7da930f49ce$export$291e1a31e8ec7868 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ToolbarSeparator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": "editor-toolbar-seperator",
            className: (0, $hekY6.default)([
                "_3iDTPbvbI6 _39xV02HZdu _0jFU0VoWWg _313842Pgdg _1DCdHiPgdg _2XsHFM2ADO _0adFHs2ADO _20VacPYbGa _0KLXruKcZT"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function ToolbarSeparator() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": "editor-toolbar-seperator",
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _39xV02HZdu _0jFU0VoWWg _313842Pgdg _1DCdHiPgdg _2XsHFM2ADO _0adFHs2ADO _20VacPYbGa _0KLXruKcZT"
        ])
    });
};
module.exports["ToolbarSeparator"] = $0998f7da930f49ce$export$291e1a31e8ec7868;

});

parcelRegister("5HQgD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $eWXt3 = parcelRequire("eWXt3");


var $3k5Tv = parcelRequire("3k5Tv");


var $794I6 = parcelRequire("794I6");


var $6OREF = parcelRequire("6OREF");


var $4Qu9h = parcelRequire("4Qu9h");


var $et3Y5 = parcelRequire("et3Y5");


var $jaFVy = parcelRequire("jaFVy");


var $iDrrr = parcelRequire("iDrrr");


var $fqVYq = parcelRequire("fqVYq");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $brnfH = parcelRequire("brnfH");

var $iil4f = parcelRequire("iil4f");

var $6NW7h = parcelRequire("6NW7h");

var $bYHr8 = parcelRequire("bYHr8");


var $kpCD8 = parcelRequire("kpCD8");


var $3nacY = parcelRequire("3nacY");


var $kCECX = parcelRequire("kCECX");

const $e3b8344075fdf5ce$export$812255e19597c431 = {
    TABLE: '.tableView-content-wrap',
    LAYOUT: '.layoutSectionView-content-wrap',
    LAYOUT_COLUMN: '.layoutColumnView-content-wrap',
    TASK_LIST: '[data-node-type="actionList"]',
    TASK_ITEM: '.taskItemView-content-wrap'
};
const $e3b8344075fdf5ce$var$COMBINED_NODE_INSERT_SELECTOR = [
    $e3b8344075fdf5ce$export$812255e19597c431.TABLE,
    $e3b8344075fdf5ce$export$812255e19597c431.LAYOUT,
    $e3b8344075fdf5ce$export$812255e19597c431.LAYOUT_COLUMN,
    $e3b8344075fdf5ce$export$812255e19597c431.TASK_LIST,
    $e3b8344075fdf5ce$export$812255e19597c431.TASK_ITEM
].join(', ');
const $e3b8344075fdf5ce$export$34c38be5e72a33bf = (target, testId)=>{
    const button = target.closest(`button[data-testid="${testId}"]`);
    if (!button) return false;
    return !button.disabled && button.getAttribute('aria-disabled') !== 'true';
};
/**
 * Checks whether a DOM node matches any known node insert marker,
 * either directly or via a nested element (e.g. breakout mark wrapper).
 */ const $e3b8344075fdf5ce$var$matchesNodeInsertMarker = (node)=>{
    if (!(node instanceof HTMLElement)) return false;
    return node.matches($e3b8344075fdf5ce$var$COMBINED_NODE_INSERT_SELECTOR) || !!node.querySelector($e3b8344075fdf5ce$var$COMBINED_NODE_INSERT_SELECTOR);
};
const $e3b8344075fdf5ce$export$b8034202af77aa76 = ({ mutations: mutations })=>{
    let hasAddedElement = false;
    for (const mutation of mutations){
        if (mutation.type !== 'childList') continue;
        for (const node of mutation.addedNodes){
            if ($e3b8344075fdf5ce$var$matchesNodeInsertMarker(node)) return {
                status: 'success'
            };
            if (node instanceof HTMLElement) hasAddedElement = true;
        }
    }
    if (hasAddedElement) return {
        status: 'success'
    };
    return undefined;
};


const $703f972a035f1160$var$pluginKey = new (0, $kCECX.PluginKey)('toolbarActionExperiences');
const $703f972a035f1160$var$TIMEOUT_DURATION = 1000;
const $703f972a035f1160$var$PRIMARY_TOOLBAR = 'primaryToolbar';
const $703f972a035f1160$var$ABORT_REASON = {
    USER_CANCELED: 'userCanceled',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $703f972a035f1160$export$452d41e37eef397d = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let editorView;
    let lastClickedToolbarButton;
    const getEditorDom = ()=>{
        if (editorView?.dom instanceof HTMLElement) return editorView.dom;
        return null;
    };
    const getInlinePopupTarget = ()=>{
        if (!lastClickedToolbarButton) return undefined;
        return lastClickedToolbarButton.closest('[data-toolbar-component="button-group"]') ?? lastClickedToolbarButton;
    };
    const observeConfigs = ()=>{
        const narrowTarget = (0, $bYHr8.getSelectionAncestorDOM)(editorView);
        const editorDom = getEditorDom();
        return [
            ...narrowTarget ? [
                {
                    target: narrowTarget,
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ] : [],
            ...editorDom ? [
                {
                    target: editorDom,
                    options: {
                        childList: true
                    }
                }
            ] : []
        ];
    };
    const createNodeInsertExperience = (action)=>new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
            action: action,
            actionSubjectId: $703f972a035f1160$var$PRIMARY_TOOLBAR,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            checks: [
                new (0, $6NW7h.ExperienceCheckTimeout)({
                    durationMs: $703f972a035f1160$var$TIMEOUT_DURATION
                }),
                new (0, $brnfH.ExperienceCheckDomMutation)({
                    onDomMutation: (0, $e3b8344075fdf5ce$export$b8034202af77aa76),
                    observeConfig: observeConfigs
                })
            ]
        });
    const buildPopupMutationConfig = (popupSelector, type)=>{
        switch(type){
            case 'inline':
                return {
                    type: type,
                    nestedElementQuery: popupSelector,
                    getTarget: getInlinePopupTarget,
                    subtree: true
                };
            case 'editorRoot':
                return {
                    type: type,
                    nestedElementQuery: popupSelector,
                    getEditorDom: getEditorDom
                };
        }
    };
    const createPopupExperience = (action, popupSelector, type)=>new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).TOOLBAR_ACTION, {
            action: action,
            actionSubjectId: $703f972a035f1160$var$PRIMARY_TOOLBAR,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            checks: [
                new (0, $6NW7h.ExperienceCheckTimeout)({
                    durationMs: $703f972a035f1160$var$TIMEOUT_DURATION
                }),
                new (0, $iil4f.ExperienceCheckPopupMutation)(buildPopupMutationConfig(popupSelector, type))
            ]
        });
    const experienceButtonMappings = [
        {
            experience: createPopupExperience('insert', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).INSERT
        },
        {
            experience: createPopupExperience('emoji', '[data-emoji-picker-container], [data-emoji-picker-container="true"], [data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).EMOJI
        },
        {
            experience: createPopupExperience('media', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).MEDIA
        },
        {
            experience: createPopupExperience('mention', '[data-testid="popup-wrapper"], [data-type-ahead="typeaheadDecoration"]', 'editorRoot'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).MENTION
        },
        {
            experience: createNodeInsertExperience('table'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).TABLE
        },
        {
            experience: createPopupExperience('tableSelector', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).TABLE_SELECTOR
        },
        {
            experience: createNodeInsertExperience('layout'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).LAYOUT
        },
        {
            experience: createPopupExperience('image', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).IMAGE
        },
        {
            experience: createNodeInsertExperience('action'),
            buttonTestId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).TASK_LIST
        }
    ];
    const handleToolbarButtonClick = (target)=>{
        for (const { experience: experience, buttonTestId: buttonTestId } of experienceButtonMappings)if ((0, $e3b8344075fdf5ce$export$34c38be5e72a33bf)(target, buttonTestId)) {
            // Store the clicked button so inline popup checks can find its button-group
            lastClickedToolbarButton = target;
            experience.start({
                forceRestart: true
            });
            return;
        }
    };
    const abortAllExperiences = (reason)=>{
        for (const { experience: experience } of experienceButtonMappings)experience.abort({
            reason: reason
        });
    };
    const doc = (0, $1hQ0e.getDocument)();
    if (!doc) return new (0, $kpCD8.SafePlugin)({
        key: $703f972a035f1160$var$pluginKey
    });
    const unbindClickListener = (0, $cbY7C.bind)(doc, {
        type: 'click',
        listener: (event)=>{
            const target = event.target;
            if (target instanceof HTMLElement) handleToolbarButtonClick(target);
        },
        options: {
            capture: true
        }
    });
    const unbindKeydownListener = (0, $cbY7C.bind)(doc, {
        type: 'keydown',
        listener: (event)=>{
            if (event.key === 'Escape') abortAllExperiences($703f972a035f1160$var$ABORT_REASON.USER_CANCELED);
        },
        options: {
            capture: true
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $703f972a035f1160$var$pluginKey,
        view: (view)=>{
            editorView = view;
            return {
                destroy: ()=>{
                    abortAllExperiences($703f972a035f1160$var$ABORT_REASON.EDITOR_DESTROYED);
                    editorView = undefined;
                    unbindClickListener();
                    unbindKeydownListener();
                }
            };
        }
    });
};








const $a0e6dc97e12274ad$export$fef912314604ae84 = new (0, $kCECX.PluginKey)('toggleInsertBlockPmKey');
const $a0e6dc97e12274ad$export$6f80226cf0aae60e = ()=>new (0, $kpCD8.SafePlugin)({
        key: $a0e6dc97e12274ad$export$fef912314604ae84,
        state: {
            init () {
                return {
                    showElementBrowser: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($a0e6dc97e12274ad$export$fef912314604ae84);
                if (!meta) return pluginState;
                return {
                    showElementBrowser: !pluginState.showElementBrowser
                };
            }
        }
    });





parcelRequire("cozmU");




var $hVLmg = parcelRequire("hVLmg");


var $7T88d = parcelRequire("7T88d");

var $5AKbu = parcelRequire("5AKbu");




parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");





var $ldqjS = parcelRequire("ldqjS");


var $5HBT9 = parcelRequire("5HBT9");


var $bFSJa = parcelRequire("bFSJa");


var $6YkHb = parcelRequire("6YkHb");

var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");

const $96d2d24891178cc9$export$f18e402f09bee3a1 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    if (!api?.codeBlock) return null;
    const onClick = ()=>{
        if (editorView) api?.codeBlock?.actions.insertCodeBlock((0, $krYZG.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $5HBT9.messages).codeblock),
            keymap: (0, $ldqjS.toggleCodeBlock)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
                label: formatMessage((0, $5HBT9.messages).codeblock),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleCodeBlock))
        })
    });
};


const $f010c9b9daef5da3$export$ab4e2221b4885da5 = (options)=>{
    // Handle backward compatibility: toolbarShowPlusInsertOnly
    if (options.toolbarShowPlusInsertOnly) return {
        codeBlock: {
            enabled: false
        },
        emoji: {
            enabled: false
        },
        insert: {
            enabled: true
        },
        layout: {
            enabled: false
        },
        media: {
            enabled: false
        },
        mention: {
            enabled: false
        },
        table: {
            enabled: false
        },
        taskList: {
            enabled: false
        }
    };
    if (!options.toolbarButtons) // disable code block by default if there's no toolbarButtons options provided, e.g on full page editor
    return {
        codeBlock: {
            enabled: false
        },
        emoji: {
            enabled: true
        },
        insert: {
            enabled: true
        },
        layout: {
            enabled: true
        },
        media: {
            enabled: true
        },
        mention: {
            enabled: true
        },
        table: {
            enabled: true
        },
        taskList: {
            enabled: true
        }
    };
    const defaults = {
        enabled: false,
        showAt: 'lg'
    };
    const resolveGroupConfig = (groupConfig)=>{
        return {
            enabled: groupConfig?.enabled ?? defaults.enabled,
            showAt: groupConfig?.showAt ?? defaults.showAt
        };
    };
    return {
        codeBlock: resolveGroupConfig(options.toolbarButtons?.codeBlock),
        emoji: resolveGroupConfig(options.toolbarButtons?.emoji),
        insert: resolveGroupConfig(options.toolbarButtons?.insert),
        layout: resolveGroupConfig(options.toolbarButtons?.layout),
        media: resolveGroupConfig(options.toolbarButtons?.media),
        mention: resolveGroupConfig(options.toolbarButtons?.mention),
        table: resolveGroupConfig(options.toolbarButtons?.table),
        taskList: resolveGroupConfig(options.toolbarButtons?.taskList)
    };
};


















var $gx3UZ = parcelRequire("gx3UZ");





var $6m2p9 = parcelRequire("6m2p9");





var $b2jdX = parcelRequire("b2jdX");


var $ieeJu = parcelRequire("ieeJu");










/**
 * Checks if an element is detached (i.e. not in the current document)
 */ const $e7ab914e34ac6655$export$2670f72994f3eb72 = (el)=>!document.body.contains(el);


const $c1b3dfccbb4debfa$export$7db65f41c8758d11 = (config = {})=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    const toggle = (0, $cozmU.useCallback)((inputMethod)=>{
        const newState = !isOpen;
        setIsOpen(newState);
        if (newState) config.onOpen?.(inputMethod);
        else config.onClose?.();
        config.analytics?.onToggle?.(newState, inputMethod);
    }, [
        isOpen,
        config
    ]);
    const close = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        config.onClose?.();
        config.analytics?.onToggle?.(false);
    }, [
        config
    ]);
    const handleEscapeKeydown = (0, $cozmU.useCallback)(()=>{
        close();
        config.focusTarget?.current?.focus();
    }, [
        close,
        config.focusTarget
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((e)=>{
        if (e.target instanceof HTMLElement && !(0, $e7ab914e34ac6655$export$2670f72994f3eb72)(e.target)) close();
    }, [
        close
    ]);
    const handleKeyboardOpen = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            setIsOpenedByKeyboard(true);
            event.preventDefault();
        }
    }, []);
    return {
        isOpen: isOpen,
        isOpenedByKeyboard: isOpenedByKeyboard,
        toggle: toggle,
        close: close,
        handleEscapeKeydown: handleEscapeKeydown,
        handleClickOutside: handleClickOutside,
        handleKeyboardOpen: handleKeyboardOpen
    };
};


const $129ea30217978cab$export$906c13b7666cd621 = ({ api: api, buttonRef: buttonRef })=>{
    const popupManager = (0, $c1b3dfccbb4debfa$export$7db65f41c8758d11)({
        focusTarget: buttonRef,
        analytics: {
            onToggle: (isOpen)=>{
                if (isOpen) api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).OPENED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI,
                    attributes: {
                        inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
            }
        }
    });
    const handleSelectedEmoji = (0, $cozmU.useCallback)((emojiId)=>{
        api?.core.actions.focus();
        api?.core.actions.execute(api?.emoji?.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
        popupManager.close();
        return true;
    }, [
        api,
        popupManager
    ]);
    const onPopupUnmount = (0, $cozmU.useCallback)(()=>{
        requestAnimationFrame(()=>api?.core.actions.focus());
    }, [
        api
    ]);
    return {
        ...popupManager,
        handleSelectedEmoji: handleSelectedEmoji,
        onPopupUnmount: onPopupUnmount
    };
};









var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $7Y8M5 = parcelRequire("7Y8M5");


var $af2XZ = parcelRequire("af2XZ");

const $321ae9f3a5d97911$var$EmojiPicker = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $uyXFl.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $af2XZ.default), {
        onPickerRef: setOutsideClickTargetRef,
        emojiProvider: props.emojiProvider,
        onSelection: props.onSelection
    });
};
const $321ae9f3a5d97911$var$EmojiPickerWithListeners = (0, $9Muxb.default)($321ae9f3a5d97911$var$EmojiPicker);
const $321ae9f3a5d97911$export$84d7903b9ff4f263 = ({ isOpen: isOpen, targetRef: targetRef, emojiProvider: emojiProvider, onSelection: onSelection, onClickOutside: onClickOutside, onEscapeKeydown: onEscapeKeydown, onUnmount: onUnmount, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    if (!isOpen || !targetRef.current || !emojiProvider) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
        target: targetRef.current,
        fitHeight: 350,
        fitWidth: 350,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            3
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onUnmount: onUnmount,
        focusTrap: true,
        zIndex: (0, $7Y8M5.akEditorMenuZIndex),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($321ae9f3a5d97911$var$EmojiPickerWithListeners, {
            emojiProvider: emojiProvider,
            onSelection: onSelection,
            handleClickOutside: onClickOutside,
            handleEscapeKeydown: onEscapeKeydown
        })
    });
};


const $db90488ce2284831$export$e6ce3311a4d41b7f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const emojiButtonRef = (0, $cozmU.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $b2jdX.useToolbarUI)();
    const { emojiProviderSelector: emojiProviderSelector, emojiProviderPromise: emojiProviderPromise, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'emoji',
        'typeAhead'
    ], (states)=>({
            emojiProviderSelector: states.emojiState?.emojiProvider,
            emojiProviderPromise: states.emojiState?.emojiProviderPromise,
            isTypeAheadAllowed: states.typeAheadState?.isAllowed
        }));
    const emojiPickerPopup = (0, $129ea30217978cab$export$906c13b7666cd621)({
        api: api,
        buttonRef: emojiButtonRef
    });
    if (!api?.emoji) return null;
    const getEmojiProvider = ()=>{
        if (emojiProviderSelector) return Promise.resolve(emojiProviderSelector);
    };
    const emojiProvider = (0, $ieeJu.expValEquals)('platform_editor_prevent_toolbar_layout_shifts', 'isEnabled', true) ? emojiProviderPromise : getEmojiProvider();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $321ae9f3a5d97911$export$84d7903b9ff4f263), {
                isOpen: emojiPickerPopup.isOpen,
                targetRef: emojiButtonRef,
                emojiProvider: emojiProvider,
                onSelection: emojiPickerPopup.handleSelectedEmoji,
                onClickOutside: emojiPickerPopup.handleClickOutside,
                onEscapeKeydown: emojiPickerPopup.handleEscapeKeydown,
                onUnmount: emojiPickerPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji),
                    keymap: (0, $ldqjS.insertEmoji)
                }),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
                        label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji),
                        size: "small"
                    }),
                    ariaKeyshortcuts: "Shift+;",
                    ref: emojiButtonRef,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: ()=>emojiPickerPopup.toggle(),
                    isSelected: emojiPickerPopup.isOpen,
                    isDisabled: !isTypeAheadAllowed || !emojiProvider,
                    testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).EMOJI
                })
            })
        ]
    });
};





parcelRequire("cozmU");



















var $6NvYG = parcelRequire("6NvYG");





const $0d749dd854ed2643$export$7554951b29a2b076 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { connectivityMode: connectivityMode, imageUploadEnabled: imageUploadEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'imageUpload'
    ], (states)=>({
            connectivityMode: states.connectivityState?.mode,
            imageUploadEnabled: states.imageUploadState?.enabled
        }));
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const isOffline = (0, $jaFVy.isOfflineMode)(connectivityMode);
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            api?.imageUpload?.actions.startUpload()(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).image),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))), {
                label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).image),
                size: "small"
            }),
            onClick: onClick,
            isDisabled: !imageUploadEnabled || isOffline,
            testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).IMAGE
        })
    });
};



































var $gFEZF = parcelRequire("gFEZF");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $lfswV = parcelRequire("lfswV");





var $h78iU = parcelRequire("h78iU");







var $jGK9e = parcelRequire("jGK9e");

var $lPJNC = parcelRequire("lPJNC");










var $mW7G5 = parcelRequire("mW7G5");

function $3f9eb1a1d7b97352$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3f9eb1a1d7b97352$export$611c894df53833b0 = 560;
const $3f9eb1a1d7b97352$export$bc386af06edc2d75 = (featuredItems, formatMessage)=>{
    if ([
        'new-description',
        'orig-description'
    ].includes((0, $mW7G5.expVal)('cc_fd_db_top_editor_toolbar', 'cohort', 'control')) || (0, $mW7G5.expValNoExposure)('cc_fd_wb_jira_quick_insert_experiment', 'isEnabled', false)) // Sort by priority (lower first) on the concatenated list so items
    // with "priority" are at the top (e.g. Whiteboard before Database)
    return featuredItems.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    // NOTE: this is *not* the ideal way to approach this. Old logic sort whiteboards to top
    const DIAGRAM_KEY = 'whiteboard-extension:create-diagram';
    const isDiagram = (item)=>item.key === DIAGRAM_KEY;
    const featuredWhiteboardsPresent = featuredItems.some(isDiagram);
    if (featuredWhiteboardsPresent) {
        const pin = (key)=>{
            const idx = featuredItems.findIndex((item)=>item.key === key);
            const filtered = featuredItems.filter((item)=>!isDiagram(item));
            if (idx === -1) return filtered;
            const picked = {
                ...featuredItems[idx],
                description: formatMessage((0, $lPJNC.messages).featuredWhiteboardDescription)
            };
            return [
                picked,
                ...filtered
            ];
        };
        return pin(DIAGRAM_KEY);
    }
    return featuredItems;
};
const $3f9eb1a1d7b97352$var$selector = (states)=>{
    return {
        connectivityMode: states.connectivityState?.mode
    };
};
const $3f9eb1a1d7b97352$var$InsertMenu = ({ editorView: editorView, dropdownItems: dropdownItems, showElementBrowserLink: showElementBrowserLink, onInsert: onInsert, toggleVisiblity: toggleVisiblity, pluginInjectionApi: pluginInjectionApi })=>{
    const [itemCount, setItemCount] = (0, $cozmU.useState)(0);
    const [height, setHeight] = (0, $cozmU.useState)($3f9eb1a1d7b97352$export$611c894df53833b0);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const cache = (0, $cozmU.useMemo)(()=>{
        return new (0, $lfswV.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: (0, $h78iU.ELEMENT_ITEM_HEIGHT),
            minHeight: (0, $h78iU.ELEMENT_ITEM_HEIGHT)
        });
    }, []);
    (0, $cozmU.useLayoutEffect)(()=>{
        // Figure based on visuals to exclude the searchbar, padding/margin, and the ViewMore item.
        const EXTRA_SPACE_EXCLUDING_ELEMENTLIST = 128;
        const totalItemHeight = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        [
            ...Array(itemCount)
        ].reduce((sum, _, index)=>sum + cache.rowHeight({
                index: index
            }), 0) + EXTRA_SPACE_EXCLUDING_ELEMENTLIST;
        if (itemCount > 0 && totalItemHeight < $3f9eb1a1d7b97352$export$611c894df53833b0) setHeight(totalItemHeight);
        else setHeight($3f9eb1a1d7b97352$export$611c894df53833b0);
    }, [
        cache,
        itemCount
    ]);
    const transform = (0, $cozmU.useCallback)((item)=>({
            title: item.content,
            description: item.tooltipDescription,
            keyshortcut: item.shortcut,
            icon: ()=>$3f9eb1a1d7b97352$var$getSvgIconForItem({
                    name: item.value.name
                }) || item.elemBefore,
            /**
     * @note This transformed items action is only used when a quick insert item has been
     * called from the quick insert menu and a search has not been performed.
     */ action: ()=>onInsert({
                    item: item
                }),
            // "insertInsertMenuItem" expects these 2 properties.
            onClick: item.onClick,
            value: item.value
        }), [
        onInsert
    ]);
    const quickInsertDropdownItems = dropdownItems.map(transform);
    const onInsertItem = (0, $cozmU.useCallback)((item)=>{
        toggleVisiblity();
        if (!editorView.hasFocus()) editorView.focus();
        pluginInjectionApi?.quickInsert?.actions.insertItem(item, (0, $krYZG.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        toggleVisiblity,
        pluginInjectionApi
    ]);
    const { connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'connectivity'
    ], $3f9eb1a1d7b97352$var$selector);
    const getItems = (0, $cozmU.useCallback)((query, category)=>{
        let result;
        /**
     * @warning The results if there is a query are not the same as the results if there is no query.
     * For example: If you have a typed panel and then select the panel item then it will call a different action
     * than is specified on the editor plugins quick insert
     * @see above transform function for more details.
     */ if (query) result = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
            query: query,
            category: category
        })?.map((item)=>(0, $jaFVy.isOfflineMode)(connectivityMode) && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item) ?? [];
        else {
            const featuredQuickInsertSuggestions = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
                category: category,
                featuredItems: true
            })?.map((item)=>(0, $jaFVy.isOfflineMode)(connectivityMode) && item.isDisabledOffline ? {
                    ...item,
                    isDisabled: true
                } : item) ?? [];
            const unfilteredResult = quickInsertDropdownItems.concat(featuredQuickInsertSuggestions);
            // need to sort on the concatenated list so desired elements are at the top
            result = $3f9eb1a1d7b97352$export$bc386af06edc2d75(unfilteredResult, formatMessage);
        }
        setItemCount(result.length);
        return result;
    }, [
        pluginInjectionApi?.quickInsert?.actions,
        quickInsertDropdownItems,
        connectivityMode,
        formatMessage
    ]);
    const emptyStateHandler = pluginInjectionApi?.quickInsert?.sharedState.currentState()?.emptyStateHandler;
    const onViewMore = (0, $cozmU.useCallback)(()=>{
        toggleVisiblity();
        pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.quickInsert?.commands.openElementBrowserModal);
    }, [
        pluginInjectionApi,
        toggleVisiblity
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $3f9eb1a1d7b97352$var$insertMenuWrapper(height)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($3f9eb1a1d7b97352$var$ElementBrowserWrapper, {
        handleClickOutside: toggleVisiblity,
        handleEscapeKeydown: toggleVisiblity,
        closeOnTab: false
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $eWXt3.default), {
        mode: "inline",
        getItems: getItems,
        emptyStateHandler: emptyStateHandler,
        onInsertItem: onInsertItem,
        showSearch: true,
        showCategories: false,
        // On page resize we want the InlineElementBrowser to show updated tools/overflow items
        key: quickInsertDropdownItems.length,
        onViewMore: showElementBrowserLink ? onViewMore : undefined,
        cache: cache
    }))));
};
const $3f9eb1a1d7b97352$var$getSvgIconForItem = ({ name: name })=>{
    const Icon = {
        codeblock: (0, $jGK9e.IconCode),
        panel: (0, $jGK9e.IconPanel),
        blockquote: (0, $jGK9e.IconQuote),
        decision: (0, $jGK9e.IconDecision),
        horizontalrule: (0, $jGK9e.IconDivider),
        expand: (0, $jGK9e.IconExpand),
        date: (0, $jGK9e.IconDate),
        status: (0, $jGK9e.IconStatus)
    }[name];
    return Icon ? /*#__PURE__*/ (0, $lOiVq.jsx)(Icon, {
        label: ""
    }) : undefined;
};
const $3f9eb1a1d7b97352$var$insertMenuWrapper = (height)=>{
    return /*#__PURE__*/ (0, $lOiVq.css)({
        display: 'flex',
        flexDirection: 'column',
        width: '320px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${height}px`,
        backgroundColor: `${"var(--ds-surface-overlay, #FFFFFF)"}`,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: `${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"}`
    });
};
const $3f9eb1a1d7b97352$var$flexWrapperStyles = {
    name: "1wlc510",
    styles: "display:flex;flex:1;box-sizing:border-box;overflow:hidden"
};
const $3f9eb1a1d7b97352$var$FlexWrapper = (props)=>{
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    const { children: children, ...divProps } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: setOutsideClickTargetRef,
        css: $3f9eb1a1d7b97352$var$flexWrapperStyles,
        ...divProps
    }, children));
};
const $3f9eb1a1d7b97352$var$ElementBrowserWrapper = (0, $9Muxb.default)($3f9eb1a1d7b97352$var$FlexWrapper);
var $3f9eb1a1d7b97352$export$2e2bcd8739ae039 = $3f9eb1a1d7b97352$var$InsertMenu;


const $ce29956ee7a2085a$var$ITEM_TO_BUTTON_MAP = {
    action: 'taskList',
    media: 'media',
    'image upload': 'media',
    mention: 'mention',
    emoji: 'emoji',
    table: 'table',
    layout: 'layout',
    codeblock: 'codeBlock'
};
const $ce29956ee7a2085a$export$7223d1a8f66d53b6 = 'link';
const $ce29956ee7a2085a$var$BREAKPOINT_ORDER = [
    'sm',
    'md',
    'lg',
    'xl'
];
/**
 * Determines if a toolbar button is visible at the current breakpoint.
 */ function $ce29956ee7a2085a$var$isButtonVisibleAtBreakpoint(buttonShowAt, currentBreakpoint) {
    if (!currentBreakpoint) return false;
    const showAtIndex = $ce29956ee7a2085a$var$BREAKPOINT_ORDER.indexOf(buttonShowAt);
    const currentIndex = $ce29956ee7a2085a$var$BREAKPOINT_ORDER.indexOf(currentBreakpoint);
    return currentIndex >= showAtIndex;
}
function $ce29956ee7a2085a$export$ebd3ed34e316bf9f(items, currentBreakpoint, toolbarConfig) {
    return items.filter((item)=>{
        const itemName = item.value.name;
        // filter out link button because it's always visible on the toolbar
        if (itemName === $ce29956ee7a2085a$export$7223d1a8f66d53b6) return false;
        const buttonKey = $ce29956ee7a2085a$var$ITEM_TO_BUTTON_MAP[itemName];
        if (!buttonKey) return true;
        const buttonConfig = toolbarConfig[buttonKey];
        if (!buttonConfig?.enabled) return true;
        const showAt = buttonConfig.showAt || 'lg';
        const isVisible = $ce29956ee7a2085a$var$isButtonVisibleAtBreakpoint(showAt, currentBreakpoint);
        return !isVisible;
    });
}


















parcelRequire("cozmU");


var $1UWNP = parcelRequire("1UWNP");


var $dOBRD = parcelRequire("dOBRD");















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");











var $lrTDq = parcelRequire("lrTDq");


var $dhtsm = parcelRequire("dhtsm");


var $aTF50 = parcelRequire("aTF50");





var $824lD = parcelRequire("824lD");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $dimUV = parcelRequire("dimUV");





var $k0CUL = parcelRequire("k0CUL");





var $eQpqk = parcelRequire("eQpqk");


var $kTb7m = parcelRequire("kTb7m");


var $hMv2K = parcelRequire("hMv2K");


var $hade9 = parcelRequire("hade9");


var $d4GYd = parcelRequire("d4GYd");


var $fodiz = parcelRequire("fodiz");


var $iAaYd = parcelRequire("iAaYd");

const $0cad2a5714c738f5$export$fa1c2bbf4100b8bc = ([aRaw], [bRaw])=>{
    const a = aRaw;
    const b = bRaw;
    return !Object.keys(a).some((key)=>{
        const k = key;
        return a[k] !== b[k];
    });
};


const $3d1523e58f3ef999$var$from = (init)=>({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        value: {
            name: init.name
        },
        elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)(init.Icon, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        elemAfter: init.shortcut ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $lrTDq.shortcutStyle)
        }, init.shortcut) : undefined,
        'aria-label': init.shortcut ? init.content + ' ' + init.shortcut : init.content,
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': init['aria-keyshortcuts'],
        shortcut: init.shortcut,
        isDisabled: init.disabled
    });
const $3d1523e58f3ef999$var$mem = (fn)=>(0, $dOBRD.default)(fn, (0, $0cad2a5714c738f5$export$fa1c2bbf4100b8bc));
const $3d1523e58f3ef999$export$31eb53bd5b582a97 = $3d1523e58f3ef999$var$mem((init)=>{
    return $3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'action',
        shortcut: '[]',
        Icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
        'aria-keyshortcuts': '[ ] Space'
    });
});
const $3d1523e58f3ef999$export$9c30223ca0a664fb = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'link',
        shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addLink)),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.addLink))
    }));
const $3d1523e58f3ef999$export$987d49ffe1b0900f = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'media',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6NvYG)))
    }));
const $3d1523e58f3ef999$export$d5dd7159835f64ad = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'image upload',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6NvYG)))
    }));
const $3d1523e58f3ef999$export$db83999c14438df4 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'mention',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))),
        shortcut: '@',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+2 Space'
    }));
const $3d1523e58f3ef999$export$a19185d1233fc4b2 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'emoji',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))),
        shortcut: ':',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+;'
    }));
const $3d1523e58f3ef999$export$9852986a3ec5f6a0 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))),
        shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.toggleTable)),
        'aria-keyshortcuts': (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleTable))
    }));
const $3d1523e58f3ef999$export$614b510decb5e0d8 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table selector',
        Icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
    }));
const $3d1523e58f3ef999$export$b3219800bda33a1f = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'layout',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eQpqk)))
    }));
const $3d1523e58f3ef999$export$c0626db977961abf = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'codeblock',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $ldqjS.getAriaKeyshortcuts)(init.shortcut)
    }));
const $3d1523e58f3ef999$export$21f42ab9b6679f44 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'panel',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $ldqjS.getAriaKeyshortcuts)(init.shortcut)
    }));
const $3d1523e58f3ef999$export$67dc04e652a298ca = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'blockquote',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': 'Shift+. Space'
    }));
const $3d1523e58f3ef999$export$29bcf506ab92b297 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'decision',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dimUV))),
        shortcut: '<>',
        'aria-keyshortcuts': 'Shift+, Shift+. Space'
    }));
const $3d1523e58f3ef999$export$f7cc6d560fcfab9b = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'horizontalrule',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9))),
        shortcut: '---',
        'aria-keyshortcuts': '- - -'
    }));
const $3d1523e58f3ef999$export$9f77e0932fb78f72 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'expand',
        Icon: (iconProps)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                label: iconProps.label,
                size: "small"
            })
    }));
const $3d1523e58f3ef999$export$324d90190a8b822a = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'date',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
        shortcut: '//',
        'aria-keyshortcuts': '/ / Enter'
    }));
const $3d1523e58f3ef999$export$c7187bbd1a7a9244 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'placeholder text',
        Icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dhtsm))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            })
    }));
const $3d1523e58f3ef999$export$471f7ae5c4103ae1 = $3d1523e58f3ef999$var$mem((init)=>$3d1523e58f3ef999$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'status',
        Icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTF50))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            })
    }));



const $df59e77976576928$var$buttonToItem = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((button)=>({
        ...button,
        title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: button.content,
            shortcutOverride: button.shortcut
        })
    }));
const $df59e77976576928$var$buttonToDropdownItem = (0, $dOBRD.default)((title)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((button)=>({
            ...button,
            title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                description: title,
                shortcutOverride: "/"
            })
        })));
const $df59e77976576928$var$createInsertBlockItems = (config)=>{
    const { isTypeAheadAllowed: isTypeAheadAllowed, tableSupported: tableSupported, tableSelectorSupported: tableSelectorSupported, mediaUploadsEnabled: mediaUploadsEnabled, mediaSupported: mediaSupported, imageUploadSupported: imageUploadSupported, imageUploadEnabled: imageUploadEnabled, mentionsSupported: mentionsSupported, mentionsDisabled: mentionsDisabled, availableWrapperBlockTypes: availableWrapperBlockTypes, actionSupported: actionSupported, decisionSupported: decisionSupported, linkSupported: linkSupported, linkDisabled: linkDisabled, emojiDisabled: emojiDisabled, emojiProvider: emojiProvider, hasEmojiPlugin: hasEmojiPlugin, hasMentionsPlugin: hasMentionsPlugin, hasMediaPlugin: hasMediaPlugin, nativeStatusSupported: nativeStatusSupported, insertMenuItems: insertMenuItems, dateEnabled: dateEnabled, placeholderTextEnabled: placeholderTextEnabled, horizontalRuleEnabled: horizontalRuleEnabled, layoutSectionEnabled: layoutSectionEnabled, expandEnabled: expandEnabled, numberOfButtons: numberOfButtons, schema: schema, formatMessage: formatMessage, isEditorOffline: isEditorOffline, itemFilter: itemFilter } = config;
    const items = [];
    const isOffline = isEditorOffline === true;
    if (actionSupported) items.push((0, $3d1523e58f3ef999$export$31eb53bd5b582a97)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).action),
        tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).actionDescription),
        disabled: false
    }));
    if (linkSupported) items.push((0, $3d1523e58f3ef999$export$9c30223ca0a664fb)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).link),
        tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).linkDescription),
        disabled: !!linkDisabled,
        'aria-haspopup': 'dialog'
    }));
    if ((0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) {
        if (imageUploadSupported) items.push((0, $3d1523e58f3ef999$export$d5dd7159835f64ad)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).image),
            disabled: !imageUploadEnabled || isOffline
        }));
        else if (hasMediaPlugin) items.push((0, $3d1523e58f3ef999$export$987d49ffe1b0900f)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).addMediaFiles),
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mediaFilesDescription),
            disabled: isOffline || !mediaSupported || !mediaUploadsEnabled
        }));
        if (hasMentionsPlugin) items.push((0, $3d1523e58f3ef999$export$db83999c14438df4)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mention),
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mentionDescription),
            disabled: !isTypeAheadAllowed || !!mentionsDisabled || !mentionsSupported,
            'aria-haspopup': 'listbox'
        }));
        if (hasEmojiPlugin) items.push((0, $3d1523e58f3ef999$export$a19185d1233fc4b2)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji),
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emojiDescription),
            disabled: emojiDisabled || !isTypeAheadAllowed || !emojiProvider,
            'aria-haspopup': 'dialog'
        }));
    } else {
        if (mediaSupported && mediaUploadsEnabled) items.push((0, $3d1523e58f3ef999$export$987d49ffe1b0900f)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).addMediaFiles),
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mediaFilesDescription),
            disabled: isOffline
        }));
        if (imageUploadSupported) items.push((0, $3d1523e58f3ef999$export$d5dd7159835f64ad)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).image),
            disabled: !imageUploadEnabled || isOffline
        }));
        if (mentionsSupported) items.push((0, $3d1523e58f3ef999$export$db83999c14438df4)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mention),
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mentionDescription),
            disabled: !isTypeAheadAllowed || !!mentionsDisabled,
            'aria-haspopup': 'listbox'
        }));
        if (emojiProvider) items.push((0, $3d1523e58f3ef999$export$a19185d1233fc4b2)({
            content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji),
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emojiDescription),
            disabled: emojiDisabled || !isTypeAheadAllowed,
            'aria-haspopup': 'dialog'
        }));
    }
    if (tableSupported) items.push((0, $3d1523e58f3ef999$export$9852986a3ec5f6a0)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).table),
        tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableDescription),
        disabled: false
    }));
    if (tableSupported && tableSelectorSupported) items.push((0, $3d1523e58f3ef999$export$614b510decb5e0d8)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableSelector),
        tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableSelectorDescription),
        disabled: false
    }));
    if (layoutSectionEnabled) {
        const labelColumns = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columns);
        items.push((0, $3d1523e58f3ef999$export$b3219800bda33a1f)({
            content: labelColumns,
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescription),
            disabled: false
        }));
    }
    const blockTypes = availableWrapperBlockTypes || [];
    const codeblockData = blockTypes.find((type)=>type.name === 'codeblock');
    const panelData = blockTypes.find((type)=>type.name === 'panel');
    const blockquoteData = blockTypes.find((type)=>type.name === 'blockquote');
    if (codeblockData) items.push((0, $3d1523e58f3ef999$export$c0626db977961abf)({
        content: formatMessage(codeblockData.title),
        tooltipDescription: formatMessage((0, $5HBT9.messages).codeblockDescription),
        disabled: false,
        shortcut: '```'
    }));
    if (panelData) items.push((0, $3d1523e58f3ef999$export$21f42ab9b6679f44)({
        content: formatMessage(panelData.title),
        tooltipDescription: formatMessage((0, $5HBT9.messages).infoPanelDescription),
        disabled: false
    }));
    if (blockquoteData) items.push((0, $3d1523e58f3ef999$export$67dc04e652a298ca)({
        content: formatMessage(blockquoteData.title),
        tooltipDescription: formatMessage((0, $5HBT9.messages).blockquoteDescription),
        disabled: false,
        shortcut: '>'
    }));
    if (decisionSupported) items.push((0, $3d1523e58f3ef999$export$29bcf506ab92b297)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).decision),
        tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).decisionDescription),
        disabled: false
    }));
    if (horizontalRuleEnabled && schema.nodes.rule) items.push((0, $3d1523e58f3ef999$export$f7cc6d560fcfab9b)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRule),
        tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRuleDescription),
        disabled: false
    }));
    if (expandEnabled && schema.nodes.expand) items.push((0, $3d1523e58f3ef999$export$9f77e0932fb78f72)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand),
        tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expandDescription),
        disabled: false
    }));
    if (dateEnabled) {
        const labelDate = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).date);
        items.push((0, $3d1523e58f3ef999$export$324d90190a8b822a)({
            content: labelDate,
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).dateDescription),
            disabled: false
        }));
    }
    if (placeholderTextEnabled) items.push((0, $3d1523e58f3ef999$export$c7187bbd1a7a9244)({
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderText),
        disabled: false
    }));
    if (nativeStatusSupported) {
        const labelStatus = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).status);
        items.push((0, $3d1523e58f3ef999$export$471f7ae5c4103ae1)({
            content: labelStatus,
            tooltipDescription: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).statusDescription),
            disabled: false
        }));
    }
    if (insertMenuItems) items.push(...insertMenuItems);
    // EDITOR-6558: apply consumer-supplied filter (e.g. Markdown Mode allowlist)
    // before computing toolbar button / dropdown splits so item counts are
    // correct downstream.
    const filteredItems = itemFilter ? items.filter(itemFilter) : items;
    let numButtonsAdjusted = numberOfButtons;
    if ((0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes')) {
        if (filteredItems.slice(0, numButtonsAdjusted).some((item)=>item.value.name === 'table selector')) numButtonsAdjusted++;
    } else numButtonsAdjusted = tableSupported && tableSelectorSupported ? numberOfButtons + 1 : numberOfButtons;
    const buttonItems = filteredItems.slice(0, numButtonsAdjusted).map($df59e77976576928$var$buttonToItem);
    const remainingItems = filteredItems.slice(numButtonsAdjusted).filter(({ value: { name: name } })=>name !== 'table selector');
    const dropdownItems = remainingItems.map($df59e77976576928$var$buttonToDropdownItem(formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).insertMenu)));
    return [
        buttonItems,
        dropdownItems
    ];
};
const $df59e77976576928$export$af56db357559c888 = (0, $dOBRD.default)($df59e77976576928$var$createInsertBlockItems, (0, $0cad2a5714c738f5$export$fa1c2bbf4100b8bc));



const $2770fd2b1c467384$export$94599bdafcdd887b = ({ api: api, breakpoint: breakpoint, editorView: editorView, horizontalRuleEnabled: horizontalRuleEnabled, insertMenuItems: insertMenuItems, itemFilter: itemFilter, nativeStatusSupported: nativeStatusSupported, numberOfButtons: numberOfButtons, tableSelectorSupported: tableSelectorSupported, expandEnabled: expandEnabled, showElementBrowserLink: showElementBrowserLink, toolbarConfig: toolbarConfig })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeAheadAllowed = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'typeAhead.isAllowed');
    const imageUploadEnabled = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'imageUpload.enabled');
    const mentionsSupported = !!(0, $4Qu9h.useSharedPluginStateSelector)(api, 'mention.mentionProvider');
    const canInsertMention = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'mention.canInsertMention');
    const dateEnabled = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'date.isInitialised');
    const placeholderTextEnabled = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'placeholderText.allowInserting');
    const mediaAllowsUploads = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'media.allowsUploads');
    const canInsertLink = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'hyperlink.canInsertLink');
    const activeLinkMark = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'hyperlink.activeLinkMark');
    const connectivityMode = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const emojiProvider = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const availableWrapperBlockTypes = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'blockType.availableWrapperBlockTypes');
    // Computed values
    const mediaUploadsEnabled = mediaAllowsUploads;
    const mediaSupported = mediaAllowsUploads !== undefined;
    const isEditorOffline = (0, $jaFVy.isOfflineMode)(connectivityMode);
    const imageUploadSupported = !!api?.imageUpload;
    const mentionsDisabled = !canInsertMention;
    const linkSupported = canInsertLink !== undefined;
    const linkDisabled = !canInsertLink || !!activeLinkMark;
    const emojiDisabled = !emojiProvider;
    const actionSupported = !!editorView?.state.schema.nodes.taskItem;
    const decisionSupported = !!editorView?.state.schema.nodes.decisionItem;
    const layoutSectionEnabled = !!api?.layout;
    const [, allDropdownItems] = editorView?.state.schema ? (0, $df59e77976576928$export$af56db357559c888)({
        isTypeAheadAllowed: isTypeAheadAllowed,
        tableSupported: !!editorView?.state.schema.nodes.table,
        tableSelectorSupported: tableSelectorSupported,
        mediaUploadsEnabled: mediaUploadsEnabled,
        mediaSupported: mediaSupported,
        isEditorOffline: isEditorOffline,
        imageUploadSupported: imageUploadSupported,
        imageUploadEnabled: imageUploadEnabled,
        mentionsSupported: mentionsSupported,
        mentionsDisabled: mentionsDisabled,
        actionSupported: actionSupported,
        decisionSupported: decisionSupported,
        linkSupported: linkSupported,
        linkDisabled: linkDisabled,
        emojiDisabled: emojiDisabled,
        hasEmojiPlugin: !!api?.emoji,
        hasMentionsPlugin: !!api?.mention,
        hasMediaPlugin: !!api?.media,
        nativeStatusSupported: nativeStatusSupported,
        dateEnabled: dateEnabled,
        placeholderTextEnabled: placeholderTextEnabled,
        horizontalRuleEnabled: horizontalRuleEnabled,
        layoutSectionEnabled: layoutSectionEnabled,
        expandEnabled: expandEnabled,
        showElementBrowserLink: showElementBrowserLink,
        emojiProvider: emojiProvider,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        insertMenuItems: insertMenuItems,
        itemFilter: itemFilter,
        schema: editorView?.state.schema,
        numberOfButtons: numberOfButtons || 0,
        formatMessage: formatMessage
    }) : [
        ,
        []
    ];
    const dropdownItems = (0, $cozmU.useMemo)(()=>{
        if (!breakpoint || !toolbarConfig) return allDropdownItems;
        return (0, $ce29956ee7a2085a$export$ebd3ed34e316bf9f)(allDropdownItems, breakpoint, toolbarConfig);
    }, [
        allDropdownItems,
        breakpoint,
        toolbarConfig
    ]);
    return {
        dropdownItems: dropdownItems,
        emojiProvider: emojiProvider,
        isTypeAheadAllowed: isTypeAheadAllowed
    };
};









const $6996af8e3d2fe24d$export$db7bd02db6cb687e = ({ api: api, buttonRef: buttonRef })=>{
    const popupManager = (0, $c1b3dfccbb4debfa$export$7db65f41c8758d11)({
        focusTarget: buttonRef
    });
    const handleSelectedTableSize = (0, $cozmU.useCallback)((rowsCount, colsCount)=>{
        // workaround to solve race condition where cursor is not placed correctly inside table
        queueMicrotask(()=>{
            api?.core?.actions.execute(api?.table?.commands.insertTableWithSize(rowsCount, colsCount, (0, $krYZG.INPUT_METHOD).PICKER));
        });
        popupManager.close();
    }, [
        api,
        popupManager
    ]);
    const onPopupUnmount = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.focus();
    }, [
        api
    ]);
    return {
        ...popupManager,
        handleSelectedTableSize: handleSelectedTableSize,
        onPopupUnmount: onPopupUnmount
    };
};



// This determines how the popup should fit. We prefer the insert menu
// opening on the bottom as we have a search bar and should only open on
// top if there is more than sufficient room.
const $45fc30027f1ce605$var$FIT_HEIGHT_BUFFER = 100;
const $45fc30027f1ce605$export$a84121b2ebfb3ce9 = ({ api: api, breakpoint: breakpoint, showElementBrowserLink: showElementBrowserLink = false, isFullPageAppearance: isFullPageAppearance = false, tableSelectorSupported: tableSelectorSupported, nativeStatusSupported: nativeStatusSupported, horizontalRuleEnabled: horizontalRuleEnabled, expandEnabled: expandEnabled, insertMenuItems: insertMenuItems, itemFilter: itemFilter, numberOfButtons: numberOfButtons, onInsertBlockType: onInsertBlockType, toolbarConfig: toolbarConfig })=>{
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const { isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $b2jdX.useToolbarUI)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [insertMenuOpen, setInsertMenuOpen] = (0, $cozmU.useState)(false);
    const insertButtonRef = (0, $cozmU.useRef)(null);
    const emojiPickerPopup = (0, $129ea30217978cab$export$906c13b7666cd621)({
        api: api,
        buttonRef: insertButtonRef
    });
    const tableSelectorPopup = (0, $6996af8e3d2fe24d$export$db7bd02db6cb687e)({
        api: api,
        buttonRef: insertButtonRef
    });
    const showMediaPicker = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'media.showMediaPicker');
    const { dropdownItems: dropdownItems, emojiProvider: emojiProvider, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $2770fd2b1c467384$export$94599bdafcdd887b)({
        api: api,
        breakpoint: breakpoint,
        editorView: editorView || undefined,
        horizontalRuleEnabled: horizontalRuleEnabled,
        insertMenuItems: insertMenuItems,
        itemFilter: itemFilter,
        nativeStatusSupported: nativeStatusSupported,
        numberOfButtons: numberOfButtons,
        tableSelectorSupported: tableSelectorSupported,
        expandEnabled: expandEnabled,
        showElementBrowserLink: showElementBrowserLink,
        toolbarConfig: toolbarConfig
    });
    if (!api?.insertBlock) return null;
    const toggleInsertMenuOpen = (newState)=>{
        setInsertMenuOpen(newState);
    };
    const onPopupUnmount = ()=>{
        requestAnimationFrame(()=>api?.core.actions.focus());
    };
    const onClick = ()=>{
        toggleInsertMenuOpen(!insertMenuOpen);
    };
    const onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
        if (!editorView) return;
        const { state: state, dispatch: dispatch } = editorView;
        // need to do this before inserting nodes so scrollIntoView works properly
        if (!editorView.hasFocus()) editorView.focus();
        switch(item.value.name){
            case 0, $ce29956ee7a2085a$export$7223d1a8f66d53b6:
                api?.core?.actions.execute(api?.hyperlink?.commands.showLinkToolbar(inputMethod));
                break;
            case 'table':
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    api?.table?.actions.insertTable?.({
                        action: (0, $krYZG.ACTION).INSERTED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK
                    })(state, dispatch);
                });
                break;
            case 'table selector':
                tableSelectorPopup.toggle(inputMethod);
                break;
            case 'image upload':
                if (api?.imageUpload?.actions.startUpload) api.imageUpload.actions.startUpload()(state, dispatch);
                break;
            case 'media':
                if (showMediaPicker) api?.mediaInsert?.commands.showMediaInsertPopup ? api?.core?.actions.execute(api?.mediaInsert?.commands.showMediaInsertPopup()) : showMediaPicker?.();
                break;
            case 'mention':
                api?.mention?.actions?.openTypeAhead(inputMethod);
                break;
            case 'emoji':
                emojiPickerPopup.toggle(inputMethod);
                break;
            case 'codeblock':
            case 'blockquote':
            case 'panel':
                onInsertBlockType?.(item.value.name)(state, dispatch);
                break;
            case 'action':
            case 'decision':
                const listType = item.value.name === 'action' ? 'taskList' : 'decisionList';
                api?.taskDecision?.actions.insertTaskDecision(listType, inputMethod)(state, dispatch);
                break;
            case 'horizontalrule':
                api?.rule?.actions.insertHorizontalRule(inputMethod)(state, dispatch);
                break;
            case 'date':
                api?.core?.actions.execute(api?.date?.commands?.insertDate({
                    inputMethod: inputMethod
                }));
                break;
            case 'placeholder text':
                api?.placeholderText?.actions.showPlaceholderFloatingToolbar(state, dispatch);
                break;
            case 'layout':
                api?.layout?.actions.insertLayoutColumns(inputMethod)(state, dispatch);
                break;
            case 'status':
                api?.core?.actions.execute(api?.status?.commands?.insertStatus(inputMethod));
                break;
            case 'expand':
                api?.expand?.actions.insertExpand(state, dispatch);
                break;
            default:
                if (item && item.onClick) item.onClick();
                break;
        }
        toggleInsertMenuOpen(false);
    };
    const onInsert = ({ item: item })=>{
        onItemActivated({
            item: item,
            inputMethod: (0, $krYZG.INPUT_METHOD).INSERT_MENU
        });
    };
    const toggleVisibility = ()=>{
        toggleInsertMenuOpen(!insertMenuOpen);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            insertMenuOpen && insertButtonRef.current && editorView && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
                target: insertButtonRef.current,
                fitHeight: (0, $3f9eb1a1d7b97352$export$611c894df53833b0) + $45fc30027f1ce605$var$FIT_HEIGHT_BUFFER,
                fitWidth: 350,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    0,
                    3
                ],
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onUnmount: onPopupUnmount,
                focusTrap: true,
                zIndex: (0, $7Y8M5.akEditorMenuZIndex),
                preventOverflow: true,
                alignX: "right",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3f9eb1a1d7b97352$export$2e2bcd8739ae039), {
                    editorView: editorView,
                    dropdownItems: dropdownItems,
                    onInsert: onInsert,
                    toggleVisiblity: toggleVisibility,
                    showElementBrowserLink: showElementBrowserLink,
                    pluginInjectionApi: api,
                    isFullPageAppearance: isFullPageAppearance
                })
            }),
            emojiProvider && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $321ae9f3a5d97911$export$84d7903b9ff4f263), {
                isOpen: emojiPickerPopup.isOpen,
                targetRef: insertButtonRef,
                emojiProvider: Promise.resolve(emojiProvider),
                onSelection: emojiPickerPopup.handleSelectedEmoji,
                onClickOutside: emojiPickerPopup.handleClickOutside,
                onEscapeKeydown: emojiPickerPopup.handleEscapeKeydown,
                onUnmount: emojiPickerPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).insertMenu),
                    keymap: (0, $ldqjS.insertElements)
                }),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                        size: "small",
                        label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).insertMenu)
                    }),
                    ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.insertElements)),
                    ref: insertButtonRef,
                    onClick: onClick,
                    isSelected: insertMenuOpen,
                    isDisabled: !isTypeAheadAllowed || isDisabled,
                    testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).INSERT
                })
            })
        ]
    });
};





parcelRequire("cozmU");






















const $625f7354988a8525$export$b5a1df4e06cdc467 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    if (!api?.layout) return null;
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            api?.layout?.actions.insertLayoutColumns((0, $krYZG.INPUT_METHOD).TOOLBAR)(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columns),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))), {
                label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columns),
                size: "small"
            }),
            onClick: onClick,
            testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).LAYOUT
        })
    });
};



































const $3852de6784618f26$export$38a6b9ce8791e252 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { popupsMountPoint: popupsMountPoint } = (0, $b2jdX.useToolbarUI)();
    const { showMediaPicker: showMediaPicker, connectivityMode: connectivityMode, allowsUploads: allowsUploads } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media',
        'connectivity'
    ], (states)=>({
            showMediaPicker: states.mediaState?.showMediaPicker,
            allowsUploads: states.mediaState?.allowsUploads,
            connectivityMode: states.connectivityState?.mode
        }));
    const mediaButtonRef = (0, $cozmU.useRef)(null);
    if (!api?.media) return null;
    const onClick = ()=>{
        if (!showMediaPicker) return;
        if (api?.mediaInsert?.commands?.showMediaInsertPopup) {
            const ref = mediaButtonRef.current;
            const resolvedMountInfo = ref?.parentElement ? {
                ref: ref,
                mountPoint: popupsMountPoint ?? ref.parentElement
            } : undefined;
            api?.core?.actions.execute(api?.mediaInsert?.commands.showMediaInsertPopup(resolvedMountInfo));
        } else showMediaPicker();
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).OPENED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    };
    const isOffline = (0, $jaFVy.isOfflineMode)(connectivityMode);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).addMediaFiles),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))), {
                label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).addMediaFiles),
                size: "small"
            }),
            onClick: onClick,
            ref: mediaButtonRef,
            isDisabled: isOffline || !allowsUploads,
            testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).MEDIA
        })
    });
};





parcelRequire("cozmU");


























const $cd56705ded1dc774$export$d16f16312388c7e = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { canInsertMention: canInsertMention, mentionProvider: mentionProvider, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'mention',
        'typeAhead'
    ], (states)=>({
            canInsertMention: states.mentionState?.canInsertMention,
            mentionProvider: states.mentionState?.mentionProvider,
            isTypeAheadAllowed: states.typeAheadState?.isAllowed
        }));
    if (!api?.mention) return null;
    const onClick = ()=>{
        api?.mention?.actions?.openTypeAhead((0, $krYZG.INPUT_METHOD).TOOLBAR);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mention),
            keymap: (0, $ldqjS.insertMention)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))), {
                label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mention),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: "Shift+2 Space",
            isDisabled: !canInsertMention || !mentionProvider || !isTypeAheadAllowed,
            testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).MENTION
        })
    });
};





parcelRequire("cozmU");

























const $bf0210effd0d17fb$export$a5d4a9df719d6bc1 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    if (!api?.table) return null;
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                api?.table?.actions.insertTable?.({
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).table),
            keymap: (0, $ldqjS.toggleTable)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))), {
                label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).table),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleTable)),
            testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).TABLE
        })
    });
};


















var $8px0e = parcelRequire("8px0e");











parcelRequire("cozmU");


var $2iq8g = parcelRequire("2iq8g");

const $af18e2c487c6a6b1$export$e82abb3e18a71b34 = ({ isOpen: isOpen, targetRef: targetRef, isOpenedByKeyboard: isOpenedByKeyboard, onSelection: onSelection, onClickOutside: onClickOutside, onEscapeKeydown: onEscapeKeydown, onUnmount: onUnmount, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    if (!isOpen || !targetRef.current) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2iq8g.default), {
        allowOutsideSelection: true,
        target: targetRef.current,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        handleClickOutside: onClickOutside,
        handleEscapeKeydown: onEscapeKeydown,
        isOpenedByKeyboard: isOpenedByKeyboard
    });
};


const $dcb5f7a2abe1b3db$export$5468cf78b7a314d6 = ({ api: api, tableSelectorSupported: tableSelectorSupported })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tableSizePickerRef = (0, $cozmU.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $b2jdX.useToolbarUI)();
    const tableSelectorPopup = (0, $6996af8e3d2fe24d$export$db7bd02db6cb687e)({
        api: api,
        buttonRef: tableSizePickerRef
    });
    if (!api?.table || !tableSelectorSupported) return null;
    const onClick = (event)=>{
        if (event.detail === 0) tableSelectorPopup.handleKeyboardOpen(event);
        tableSelectorPopup.toggle();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $af18e2c487c6a6b1$export$e82abb3e18a71b34), {
                isOpen: tableSelectorPopup.isOpen,
                targetRef: tableSizePickerRef,
                isOpenedByKeyboard: tableSelectorPopup.isOpenedByKeyboard,
                onSelection: tableSelectorPopup.handleSelectedTableSize,
                onClickOutside: tableSelectorPopup.handleClickOutside,
                onEscapeKeydown: tableSelectorPopup.handleEscapeKeydown,
                onUnmount: tableSelectorPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
                content: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableSelector),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8px0e.MoreItemsIcon), {
                        label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableSelector)
                    }),
                    onClick: onClick,
                    isSelected: tableSelectorPopup.isOpen,
                    ref: tableSizePickerRef,
                    testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).TABLE_SELECTOR
                })
            })
        ]
    });
};





parcelRequire("cozmU");

























const $645223ecec69ea53$export$be2acb2f228dcb8b = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    if (!api?.taskDecision) return null;
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            api?.taskDecision?.actions.insertTaskDecision('taskList', (0, $krYZG.INPUT_METHOD).TOOLBAR)(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).action),
            keymap: (0, $ldqjS.insertTaskList)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))), {
                label: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).action),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: "[ ] Space",
            testId: (0, $3nacY.TOOLBAR_BUTTON_TEST_ID).TASK_LIST
        })
    });
};


const $96b3a66fa4c20cdd$export$a758406ca53b86a5 = ({ api: api, options: options, onInsertBlockType: onInsertBlockType })=>{
    const config = (0, $f010c9b9daef5da3$export$ab4e2221b4885da5)(options);
    const components = [];
    // Helper function to create responsive wrapper component
    const createResponsiveComponent = (showAt)=>{
        return ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                above: showAt || 'lg',
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                    children: children
                })
            });
    };
    // TaskList Group
    if (config.taskList?.enabled) {
        components.push({
            type: (0, $3nacY.TASK_LIST_GROUP).type,
            key: (0, $3nacY.TASK_LIST_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.TASK_LIST_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.taskList?.showAt)
        });
        components.push({
            type: (0, $3nacY.TASK_LIST_BUTTON).type,
            key: (0, $3nacY.TASK_LIST_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.TASK_LIST_GROUP).type,
                    key: (0, $3nacY.TASK_LIST_GROUP).key,
                    rank: (0, $hVLmg.TASK_LIST_GROUP_RANK)[(0, $3nacY.TASK_LIST_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $645223ecec69ea53$export$be2acb2f228dcb8b), {
                    api: api
                })
        });
    }
    // Media Group
    if (config.media?.enabled) {
        components.push({
            type: (0, $3nacY.MEDIA_GROUP).type,
            key: (0, $3nacY.MEDIA_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.MEDIA_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.media?.showAt)
        });
        components.push({
            type: (0, $3nacY.MEDIA_BUTTON).type,
            key: (0, $3nacY.MEDIA_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.MEDIA_GROUP).type,
                    key: (0, $3nacY.MEDIA_GROUP).key,
                    rank: (0, $hVLmg.MEDIA_GROUP_RANK)[(0, $3nacY.MEDIA_BUTTON).key]
                }
            ],
            component: ()=>!!api?.imageUpload ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0d749dd854ed2643$export$7554951b29a2b076), {
                    api: api
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3852de6784618f26$export$38a6b9ce8791e252), {
                    api: api
                })
        });
    }
    // CodeBlock Group
    if (config.codeBlock?.enabled) {
        components.push({
            type: (0, $3nacY.CODE_BLOCK_GROUP).type,
            key: (0, $3nacY.CODE_BLOCK_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.CODE_BLOCK_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.codeBlock?.showAt)
        });
        components.push({
            type: (0, $3nacY.CODE_BLOCK_BUTTON).type,
            key: (0, $3nacY.CODE_BLOCK_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.CODE_BLOCK_GROUP).type,
                    key: (0, $3nacY.CODE_BLOCK_GROUP).key,
                    rank: (0, $hVLmg.CODE_BLOCK_GROUP_RANK)[(0, $3nacY.CODE_BLOCK_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $96d2d24891178cc9$export$f18e402f09bee3a1), {
                    api: api
                })
        });
    }
    // Mention Group
    if (config.mention?.enabled) {
        components.push({
            type: (0, $3nacY.MENTION_GROUP).type,
            key: (0, $3nacY.MENTION_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.MENTION_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.mention.showAt)
        });
        components.push({
            type: (0, $3nacY.MENTION_BUTTON).type,
            key: (0, $3nacY.MENTION_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.MENTION_GROUP).type,
                    key: (0, $3nacY.MENTION_GROUP).key,
                    rank: (0, $hVLmg.MENTION_GROUP_RANK)[(0, $3nacY.MENTION_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $cd56705ded1dc774$export$d16f16312388c7e), {
                    api: api
                })
        });
    }
    // Emoji Group
    if (config.emoji?.enabled) {
        components.push({
            type: (0, $3nacY.EMOJI_GROUP).type,
            key: (0, $3nacY.EMOJI_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.EMOJI_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.emoji.showAt)
        });
        components.push({
            type: (0, $3nacY.EMOJI_BUTTON).type,
            key: (0, $3nacY.EMOJI_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.EMOJI_GROUP).type,
                    key: (0, $3nacY.EMOJI_GROUP).key,
                    rank: (0, $hVLmg.EMOJI_GROUP_RANK)[(0, $3nacY.EMOJI_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $db90488ce2284831$export$e6ce3311a4d41b7f), {
                    api: api
                })
        });
    }
    // Layout Group
    if (config.layout?.enabled) {
        components.push({
            type: (0, $3nacY.LAYOUT_GROUP).type,
            key: (0, $3nacY.LAYOUT_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.LAYOUT_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.layout.showAt)
        });
        components.push({
            type: (0, $3nacY.LAYOUT_BUTTON).type,
            key: (0, $3nacY.LAYOUT_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.LAYOUT_GROUP).type,
                    key: (0, $3nacY.LAYOUT_GROUP).key,
                    rank: (0, $hVLmg.LAYOUT_GROUP_RANK)[(0, $3nacY.LAYOUT_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $625f7354988a8525$export$b5a1df4e06cdc467), {
                    api: api
                })
        });
    }
    // Table Group
    if (config.table?.enabled) {
        components.push({
            type: (0, $3nacY.TABLE_GROUP).type,
            key: (0, $3nacY.TABLE_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.TABLE_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.table.showAt)
        });
        components.push({
            type: (0, $3nacY.TABLE_BUTTON).type,
            key: (0, $3nacY.TABLE_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.TABLE_GROUP).type,
                    key: (0, $3nacY.TABLE_GROUP).key,
                    rank: (0, $hVLmg.TABLE_GROUP_RANK)[(0, $3nacY.TABLE_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $bf0210effd0d17fb$export$a5d4a9df719d6bc1), {
                    api: api
                })
        });
        if (options.tableSelectorSupported) components.push({
            type: (0, $3nacY.TABLE_SIZE_PICKER).type,
            key: (0, $3nacY.TABLE_SIZE_PICKER).key,
            parents: [
                {
                    type: (0, $3nacY.TABLE_GROUP).type,
                    key: (0, $3nacY.TABLE_GROUP).key,
                    rank: (0, $hVLmg.TABLE_GROUP_RANK)[(0, $3nacY.TABLE_SIZE_PICKER).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $dcb5f7a2abe1b3db$export$5468cf78b7a314d6), {
                    api: api,
                    tableSelectorSupported: options.tableSelectorSupported
                })
        });
    }
    // Insert Group
    if (config.insert?.enabled) {
        const createInsertButtonComponent = (breakpoint)=>{
            return ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $45fc30027f1ce605$export$a84121b2ebfb3ce9), {
                    api: api,
                    breakpoint: breakpoint,
                    toolbarConfig: config,
                    showElementBrowserLink: options.showElementBrowserLink,
                    tableSelectorSupported: options.tableSelectorSupported,
                    onInsertBlockType: onInsertBlockType,
                    nativeStatusSupported: options.nativeStatusSupported,
                    horizontalRuleEnabled: options.horizontalRuleEnabled,
                    expandEnabled: options.allowExpand,
                    insertMenuItems: options.insertMenuItems,
                    itemFilter: options.itemFilter,
                    numberOfButtons: 0
                });
        };
        components.push({
            type: (0, $3nacY.INSERT_GROUP).type,
            key: `${(0, $3nacY.INSERT_GROUP).key}-none`,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    below: "sm",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $3nacY.INSERT_BUTTON).type,
            key: (0, $3nacY.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_GROUP).type,
                    key: `${(0, $3nacY.INSERT_GROUP).key}-none`,
                    rank: (0, $hVLmg.INSERT_GROUP_RANK)[(0, $3nacY.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent(null)
        });
        components.push({
            type: (0, $3nacY.INSERT_GROUP).type,
            key: `${(0, $3nacY.INSERT_GROUP).key}-sm`,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    only: "sm",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $3nacY.INSERT_BUTTON).type,
            key: (0, $3nacY.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_GROUP).type,
                    key: `${(0, $3nacY.INSERT_GROUP).key}-sm`,
                    rank: (0, $hVLmg.INSERT_GROUP_RANK)[(0, $3nacY.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('sm')
        });
        components.push({
            type: (0, $3nacY.INSERT_GROUP).type,
            key: `${(0, $3nacY.INSERT_GROUP).key}-md`,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    only: "md",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $3nacY.INSERT_BUTTON).type,
            key: (0, $3nacY.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_GROUP).type,
                    key: `${(0, $3nacY.INSERT_GROUP).key}-md`,
                    rank: (0, $hVLmg.INSERT_GROUP_RANK)[(0, $3nacY.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('md')
        });
        components.push({
            type: (0, $3nacY.INSERT_GROUP).type,
            key: `${(0, $3nacY.INSERT_GROUP).key}-lg`,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    only: "lg",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $3nacY.INSERT_BUTTON).type,
            key: (0, $3nacY.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_GROUP).type,
                    key: `${(0, $3nacY.INSERT_GROUP).key}-lg`,
                    rank: (0, $hVLmg.INSERT_GROUP_RANK)[(0, $3nacY.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('lg')
        });
        components.push({
            type: (0, $3nacY.INSERT_GROUP).type,
            key: `${(0, $3nacY.INSERT_GROUP).key}-xl`,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: (0, $hVLmg.INSERT_BLOCK_SECTION_RANK)[(0, $3nacY.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
                    only: "xl",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $3nacY.INSERT_BUTTON).type,
            key: (0, $3nacY.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_GROUP).type,
                    key: `${(0, $3nacY.INSERT_GROUP).key}-xl`,
                    rank: (0, $hVLmg.INSERT_GROUP_RANK)[(0, $3nacY.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('xl')
        });
    }
    return components;
};


/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















var $9iFhC = parcelRequire("9iFhC");







var $ldbHR = parcelRequire("ldbHR");






















parcelRequire("cozmU");




parcelRequire("cozmU");





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

















/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ function $f7c86dfc23aa6340$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f7c86dfc23aa6340$export$61533625d778d03b = {
    name: "y71vja",
    styles: "width:42px;display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}"
};
const $f7c86dfc23aa6340$export$16be3daa8c26e74d = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};


const $e33a84ec4af64fae$var$DropDownButtonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $f7c86dfc23aa6340$export$61533625d778d03b)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        label: props.label,
        color: "currentColor",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("span", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "currentColor",
        size: "small"
    }))));
const $e33a84ec4af64fae$export$e200d4ca2624495d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        ref: props.handleRef,
        selected: props.selected,
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        spacing: props.spacing,
        "aria-expanded": props['aria-expanded'],
        "aria-haspopup": props['aria-haspopup'],
        "aria-keyshortcuts": props['aria-keyshortcuts'],
        "aria-label": `${props.label}`,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)($e33a84ec4af64fae$var$DropDownButtonIcon, {
            label: ""
        }),
        title: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
            description: props.label,
            shortcutOverride: "/"
        })
    }));


// This determines how the popup should fit. We prefer the insert menu
// opening on the bottom as we have a search bar and should only open on
// top if there is more than sufficient room.
const $dbf22e944567fb92$var$FIT_HEIGHT_BUFFER = 100;
const $dbf22e944567fb92$export$fa06a3a473615c12 = (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            props.open && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
                target: props.plusButtonRef,
                fitHeight: (0, $3f9eb1a1d7b97352$export$611c894df53833b0) + $dbf22e944567fb92$var$FIT_HEIGHT_BUFFER,
                fitWidth: 350,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    0,
                    3
                ],
                mountTo: props.popupsMountPoint,
                boundariesElement: props.popupsBoundariesElement,
                scrollableElement: props.popupsScrollableElement,
                preventOverflow: true,
                alignX: "right",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3f9eb1a1d7b97352$export$2e2bcd8739ae039), {
                    editorView: props.editorView,
                    dropdownItems: props.items,
                    onInsert: props.onInsert,
                    toggleVisiblity: props.togglePlusMenuVisibility,
                    showElementBrowserLink: props.showElementBrowserLink,
                    pluginInjectionApi: props.pluginInjectionApi,
                    isFullPageAppearance: props.isFullPageAppearance
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e33a84ec4af64fae$export$e200d4ca2624495d), {
                "aria-expanded": props.open,
                "aria-haspopup": true,
                handleRef: props.onRef,
                selected: props.open,
                disabled: props.disabled,
                onClick: props.onClick,
                onKeyDown: props.onKeyDown,
                spacing: props.spacing,
                label: props.label,
                "aria-keyshortcuts": "/"
            })
        ]
    });
};



const $e7b38bfdd04ca561$export$4476666e12e8d26e = (props)=>{
    if (props.items.length === 0 && !props.showElementBrowserLink) return null;
    if (props.disabled) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e33a84ec4af64fae$export$e200d4ca2624495d), {
            "aria-expanded": props.open,
            "aria-haspopup": true,
            handleRef: props.onRef,
            selected: props.open,
            disabled: props.disabled,
            onClick: props.onClick,
            onKeyDown: props.onKeyDown,
            spacing: props.spacing,
            label: props.label,
            "aria-keyshortcuts": "/"
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dbf22e944567fb92$export$fa06a3a473615c12), {
        disabled: props.disabled,
        editorView: props.editorView,
        items: props.items,
        label: props.label,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        onInsert: props.onInsert,
        onRef: props.onPlusButtonRef,
        open: props.open,
        plusButtonRef: props.plusButtonRef,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        spacing: props.spacing,
        togglePlusMenuVisibility: props.togglePlusMenuVisibility,
        showElementBrowserLink: props.showElementBrowserLink,
        pluginInjectionApi: props.pluginInjectionApi,
        isFullPageAppearance: props.isFullPageAppearance
    });
};



/**
 * Checks if an element is detached (i.e. not in the current document)
 */ // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing DOM check surfaced by this mechanical PR.
const $166da085bf2fd97f$var$isDetachedElement = (el)=>!document.body.contains(el);
const $166da085bf2fd97f$var$TABLE_SELECTOR_STRING = 'table selector';
// TODO: ED-26959 - Jenga team will create a component for a split button using this css
const $166da085bf2fd97f$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${"var(--ds-background-neutral-subtle-hovered, #0515240F)"};

    &:hover {
      background: ${"var(--ds-background-neutral-hovered, #0B120E24)"};
    }
  }`;
const $166da085bf2fd97f$var$EmojiPicker = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $uyXFl.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $af2XZ.default), {
        onPickerRef: setOutsideClickTargetRef,
        ...props
    });
};
const $166da085bf2fd97f$var$EmojiPickerWithListeners = (0, $9Muxb.default)($166da085bf2fd97f$var$EmojiPicker);
const $166da085bf2fd97f$export$6555404d88cb913b = ({ isTableSelectorOpen: isTableSelectorOpen, isButtonDisabled: isButtonDisabled })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation due to mixins
    (0, $lOiVq.css)("display:flex;", !isTableSelectorOpen && !isButtonDisabled && $166da085bf2fd97f$var$getHoverStyles('.table-selector-toolbar-btn'), " ", !isTableSelectorOpen && !isButtonDisabled && $166da085bf2fd97f$var$getHoverStyles('.table-toolbar-btn'), " .table-toolbar-btn{border-top-right-radius:var(--ds-radius-large, 0px);border-bottom-right-radius:var(--ds-radius-large, 0px);margin-right:var(--ds-space-025, 2px);padding:var(--ds-space-0, 0px);&>span{min-width:16px;margin:var(--ds-space-0, 0px);}}.table-selector-toolbar-btn{padding:var(--ds-space-0, 0px);border-top-left-radius:var(--ds-radius-large, 0px)!important;border-bottom-left-radius:var(--ds-radius-large, 0px)!important;&>span{margin:var(--ds-space-0, 0px);width:16px!important;display:flex;justify-content:center;}}");
class $166da085bf2fd97f$export$630ae7da9d01a215 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        const [buttons, dropdownItems] = (0, $df59e77976576928$export$af56db357559c888)({
            isTypeAheadAllowed: props.isTypeAheadAllowed,
            tableSupported: props.tableSupported,
            tableSelectorSupported: props.tableSelectorSupported,
            mediaUploadsEnabled: props.mediaUploadsEnabled,
            mediaSupported: props.mediaSupported,
            isEditorOffline: props.isEditorOffline,
            imageUploadSupported: props.imageUploadSupported,
            imageUploadEnabled: props.imageUploadEnabled,
            mentionsSupported: props.mentionsSupported,
            mentionsDisabled: props.mentionsDisabled,
            actionSupported: props.actionSupported,
            decisionSupported: props.decisionSupported,
            linkSupported: props.linkSupported,
            linkDisabled: props.linkDisabled,
            emojiDisabled: props.emojiDisabled,
            hasEmojiPlugin: !!props.pluginInjectionApi?.emoji,
            hasMentionsPlugin: !!props.pluginInjectionApi?.mention,
            hasMediaPlugin: !!props.pluginInjectionApi?.media,
            nativeStatusSupported: props.nativeStatusSupported,
            dateEnabled: props.dateEnabled,
            placeholderTextEnabled: props.placeholderTextEnabled,
            horizontalRuleEnabled: props.horizontalRuleEnabled,
            layoutSectionEnabled: props.layoutSectionEnabled,
            expandEnabled: props.expandEnabled,
            showElementBrowserLink: props.showElementBrowserLink,
            emojiProvider: props.emojiProvider,
            availableWrapperBlockTypes: props.availableWrapperBlockTypes,
            insertMenuItems: props.insertMenuItems,
            itemFilter: props.itemFilter,
            schema: props.editorView.state.schema,
            numberOfButtons: props.buttons,
            formatMessage: props.intl.formatMessage
        });
        return {
            ...state,
            buttons: buttons,
            dropdownItems: dropdownItems
        };
    }
    componentDidUpdate(prevProps) {
        // If number of visible buttons changed, close emoji picker and table selector
        if (prevProps.buttons !== this.props.buttons) this.setState({
            emojiPickerOpen: false,
            isTableSelectorOpen: false
        });
        if (this.state.isOpenedByKeyboard) {
            const downArrowEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.dropdownButtonRef?.deref()?.dispatchEvent(downArrowEvent);
            this.setState({
                ...this.state,
                isOpenedByKeyboard: false
            });
        }
        if (this.state.isTableSelectorOpen) this.setState({
            isTableSelectorOpenedByKeyboard: false
        });
        if (this.props.showElementBrowser !== prevProps.showElementBrowser) {
            this.handleClick();
            this.setState({
                ...this.state,
                isPlusMenuOpen: this.props.showElementBrowser
            });
        }
    }
    renderPopup() {
        const { emojiPickerOpen: emojiPickerOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, emojiProvider: emojiProvider } = this.props;
        const dropdownEmoji = this.state.dropdownItems.some(({ value: { name: name } })=>name === 'emoji');
        const dropDownButtonRef = this.plusButtonRef;
        const ref = dropdownEmoji ? dropDownButtonRef : this.emojiButtonRef;
        if (!emojiPickerOpen || !ref || !emojiProvider) return null;
        const onUnmount = ()=>{
            requestAnimationFrame(()=>this.props.pluginInjectionApi?.core?.actions?.focus());
        };
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
            target: ref.deref(),
            fitHeight: 350,
            fitWidth: 350,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                3
            ],
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            onUnmount: onUnmount,
            focusTrap: true,
            zIndex: (0, $7Y8M5.akEditorMenuZIndex)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($166da085bf2fd97f$var$EmojiPickerWithListeners, {
            emojiProvider: emojiProvider,
            onSelection: this.handleSelectedEmoji,
            handleClickOutside: this.handleEmojiClickOutside,
            handleEscapeKeydown: this.handleEmojiPressEscape
        }));
    }
    renderTableSelectorPopup() {
        const { isTableSelectorOpen: isTableSelectorOpen, isTableSelectorOpenedByKeyboard: isTableSelectorOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, pluginInjectionApi: pluginInjectionApi } = this.props;
        const ref = this.tableButtonRef.current ?? undefined;
        if (!isTableSelectorOpen) return null;
        // We use focusTrap in the Popup. When we insert a table via popup,
        // the popup closes, focusTrap gets destroyed and the popup detaches.
        // The focus gets set to the body element. onUnmount method sets focus on the editor right before the
        // Popup will be unmounted to ensure that the new table has a selection with a blinking cursor.
        // So we can start typing right away.
        const onUnmount = ()=>pluginInjectionApi?.core?.actions?.focus();
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2iq8g.default), {
            allowOutsideSelection: true,
            target: ref,
            onUnmount: onUnmount,
            onSelection: this.handleSelectedTableSize,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            handleClickOutside: this.handleTableSelectorClickOutside,
            handleEscapeKeydown: this.handleTableSelectorPressEscape,
            isOpenedByKeyboard: isTableSelectorOpenedByKeyboard
        });
    }
    render() {
        const { buttons: buttons, dropdownItems: dropdownItems, emojiPickerOpen: emojiPickerOpen, isTableSelectorOpen: isTableSelectorOpen } = this.state;
        const { isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, editorAppearance: editorAppearance } = this.props;
        const isFullPageAppearance = [
            'full-page',
            'full-width'
        ].includes(editorAppearance ?? '');
        const isTableButtonVisible = buttons.some(({ value: value })=>value.name === 'table');
        const isTableSizeVisible = buttons.some(({ value: value })=>value.name === 'table selector');
        if (buttons.length === 0 && dropdownItems.length === 0) return null;
        const toolbarButtons = [];
        let tableSelectorButton;
        let tableButton;
        // Seperate table buttons from toolbar buttons
        for (const btn of buttons){
            if (btn.value.name === $166da085bf2fd97f$var$TABLE_SELECTOR_STRING) tableSelectorButton = btn;
            else if (btn.value.name === 'table' && this.props.tableSelectorSupported) tableButton = btn;
            else toolbarButtons.push(btn);
        }
        return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9iFhC.buttonGroupStyle)
        }, toolbarButtons.map((btn)=>{
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
                item: btn,
                testId: this.getToolbarButtonTestId(btn),
                ref: this.handleToolbarRef(btn.value.name),
                key: btn.value.name,
                spacing: isReducedSpacing ? 'none' : 'default',
                disabled: isDisabled || btn.isDisabled,
                iconBefore: btn.elemBefore,
                selected: btn.value.name === 'emoji' && emojiPickerOpen || btn.isActive,
                title: btn.title,
                "aria-label": btn['aria-label'],
                "aria-haspopup": btn['aria-haspopup'],
                "aria-keyshortcuts": btn['aria-keyshortcuts'],
                onItemClick: this.insertToolbarMenuItem
            });
        }), this.props.tableSelectorSupported && (isTableButtonVisible || isTableSizeVisible) && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $166da085bf2fd97f$export$6555404d88cb913b({
                isTableSelectorOpen: isTableSelectorOpen,
                isButtonDisabled: tableButton?.isDisabled
            })
        }, isTableButtonVisible && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-toolbar-btn",
            item: tableButton,
            ref: this.tableButtonRef,
            testId: String(tableButton?.content),
            key: tableButton?.value.name,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableButton?.isDisabled,
            iconBefore: tableButton?.elemBefore,
            selected: tableButton?.isActive || isTableSelectorOpen,
            title: tableButton?.title,
            "aria-label": tableButton ? tableButton['aria-label'] : undefined,
            "aria-haspopup": tableButton ? tableButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableButton ? tableButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem
        }), isTableButtonVisible && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-selector-toolbar-btn",
            item: tableSelectorButton,
            testId: String(tableSelectorButton?.content),
            key: tableSelectorButton?.value.name,
            ref: this.tableSelectorButtonRef,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableSelectorButton?.isDisabled,
            iconBefore: tableSelectorButton?.elemBefore,
            selected: tableSelectorButton?.isActive || isTableSelectorOpen,
            title: tableSelectorButton?.title,
            "aria-label": tableSelectorButton ? tableSelectorButton['aria-label'] : undefined,
            "aria-haspopup": tableSelectorButton ? tableSelectorButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableSelectorButton ? tableSelectorButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem,
            onKeyDown: this.handleTableSelectorOpenByKeyboard
        })), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: (0, $9iFhC.wrapperStyle)
        }, this.renderPopup(), this.renderTableSelectorPopup(), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $e7b38bfdd04ca561$export$4476666e12e8d26e), {
            popupsMountPoint: this.props.popupsMountPoint,
            popupsBoundariesElement: this.props.popupsBoundariesElement,
            popupsScrollableElement: this.props.popupsScrollableElement,
            disabled: this.props.isDisabled ?? false,
            editorView: this.props.editorView,
            spacing: this.props.isReducedSpacing ? 'none' : 'default',
            label: this.props.intl.formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).insertMenu),
            open: this.state.isPlusMenuOpen,
            plusButtonRef: this.plusButtonRef?.deref(),
            items: this.state.dropdownItems,
            onRef: this.handleDropDownButtonRef,
            onPlusButtonRef: this.handlePlusButtonRef,
            onClick: this.handleClick,
            onKeyDown: this.handleOpenByKeyboard,
            onInsert: this.insertInsertMenuItem,
            togglePlusMenuVisibility: this.togglePlusMenuVisibility,
            showElementBrowserLink: this.props.showElementBrowserLink || false,
            pluginInjectionApi: this.props.pluginInjectionApi,
            isFullPageAppearance: isFullPageAppearance
        })), (!this.props.pluginInjectionApi?.primaryToolbar && this.props.showSeparator || isFullPageAppearance && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: (0, $9iFhC.separatorStyles)
        }));
    }
    constructor(..._args){
        super(..._args);
        this.dropdownButtonRef = void 0;
        this.emojiButtonRef = void 0;
        this.mediaButtonRef = void 0;
        this.plusButtonRef = void 0;
        this.tableButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.tableSelectorButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = {
            isPlusMenuOpen: false,
            emojiPickerOpen: false,
            isOpenedByKeyboard: false,
            buttons: [],
            dropdownItems: [],
            isTableSelectorOpen: false,
            isTableSelectorOpenedByKeyboard: false
        };
        this.onOpenChange = (attrs)=>{
            const state = {
                isPlusMenuOpen: attrs.isPlusMenuOpen,
                emojiPickerOpen: this.state.emojiPickerOpen
            };
            if (this.state.emojiPickerOpen && !attrs.open) state.emojiPickerOpen = false;
            this.setState(state, ()=>{
                const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                if (!dispatchAnalyticsEvent) return;
                const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
                if (isPlusMenuOpen) return dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).OPENED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
                return dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CLOSED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
            });
        };
        this.togglePlusMenuVisibility = (event)=>{
            const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            if (pluginInjectionApi && (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) pluginInjectionApi.core.actions.execute(({ tr: tr })=>{
                if (isPlusMenuOpen) pluginInjectionApi.metrics?.commands.startActiveSessionTimer()({
                    tr: tr
                });
                else pluginInjectionApi.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                return tr;
            });
            this.onOpenChange({
                isPlusMenuOpen: !isPlusMenuOpen
            });
            if (event?.key === 'Escape') (this.plusButtonRef || this.dropdownButtonRef)?.deref()?.focus();
        };
        this.toggleEmojiPicker = (inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    emojiPickerOpen: !prevState.emojiPickerOpen
                }), ()=>{
                if (this.state.emojiPickerOpen) {
                    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                    if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                        action: (0, $krYZG.ACTION).OPENED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).UI
                    });
                }
            });
        };
        this.handleEmojiPressEscape = ()=>{
            this.toggleEmojiPicker((0, $krYZG.INPUT_METHOD).KEYBOARD);
            this.emojiButtonRef?.deref()?.focus();
        };
        this.handleEmojiClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Workaround for FS-1322 - where two onClicks fire - one when the upload button is
            // still in the document, and one once it's detached. Does not always occur, and
            // may be a side effect of a react render optimisation
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$166da085bf2fd97f$var$isDetachedElement(e.target)) this.toggleEmojiPicker((0, $krYZG.INPUT_METHOD).TOOLBAR);
        };
        this.getToolbarButtonTestId = (btn)=>{
            const buttonTestIds = {
                media: 'media-attachment-toolbar-button'
            };
            return buttonTestIds[btn.value.name] || String(btn.content);
        };
        this.handleToolbarRef = (buttonName)=>(ref)=>{
                if (!ref) return;
                switch(buttonName){
                    case 'emoji':
                        this.emojiButtonRef = new WeakRef(ref);
                        break;
                    case 'media':
                        this.mediaButtonRef = new WeakRef(ref);
                        break;
                }
            };
        this.handlePlusButtonRef = (ref)=>{
            if (ref) this.plusButtonRef = new WeakRef(ref);
        };
        this.handleDropDownButtonRef = (ref)=>{
            if (ref) this.dropdownButtonRef = new WeakRef(ref);
        };
        this.toggleTableSelector = (_inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    isTableSelectorOpen: !prevState.isTableSelectorOpen
                }));
        };
        this.handleSelectedTableSize = (rowsCount, colsCount)=>{
            this.insertTableWithSize((0, $krYZG.INPUT_METHOD).TOOLBAR, rowsCount, colsCount)();
            this.toggleTableSelector();
        };
        this.handleTableSelectorPressEscape = ()=>{
            this.toggleTableSelector((0, $krYZG.INPUT_METHOD).KEYBOARD);
            this.tableSelectorButtonRef.current?.focus();
        };
        this.handleTableSelectorClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$166da085bf2fd97f$var$isDetachedElement(e.target)) this.toggleTableSelector((0, $krYZG.INPUT_METHOD).TOOLBAR);
        };
        this.handleClick = ()=>{
            this.togglePlusMenuVisibility();
        };
        this.handleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                this.setState({
                    ...this.state,
                    isOpenedByKeyboard: true
                });
                event.preventDefault();
                this.togglePlusMenuVisibility();
            }
        };
        this.handleTableSelectorOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') this.setState({
                isTableSelectorOpenedByKeyboard: true
            });
        };
        this.toggleLinkPanel = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.hyperlink?.commands.showLinkToolbar(inputMethod)) ?? false;
        };
        this.insertMention = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            if (!editorView) return true;
            const pluginState = pluginInjectionApi?.mention?.sharedState.currentState();
            if (pluginState && pluginState.canInsertMention === false) return false;
            return Boolean(pluginInjectionApi?.mention?.actions?.openTypeAhead(inputMethod));
        };
        this.insertTable = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi, editorView: editorView } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                pluginInjectionApi?.table?.actions.insertTable?.({
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        };
        this.insertTableWithSize = (inputMethod, rowsCount, colsCount)=>()=>{
                const { pluginInjectionApi: pluginInjectionApi } = this.props;
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.table?.commands.insertTableWithSize(rowsCount, colsCount, (0, $krYZG.INPUT_METHOD).PICKER));
                });
            };
        this.createDate = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.date?.commands?.insertDate({
                inputMethod: inputMethod
            }));
            return true;
        };
        this.createPlaceholderText = ()=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.placeholderText?.actions.showPlaceholderFloatingToolbar(editorView.state, editorView.dispatch);
            return true;
        };
        this.insertLayoutColumns = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.layout?.actions.insertLayoutColumns(inputMethod)(editorView.state, editorView.dispatch);
            return true;
        };
        this.createStatus = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return Boolean(pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.status?.commands?.insertStatus(inputMethod)));
        };
        this.openMediaPicker = (inputMethod)=>{
            const { onShowMediaPicker: onShowMediaPicker, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
            if (onShowMediaPicker) {
                const ref = this.mediaButtonRef?.deref();
                const args = ref?.parentElement ? {
                    ref: ref,
                    mountPoint: this.props.popupsMountPoint ?? ref.parentElement
                } : undefined;
                onShowMediaPicker(args);
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).OPENED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
            }
            return true;
        };
        this.insertTaskDecision = (name, inputMethod)=>()=>{
                const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
                const listType = name === 'action' ? 'taskList' : 'decisionList';
                return pluginInjectionApi?.taskDecision?.actions.insertTaskDecision(listType, inputMethod)(state, dispatch) ?? false;
            };
        this.insertHorizontalRule = (inputMethod)=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.rule?.actions.insertHorizontalRule(inputMethod)(state, dispatch) ?? false;
        };
        this.insertExpand = ()=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.expand?.actions.insertExpand(state, dispatch) ?? false;
        };
        this.insertBlockType = (itemName)=>()=>{
                const { editorView: editorView, onInsertBlockType: onInsertBlockType } = this.props;
                const { state: state, dispatch: dispatch } = editorView;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onInsertBlockType(itemName)(state, dispatch);
                return true;
            };
        this.handleSelectedEmoji = (emojiId)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            this.props.editorView.focus();
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi.emoji?.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
            this.toggleEmojiPicker();
            return true;
        };
        this.onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
            const { editorView: editorView, handleImageUpload: handleImageUpload, expandEnabled: expandEnabled } = this.props;
            // need to do this before inserting nodes so scrollIntoView works properly
            if (!editorView.hasFocus()) editorView.focus();
            switch(item.value.name){
                case 0, $ce29956ee7a2085a$export$7223d1a8f66d53b6:
                    this.toggleLinkPanel(inputMethod);
                    break;
                case 'table':
                    this.insertTable(inputMethod);
                    break;
                case 'table selector':
                    this.toggleTableSelector(inputMethod);
                    break;
                case 'image upload':
                    if (handleImageUpload) {
                        const { state: state, dispatch: dispatch } = editorView;
                        handleImageUpload()(state, dispatch);
                    }
                    break;
                case 'media':
                    this.openMediaPicker(inputMethod);
                    break;
                case 'mention':
                    this.insertMention(inputMethod);
                    break;
                case 'emoji':
                    this.toggleEmojiPicker(inputMethod);
                    break;
                case 'codeblock':
                case 'blockquote':
                case 'panel':
                    this.insertBlockType(item.value.name)();
                    break;
                case 'action':
                case 'decision':
                    this.insertTaskDecision(item.value.name, inputMethod)();
                    break;
                case 'horizontalrule':
                    this.insertHorizontalRule(inputMethod);
                    break;
                case 'date':
                    this.createDate(inputMethod);
                    break;
                case 'placeholder text':
                    this.createPlaceholderText();
                    break;
                case 'layout':
                    this.insertLayoutColumns(inputMethod);
                    break;
                case 'status':
                    this.createStatus(inputMethod);
                    break;
                // https://product-fabric.atlassian.net/browse/ED-8053
                // @ts-ignore: OK to fallthrough to default
                case 'expand':
                    if (expandEnabled) {
                        this.insertExpand();
                        break;
                    }
                // eslint-disable-next-line no-fallthrough
                default:
                    if (item && item.onClick) {
                        item.onClick();
                        break;
                    }
            }
            this.setState({
                isPlusMenuOpen: false
            });
        };
        this.insertToolbarMenuItem = (btn)=>this.onItemActivated({
                item: btn,
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            });
        this.insertInsertMenuItem = ({ item: item })=>this.onItemActivated({
                item: item,
                inputMethod: (0, $krYZG.INPUT_METHOD).INSERT_MENU
            });
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $166da085bf2fd97f$var$_default_1 = (0, $kSwu1.injectIntl)($166da085bf2fd97f$export$630ae7da9d01a215);
var $166da085bf2fd97f$export$2e2bcd8739ae039 = $166da085bf2fd97f$var$_default_1;


const $7ade245df6aaf6da$export$7e87882fdef9bc6 = (toolbarSize, appearance)=>{
    // Different button numbers for full-page to better match full page toolbar breakpoints
    if (appearance === 'full-page' && (0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $6OREF.ToolbarSize).XXL:
        case (0, $6OREF.ToolbarSize).XL:
        case (0, $6OREF.ToolbarSize).L:
            return 7;
        case (0, $6OREF.ToolbarSize).M:
            return 3;
        default:
            return 0;
    }
    if ((0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $6OREF.ToolbarSize).XXL:
        case (0, $6OREF.ToolbarSize).XL:
            return 7;
        case (0, $6OREF.ToolbarSize).L:
            return 5;
        case (0, $6OREF.ToolbarSize).M:
        case (0, $6OREF.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
    else switch(toolbarSize){
        case (0, $6OREF.ToolbarSize).XXL:
        case (0, $6OREF.ToolbarSize).XL:
        case (0, $6OREF.ToolbarSize).L:
        case (0, $6OREF.ToolbarSize).M:
            return 7;
        case (0, $6OREF.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
};
/**
 * Wrapper over insertBlockTypeWithAnalytics to autobind toolbar input method
 * @param name Block name
 */ function $7ade245df6aaf6da$var$handleInsertBlockType(insertCodeBlock, insertPanel, insertBlockQuote) {
    return (name)=>{
        if (name === (0, $et3Y5.CODE_BLOCK).name && insertCodeBlock) return insertCodeBlock((0, $krYZG.INPUT_METHOD).TOOLBAR);
        if (name === (0, $et3Y5.PANEL).name && insertPanel) return insertPanel((0, $krYZG.INPUT_METHOD).TOOLBAR);
        if (name === (0, $et3Y5.BLOCK_QUOTE).name && insertBlockQuote) return insertBlockQuote((0, $krYZG.INPUT_METHOD).INSERT_MENU);
        return ()=>false;
    };
}
function $7ade245df6aaf6da$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $7ade245df6aaf6da$export$b7df1817ade19df9 = ({ config: options = {}, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const refs = {};
    const primaryToolbarComponent = ({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, providerFactory: providerFactory, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem })=>{
        refs.popupsMountPoint = popupsMountPoint || undefined;
        const renderNode = (providers)=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($7ade245df6aaf6da$var$ToolbarInsertBlockWithInjectionApi, {
                pluginInjectionApi: api,
                editorView: editorView,
                editorActions: editorActions,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                toolbarSize: toolbarSize,
                disabled: disabled,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                isLastItem: isLastItem,
                providers: providers,
                options: options,
                appearance: options.appearance
            });
        };
        if ((0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($7ade245df6aaf6da$var$ToolbarInsertBlockWithInjectionApi, {
                pluginInjectionApi: api,
                editorView: editorView,
                editorActions: editorActions,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                toolbarSize: toolbarSize,
                disabled: disabled,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                isLastItem: isLastItem,
                options: options,
                appearance: options.appearance
            });
        }
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
            providerFactory: providerFactory,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'emojiProvider'
            ],
            renderNode: renderNode
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $96b3a66fa4c20cdd$export$a758406ca53b86a5)({
        api: api,
        onInsertBlockType: $7ade245df6aaf6da$var$handleInsertBlockType(api?.codeBlock?.actions.insertCodeBlock, api?.panel?.actions.insertPanel, api?.blockType?.actions.insertBlockQuote),
        options: options
    }));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'insertBlock',
        component: primaryToolbarComponent
    });
    const plugin = {
        name: 'insertBlock',
        actions: {
            toggleAdditionalMenu: ()=>{
                api?.core?.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $a0e6dc97e12274ad$export$fef912314604ae84), true);
                });
            }
        },
        getSharedState: (editorState)=>{
            if (!editorState || ![
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '')) return;
            const toggleInsertBlockPluginState = (0, $a0e6dc97e12274ad$export$fef912314604ae84).getState(editorState);
            return {
                showElementBrowser: toggleInsertBlockPluginState?.showElementBrowser || false
            };
        },
        usePluginHook () {
            (0, $cozmU.useEffect)(()=>{
                // This is to optimise the UI so that when the user first clicks on the insert
                // menu it opens instantly. As we're delaying the loading this won't affect the
                // initial editor rendering metrics.
                $7ade245df6aaf6da$var$delayUntilIdle(()=>{
                    (0, $eWXt3.default).preload();
                });
            }, []);
        },
        pmPlugins: ()=>{
            [
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '');
            const plugins = [];
            plugins.push({
                name: 'toggleInsertBlockPmPlugin',
                plugin: ()=>(0, $a0e6dc97e12274ad$export$6f80226cf0aae60e)()
            });
            if ((0, $iDrrr.fg)('platform_editor_experience_tracking_toolbar_button')) plugins.push({
                name: 'toolbarActionExperiences',
                plugin: ()=>(0, $703f972a035f1160$export$452d41e37eef397d)({
                        dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload)
                    })
            });
            return plugins;
        },
        pluginsOptions: {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
    return plugin;
};
const $7ade245df6aaf6da$var$selector = (states)=>{
    return {
        emojiProviderSelector: states.emojiState?.emojiProvider,
        showMediaPicker: states.mediaState?.showMediaPicker,
        mediaAllowsUploads: states.mediaState?.allowsUploads,
        showElementBrowser: states.insertBlockState?.showElementBrowser,
        isTypeAheadAllowed: states.typeAheadState?.isAllowed,
        mentionProvider: states.mentionState?.mentionProvider,
        canInsertMention: states.mentionState?.canInsertMention,
        dateEnabled: states.dateState?.isInitialised,
        placeholderTextAllowInserting: states.placeholderTextState?.allowInserting,
        connectivityMode: states.connectivityState?.mode,
        imageUploadEnabled: states.imageUploadState?.enabled,
        availableWrapperBlockTypes: states.blockTypeState?.availableWrapperBlockTypes,
        canInsertLink: states.hyperlinkState?.canInsertLink,
        activeLinkMark: states.hyperlinkState?.activeLinkMark
    };
};
function $7ade245df6aaf6da$var$ToolbarInsertBlockWithInjectionApi({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem, pluginInjectionApi: pluginInjectionApi, options: options, appearance: appearance }) {
    const buttons = $7ade245df6aaf6da$export$7e87882fdef9bc6(toolbarSize, appearance);
    const { emojiProviderSelector: emojiProviderSelector, showMediaPicker: showMediaPicker, mediaAllowsUploads: mediaAllowsUploads, showElementBrowser: showElementBrowser, isTypeAheadAllowed: isTypeAheadAllowed, mentionProvider: mentionProvider, canInsertMention: canInsertMention, dateEnabled: dateEnabled, placeholderTextAllowInserting: placeholderTextAllowInserting, connectivityMode: connectivityMode, imageUploadEnabled: imageUploadEnabled, availableWrapperBlockTypes: availableWrapperBlockTypes, canInsertLink: canInsertLink, activeLinkMark: activeLinkMark } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'hyperlink',
        'date',
        'imageUpload',
        'mention',
        'emoji',
        'blockType',
        'media',
        'typeAhead',
        'placeholderText',
        'insertBlock',
        'connectivity'
    ], $7ade245df6aaf6da$var$selector);
    const emojiProviderPromise = (0, $4Qu9h.useSharedPluginStateSelector)(pluginInjectionApi, 'emoji.emojiProviderPromise', {
        disabled: !(0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)
    });
    const getEmojiProvider = ()=>{
        if (emojiProviderSelector) return Promise.resolve(emojiProviderSelector);
    };
    const emojiProvider = (0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true, {
        exposure: true
    }) ? emojiProviderPromise : getEmojiProvider();
    const onShowMediaPicker = (mountInfo)=>{
        if (!showMediaPicker) return;
        pluginInjectionApi?.mediaInsert?.commands.showMediaInsertPopup ? pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.mediaInsert?.commands.showMediaInsertPopup(mountInfo)) : showMediaPicker();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $166da085bf2fd97f$export$2e2bcd8739ae039), {
        showElementBrowser: showElementBrowser || false,
        pluginInjectionApi: pluginInjectionApi,
        buttons: buttons,
        isReducedSpacing: isToolbarReducedSpacing,
        isDisabled: disabled,
        isTypeAheadAllowed: Boolean(isTypeAheadAllowed),
        editorView: editorView,
        tableSupported: !!editorView.state.schema.nodes.table,
        tableSelectorSupported: options.tableSelectorSupported && !!editorView.state.schema.nodes.table,
        actionSupported: !!editorView.state.schema.nodes.taskItem,
        mentionsSupported: !!mentionProvider,
        mentionsDisabled: !canInsertMention,
        decisionSupported: !!editorView.state.schema.nodes.decisionItem,
        dateEnabled: !!dateEnabled,
        placeholderTextEnabled: !!placeholderTextAllowInserting,
        layoutSectionEnabled: Boolean(pluginInjectionApi?.layout),
        expandEnabled: !!options.allowExpand,
        mediaUploadsEnabled: mediaAllowsUploads ?? undefined,
        onShowMediaPicker: onShowMediaPicker,
        mediaSupported: mediaAllowsUploads !== undefined,
        isEditorOffline: (0, $jaFVy.isOfflineMode)(connectivityMode),
        imageUploadSupported: !!pluginInjectionApi?.imageUpload,
        imageUploadEnabled: imageUploadEnabled,
        handleImageUpload: pluginInjectionApi?.imageUpload?.actions.startUpload,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        linkSupported: canInsertLink !== undefined,
        linkDisabled: !canInsertLink || !!activeLinkMark,
        emojiDisabled: !emojiProvider,
        emojiProvider: emojiProvider,
        nativeStatusSupported: options.nativeStatusSupported,
        horizontalRuleEnabled: options.horizontalRuleEnabled,
        onInsertBlockType: $7ade245df6aaf6da$var$handleInsertBlockType(pluginInjectionApi?.codeBlock?.actions.insertCodeBlock, pluginInjectionApi?.panel?.actions.insertPanel, pluginInjectionApi?.blockType?.actions.insertBlockQuote),
        onInsertMacroFromMacroBrowser: pluginInjectionApi?.extension?.actions.insertMacroFromMacroBrowser,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        insertMenuItems: options.insertMenuItems,
        itemFilter: options.itemFilter,
        editorActions: editorActions,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        showElementBrowserLink: options.showElementBrowserLink,
        showSeparator: !isLastItem && toolbarSize <= (0, $6OREF.ToolbarSize).S,
        editorAppearance: options.appearance
    });
}
module.exports["insertBlockPlugin"] = $7ade245df6aaf6da$export$b7df1817ade19df9;

});

parcelRegister("aTF50", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c9278148f534358276d80793fde07a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7eeee803285e787b$var$_react = $7eeee803285e787b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7eeee803285e787b$var$_baseNew = $7eeee803285e787b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7eeee803285e787b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/lozenge
 * Usage guidance:
 * Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7eeee803285e787b$var$LozengeIcon = (props)=>/*#__PURE__*/ $7eeee803285e787b$var$_react.default.createElement($7eeee803285e787b$var$_baseNew.default, Object.assign({
        name: "LozengeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$7eeee803285e787b$var$LozengeIcon.displayName = 'LozengeIcon';
var $7eeee803285e787b$var$_default = module.exports.default = $7eeee803285e787b$var$LozengeIcon;

});

parcelRegister("2iq8g", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $9Muxb = parcelRequire("9Muxb");


var $7XIuB = parcelRequire("7XIuB");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");





var $gx3UZ = parcelRequire("gx3UZ");


var $uyXFl = parcelRequire("uyXFl");

function $2b70dbb241c1e3c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b70dbb241c1e3c2$export$fe015b05aaf05d59 = 2;
const $2b70dbb241c1e3c2$export$80d6f86639b2335 = 17;
const $2b70dbb241c1e3c2$var$MULTIPLICATION_SYMBOL = "\xd7";
const $2b70dbb241c1e3c2$var$selectedButtonStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-blue-subtle, #669DF1)"}`
});
const $2b70dbb241c1e3c2$var$buttonStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    height: `${$2b70dbb241c1e3c2$export$80d6f86639b2335}px`,
    width: `${$2b70dbb241c1e3c2$export$80d6f86639b2335}px`,
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'pointer',
    display: 'block',
    '&:focus': {
        outline: 'none',
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
        boxShadow: `0 0 0 0.5px ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $2b70dbb241c1e3c2$var$selectionSizeTextStyles = {
    name: "1d7cjgr",
    styles: "line-height:14px;display:flex;justify-content:center;margin-top:var(--ds-space-075, 6px);padding:var(--ds-space-075, 6px)"
};
const $2b70dbb241c1e3c2$var$TableSelectorButton = ({ row: row, col: col, isActive: isActive, onClick: onClick, label: label, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus })=>{
    const btnRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (btnRef.current) {
            if (isFocused) btnRef.current.focus({
                preventScroll: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? true : undefined
            });
            else btnRef.current.blur();
        }
    }, [
        isFocused,
        btnRef
    ]);
    const handleFocus = col === 1 && row === 1 ? ()=>handleInitialButtonFocus() : undefined;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        type: "button",
        css: [
            $2b70dbb241c1e3c2$var$buttonStyles,
            isActive ? $2b70dbb241c1e3c2$var$selectedButtonStyles : undefined
        ],
        onClick: ()=>onClick(row, col),
        "aria-label": label,
        onKeyDown: onKeyDown,
        ref: btnRef,
        onFocus: handleFocus
    });
};
const $2b70dbb241c1e3c2$var$createArray = (maxCols, maxRows)=>{
    const arr = [];
    for(let i = 1; i < maxRows + 1; i++)for(let j = 1; j < maxCols + 1; j++)arr.push({
        col: j,
        row: i
    });
    return arr;
};
const $2b70dbb241c1e3c2$var$gridWrapperStyles = ({ maxCols: maxCols, maxRows: maxRows })=>/*#__PURE__*/ (0, $lOiVq.css)({
        display: 'grid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `repeat(${maxCols}, 1fr)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateRows: `repeat(${maxRows}, 1fr)`,
        gap: `${"var(--ds-space-025, 2px)"}`
    });
const $2b70dbb241c1e3c2$var$TableSelectorPopup = ({ maxCols: maxCols, maxRows: maxRows, onSelection: onSelection, selectedCol: selectedCol, selectedRow: selectedRow, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus, intl: { formatMessage: formatMessage } })=>{
    const buttons = (0, $cozmU.useMemo)(()=>{
        return $2b70dbb241c1e3c2$var$createArray(maxCols, maxRows);
    }, [
        maxCols,
        maxRows
    ]);
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dinVW.Stack), {
        ref: setOutsideClickTargetRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "aria-label": `${formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableSizeSelectorPopup)}`,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        $2b70dbb241c1e3c2$var$gridWrapperStyles({
            maxCols: maxCols,
            maxRows: maxRows
        })
    }, buttons.map(({ col: col, row: row }, index)=>{
        const isCurrentFocused = isFocused && selectedCol === col && selectedRow === row;
        const isActive = selectedCol >= col && selectedRow >= row ? true : false;
        return /*#__PURE__*/ (0, $lOiVq.jsx)($2b70dbb241c1e3c2$var$TableSelectorButton, {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            isActive: isActive,
            col: col,
            row: row,
            onClick: onSelection,
            label: `${formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableSizeSelectorButton, {
                numberOfColumns: col,
                numberOfRows: row
            })}`,
            onKeyDown: onKeyDown,
            isFocused: isCurrentFocused,
            handleInitialButtonFocus: handleInitialButtonFocus
        });
    })), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $2b70dbb241c1e3c2$var$selectionSizeTextStyles,
        "aria-hidden": true
    }, `${selectedCol} ${$2b70dbb241c1e3c2$var$MULTIPLICATION_SYMBOL} ${selectedRow}`));
};
const $2b70dbb241c1e3c2$var$_default_1 = (0, $kSwu1.injectIntl)($2b70dbb241c1e3c2$var$TableSelectorPopup);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2b70dbb241c1e3c2$export$2e2bcd8739ae039 = $2b70dbb241c1e3c2$var$_default_1;


const $f48065966ecdf5d8$var$TABLE_SELECTOR_PADDING_TOP = 8;
const $f48065966ecdf5d8$var$POPUP_OFFSET = [
    0,
    3
];
const $f48065966ecdf5d8$var$TABLE_SELECTOR_PADDING_SIDE = 10;
const $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS = 5;
const $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_COLS = 10;
const $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE = 1;
const $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS = 10;
const $f48065966ecdf5d8$var$TableSelectorWithListeners = (0, $9Muxb.default)((0, $2b70dbb241c1e3c2$export$2e2bcd8739ae039));
const $f48065966ecdf5d8$var$initialSizeState = {
    col: $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    row: $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    maxCol: $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_COLS,
    maxRow: $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS
};
const $f48065966ecdf5d8$var$tableSelectorPopupWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: "var(--ds-radius-small, 3px)",
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    padding: `${"var(--ds-space-100, 8px)"} ${$f48065966ecdf5d8$var$TABLE_SELECTOR_PADDING_SIDE}px`
});
const $f48065966ecdf5d8$export$4b4bd4d01ec9c7c9 = (props)=>{
    const [size, setSize] = (0, $cozmU.useState)({
        ...$f48065966ecdf5d8$var$initialSizeState,
        ...props.defaultSize
    });
    const tablePopupRef = (0, $cozmU.useRef)(null);
    // If popup opened by keyboard enable keyboard mode
    const isKeyboardMode = (0, $cozmU.useRef)(props.isOpenedByKeyboard);
    const enableKeyboardMode = (0, $cozmU.useCallback)(()=>{
        if (!isKeyboardMode.current) isKeyboardMode.current = true;
    }, [
        isKeyboardMode
    ]);
    const disableKeyboardMode = (0, $cozmU.useCallback)(()=>{
        if (isKeyboardMode.current) isKeyboardMode.current = false;
    }, [
        isKeyboardMode
    ]);
    // Mouse move is used to allow selection changes outside of the popup and is more reactive to changes.
    const handleMouseMove = (0, $cozmU.useCallback)((e)=>{
        if (!tablePopupRef.current) return;
        disableKeyboardMode();
        const tablePopup = tablePopupRef.current;
        const { left: left, top: top } = tablePopup.getBoundingClientRect();
        // Mouse position on popup
        const selectedWidth = e.clientX - left;
        const selectedHeight = e.clientY - top;
        // Calculate number grid cells selected
        let selectedGridCols = Math.ceil((selectedWidth - $f48065966ecdf5d8$var$TABLE_SELECTOR_PADDING_SIDE + (0, $2b70dbb241c1e3c2$export$fe015b05aaf05d59)) / ((0, $2b70dbb241c1e3c2$export$fe015b05aaf05d59) + (0, $2b70dbb241c1e3c2$export$80d6f86639b2335)));
        let selectedGridRows = Math.ceil((selectedHeight - $f48065966ecdf5d8$var$TABLE_SELECTOR_PADDING_TOP + (0, $2b70dbb241c1e3c2$export$fe015b05aaf05d59)) / ((0, $2b70dbb241c1e3c2$export$fe015b05aaf05d59) + (0, $2b70dbb241c1e3c2$export$80d6f86639b2335)));
        // Keep the selected rows and columns within the defined bounds
        let gridRows = $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS;
        if (selectedGridCols < 1) selectedGridCols = 1;
        if (selectedGridCols > size.maxCol) selectedGridCols = size.maxCol;
        if (selectedGridRows < 1) selectedGridRows = 1;
        // Expand grid when row selection is greater than the default grid size
        if (selectedGridRows >= $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS && selectedGridRows < $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) gridRows = selectedGridRows + 1;
        if (selectedGridRows >= $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) {
            selectedGridRows = $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
            gridRows = $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
        }
        if (selectedGridCols !== size.col || selectedGridRows !== size.row) setSize({
            col: selectedGridCols,
            row: selectedGridRows,
            maxCol: $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_COLS,
            maxRow: gridRows
        });
    }, [
        disableKeyboardMode,
        size,
        setSize
    ]);
    const decreasingSequence = (maxNumber, prevNumber)=>{
        let nextNumber = prevNumber - 1;
        if (prevNumber === 1) nextNumber = maxNumber;
        return nextNumber;
    };
    const getMaxRow = (prevSize, eventKey)=>{
        switch(eventKey){
            case 'ArrowDown':
                // Expand the grid size when last row selected
                if (prevSize.maxRow < $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.row >= $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS - 1) return prevSize.maxRow + 1;
                if (prevSize.row === $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) return $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS;
                return prevSize.maxRow;
            case 'ArrowLeft':
                const moveToPrevRow = prevSize.col === 1 && prevSize.row > 1;
                const moveToLastRow = prevSize.row === 1 && prevSize.col === 1;
                // Expand the popup to max size when selected row wraps around to last row
                if (moveToLastRow) return $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                // Decrease the popup when decreased row selection
                if (prevSize.maxRow > $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS && moveToPrevRow) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowUp':
                if (prevSize.row === 1) return $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                else if (prevSize.maxRow > $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowRight':
                const moveToNextRow = prevSize.col === $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_COLS;
                const increaseMaxRow = prevSize.maxRow < $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && moveToNextRow && prevSize.row + 1 === prevSize.maxRow;
                // Decrease popup size for wrap around to selection 1 x 1
                if (prevSize.row === $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.col === $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_COLS) return $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_ROWS;
                else if (increaseMaxRow) return prevSize.maxRow + 1;
                return prevSize.maxRow;
            default:
                return prevSize.maxRow;
        }
    };
    const handleInitialButtonFocus = (0, $cozmU.useCallback)(()=>{
        if (isKeyboardMode.current !== true) {
            enableKeyboardMode();
            setSize($f48065966ecdf5d8$var$initialSizeState);
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (event.key === 'ArrowDown') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                return {
                    ...prevSize,
                    row: prevSize.row % prevSize.maxRow + 1,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) event.preventDefault();
        }
        if (event.key === 'ArrowRight') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToNextRow = prevSize.col === $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_COLS;
                return {
                    ...prevSize,
                    col: prevSize.col % $f48065966ecdf5d8$var$DEFAULT_TABLE_SELECTOR_COLS + 1,
                    row: moveToNextRow ? prevSize.row % prevSize.maxRow + 1 : prevSize.row,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowLeft') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const getRow = (prevRow, prevCol)=>{
                    const row = prevRow;
                    // Move to previous row for wrap around
                    if (prevSize.col === 1 && prevSize.row > 1) return prevRow - 1;
                    else if (prevRow === 1 && prevCol === 1) return $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                    return row;
                };
                return {
                    ...prevSize,
                    col: decreasingSequence(prevSize.maxCol, prevSize.col),
                    row: getRow(prevSize.row, prevSize.col),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowUp') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToLastRow = prevSize.row === 1;
                return {
                    ...prevSize,
                    row: moveToLastRow ? $f48065966ecdf5d8$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS : decreasingSequence(prevSize.maxRow, prevSize.row),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) event.preventDefault();
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    (0, $cozmU.useEffect)(()=>{
        let unbind;
        const target = props.allowOutsideSelection ? window : tablePopupRef.current;
        if (target) unbind = (0, $cbY7C.bind)(target, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return unbind;
    }, [
        handleMouseMove,
        props.allowOutsideSelection,
        tablePopupRef
    ]);
    const offset = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $f48065966ecdf5d8$var$POPUP_OFFSET : [
        0,
        3
    ];
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        target: props.target,
        offset: offset,
        mountTo: props.popupsMountPoint,
        boundariesElement: props.popupsBoundariesElement,
        scrollableElement: props.popupsScrollableElement,
        focusTrap: true,
        onUnmount: props.onUnmount,
        zIndex: (0, $7Y8M5.akEditorMenuZIndex)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $f48065966ecdf5d8$var$tableSelectorPopupWrapperStyles,
        ref: tablePopupRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($f48065966ecdf5d8$var$TableSelectorWithListeners, {
        handleClickOutside: props.handleClickOutside,
        handleEscapeKeydown: props.handleEscapeKeydown,
        maxCols: size.maxCol,
        maxRows: size.maxRow,
        onSelection: props.onSelection,
        selectedCol: size.col,
        selectedRow: size.row,
        onKeyDown: handleKeyDown,
        isFocused: isKeyboardMode.current,
        handleInitialButtonFocus: handleInitialButtonFocus
    })));
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f48065966ecdf5d8$export$2e2bcd8739ae039 = $f48065966ecdf5d8$export$4b4bd4d01ec9c7c9;
module.exports["default"] = $f48065966ecdf5d8$export$2e2bcd8739ae039;

});

parcelRegister("fClPf", function(module, exports) {
const $61b06ca3337bd074$export$d5851c05c73d1974 = 6;
module.exports["MAX_INDENTATION_LEVEL"] = $61b06ca3337bd074$export$d5851c05c73d1974;

});

parcelRegister("1171P", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $6OREF = parcelRequire("6OREF");


var $1KOhB = parcelRequire("1KOhB");


var $iDrrr = parcelRequire("iDrrr");


var $fqVYq = parcelRequire("fqVYq");


var $fClPf = parcelRequire("fClPf");


var $32JQq = parcelRequire("32JQq");


var $bjg0G = parcelRequire("bjg0G");


var $anBbz = parcelRequire("anBbz");

function $8e86d01cf66bb079$export$3d562ab2ad3402f3(editorState, allowHeadingAndParagraphIndentation, taskDecisionState, indentationState, isInsideListItem) {
    const state = {
        indentDisabled: true,
        outdentDisabled: true,
        node: null
    };
    const { selection: selection } = editorState;
    // Handle bullet and numbered lists seperately as they do
    // not use the indentation mark.
    // Check for lists before paragraphs and headings in case
    // the selection is in a list nested in a layout column.
    if (isInsideListItem?.(editorState.tr)) {
        const { indentLevel: indentLevel, itemIndex: itemIndex } = (0, $32JQq.getListItemAttributes)(selection.$head);
        const isFlexibleListIndentationEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_flexible_list_indentation', 'isEnabled', true);
        return {
            // List indent levels are zero indexed so we need to subtract 1
            indentDisabled: !isFlexibleListIndentationEnabled && itemIndex === 0 || indentLevel >= (0, $fClPf.MAX_INDENTATION_LEVEL) - 1,
            outdentDisabled: false,
            node: 'list'
        };
    }
    // Handle tasks seperately as they do not use the indentation mark
    // and have different behaviour for outdent compared to lists
    if (taskDecisionState?.isInsideTask) return {
        indentDisabled: taskDecisionState.indentDisabled,
        outdentDisabled: taskDecisionState.outdentDisabled,
        node: 'taskList'
    };
    const isTopLevelParagraphOrHeading = selection.$from.depth === 1;
    const isInLayoutNode = (0, $bjg0G.hasParentNodeOfType)(editorState.schema.nodes.layoutColumn)(selection) && // depth of non-nested paragraphs and headings in layouts will always be 3
    selection.$from.depth === 3;
    if (allowHeadingAndParagraphIndentation && (indentationState?.isIndentationAllowed ?? false) && (isTopLevelParagraphOrHeading || isInLayoutNode) && indentationState?.indentDisabled !== undefined && indentationState?.outdentDisabled !== undefined) return {
        indentDisabled: indentationState.indentDisabled,
        outdentDisabled: indentationState.outdentDisabled,
        node: 'paragraph_heading'
    };
    return state;
}


var $458aeeea406ead1a$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");











const $9d2955ce5d046655$export$e9305b3bafad3ba4 = ()=>(0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_markdown_compatible_toolbar');


const $c12e51a95ce2beb8$export$602524aee99c280f = (pluginInjectionApi, indentationStateNode, inputMethod)=>({ buttonName: buttonName, editorView: editorView })=>{
        const isInSourceView = (0, $9d2955ce5d046655$export$e9305b3bafad3ba4)() && pluginInjectionApi?.markdownMode?.sharedState.currentState()?.view === 'syntax';
        switch(buttonName){
            case 'bullet_list':
                if (isInSourceView) {
                    pluginInjectionApi?.markdownMode?.actions.toggleSourceBulletList();
                    break;
                }
                pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.toggleBulletList(inputMethod));
                break;
            case 'ordered_list':
                if (isInSourceView) {
                    pluginInjectionApi?.markdownMode?.actions.toggleSourceOrderedList();
                    break;
                }
                pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.toggleOrderedList(inputMethod));
                break;
            case 'indent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') pluginInjectionApi?.indentation?.actions.indentParagraphOrHeading(inputMethod)(editorView.state, editorView.dispatch);
                    if (node === 'list') pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.indentList(inputMethod));
                    if (node === 'taskList') pluginInjectionApi?.taskDecision?.actions.indentTaskList(inputMethod)(editorView.state, editorView.dispatch);
                    break;
                }
            case 'outdent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') pluginInjectionApi?.indentation?.actions.outdentParagraphOrHeading(inputMethod)(editorView.state, editorView.dispatch);
                    if (node === 'list') pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.list?.commands.outdentList(inputMethod));
                    if (node === 'taskList') pluginInjectionApi?.taskDecision?.actions.outdentTaskList(inputMethod)(editorView.state, editorView.dispatch);
                    break;
                }
        }
    };


/* Toolbar.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $ldqjS = parcelRequire("ldqjS");


var $jexwB = parcelRequire("jexwB");

var $h4y3S = parcelRequire("h4y3S");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $85e4c8cd5cab4b2e$var$buttonGroupStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $85e4c8cd5cab4b2e$var$buttonGroupStyleUnbounded = null;
const $85e4c8cd5cab4b2e$export$89cfa2b8585c6d03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ToolbarButtonGroup(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT",
            "_1TptY7Q4SZ _42zk8BYbGa _0xQy2f1Y8M"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function ToolbarButtonGroup({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT",
            "_1TptY7Q4SZ _42zk8BYbGa _0xQy2f1Y8M"
        ]),
        children: children
    });
};


var $5aXzT = parcelRequire("5aXzT");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $3fO5l = parcelRequire("3fO5l");


var $fTKqO = parcelRequire("fTKqO");


var $3H27T = parcelRequire("3H27T");


var $gaHi2 = parcelRequire("gaHi2");

function $3b4688458df3e913$export$4c260019440d418f(props) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const indentButtonRef = (0, $cozmU.useRef)(null);
    const outdentButtonRef = (0, $cozmU.useRef)(null);
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const labelUnorderedList = formatMessage((0, $h4y3S.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $h4y3S.messages).orderedList);
    const labelListsFormat = formatMessage((0, $h4y3S.messages).listsFormat);
    const indentMessage = formatMessage((0, $jexwB.messages).indent);
    const outdentMessage = formatMessage((0, $jexwB.messages).outdent);
    const isIndentButtonFocused = document.activeElement === indentButtonRef.current;
    const isOutdentButtonFocused = document.activeElement === outdentButtonRef.current;
    const handleOnItemActivated = (buttonName)=>(event)=>onItemActivated({
                editorView: props.editorView,
                buttonName: buttonName
            });
    (0, $cozmU.useEffect)(()=>{
        if (isIndentButtonFocused && indentDisabled && outdentButtonRef.current) outdentButtonRef.current.focus();
    }, [
        indentButtonRef,
        indentDisabled,
        isIndentButtonFocused
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isOutdentButtonFocused && outdentDisabled && indentButtonRef.current) indentButtonRef.current.focus();
    }, [
        outdentButtonRef,
        outdentDisabled,
        isOutdentButtonFocused
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $85e4c8cd5cab4b2e$export$89cfa2b8585c6d03), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                role: "group",
                "aria-label": labelListsFormat,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
                        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).BULLET_LIST,
                        testId: labelUnorderedList,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('bullet_list'),
                        selected: bulletListActive,
                        "aria-pressed": bulletListActive,
                        "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.toggleBulletList), labelUnorderedList),
                        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleBulletList)),
                        disabled: bulletListDisabled || disabled,
                        title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                            description: labelUnorderedList,
                            keymap: (0, $ldqjS.toggleBulletList)
                        }),
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                            label: "",
                            color: "currentColor",
                            spacing: "spacious"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
                        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).ORDERED_LIST,
                        testId: labelOrderedList,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('ordered_list'),
                        selected: orderedListActive,
                        "aria-pressed": orderedListActive,
                        "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.toggleOrderedList), labelOrderedList),
                        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleOrderedList)),
                        disabled: orderedListDisabled || disabled,
                        title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                            description: labelOrderedList,
                            keymap: (0, $ldqjS.toggleOrderedList)
                        }),
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fTKqO))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        })
                    }),
                    showIndentationButtons && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
                        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).OUTDENT,
                        testId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).OUTDENT,
                        ref: outdentButtonRef,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('outdent'),
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3H27T))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        }),
                        disabled: outdentDisabled || disabled,
                        "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.outdent), outdentMessage),
                        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.outdent)),
                        title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                            description: outdentMessage,
                            keymap: (0, $ldqjS.outdent)
                        })
                    }),
                    showIndentationButtons && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
                        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).INDENT,
                        testId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).INDENT,
                        ref: indentButtonRef,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('indent'),
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gaHi2))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        }),
                        disabled: indentDisabled || disabled,
                        "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.indent), indentMessage),
                        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.indent)),
                        title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                            description: indentMessage,
                            keymap: (0, $ldqjS.indent)
                        })
                    })
                ]
            }),
            !pluginInjectionApi?.primaryToolbar && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5aXzT.ToolbarSeparator), {})
        ]
    });
}


/* ToolbarDropdown.tsx generated by @compiled/babel-plugin v2.0.0 */ 

















var $6keIx = parcelRequire("6keIx");

var $hYOVX = parcelRequire("hYOVX");

var $12XbP = parcelRequire("12XbP");

var $5ttHX = parcelRequire("5ttHX");




var $gLi18 = parcelRequire("gLi18");



















function $cdfcd733face8fc2$export$6dea40f2cdd197ea(props) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, orderedListActive: orderedListActive, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const [isDropdownOpen, setIsDropdownOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isOpenedByKeyboard, setOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const labelLists = formatMessage((0, $h4y3S.messages).lists); // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onOpenChange = (attrs)=>{
        setIsDropdownOpen(attrs.isDropdownOpen);
    };
    const handleTriggerClick = ()=>{
        onOpenChange({
            isDropdownOpen: !isDropdownOpen
        });
    };
    const handleOnKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setIsDropdownOpen(!isDropdownOpen);
            setOpenedByKeyboard(true);
        }
    };
    const items = $cdfcd733face8fc2$var$useItems(props);
    const handleOnItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        setIsDropdownOpen(!shouldCloseMenu);
        return onItemActivated({
            editorView: props.editorView,
            buttonName: item.value.name
        });
    };
    const reducedSpacing = props.toolbarType === (0, $458aeeea406ead1a$export$a5d11b3163e4b1a5).FLOATING ? 'compact' : 'none';
    let activeListIcon = null;
    let isSelected = isDropdownOpen;
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) activeListIcon = orderedListActive ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fTKqO))), {
        spacing: "spacious",
        label: ""
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
        spacing: "spacious",
        label: ""
    });
    else {
        activeListIcon = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
            color: "currentColor",
            spacing: "spacious",
            label: labelLists
        });
        isSelected = bulletListActive || orderedListActive || isDropdownOpen;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $12XbP.ToolbarDropdownWrapper), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gLi18.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onItemActivated: handleOnItemActivated,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                isOpen: isDropdownOpen,
                onOpenChange: onOpenChange,
                fitHeight: 188,
                fitWidth: 175,
                shouldUseDefaultRole: true,
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) setOpenedByKeyboard(false);
                    return isOpenedByKeyboard;
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
                    spacing: isReducedSpacing ? reducedSpacing : 'default',
                    selected: isSelected,
                    "aria-expanded": isDropdownOpen,
                    "aria-haspopup": true,
                    "aria-label": labelLists,
                    disabled: disabled,
                    onClick: handleTriggerClick,
                    onKeyDown: handleOnKeyDown,
                    title: labelLists,
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hYOVX.ToolbarDropdownTriggerWrapper), {
                        children: [
                            activeListIcon,
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5ttHX.ToolbarExpandIcon), {})
                        ]
                    })
                })
            }),
            !pluginInjectionApi?.primaryToolbar && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5aXzT.ToolbarSeparator), {})
        ]
    });
}
function $cdfcd733face8fc2$var$useItems(props) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelUnorderedList = formatMessage((0, $h4y3S.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $h4y3S.messages).orderedList);
    const items = [
        {
            key: 'unorderedList',
            content: labelUnorderedList,
            value: {
                name: 'bullet_list'
            },
            isDisabled: props.bulletListDisabled,
            isActive: Boolean(props.bulletListActive),
            elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                children: (0, $ldqjS.tooltip)((0, $ldqjS.toggleBulletList))
            }),
            elemBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                label: ""
            }) : undefined
        },
        {
            key: 'orderedList',
            content: labelOrderedList,
            value: {
                name: 'ordered_list'
            },
            isDisabled: props.orderedListDisabled,
            isActive: Boolean(props.orderedListActive),
            elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                children: (0, $ldqjS.tooltip)((0, $ldqjS.toggleOrderedList))
            }),
            elemBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fTKqO))), {
                label: ""
            }) : undefined
        }
    ];
    if (props.showIndentationButtons) {
        const labelIndent = formatMessage((0, $jexwB.messages).indent);
        const labelOutdent = formatMessage((0, $jexwB.messages).outdent);
        items.push({
            key: 'outdent',
            content: labelOutdent,
            value: {
                name: 'outdent'
            },
            isDisabled: props.outdentDisabled,
            isActive: false,
            elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                children: (0, $ldqjS.tooltip)((0, $ldqjS.outdent))
            }),
            elemBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3H27T))), {
                label: ""
            }) : undefined
        }, {
            key: 'indent',
            content: labelIndent,
            value: {
                name: 'indent'
            },
            isDisabled: props.indentDisabled,
            isActive: false,
            elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                children: (0, $ldqjS.tooltip)((0, $ldqjS.indent))
            }),
            elemBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gaHi2))), {
                label: ""
            }) : undefined
        });
    }
    return [
        {
            items: items
        }
    ];
}






const $2a60f385887eff99$var$toolbarTypeToInputMethod = {
    [(0, $458aeeea406ead1a$export$a5d11b3163e4b1a5).PRIMARY]: (0, $krYZG.INPUT_METHOD).TOOLBAR,
    [(0, $458aeeea406ead1a$export$a5d11b3163e4b1a5).FLOATING]: (0, $krYZG.INPUT_METHOD).FLOATING_TB
};
const $2a60f385887eff99$export$8213a6fbfa466e73 = (toolbarType)=>$2a60f385887eff99$var$toolbarTypeToInputMethod[toolbarType];


function $5a039d716845865d$export$2e2bcd8739ae039(props) {
    const { disabled: disabled, isSmall: isSmall, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, indentationStateNode: indentationStateNode, featureFlags: featureFlags, pluginInjectionApi: pluginInjectionApi, toolbarType: toolbarType } = props;
    const inputMethod = toolbarType ? (0, $2a60f385887eff99$export$8213a6fbfa466e73)(toolbarType) : (0, $krYZG.INPUT_METHOD).TOOLBAR;
    if (isSmall || toolbarType === (0, $458aeeea406ead1a$export$a5d11b3163e4b1a5).FLOATING || (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
        const areAllOptionsDisabled = [
            bulletListDisabled,
            orderedListDisabled,
            indentDisabled,
            outdentDisabled
        ].every((item)=>Boolean(item) === true);
        const isDisabled = disabled || areAllOptionsDisabled;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cdfcd733face8fc2$export$6dea40f2cdd197ea), {
            editorView: props.editorView,
            isReducedSpacing: isReducedSpacing,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            bulletListActive: bulletListActive,
            bulletListDisabled: bulletListDisabled,
            showIndentationButtons: showIndentationButtons,
            orderedListActive: orderedListActive,
            orderedListDisabled: orderedListDisabled,
            indentDisabled: indentDisabled,
            outdentDisabled: outdentDisabled,
            disabled: isDisabled,
            onItemActivated: (0, $c12e51a95ce2beb8$export$602524aee99c280f)(pluginInjectionApi, indentationStateNode, inputMethod),
            featureFlags: featureFlags,
            pluginInjectionApi: pluginInjectionApi,
            toolbarType: toolbarType
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3b4688458df3e913$export$4c260019440d418f), {
        editorView: props.editorView,
        isReducedSpacing: isReducedSpacing,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        showIndentationButtons: showIndentationButtons,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled,
        disabled: disabled,
        onItemActivated: (0, $c12e51a95ce2beb8$export$602524aee99c280f)(pluginInjectionApi, indentationStateNode, inputMethod),
        featureFlags: featureFlags,
        pluginInjectionApi: pluginInjectionApi
    });
}




















const $75f00297b2d22949$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true,
    isSmall: true
};
function $75f00297b2d22949$export$b15abb95157a91c7({ featureFlags: featureFlags, editorView: editorView, showIndentationButtons: showIndentationButtons, pluginInjectionApi: pluginInjectionApi, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation }) {
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'list',
        'indentation'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListActive: states.listState?.orderedListActive,
            orderedListDisabled: states.listState?.orderedListDisabled,
            isIndentationAllowed: states.indentationState?.isIndentationAllowed,
            indentDisabled: states.indentationState?.indentDisabled,
            outdentDisabled: states.indentationState?.outdentDisabled,
            // decorationSet is required to re-render PrimaryToolbarComponent component, so that the toolbar states updates regularly
            decorationSet: states.listState?.decorationSet
        }));
    const [taskDecisionState, setTaskDecisionState] = (0, $cozmU.useState)();
    (0, $1KOhB.usePluginStateEffect)(pluginInjectionApi, [
        'taskDecision'
    ], ({ taskDecisionState: newTaskDecisionState })=>{
        if (newTaskDecisionState?.outdentDisabled !== taskDecisionState?.outdentDisabled || newTaskDecisionState?.indentDisabled !== taskDecisionState?.indentDisabled || newTaskDecisionState?.isInsideTask !== taskDecisionState?.isInsideTask) setTaskDecisionState({
            isInsideTask: Boolean(newTaskDecisionState?.isInsideTask),
            indentDisabled: Boolean(newTaskDecisionState?.indentDisabled),
            outdentDisabled: Boolean(newTaskDecisionState?.outdentDisabled)
        });
    });
    const toolbarListsIndentationState = (0, $8e86d01cf66bb079$export$3d562ab2ad3402f3)(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, pluginInjectionApi?.list?.actions.isInsideListItem);
    if (bulletListActive === undefined || bulletListDisabled === undefined || orderedListActive === undefined || orderedListDisabled === undefined) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5a039d716845865d$export$2e2bcd8739ae039), {
        featureFlags: featureFlags,
        isSmall: $75f00297b2d22949$var$FloatingToolbarSettings.isSmall,
        isReducedSpacing: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? false : $75f00297b2d22949$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        disabled: $75f00297b2d22949$var$FloatingToolbarSettings.disabled,
        editorView: editorView,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        showIndentationButtons: !!showIndentationButtons,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        indentDisabled: toolbarListsIndentationState.indentDisabled,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        outdentDisabled: toolbarListsIndentationState.outdentDisabled,
        indentationStateNode: toolbarListsIndentationState?.node,
        pluginInjectionApi: pluginInjectionApi,
        toolbarType: (0, $458aeeea406ead1a$export$a5d11b3163e4b1a5).FLOATING
    });
}





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");

var $bFSJa = parcelRequire("bFSJa");


var $7T88d = parcelRequire("7T88d");

var $5AKbu = parcelRequire("5AKbu");




parcelRequire("cozmU");







var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");




parcelRequire("cozmU");














var $is7KY = parcelRequire("is7KY");




var $dVKvM = parcelRequire("dVKvM");

var $i9j2V = parcelRequire("i9j2V");


const $33b581386ae978d8$export$7d7b92fab7b2082a = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const bulletMessage = formatMessage((0, $h4y3S.messages).bulletedList);
    const isMarkdownToolbarEnabled = (0, $9d2955ce5d046655$export$e9305b3bafad3ba4)();
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, taskListActive: taskListActive, sourceBlockFormatState: sourceBlockFormatState, sourceListFormatState: sourceListFormatState, markdownView: markdownView } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision',
        'markdownMode'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            taskListActive: states.taskDecisionState?.isInsideTask,
            markdownView: isMarkdownToolbarEnabled ? states.markdownModeState?.view : undefined,
            sourceBlockFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceBlockFormatState : null,
            sourceListFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceListFormatState : null
        }));
    const isInSourceView = isMarkdownToolbarEnabled && markdownView === 'syntax';
    const isSourceTaskListActive = Boolean(sourceListFormatState?.inTaskList);
    const isDisabled = isInSourceView ? Boolean(sourceBlockFormatState?.inCodeBlock || isSourceTaskListActive) : bulletListDisabled && !taskListActive;
    const onClick = ()=>{
        if (isInSourceView) {
            if (sourceBlockFormatState?.inCodeBlock) return;
            if (isSourceTaskListActive) return;
            api?.markdownMode?.actions.toggleSourceBulletList();
            return;
        }
        api?.core.actions.execute(taskListActive ? api?.taskDecision?.commands.toggleTaskList('bulletList') : api?.list.commands.toggleBulletList((0, $is7KY.getInputMethodFromParentKeys)(parents)));
    };
    const shortcut = (0, $ldqjS.formatShortcut)((0, $ldqjS.toggleBulletList));
    return {
        bulletMessage: bulletMessage,
        onClick: onClick,
        isDisabled: isDisabled,
        isSelected: isInSourceView ? sourceListFormatState?.inBulletList : bulletListActive,
        shortcut: shortcut
    };
};
const $33b581386ae978d8$export$13c3f4610578d225 = ({ api: api, parents: parents })=>{
    const { bulletMessage: bulletMessage, onClick: onClick, isDisabled: isDisabled, isSelected: isSelected, shortcut: shortcut } = $33b581386ae978d8$export$7d7b92fab7b2082a({
        api: api,
        parents: parents
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isSelected: isSelected,
        isDisabled: isDisabled,
        onClick: onClick,
        ariaKeyshortcuts: shortcut,
        children: bulletMessage
    });
};


const $a998beaa633010f0$export$40c1053c0d024043 = ({ api: api, parents: parents })=>{
    const { bulletMessage: bulletMessage, onClick: onClick, isDisabled: isDisabled, isSelected: isSelected } = (0, $33b581386ae978d8$export$7d7b92fab7b2082a)({
        api: api,
        parents: parents
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: bulletMessage,
            keymap: (0, $ldqjS.toggleBulletList)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                size: "small",
                label: ""
            }),
            onClick: onClick,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleBulletList)),
            label: bulletMessage
        })
    });
};


const $7daef22a7c492711$var$BulletedListButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $7daef22a7c492711$export$eeaae60d77808105 = (api)=>{
    return [
        {
            type: (0, $3nacY.BULLETED_LIST_BUTTON_GROUP).type,
            key: (0, $3nacY.BULLETED_LIST_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.BULLETED_LIST_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($7daef22a7c492711$var$BulletedListButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.BULLETED_LIST_BUTTON).type,
            key: (0, $3nacY.BULLETED_LIST_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.BULLETED_LIST_BUTTON_GROUP).type,
                    key: (0, $3nacY.BULLETED_LIST_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $a998beaa633010f0$export$40c1053c0d024043), {
                    api: api,
                    parents: parents
                })
        }
    ];
};







const $4757a3eb5de96d88$export$ba625abe9e2ccf66 = ()=>{
    return [
        {
            type: (0, $3nacY.LISTS_INDENTATION_GROUP_INLINE).type,
            key: (0, $3nacY.LISTS_INDENTATION_GROUP_INLINE).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION).type,
                    key: (0, $3nacY.TEXT_SECTION).key,
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.LISTS_INDENTATION_GROUP).key]
                }
            ]
        }
    ];
};





parcelRequire("cozmU");













const $99b886ddb92191e4$var$ListsIndentationGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $99b886ddb92191e4$var$ListsIndentationGroupCollapsed = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7T88d.Show), {
        below: "xl",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
            children: children
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5AKbu.ToolbarButtonGroup), {
        children: children
    });
};
const $99b886ddb92191e4$export$559bcfe9bd160d2a = ()=>{
    return [
        {
            type: (0, $3nacY.LISTS_INDENTATION_GROUP).type,
            key: (0, $3nacY.LISTS_INDENTATION_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.LISTS_INDENTATION_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($99b886ddb92191e4$var$ListsIndentationGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.LISTS_INDENTATION_GROUP_COLLAPSED).type,
            key: (0, $3nacY.LISTS_INDENTATION_GROUP_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.LISTS_INDENTATION_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($99b886ddb92191e4$var$ListsIndentationGroupCollapsed, {
                    children: children
                });
            }
        }
    ];
};





parcelRequire("cozmU");









parcelRequire("cozmU");













var $hdn7b = parcelRequire("hdn7b");














var $iAaYd = parcelRequire("iAaYd");


var $ieeJu = parcelRequire("ieeJu");


function $6c03ae545d8975a0$var$useListsIndentationHeroButtonInfo({ api: api, parents: parents, defaultListType: defaultListType }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isMarkdownToolbarEnabled = (0, $9d2955ce5d046655$export$e9305b3bafad3ba4)();
    const { pmBulletListActive: pmBulletListActive, pmBulletListDisabled: pmBulletListDisabled, pmOrderedListActive: pmOrderedListActive, pmTaskListActive: pmTaskListActive, sourceBlockFormatState: sourceBlockFormatState, sourceListFormatState: sourceListFormatState, markdownView: markdownView } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision',
        'interaction',
        'markdownMode'
    ], (states)=>{
        const useDefaultToolbarState = states.interactionState?.interactionState === 'hasNotHadInteraction' && (0, $ieeJu.expValEquals)('platform_editor_default_toolbar_state', 'isEnabled', true);
        return {
            pmBulletListActive: useDefaultToolbarState ? false : states.listState?.bulletListActive,
            pmBulletListDisabled: states.listState?.bulletListDisabled,
            pmOrderedListActive: useDefaultToolbarState ? false : states.listState?.orderedListActive,
            pmTaskListActive: useDefaultToolbarState ? false : states.taskDecisionState?.isInsideTask,
            markdownView: isMarkdownToolbarEnabled ? states.markdownModeState?.view : undefined,
            sourceBlockFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceBlockFormatState : null,
            sourceListFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceListFormatState : null
        };
    });
    const isInSourceView = isMarkdownToolbarEnabled && markdownView === 'syntax';
    const isBulletListActive = isInSourceView ? sourceListFormatState?.inBulletList : pmBulletListActive;
    const isOrderedListActive = isInSourceView ? sourceListFormatState?.inOrderedList : pmOrderedListActive;
    const taskListActive = isInSourceView ? Boolean(sourceListFormatState?.inTaskList) : pmTaskListActive;
    const getListType = taskListActive ? 'taskList' : isOrderedListActive ? 'orderedList' : defaultListType;
    const taskListKeymap = (0, $ldqjS.toggleTaskList);
    const getKeymap = getListType === 'taskList' ? taskListKeymap : getListType === 'orderedList' ? (0, $ldqjS.toggleOrderedList) : (0, $ldqjS.toggleBulletList);
    const shortcut = (0, $ldqjS.formatShortcut)(getKeymap);
    const keymap = getKeymap;
    const message = getListType === 'taskList' ? formatMessage((0, $hdn7b.tasksAndDecisionsMessages).taskList) : getListType === 'orderedList' ? formatMessage((0, $h4y3S.messages).orderedList) : formatMessage((0, $h4y3S.messages).bulletedList);
    const onClick = ()=>{
        const inputMethod = (0, $is7KY.getInputMethodFromParentKeys)(parents);
        if (isInSourceView) {
            if (sourceBlockFormatState?.inCodeBlock || getListType === 'taskList') return;
            if (getListType === 'orderedList') api?.markdownMode?.actions.toggleSourceOrderedList();
            else api?.markdownMode?.actions.toggleSourceBulletList();
            return;
        }
        if (getListType === 'taskList') api?.core.actions.execute(api?.taskDecision?.commands.toggleTaskList());
        else if (getListType === 'orderedList') api?.core.actions.execute(api?.list.commands.toggleOrderedList(inputMethod));
        else api?.core.actions.execute(api?.list.commands.toggleBulletList(inputMethod));
    };
    const iconBefore = getListType === 'taskList' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))), {
        label: formatMessage((0, $hdn7b.tasksAndDecisionsMessages).taskList),
        size: "small"
    }) : getListType === 'orderedList' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fTKqO))), {
        label: formatMessage((0, $h4y3S.messages).orderedList),
        size: "small"
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
        label: formatMessage((0, $h4y3S.messages).bulletedList),
        size: "small"
    });
    const isSelected = getListType === 'bulletList' ? isBulletListActive : getListType === 'orderedList' ? isOrderedListActive : taskListActive;
    const isDisabled = isInSourceView ? Boolean(sourceBlockFormatState?.inCodeBlock || taskListActive) : !isOrderedListActive && !taskListActive && pmBulletListDisabled;
    return {
        shortcut: shortcut,
        keymap: keymap,
        message: message,
        onClick: onClick,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled
    };
}
const $6c03ae545d8975a0$export$64aac13cbedfda18 = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, keymap: keymap, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $6c03ae545d8975a0$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'bulletList'
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: message,
            keymap: keymap
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};
const $6c03ae545d8975a0$export$ac280cc0a77a657a = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, keymap: keymap, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $6c03ae545d8975a0$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'orderedList'
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: message,
            keymap: keymap
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};
const $6c03ae545d8975a0$export$a7640af50de0f233 = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $6c03ae545d8975a0$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'bulletList'
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};


const $46720ed06d3ef93e$export$b917037285a1e87b = (api)=>{
    return [
        {
            type: (0, $3nacY.LISTS_INDENTATION_HERO_BUTTON).type,
            key: (0, $3nacY.LISTS_INDENTATION_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_GROUP).type,
                    key: (0, $3nacY.LISTS_INDENTATION_GROUP).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_GROUP_RANK)[(0, $3nacY.LISTS_INDENTATION_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6c03ae545d8975a0$export$ac280cc0a77a657a), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).type,
            key: (0, $3nacY.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_GROUP_COLLAPSED).type,
                    key: (0, $3nacY.LISTS_INDENTATION_GROUP_COLLAPSED).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3nacY.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]
                },
                {
                    type: (0, $3nacY.LISTS_INDENTATION_GROUP_INLINE).type,
                    key: (0, $3nacY.LISTS_INDENTATION_GROUP_INLINE).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3nacY.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6c03ae545d8975a0$export$64aac13cbedfda18), {
                    api: api,
                    parents: parents
                })
        }
    ];
};





parcelRequire("cozmU");










parcelRequire("cozmU");


























const $9aa3ba2efd6c043f$export$738f7a376e7e29b3 = ({ api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, state: state })=>{
    const { isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'indentation'
    ], (states)=>({
            isIndentationAllowed: states.indentationState?.isIndentationAllowed,
            outdentDisabled: states.indentationState?.outdentDisabled,
            indentDisabled: states.indentationState?.indentDisabled
        }));
    const { isInsideTask: isInsideTask, indentDisabled: taskIndentDisabled, outdentDisabled: taskOutdentDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'taskDecision'
    ], (states)=>({
            isInsideTask: states.taskDecisionState?.isInsideTask,
            outdentDisabled: states.taskDecisionState?.outdentDisabled,
            indentDisabled: states.taskDecisionState?.indentDisabled
        }));
    if (!state) return undefined;
    return (0, $8e86d01cf66bb079$export$3d562ab2ad3402f3)(state, allowHeadingAndParagraphIndentation, {
        isInsideTask: isInsideTask ?? false,
        indentDisabled: taskIndentDisabled ?? false,
        outdentDisabled: taskOutdentDisabled ?? false
    }, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, api?.list.actions.isInsideListItem);
};


const $bc4684f34950601f$export$fdc3a713c0f7f7e = ({ api: api, showIndentationButtons: showIndentationButtons, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const indentationState = (0, $9aa3ba2efd6c043f$export$738f7a376e7e29b3)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView?.state
    });
    if (!showIndentationButtons) return null;
    const onClick = ()=>{
        const inputMethod = (0, $is7KY.getInputMethodFromParentKeys)(parents);
        const node = indentationState?.node;
        if (node === 'paragraph_heading') {
            if (editorView?.state) api?.indentation?.actions.indentParagraphOrHeading(inputMethod)(editorView?.state, editorView?.dispatch);
        }
        if (node === 'list') api?.core?.actions.execute(api?.list?.commands.indentList(inputMethod));
        if (node === 'taskList') {
            if (editorView?.state) api?.taskDecision?.actions.indentTaskList(inputMethod)(editorView?.state, editorView?.dispatch);
        }
    };
    const shortcut = (0, $ldqjS.formatShortcut)((0, $ldqjS.indent));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gaHi2))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isDisabled: indentationState?.indentDisabled,
        ariaKeyshortcuts: shortcut,
        onClick: onClick,
        children: formatMessage((0, $jexwB.messages).indent)
    });
};





parcelRequire("cozmU");







// Common Translations will live here



const $813729644423be31$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unorderedList: {
        id: "fabric.editor.unorderedList",
        defaultMessage: "Bullet list"
    },
    unorderedListDescription: {
        id: "fabric.editor.unorderedList.description",
        defaultMessage: "Create an unordered list"
    },
    orderedList: {
        id: "fabric.editor.orderedList",
        defaultMessage: "Numbered list"
    },
    orderedListDescription: {
        id: "fabric.editor.orderedList.description",
        defaultMessage: "Create an ordered list"
    },
    lists: {
        id: "fabric.editor.lists",
        defaultMessage: "Lists"
    }
});






var $8px0e = parcelRequire("8px0e");

var $a6nzD = parcelRequire("a6nzD");





const $6fb0e3d8d7b68518$export$4f71a14292bb825f = ({ children: children, api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const indentationState = (0, $9aa3ba2efd6c043f$export$738f7a376e7e29b3)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView?.state
    });
    const isMarkdownToolbarEnabled = (0, $9d2955ce5d046655$export$e9305b3bafad3ba4)();
    const { bulletListDisabled: bulletListDisabled, orderedListDisabled: orderedListDisabled, taskListActive: taskListActive, markdownView: markdownView } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision',
        'markdownMode'
    ], (states)=>({
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListDisabled: states.listState?.orderedListDisabled,
            taskListActive: states.taskDecisionState?.isInsideTask,
            markdownView: isMarkdownToolbarEnabled ? states.markdownModeState?.view : undefined
        }));
    const isInSourceView = isMarkdownToolbarEnabled && markdownView === 'syntax';
    const allItemsDisabled = !isInSourceView && bulletListDisabled && orderedListDisabled && indentationState?.indentDisabled && indentationState?.outdentDisabled && !taskListActive;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8px0e.MoreItemsIcon), {
            label: formatMessage((0, $813729644423be31$export$defe85febe8b728c).lists)
        }),
        isDisabled: allItemsDisabled,
        testId: "editor-toolbar__lists-and-indentation-menu",
        label: formatMessage((0, $813729644423be31$export$defe85febe8b728c).lists),
        tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: formatMessage((0, $813729644423be31$export$defe85febe8b728c).lists)
        }),
        children: children
    });
};





parcelRequire("cozmU");





var $jgJIe = parcelRequire("jgJIe");

const $3d86b000e1a70a86$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3nacY.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};





parcelRequire("cozmU");
























const $636477302d864ac8$export$248224347373862f = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isMarkdownToolbarEnabled = (0, $9d2955ce5d046655$export$e9305b3bafad3ba4)();
    const { orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, taskListActive: taskListActive, sourceBlockFormatState: sourceBlockFormatState, sourceListFormatState: sourceListFormatState, markdownView: markdownView } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision',
        'markdownMode'
    ], (states)=>({
            orderedListActive: states.listState?.orderedListActive,
            orderedListDisabled: states.listState?.orderedListDisabled,
            taskListActive: states.taskDecisionState?.isInsideTask,
            markdownView: isMarkdownToolbarEnabled ? states.markdownModeState?.view : undefined,
            sourceBlockFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceBlockFormatState : null,
            sourceListFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceListFormatState : null
        }));
    const isInSourceView = isMarkdownToolbarEnabled && markdownView === 'syntax';
    const isSourceTaskListActive = Boolean(sourceListFormatState?.inTaskList);
    const onClick = ()=>{
        if (isInSourceView) {
            if (sourceBlockFormatState?.inCodeBlock) return;
            if (isSourceTaskListActive) return;
            api?.markdownMode?.actions.toggleSourceOrderedList();
            return;
        }
        api?.core.actions.execute(taskListActive ? api?.taskDecision?.commands.toggleTaskList('orderedList') : api?.list.commands.toggleOrderedList((0, $is7KY.getInputMethodFromParentKeys)(parents)));
    };
    const shortcut = (0, $ldqjS.formatShortcut)((0, $ldqjS.toggleOrderedList));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fTKqO))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isSelected: isInSourceView ? sourceListFormatState?.inOrderedList : orderedListActive,
        isDisabled: isInSourceView ? Boolean(sourceBlockFormatState?.inCodeBlock || isSourceTaskListActive) : orderedListDisabled && !taskListActive,
        onClick: onClick,
        ariaKeyshortcuts: shortcut,
        children: formatMessage((0, $h4y3S.messages).orderedList)
    });
};





parcelRequire("cozmU");























const $f50c0d35d7937f1f$export$549a24252ad8d94 = ({ api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, showIndentationButtons: showIndentationButtons, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const indentationState = (0, $9aa3ba2efd6c043f$export$738f7a376e7e29b3)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView?.state
    });
    if (!showIndentationButtons) return null;
    const onClick = ()=>{
        const inputMethod = (0, $is7KY.getInputMethodFromParentKeys)(parents);
        const node = indentationState?.node;
        if (node === 'paragraph_heading') {
            if (editorView?.state) api?.indentation?.actions.outdentParagraphOrHeading(inputMethod)(editorView?.state, editorView?.dispatch);
        }
        if (node === 'list') api?.core.actions.execute(api?.list.commands.outdentList(inputMethod));
        if (node === 'taskList') {
            if (editorView?.state) api?.taskDecision?.actions.outdentTaskList(inputMethod)(editorView?.state, editorView?.dispatch);
        }
    };
    const shortcut = (0, $ldqjS.formatShortcut)((0, $ldqjS.outdent));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3H27T))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isDisabled: indentationState?.outdentDisabled,
        ariaKeyshortcuts: shortcut,
        onClick: onClick,
        children: formatMessage((0, $jexwB.messages).outdent)
    });
};


const $806dd6458ac051c4$export$9c70fcf7cde6c956 = (allowHeadingAndParagraphIndentation, showIndentationButtons, api)=>{
    return [
        {
            type: (0, $3nacY.LISTS_INDENTATION_MENU).type,
            key: (0, $3nacY.LISTS_INDENTATION_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_GROUP).type,
                    key: (0, $3nacY.LISTS_INDENTATION_GROUP).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_GROUP_RANK)[(0, $3nacY.LISTS_INDENTATION_MENU).key]
                },
                {
                    type: (0, $3nacY.LISTS_INDENTATION_GROUP_COLLAPSED).type,
                    key: (0, $3nacY.LISTS_INDENTATION_GROUP_COLLAPSED).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3nacY.LISTS_INDENTATION_MENU).key]
                },
                {
                    type: (0, $3nacY.LISTS_INDENTATION_GROUP_INLINE).type,
                    key: (0, $3nacY.LISTS_INDENTATION_GROUP_INLINE).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $3nacY.LISTS_INDENTATION_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6fb0e3d8d7b68518$export$4f71a14292bb825f), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    children: children
                })
        },
        {
            type: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).type,
            key: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_MENU).type,
                    key: (0, $3nacY.LISTS_INDENTATION_MENU).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_MENU_RANK)[(0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key]
                },
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $hVLmg.TEXT_COLLAPSED_MENU_RANK)[(0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key]
                }
            ],
            component: (0, $3d86b000e1a70a86$export$4b1545b4f2016d26)
        },
        {
            type: (0, $3nacY.BULLETED_LIST_MENU_ITEM).type,
            key: (0, $3nacY.BULLETED_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3nacY.BULLETED_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $33b581386ae978d8$export$13c3f4610578d225), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.NUMBERED_LIST_MENU_ITEM).type,
            key: (0, $3nacY.NUMBERED_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3nacY.NUMBERED_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $636477302d864ac8$export$248224347373862f), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.OUTDENT_MENU_ITEM).type,
            key: (0, $3nacY.OUTDENT_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3nacY.OUTDENT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f50c0d35d7937f1f$export$549a24252ad8d94), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    showIndentationButtons: showIndentationButtons,
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.INDENT_MENU_ITEM).type,
            key: (0, $3nacY.INDENT_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3nacY.INDENT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $bc4684f34950601f$export$fdc3a713c0f7f7e), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    showIndentationButtons: showIndentationButtons,
                    parents: parents
                })
        }
    ];
};


const $523c90b836bc0ea7$export$a758406ca53b86a5 = ({ api: api, showIndentationButtons: showIndentationButtons, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation })=>{
    return [
        ...(0, $99b886ddb92191e4$export$559bcfe9bd160d2a)(),
        ...(0, $4757a3eb5de96d88$export$ba625abe9e2ccf66)(),
        ...(0, $46720ed06d3ef93e$export$b917037285a1e87b)(api),
        ...(0, $7daef22a7c492711$export$eeaae60d77808105)(api),
        ...(0, $806dd6458ac051c4$export$9c70fcf7cde6c956)(allowHeadingAndParagraphIndentation, showIndentationButtons, api)
    ];
};


const $320ae48a93aaaaaf$export$fdc8ab6a3979a865 = ({ config: config, api: api })=>{
    const { showIndentationButtons: showIndentationButtons = false, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation = false } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)($320ae48a93aaaaaf$export$94516d5cccf573e3, {
            featureFlags: featureFlags,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isSmall: toolbarSize < (0, $6OREF.ToolbarSize).L,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            showIndentationButtons: showIndentationButtons,
            pluginInjectionApi: api,
            allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $523c90b836bc0ea7$export$a758406ca53b86a5)({
        api: api,
        showIndentationButtons: showIndentationButtons,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
    }));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'toolbarListsIndentation',
        component: primaryToolbarComponent
    });
    return {
        name: 'toolbarListsIndentation',
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar () {
                    const toolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view)=>{
                                if (!view) return;
                                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $75f00297b2d22949$export$b15abb95157a91c7), {
                                    editorView: view,
                                    featureFlags: featureFlags,
                                    pluginInjectionApi: api,
                                    showIndentationButtons: showIndentationButtons,
                                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
                                });
                            },
                            fallback: []
                        };
                        return {
                            rank: 3,
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ],
                            pluginName: 'toolbarListsIndentation'
                        };
                    } else return undefined;
                }
            }
        },
        primaryToolbarComponent: !isToolbarAIFCEnabled && !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
function $320ae48a93aaaaaf$export$94516d5cccf573e3({ featureFlags: featureFlags, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, editorView: editorView, showIndentationButtons: showIndentationButtons, pluginInjectionApi: pluginInjectionApi, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation }) {
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'list',
        'indentation'
    ], (states)=>({
            bulletListActive: states.listState?.bulletListActive,
            bulletListDisabled: states.listState?.bulletListDisabled,
            orderedListActive: states.listState?.orderedListActive,
            orderedListDisabled: states.listState?.orderedListDisabled,
            isIndentationAllowed: states.indentationState?.isIndentationAllowed,
            indentDisabled: states.indentationState?.indentDisabled,
            outdentDisabled: states.indentationState?.outdentDisabled,
            // decorationSet is required to re-render PrimaryToolbarComponent component, so that the toolbar states updates regularly
            decorationSet: states.listState?.decorationSet
        }));
    const [taskDecisionState, setTaskDecisionState] = (0, $cozmU.useState)();
    (0, $1KOhB.usePluginStateEffect)(pluginInjectionApi, [
        'taskDecision'
    ], ({ taskDecisionState: newTaskDecisionState })=>{
        if (newTaskDecisionState?.outdentDisabled !== taskDecisionState?.outdentDisabled || newTaskDecisionState?.indentDisabled !== taskDecisionState?.indentDisabled || newTaskDecisionState?.isInsideTask !== taskDecisionState?.isInsideTask) setTaskDecisionState({
            isInsideTask: Boolean(newTaskDecisionState?.isInsideTask),
            indentDisabled: Boolean(newTaskDecisionState?.indentDisabled),
            outdentDisabled: Boolean(newTaskDecisionState?.outdentDisabled)
        });
    });
    const toolbarListsIndentationState = (0, $8e86d01cf66bb079$export$3d562ab2ad3402f3)(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, pluginInjectionApi?.list?.actions.isInsideListItem);
    if (bulletListActive === undefined || bulletListDisabled === undefined || orderedListActive === undefined || orderedListDisabled === undefined) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5a039d716845865d$export$2e2bcd8739ae039), {
        featureFlags: featureFlags,
        isSmall: isSmall,
        isReducedSpacing: isToolbarReducedSpacing,
        disabled: disabled,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        showIndentationButtons: !!showIndentationButtons,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        indentDisabled: toolbarListsIndentationState.indentDisabled,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        outdentDisabled: toolbarListsIndentationState.outdentDisabled,
        indentationStateNode: toolbarListsIndentationState?.node,
        pluginInjectionApi: pluginInjectionApi,
        toolbarType: (0, $458aeeea406ead1a$export$a5d11b3163e4b1a5).PRIMARY
    });
}
module.exports["toolbarListsIndentationPlugin"] = $320ae48a93aaaaaf$export$fdc8ab6a3979a865;

});

parcelRegister("hYOVX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $987118a570d04aaf$var$triggerWrapperStylesWithPadding = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $987118a570d04aaf$var$triggerWrapperStylesUnbounded = null;
const $987118a570d04aaf$export$bddd4c3563999c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ToolbarDropdownTriggerWrapper(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1ZnuxbFQfX",
            "_3qgovSYbGa"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function ToolbarDropdownTriggerWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1ZnuxbFQfX",
            "_3qgovSYbGa"
        ]),
        children: children
    });
};
module.exports["ToolbarDropdownTriggerWrapper"] = $987118a570d04aaf$export$bddd4c3563999c;

});

parcelRegister("12XbP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $69e4cb0a35c87667$var$wrapperStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $69e4cb0a35c87667$var$wrapperStylesUnbounded = null;
const $69e4cb0a35c87667$export$b4f55ae464964425 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ToolbarDropdownWrapper(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _2XsHFMdnbC _4ouGXIIZbP",
            "_1Fbn34Q4SZ _4zT8tSQ4SZ _4EWkALQ4SZ _3qgovSYbGa"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function ToolbarDropdownWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _2XsHFMdnbC _4ouGXIIZbP",
            "_1Fbn34Q4SZ _4zT8tSQ4SZ _4EWkALQ4SZ _3qgovSYbGa"
        ]),
        children: children
    });
};
module.exports["ToolbarDropdownWrapper"] = $69e4cb0a35c87667$export$b4f55ae464964425;

});

parcelRegister("5ttHX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7sJoX = parcelRequire("7sJoX");

const $00c33121933c3020$var$expandIconContainerStyle = null;
const $00c33121933c3020$export$12d8719856664799 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ToolbarExpandIcon() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0hPCNLDIqT"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function ToolbarExpandIcon() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
};
module.exports["ToolbarExpandIcon"] = $00c33121933c3020$export$12d8719856664799;

});

parcelRegister("9FPR8", function(module, exports) {
function $91a510caaeae058e$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
module.exports["isBody"] = $91a510caaeae058e$export$540dbd453ede1ce3;

});

parcelRegister("lfek5", function(module, exports) {
function $3f67f651c53dfb35$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
module.exports["isTextNode"] = $3f67f651c53dfb35$export$ccbedd67ef6e9417;

});

parcelRegister("5xdta", function(module, exports) {
function $c7b6dd0211227f56$export$f306d9dd555af398(nodeType, pos) {
    return `${nodeType}:${pos}`;
}
module.exports["makeNodePlaceholderId"] = $c7b6dd0211227f56$export$f306d9dd555af398;

});

parcelRegister("d6dQh", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $aPdNQ = parcelRequire("aPdNQ");


var $5xdta = parcelRequire("5xdta");

const $343e96fb4339c18d$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((view)=>{
    return view.dom?.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $343e96fb4339c18d$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
class $343e96fb4339c18d$export$dccb00b9da782c66 {
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
    constructor(_node, view, _getPos, _outerDeco){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.outerDeco = void 0;
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$343e96fb4339c18d$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        this.node = _node;
        this.outerDeco = _outerDeco;
        if (typeof _node.type?.spec?.toDOM !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $343e96fb4339c18d$var$getEditorLineWidth(view)
        };
        const fallback = (0, $aPdNQ.DOMSerializer).renderSpec(document, _node.type.spec.toDOM(_node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', _node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
            // This is used by the UFO to identify the node
            this.dom.setAttribute('data-vc', `editor-lnv-fallback--${_node.type.name}`);
            const pos = _getPos();
            if (pos !== undefined) // Used for UFO to identify this as a placeholder
            this.dom.setAttribute('data-editor-lnv-placeholder', (0, $5xdta.makeNodePlaceholderId)(_node.type.name, pos));
        }
    }
}
module.exports["LazyNodeView"] = $343e96fb4339c18d$export$dccb00b9da782c66;

});

parcelRegister("e2j05", function(module, exports) {

var $4EksL = parcelRequire("4EksL");

function $9860d31165882d4e$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), side)));
}
module.exports["setGapCursorSelection"] = $9860d31165882d4e$export$a8946811e8b82dd;

});

parcelRegister("i8Wi0", function(module, exports) {
function $861eba5e483fa405$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
module.exports["validatePosition"] = $861eba5e483fa405$export$ab306cb155a0ca1b;

});

parcelRegister("bBlkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a76f1b23721b4962045de252c103d405>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8723b1aa20f616d3$var$_react = $8723b1aa20f616d3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8723b1aa20f616d3$var$_baseNew = $8723b1aa20f616d3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8723b1aa20f616d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-five
 * Usage guidance:
 * Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8723b1aa20f616d3$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $8723b1aa20f616d3$var$_react.default.createElement($8723b1aa20f616d3$var$_baseNew.default, Object.assign({
        name: "TextHeadingFiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$8723b1aa20f616d3$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $8723b1aa20f616d3$var$_default = module.exports.default = $8723b1aa20f616d3$var$TextHeadingFiveIcon;

});

parcelRegister("dhsWS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::38a395ef1316610d3a95f8df79c2ec77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ab35180aecf66ba$var$_react = $9ab35180aecf66ba$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ab35180aecf66ba$var$_baseNew = $9ab35180aecf66ba$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9ab35180aecf66ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-four
 * Usage guidance:
 * Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ab35180aecf66ba$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $9ab35180aecf66ba$var$_react.default.createElement($9ab35180aecf66ba$var$_baseNew.default, Object.assign({
        name: "TextHeadingFourIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$9ab35180aecf66ba$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $9ab35180aecf66ba$var$_default = module.exports.default = $9ab35180aecf66ba$var$TextHeadingFourIcon;

});

parcelRegister("bc70Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eee691665e02eaa3903236d0d832e952>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $826641b7716f1b31$var$_react = $826641b7716f1b31$var$_interopRequireDefault((parcelRequire("cozmU")));

var $826641b7716f1b31$var$_baseNew = $826641b7716f1b31$var$_interopRequireDefault((parcelRequire("gElAV")));
function $826641b7716f1b31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-one
 * Usage guidance:
 * Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $826641b7716f1b31$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $826641b7716f1b31$var$_react.default.createElement($826641b7716f1b31$var$_baseNew.default, Object.assign({
        name: "TextHeadingOneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$826641b7716f1b31$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $826641b7716f1b31$var$_default = module.exports.default = $826641b7716f1b31$var$TextHeadingOneIcon;

});

parcelRegister("gIW0y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50408d02af03ae8936014cad63d1f46c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2cdc0923cffa528$var$_react = $c2cdc0923cffa528$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c2cdc0923cffa528$var$_baseNew = $c2cdc0923cffa528$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c2cdc0923cffa528$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-six
 * Usage guidance:
 * Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2cdc0923cffa528$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $c2cdc0923cffa528$var$_react.default.createElement($c2cdc0923cffa528$var$_baseNew.default, Object.assign({
        name: "TextHeadingSixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$c2cdc0923cffa528$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $c2cdc0923cffa528$var$_default = module.exports.default = $c2cdc0923cffa528$var$TextHeadingSixIcon;

});

parcelRegister("bUmH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::570777efd818570465c22920c54b5aeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ab6871d3041ed2a$var$_react = $8ab6871d3041ed2a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8ab6871d3041ed2a$var$_baseNew = $8ab6871d3041ed2a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8ab6871d3041ed2a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-three
 * Usage guidance:
 * Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ab6871d3041ed2a$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $8ab6871d3041ed2a$var$_react.default.createElement($8ab6871d3041ed2a$var$_baseNew.default, Object.assign({
        name: "TextHeadingThreeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$8ab6871d3041ed2a$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $8ab6871d3041ed2a$var$_default = module.exports.default = $8ab6871d3041ed2a$var$TextHeadingThreeIcon;

});

parcelRegister("66wqx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d5bdaf257719ba73546ebd48db94e28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $471c74f1ef0d24e8$var$_react = $471c74f1ef0d24e8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $471c74f1ef0d24e8$var$_baseNew = $471c74f1ef0d24e8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $471c74f1ef0d24e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-two
 * Usage guidance:
 * Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $471c74f1ef0d24e8$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $471c74f1ef0d24e8$var$_react.default.createElement($471c74f1ef0d24e8$var$_baseNew.default, Object.assign({
        name: "TextHeadingTwoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$471c74f1ef0d24e8$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $471c74f1ef0d24e8$var$_default = module.exports.default = $471c74f1ef0d24e8$var$TextHeadingTwoIcon;

});

parcelRegister("5KCL9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a25bb6f5cbb0da3c43b04fc1c9311429>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42ff5075a1dfbf67$var$_react = $42ff5075a1dfbf67$var$_interopRequireDefault((parcelRequire("cozmU")));

var $42ff5075a1dfbf67$var$_baseNew = $42ff5075a1dfbf67$var$_interopRequireDefault((parcelRequire("gElAV")));
function $42ff5075a1dfbf67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-small
 * Usage guidance:
 * Reserved for representing small text style in text editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42ff5075a1dfbf67$var$TextSmallIcon = (props)=>/*#__PURE__*/ $42ff5075a1dfbf67$var$_react.default.createElement($42ff5075a1dfbf67$var$_baseNew.default, Object.assign({
        name: "TextSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.251V15h-1.5V2.5H0V1zm3.5 11.375v-.5c0-.621-.504-1.125-1.125-1.125h-1.75A2.625 2.625 0 0 1 9 8.125v-.5A2.625 2.625 0 0 1 11.625 5H13.5A2.5 2.5 0 0 1 16 7.5h-1.5a1 1 0 0 0-1-1h-1.875c-.621 0-1.125.504-1.125 1.125v.5c0 .621.504 1.125 1.125 1.125h1.75A2.625 2.625 0 0 1 16 11.875v.5A2.625 2.625 0 0 1 13.375 15H11.5A2.5 2.5 0 0 1 9 12.5h1.5a1 1 0 0 0 1 1h1.875c.621 0 1.125-.504 1.125-1.125"/>`
    }, props));
$42ff5075a1dfbf67$var$TextSmallIcon.displayName = 'TextSmallIcon';
var $42ff5075a1dfbf67$var$_default = module.exports.default = $42ff5075a1dfbf67$var$TextSmallIcon;

});

parcelRegister("2oOlV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4a428fb45ffc461f11d5708ab4120c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bf4e1aac9a45edf$var$_react = $1bf4e1aac9a45edf$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1bf4e1aac9a45edf$var$_baseNew = $1bf4e1aac9a45edf$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1bf4e1aac9a45edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextParagraph".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/text-paragraph
 * Usage guidance:
 * Confluence Editor AI action for reformatting paragraphs into multiple shorter paragraphs
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bf4e1aac9a45edf$var$TextParagraphIcon = (props)=>/*#__PURE__*/ $1bf4e1aac9a45edf$var$_react.default.createElement($1bf4e1aac9a45edf$var$_baseNew.default, Object.assign({
        name: "TextParagraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 2.5a2.75 2.75 0 0 0 0 5.5H8V2.5zm3.25 0V15H8V9.5H6.25a4.25 4.25 0 0 1 0-8.5h5.5a.75.75 0 0 1 .75.75V15H11V2.5z" clip-rule="evenodd"/>`
    }, props));
$1bf4e1aac9a45edf$var$TextParagraphIcon.displayName = 'TextParagraphIcon';
var $1bf4e1aac9a45edf$var$_default = module.exports.default = $1bf4e1aac9a45edf$var$TextParagraphIcon;

});

parcelRegister("9Jc4C", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $eh6Ml = parcelRequire("eh6Ml");


var $9d7Pd = parcelRequire("9d7Pd");


var $lpNn5 = parcelRequire("lpNn5");


var $eTVtR = parcelRequire("eTVtR");


function $9e323ba5e86ea129$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9e323ba5e86ea129$var$labelStyles = {
    name: "18nns55",
    styles: "display:inline-block;width:100%"
};
const $9e323ba5e86ea129$var$spacerStyles = {
    name: "nce1h9",
    styles: "display:flex;flex:1;padding:var(--ds-space-100, 8px)"
};
const $9e323ba5e86ea129$var$DropdownButtonItem = (0, $9d7Pd.default);
const $9e323ba5e86ea129$var$SelectedIconBefore = ({ itemSelected: itemSelected, intl: intl, showSelected: showSelected })=>{
    if (showSelected && itemSelected) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: intl.formatMessage((0, $eTVtR.default).confirmModalOK),
        spacing: "none"
    }));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $9e323ba5e86ea129$var$spacerStyles
    });
};
const $9e323ba5e86ea129$export$ed97964d1871885d = (props)=>{
    const { item: item, hide: hide, dispatchCommand: dispatchCommand, editorView: editorView, showSelected: showSelected, intl: intl } = props;
    const itemSelected = item.selected;
    const iconBefore = (0, $cozmU.useMemo)(()=>{
        if (item.icon) return item.icon;
        else return /*#__PURE__*/ (0, $lOiVq.jsx)($9e323ba5e86ea129$var$SelectedIconBefore, {
            itemSelected: itemSelected,
            showSelected: showSelected,
            intl: intl
        });
    }, [
        itemSelected,
        showSelected,
        intl,
        item.icon
    ]);
    const [tooltipContent, setTooltipContent] = (0, $cozmU.useState)(item.tooltip || '');
    const handleItemMouseOut = (0, $cozmU.useCallback)(()=>{
        setTooltipContent('');
        if (item.onMouseOut) dispatchCommand(item.onMouseOut);
    }, [
        item.onMouseOut,
        dispatchCommand
    ]);
    const handleItemMouseDown = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault(); // ED-16204 - This is needed for safari to get handleItemClick() to work
        if (item.onMouseDown) dispatchCommand(item.onMouseDown);
    }, [
        item.onMouseDown,
        dispatchCommand
    ]);
    const handleItemMouseOver = (0, $cozmU.useCallback)(()=>{
        setTooltipContent(item.tooltip || '');
        if (item.onMouseOver) dispatchCommand(item.onMouseOver);
    }, [
        item.tooltip,
        item.onMouseOver,
        dispatchCommand
    ]);
    const handleItemMouseEnter = (0, $cozmU.useCallback)((e)=>{
        if (item.onMouseEnter) {
            e.preventDefault();
            dispatchCommand(item.onMouseEnter);
        }
    }, [
        item.onMouseEnter,
        dispatchCommand
    ]);
    const handleItemMouseLeave = (0, $cozmU.useCallback)((e)=>{
        if (item.onMouseLeave) {
            e.preventDefault();
            dispatchCommand(item.onMouseLeave);
        }
    }, [
        item.onMouseLeave,
        dispatchCommand
    ]);
    const handleItemOnFocus = (0, $cozmU.useCallback)((e)=>{
        if (item.onFocus) {
            e.preventDefault();
            dispatchCommand(item.onFocus);
        }
    }, [
        item.onFocus,
        dispatchCommand
    ]);
    const handleItemOnBlur = (0, $cozmU.useCallback)((e)=>{
        if (item.onBlur) {
            e.preventDefault();
            dispatchCommand(item.onBlur);
        }
    }, [
        item.onBlur,
        dispatchCommand
    ]);
    const handleItemClick = (0, $cozmU.useCallback)(()=>{
        /**
     * The order of dispatching the event and hide() is important, because
     * the ClickAreaBlock will be relying on the element to calculate the
     * click coordinate.
     * For more details, please visit the comment in this PR https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/5328/edm-1321-set-selection-near-smart-link?link_source=email#chg-packages/editor/editor-core/src/plugins/floating-toolbar/ui/DropdownMenu.tsx
     */ dispatchCommand(item.onClick);
        hide();
        if (!editorView?.hasFocus()) editorView?.focus();
    }, [
        dispatchCommand,
        item.onClick,
        hide,
        editorView
    ]);
    /* ED-16704 - Native mouse event handler to overcome firefox issue on disabled <button> - https://github.com/whatwg/html/issues/5886 */ const labelRef = (0, $cozmU.useRef)(null);
    const handleTitleWrapperMouseEvent = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        if (item.disabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, [
        item.disabled
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isAriaChecked = (item)=>{
        const { selected: selected, domItemOptions: domItemOptions } = item;
        return domItemOptions?.type === 'item-checkbox' ? selected : undefined;
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasRole = (item)=>{
        // Always return proper menu roles to fix aria-required-children violations
        return item.domItemOptions?.type === 'item-checkbox' ? 'menuitemcheckbox' : 'menuitem';
    };
    (0, $cozmU.useEffect)(()=>{
        const labelRefCurrent = labelRef.current;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('click', handleTitleWrapperMouseEvent);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('mousedown', handleTitleWrapperMouseEvent);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('click', handleTitleWrapperMouseEvent);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('mousedown', handleTitleWrapperMouseEvent);
        };
    });
    const itemContent = /*#__PURE__*/ (0, $lOiVq.jsx)($9e323ba5e86ea129$var$DropdownButtonItem, {
        isSelected: itemSelected,
        iconBefore: iconBefore,
        iconAfter: item.elemAfter,
        onClick: handleItemClick,
        "data-testid": item.testId,
        isDisabled: item.disabled,
        onMouseDown: handleItemMouseDown,
        onMouseOver: handleItemMouseOver,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        onMouseOut: handleItemMouseOut,
        onFocus: handleItemOnFocus,
        onBlur: handleItemOnBlur,
        role: hasRole(item),
        "aria-checked": isAriaChecked(item)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: labelRef,
        css: $9e323ba5e86ea129$var$labelStyles
    }, item.title));
    if (tooltipContent) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: tooltipContent
    }, itemContent);
    return itemContent;
};
module.exports["DropdownMenuItem"] = $9e323ba5e86ea129$export$ed97964d1871885d;

});

parcelRegister("7HhCu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $lOiVq = parcelRequire("lOiVq");

function $5116cca041a867a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5116cca041a867a0$var$separatorStyles = {
    name: "1qptm7f",
    styles: "background:var(--ds-border, #0B120E24);height:1px"
};
const $5116cca041a867a0$export$c0340fdc1581055e = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $5116cca041a867a0$var$separatorStyles
    });
};
module.exports["DropdownSeparator"] = $5116cca041a867a0$export$c0340fdc1581055e;

});

parcelRegister("jIX6h", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4b09be0139b5e5f4$export$12d66ae3e5b38d26 = (0, $kSwu1.defineMessages)({
    '#DEEBFF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#B3D4FF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#4C9AFF': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#ADCBFB': {
        id: "fabric.theme.bold-blue-new",
        defaultMessage: "Bold blue"
    },
    '#E6FCFF': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#B3F5FF': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#79E2F2': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#B1E4F7': {
        id: "fabric.theme.bold-teal-new",
        defaultMessage: "Bold teal"
    },
    '#E3FCEF': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#ABF5D1': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#57D9A3': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#97EDC9': {
        id: "fabric.theme.bold-green-new",
        defaultMessage: "Bold green"
    },
    '#FFFAE6': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFF0B3': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FFC400': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#EFDD4E': {
        id: "fabric.theme.bold-yellow-new",
        defaultMessage: "Bold yellow"
    },
    '#FFEBE6': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#FFBDAD': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#FF8F73': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#FFB8B2': {
        id: "fabric.theme.bold-red-new",
        defaultMessage: "Bold red"
    },
    '#EAE6FF': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#C0B6F2': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#998DD9': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#E3BDFA': {
        id: "fabric.theme.bold-purple-new",
        defaultMessage: "Bold purple"
    },
    '#FFFFFF': {
        id: "fabric.theme.white",
        defaultMessage: "White"
    },
    '#F4F5F7': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#B3BAC5': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    },
    '#B7B9BE': {
        id: "fabric.theme.bold-gray-new",
        defaultMessage: "Bold gray"
    },
    '#EFFFD6': {
        id: "fabric.theme.subtle-lime",
        defaultMessage: "Subtle lime"
    },
    '#D3F1A7': {
        id: "fabric.theme.lime",
        defaultMessage: "Lime"
    },
    '#BDE97C': {
        id: "fabric.theme.bold-lime",
        defaultMessage: "Bold lime"
    },
    '#FFF5DB': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    '#FCE4A6': {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    '#FBD779': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#FFECF8': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    '#FDD0EC': {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    },
    '#FCB6E1': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    }
});
module.exports["lightBackgroundPaletteTooltipMessages"] = $4b09be0139b5e5f4$export$12d66ae3e5b38d26;

});

parcelRegister("72AfS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0d29ca9c301aefa8$export$3db7ab7dd64ad21a = (0, $kSwu1.defineMessages)({
    // Blue color
    '#7AB2FF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#247FFF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#0055CC': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#003884': {
        id: "fabric.theme.bolder-blue",
        defaultMessage: "Bolder blue"
    },
    // Teal color
    '#60C6D2': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#1D9AAA': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#1D7F8C': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#206B74': {
        id: "fabric.theme.bolder-teal",
        defaultMessage: "Bolder teal"
    },
    // Green color
    '#6BE1B0': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#23A971': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#177D52': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#055C3F': {
        id: "fabric.theme.bolder-green",
        defaultMessage: "Bolder green"
    },
    // Yellow color
    '#FFDB57': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFBE33': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FF9D00': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#946104': {
        id: "fabric.theme.bolder-yellow",
        defaultMessage: "Bolder yellow"
    },
    // Red color
    '#FF8F73': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#FC552C': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#D32D03': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#A32000': {
        id: "fabric.theme.bolder-red",
        defaultMessage: "Bolder red"
    },
    // Orange color
    '#FAA53D': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    '#D97008': {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    '#B65C02': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#974F0C': {
        id: "fabric.theme.bolder-orange",
        defaultMessage: "Bolder orange"
    },
    // Magenta color
    '#E774BB': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    '#DA62AC': {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    },
    '#CD519D': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    '#943D73': {
        id: "fabric.theme.bolder-magenta",
        defaultMessage: "Bolder magenta"
    },
    // Purple color
    '#B5A7FB': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#8B77EE': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#5A43D0': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#44368B': {
        id: "fabric.theme.bolder-purple",
        defaultMessage: "Bolder purple"
    },
    // Gray color
    '#8993A5': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#8590A2': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#758195': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    },
    '#44546F': {
        id: "fabric.theme.bolder-gray",
        defaultMessage: "Bolder gray"
    }
});
module.exports["lightChartsColorPaletteTooltipMessages"] = $0d29ca9c301aefa8$export$3db7ab7dd64ad21a;

});

parcelRegister("cUMTy", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $baaece4e6374c35b$export$788a656fb7fb7897 = (0, $kSwu1.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.white",
        defaultMessage: "White"
    },
    '#B3D4FF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#B3F5FF': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#ABF5D1': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#FFF0B3': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFBDAD': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#EAE6FF': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#97A0AF': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#4C9AFF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#00B8D9': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#36B37E': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#FFC400': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FF5630': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#FF991F': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#6554C0': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#0747A6': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#008DA6': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#006644': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#BF2600': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#403294': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#172B4D': {
        id: "fabric.theme.default",
        defaultMessage: "Default"
    },
    '#D3F1A7': {
        id: "fabric.theme.subtle-lime",
        defaultMessage: "Subtle lime"
    },
    '#FDD0EC': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    '#6A9A23': {
        id: "fabric.theme.lime",
        defaultMessage: "Lime"
    },
    '#CD519D': {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    },
    '#4C6B1F': {
        id: "fabric.theme.bold-lime",
        defaultMessage: "Bold lime"
    },
    '#943D73': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    '#B38600': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#7F5F01': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#FCE4A6': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    '#E06C00': {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    '#9E4C00': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    }
});
module.exports["lightTextPaletteTooltipMessages"] = $baaece4e6374c35b$export$788a656fb7fb7897;

});

parcelRegister("iZTi0", function(module, exports) {
function $4754afc2f794b487$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
module.exports["getSelectedRowAndColumn"] = $4754afc2f794b487$export$17092ffd56d3b3b2;

});

parcelRegister("3mD3Q", function(module, exports) {
var $ef664e66e230e411$export$6dcc1033b74c9344 = /*#__PURE__*/ function(LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
    LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
    LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
    LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
    LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
    return LinkAction;
}({});
module.exports["LinkAction"] = $ef664e66e230e411$export$6dcc1033b74c9344;

});

parcelRegister("o2UQ9", function(module, exports) {

var $kHija = parcelRequire("kHija");


var $9bUBT = parcelRequire("9bUBT");

var $kwAo1 = parcelRequire("kwAo1");

var $3mD3Q = parcelRequire("3mD3Q");


var $kpCD8 = parcelRequire("kpCD8");


var $gid2f = parcelRequire("gid2f");

var $2w79Z = parcelRequire("2w79Z");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");

const $eb5187e713cbf371$var$mapTransactionToState = (state, tr)=>{
    if (!state) return undefined;
    else if (state.type === (0, $kwAo1.InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, $kwAo1.InsertStatus).EDIT_INSERTED_TOOLBAR) {
        const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
        const node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) return state;
            return {
                ...state,
                pos: pos,
                node: node
            };
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return;
    } else if (state.type === (0, $kwAo1.InsertStatus).INSERT_LINK_TOOLBAR) return {
        ...state,
        from: tr.mapping.map(state.from),
        to: tr.mapping.map(state.to)
    };
    return;
};
const $eb5187e713cbf371$var$toState = (state, action, editorState)=>{
    // Show insert or edit toolbar
    if (!state) switch(action){
        case (0, $3mD3Q.LinkAction).SHOW_INSERT_TOOLBAR:
            {
                const { from: from, to: to } = editorState.selection;
                if ((0, $gid2f.canLinkBeCreatedInRange)(from, to)(editorState)) return {
                    type: (0, $kwAo1.InsertStatus).INSERT_LINK_TOOLBAR,
                    from: from,
                    to: to
                };
                return undefined;
            }
        case (0, $3mD3Q.LinkAction).SELECTION_CHANGE:
            // If the user has moved their cursor, see if they're in a link
            const link = (0, $9bUBT.getActiveLinkMark)(editorState);
            if (link) return {
                ...link,
                type: (0, $kwAo1.InsertStatus).EDIT_LINK_TOOLBAR
            };
            return undefined;
        default:
            return undefined;
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === (0, $kwAo1.InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
        case (0, $3mD3Q.LinkAction).EDIT_INSERTED_TOOLBAR:
            {
                const link = (0, $9bUBT.getActiveLinkMark)(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) return {
                        ...state,
                        type: (0, $kwAo1.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                    return {
                        ...link,
                        type: (0, $kwAo1.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                }
                return undefined;
            }
        case (0, $3mD3Q.LinkAction).SELECTION_CHANGE:
            const link1 = (0, $9bUBT.getActiveLinkMark)(editorState);
            if (link1) {
                if (link1.pos === state.pos && link1.node === state.node) // Make sure we return the same object, if it's the same link
                return state;
                return {
                    ...link1,
                    type: (0, $kwAo1.InsertStatus).EDIT_LINK_TOOLBAR
                };
            }
            return undefined;
        case (0, $3mD3Q.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === (0, $kwAo1.InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
        case (0, $3mD3Q.LinkAction).SELECTION_CHANGE:
        case (0, $3mD3Q.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    return;
};
const $eb5187e713cbf371$var$getActiveText = (selection)=>{
    const currentSlice = selection.content();
    if (currentSlice.size === 0) return;
    if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, $kCECX.TextSelection)) return currentSlice.content.firstChild.textContent;
    return;
};
const $eb5187e713cbf371$export$77b371d6becc8882 = new (0, $kCECX.PluginKey)('hyperlinkPlugin');
const $eb5187e713cbf371$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, _pluginInjectionApi, _onClickCallback, __livePage)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init (_, state) {
                const canInsertLink = (0, $gid2f.canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    activeText: $eb5187e713cbf371$var$getActiveText(state.selection),
                    canInsertLink: canInsertLink,
                    timesViewed: 0,
                    activeLinkMark: $eb5187e713cbf371$var$toState(undefined, (0, $3mD3Q.LinkAction).SELECTION_CHANGE, state),
                    editorAppearance: editorAppearance
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let state = pluginState;
                const action = tr.getMeta($eb5187e713cbf371$export$77b371d6becc8882) && tr.getMeta($eb5187e713cbf371$export$77b371d6becc8882).type;
                const inputMethod = tr.getMeta($eb5187e713cbf371$export$77b371d6becc8882) && tr.getMeta($eb5187e713cbf371$export$77b371d6becc8882).inputMethod;
                if (tr.docChanged) state = {
                    activeText: state.activeText,
                    canInsertLink: (0, $gid2f.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    timesViewed: state.timesViewed,
                    inputMethod: inputMethod,
                    activeLinkMark: $eb5187e713cbf371$var$mapTransactionToState(state.activeLinkMark, tr),
                    editorAppearance: editorAppearance
                };
                if (action) {
                    const stateForAnalytics = [
                        (0, $3mD3Q.LinkAction).SHOW_INSERT_TOOLBAR,
                        (0, $3mD3Q.LinkAction).EDIT_INSERTED_TOOLBAR
                    ].includes(action) ? {
                        timesViewed: ++state.timesViewed,
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))()
                    } : {
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId
                    };
                    state = {
                        activeText: state.activeText,
                        canInsertLink: state.canInsertLink,
                        inputMethod: inputMethod,
                        activeLinkMark: $eb5187e713cbf371$var$toState(state.activeLinkMark, action, newState),
                        editorAppearance: editorAppearance,
                        ...stateForAnalytics
                    };
                }
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.selectionSet && hasPositionChanged) state = {
                    activeText: $eb5187e713cbf371$var$getActiveText(newState.selection),
                    canInsertLink: (0, $gid2f.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    activeLinkMark: $eb5187e713cbf371$var$toState(state.activeLinkMark, (0, $3mD3Q.LinkAction).SELECTION_CHANGE, newState),
                    timesViewed: state.timesViewed,
                    searchSessionId: state.searchSessionId,
                    inputMethod: inputMethod,
                    editorAppearance: editorAppearance
                };
                if (!(0, $2w79Z.shallowEqual)(state, pluginState)) dispatch($eb5187e713cbf371$export$77b371d6becc8882, state);
                return state;
            }
        },
        key: $eb5187e713cbf371$export$77b371d6becc8882,
        props: {
            decorations: ()=>{
                return (0, $8nvEM.DecorationSet).empty;
            },
            handleDOMEvents: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mouseup: (_, event)=>{
                    // this prevents redundant selection transaction when clicking on link
                    // link state will be update on slection change which happens on mousedown
                    if ($eb5187e713cbf371$var$isLinkDirectTarget(event)) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mousedown: (view, event)=>{
                    // since link clicks are disallowed by browsers inside contenteditable
                    // so we need to handle shift+click selection ourselves in this case
                    if (!event.shiftKey || !$eb5187e713cbf371$var$isLinkDirectTarget(event)) return false;
                    const { state: state } = view;
                    const { selection: { $anchor: $anchor } } = state;
                    const newPosition = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if (newPosition?.pos != null && newPosition.pos !== $anchor.pos) {
                        const tr = state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            }
        }
    });
function $eb5187e713cbf371$var$isLinkDirectTarget(event) {
    return event?.target instanceof HTMLElement && event.target.tagName === 'A';
}
module.exports["stateKey"] = $eb5187e713cbf371$export$77b371d6becc8882;
module.exports["plugin"] = $eb5187e713cbf371$export$ca524d3785e2543;

});

parcelRegister("IAZGS", function(module, exports) {
function $01194ebd00b44281$export$8476280b1d47554d(pos) {
    return ({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        return !!node && node.isText;
    };
}
module.exports["isTextAtPos"] = $01194ebd00b44281$export$8476280b1d47554d;

});

parcelRegister("k0VoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $d16b4c65010f69bb$var$timer;
const $d16b4c65010f69bb$var$Announcer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(15);
    const { ariaAtomic: t1, ariaLive: t2, ariaRelevant: t3, role: t4, text: t5, delay: t6 } = t0;
    const ariaAtomic = t1 === undefined ? "true" : t1;
    const ariaLive = t2 === undefined ? "polite" : t2;
    const ariaRelevant = t3 === undefined ? "all" : t3;
    const role = t4 === undefined ? "status" : t4;
    const text = t5 === undefined ? "" : t5;
    const delay = t6 === undefined ? 0 : t6;
    const [contentRendered, setContentRendered] = (0, $cozmU.useState)(false);
    let t7;
    if ($[0] !== delay) {
        t7 = ()=>{
            clearTimeout($d16b4c65010f69bb$var$timer);
            setContentRendered(false);
            $d16b4c65010f69bb$var$timer = setTimeout(()=>{
                setContentRendered(true);
            }, delay);
            return $d16b4c65010f69bb$var$_temp;
        };
        $[0] = delay;
        $[1] = t7;
    } else t7 = $[1];
    let t8;
    if ($[2] !== delay || $[3] !== text) {
        t8 = [
            text,
            delay
        ];
        $[2] = delay;
        $[3] = text;
        $[4] = t8;
    } else t8 = $[4];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[5] !== contentRendered || $[6] !== text) {
        t9 = contentRendered && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            children: text
        });
        $[5] = contentRendered;
        $[6] = text;
        $[7] = t9;
    } else t9 = $[7];
    let t10;
    if ($[8] !== ariaAtomic || $[9] !== ariaLive || $[10] !== ariaRelevant || $[11] !== ref || $[12] !== role || $[13] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: "assistive",
            ref: ref,
            role: role,
            "aria-atomic": ariaAtomic,
            "aria-relevant": ariaRelevant,
            "aria-live": ariaLive,
            children: t9
        });
        $[8] = ariaAtomic;
        $[9] = ariaLive;
        $[10] = ariaRelevant;
        $[11] = ref;
        $[12] = role;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    return t10;
} : ({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        clearTimeout($d16b4c65010f69bb$var$timer);
        setContentRendered(false);
        $d16b4c65010f69bb$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($d16b4c65010f69bb$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        children: contentRendered && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            children: text
        })
    });
});
const $d16b4c65010f69bb$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)($d16b4c65010f69bb$var$Announcer);
var $d16b4c65010f69bb$export$2e2bcd8739ae039 = $d16b4c65010f69bb$var$_default_1;
function $d16b4c65010f69bb$var$_temp() {
    return clearTimeout($d16b4c65010f69bb$var$timer);
}
module.exports["default"] = $d16b4c65010f69bb$export$2e2bcd8739ae039;

});

parcelRegister("bzBji", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b67b4470b0e543de$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    displayText: {
        id: "fabric.editor.displayText",
        defaultMessage: "Text to display"
    },
    clearText: {
        id: "fabric.editor.clearLinkText",
        defaultMessage: "Clear text"
    },
    clearLink: {
        id: "fabric.editor.clearLink",
        defaultMessage: "Clear link"
    },
    hyperlinkAriaLabel: {
        id: "fabric.editor.hyperlink.ariaLabel",
        defaultMessage: "Hyperlink Edit"
    },
    searchLinkAriaDescription: {
        id: "fabric.editor.hyperlink.searchLinkAriaDescription",
        defaultMessage: "Suggestions will appear below as you type into the field"
    },
    searchLinkResults: {
        id: "fabric.editor.hyperlink.searchLinkResults",
        defaultMessage: "{count, plural, =0 {no results} one {# result} other {# results}} found"
    },
    linkVisibleLabel: {
        id: "fabric.editor.hyperlink.linkVisibleLabel",
        defaultMessage: "Paste or search for link"
    },
    textVisibleLabel: {
        id: "fabric.editor.hyperlink.textVisibleLabel",
        defaultMessage: "Display text (optional)"
    }
});
module.exports["messages"] = $b67b4470b0e543de$export$defe85febe8b728c;

});

parcelRegister("i94vj", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");

const $f983cb6350e06a66$export$b81ddbf3e2eaad80 = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-input, #8C8F97)"}`,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'content-box',
        color: "var(--ds-text, #292A2E)",
        flexGrow: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(13),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '20px',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
        minWidth: '145px',
        /* Hides IE10+ built-in [x] clear input button */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-clear': {
            display: 'none'
        },
        '&:focus': {
            outline: 'none',
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            borderColor: "var(--ds-border-focused, #4688EC)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}`
        },
        '&::placeholder': {
            color: "var(--ds-text-subtlest, #6B6E76)"
        }
    }
});
const $f983cb6350e06a66$export$c9f899b6422903f6 = (width)=>/*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${width}px`
        }
    });
module.exports["panelTextInput"] = $f983cb6350e06a66$export$b81ddbf3e2eaad80;
module.exports["panelTextInputWithCustomWidth"] = $f983cb6350e06a66$export$c9f899b6422903f6;

});

parcelRegister("iRydk", function(module, exports) {

var $1Ujre = parcelRequire("1Ujre");


var $f6RxU = parcelRequire("f6RxU");


var $fIopu = parcelRequire("fIopu");


var $2xhuI = parcelRequire("2xhuI");

const $b762f5e44adad79e$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    let pageActionText = '';
    switch(pageAction){
        case 'updated':
            pageActionText = intl.formatMessage((0, $2xhuI.default).timeUpdated);
            break;
        case 'viewed':
            pageActionText = intl.formatMessage((0, $2xhuI.default).timeViewed);
            break;
    }
    if ((0, $1Ujre.default)(timeStamp, Date.now()) < -7) return {
        pageAction: pageActionText,
        dateString: (0, $f6RxU.default)(timeStamp, 'MMMM dd, yyyy')
    };
    return {
        pageAction: pageActionText,
        dateString: (0, $fIopu.default)(timeStamp, Date.now()),
        timeSince: intl.formatMessage((0, $2xhuI.default).timeAgo)
    };
};
const $b762f5e44adad79e$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $b762f5e44adad79e$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $b762f5e44adad79e$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};
module.exports["transformTimeStamp"] = $b762f5e44adad79e$export$439b9bb86eb9f500;

});

parcelRegister("hgAxn", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");

const $d2eaefa960ed0d55$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $bjg0G.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $bjg0G.findParentNodeOfType)(codeBlock)(selection || state.selection);
};
module.exports["findCodeBlock"] = $d2eaefa960ed0d55$export$8435d1ef36841a34;

});

parcelRegister("ca4Zc", function(module, exports) {

var $8HW7o = parcelRequire("8HW7o");

const $cbea9f1ab393c1a2$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $8HW7o.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};
module.exports["anyMarkActive"] = $cbea9f1ab393c1a2$export$3d7a3b3f27c57f56;

});

parcelRegister("1efRc", function(module, exports) {
function $375d8019f7a028d7$export$e20225b4cda674a8(type, item) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
module.exports["checkClipboardTypes"] = $375d8019f7a028d7$export$e20225b4cda674a8;

});

parcelRegister("aDwKe", function(module, exports) {

var $fud2r = parcelRequire("fud2r");

const $bbc44457954f0e13$export$c20bd22f1bffad40 = (slice, schema)=>{
    const { extension: extension, inlineExtension: inlineExtension } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if ([
            extension,
            inlineExtension
        ].includes(node.type) && typeof node.attrs.parameters?.macroMetadata?.macroId?.value !== 'undefined') // Strip the macroId. While pasting on the same page, macroId does not change until the page
        // is published and causes collision with the existing macroId where switching tabs of one
        // node changes the tabs for the other node
        delete node.attrs.parameters.macroMetadata.macroId;
        return node;
    });
};
module.exports["transformSliceToRemoveMacroId"] = $bbc44457954f0e13$export$c20bd22f1bffad40;

});

parcelRegister("8Kvl9", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0efea97da41e4741$export$940a17143b866527 = (0, $kSwu1.defineMessages)({
    typeAheadPopupLabel: {
        id: "fabric.editor.typeAhead.popupLabel",
        defaultMessage: "Typeahead results"
    },
    quickInsertPopupLabel: {
        id: "fabric.editor.typeAhead.quickInsertPopupLabel",
        defaultMessage: "Shortcuts for inserts and formatting"
    },
    quickInsertInputLabel: {
        id: "fabric.editor.typeAhead.quickInsertInputLabel",
        defaultMessage: "Begin typing to search or filter shortcut options"
    },
    quickInsertInputPlaceholderLabel: {
        id: "fabric.editor.typeAhead.quickInsertInputPlaceholderLabel",
        defaultMessage: "Search"
    },
    emojiPopupLabel: {
        id: "fabric.editor.typeahead.emojiPopupLabel",
        defaultMessage: "Emoji shortcuts"
    },
    emojiInputLabel: {
        id: "fabric.editor.typeahead.emojiInputLabel",
        defaultMessage: "Begin typing to search or filter emoji options"
    },
    mentionPopupLabel: {
        id: "fabric.editor.typeahead.mentionPopupLabel",
        defaultMessage: "Users you can tag"
    },
    mentionInputLabel: {
        id: "fabric.editor.typeahead.mentionInputLabel",
        defaultMessage: "Begin typing to search for users to tag"
    },
    metionListItemLabel: {
        id: "fabric.editor.typeahead.metionListItemLabel",
        defaultMessage: "User {name} @{shortName}"
    },
    mentionListItemLabelWithDescription: {
        id: "fabric.editor.typeahead.mentionListItemLabelWithDescription",
        defaultMessage: "User {name} @{shortName}. {description}"
    },
    emojiListItemLabel: {
        id: "fabric.editor.typeahead.emojiListItemLabel",
        defaultMessage: "Emoji {name} Text Shortcut {shortcut}"
    },
    inputQueryAssistiveLabel: {
        id: "fabric.editor.inputQueryAssistiveTxt",
        defaultMessage: "When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures."
    },
    searchResultsLabel: {
        id: "fabric.editor.searchResults",
        defaultMessage: "{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option."
    },
    noSearchResultsLabel: {
        id: "fabric.editor.noSearchResults",
        defaultMessage: "No search results"
    },
    descriptionLabel: {
        id: "fabric.editor.description",
        defaultMessage: "Description"
    },
    shortcutLabel: {
        id: "fabric.editor.shortcut",
        defaultMessage: "Text shortcut"
    },
    typeAheadErrorFallbackHeading: {
        id: "fabric.editor.typeAheadErrorFallbackHeading",
        defaultMessage: "Something went wrong"
    },
    typeAheadErrorFallbackDesc: {
        id: "fabric.editor.typeAheadErrorFallbackDescription",
        defaultMessage: "No results available. Try again."
    },
    viewAllInserts: {
        id: "fablric.editor.viewAllInserts",
        defaultMessage: "View all inserts"
    },
    emptySearchResults: {
        id: "fabric.editor.emptySearchResults",
        defaultMessage: "We couldn't find any results."
    },
    emptySearchResultsSuggestion: {
        id: "fabric.editor.emptySearchResultsSuggestion",
        defaultMessage: "Select {buttonName} to browse inserts."
    },
    emptySearchResultsSuggestionNew: {
        id: "fabric.editor.emptySearchResultsSuggestionNew",
        defaultMessage: "Select {askRovoName} for help, or {buttonName} to browse inserts."
    },
    emptySearchResultsSuggestionAskRovoOnly: {
        id: "fabric.editor.emptySearchResultsSuggestionAskRovoOnly",
        defaultMessage: "Select {askRovoName} for help."
    }
});
module.exports["typeAheadListMessages"] = $0efea97da41e4741$export$940a17143b866527;

});

parcelRegister("lb5Vp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9bf917753ad755b7424a8453db8f6599>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6af389de4282836$var$_react = $f6af389de4282836$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f6af389de4282836$var$_baseNew = $f6af389de4282836$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f6af389de4282836$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSubscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-subscript
 * Usage guidance:
 * Reserved for subscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f6af389de4282836$var$TextSubscriptIcon = (props)=>/*#__PURE__*/ $f6af389de4282836$var$_react.default.createElement($f6af389de4282836$var$_baseNew.default, Object.assign({
        name: "TextSubscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49.5h.08a.75.75 0 0 1 .67.75V16H13v-6h-1V8.5z"/>`
    }, props));
$f6af389de4282836$var$TextSubscriptIcon.displayName = 'TextSubscriptIcon';
var $f6af389de4282836$var$_default = module.exports.default = $f6af389de4282836$var$TextSubscriptIcon;

});

parcelRegister("aZ6Nw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d6f8da60e0b65f3e3f3a36c0ebece76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff4dfcbe916b373$var$_react = $7ff4dfcbe916b373$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7ff4dfcbe916b373$var$_baseNew = $7ff4dfcbe916b373$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7ff4dfcbe916b373$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSuperscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-superscript
 * Usage guidance:
 * Reserved for superscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff4dfcbe916b373$var$TextSuperscriptIcon = (props)=>/*#__PURE__*/ $7ff4dfcbe916b373$var$_react.default.createElement($7ff4dfcbe916b373$var$_baseNew.default, Object.assign({
        name: "TextSuperscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49-8h.08a.75.75 0 0 1 .67.75V7.5H13v-6h-1V0z"/>`
    }, props));
$7ff4dfcbe916b373$var$TextSuperscriptIcon.displayName = 'TextSuperscriptIcon';
var $7ff4dfcbe916b373$var$_default = module.exports.default = $7ff4dfcbe916b373$var$TextSuperscriptIcon;

});

parcelRegister("dN8tJ", function(module, exports) {
/** Identifies system items that reveal the remaining items in a type-ahead section. */ const $373eac8c1563e631$export$9a2fe7e12b4abbb3 = '--system-section-overflow';
module.exports["SECTION_OVERFLOW_ITEM_KEY_SUFFIX"] = $373eac8c1563e631$export$9a2fe7e12b4abbb3;

});

parcelRegister("kUWm2", function(module, exports) {
/** Identifies reserved type-ahead sections whose item is rendered as the persistent menu footer. */ const $4b38e49f7dede67f$export$23db4396eb0ad54b = '--system-menu-footer';
module.exports["MENU_FOOTER_SECTION_KEY_SUFFIX"] = $4b38e49f7dede67f$export$23db4396eb0ad54b;

});

parcelRegister("2F1us", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "List", {
    enumerable: true,
    get: function get() {
        return $1f00910b2899fad6$var$_List["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $1f00910b2899fad6$var$_List["default"];
    }
});

var $1f00910b2899fad6$var$_List = $5r8BJ((parcelRequire("4BAKK")));

});

parcelRegister("6XFzX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = void 0;

var $k5Nqi = parcelRequire("k5Nqi");

/*:: export type AnimationTimeoutId = {
  id: number,
};*/ var $5118817e3e03b6c5$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame /*: AnimationTimeoutId*/ ) {
    return (0, $k5Nqi.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $5118817e3e03b6c5$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback /*: Function*/ , delay /*: number*/ ) /*: AnimationTimeoutId*/ {
    var start;
    // wait for end of processing current event handler, because event handler may be long
    Promise.resolve().then(function() {
        start = Date.now();
    });
    var _timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $k5Nqi.raf)(_timeout);
    };
    var frame /*: AnimationTimeoutId*/  = {
        id: (0, $k5Nqi.raf)(_timeout)
    };
    return frame;
};

});

parcelRegister("kaABV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMaxElementSize = void 0;
var $eaf123ee7320a358$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $eaf123ee7320a358$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $eaf123ee7320a358$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $eaf123ee7320a358$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $eaf123ee7320a358$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() /*: number*/ {
    if ($eaf123ee7320a358$var$isBrowser()) {
        if ($eaf123ee7320a358$var$isChrome()) return $eaf123ee7320a358$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $eaf123ee7320a358$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});

parcelRegister("9ULBF", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $gPewy = parcelRequire("gPewy");

function $a0f86dcd5cb43910$export$b1e4478495976768(node) {
    const { bulletList: bulletList } = node.type.schema.nodes;
    if (!bulletList) return false;
    const listFragment = (0, $aPdNQ.Fragment).from(bulletList.createAndFill());
    return !(0, $gPewy.isListItemNode)(node) && node.type.validContent(listFragment);
}
module.exports["isListNodeValidContent"] = $a0f86dcd5cb43910$export$b1e4478495976768;

});

parcelRegister("2CYgA", function(module, exports) {
var $584018434f68a809$export$5e0de40a18047fef = /*#__PURE__*/ function(JoinDirection) {
    JoinDirection[JoinDirection["LEFT"] = 1] = "LEFT";
    JoinDirection[JoinDirection["RIGHT"] = -1] = "RIGHT";
    return JoinDirection;
}({});
module.exports["JoinDirection"] = $584018434f68a809$export$5e0de40a18047fef;

});

parcelRegister("kPujW", function(module, exports) {

var $aXHNB = parcelRequire("aXHNB");

const $31a530d306139601$export$5fe3c994010aac53 = (resolvedPos)=>{
    let count = 0;
    for(let i = resolvedPos.depth - 1; i > 0; i--){
        const node = resolvedPos.node(i);
        if ((0, $aXHNB.isListNode)(node)) count += 1;
    }
    return count;
};
module.exports["numberNestedLists"] = $31a530d306139601$export$5fe3c994010aac53;

});

parcelRegister("f4zz7", function(module, exports) {

var $gPewy = parcelRequire("gPewy");

var $aXHNB = parcelRequire("aXHNB");

const $8cac49de998805f1$export$c910df91212e45f2 = (tr)=>{
    const { from: from, to: to } = tr.selection;
    if (from === to) return 1;
    let count = 0;
    const listSlice = tr.doc.cut(from, to);
    listSlice.content.nodesBetween(0, listSlice.content.size, (node, pos, parent, index)=>{
        if (parent && (0, $gPewy.isListItemNode)(parent) && !(0, $aXHNB.isListNode)(node) && index === 0) count++;
    });
    return count;
};
module.exports["countListItemsInSelection"] = $8cac49de998805f1$export$c910df91212e45f2;

});

parcelRegister("32JQq", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $gPewy = parcelRequire("gPewy");


var $kPujW = parcelRequire("kPujW");

const $d290eba01d8a97e5$export$3f981ad265759e92 = ($pos)=>{
    // Get level for the correct indent of nesting
    const indentLevel = (0, $kPujW.numberNestedLists)($pos) - 1;
    const itemAtPos = (0, $bjg0G.findParentNodeClosestToPos)($pos, (0, $gPewy.isListItemNode));
    // Get the index of the current item relative to parent (parent is at item depth - 1)
    const itemIndex = $pos.index(itemAtPos ? itemAtPos.depth - 1 : undefined);
    return {
        indentLevel: indentLevel,
        itemIndex: itemIndex
    };
};
const $d290eba01d8a97e5$export$6c425b5a921132e = ({ selection: selection, doc: doc })=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const head = $d290eba01d8a97e5$var$resolvePositionToStartOfListItem($from);
        return new (0, $kCECX.TextSelection)(head, head);
    }
    const head = $d290eba01d8a97e5$var$resolvePositionToStartOfListItem($from);
    const anchor = $d290eba01d8a97e5$var$resolvePositionToEndOfListItem($to);
    return new (0, $kCECX.TextSelection)(anchor, head);
};
const $d290eba01d8a97e5$var$resolvePositionToStartOfListItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, (0, $gPewy.isListItemNode));
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $kCECX.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $d290eba01d8a97e5$var$resolvePositionToEndOfListItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, (0, $gPewy.isListItemNode));
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $kCECX.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};
module.exports["getListItemAttributes"] = $d290eba01d8a97e5$export$3f981ad265759e92;
module.exports["normalizeListItemsSelection"] = $d290eba01d8a97e5$export$6c425b5a921132e;

});

parcelRegister("cBcXO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e29b6bb89403ebf3bd65fdcc880ec2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92c2ff0b10cd174b$var$_react = $92c2ff0b10cd174b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $92c2ff0b10cd174b$var$_baseNew = $92c2ff0b10cd174b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $92c2ff0b10cd174b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ColourNone".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/colour-none
 * Usage guidance:
 * Remove colours from Whiteboard's colour picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92c2ff0b10cd174b$var$ColourNoneIcon = (props)=>/*#__PURE__*/ $92c2ff0b10cd174b$var$_react.default.createElement($92c2ff0b10cd174b$var$_baseNew.default, Object.assign({
        name: "ColourNoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM9.32 12.5l1.5 1.5H4a2 2 0 0 1-2-2V5.18l1.5 1.5V12a.5.5 0 0 0 .5.5zM12 2H5.18l1.5 1.5H12a.5.5 0 0 1 .5.5v5.32l1.5 1.5V4a2 2 0 0 0-2-2"/>`
    }, props));
$92c2ff0b10cd174b$var$ColourNoneIcon.displayName = 'ColourNoneIcon';
var $92c2ff0b10cd174b$var$_default = module.exports.default = $92c2ff0b10cd174b$var$ColourNoneIcon;

});

parcelRegister("eWXt3", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $4wH3g = parcelRequire("4wH3g");


var $lfoFx = parcelRequire("lfoFx");

function $ec6a9f28a9010571$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ec6a9f28a9010571$var$spinnerContainer = {
    name: "c1gsw5",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;width:100%"
};

const $ec6a9f28a9010571$var$ElementBrowserLoader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "RQhdv",
    name: "ElementBrowserLoader",
    loader: ()=>(parcelRequire("kkC4n")).then((module)=>module.default),
    loading: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $ec6a9f28a9010571$var$spinnerContainer
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfoFx.default), {
            size: "medium",
            interactionName: "element-browser-spinner"
        }))
});
var $ec6a9f28a9010571$export$2e2bcd8739ae039 = $ec6a9f28a9010571$var$ElementBrowserLoader;
module.exports["default"] = $ec6a9f28a9010571$export$2e2bcd8739ae039;

});

parcelRegister("et3Y5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $5HBT9 = parcelRequire("5HBT9");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $bBlkn = parcelRequire("bBlkn");

var $dhsWS = parcelRequire("dhsWS");

var $bc70Z = parcelRequire("bc70Z");

var $gIW0y = parcelRequire("gIW0y");

var $bUmH3 = parcelRequire("bUmH3");

var $66wqx = parcelRequire("66wqx");

var $d4GYd = parcelRequire("d4GYd");

var $UL6rM = parcelRequire("UL6rM");

var $2HIrf = parcelRequire("2HIrf");

var $5KCL9 = parcelRequire("5KCL9");























var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $2183L = parcelRequire("2183L");

const $5c3c0e25283cb7d4$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $5HBT9.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p',
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.Text), {})
};
const $5c3c0e25283cb7d4$export$1c89d6b8fe002592 = {
    name: 'smallText',
    title: (0, $5HBT9.messages).smallText,
    nodeName: 'paragraph',
    markName: 'fontSize',
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5KCL9))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.Text), {})
};
const $5c3c0e25283cb7d4$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $5HBT9.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bc70Z))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.H1), {})
};
const $5c3c0e25283cb7d4$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $5HBT9.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($66wqx))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.H2), {})
};
const $5c3c0e25283cb7d4$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $5HBT9.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bUmH3))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.H3), {})
};
const $5c3c0e25283cb7d4$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $5HBT9.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dhsWS))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.H4), {})
};
const $5c3c0e25283cb7d4$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $5HBT9.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bBlkn))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.H5), {})
};
const $5c3c0e25283cb7d4$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $5HBT9.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gIW0y))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2183L.H6), {})
};
const $5c3c0e25283cb7d4$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $5HBT9.messages).blockquote,
    nodeName: 'blockquote',
    tagName: 'blockquote'
};
const $5c3c0e25283cb7d4$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $5HBT9.messages).codeblock,
    nodeName: 'codeBlock'
};
const $5c3c0e25283cb7d4$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $5HBT9.messages).infoPanel,
    nodeName: 'panel'
};
const $5c3c0e25283cb7d4$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $5HBT9.messages).other,
    nodeName: ''
};
const $5c3c0e25283cb7d4$export$2ec1d6c4f06d927 = [
    $5c3c0e25283cb7d4$export$58d6de174a4025df,
    $5c3c0e25283cb7d4$export$1c89d6b8fe002592,
    $5c3c0e25283cb7d4$export$aca53469ff012f69,
    $5c3c0e25283cb7d4$export$8af5e2d4f952c9f0,
    $5c3c0e25283cb7d4$export$4b4c4ef3a93a84d8,
    $5c3c0e25283cb7d4$export$67379271b4d26982,
    $5c3c0e25283cb7d4$export$230d7efa1736763e,
    $5c3c0e25283cb7d4$export$329adfa5d98f30d5
];
var $5c3c0e25283cb7d4$var$ToolbarBlockTypes = /*#__PURE__*/ function(ToolbarBlockTypes) {
    ToolbarBlockTypes["normal"] = "normal";
    ToolbarBlockTypes["heading1"] = "heading1";
    ToolbarBlockTypes["heading2"] = "heading2";
    ToolbarBlockTypes["heading3"] = "heading3";
    ToolbarBlockTypes["heading4"] = "heading4";
    ToolbarBlockTypes["heading5"] = "heading5";
    ToolbarBlockTypes["heading6"] = "heading6";
    ToolbarBlockTypes["blockquote"] = "blockquote";
    return ToolbarBlockTypes;
}($5c3c0e25283cb7d4$var$ToolbarBlockTypes || {});
const $5c3c0e25283cb7d4$export$eb0a3dded5e1d29b = ({ allowFontSize: allowFontSize })=>({
        normal: {
            ...$5c3c0e25283cb7d4$export$58d6de174a4025df,
            icon: // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_change_normal_text_icon') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HIrf))), {
                size: "small",
                label: ""
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.NORMAL_TEXT_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.NORMAL_TEXT_MENU_ITEM).key
        },
        ...allowFontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && {
            smallText: {
                ...$5c3c0e25283cb7d4$export$1c89d6b8fe002592,
                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5KCL9))), {
                    size: "small",
                    label: ""
                }),
                toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.SMALL_TEXT_MENU_ITEM).key],
                toolbarKey: (0, $3nacY.SMALL_TEXT_MENU_ITEM).key
            }
        },
        heading1: {
            ...$5c3c0e25283cb7d4$export$aca53469ff012f69,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bc70Z))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.HEADING_1_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.HEADING_1_MENU_ITEM).key
        },
        heading2: {
            ...$5c3c0e25283cb7d4$export$8af5e2d4f952c9f0,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($66wqx))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.HEADING_2_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.HEADING_2_MENU_ITEM).key
        },
        heading3: {
            ...$5c3c0e25283cb7d4$export$4b4c4ef3a93a84d8,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bUmH3))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.HEADING_3_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.HEADING_3_MENU_ITEM).key
        },
        heading4: {
            ...$5c3c0e25283cb7d4$export$67379271b4d26982,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dhsWS))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.HEADING_4_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.HEADING_4_MENU_ITEM).key
        },
        heading5: {
            ...$5c3c0e25283cb7d4$export$230d7efa1736763e,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bBlkn))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.HEADING_5_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.HEADING_5_MENU_ITEM).key
        },
        heading6: {
            ...$5c3c0e25283cb7d4$export$329adfa5d98f30d5,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gIW0y))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.HEADING_6_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.HEADING_6_MENU_ITEM).key
        },
        blockquote: {
            ...$5c3c0e25283cb7d4$export$175cdd8bc7e4b125,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $hVLmg.TEXT_STYLES_MENU_SECTION_RANK)[(0, $3nacY.BLOCK_QUOTE_MENU_ITEM).key],
            toolbarKey: (0, $3nacY.BLOCK_QUOTE_MENU_ITEM).key
        }
    });
const $5c3c0e25283cb7d4$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $5c3c0e25283cb7d4$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $5c3c0e25283cb7d4$export$c6516682f7569488 = [
    $5c3c0e25283cb7d4$export$175cdd8bc7e4b125,
    $5c3c0e25283cb7d4$export$cf55d1bff75690da,
    $5c3c0e25283cb7d4$export$867b449446b85962
];
const $5c3c0e25283cb7d4$export$237f26fa8dbc0d9a = $5c3c0e25283cb7d4$export$2ec1d6c4f06d927.concat($5c3c0e25283cb7d4$export$c6516682f7569488);
const $5c3c0e25283cb7d4$export$a1bb601016dd2309 = (includeBlockQuoteAsTextstyleOption)=>{
    return includeBlockQuoteAsTextstyleOption ? [
        ...$5c3c0e25283cb7d4$export$2ec1d6c4f06d927,
        $5c3c0e25283cb7d4$export$175cdd8bc7e4b125
    ] : $5c3c0e25283cb7d4$export$2ec1d6c4f06d927;
};
const $5c3c0e25283cb7d4$export$110c9c3e05131569 = $5c3c0e25283cb7d4$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $5c3c0e25283cb7d4$export$33dfdcd30c23ea87 = $5c3c0e25283cb7d4$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});
module.exports["NORMAL_TEXT"] = $5c3c0e25283cb7d4$export$58d6de174a4025df;
module.exports["SMALL_TEXT"] = $5c3c0e25283cb7d4$export$1c89d6b8fe002592;
module.exports["HEADING_1"] = $5c3c0e25283cb7d4$export$aca53469ff012f69;
module.exports["HEADING_2"] = $5c3c0e25283cb7d4$export$8af5e2d4f952c9f0;
module.exports["HEADING_3"] = $5c3c0e25283cb7d4$export$4b4c4ef3a93a84d8;
module.exports["HEADING_4"] = $5c3c0e25283cb7d4$export$67379271b4d26982;
module.exports["HEADING_5"] = $5c3c0e25283cb7d4$export$230d7efa1736763e;
module.exports["HEADING_6"] = $5c3c0e25283cb7d4$export$329adfa5d98f30d5;
module.exports["BLOCK_QUOTE"] = $5c3c0e25283cb7d4$export$175cdd8bc7e4b125;
module.exports["CODE_BLOCK"] = $5c3c0e25283cb7d4$export$cf55d1bff75690da;
module.exports["PANEL"] = $5c3c0e25283cb7d4$export$867b449446b85962;
module.exports["OTHER"] = $5c3c0e25283cb7d4$export$d46a05f8561f868a;
module.exports["TEXT_BLOCK_TYPES"] = $5c3c0e25283cb7d4$export$2ec1d6c4f06d927;
module.exports["toolbarBlockTypesWithRank"] = $5c3c0e25283cb7d4$export$eb0a3dded5e1d29b;
module.exports["FORMATTING_NODE_TYPES"] = $5c3c0e25283cb7d4$export$a5cb0c20bd02ce0c;
module.exports["FORMATTING_MARK_TYPES"] = $5c3c0e25283cb7d4$export$73b50f8f13648c71;
module.exports["WRAPPER_BLOCK_TYPES"] = $5c3c0e25283cb7d4$export$c6516682f7569488;
module.exports["getBlockTypesInDropdown"] = $5c3c0e25283cb7d4$export$a1bb601016dd2309;
module.exports["HEADINGS_BY_LEVEL"] = $5c3c0e25283cb7d4$export$110c9c3e05131569;
module.exports["HEADINGS_BY_NAME"] = $5c3c0e25283cb7d4$export$33dfdcd30c23ea87;

});

parcelRegister("lPJNC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3e2d250be541ee83$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    help: {
        id: "fabric.editor.elementBrowser.help",
        defaultMessage: "Help"
    },
    insert: {
        id: "fabric.editor.elementbrowser.modal.insert",
        defaultMessage: "Insert"
    },
    close: {
        id: "fabric.editor.elementbrowser.modal.close",
        defaultMessage: "Close"
    },
    all: {
        id: "fabric.editor.elementbrowser.categorylist.category-all",
        defaultMessage: "All"
    },
    formatting: {
        id: "fabric.editor.elementbrowser.categorylist.category-formatting",
        defaultMessage: "Formatting"
    },
    'confluence-content': {
        id: "fabric.editor.elementbrowser.categorylist.category-confluence-content",
        defaultMessage: "Confluence content"
    },
    media: {
        id: "fabric.editor.elementbrowser.categorylist.category-media",
        defaultMessage: "Media"
    },
    visuals: {
        id: "fabric.editor.elementbrowser.categorylist.category-visuals",
        defaultMessage: "Visuals & images"
    },
    navigation: {
        id: "fabric.editor.elementbrowser.categorylist.category-navigation",
        defaultMessage: "Navigation"
    },
    'external-content': {
        id: "fabric.editor.elementbrowser.categorylist.category-external-content",
        defaultMessage: "External content"
    },
    communication: {
        id: "fabric.editor.elementbrowser.categorylist.category-communication",
        defaultMessage: "Communication"
    },
    reporting: {
        id: "fabric.editor.elementbrowser.categorylist.category-reporting",
        defaultMessage: "Reporting"
    },
    admin: {
        id: "fabric.editor.elementbrowser.categorylist.category-admin",
        defaultMessage: "Administration"
    },
    development: {
        id: "fabric.editor.elementbrowser.categorylist.category-development",
        defaultMessage: "Development"
    },
    AI: {
        id: "fabric.editor.elementbrowser.categorylist.category-ai",
        defaultMessage: "Rovo"
    },
    featuredWhiteboardDescription: {
        id: "fabric.editor.elementbrowser.featured.whiteboard.description",
        defaultMessage: "Use a whiteboard to add visuals to your page"
    },
    browse: {
        id: "fabric.editor.elementbrowser.sidebar.heading",
        defaultMessage: "Browse"
    },
    categoryRecommended: {
        id: "editor-common.quick-insert.categoryRecommended",
        defaultMessage: "Recommended"
    },
    categoryStructure: {
        id: "editor-common.quick-insert.categoryStructure",
        defaultMessage: "Structure"
    },
    categoryMedia: {
        id: "editor-common.quick-insert.categoryMedia",
        defaultMessage: "Media"
    },
    categoryEmbed: {
        id: "editor-common.quick-insert.categoryEmbed",
        defaultMessage: "Embed"
    },
    categoryTextFormatting: {
        id: "editor-common.quick-insert.categoryTextFormatting",
        defaultMessage: "Text formatting"
    },
    categoryRovo: {
        id: "editor-common.quick-insert.categoryRovo",
        defaultMessage: "Rovo"
    },
    categoryDataAndCharts: {
        id: "editor-common.quick-insert.categoryDataAndCharts",
        defaultMessage: "Data and charts"
    },
    categoryBlockTemplates: {
        id: "editor-common.quick-insert.categoryBlockTemplates",
        defaultMessage: "Block templates"
    },
    categoryOther: {
        id: "editor-common.quick-insert.categoryOther",
        defaultMessage: "Other"
    }
});
module.exports["messages"] = $3e2d250be541ee83$export$defe85febe8b728c;

});

parcelRegister("kwAo1", function(module, exports) {
var $a6c7d986b9fc6316$export$8dcc3cd59f9a0726 = /*#__PURE__*/ function(InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
    InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
    return InsertStatus;
}({});
module.exports["InsertStatus"] = $a6c7d986b9fc6316$export$8dcc3cd59f9a0726;

});

parcelRegister("k5Nqi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.raf = module.exports.caf = void 0;
/*:: type Callback = (timestamp: number) => void;*/ /*:: type CancelAnimationFrame = (requestId: number) => void;*/ /*:: type RequestAnimationFrame = (callback: Callback) => number;*/ // Properly handle server-side rendering.
var $ea0a9cb51440db31$var$win;
if (typeof window !== 'undefined') $ea0a9cb51440db31$var$win = window;
else if (typeof self !== 'undefined') $ea0a9cb51440db31$var$win = self;
else $ea0a9cb51440db31$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $ea0a9cb51440db31$var$request = $ea0a9cb51440db31$var$win.requestAnimationFrame || $ea0a9cb51440db31$var$win.webkitRequestAnimationFrame || $ea0a9cb51440db31$var$win.mozRequestAnimationFrame || $ea0a9cb51440db31$var$win.oRequestAnimationFrame || $ea0a9cb51440db31$var$win.msRequestAnimationFrame || function(callback /*: Callback*/ ) /*: RequestAnimationFrame*/ {
    return $ea0a9cb51440db31$var$win /*: any*/ .setTimeout(callback, 1000 / 60);
};
var $ea0a9cb51440db31$var$cancel = $ea0a9cb51440db31$var$win.cancelAnimationFrame || $ea0a9cb51440db31$var$win.webkitCancelAnimationFrame || $ea0a9cb51440db31$var$win.mozCancelAnimationFrame || $ea0a9cb51440db31$var$win.oCancelAnimationFrame || $ea0a9cb51440db31$var$win.msCancelAnimationFrame || function(id /*: number*/ ) {
    $ea0a9cb51440db31$var$win /*: any*/ .clearTimeout(id);
};
var $ea0a9cb51440db31$var$raf /*: RequestAnimationFrame*/  = module.exports.raf = $ea0a9cb51440db31$var$request /*: any*/ ;
var $ea0a9cb51440db31$var$caf /*: CancelAnimationFrame*/  = module.exports.caf = $ea0a9cb51440db31$var$cancel /*: any*/ ;

});

parcelRegister("2183L", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

const $3ec0882548194f50$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        children: children
    });
const $3ec0882548194f50$export$5f1af8db9871e1d6 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($3ec0882548194f50$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2 1H14V5H12.5V2.5H8.8125V13.5H10.5V15H5.5V13.5H7.3125V2.5H3.5V5H2V1Z",
                fill: "currentColor"
            })
        })
    });
const $3ec0882548194f50$export$5523b16adee8048 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($3ec0882548194f50$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H1.5V6.25H6V0H7.5V6.25V7.75V14H6V7.75H1.5V14H0V7.75V6.25V0ZM9.85801 12.6959V14H13.9999V12.6959H12.8161V7.83108H11.3138L9.8418 8.86406V10.4342L11.3499 9.31528V12.6959H9.85801Z",
                fill: "currentColor"
            })
        })
    });
const $3ec0882548194f50$export$cb94397127ac9363 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($3ec0882548194f50$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM9.2395 12.8296V14H14V12.6553H11.5637V12.573L12.4146 11.875C12.7826 11.5734 13.0772 11.2981 13.2986 11.0491C13.5199 10.8 13.679 10.5635 13.7759 10.3394C13.8755 10.1152 13.9253 9.89111 13.9253 9.66699V9.64624C13.9253 9.28101 13.8285 8.96419 13.6348 8.6958C13.4411 8.42464 13.1685 8.21574 12.8171 8.06909C12.4685 7.91968 12.0562 7.84497 11.5803 7.84497C11.0906 7.84497 10.6617 7.93075 10.2937 8.10229C9.92847 8.27108 9.64347 8.50903 9.43872 8.81616C9.23674 9.12052 9.13574 9.47884 9.13574 9.89111V9.92432H10.7378V9.88696C10.7378 9.74308 10.771 9.6158 10.8374 9.50513C10.9038 9.39445 10.9951 9.30729 11.1113 9.24365C11.2303 9.18001 11.3659 9.14819 11.5181 9.14819C11.6647 9.14819 11.7906 9.1731 11.8958 9.2229C12.0037 9.27271 12.0853 9.34465 12.1406 9.43872C12.1987 9.5328 12.2278 9.64486 12.2278 9.7749V9.79565C12.2278 9.9008 12.1946 10.0115 12.1282 10.1277C12.0645 10.2439 11.9497 10.3878 11.7837 10.5593C11.6177 10.7281 11.3811 10.9467 11.074 11.2151L9.2395 12.8296Z",
                fill: "currentColor"
            })
        })
    });
const $3ec0882548194f50$export$746be9e3a3dfff1f = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($3ec0882548194f50$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.219 13.7649C10.5811 13.9216 11.0012 14 11.4794 14C12.0009 14 12.4494 13.9257 12.825 13.7771C13.2005 13.6258 13.4896 13.411 13.6922 13.1327C13.8976 12.8544 14.0002 12.5248 14.0002 12.1438V12.1357C14.0002 11.7575 13.8706 11.4535 13.6112 11.2239C13.3518 10.9942 13.0006 10.8564 12.5575 10.8105V10.7781C12.7709 10.7348 12.9681 10.6565 13.1492 10.543C13.3329 10.4295 13.4801 10.2823 13.5909 10.1013C13.7017 9.91755 13.7571 9.70275 13.7571 9.45688V9.44878C13.7571 9.12186 13.6639 8.83817 13.4774 8.5977C13.291 8.35454 13.0262 8.16541 12.6831 8.03032C12.34 7.89523 11.9347 7.82769 11.4673 7.82769C11.0134 7.82769 10.6162 7.90469 10.2758 8.05869C9.93805 8.20999 9.67057 8.42479 9.47334 8.70308C9.27611 8.98136 9.16533 9.31099 9.14102 9.69194L9.13696 9.75273H10.6851L10.6892 9.71626C10.7027 9.58927 10.7418 9.4785 10.8067 9.38394C10.8715 9.28667 10.9593 9.21237 11.0701 9.16104C11.1836 9.107 11.316 9.07998 11.4673 9.07998C11.6132 9.07998 11.7388 9.10565 11.8442 9.15698C11.9523 9.20562 12.0347 9.27586 12.0914 9.36772C12.1481 9.45959 12.1765 9.56631 12.1765 9.68789V9.696C12.1765 9.81488 12.1427 9.9189 12.0752 10.0081C12.0104 10.0945 11.9158 10.1607 11.7915 10.2066C11.6672 10.2526 11.5159 10.2755 11.3376 10.2755H10.7337V11.4062H11.3376C11.6348 11.4062 11.8618 11.4589 12.0185 11.5643C12.1752 11.667 12.2535 11.8183 12.2535 12.0182V12.0263C12.2535 12.1506 12.2224 12.2614 12.1603 12.3586C12.0982 12.4532 12.009 12.5289 11.8928 12.5856C11.7766 12.6396 11.6375 12.6667 11.4754 12.6667C11.3133 12.6667 11.1728 12.641 11.0539 12.5896C10.935 12.5383 10.8405 12.4681 10.7702 12.3789C10.7 12.2897 10.6567 12.1911 10.6405 12.0831L10.6324 12.0344H8.99512L8.99917 12.0871C9.02889 12.4762 9.14912 12.8139 9.35986 13.1003C9.57061 13.3867 9.857 13.6082 10.219 13.7649Z",
                fill: "currentColor"
            })
        })
    });
const $3ec0882548194f50$export$cc5e069d64fda823 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($3ec0882548194f50$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM11.542 13.0117V14H13.2607V13.0117H13.9998V11.6195H13.2607V7.79961H10.7428C10.5852 8.05169 10.4291 8.30378 10.2744 8.55586C10.1226 8.80508 9.97077 9.05573 9.81894 9.30781C9.66999 9.5599 9.52103 9.81628 9.37207 10.077C9.22311 10.3348 9.07559 10.5969 8.92949 10.8633C8.7834 11.1268 8.6373 11.3975 8.49121 11.6754V13.0117H11.542ZM11.5936 11.6883H10.0338V11.6023C10.1226 11.4276 10.2143 11.2543 10.3088 11.0824C10.4033 10.9077 10.4993 10.7344 10.5967 10.5625C10.6969 10.3906 10.7972 10.2202 10.8975 10.0512C10.9977 9.8793 11.098 9.71029 11.1982 9.54414C11.3014 9.37799 11.4045 9.21328 11.5076 9.05H11.5936V11.6883Z",
                fill: "currentColor"
            })
        })
    });
const $3ec0882548194f50$export$88ef9fdaf11f7a1f = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($3ec0882548194f50$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.2808 13.7551C10.6349 13.9184 11.0527 14 11.5342 14C12.0239 14 12.4542 13.9101 12.825 13.7302C13.1957 13.5476 13.4835 13.2917 13.6882 12.9624C13.8958 12.6331 13.9995 12.2499 13.9995 11.8127V11.8044C13.9995 11.4281 13.9165 11.0961 13.7505 10.8083C13.5872 10.5178 13.3617 10.2896 13.074 10.1235C12.7862 9.95752 12.457 9.87451 12.0862 9.87451C11.887 9.87451 11.703 9.90356 11.5342 9.96167C11.3682 10.0198 11.2243 10.1 11.1025 10.2024C10.9808 10.3048 10.884 10.4237 10.812 10.5593H10.729L10.8203 9.1731H13.6177V7.84497H9.45898L9.22241 11.4973H10.7207C10.7511 11.4392 10.7913 11.3839 10.8411 11.3313C10.8909 11.276 10.9462 11.2275 11.0071 11.186C11.079 11.139 11.1579 11.103 11.2437 11.0781C11.3322 11.0505 11.4277 11.0366 11.53 11.0366C11.6933 11.0366 11.8385 11.0712 11.9658 11.1404C12.0931 11.2068 12.1927 11.2995 12.2646 11.4185C12.3366 11.5374 12.3726 11.6772 12.3726 11.8376V11.8459C12.3726 12.0037 12.3366 12.1448 12.2646 12.2693C12.1927 12.391 12.0931 12.4865 11.9658 12.5557C11.8413 12.6248 11.6974 12.6594 11.5342 12.6594C11.3903 12.6594 11.2616 12.6345 11.1482 12.5847C11.0347 12.5349 10.9393 12.4685 10.8618 12.3855C10.7871 12.2997 10.7318 12.2056 10.6958 12.1033L10.6875 12.0784H9.12695L9.1311 12.1531C9.15047 12.4989 9.25838 12.8116 9.45483 13.0911C9.65405 13.3705 9.92936 13.5919 10.2808 13.7551Z",
                fill: "currentColor"
            })
        })
    });
const $3ec0882548194f50$export$a559fb8039b06400 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($3ec0882548194f50$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.4615 13.7893C10.7857 13.9298 11.1531 14 11.5638 14C12.0501 14 12.4757 13.9068 12.8404 13.7204C13.2052 13.5339 13.4889 13.28 13.6915 12.9584C13.8968 12.6342 13.9995 12.2681 13.9995 11.8602V11.8521C13.9995 11.4873 13.9225 11.1644 13.7685 10.8834C13.6172 10.5998 13.3997 10.3782 13.116 10.2188C12.835 10.0567 12.4973 9.97563 12.1028 9.97563C11.8272 9.97563 11.5935 10.0135 11.4017 10.0891C11.2099 10.1648 11.0532 10.2634 10.9316 10.385C10.81 10.5065 10.7141 10.6389 10.6438 10.7821H10.5547C10.5548 10.7402 10.5561 10.6984 10.5587 10.6565C10.575 10.3539 10.6195 10.0878 10.6925 9.8581C10.7681 9.62845 10.8762 9.44878 11.0167 9.31909C11.1572 9.1894 11.3328 9.12456 11.5436 9.12456C11.6624 9.12456 11.7678 9.14347 11.8597 9.1813C11.9542 9.21912 12.0353 9.27046 12.1028 9.3353C12.1704 9.40015 12.2204 9.47309 12.2528 9.55415L12.2649 9.58252H13.9266L13.9225 9.5582C13.8685 9.23398 13.7334 8.94219 13.5172 8.68281C13.3011 8.42074 13.0215 8.21269 12.6783 8.05869C12.3379 7.90469 11.9542 7.82768 11.5273 7.82768C11.0032 7.82768 10.5466 7.95062 10.1575 8.19648C9.76846 8.44235 9.4672 8.79629 9.25376 9.2583C9.04032 9.71761 8.93359 10.2674 8.93359 10.9078V10.9159C8.93359 11.3941 8.99303 11.8237 9.11191 12.2046C9.23079 12.5856 9.40371 12.9098 9.63066 13.1773C9.86032 13.4421 10.1373 13.6461 10.4615 13.7893ZM10.7492 11.9047C10.7492 12.056 10.7843 12.1925 10.8546 12.3141C10.9275 12.4356 11.0248 12.5316 11.1464 12.6018C11.2707 12.6694 11.4071 12.7031 11.5557 12.7031C11.707 12.7031 11.8435 12.6694 11.965 12.6018C12.0866 12.5316 12.1839 12.4383 12.2568 12.3222C12.3298 12.206 12.3663 12.075 12.3663 11.9291V11.9209C12.3663 11.7696 12.3311 11.6359 12.2609 11.5197C12.1906 11.4035 12.0947 11.3117 11.9731 11.2441C11.8543 11.1766 11.7165 11.1428 11.5598 11.1428C11.4112 11.1428 11.2747 11.1752 11.1504 11.2401C11.0289 11.3022 10.9316 11.39 10.8586 11.5035C10.7857 11.617 10.7492 11.748 10.7492 11.8966V11.9047Z",
                fill: "currentColor"
            })
        })
    });
module.exports["Text"] = $3ec0882548194f50$export$5f1af8db9871e1d6;
module.exports["H1"] = $3ec0882548194f50$export$5523b16adee8048;
module.exports["H2"] = $3ec0882548194f50$export$cb94397127ac9363;
module.exports["H3"] = $3ec0882548194f50$export$746be9e3a3dfff1f;
module.exports["H4"] = $3ec0882548194f50$export$cc5e069d64fda823;
module.exports["H5"] = $3ec0882548194f50$export$88ef9fdaf11f7a1f;
module.exports["H6"] = $3ec0882548194f50$export$a559fb8039b06400;

});


$parcel$global.rlb("gGcbZ")
//# sourceMappingURL=FullPageEditorComponent.9f9d49b6.js.map
